
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebe40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebe40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iwYKF", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d7da5726a9ca36a2$export$ffb0004e005737fa, (v) => $d7da5726a9ca36a2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d7da5726a9ca36a2$export$34b9dba7ce09269b, (v) => $d7da5726a9ca36a2$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d7da5726a9ca36a2$export$25062201e9e25d76, (v) => $d7da5726a9ca36a2$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7da5726a9ca36a2$export$ffb0004e005737fa;
var $d7da5726a9ca36a2$export$34b9dba7ce09269b;
var $d7da5726a9ca36a2$export$25062201e9e25d76;
"use strict";

var $lx97N = parcelRequire("lx97N");
var $d7da5726a9ca36a2$var$k = Symbol.for("react.element"), $d7da5726a9ca36a2$var$l = Symbol.for("react.fragment"), $d7da5726a9ca36a2$var$m = Object.prototype.hasOwnProperty, $d7da5726a9ca36a2$var$n = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d7da5726a9ca36a2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d7da5726a9ca36a2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d7da5726a9ca36a2$var$m.call(a, b) && !$d7da5726a9ca36a2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d7da5726a9ca36a2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d7da5726a9ca36a2$var$n.current
    };
}
$d7da5726a9ca36a2$export$ffb0004e005737fa = $d7da5726a9ca36a2$var$l;
$d7da5726a9ca36a2$export$34b9dba7ce09269b = $d7da5726a9ca36a2$var$q;
$d7da5726a9ca36a2$export$25062201e9e25d76 = $d7da5726a9ca36a2$var$q;

});
parcelRegister("lx97N", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8E8IG"));

});
parcelRegister("8E8IG", function(module, exports) {

$parcel$export(module.exports, "Children", () => $64b8d2b03b5764eb$export$dca3b0875bd9a954, (v) => $64b8d2b03b5764eb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $64b8d2b03b5764eb$export$16fa2f45be04daa8, (v) => $64b8d2b03b5764eb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $64b8d2b03b5764eb$export$ffb0004e005737fa, (v) => $64b8d2b03b5764eb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $64b8d2b03b5764eb$export$e2c29f18771995cb, (v) => $64b8d2b03b5764eb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $64b8d2b03b5764eb$export$221d75b3f55bb0bd, (v) => $64b8d2b03b5764eb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $64b8d2b03b5764eb$export$5f8d39834fd61797, (v) => $64b8d2b03b5764eb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $64b8d2b03b5764eb$export$74bf444e3cd11ea5, (v) => $64b8d2b03b5764eb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $64b8d2b03b5764eb$export$ae55be85d98224ed, (v) => $64b8d2b03b5764eb$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $64b8d2b03b5764eb$export$e530037191fcd5d7, (v) => $64b8d2b03b5764eb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $64b8d2b03b5764eb$export$fd42f52fd3ae1109, (v) => $64b8d2b03b5764eb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $64b8d2b03b5764eb$export$c8a8987d4410bf2d, (v) => $64b8d2b03b5764eb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $64b8d2b03b5764eb$export$d38cd72104c1f0e9, (v) => $64b8d2b03b5764eb$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43, (v) => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $64b8d2b03b5764eb$export$257a8862b851cb5b, (v) => $64b8d2b03b5764eb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $64b8d2b03b5764eb$export$a8257692ac88316c, (v) => $64b8d2b03b5764eb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $64b8d2b03b5764eb$export$488013bae63b21da, (v) => $64b8d2b03b5764eb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $64b8d2b03b5764eb$export$7c73462e0d25e514, (v) => $64b8d2b03b5764eb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $64b8d2b03b5764eb$export$7568632d0d33d16d, (v) => $64b8d2b03b5764eb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $64b8d2b03b5764eb$export$88948ce120ea2619, (v) => $64b8d2b03b5764eb$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $64b8d2b03b5764eb$export$35808ee640e87ca7, (v) => $64b8d2b03b5764eb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $64b8d2b03b5764eb$export$fae74005e78b1a27, (v) => $64b8d2b03b5764eb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e, (v) => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf, (v) => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $64b8d2b03b5764eb$export$6d9c69b0de29b591, (v) => $64b8d2b03b5764eb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $64b8d2b03b5764eb$export$f680877a34711e37, (v) => $64b8d2b03b5764eb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $64b8d2b03b5764eb$export$d5a552a76deda3c2, (v) => $64b8d2b03b5764eb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $64b8d2b03b5764eb$export$aaabe4eda9ed9969, (v) => $64b8d2b03b5764eb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $64b8d2b03b5764eb$export$e5c5a5f917a5871c, (v) => $64b8d2b03b5764eb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $64b8d2b03b5764eb$export$1538c33de8887b59, (v) => $64b8d2b03b5764eb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $64b8d2b03b5764eb$export$13e3392192263954, (v) => $64b8d2b03b5764eb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $64b8d2b03b5764eb$export$b8f5890fc79d6aca, (v) => $64b8d2b03b5764eb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $64b8d2b03b5764eb$export$60241385465d0a34, (v) => $64b8d2b03b5764eb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $64b8d2b03b5764eb$export$306c0aa65ff9ec16, (v) => $64b8d2b03b5764eb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $64b8d2b03b5764eb$export$7b286972b8d8ccbf, (v) => $64b8d2b03b5764eb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $64b8d2b03b5764eb$export$83d89fbfd8236492, (v) => $64b8d2b03b5764eb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $64b8d2b03b5764eb$export$dca3b0875bd9a954;
var $64b8d2b03b5764eb$export$16fa2f45be04daa8;
var $64b8d2b03b5764eb$export$ffb0004e005737fa;
var $64b8d2b03b5764eb$export$e2c29f18771995cb;
var $64b8d2b03b5764eb$export$221d75b3f55bb0bd;
var $64b8d2b03b5764eb$export$5f8d39834fd61797;
var $64b8d2b03b5764eb$export$74bf444e3cd11ea5;
var $64b8d2b03b5764eb$export$ae55be85d98224ed;
var $64b8d2b03b5764eb$export$e530037191fcd5d7;
var $64b8d2b03b5764eb$export$fd42f52fd3ae1109;
var $64b8d2b03b5764eb$export$c8a8987d4410bf2d;
var $64b8d2b03b5764eb$export$d38cd72104c1f0e9;
var $64b8d2b03b5764eb$export$7d1e3a5e95ceca43;
var $64b8d2b03b5764eb$export$257a8862b851cb5b;
var $64b8d2b03b5764eb$export$a8257692ac88316c;
var $64b8d2b03b5764eb$export$488013bae63b21da;
var $64b8d2b03b5764eb$export$7c73462e0d25e514;
var $64b8d2b03b5764eb$export$7568632d0d33d16d;
var $64b8d2b03b5764eb$export$88948ce120ea2619;
var $64b8d2b03b5764eb$export$35808ee640e87ca7;
var $64b8d2b03b5764eb$export$fae74005e78b1a27;
var $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e;
var $64b8d2b03b5764eb$export$6a7bc4e911dc01cf;
var $64b8d2b03b5764eb$export$6d9c69b0de29b591;
var $64b8d2b03b5764eb$export$f680877a34711e37;
var $64b8d2b03b5764eb$export$d5a552a76deda3c2;
var $64b8d2b03b5764eb$export$aaabe4eda9ed9969;
var $64b8d2b03b5764eb$export$e5c5a5f917a5871c;
var $64b8d2b03b5764eb$export$1538c33de8887b59;
var $64b8d2b03b5764eb$export$13e3392192263954;
var $64b8d2b03b5764eb$export$b8f5890fc79d6aca;
var $64b8d2b03b5764eb$export$60241385465d0a34;
var $64b8d2b03b5764eb$export$306c0aa65ff9ec16;
var $64b8d2b03b5764eb$export$7b286972b8d8ccbf;
var $64b8d2b03b5764eb$export$83d89fbfd8236492;
"use strict";
var $64b8d2b03b5764eb$var$l = Symbol.for("react.element"), $64b8d2b03b5764eb$var$n = Symbol.for("react.portal"), $64b8d2b03b5764eb$var$p = Symbol.for("react.fragment"), $64b8d2b03b5764eb$var$q = Symbol.for("react.strict_mode"), $64b8d2b03b5764eb$var$r = Symbol.for("react.profiler"), $64b8d2b03b5764eb$var$t = Symbol.for("react.provider"), $64b8d2b03b5764eb$var$u = Symbol.for("react.context"), $64b8d2b03b5764eb$var$v = Symbol.for("react.forward_ref"), $64b8d2b03b5764eb$var$w = Symbol.for("react.suspense"), $64b8d2b03b5764eb$var$x = Symbol.for("react.memo"), $64b8d2b03b5764eb$var$y = Symbol.for("react.lazy"), $64b8d2b03b5764eb$var$z = Symbol.iterator;
function $64b8d2b03b5764eb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $64b8d2b03b5764eb$var$z && a[$64b8d2b03b5764eb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $64b8d2b03b5764eb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $64b8d2b03b5764eb$var$C = Object.assign, $64b8d2b03b5764eb$var$D = {};
function $64b8d2b03b5764eb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
$64b8d2b03b5764eb$var$E.prototype.isReactComponent = {};
$64b8d2b03b5764eb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$64b8d2b03b5764eb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $64b8d2b03b5764eb$var$F() {}
$64b8d2b03b5764eb$var$F.prototype = $64b8d2b03b5764eb$var$E.prototype;
function $64b8d2b03b5764eb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
var $64b8d2b03b5764eb$var$H = $64b8d2b03b5764eb$var$G.prototype = new $64b8d2b03b5764eb$var$F;
$64b8d2b03b5764eb$var$H.constructor = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$var$C($64b8d2b03b5764eb$var$H, $64b8d2b03b5764eb$var$E.prototype);
$64b8d2b03b5764eb$var$H.isPureReactComponent = !0;
var $64b8d2b03b5764eb$var$I = Array.isArray, $64b8d2b03b5764eb$var$J = Object.prototype.hasOwnProperty, $64b8d2b03b5764eb$var$K = {
    current: null
}, $64b8d2b03b5764eb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $64b8d2b03b5764eb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$64b8d2b03b5764eb$var$J.call(b, d) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $64b8d2b03b5764eb$var$K.current
    };
}
function $64b8d2b03b5764eb$var$N(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $64b8d2b03b5764eb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $64b8d2b03b5764eb$var$l;
}
function $64b8d2b03b5764eb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $64b8d2b03b5764eb$var$P = /\/+/g;
function $64b8d2b03b5764eb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $64b8d2b03b5764eb$var$escape("" + a.key) : b.toString(36);
}
function $64b8d2b03b5764eb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $64b8d2b03b5764eb$var$l:
                case $64b8d2b03b5764eb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $64b8d2b03b5764eb$var$Q(h, 0) : d, $64b8d2b03b5764eb$var$I(c) ? (e = "", null != a && (e = a.replace($64b8d2b03b5764eb$var$P, "$&/") + "/"), $64b8d2b03b5764eb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($64b8d2b03b5764eb$var$O(c) && (c = $64b8d2b03b5764eb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($64b8d2b03b5764eb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($64b8d2b03b5764eb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $64b8d2b03b5764eb$var$Q(k, g);
        h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    }
    else if (f = $64b8d2b03b5764eb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $64b8d2b03b5764eb$var$Q(k, g++), h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $64b8d2b03b5764eb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $64b8d2b03b5764eb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $64b8d2b03b5764eb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $64b8d2b03b5764eb$var$U = {
    current: null
}, $64b8d2b03b5764eb$var$V = {
    transition: null
}, $64b8d2b03b5764eb$var$W = {
    ReactCurrentDispatcher: $64b8d2b03b5764eb$var$U,
    ReactCurrentBatchConfig: $64b8d2b03b5764eb$var$V,
    ReactCurrentOwner: $64b8d2b03b5764eb$var$K
};
$64b8d2b03b5764eb$export$dca3b0875bd9a954 = {
    map: $64b8d2b03b5764eb$var$S,
    forEach: function(a, b, e) {
        $64b8d2b03b5764eb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $64b8d2b03b5764eb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $64b8d2b03b5764eb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$64b8d2b03b5764eb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$64b8d2b03b5764eb$export$16fa2f45be04daa8 = $64b8d2b03b5764eb$var$E;
$64b8d2b03b5764eb$export$ffb0004e005737fa = $64b8d2b03b5764eb$var$p;
$64b8d2b03b5764eb$export$e2c29f18771995cb = $64b8d2b03b5764eb$var$r;
$64b8d2b03b5764eb$export$221d75b3f55bb0bd = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$export$5f8d39834fd61797 = $64b8d2b03b5764eb$var$q;
$64b8d2b03b5764eb$export$74bf444e3cd11ea5 = $64b8d2b03b5764eb$var$w;
$64b8d2b03b5764eb$export$ae55be85d98224ed = $64b8d2b03b5764eb$var$W;
$64b8d2b03b5764eb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $64b8d2b03b5764eb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $64b8d2b03b5764eb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$64b8d2b03b5764eb$var$J.call(b, f) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$64b8d2b03b5764eb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $64b8d2b03b5764eb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $64b8d2b03b5764eb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$64b8d2b03b5764eb$export$c8a8987d4410bf2d = $64b8d2b03b5764eb$var$M;
$64b8d2b03b5764eb$export$d38cd72104c1f0e9 = function(a) {
    var b = $64b8d2b03b5764eb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$64b8d2b03b5764eb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$v,
        render: a
    };
};
$64b8d2b03b5764eb$export$a8257692ac88316c = $64b8d2b03b5764eb$var$O;
$64b8d2b03b5764eb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $64b8d2b03b5764eb$var$T
    };
};
$64b8d2b03b5764eb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$64b8d2b03b5764eb$export$7568632d0d33d16d = function(a) {
    var b = $64b8d2b03b5764eb$var$V.transition;
    $64b8d2b03b5764eb$var$V.transition = {};
    try {
        a();
    } finally{
        $64b8d2b03b5764eb$var$V.transition = b;
    }
};
$64b8d2b03b5764eb$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$64b8d2b03b5764eb$export$35808ee640e87ca7 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useCallback(a, b);
};
$64b8d2b03b5764eb$export$fae74005e78b1a27 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useContext(a);
};
$64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = function() {};
$64b8d2b03b5764eb$export$6a7bc4e911dc01cf = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useDeferredValue(a);
};
$64b8d2b03b5764eb$export$6d9c69b0de29b591 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useEffect(a, b);
};
$64b8d2b03b5764eb$export$f680877a34711e37 = function() {
    return $64b8d2b03b5764eb$var$U.current.useId();
};
$64b8d2b03b5764eb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useImperativeHandle(a, b, e);
};
$64b8d2b03b5764eb$export$aaabe4eda9ed9969 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useInsertionEffect(a, b);
};
$64b8d2b03b5764eb$export$e5c5a5f917a5871c = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useLayoutEffect(a, b);
};
$64b8d2b03b5764eb$export$1538c33de8887b59 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useMemo(a, b);
};
$64b8d2b03b5764eb$export$13e3392192263954 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useReducer(a, b, e);
};
$64b8d2b03b5764eb$export$b8f5890fc79d6aca = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useRef(a);
};
$64b8d2b03b5764eb$export$60241385465d0a34 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useState(a);
};
$64b8d2b03b5764eb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useSyncExternalStore(a, b, e);
};
$64b8d2b03b5764eb$export$7b286972b8d8ccbf = function() {
    return $64b8d2b03b5764eb$var$U.current.useTransition();
};
$64b8d2b03b5764eb$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("f2Jil", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $af3a2d87ccb15d29$export$ae55be85d98224ed, (v) => $af3a2d87ccb15d29$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $af3a2d87ccb15d29$export$d39a5bbd09211389, (v) => $af3a2d87ccb15d29$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $af3a2d87ccb15d29$export$882461b6382ed46c, (v) => $af3a2d87ccb15d29$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $af3a2d87ccb15d29$export$466bfc07425424d5, (v) => $af3a2d87ccb15d29$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4, (v) => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $af3a2d87ccb15d29$export$fa8d919ba61d84db, (v) => $af3a2d87ccb15d29$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $af3a2d87ccb15d29$export$757ceba2d55c277e, (v) => $af3a2d87ccb15d29$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $af3a2d87ccb15d29$export$b3890eb0ae9dca99, (v) => $af3a2d87ccb15d29$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $af3a2d87ccb15d29$export$502457920280e6be, (v) => $af3a2d87ccb15d29$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $af3a2d87ccb15d29$export$c78a37762a8d58e1, (v) => $af3a2d87ccb15d29$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $af3a2d87ccb15d29$export$dc54d992c10e8a18, (v) => $af3a2d87ccb15d29$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $af3a2d87ccb15d29$export$83d89fbfd8236492, (v) => $af3a2d87ccb15d29$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $af3a2d87ccb15d29$export$ae55be85d98224ed;
var $af3a2d87ccb15d29$export$d39a5bbd09211389;
var $af3a2d87ccb15d29$export$882461b6382ed46c;
var $af3a2d87ccb15d29$export$466bfc07425424d5;
var $af3a2d87ccb15d29$export$cd75ccfd720a3cd4;
var $af3a2d87ccb15d29$export$fa8d919ba61d84db;
var $af3a2d87ccb15d29$export$757ceba2d55c277e;
var $af3a2d87ccb15d29$export$b3890eb0ae9dca99;
var $af3a2d87ccb15d29$export$502457920280e6be;
var $af3a2d87ccb15d29$export$c78a37762a8d58e1;
var $af3a2d87ccb15d29$export$dc54d992c10e8a18;
var $af3a2d87ccb15d29$export$83d89fbfd8236492;
"use strict";

var $lx97N = parcelRequire("lx97N");

var $7DCHO = parcelRequire("7DCHO");
function $af3a2d87ccb15d29$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $af3a2d87ccb15d29$var$da = new Set, $af3a2d87ccb15d29$var$ea = {};
function $af3a2d87ccb15d29$var$fa(a, b) {
    $af3a2d87ccb15d29$var$ha(a, b);
    $af3a2d87ccb15d29$var$ha(a + "Capture", b);
}
function $af3a2d87ccb15d29$var$ha(a, b) {
    $af3a2d87ccb15d29$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$da.add(b[a]);
}
var $af3a2d87ccb15d29$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $af3a2d87ccb15d29$var$ja = Object.prototype.hasOwnProperty, $af3a2d87ccb15d29$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $af3a2d87ccb15d29$var$la = {}, $af3a2d87ccb15d29$var$ma = {};
function $af3a2d87ccb15d29$var$oa(a) {
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$ma, a)) return !0;
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$la, a)) return !1;
    if ($af3a2d87ccb15d29$var$ka.test(a)) return $af3a2d87ccb15d29$var$ma[a] = !0;
    $af3a2d87ccb15d29$var$la[a] = !0;
    return !1;
}
function $af3a2d87ccb15d29$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $af3a2d87ccb15d29$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $af3a2d87ccb15d29$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $af3a2d87ccb15d29$var$ra = /[\-:]([a-z])/g;
function $af3a2d87ccb15d29$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$af3a2d87ccb15d29$var$z.xlinkHref = new $af3a2d87ccb15d29$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $af3a2d87ccb15d29$var$ta(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$z.hasOwnProperty(b) ? $af3a2d87ccb15d29$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $af3a2d87ccb15d29$var$qa(b, c, e, d) && (c = null), d || null === e ? $af3a2d87ccb15d29$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $af3a2d87ccb15d29$var$ua = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $af3a2d87ccb15d29$var$va = Symbol.for("react.element"), $af3a2d87ccb15d29$var$wa = Symbol.for("react.portal"), $af3a2d87ccb15d29$var$ya = Symbol.for("react.fragment"), $af3a2d87ccb15d29$var$za = Symbol.for("react.strict_mode"), $af3a2d87ccb15d29$var$Aa = Symbol.for("react.profiler"), $af3a2d87ccb15d29$var$Ba = Symbol.for("react.provider"), $af3a2d87ccb15d29$var$Ca = Symbol.for("react.context"), $af3a2d87ccb15d29$var$Da = Symbol.for("react.forward_ref"), $af3a2d87ccb15d29$var$Ea = Symbol.for("react.suspense"), $af3a2d87ccb15d29$var$Fa = Symbol.for("react.suspense_list"), $af3a2d87ccb15d29$var$Ga = Symbol.for("react.memo"), $af3a2d87ccb15d29$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $af3a2d87ccb15d29$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $af3a2d87ccb15d29$var$Ja = Symbol.iterator;
function $af3a2d87ccb15d29$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $af3a2d87ccb15d29$var$Ja && a[$af3a2d87ccb15d29$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $af3a2d87ccb15d29$var$A = Object.assign, $af3a2d87ccb15d29$var$La;
function $af3a2d87ccb15d29$var$Ma(a) {
    if (void 0 === $af3a2d87ccb15d29$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $af3a2d87ccb15d29$var$La = b && b[1] || "";
    }
    return "\n" + $af3a2d87ccb15d29$var$La + a;
}
var $af3a2d87ccb15d29$var$Na = !1;
function $af3a2d87ccb15d29$var$Oa(a, b) {
    if (!a || $af3a2d87ccb15d29$var$Na) return "";
    $af3a2d87ccb15d29$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $af3a2d87ccb15d29$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $af3a2d87ccb15d29$var$Ma(a) : "";
}
function $af3a2d87ccb15d29$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $af3a2d87ccb15d29$var$Ma(a.type);
        case 16:
            return $af3a2d87ccb15d29$var$Ma("Lazy");
        case 13:
            return $af3a2d87ccb15d29$var$Ma("Suspense");
        case 19:
            return $af3a2d87ccb15d29$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !1), a;
        case 11:
            return a = $af3a2d87ccb15d29$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return "Fragment";
        case $af3a2d87ccb15d29$var$wa:
            return "Portal";
        case $af3a2d87ccb15d29$var$Aa:
            return "Profiler";
        case $af3a2d87ccb15d29$var$za:
            return "StrictMode";
        case $af3a2d87ccb15d29$var$Ea:
            return "Suspense";
        case $af3a2d87ccb15d29$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $af3a2d87ccb15d29$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $af3a2d87ccb15d29$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $af3a2d87ccb15d29$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $af3a2d87ccb15d29$var$Ga:
            return b = a.displayName || null, null !== b ? b : $af3a2d87ccb15d29$var$Qa(a.type) || "Memo";
        case $af3a2d87ccb15d29$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $af3a2d87ccb15d29$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $af3a2d87ccb15d29$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $af3a2d87ccb15d29$var$Qa(b);
        case 8:
            return b === $af3a2d87ccb15d29$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $af3a2d87ccb15d29$var$Ua(a) {
    var b = $af3a2d87ccb15d29$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $af3a2d87ccb15d29$var$Va(a) {
    a._valueTracker || (a._valueTracker = $af3a2d87ccb15d29$var$Ua(a));
}
function $af3a2d87ccb15d29$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $af3a2d87ccb15d29$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $af3a2d87ccb15d29$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $af3a2d87ccb15d29$var$Ya(a, b) {
    var c = b.checked;
    return $af3a2d87ccb15d29$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $af3a2d87ccb15d29$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $af3a2d87ccb15d29$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $af3a2d87ccb15d29$var$ab(a, b) {
    b = b.checked;
    null != b && $af3a2d87ccb15d29$var$ta(a, "checked", b, !1);
}
function $af3a2d87ccb15d29$var$bb(a, b) {
    $af3a2d87ccb15d29$var$ab(a, b);
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $af3a2d87ccb15d29$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $af3a2d87ccb15d29$var$cb(a, b.type, $af3a2d87ccb15d29$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $af3a2d87ccb15d29$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $af3a2d87ccb15d29$var$cb(a, b, c) {
    if ("number" !== b || $af3a2d87ccb15d29$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $af3a2d87ccb15d29$var$eb = Array.isArray;
function $af3a2d87ccb15d29$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $af3a2d87ccb15d29$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $af3a2d87ccb15d29$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($af3a2d87ccb15d29$var$p(91));
    return $af3a2d87ccb15d29$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $af3a2d87ccb15d29$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($af3a2d87ccb15d29$var$p(92));
            if ($af3a2d87ccb15d29$var$eb(c)) {
                if (1 < c.length) throw Error($af3a2d87ccb15d29$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $af3a2d87ccb15d29$var$Sa(c)
    };
}
function $af3a2d87ccb15d29$var$ib(a, b) {
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = $af3a2d87ccb15d29$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $af3a2d87ccb15d29$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $af3a2d87ccb15d29$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $af3a2d87ccb15d29$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $af3a2d87ccb15d29$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $af3a2d87ccb15d29$var$mb, $af3a2d87ccb15d29$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $af3a2d87ccb15d29$var$mb = $af3a2d87ccb15d29$var$mb || document.createElement("div");
        $af3a2d87ccb15d29$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $af3a2d87ccb15d29$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $af3a2d87ccb15d29$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $af3a2d87ccb15d29$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $af3a2d87ccb15d29$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($af3a2d87ccb15d29$var$pb).forEach(function(a) {
    $af3a2d87ccb15d29$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $af3a2d87ccb15d29$var$pb[b] = $af3a2d87ccb15d29$var$pb[a];
    });
});
function $af3a2d87ccb15d29$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $af3a2d87ccb15d29$var$pb.hasOwnProperty(a) && $af3a2d87ccb15d29$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $af3a2d87ccb15d29$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $af3a2d87ccb15d29$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $af3a2d87ccb15d29$var$tb = $af3a2d87ccb15d29$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $af3a2d87ccb15d29$var$ub(a, b) {
    if (b) {
        if ($af3a2d87ccb15d29$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($af3a2d87ccb15d29$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($af3a2d87ccb15d29$var$p(62));
    }
}
function $af3a2d87ccb15d29$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $af3a2d87ccb15d29$var$wb = null;
function $af3a2d87ccb15d29$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $af3a2d87ccb15d29$var$yb = null, $af3a2d87ccb15d29$var$zb = null, $af3a2d87ccb15d29$var$Ab = null;
function $af3a2d87ccb15d29$var$Bb(a) {
    if (a = $af3a2d87ccb15d29$var$Cb(a)) {
        if ("function" !== typeof $af3a2d87ccb15d29$var$yb) throw Error($af3a2d87ccb15d29$var$p(280));
        var b = a.stateNode;
        b && (b = $af3a2d87ccb15d29$var$Db(b), $af3a2d87ccb15d29$var$yb(a.stateNode, a.type, b));
    }
}
function $af3a2d87ccb15d29$var$Eb(a) {
    $af3a2d87ccb15d29$var$zb ? $af3a2d87ccb15d29$var$Ab ? $af3a2d87ccb15d29$var$Ab.push(a) : $af3a2d87ccb15d29$var$Ab = [
        a
    ] : $af3a2d87ccb15d29$var$zb = a;
}
function $af3a2d87ccb15d29$var$Fb() {
    if ($af3a2d87ccb15d29$var$zb) {
        var a = $af3a2d87ccb15d29$var$zb, b = $af3a2d87ccb15d29$var$Ab;
        $af3a2d87ccb15d29$var$Ab = $af3a2d87ccb15d29$var$zb = null;
        $af3a2d87ccb15d29$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$Bb(b[a]);
    }
}
function $af3a2d87ccb15d29$var$Gb(a, b) {
    return a(b);
}
function $af3a2d87ccb15d29$var$Hb() {}
var $af3a2d87ccb15d29$var$Ib = !1;
function $af3a2d87ccb15d29$var$Jb(a, b, c) {
    if ($af3a2d87ccb15d29$var$Ib) return a(b, c);
    $af3a2d87ccb15d29$var$Ib = !0;
    try {
        return $af3a2d87ccb15d29$var$Gb(a, b, c);
    } finally{
        if ($af3a2d87ccb15d29$var$Ib = !1, null !== $af3a2d87ccb15d29$var$zb || null !== $af3a2d87ccb15d29$var$Ab) $af3a2d87ccb15d29$var$Hb(), $af3a2d87ccb15d29$var$Fb();
    }
}
function $af3a2d87ccb15d29$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $af3a2d87ccb15d29$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($af3a2d87ccb15d29$var$p(231, b, typeof c));
    return c;
}
var $af3a2d87ccb15d29$var$Lb = !1;
if ($af3a2d87ccb15d29$var$ia) try {
    var $af3a2d87ccb15d29$var$Mb = {};
    Object.defineProperty($af3a2d87ccb15d29$var$Mb, "passive", {
        get: function() {
            $af3a2d87ccb15d29$var$Lb = !0;
        }
    });
    window.addEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
    window.removeEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
} catch (a) {
    $af3a2d87ccb15d29$var$Lb = !1;
}
function $af3a2d87ccb15d29$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $af3a2d87ccb15d29$var$Ob = !1, $af3a2d87ccb15d29$var$Pb = null, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, $af3a2d87ccb15d29$var$Sb = {
    onError: function(a) {
        $af3a2d87ccb15d29$var$Ob = !0;
        $af3a2d87ccb15d29$var$Pb = a;
    }
};
function $af3a2d87ccb15d29$var$Tb(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Ob = !1;
    $af3a2d87ccb15d29$var$Pb = null;
    $af3a2d87ccb15d29$var$Nb.apply($af3a2d87ccb15d29$var$Sb, arguments);
}
function $af3a2d87ccb15d29$var$Ub(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Tb.apply(this, arguments);
    if ($af3a2d87ccb15d29$var$Ob) {
        if ($af3a2d87ccb15d29$var$Ob) {
            var l = $af3a2d87ccb15d29$var$Pb;
            $af3a2d87ccb15d29$var$Ob = !1;
            $af3a2d87ccb15d29$var$Pb = null;
        } else throw Error($af3a2d87ccb15d29$var$p(198));
        $af3a2d87ccb15d29$var$Qb || ($af3a2d87ccb15d29$var$Qb = !0, $af3a2d87ccb15d29$var$Rb = l);
    }
}
function $af3a2d87ccb15d29$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $af3a2d87ccb15d29$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xb(a) {
    if ($af3a2d87ccb15d29$var$Vb(a) !== a) throw Error($af3a2d87ccb15d29$var$p(188));
}
function $af3a2d87ccb15d29$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $af3a2d87ccb15d29$var$Vb(a);
        if (null === b) throw Error($af3a2d87ccb15d29$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $af3a2d87ccb15d29$var$Xb(e), a;
                if (f === d) return $af3a2d87ccb15d29$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($af3a2d87ccb15d29$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($af3a2d87ccb15d29$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($af3a2d87ccb15d29$var$p(190));
    }
    if (3 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $af3a2d87ccb15d29$var$Zb(a) {
    a = $af3a2d87ccb15d29$var$Yb(a);
    return null !== a ? $af3a2d87ccb15d29$var$$b(a) : null;
}
function $af3a2d87ccb15d29$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $af3a2d87ccb15d29$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$ac = $7DCHO.unstable_scheduleCallback, $af3a2d87ccb15d29$var$bc = $7DCHO.unstable_cancelCallback, $af3a2d87ccb15d29$var$cc = $7DCHO.unstable_shouldYield, $af3a2d87ccb15d29$var$dc = $7DCHO.unstable_requestPaint, $af3a2d87ccb15d29$var$B = $7DCHO.unstable_now, $af3a2d87ccb15d29$var$ec = $7DCHO.unstable_getCurrentPriorityLevel, $af3a2d87ccb15d29$var$fc = $7DCHO.unstable_ImmediatePriority, $af3a2d87ccb15d29$var$gc = $7DCHO.unstable_UserBlockingPriority, $af3a2d87ccb15d29$var$hc = $7DCHO.unstable_NormalPriority, $af3a2d87ccb15d29$var$ic = $7DCHO.unstable_LowPriority, $af3a2d87ccb15d29$var$jc = $7DCHO.unstable_IdlePriority, $af3a2d87ccb15d29$var$kc = null, $af3a2d87ccb15d29$var$lc = null;
function $af3a2d87ccb15d29$var$mc(a) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberRoot) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberRoot($af3a2d87ccb15d29$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $af3a2d87ccb15d29$var$oc = Math.clz32 ? Math.clz32 : $af3a2d87ccb15d29$var$nc, $af3a2d87ccb15d29$var$pc = Math.log, $af3a2d87ccb15d29$var$qc = Math.LN2;
function $af3a2d87ccb15d29$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($af3a2d87ccb15d29$var$pc(a) / $af3a2d87ccb15d29$var$qc | 0) | 0;
}
var $af3a2d87ccb15d29$var$rc = 64, $af3a2d87ccb15d29$var$sc = 4194304;
function $af3a2d87ccb15d29$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $af3a2d87ccb15d29$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $af3a2d87ccb15d29$var$tc(h) : (f &= g, 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $af3a2d87ccb15d29$var$tc(g) : 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $af3a2d87ccb15d29$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $af3a2d87ccb15d29$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $af3a2d87ccb15d29$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $af3a2d87ccb15d29$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $af3a2d87ccb15d29$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $af3a2d87ccb15d29$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $af3a2d87ccb15d29$var$yc() {
    var a = $af3a2d87ccb15d29$var$rc;
    $af3a2d87ccb15d29$var$rc <<= 1;
    0 === ($af3a2d87ccb15d29$var$rc & 4194240) && ($af3a2d87ccb15d29$var$rc = 64);
    return a;
}
function $af3a2d87ccb15d29$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $af3a2d87ccb15d29$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $af3a2d87ccb15d29$var$oc(b);
    a[b] = c;
}
function $af3a2d87ccb15d29$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $af3a2d87ccb15d29$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $af3a2d87ccb15d29$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $af3a2d87ccb15d29$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $af3a2d87ccb15d29$var$C = 0;
function $af3a2d87ccb15d29$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $af3a2d87ccb15d29$var$Ec, $af3a2d87ccb15d29$var$Fc, $af3a2d87ccb15d29$var$Gc, $af3a2d87ccb15d29$var$Hc, $af3a2d87ccb15d29$var$Ic, $af3a2d87ccb15d29$var$Jc = !1, $af3a2d87ccb15d29$var$Kc = [], $af3a2d87ccb15d29$var$Lc = null, $af3a2d87ccb15d29$var$Mc = null, $af3a2d87ccb15d29$var$Nc = null, $af3a2d87ccb15d29$var$Oc = new Map, $af3a2d87ccb15d29$var$Pc = new Map, $af3a2d87ccb15d29$var$Qc = [], $af3a2d87ccb15d29$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $af3a2d87ccb15d29$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $af3a2d87ccb15d29$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $af3a2d87ccb15d29$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $af3a2d87ccb15d29$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $af3a2d87ccb15d29$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $af3a2d87ccb15d29$var$Pc.delete(b.pointerId);
    }
}
function $af3a2d87ccb15d29$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $af3a2d87ccb15d29$var$Cb(b), null !== b && $af3a2d87ccb15d29$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $af3a2d87ccb15d29$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $af3a2d87ccb15d29$var$Lc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $af3a2d87ccb15d29$var$Mc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $af3a2d87ccb15d29$var$Nc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $af3a2d87ccb15d29$var$Oc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $af3a2d87ccb15d29$var$Pc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Vc(a) {
    var b = $af3a2d87ccb15d29$var$Wc(a.target);
    if (null !== b) {
        var c = $af3a2d87ccb15d29$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $af3a2d87ccb15d29$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $af3a2d87ccb15d29$var$Ic(a.priority, function() {
                        $af3a2d87ccb15d29$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $af3a2d87ccb15d29$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $af3a2d87ccb15d29$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $af3a2d87ccb15d29$var$wb = d;
            c.target.dispatchEvent(d);
            $af3a2d87ccb15d29$var$wb = null;
        } else return b = $af3a2d87ccb15d29$var$Cb(c), null !== b && $af3a2d87ccb15d29$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Zc(a, b, c) {
    $af3a2d87ccb15d29$var$Xc(a) && c.delete(b);
}
function $af3a2d87ccb15d29$var$$c() {
    $af3a2d87ccb15d29$var$Jc = !1;
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Lc) && ($af3a2d87ccb15d29$var$Lc = null);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Mc) && ($af3a2d87ccb15d29$var$Mc = null);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Nc) && ($af3a2d87ccb15d29$var$Nc = null);
    $af3a2d87ccb15d29$var$Oc.forEach($af3a2d87ccb15d29$var$Zc);
    $af3a2d87ccb15d29$var$Pc.forEach($af3a2d87ccb15d29$var$Zc);
}
function $af3a2d87ccb15d29$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $af3a2d87ccb15d29$var$Jc || ($af3a2d87ccb15d29$var$Jc = !0, $7DCHO.unstable_scheduleCallback($7DCHO.unstable_NormalPriority, $af3a2d87ccb15d29$var$$c)));
}
function $af3a2d87ccb15d29$var$bd(a) {
    function b(b) {
        return $af3a2d87ccb15d29$var$ad(b, a);
    }
    if (0 < $af3a2d87ccb15d29$var$Kc.length) {
        $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Kc[0], a);
        for(var c = 1; c < $af3a2d87ccb15d29$var$Kc.length; c++){
            var d = $af3a2d87ccb15d29$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Lc, a);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Mc, a);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Nc, a);
    $af3a2d87ccb15d29$var$Oc.forEach(b);
    $af3a2d87ccb15d29$var$Pc.forEach(b);
    for(c = 0; c < $af3a2d87ccb15d29$var$Qc.length; c++)d = $af3a2d87ccb15d29$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $af3a2d87ccb15d29$var$Qc.length && (c = $af3a2d87ccb15d29$var$Qc[0], null === c.blockedOn);)$af3a2d87ccb15d29$var$Vc(c), null === c.blockedOn && $af3a2d87ccb15d29$var$Qc.shift();
}
var $af3a2d87ccb15d29$var$cd = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$dd = !0;
function $af3a2d87ccb15d29$var$ed(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$gd(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 4, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$fd(a, b, c, d) {
    if ($af3a2d87ccb15d29$var$dd) {
        var e = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
        if (null === e) $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c), $af3a2d87ccb15d29$var$Sc(a, d);
        else if ($af3a2d87ccb15d29$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($af3a2d87ccb15d29$var$Sc(a, d), b & 4 && -1 < $af3a2d87ccb15d29$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $af3a2d87ccb15d29$var$Cb(e);
                null !== f && $af3a2d87ccb15d29$var$Ec(f);
                f = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
                null === f && $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $af3a2d87ccb15d29$var$hd(a, b, d, null, c);
    }
}
var $af3a2d87ccb15d29$var$id = null;
function $af3a2d87ccb15d29$var$Yc(a, b, c, d) {
    $af3a2d87ccb15d29$var$id = null;
    a = $af3a2d87ccb15d29$var$xb(d);
    a = $af3a2d87ccb15d29$var$Wc(a);
    if (null !== a) {
        if (b = $af3a2d87ccb15d29$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $af3a2d87ccb15d29$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $af3a2d87ccb15d29$var$id = a;
    return null;
}
function $af3a2d87ccb15d29$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($af3a2d87ccb15d29$var$ec()){
                case $af3a2d87ccb15d29$var$fc:
                    return 1;
                case $af3a2d87ccb15d29$var$gc:
                    return 4;
                case $af3a2d87ccb15d29$var$hc:
                case $af3a2d87ccb15d29$var$ic:
                    return 16;
                case $af3a2d87ccb15d29$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ld = null, $af3a2d87ccb15d29$var$md = null;
function $af3a2d87ccb15d29$var$nd() {
    if ($af3a2d87ccb15d29$var$md) return $af3a2d87ccb15d29$var$md;
    var a, b = $af3a2d87ccb15d29$var$ld, c = b.length, d, e = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $af3a2d87ccb15d29$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $af3a2d87ccb15d29$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $af3a2d87ccb15d29$var$pd() {
    return !0;
}
function $af3a2d87ccb15d29$var$qd() {
    return !1;
}
function $af3a2d87ccb15d29$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $af3a2d87ccb15d29$var$pd : $af3a2d87ccb15d29$var$qd;
        this.isPropagationStopped = $af3a2d87ccb15d29$var$qd;
        return this;
    }
    $af3a2d87ccb15d29$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $af3a2d87ccb15d29$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $af3a2d87ccb15d29$var$pd);
        },
        persist: function() {},
        isPersistent: $af3a2d87ccb15d29$var$pd
    });
    return b;
}
var $af3a2d87ccb15d29$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $af3a2d87ccb15d29$var$td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$sd), $af3a2d87ccb15d29$var$ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    view: 0,
    detail: 0
}), $af3a2d87ccb15d29$var$vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$ud), $af3a2d87ccb15d29$var$wd, $af3a2d87ccb15d29$var$xd, $af3a2d87ccb15d29$var$yd, $af3a2d87ccb15d29$var$Ad = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $af3a2d87ccb15d29$var$yd && ($af3a2d87ccb15d29$var$yd && "mousemove" === a.type ? ($af3a2d87ccb15d29$var$wd = a.screenX - $af3a2d87ccb15d29$var$yd.screenX, $af3a2d87ccb15d29$var$xd = a.screenY - $af3a2d87ccb15d29$var$yd.screenY) : $af3a2d87ccb15d29$var$xd = $af3a2d87ccb15d29$var$wd = 0, $af3a2d87ccb15d29$var$yd = a);
        return $af3a2d87ccb15d29$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $af3a2d87ccb15d29$var$xd;
    }
}), $af3a2d87ccb15d29$var$Bd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ad), $af3a2d87ccb15d29$var$Cd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    dataTransfer: 0
}), $af3a2d87ccb15d29$var$Dd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Cd), $af3a2d87ccb15d29$var$Ed = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    relatedTarget: 0
}), $af3a2d87ccb15d29$var$Fd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ed), $af3a2d87ccb15d29$var$Gd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Hd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Gd), $af3a2d87ccb15d29$var$Id = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $af3a2d87ccb15d29$var$Jd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Id), $af3a2d87ccb15d29$var$Kd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    data: 0
}), $af3a2d87ccb15d29$var$Ld = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Kd), $af3a2d87ccb15d29$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $af3a2d87ccb15d29$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $af3a2d87ccb15d29$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $af3a2d87ccb15d29$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $af3a2d87ccb15d29$var$Od[a]) ? !!b[a] : !1;
}
function $af3a2d87ccb15d29$var$zd() {
    return $af3a2d87ccb15d29$var$Pd;
}
var $af3a2d87ccb15d29$var$Qd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $af3a2d87ccb15d29$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $af3a2d87ccb15d29$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $af3a2d87ccb15d29$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $af3a2d87ccb15d29$var$Rd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Qd), $af3a2d87ccb15d29$var$Sd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $af3a2d87ccb15d29$var$Td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Sd), $af3a2d87ccb15d29$var$Ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd
}), $af3a2d87ccb15d29$var$Vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ud), $af3a2d87ccb15d29$var$Wd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Xd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Wd), $af3a2d87ccb15d29$var$Yd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $af3a2d87ccb15d29$var$Zd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Yd), $af3a2d87ccb15d29$var$$d = [
    9,
    13,
    27,
    32
], $af3a2d87ccb15d29$var$ae = $af3a2d87ccb15d29$var$ia && "CompositionEvent" in window, $af3a2d87ccb15d29$var$be = null;
$af3a2d87ccb15d29$var$ia && "documentMode" in document && ($af3a2d87ccb15d29$var$be = document.documentMode);
var $af3a2d87ccb15d29$var$ce = $af3a2d87ccb15d29$var$ia && "TextEvent" in window && !$af3a2d87ccb15d29$var$be, $af3a2d87ccb15d29$var$de = $af3a2d87ccb15d29$var$ia && (!$af3a2d87ccb15d29$var$ae || $af3a2d87ccb15d29$var$be && 8 < $af3a2d87ccb15d29$var$be && 11 >= $af3a2d87ccb15d29$var$be), $af3a2d87ccb15d29$var$ee = String.fromCharCode(32), $af3a2d87ccb15d29$var$fe = !1;
function $af3a2d87ccb15d29$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $af3a2d87ccb15d29$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $af3a2d87ccb15d29$var$ie = !1;
function $af3a2d87ccb15d29$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $af3a2d87ccb15d29$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $af3a2d87ccb15d29$var$fe = !0;
            return $af3a2d87ccb15d29$var$ee;
        case "textInput":
            return a = b.data, a === $af3a2d87ccb15d29$var$ee && $af3a2d87ccb15d29$var$fe ? null : a;
        default:
            return null;
    }
}
function $af3a2d87ccb15d29$var$ke(a, b) {
    if ($af3a2d87ccb15d29$var$ie) return "compositionend" === a || !$af3a2d87ccb15d29$var$ae && $af3a2d87ccb15d29$var$ge(a, b) ? (a = $af3a2d87ccb15d29$var$nd(), $af3a2d87ccb15d29$var$md = $af3a2d87ccb15d29$var$ld = $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $af3a2d87ccb15d29$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $af3a2d87ccb15d29$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$af3a2d87ccb15d29$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $af3a2d87ccb15d29$var$ne(a, b, c, d) {
    $af3a2d87ccb15d29$var$Eb(d);
    b = $af3a2d87ccb15d29$var$oe(b, "onChange");
    0 < b.length && (c = new $af3a2d87ccb15d29$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $af3a2d87ccb15d29$var$pe = null, $af3a2d87ccb15d29$var$qe = null;
function $af3a2d87ccb15d29$var$re(a) {
    $af3a2d87ccb15d29$var$se(a, 0);
}
function $af3a2d87ccb15d29$var$te(a) {
    var b = $af3a2d87ccb15d29$var$ue(a);
    if ($af3a2d87ccb15d29$var$Wa(b)) return a;
}
function $af3a2d87ccb15d29$var$ve(a, b) {
    if ("change" === a) return b;
}
var $af3a2d87ccb15d29$var$we = !1;
if ($af3a2d87ccb15d29$var$ia) {
    var $af3a2d87ccb15d29$var$xe;
    if ($af3a2d87ccb15d29$var$ia) {
        var $af3a2d87ccb15d29$var$ye = "oninput" in document;
        if (!$af3a2d87ccb15d29$var$ye) {
            var $af3a2d87ccb15d29$var$ze = document.createElement("div");
            $af3a2d87ccb15d29$var$ze.setAttribute("oninput", "return;");
            $af3a2d87ccb15d29$var$ye = "function" === typeof $af3a2d87ccb15d29$var$ze.oninput;
        }
        $af3a2d87ccb15d29$var$xe = $af3a2d87ccb15d29$var$ye;
    } else $af3a2d87ccb15d29$var$xe = !1;
    $af3a2d87ccb15d29$var$we = $af3a2d87ccb15d29$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $af3a2d87ccb15d29$var$Ae() {
    $af3a2d87ccb15d29$var$pe && ($af3a2d87ccb15d29$var$pe.detachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be), $af3a2d87ccb15d29$var$qe = $af3a2d87ccb15d29$var$pe = null);
}
function $af3a2d87ccb15d29$var$Be(a) {
    if ("value" === a.propertyName && $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe)) {
        var b = [];
        $af3a2d87ccb15d29$var$ne(b, $af3a2d87ccb15d29$var$qe, a, $af3a2d87ccb15d29$var$xb(a));
        $af3a2d87ccb15d29$var$Jb($af3a2d87ccb15d29$var$re, b);
    }
}
function $af3a2d87ccb15d29$var$Ce(a, b, c) {
    "focusin" === a ? ($af3a2d87ccb15d29$var$Ae(), $af3a2d87ccb15d29$var$pe = b, $af3a2d87ccb15d29$var$qe = c, $af3a2d87ccb15d29$var$pe.attachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be)) : "focusout" === a && $af3a2d87ccb15d29$var$Ae();
}
function $af3a2d87ccb15d29$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe);
}
function $af3a2d87ccb15d29$var$Ee(a, b) {
    if ("click" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $af3a2d87ccb15d29$var$He = "function" === typeof Object.is ? Object.is : $af3a2d87ccb15d29$var$Ge;
function $af3a2d87ccb15d29$var$Ie(a, b) {
    if ($af3a2d87ccb15d29$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$af3a2d87ccb15d29$var$ja.call(b, e) || !$af3a2d87ccb15d29$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $af3a2d87ccb15d29$var$Ke(a, b) {
    var c = $af3a2d87ccb15d29$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $af3a2d87ccb15d29$var$Je(c);
    }
}
function $af3a2d87ccb15d29$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $af3a2d87ccb15d29$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $af3a2d87ccb15d29$var$Me() {
    for(var a = window, b = $af3a2d87ccb15d29$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $af3a2d87ccb15d29$var$Xa(a.document);
    }
    return b;
}
function $af3a2d87ccb15d29$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $af3a2d87ccb15d29$var$Oe(a) {
    var b = $af3a2d87ccb15d29$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $af3a2d87ccb15d29$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $af3a2d87ccb15d29$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $af3a2d87ccb15d29$var$Ke(c, f);
                var g = $af3a2d87ccb15d29$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $af3a2d87ccb15d29$var$Pe = $af3a2d87ccb15d29$var$ia && "documentMode" in document && 11 >= document.documentMode, $af3a2d87ccb15d29$var$Qe = null, $af3a2d87ccb15d29$var$Re = null, $af3a2d87ccb15d29$var$Se = null, $af3a2d87ccb15d29$var$Te = !1;
function $af3a2d87ccb15d29$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $af3a2d87ccb15d29$var$Te || null == $af3a2d87ccb15d29$var$Qe || $af3a2d87ccb15d29$var$Qe !== $af3a2d87ccb15d29$var$Xa(d) || (d = $af3a2d87ccb15d29$var$Qe, "selectionStart" in d && $af3a2d87ccb15d29$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $af3a2d87ccb15d29$var$Se && $af3a2d87ccb15d29$var$Ie($af3a2d87ccb15d29$var$Se, d) || ($af3a2d87ccb15d29$var$Se = d, d = $af3a2d87ccb15d29$var$oe($af3a2d87ccb15d29$var$Re, "onSelect"), 0 < d.length && (b = new $af3a2d87ccb15d29$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $af3a2d87ccb15d29$var$Qe)));
}
function $af3a2d87ccb15d29$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $af3a2d87ccb15d29$var$We = {
    animationend: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationIteration"),
    animationstart: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationStart"),
    transitionend: $af3a2d87ccb15d29$var$Ve("Transition", "TransitionEnd")
}, $af3a2d87ccb15d29$var$Xe = {}, $af3a2d87ccb15d29$var$Ye = {};
$af3a2d87ccb15d29$var$ia && ($af3a2d87ccb15d29$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $af3a2d87ccb15d29$var$We.animationend.animation, delete $af3a2d87ccb15d29$var$We.animationiteration.animation, delete $af3a2d87ccb15d29$var$We.animationstart.animation), "TransitionEvent" in window || delete $af3a2d87ccb15d29$var$We.transitionend.transition);
function $af3a2d87ccb15d29$var$Ze(a) {
    if ($af3a2d87ccb15d29$var$Xe[a]) return $af3a2d87ccb15d29$var$Xe[a];
    if (!$af3a2d87ccb15d29$var$We[a]) return a;
    var b = $af3a2d87ccb15d29$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $af3a2d87ccb15d29$var$Ye) return $af3a2d87ccb15d29$var$Xe[a] = b[c];
    return a;
}
var $af3a2d87ccb15d29$var$$e = $af3a2d87ccb15d29$var$Ze("animationend"), $af3a2d87ccb15d29$var$af = $af3a2d87ccb15d29$var$Ze("animationiteration"), $af3a2d87ccb15d29$var$bf = $af3a2d87ccb15d29$var$Ze("animationstart"), $af3a2d87ccb15d29$var$cf = $af3a2d87ccb15d29$var$Ze("transitionend"), $af3a2d87ccb15d29$var$df = new Map, $af3a2d87ccb15d29$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $af3a2d87ccb15d29$var$ff(a, b) {
    $af3a2d87ccb15d29$var$df.set(a, b);
    $af3a2d87ccb15d29$var$fa(b, [
        a
    ]);
}
for(var $af3a2d87ccb15d29$var$gf = 0; $af3a2d87ccb15d29$var$gf < $af3a2d87ccb15d29$var$ef.length; $af3a2d87ccb15d29$var$gf++){
    var $af3a2d87ccb15d29$var$hf = $af3a2d87ccb15d29$var$ef[$af3a2d87ccb15d29$var$gf], $af3a2d87ccb15d29$var$jf = $af3a2d87ccb15d29$var$hf.toLowerCase(), $af3a2d87ccb15d29$var$kf = $af3a2d87ccb15d29$var$hf[0].toUpperCase() + $af3a2d87ccb15d29$var$hf.slice(1);
    $af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$jf, "on" + $af3a2d87ccb15d29$var$kf);
}
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$$e, "onAnimationEnd");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$af, "onAnimationIteration");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$bf, "onAnimationStart");
$af3a2d87ccb15d29$var$ff("dblclick", "onDoubleClick");
$af3a2d87ccb15d29$var$ff("focusin", "onFocus");
$af3a2d87ccb15d29$var$ff("focusout", "onBlur");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$cf, "onTransitionEnd");
$af3a2d87ccb15d29$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$af3a2d87ccb15d29$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $af3a2d87ccb15d29$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $af3a2d87ccb15d29$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($af3a2d87ccb15d29$var$lf));
function $af3a2d87ccb15d29$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $af3a2d87ccb15d29$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $af3a2d87ccb15d29$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($af3a2d87ccb15d29$var$Qb) throw a = $af3a2d87ccb15d29$var$Rb, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, a;
}
function $af3a2d87ccb15d29$var$D(a, b) {
    var c = b[$af3a2d87ccb15d29$var$of];
    void 0 === c && (c = b[$af3a2d87ccb15d29$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($af3a2d87ccb15d29$var$pf(b, a, 2, !1), c.add(d));
}
function $af3a2d87ccb15d29$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $af3a2d87ccb15d29$var$pf(c, a, d, b);
}
var $af3a2d87ccb15d29$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $af3a2d87ccb15d29$var$sf(a) {
    if (!a[$af3a2d87ccb15d29$var$rf]) {
        a[$af3a2d87ccb15d29$var$rf] = !0;
        $af3a2d87ccb15d29$var$da.forEach(function(b) {
            "selectionchange" !== b && ($af3a2d87ccb15d29$var$mf.has(b) || $af3a2d87ccb15d29$var$qf(b, !1, a), $af3a2d87ccb15d29$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$af3a2d87ccb15d29$var$rf] || (b[$af3a2d87ccb15d29$var$rf] = !0, $af3a2d87ccb15d29$var$qf("selectionchange", !1, b));
    }
}
function $af3a2d87ccb15d29$var$pf(a, b, c, d) {
    switch($af3a2d87ccb15d29$var$jd(b)){
        case 1:
            var e = $af3a2d87ccb15d29$var$ed;
            break;
        case 4:
            e = $af3a2d87ccb15d29$var$gd;
            break;
        default:
            e = $af3a2d87ccb15d29$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$af3a2d87ccb15d29$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $af3a2d87ccb15d29$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $af3a2d87ccb15d29$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $af3a2d87ccb15d29$var$Jb(function() {
        var d = f, e = $af3a2d87ccb15d29$var$xb(c), g = [];
        a: {
            var h = $af3a2d87ccb15d29$var$df.get(a);
            if (void 0 !== h) {
                var k = $af3a2d87ccb15d29$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $af3a2d87ccb15d29$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $af3a2d87ccb15d29$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $af3a2d87ccb15d29$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $af3a2d87ccb15d29$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $af3a2d87ccb15d29$var$Vd;
                        break;
                    case $af3a2d87ccb15d29$var$$e:
                    case $af3a2d87ccb15d29$var$af:
                    case $af3a2d87ccb15d29$var$bf:
                        k = $af3a2d87ccb15d29$var$Hd;
                        break;
                    case $af3a2d87ccb15d29$var$cf:
                        k = $af3a2d87ccb15d29$var$Xd;
                        break;
                    case "scroll":
                        k = $af3a2d87ccb15d29$var$vd;
                        break;
                    case "wheel":
                        k = $af3a2d87ccb15d29$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $af3a2d87ccb15d29$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $af3a2d87ccb15d29$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $af3a2d87ccb15d29$var$Kb(w, x), null != F && t.push($af3a2d87ccb15d29$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $af3a2d87ccb15d29$var$wb && (n = c.relatedTarget || c.fromElement) && ($af3a2d87ccb15d29$var$Wc(n) || n[$af3a2d87ccb15d29$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $af3a2d87ccb15d29$var$Wc(n) : null, null !== n && (J = $af3a2d87ccb15d29$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $af3a2d87ccb15d29$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $af3a2d87ccb15d29$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $af3a2d87ccb15d29$var$ue(k);
                        u = null == n ? h : $af3a2d87ccb15d29$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $af3a2d87ccb15d29$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $af3a2d87ccb15d29$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $af3a2d87ccb15d29$var$vf(F))u++;
                            for(; 0 < w - u;)t = $af3a2d87ccb15d29$var$vf(t), w--;
                            for(; 0 < u - w;)x = $af3a2d87ccb15d29$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $af3a2d87ccb15d29$var$vf(t);
                                x = $af3a2d87ccb15d29$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $af3a2d87ccb15d29$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $af3a2d87ccb15d29$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $af3a2d87ccb15d29$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $af3a2d87ccb15d29$var$ve;
                else if ($af3a2d87ccb15d29$var$me(h)) {
                    if ($af3a2d87ccb15d29$var$we) na = $af3a2d87ccb15d29$var$Fe;
                    else {
                        na = $af3a2d87ccb15d29$var$De;
                        var xa = $af3a2d87ccb15d29$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $af3a2d87ccb15d29$var$Ee);
                if (na && (na = na(a, d))) {
                    $af3a2d87ccb15d29$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $af3a2d87ccb15d29$var$cb(h, "number", h.value);
            }
            xa = d ? $af3a2d87ccb15d29$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($af3a2d87ccb15d29$var$me(xa) || "true" === xa.contentEditable) $af3a2d87ccb15d29$var$Qe = xa, $af3a2d87ccb15d29$var$Re = d, $af3a2d87ccb15d29$var$Se = null;
                    break;
                case "focusout":
                    $af3a2d87ccb15d29$var$Se = $af3a2d87ccb15d29$var$Re = $af3a2d87ccb15d29$var$Qe = null;
                    break;
                case "mousedown":
                    $af3a2d87ccb15d29$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $af3a2d87ccb15d29$var$Te = !1;
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($af3a2d87ccb15d29$var$Pe) break;
                case "keydown":
                case "keyup":
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
            }
            var $a;
            if ($af3a2d87ccb15d29$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $af3a2d87ccb15d29$var$ie ? $af3a2d87ccb15d29$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($af3a2d87ccb15d29$var$de && "ko" !== c.locale && ($af3a2d87ccb15d29$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $af3a2d87ccb15d29$var$ie && ($a = $af3a2d87ccb15d29$var$nd()) : ($af3a2d87ccb15d29$var$kd = e, $af3a2d87ccb15d29$var$ld = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, $af3a2d87ccb15d29$var$ie = !0)), xa = $af3a2d87ccb15d29$var$oe(d, ba), 0 < xa.length && (ba = new $af3a2d87ccb15d29$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $af3a2d87ccb15d29$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $af3a2d87ccb15d29$var$ce ? $af3a2d87ccb15d29$var$je(a, c) : $af3a2d87ccb15d29$var$ke(a, c)) d = $af3a2d87ccb15d29$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $af3a2d87ccb15d29$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $af3a2d87ccb15d29$var$se(g, b);
    });
}
function $af3a2d87ccb15d29$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $af3a2d87ccb15d29$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $af3a2d87ccb15d29$var$Kb(a, c), null != f && d.unshift($af3a2d87ccb15d29$var$tf(a, f, e)), f = $af3a2d87ccb15d29$var$Kb(a, b), null != f && d.push($af3a2d87ccb15d29$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $af3a2d87ccb15d29$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $af3a2d87ccb15d29$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.unshift($af3a2d87ccb15d29$var$tf(c, k, h))) : e || (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.push($af3a2d87ccb15d29$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $af3a2d87ccb15d29$var$xf = /\r\n?/g, $af3a2d87ccb15d29$var$yf = /\u0000|\uFFFD/g;
function $af3a2d87ccb15d29$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($af3a2d87ccb15d29$var$xf, "\n").replace($af3a2d87ccb15d29$var$yf, "");
}
function $af3a2d87ccb15d29$var$Af(a, b, c) {
    b = $af3a2d87ccb15d29$var$zf(b);
    if ($af3a2d87ccb15d29$var$zf(a) !== b && c) throw Error($af3a2d87ccb15d29$var$p(425));
}
function $af3a2d87ccb15d29$var$Bf() {}
var $af3a2d87ccb15d29$var$Cf = null, $af3a2d87ccb15d29$var$Df = null;
function $af3a2d87ccb15d29$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $af3a2d87ccb15d29$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $af3a2d87ccb15d29$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $af3a2d87ccb15d29$var$Hf = "function" === typeof Promise ? Promise : void 0, $af3a2d87ccb15d29$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $af3a2d87ccb15d29$var$Hf ? function(a) {
    return $af3a2d87ccb15d29$var$Hf.resolve(null).then(a).catch($af3a2d87ccb15d29$var$If);
} : $af3a2d87ccb15d29$var$Ff;
function $af3a2d87ccb15d29$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $af3a2d87ccb15d29$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $af3a2d87ccb15d29$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $af3a2d87ccb15d29$var$bd(b);
}
function $af3a2d87ccb15d29$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $af3a2d87ccb15d29$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nf = Math.random().toString(36).slice(2), $af3a2d87ccb15d29$var$Of = "__reactFiber$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Pf = "__reactProps$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$uf = "__reactContainer$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$of = "__reactEvents$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Qf = "__reactListeners$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Rf = "__reactHandles$" + $af3a2d87ccb15d29$var$Nf;
function $af3a2d87ccb15d29$var$Wc(a) {
    var b = a[$af3a2d87ccb15d29$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$af3a2d87ccb15d29$var$uf] || c[$af3a2d87ccb15d29$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $af3a2d87ccb15d29$var$Mf(a); null !== a;){
                if (c = a[$af3a2d87ccb15d29$var$Of]) return c;
                a = $af3a2d87ccb15d29$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Cb(a) {
    a = a[$af3a2d87ccb15d29$var$Of] || a[$af3a2d87ccb15d29$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $af3a2d87ccb15d29$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($af3a2d87ccb15d29$var$p(33));
}
function $af3a2d87ccb15d29$var$Db(a) {
    return a[$af3a2d87ccb15d29$var$Pf] || null;
}
var $af3a2d87ccb15d29$var$Sf = [], $af3a2d87ccb15d29$var$Tf = -1;
function $af3a2d87ccb15d29$var$Uf(a) {
    return {
        current: a
    };
}
function $af3a2d87ccb15d29$var$E(a) {
    0 > $af3a2d87ccb15d29$var$Tf || (a.current = $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf], $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = null, $af3a2d87ccb15d29$var$Tf--);
}
function $af3a2d87ccb15d29$var$G(a, b) {
    $af3a2d87ccb15d29$var$Tf++;
    $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = a.current;
    a.current = b;
}
var $af3a2d87ccb15d29$var$Vf = {}, $af3a2d87ccb15d29$var$H = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Vf), $af3a2d87ccb15d29$var$Wf = $af3a2d87ccb15d29$var$Uf(!1), $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$Vf;
function $af3a2d87ccb15d29$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $af3a2d87ccb15d29$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $af3a2d87ccb15d29$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $af3a2d87ccb15d29$var$$f() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
}
function $af3a2d87ccb15d29$var$ag(a, b, c) {
    if ($af3a2d87ccb15d29$var$H.current !== $af3a2d87ccb15d29$var$Vf) throw Error($af3a2d87ccb15d29$var$p(168));
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
function $af3a2d87ccb15d29$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($af3a2d87ccb15d29$var$p(108, $af3a2d87ccb15d29$var$Ra(a) || "Unknown", e));
    return $af3a2d87ccb15d29$var$A({}, c, d);
}
function $af3a2d87ccb15d29$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $af3a2d87ccb15d29$var$Vf;
    $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$H.current;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, $af3a2d87ccb15d29$var$Wf.current);
    return !0;
}
function $af3a2d87ccb15d29$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($af3a2d87ccb15d29$var$p(169));
    c ? (a = $af3a2d87ccb15d29$var$bg(a, b, $af3a2d87ccb15d29$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a)) : $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
var $af3a2d87ccb15d29$var$eg = null, $af3a2d87ccb15d29$var$fg = !1, $af3a2d87ccb15d29$var$gg = !1;
function $af3a2d87ccb15d29$var$hg(a) {
    null === $af3a2d87ccb15d29$var$eg ? $af3a2d87ccb15d29$var$eg = [
        a
    ] : $af3a2d87ccb15d29$var$eg.push(a);
}
function $af3a2d87ccb15d29$var$ig(a) {
    $af3a2d87ccb15d29$var$fg = !0;
    $af3a2d87ccb15d29$var$hg(a);
}
function $af3a2d87ccb15d29$var$jg() {
    if (!$af3a2d87ccb15d29$var$gg && null !== $af3a2d87ccb15d29$var$eg) {
        $af3a2d87ccb15d29$var$gg = !0;
        var a = 0, b = $af3a2d87ccb15d29$var$C;
        try {
            var c = $af3a2d87ccb15d29$var$eg;
            for($af3a2d87ccb15d29$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $af3a2d87ccb15d29$var$eg = null;
            $af3a2d87ccb15d29$var$fg = !1;
        } catch (e) {
            throw null !== $af3a2d87ccb15d29$var$eg && ($af3a2d87ccb15d29$var$eg = $af3a2d87ccb15d29$var$eg.slice(a + 1)), $af3a2d87ccb15d29$var$ac($af3a2d87ccb15d29$var$fc, $af3a2d87ccb15d29$var$jg), e;
        } finally{
            $af3a2d87ccb15d29$var$C = b, $af3a2d87ccb15d29$var$gg = !1;
        }
    }
    return null;
}
var $af3a2d87ccb15d29$var$kg = [], $af3a2d87ccb15d29$var$lg = 0, $af3a2d87ccb15d29$var$mg = null, $af3a2d87ccb15d29$var$ng = 0, $af3a2d87ccb15d29$var$og = [], $af3a2d87ccb15d29$var$pg = 0, $af3a2d87ccb15d29$var$qg = null, $af3a2d87ccb15d29$var$rg = 1, $af3a2d87ccb15d29$var$sg = "";
function $af3a2d87ccb15d29$var$tg(a, b) {
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$ng;
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$mg;
    $af3a2d87ccb15d29$var$mg = a;
    $af3a2d87ccb15d29$var$ng = b;
}
function $af3a2d87ccb15d29$var$ug(a, b, c) {
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg;
    $af3a2d87ccb15d29$var$qg = a;
    var d = $af3a2d87ccb15d29$var$rg;
    a = $af3a2d87ccb15d29$var$sg;
    var e = 32 - $af3a2d87ccb15d29$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $af3a2d87ccb15d29$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $af3a2d87ccb15d29$var$rg = 1 << 32 - $af3a2d87ccb15d29$var$oc(b) + e | c << e | d;
        $af3a2d87ccb15d29$var$sg = f + a;
    } else $af3a2d87ccb15d29$var$rg = 1 << f | c << e | d, $af3a2d87ccb15d29$var$sg = a;
}
function $af3a2d87ccb15d29$var$vg(a) {
    null !== a.return && ($af3a2d87ccb15d29$var$tg(a, 1), $af3a2d87ccb15d29$var$ug(a, 1, 0));
}
function $af3a2d87ccb15d29$var$wg(a) {
    for(; a === $af3a2d87ccb15d29$var$mg;)$af3a2d87ccb15d29$var$mg = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null, $af3a2d87ccb15d29$var$ng = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null;
    for(; a === $af3a2d87ccb15d29$var$qg;)$af3a2d87ccb15d29$var$qg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$sg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$rg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null;
}
var $af3a2d87ccb15d29$var$xg = null, $af3a2d87ccb15d29$var$yg = null, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$zg = null;
function $af3a2d87ccb15d29$var$Ag(a, b) {
    var c = $af3a2d87ccb15d29$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $af3a2d87ccb15d29$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $af3a2d87ccb15d29$var$qg ? {
                id: $af3a2d87ccb15d29$var$rg,
                overflow: $af3a2d87ccb15d29$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $af3a2d87ccb15d29$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $af3a2d87ccb15d29$var$Eg(a) {
    if ($af3a2d87ccb15d29$var$I) {
        var b = $af3a2d87ccb15d29$var$yg;
        if (b) {
            var c = b;
            if (!$af3a2d87ccb15d29$var$Cg(a, b)) {
                if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
                b = $af3a2d87ccb15d29$var$Lf(c.nextSibling);
                var d = $af3a2d87ccb15d29$var$xg;
                b && $af3a2d87ccb15d29$var$Cg(a, b) ? $af3a2d87ccb15d29$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$xg = a);
            }
        } else {
            if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $af3a2d87ccb15d29$var$I = !1;
            $af3a2d87ccb15d29$var$xg = a;
        }
    }
}
function $af3a2d87ccb15d29$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $af3a2d87ccb15d29$var$xg = a;
}
function $af3a2d87ccb15d29$var$Gg(a) {
    if (a !== $af3a2d87ccb15d29$var$xg) return !1;
    if (!$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$Fg(a), $af3a2d87ccb15d29$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$af3a2d87ccb15d29$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $af3a2d87ccb15d29$var$yg)) {
        if ($af3a2d87ccb15d29$var$Dg(a)) throw $af3a2d87ccb15d29$var$Hg(), Error($af3a2d87ccb15d29$var$p(418));
        for(; b;)$af3a2d87ccb15d29$var$Ag(a, b), b = $af3a2d87ccb15d29$var$Lf(b.nextSibling);
    }
    $af3a2d87ccb15d29$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($af3a2d87ccb15d29$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $af3a2d87ccb15d29$var$yg = null;
        }
    } else $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg ? $af3a2d87ccb15d29$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $af3a2d87ccb15d29$var$Hg() {
    for(var a = $af3a2d87ccb15d29$var$yg; a;)a = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
}
function $af3a2d87ccb15d29$var$Ig() {
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg = null;
    $af3a2d87ccb15d29$var$I = !1;
}
function $af3a2d87ccb15d29$var$Jg(a) {
    null === $af3a2d87ccb15d29$var$zg ? $af3a2d87ccb15d29$var$zg = [
        a
    ] : $af3a2d87ccb15d29$var$zg.push(a);
}
var $af3a2d87ccb15d29$var$Kg = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig;
function $af3a2d87ccb15d29$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $af3a2d87ccb15d29$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Mg = $af3a2d87ccb15d29$var$Uf(null), $af3a2d87ccb15d29$var$Ng = null, $af3a2d87ccb15d29$var$Og = null, $af3a2d87ccb15d29$var$Pg = null;
function $af3a2d87ccb15d29$var$Qg() {
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Ng = null;
}
function $af3a2d87ccb15d29$var$Rg(a) {
    var b = $af3a2d87ccb15d29$var$Mg.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Mg);
    a._currentValue = b;
}
function $af3a2d87ccb15d29$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $af3a2d87ccb15d29$var$Tg(a, b) {
    $af3a2d87ccb15d29$var$Ng = a;
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($af3a2d87ccb15d29$var$Ug = !0), a.firstContext = null);
}
function $af3a2d87ccb15d29$var$Vg(a) {
    var b = a._currentValue;
    if ($af3a2d87ccb15d29$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $af3a2d87ccb15d29$var$Og) {
            if (null === $af3a2d87ccb15d29$var$Ng) throw Error($af3a2d87ccb15d29$var$p(308));
            $af3a2d87ccb15d29$var$Og = a;
            $af3a2d87ccb15d29$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Og.next = a;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Wg = null;
function $af3a2d87ccb15d29$var$Xg(a) {
    null === $af3a2d87ccb15d29$var$Wg ? $af3a2d87ccb15d29$var$Wg = [
        a
    ] : $af3a2d87ccb15d29$var$Wg.push(a);
}
function $af3a2d87ccb15d29$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $af3a2d87ccb15d29$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $af3a2d87ccb15d29$var$Zg(a, d);
}
function $af3a2d87ccb15d29$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $af3a2d87ccb15d29$var$$g = !1;
function $af3a2d87ccb15d29$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $af3a2d87ccb15d29$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $af3a2d87ccb15d29$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $af3a2d87ccb15d29$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $af3a2d87ccb15d29$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $af3a2d87ccb15d29$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $af3a2d87ccb15d29$var$Zg(a, c);
}
function $af3a2d87ccb15d29$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
function $af3a2d87ccb15d29$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $af3a2d87ccb15d29$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $af3a2d87ccb15d29$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $af3a2d87ccb15d29$var$A({}, q, r);
                            break a;
                        case 2:
                            $af3a2d87ccb15d29$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $af3a2d87ccb15d29$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $af3a2d87ccb15d29$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($af3a2d87ccb15d29$var$p(191, e));
            e.call(d);
        }
    }
}
var $af3a2d87ccb15d29$var$jh = (new $lx97N.Component).refs;
function $af3a2d87ccb15d29$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $af3a2d87ccb15d29$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $af3a2d87ccb15d29$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $af3a2d87ccb15d29$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $af3a2d87ccb15d29$var$L(), d = $af3a2d87ccb15d29$var$lh(a), e = $af3a2d87ccb15d29$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $af3a2d87ccb15d29$var$dh(a, e, d);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, d, c), $af3a2d87ccb15d29$var$eh(b, a, d));
    }
};
function $af3a2d87ccb15d29$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$af3a2d87ccb15d29$var$Ie(c, d) || !$af3a2d87ccb15d29$var$Ie(e, f) : !0;
}
function $af3a2d87ccb15d29$var$ph(a, b, c) {
    var d = !1, e = $af3a2d87ccb15d29$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $af3a2d87ccb15d29$var$Vg(f) : (e = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $af3a2d87ccb15d29$var$Yf(a, e) : $af3a2d87ccb15d29$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $af3a2d87ccb15d29$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $af3a2d87ccb15d29$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(b, b.state, null);
}
function $af3a2d87ccb15d29$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $af3a2d87ccb15d29$var$jh;
    $af3a2d87ccb15d29$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $af3a2d87ccb15d29$var$Vg(f) : (f = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, e.context = $af3a2d87ccb15d29$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($af3a2d87ccb15d29$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(e, e.state, null), $af3a2d87ccb15d29$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $af3a2d87ccb15d29$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($af3a2d87ccb15d29$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $af3a2d87ccb15d29$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($af3a2d87ccb15d29$var$p(284));
        if (!c._owner) throw Error($af3a2d87ccb15d29$var$p(290, a));
    }
    return a;
}
function $af3a2d87ccb15d29$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($af3a2d87ccb15d29$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $af3a2d87ccb15d29$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $af3a2d87ccb15d29$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $af3a2d87ccb15d29$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $af3a2d87ccb15d29$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $af3a2d87ccb15d29$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $af3a2d87ccb15d29$var$sh(a, b, c), d.return = a, d;
        d = $af3a2d87ccb15d29$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $af3a2d87ccb15d29$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $af3a2d87ccb15d29$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $af3a2d87ccb15d29$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $af3a2d87ccb15d29$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c = $af3a2d87ccb15d29$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $af3a2d87ccb15d29$var$sh(a, null, b), c.return = a, c;
                case $af3a2d87ccb15d29$var$wa:
                    return b = $af3a2d87ccb15d29$var$zh(b, a.mode, c), b.return = a, b;
                case $af3a2d87ccb15d29$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($af3a2d87ccb15d29$var$eb(b) || $af3a2d87ccb15d29$var$Ka(b)) return b = $af3a2d87ccb15d29$var$Ah(b, a.mode, c, null), b.return = a, b;
            $af3a2d87ccb15d29$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($af3a2d87ccb15d29$var$eb(c) || $af3a2d87ccb15d29$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $af3a2d87ccb15d29$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $af3a2d87ccb15d29$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $af3a2d87ccb15d29$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($af3a2d87ccb15d29$var$eb(d) || $af3a2d87ccb15d29$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $af3a2d87ccb15d29$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $af3a2d87ccb15d29$var$Ka(h);
        if ("function" !== typeof l) throw Error($af3a2d87ccb15d29$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($af3a2d87ccb15d29$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $af3a2d87ccb15d29$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $af3a2d87ccb15d29$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $af3a2d87ccb15d29$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $af3a2d87ccb15d29$var$ya ? (d = $af3a2d87ccb15d29$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $af3a2d87ccb15d29$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $af3a2d87ccb15d29$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $af3a2d87ccb15d29$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($af3a2d87ccb15d29$var$eb(f)) return n(a, d, f, h);
            if ($af3a2d87ccb15d29$var$Ka(f)) return t(a, d, f, h);
            $af3a2d87ccb15d29$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $af3a2d87ccb15d29$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $af3a2d87ccb15d29$var$Bh = $af3a2d87ccb15d29$var$vh(!0), $af3a2d87ccb15d29$var$Ch = $af3a2d87ccb15d29$var$vh(!1), $af3a2d87ccb15d29$var$Dh = {}, $af3a2d87ccb15d29$var$Eh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Fh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Gh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh);
function $af3a2d87ccb15d29$var$Hh(a) {
    if (a === $af3a2d87ccb15d29$var$Dh) throw Error($af3a2d87ccb15d29$var$p(174));
    return a;
}
function $af3a2d87ccb15d29$var$Ih(a, b) {
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Gh, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, $af3a2d87ccb15d29$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $af3a2d87ccb15d29$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $af3a2d87ccb15d29$var$lb(b, a);
    }
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, b);
}
function $af3a2d87ccb15d29$var$Jh() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Gh);
}
function $af3a2d87ccb15d29$var$Kh(a) {
    $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
    var b = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
    var c = $af3a2d87ccb15d29$var$lb(b, a.type);
    b !== c && ($af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, c));
}
function $af3a2d87ccb15d29$var$Lh(a) {
    $af3a2d87ccb15d29$var$Fh.current === a && ($af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh));
}
var $af3a2d87ccb15d29$var$M = $af3a2d87ccb15d29$var$Uf(0);
function $af3a2d87ccb15d29$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nh = [];
function $af3a2d87ccb15d29$var$Oh() {
    for(var a = 0; a < $af3a2d87ccb15d29$var$Nh.length; a++)$af3a2d87ccb15d29$var$Nh[a]._workInProgressVersionPrimary = null;
    $af3a2d87ccb15d29$var$Nh.length = 0;
}
var $af3a2d87ccb15d29$var$Ph = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$Qh = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$Rh = 0, $af3a2d87ccb15d29$var$N = null, $af3a2d87ccb15d29$var$O = null, $af3a2d87ccb15d29$var$P = null, $af3a2d87ccb15d29$var$Sh = !1, $af3a2d87ccb15d29$var$Th = !1, $af3a2d87ccb15d29$var$Uh = 0, $af3a2d87ccb15d29$var$Vh = 0;
function $af3a2d87ccb15d29$var$Q() {
    throw Error($af3a2d87ccb15d29$var$p(321));
}
function $af3a2d87ccb15d29$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$af3a2d87ccb15d29$var$He(a[c], b[c])) return !1;
    return !0;
}
function $af3a2d87ccb15d29$var$Xh(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$Rh = f;
    $af3a2d87ccb15d29$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $af3a2d87ccb15d29$var$Ph.current = null === a || null === a.memoizedState ? $af3a2d87ccb15d29$var$Yh : $af3a2d87ccb15d29$var$Zh;
    a = c(d, e);
    if ($af3a2d87ccb15d29$var$Th) {
        f = 0;
        do {
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            if (25 <= f) throw Error($af3a2d87ccb15d29$var$p(301));
            f += 1;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = null;
            b.updateQueue = null;
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$$h;
            a = c(d, e);
        }while ($af3a2d87ccb15d29$var$Th);
    }
    $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
    b = null !== $af3a2d87ccb15d29$var$O && null !== $af3a2d87ccb15d29$var$O.next;
    $af3a2d87ccb15d29$var$Rh = 0;
    $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
    $af3a2d87ccb15d29$var$Sh = !1;
    if (b) throw Error($af3a2d87ccb15d29$var$p(300));
    return a;
}
function $af3a2d87ccb15d29$var$bi() {
    var a = 0 !== $af3a2d87ccb15d29$var$Uh;
    $af3a2d87ccb15d29$var$Uh = 0;
    return a;
}
function $af3a2d87ccb15d29$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$di() {
    if (null === $af3a2d87ccb15d29$var$O) {
        var a = $af3a2d87ccb15d29$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $af3a2d87ccb15d29$var$O.next;
    var b = null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState : $af3a2d87ccb15d29$var$P.next;
    if (null !== b) $af3a2d87ccb15d29$var$P = b, $af3a2d87ccb15d29$var$O = a;
    else {
        if (null === a) throw Error($af3a2d87ccb15d29$var$p(310));
        $af3a2d87ccb15d29$var$O = a;
        a = {
            memoizedState: $af3a2d87ccb15d29$var$O.memoizedState,
            baseState: $af3a2d87ccb15d29$var$O.baseState,
            baseQueue: $af3a2d87ccb15d29$var$O.baseQueue,
            queue: $af3a2d87ccb15d29$var$O.queue,
            next: null
        };
        null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    }
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $af3a2d87ccb15d29$var$fi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = $af3a2d87ccb15d29$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($af3a2d87ccb15d29$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $af3a2d87ccb15d29$var$N.lanes |= m;
                $af3a2d87ccb15d29$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $af3a2d87ccb15d29$var$He(d, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $af3a2d87ccb15d29$var$N.lanes |= f, $af3a2d87ccb15d29$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $af3a2d87ccb15d29$var$gi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $af3a2d87ccb15d29$var$He(f, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $af3a2d87ccb15d29$var$hi() {}
function $af3a2d87ccb15d29$var$ii(a, b) {
    var c = $af3a2d87ccb15d29$var$N, d = $af3a2d87ccb15d29$var$di(), e = b(), f = !$af3a2d87ccb15d29$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $af3a2d87ccb15d29$var$Ug = !0);
    d = d.queue;
    $af3a2d87ccb15d29$var$ji($af3a2d87ccb15d29$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $af3a2d87ccb15d29$var$P && $af3a2d87ccb15d29$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
        0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(c, b, e);
    }
    return e;
}
function $af3a2d87ccb15d29$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $af3a2d87ccb15d29$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
}
function $af3a2d87ccb15d29$var$ki(a, b, c) {
    return c(function() {
        $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
    });
}
function $af3a2d87ccb15d29$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$af3a2d87ccb15d29$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $af3a2d87ccb15d29$var$pi(a) {
    var b = $af3a2d87ccb15d29$var$Zg(a, 1);
    null !== b && $af3a2d87ccb15d29$var$mh(b, a, 1, -1);
}
function $af3a2d87ccb15d29$var$qi(a) {
    var b = $af3a2d87ccb15d29$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $af3a2d87ccb15d29$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $af3a2d87ccb15d29$var$ri.bind(null, $af3a2d87ccb15d29$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $af3a2d87ccb15d29$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $af3a2d87ccb15d29$var$si() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$ti(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$ci();
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $af3a2d87ccb15d29$var$ui(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $af3a2d87ccb15d29$var$O) {
        var g = $af3a2d87ccb15d29$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $af3a2d87ccb15d29$var$Wh(d, g.deps)) {
            e.memoizedState = $af3a2d87ccb15d29$var$li(b, c, f, d);
            return;
        }
    }
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, f, d);
}
function $af3a2d87ccb15d29$var$vi(a, b) {
    return $af3a2d87ccb15d29$var$ti(8390656, 8, a, b);
}
function $af3a2d87ccb15d29$var$ji(a, b) {
    return $af3a2d87ccb15d29$var$ui(2048, 8, a, b);
}
function $af3a2d87ccb15d29$var$wi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 2, a, b);
}
function $af3a2d87ccb15d29$var$xi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 4, a, b);
}
function $af3a2d87ccb15d29$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $af3a2d87ccb15d29$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $af3a2d87ccb15d29$var$ui(4, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
}
function $af3a2d87ccb15d29$var$Ai() {}
function $af3a2d87ccb15d29$var$Bi(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Ci(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Di(a, b, c) {
    if (0 === ($af3a2d87ccb15d29$var$Rh & 21)) return a.baseState && (a.baseState = !1, $af3a2d87ccb15d29$var$Ug = !0), a.memoizedState = c;
    $af3a2d87ccb15d29$var$He(c, b) || (c = $af3a2d87ccb15d29$var$yc(), $af3a2d87ccb15d29$var$N.lanes |= c, $af3a2d87ccb15d29$var$hh |= c, a.baseState = !0);
    return b;
}
function $af3a2d87ccb15d29$var$Ei(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    $af3a2d87ccb15d29$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $af3a2d87ccb15d29$var$Qh.transition;
    $af3a2d87ccb15d29$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$Qh.transition = d;
    }
}
function $af3a2d87ccb15d29$var$Fi() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$Gi(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, c);
    else if (c = $af3a2d87ccb15d29$var$Yg(a, b, c, d), null !== c) {
        var e = $af3a2d87ccb15d29$var$L();
        $af3a2d87ccb15d29$var$mh(c, a, d, e);
        $af3a2d87ccb15d29$var$Ji(c, b, d);
    }
}
function $af3a2d87ccb15d29$var$ri(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($af3a2d87ccb15d29$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $af3a2d87ccb15d29$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $af3a2d87ccb15d29$var$Yg(a, b, e, d);
        null !== c && (e = $af3a2d87ccb15d29$var$L(), $af3a2d87ccb15d29$var$mh(c, a, d, e), $af3a2d87ccb15d29$var$Ji(c, b, d));
    }
}
function $af3a2d87ccb15d29$var$Hi(a) {
    var b = a.alternate;
    return a === $af3a2d87ccb15d29$var$N || null !== b && b === $af3a2d87ccb15d29$var$N;
}
function $af3a2d87ccb15d29$var$Ii(a, b) {
    $af3a2d87ccb15d29$var$Th = $af3a2d87ccb15d29$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $af3a2d87ccb15d29$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
var $af3a2d87ccb15d29$var$ai = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Q,
    useContext: $af3a2d87ccb15d29$var$Q,
    useEffect: $af3a2d87ccb15d29$var$Q,
    useImperativeHandle: $af3a2d87ccb15d29$var$Q,
    useInsertionEffect: $af3a2d87ccb15d29$var$Q,
    useLayoutEffect: $af3a2d87ccb15d29$var$Q,
    useMemo: $af3a2d87ccb15d29$var$Q,
    useReducer: $af3a2d87ccb15d29$var$Q,
    useRef: $af3a2d87ccb15d29$var$Q,
    useState: $af3a2d87ccb15d29$var$Q,
    useDebugValue: $af3a2d87ccb15d29$var$Q,
    useDeferredValue: $af3a2d87ccb15d29$var$Q,
    useTransition: $af3a2d87ccb15d29$var$Q,
    useMutableSource: $af3a2d87ccb15d29$var$Q,
    useSyncExternalStore: $af3a2d87ccb15d29$var$Q,
    useId: $af3a2d87ccb15d29$var$Q,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Yh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: function(a, b) {
        $af3a2d87ccb15d29$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $af3a2d87ccb15d29$var$ti(4194308, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $af3a2d87ccb15d29$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $af3a2d87ccb15d29$var$Gi.bind(null, $af3a2d87ccb15d29$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $af3a2d87ccb15d29$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $af3a2d87ccb15d29$var$qi,
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        return $af3a2d87ccb15d29$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$qi(!1), b = a[0];
        a = $af3a2d87ccb15d29$var$Ei.bind(null, a[1]);
        $af3a2d87ccb15d29$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$N, e = $af3a2d87ccb15d29$var$ci();
        if ($af3a2d87ccb15d29$var$I) {
            if (void 0 === c) throw Error($af3a2d87ccb15d29$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
            0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $af3a2d87ccb15d29$var$vi($af3a2d87ccb15d29$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $af3a2d87ccb15d29$var$ci(), b = $af3a2d87ccb15d29$var$R.identifierPrefix;
        if ($af3a2d87ccb15d29$var$I) {
            var c = $af3a2d87ccb15d29$var$sg;
            var d = $af3a2d87ccb15d29$var$rg;
            c = (d & ~(1 << 32 - $af3a2d87ccb15d29$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $af3a2d87ccb15d29$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $af3a2d87ccb15d29$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Zh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$fi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$$h = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$gi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return null === $af3a2d87ccb15d29$var$O ? b.memoizedState = a : $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
};
function $af3a2d87ccb15d29$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $af3a2d87ccb15d29$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $af3a2d87ccb15d29$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $af3a2d87ccb15d29$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $af3a2d87ccb15d29$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $af3a2d87ccb15d29$var$Oi(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $af3a2d87ccb15d29$var$Pi || ($af3a2d87ccb15d29$var$Pi = !0, $af3a2d87ccb15d29$var$Qi = d);
        $af3a2d87ccb15d29$var$Mi(a, b);
    };
    return c;
}
function $af3a2d87ccb15d29$var$Ri(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $af3a2d87ccb15d29$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $af3a2d87ccb15d29$var$Mi(a, b);
        "function" !== typeof d && (null === $af3a2d87ccb15d29$var$Si ? $af3a2d87ccb15d29$var$Si = new Set([
            this
        ]) : $af3a2d87ccb15d29$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $af3a2d87ccb15d29$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $af3a2d87ccb15d29$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $af3a2d87ccb15d29$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $af3a2d87ccb15d29$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $af3a2d87ccb15d29$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $af3a2d87ccb15d29$var$ch(-1, 1), b.tag = 2, $af3a2d87ccb15d29$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $af3a2d87ccb15d29$var$Xi = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$Ug = !1;
function $af3a2d87ccb15d29$var$Yi(a, b, c, d) {
    b.child = null === a ? $af3a2d87ccb15d29$var$Ch(b, null, c, d) : $af3a2d87ccb15d29$var$Bh(b, a.child, c, d);
}
function $af3a2d87ccb15d29$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $af3a2d87ccb15d29$var$Tg(b, e);
    d = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    c = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && c && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, d, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$af3a2d87ccb15d29$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $af3a2d87ccb15d29$var$cj(a, b, f, d, e);
        a = $af3a2d87ccb15d29$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $af3a2d87ccb15d29$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $af3a2d87ccb15d29$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $af3a2d87ccb15d29$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $af3a2d87ccb15d29$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($af3a2d87ccb15d29$var$Ie(f, d) && a.ref === b.ref) {
            if ($af3a2d87ccb15d29$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($af3a2d87ccb15d29$var$Ug = !0);
            else return b.lanes = a.lanes, $af3a2d87ccb15d29$var$$i(a, b, e);
        }
    }
    return $af3a2d87ccb15d29$var$dj(a, b, c, d, e);
}
function $af3a2d87ccb15d29$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj);
            $af3a2d87ccb15d29$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= d;
    $af3a2d87ccb15d29$var$Yi(a, b, e, c);
    return b.child;
}
function $af3a2d87ccb15d29$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $af3a2d87ccb15d29$var$dj(a, b, c, d, e) {
    var f = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current;
    f = $af3a2d87ccb15d29$var$Yf(b, f);
    $af3a2d87ccb15d29$var$Tg(b, e);
    c = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    d = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && d && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, c, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$ij(a, b, c, d, e) {
    if ($af3a2d87ccb15d29$var$Zf(c)) {
        var f = !0;
        $af3a2d87ccb15d29$var$cg(b);
    } else f = !1;
    $af3a2d87ccb15d29$var$Tg(b, e);
    if (null === b.stateNode) $af3a2d87ccb15d29$var$jj(a, b), $af3a2d87ccb15d29$var$ph(b, c, d), $af3a2d87ccb15d29$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $af3a2d87ccb15d29$var$Vg(l) : (l = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, l = $af3a2d87ccb15d29$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $af3a2d87ccb15d29$var$qh(b, g, d, l);
        $af3a2d87ccb15d29$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof m && ($af3a2d87ccb15d29$var$kh(b, c, m, d), k = b.memoizedState), (h = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $af3a2d87ccb15d29$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $af3a2d87ccb15d29$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $af3a2d87ccb15d29$var$Vg(k) : (k = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, k = $af3a2d87ccb15d29$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $af3a2d87ccb15d29$var$qh(b, g, d, k);
        $af3a2d87ccb15d29$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof y && ($af3a2d87ccb15d29$var$kh(b, c, y, d), n = b.memoizedState), (l = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $af3a2d87ccb15d29$var$kj(a, b, c, d, f, e);
}
function $af3a2d87ccb15d29$var$kj(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $af3a2d87ccb15d29$var$dg(b, c, !1), $af3a2d87ccb15d29$var$$i(a, b, f);
    d = b.stateNode;
    $af3a2d87ccb15d29$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $af3a2d87ccb15d29$var$Bh(b, a.child, null, f), b.child = $af3a2d87ccb15d29$var$Bh(b, null, h, f)) : $af3a2d87ccb15d29$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $af3a2d87ccb15d29$var$dg(b, c, !0);
    return b.child;
}
function $af3a2d87ccb15d29$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $af3a2d87ccb15d29$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $af3a2d87ccb15d29$var$ag(a, b.context, !1);
    $af3a2d87ccb15d29$var$Ih(a, b.containerInfo);
}
function $af3a2d87ccb15d29$var$mj(a, b, c, d, e) {
    $af3a2d87ccb15d29$var$Ig();
    $af3a2d87ccb15d29$var$Jg(e);
    b.flags |= 256;
    $af3a2d87ccb15d29$var$Yi(a, b, c, d);
    return b.child;
}
var $af3a2d87ccb15d29$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $af3a2d87ccb15d29$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $af3a2d87ccb15d29$var$pj(a, b, c) {
    var d = b.pendingProps, e = $af3a2d87ccb15d29$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, e & 1);
    if (null === a) {
        $af3a2d87ccb15d29$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $af3a2d87ccb15d29$var$qj(g, d, 0, null), a = $af3a2d87ccb15d29$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $af3a2d87ccb15d29$var$oj(c), b.memoizedState = $af3a2d87ccb15d29$var$nj, a) : $af3a2d87ccb15d29$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $af3a2d87ccb15d29$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $af3a2d87ccb15d29$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $af3a2d87ccb15d29$var$wh(h, f) : (f = $af3a2d87ccb15d29$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $af3a2d87ccb15d29$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $af3a2d87ccb15d29$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $af3a2d87ccb15d29$var$rj(a, b) {
    b = $af3a2d87ccb15d29$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $af3a2d87ccb15d29$var$tj(a, b, c, d) {
    null !== d && $af3a2d87ccb15d29$var$Jg(d);
    $af3a2d87ccb15d29$var$Bh(b, a.child, null, c);
    a = $af3a2d87ccb15d29$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $af3a2d87ccb15d29$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(422))), $af3a2d87ccb15d29$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $af3a2d87ccb15d29$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $af3a2d87ccb15d29$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $af3a2d87ccb15d29$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $af3a2d87ccb15d29$var$oj(g);
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $af3a2d87ccb15d29$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($af3a2d87ccb15d29$var$p(419));
        d = $af3a2d87ccb15d29$var$Li(f, d, void 0);
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($af3a2d87ccb15d29$var$Ug || h) {
        d = $af3a2d87ccb15d29$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $af3a2d87ccb15d29$var$Zg(a, e), $af3a2d87ccb15d29$var$mh(d, a, e, -1));
        }
        $af3a2d87ccb15d29$var$uj();
        d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(421)));
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $af3a2d87ccb15d29$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(e.nextSibling);
    $af3a2d87ccb15d29$var$xg = b;
    $af3a2d87ccb15d29$var$I = !0;
    $af3a2d87ccb15d29$var$zg = null;
    null !== a && ($af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg, $af3a2d87ccb15d29$var$rg = a.id, $af3a2d87ccb15d29$var$sg = a.overflow, $af3a2d87ccb15d29$var$qg = b);
    b = $af3a2d87ccb15d29$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $af3a2d87ccb15d29$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $af3a2d87ccb15d29$var$Sg(a.return, b, c);
}
function $af3a2d87ccb15d29$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $af3a2d87ccb15d29$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $af3a2d87ccb15d29$var$Yi(a, b, d.children, c);
    d = $af3a2d87ccb15d29$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (19 === a.tag) $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $af3a2d87ccb15d29$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $af3a2d87ccb15d29$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $af3a2d87ccb15d29$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $af3a2d87ccb15d29$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $af3a2d87ccb15d29$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $af3a2d87ccb15d29$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $af3a2d87ccb15d29$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($af3a2d87ccb15d29$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $af3a2d87ccb15d29$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $af3a2d87ccb15d29$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $af3a2d87ccb15d29$var$lj(b);
            $af3a2d87ccb15d29$var$Ig();
            break;
        case 5:
            $af3a2d87ccb15d29$var$Kh(b);
            break;
        case 1:
            $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$cg(b);
            break;
        case 4:
            $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $af3a2d87ccb15d29$var$pj(a, b, c);
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
                a = $af3a2d87ccb15d29$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $af3a2d87ccb15d29$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    return $af3a2d87ccb15d29$var$$i(a, b, c);
}
var $af3a2d87ccb15d29$var$Aj, $af3a2d87ccb15d29$var$Bj, $af3a2d87ccb15d29$var$Cj, $af3a2d87ccb15d29$var$Dj;
$af3a2d87ccb15d29$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$af3a2d87ccb15d29$var$Bj = function() {};
$af3a2d87ccb15d29$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $af3a2d87ccb15d29$var$Ya(a, e);
                d = $af3a2d87ccb15d29$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $af3a2d87ccb15d29$var$A({}, e, {
                    value: void 0
                });
                d = $af3a2d87ccb15d29$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $af3a2d87ccb15d29$var$gb(a, e);
                d = $af3a2d87ccb15d29$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
        }
        $af3a2d87ccb15d29$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $af3a2d87ccb15d29$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$af3a2d87ccb15d29$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $af3a2d87ccb15d29$var$Ej(a, b) {
    if (!$af3a2d87ccb15d29$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $af3a2d87ccb15d29$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $af3a2d87ccb15d29$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $af3a2d87ccb15d29$var$S(b), null;
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 3:
            d = b.stateNode;
            $af3a2d87ccb15d29$var$Jh();
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
            $af3a2d87ccb15d29$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $af3a2d87ccb15d29$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null));
            $af3a2d87ccb15d29$var$Bj(a, b);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 5:
            $af3a2d87ccb15d29$var$Lh(b);
            var e = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $af3a2d87ccb15d29$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                    $af3a2d87ccb15d29$var$S(b);
                    return null;
                }
                a = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    d[$af3a2d87ccb15d29$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $af3a2d87ccb15d29$var$D("cancel", d);
                            $af3a2d87ccb15d29$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], d);
                            break;
                        case "source":
                            $af3a2d87ccb15d29$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $af3a2d87ccb15d29$var$D("error", d);
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "details":
                            $af3a2d87ccb15d29$var$D("toggle", d);
                            break;
                        case "input":
                            $af3a2d87ccb15d29$var$Za(d, f);
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$hb(d, f), $af3a2d87ccb15d29$var$D("invalid", d);
                    }
                    $af3a2d87ccb15d29$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $af3a2d87ccb15d29$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $af3a2d87ccb15d29$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $af3a2d87ccb15d29$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $af3a2d87ccb15d29$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$af3a2d87ccb15d29$var$Of] = b;
                    a[$af3a2d87ccb15d29$var$Pf] = d;
                    $af3a2d87ccb15d29$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $af3a2d87ccb15d29$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $af3a2d87ccb15d29$var$D("cancel", a);
                                $af3a2d87ccb15d29$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $af3a2d87ccb15d29$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $af3a2d87ccb15d29$var$D("error", a);
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $af3a2d87ccb15d29$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $af3a2d87ccb15d29$var$Za(a, d);
                                e = $af3a2d87ccb15d29$var$Ya(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $af3a2d87ccb15d29$var$A({}, d, {
                                    value: void 0
                                });
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$hb(a, d);
                                e = $af3a2d87ccb15d29$var$gb(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $af3a2d87ccb15d29$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $af3a2d87ccb15d29$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $af3a2d87ccb15d29$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $af3a2d87ccb15d29$var$ob(a, k) : "number" === typeof k && $af3a2d87ccb15d29$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $af3a2d87ccb15d29$var$D("scroll", a) : null != k && $af3a2d87ccb15d29$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $af3a2d87ccb15d29$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $af3a2d87ccb15d29$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $af3a2d87ccb15d29$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $af3a2d87ccb15d29$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                c = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
                $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $af3a2d87ccb15d29$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$af3a2d87ccb15d29$var$Of] = b, b.stateNode = d;
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($af3a2d87ccb15d29$var$I && null !== $af3a2d87ccb15d29$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $af3a2d87ccb15d29$var$Hg(), $af3a2d87ccb15d29$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $af3a2d87ccb15d29$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(317));
                        f[$af3a2d87ccb15d29$var$Of] = b;
                    } else $af3a2d87ccb15d29$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $af3a2d87ccb15d29$var$S(b);
                    f = !1;
                } else null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($af3a2d87ccb15d29$var$M.current & 1) ? 0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 3) : $af3a2d87ccb15d29$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$Bj(a, b), null === a && $af3a2d87ccb15d29$var$sf(b.stateNode.containerInfo), $af3a2d87ccb15d29$var$S(b), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), $af3a2d87ccb15d29$var$S(b), null;
        case 17:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 19:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            f = b.memoizedState;
            if (null === f) return $af3a2d87ccb15d29$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $af3a2d87ccb15d29$var$Ej(f, !1);
                else {
                    if (0 !== $af3a2d87ccb15d29$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $af3a2d87ccb15d29$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $af3a2d87ccb15d29$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $af3a2d87ccb15d29$var$B() > $af3a2d87ccb15d29$var$Hj && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $af3a2d87ccb15d29$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $af3a2d87ccb15d29$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$S(b), null;
                    } else 2 * $af3a2d87ccb15d29$var$B() - f.renderingStartTime > $af3a2d87ccb15d29$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $af3a2d87ccb15d29$var$B(), b.sibling = null, c = $af3a2d87ccb15d29$var$M.current, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d ? c & 1 | 2 : c & 1), b;
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($af3a2d87ccb15d29$var$gj & 1073741824) && ($af3a2d87ccb15d29$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $af3a2d87ccb15d29$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
}
function $af3a2d87ccb15d29$var$Jj(a, b) {
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $af3a2d87ccb15d29$var$Lh(b), null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($af3a2d87ccb15d29$var$p(340));
                $af3a2d87ccb15d29$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M), null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$Kj = !1, $af3a2d87ccb15d29$var$U = !1, $af3a2d87ccb15d29$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $af3a2d87ccb15d29$var$V = null;
function $af3a2d87ccb15d29$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $af3a2d87ccb15d29$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $af3a2d87ccb15d29$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $af3a2d87ccb15d29$var$W(a, b, d);
    }
}
var $af3a2d87ccb15d29$var$Oj = !1;
function $af3a2d87ccb15d29$var$Pj(a, b) {
    $af3a2d87ccb15d29$var$Cf = $af3a2d87ccb15d29$var$dd;
    a = $af3a2d87ccb15d29$var$Me();
    if ($af3a2d87ccb15d29$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $af3a2d87ccb15d29$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $af3a2d87ccb15d29$var$dd = !1;
    for($af3a2d87ccb15d29$var$V = b; null !== $af3a2d87ccb15d29$var$V;)if (b = $af3a2d87ccb15d29$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $af3a2d87ccb15d29$var$V = a;
    else for(; null !== $af3a2d87ccb15d29$var$V;){
        b = $af3a2d87ccb15d29$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $af3a2d87ccb15d29$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(163));
            }
        } catch (F) {
            $af3a2d87ccb15d29$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $af3a2d87ccb15d29$var$V = a;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
    n = $af3a2d87ccb15d29$var$Oj;
    $af3a2d87ccb15d29$var$Oj = !1;
    return n;
}
function $af3a2d87ccb15d29$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $af3a2d87ccb15d29$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $af3a2d87ccb15d29$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $af3a2d87ccb15d29$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $af3a2d87ccb15d29$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $af3a2d87ccb15d29$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$af3a2d87ccb15d29$var$Of], delete b[$af3a2d87ccb15d29$var$Pf], delete b[$af3a2d87ccb15d29$var$of], delete b[$af3a2d87ccb15d29$var$Qf], delete b[$af3a2d87ccb15d29$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $af3a2d87ccb15d29$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $af3a2d87ccb15d29$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $af3a2d87ccb15d29$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $af3a2d87ccb15d29$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $af3a2d87ccb15d29$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling;
}
function $af3a2d87ccb15d29$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling;
}
var $af3a2d87ccb15d29$var$X = null, $af3a2d87ccb15d29$var$Yj = !1;
function $af3a2d87ccb15d29$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$af3a2d87ccb15d29$var$ak(a, b, c), c = c.sibling;
}
function $af3a2d87ccb15d29$var$ak(a, b, c) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount($af3a2d87ccb15d29$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Mj(c, b);
        case 6:
            var d = $af3a2d87ccb15d29$var$X, e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $af3a2d87ccb15d29$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? $af3a2d87ccb15d29$var$Kf(a.parentNode, c) : 1 === a.nodeType && $af3a2d87ccb15d29$var$Kf(a, c), $af3a2d87ccb15d29$var$bd(a)) : $af3a2d87ccb15d29$var$Kf($af3a2d87ccb15d29$var$X, c.stateNode));
            break;
        case 4:
            d = $af3a2d87ccb15d29$var$X;
            e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = c.stateNode.containerInfo;
            $af3a2d87ccb15d29$var$Yj = !0;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$af3a2d87ccb15d29$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $af3a2d87ccb15d29$var$Nj(c, b, g) : 0 !== (f & 4) && $af3a2d87ccb15d29$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 1:
            if (!$af3a2d87ccb15d29$var$U && ($af3a2d87ccb15d29$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $af3a2d87ccb15d29$var$W(c, b, h);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 21:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($af3a2d87ccb15d29$var$U = (d = $af3a2d87ccb15d29$var$U) || null !== c.memoizedState, $af3a2d87ccb15d29$var$Zj(a, b, c), $af3a2d87ccb15d29$var$U = d) : $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        default:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $af3a2d87ccb15d29$var$Lj);
        b.forEach(function(b) {
            var d = $af3a2d87ccb15d29$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $af3a2d87ccb15d29$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $af3a2d87ccb15d29$var$X = h.stateNode;
                        $af3a2d87ccb15d29$var$Yj = !1;
                        break a;
                    case 3:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                    case 4:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $af3a2d87ccb15d29$var$X) throw Error($af3a2d87ccb15d29$var$p(160));
            $af3a2d87ccb15d29$var$ak(f, g, e);
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $af3a2d87ccb15d29$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$af3a2d87ccb15d29$var$ek(b, a), b = b.sibling;
}
function $af3a2d87ccb15d29$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                try {
                    $af3a2d87ccb15d29$var$Qj(3, a, a.return), $af3a2d87ccb15d29$var$Rj(3, a);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
                try {
                    $af3a2d87ccb15d29$var$Qj(5, a, a.return);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            break;
        case 5:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $af3a2d87ccb15d29$var$ob(e, "");
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $af3a2d87ccb15d29$var$ab(e, f);
                    $af3a2d87ccb15d29$var$vb(h, g);
                    var l = $af3a2d87ccb15d29$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $af3a2d87ccb15d29$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $af3a2d87ccb15d29$var$nb(e, q) : "children" === m ? $af3a2d87ccb15d29$var$ob(e, q) : $af3a2d87ccb15d29$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $af3a2d87ccb15d29$var$bb(e, f);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.defaultValue, !0) : $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$af3a2d87ccb15d29$var$Pf] = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($af3a2d87ccb15d29$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $af3a2d87ccb15d29$var$bd(b.containerInfo);
            } catch (t) {
                $af3a2d87ccb15d29$var$W(a, a.return, t);
            }
            break;
        case 4:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            break;
        case 13:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($af3a2d87ccb15d29$var$gk = $af3a2d87ccb15d29$var$B()));
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($af3a2d87ccb15d29$var$U = (l = $af3a2d87ccb15d29$var$U) || m, $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$U = l) : $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($af3a2d87ccb15d29$var$V = a, m = a.child; null !== m;){
                    for(q = $af3a2d87ccb15d29$var$V = m; null !== $af3a2d87ccb15d29$var$V;){
                        r = $af3a2d87ccb15d29$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $af3a2d87ccb15d29$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $af3a2d87ccb15d29$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $af3a2d87ccb15d29$var$V = y) : $af3a2d87ccb15d29$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $af3a2d87ccb15d29$var$rb("display", g));
                            } catch (t) {
                                $af3a2d87ccb15d29$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $af3a2d87ccb15d29$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 21:
            break;
        default:
            $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$fk(a);
    }
}
function $af3a2d87ccb15d29$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($af3a2d87ccb15d29$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($af3a2d87ccb15d29$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($af3a2d87ccb15d29$var$ob(e, ""), d.flags &= -33);
                    var f = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(161));
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $af3a2d87ccb15d29$var$ik(a, b, c) {
    $af3a2d87ccb15d29$var$V = a;
    $af3a2d87ccb15d29$var$jk(a, b, c);
}
function $af3a2d87ccb15d29$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $af3a2d87ccb15d29$var$V;){
        var e = $af3a2d87ccb15d29$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $af3a2d87ccb15d29$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $af3a2d87ccb15d29$var$U;
                h = $af3a2d87ccb15d29$var$Kj;
                var l = $af3a2d87ccb15d29$var$U;
                $af3a2d87ccb15d29$var$Kj = g;
                if (($af3a2d87ccb15d29$var$U = k) && !l) for($af3a2d87ccb15d29$var$V = e; null !== $af3a2d87ccb15d29$var$V;)g = $af3a2d87ccb15d29$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $af3a2d87ccb15d29$var$kk(e) : null !== k ? (k.return = g, $af3a2d87ccb15d29$var$V = k) : $af3a2d87ccb15d29$var$kk(e);
                for(; null !== f;)$af3a2d87ccb15d29$var$V = f, $af3a2d87ccb15d29$var$jk(f, b, c), f = f.sibling;
                $af3a2d87ccb15d29$var$V = e;
                $af3a2d87ccb15d29$var$Kj = h;
                $af3a2d87ccb15d29$var$U = l;
            }
            $af3a2d87ccb15d29$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $af3a2d87ccb15d29$var$V = f) : $af3a2d87ccb15d29$var$lk(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$lk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$af3a2d87ccb15d29$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $af3a2d87ccb15d29$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $af3a2d87ccb15d29$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $af3a2d87ccb15d29$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $af3a2d87ccb15d29$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($af3a2d87ccb15d29$var$p(163));
                }
                $af3a2d87ccb15d29$var$U || b.flags & 512 && $af3a2d87ccb15d29$var$Sj(b);
            } catch (r) {
                $af3a2d87ccb15d29$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$hk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$kk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Rj(4, b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $af3a2d87ccb15d29$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(b, b.return, k);
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $af3a2d87ccb15d29$var$V = h;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
var $af3a2d87ccb15d29$var$mk = Math.ceil, $af3a2d87ccb15d29$var$nk = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$ok = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$pk = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$K = 0, $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Y = null, $af3a2d87ccb15d29$var$Z = 0, $af3a2d87ccb15d29$var$gj = 0, $af3a2d87ccb15d29$var$fj = $af3a2d87ccb15d29$var$Uf(0), $af3a2d87ccb15d29$var$T = 0, $af3a2d87ccb15d29$var$qk = null, $af3a2d87ccb15d29$var$hh = 0, $af3a2d87ccb15d29$var$rk = 0, $af3a2d87ccb15d29$var$sk = 0, $af3a2d87ccb15d29$var$tk = null, $af3a2d87ccb15d29$var$uk = null, $af3a2d87ccb15d29$var$gk = 0, $af3a2d87ccb15d29$var$Hj = Infinity, $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Pi = !1, $af3a2d87ccb15d29$var$Qi = null, $af3a2d87ccb15d29$var$Si = null, $af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = null, $af3a2d87ccb15d29$var$yk = 0, $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, $af3a2d87ccb15d29$var$Bk = -1, $af3a2d87ccb15d29$var$Ck = 0;
function $af3a2d87ccb15d29$var$L() {
    return 0 !== ($af3a2d87ccb15d29$var$K & 6) ? $af3a2d87ccb15d29$var$B() : -1 !== $af3a2d87ccb15d29$var$Bk ? $af3a2d87ccb15d29$var$Bk : $af3a2d87ccb15d29$var$Bk = $af3a2d87ccb15d29$var$B();
}
function $af3a2d87ccb15d29$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2) && 0 !== $af3a2d87ccb15d29$var$Z) return $af3a2d87ccb15d29$var$Z & -$af3a2d87ccb15d29$var$Z;
    if (null !== $af3a2d87ccb15d29$var$Kg.transition) return 0 === $af3a2d87ccb15d29$var$Ck && ($af3a2d87ccb15d29$var$Ck = $af3a2d87ccb15d29$var$yc()), $af3a2d87ccb15d29$var$Ck;
    a = $af3a2d87ccb15d29$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $af3a2d87ccb15d29$var$jd(a.type);
    return a;
}
function $af3a2d87ccb15d29$var$mh(a, b, c, d) {
    if (50 < $af3a2d87ccb15d29$var$zk) throw $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, Error($af3a2d87ccb15d29$var$p(185));
    $af3a2d87ccb15d29$var$Ac(a, c, d);
    if (0 === ($af3a2d87ccb15d29$var$K & 2) || a !== $af3a2d87ccb15d29$var$R) a === $af3a2d87ccb15d29$var$R && (0 === ($af3a2d87ccb15d29$var$K & 2) && ($af3a2d87ccb15d29$var$rk |= c), 4 === $af3a2d87ccb15d29$var$T && $af3a2d87ccb15d29$var$Dk(a, $af3a2d87ccb15d29$var$Z)), $af3a2d87ccb15d29$var$Ek(a, d), 1 === c && 0 === $af3a2d87ccb15d29$var$K && 0 === (b.mode & 1) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
}
function $af3a2d87ccb15d29$var$Ek(a, b) {
    var c = a.callbackNode;
    $af3a2d87ccb15d29$var$wc(a, b);
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) null !== c && $af3a2d87ccb15d29$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $af3a2d87ccb15d29$var$bc(c);
        if (1 === b) 0 === a.tag ? $af3a2d87ccb15d29$var$ig($af3a2d87ccb15d29$var$Fk.bind(null, a)) : $af3a2d87ccb15d29$var$hg($af3a2d87ccb15d29$var$Fk.bind(null, a)), $af3a2d87ccb15d29$var$Jf(function() {
            0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
        }), c = null;
        else {
            switch($af3a2d87ccb15d29$var$Dc(d)){
                case 1:
                    c = $af3a2d87ccb15d29$var$fc;
                    break;
                case 4:
                    c = $af3a2d87ccb15d29$var$gc;
                    break;
                case 16:
                    c = $af3a2d87ccb15d29$var$hc;
                    break;
                case 536870912:
                    c = $af3a2d87ccb15d29$var$jc;
                    break;
                default:
                    c = $af3a2d87ccb15d29$var$hc;
            }
            c = $af3a2d87ccb15d29$var$Gk(c, $af3a2d87ccb15d29$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $af3a2d87ccb15d29$var$Hk(a, b) {
    $af3a2d87ccb15d29$var$Bk = -1;
    $af3a2d87ccb15d29$var$Ck = 0;
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    var c = a.callbackNode;
    if ($af3a2d87ccb15d29$var$Ik() && a.callbackNode !== c) return null;
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $af3a2d87ccb15d29$var$Jk(a, d);
    else {
        b = d;
        var e = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 2;
        var f = $af3a2d87ccb15d29$var$Kk();
        if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$Lk(a, b);
        for(;;)try {
            $af3a2d87ccb15d29$var$Mk();
            break;
        } catch (h) {
            $af3a2d87ccb15d29$var$Nk(a, h);
        }
        $af3a2d87ccb15d29$var$Qg();
        $af3a2d87ccb15d29$var$nk.current = f;
        $af3a2d87ccb15d29$var$K = e;
        null !== $af3a2d87ccb15d29$var$Y ? b = 0 : ($af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0, b = $af3a2d87ccb15d29$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $af3a2d87ccb15d29$var$xc(a), 0 !== e && (d = e, b = $af3a2d87ccb15d29$var$Ok(a, e)));
        if (1 === b) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
        if (6 === b) $af3a2d87ccb15d29$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$af3a2d87ccb15d29$var$Pk(e) && (b = $af3a2d87ccb15d29$var$Jk(a, d), 2 === b && (f = $af3a2d87ccb15d29$var$xc(a), 0 !== f && (d = f, b = $af3a2d87ccb15d29$var$Ok(a, f))), 1 === b)) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($af3a2d87ccb15d29$var$p(345));
                case 2:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 3:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $af3a2d87ccb15d29$var$gk + 500 - $af3a2d87ccb15d29$var$B(), 10 < b)) {
                        if (0 !== $af3a2d87ccb15d29$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $af3a2d87ccb15d29$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), b);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 4:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $af3a2d87ccb15d29$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $af3a2d87ccb15d29$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $af3a2d87ccb15d29$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), d);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 5:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(329));
            }
        }
    }
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return a.callbackNode === c ? $af3a2d87ccb15d29$var$Hk.bind(null, a) : null;
}
function $af3a2d87ccb15d29$var$Ok(a, b) {
    var c = $af3a2d87ccb15d29$var$tk;
    a.current.memoizedState.isDehydrated && ($af3a2d87ccb15d29$var$Lk(a, b).flags |= 256);
    a = $af3a2d87ccb15d29$var$Jk(a, b);
    2 !== a && (b = $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$uk = c, null !== b && $af3a2d87ccb15d29$var$Gj(b));
    return a;
}
function $af3a2d87ccb15d29$var$Gj(a) {
    null === $af3a2d87ccb15d29$var$uk ? $af3a2d87ccb15d29$var$uk = a : $af3a2d87ccb15d29$var$uk.push.apply($af3a2d87ccb15d29$var$uk, a);
}
function $af3a2d87ccb15d29$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$af3a2d87ccb15d29$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Dk(a, b) {
    b &= ~$af3a2d87ccb15d29$var$sk;
    b &= ~$af3a2d87ccb15d29$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $af3a2d87ccb15d29$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $af3a2d87ccb15d29$var$Fk(a) {
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$uc(a, 0);
    if (0 === (b & 1)) return $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), null;
    var c = $af3a2d87ccb15d29$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $af3a2d87ccb15d29$var$xc(a);
        0 !== d && (b = d, c = $af3a2d87ccb15d29$var$Ok(a, d));
    }
    if (1 === c) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, b), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
    if (6 === c) throw Error($af3a2d87ccb15d29$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return null;
}
function $af3a2d87ccb15d29$var$Rk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    try {
        return a(b);
    } finally{
        $af3a2d87ccb15d29$var$K = c, 0 === $af3a2d87ccb15d29$var$K && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
    }
}
function $af3a2d87ccb15d29$var$Sk(a) {
    null !== $af3a2d87ccb15d29$var$xk && 0 === $af3a2d87ccb15d29$var$xk.tag && 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    var c = $af3a2d87ccb15d29$var$pk.transition, d = $af3a2d87ccb15d29$var$C;
    try {
        if ($af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, a) return a();
    } finally{
        $af3a2d87ccb15d29$var$C = d, $af3a2d87ccb15d29$var$pk.transition = c, $af3a2d87ccb15d29$var$K = b, 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
    }
}
function $af3a2d87ccb15d29$var$Ij() {
    $af3a2d87ccb15d29$var$gj = $af3a2d87ccb15d29$var$fj.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$fj);
}
function $af3a2d87ccb15d29$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $af3a2d87ccb15d29$var$Gf(c));
    if (null !== $af3a2d87ccb15d29$var$Y) for(c = $af3a2d87ccb15d29$var$Y.return; null !== c;){
        var d = c;
        $af3a2d87ccb15d29$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $af3a2d87ccb15d29$var$$f();
                break;
            case 3:
                $af3a2d87ccb15d29$var$Jh();
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
                $af3a2d87ccb15d29$var$Oh();
                break;
            case 5:
                $af3a2d87ccb15d29$var$Lh(d);
                break;
            case 4:
                $af3a2d87ccb15d29$var$Jh();
                break;
            case 13:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 19:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 10:
                $af3a2d87ccb15d29$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $af3a2d87ccb15d29$var$Ij();
        }
        c = c.return;
    }
    $af3a2d87ccb15d29$var$R = a;
    $af3a2d87ccb15d29$var$Y = a = $af3a2d87ccb15d29$var$wh(a.current, null);
    $af3a2d87ccb15d29$var$Z = $af3a2d87ccb15d29$var$gj = b;
    $af3a2d87ccb15d29$var$T = 0;
    $af3a2d87ccb15d29$var$qk = null;
    $af3a2d87ccb15d29$var$sk = $af3a2d87ccb15d29$var$rk = $af3a2d87ccb15d29$var$hh = 0;
    $af3a2d87ccb15d29$var$uk = $af3a2d87ccb15d29$var$tk = null;
    if (null !== $af3a2d87ccb15d29$var$Wg) {
        for(b = 0; b < $af3a2d87ccb15d29$var$Wg.length; b++)if (c = $af3a2d87ccb15d29$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $af3a2d87ccb15d29$var$Wg = null;
    }
    return a;
}
function $af3a2d87ccb15d29$var$Nk(a, b) {
    do {
        var c = $af3a2d87ccb15d29$var$Y;
        try {
            $af3a2d87ccb15d29$var$Qg();
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
            if ($af3a2d87ccb15d29$var$Sh) {
                for(var d = $af3a2d87ccb15d29$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $af3a2d87ccb15d29$var$Sh = !1;
            }
            $af3a2d87ccb15d29$var$Rh = 0;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            $af3a2d87ccb15d29$var$ok.current = null;
            if (null === c || null === c.return) {
                $af3a2d87ccb15d29$var$T = 1;
                $af3a2d87ccb15d29$var$qk = b;
                $af3a2d87ccb15d29$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $af3a2d87ccb15d29$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $af3a2d87ccb15d29$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $af3a2d87ccb15d29$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $af3a2d87ccb15d29$var$Ti(f, l, b);
                            $af3a2d87ccb15d29$var$uj();
                            break a;
                        }
                        k = Error($af3a2d87ccb15d29$var$p(426));
                    }
                } else if ($af3a2d87ccb15d29$var$I && h.mode & 1) {
                    var J = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $af3a2d87ccb15d29$var$Wi(J, g, h, f, b);
                        $af3a2d87ccb15d29$var$Jg($af3a2d87ccb15d29$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $af3a2d87ccb15d29$var$Ki(k, h);
                4 !== $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 2);
                null === $af3a2d87ccb15d29$var$tk ? $af3a2d87ccb15d29$var$tk = [
                    f
                ] : $af3a2d87ccb15d29$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $af3a2d87ccb15d29$var$Oi(f, k, b);
                            $af3a2d87ccb15d29$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $af3a2d87ccb15d29$var$Ri(f, h, b);
                                $af3a2d87ccb15d29$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $af3a2d87ccb15d29$var$Tk(c);
        } catch (na) {
            b = na;
            $af3a2d87ccb15d29$var$Y === c && null !== c && ($af3a2d87ccb15d29$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $af3a2d87ccb15d29$var$Kk() {
    var a = $af3a2d87ccb15d29$var$nk.current;
    $af3a2d87ccb15d29$var$nk.current = $af3a2d87ccb15d29$var$ai;
    return null === a ? $af3a2d87ccb15d29$var$ai : a;
}
function $af3a2d87ccb15d29$var$uj() {
    if (0 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T || 2 === $af3a2d87ccb15d29$var$T) $af3a2d87ccb15d29$var$T = 4;
    null === $af3a2d87ccb15d29$var$R || 0 === ($af3a2d87ccb15d29$var$hh & 268435455) && 0 === ($af3a2d87ccb15d29$var$rk & 268435455) || $af3a2d87ccb15d29$var$Dk($af3a2d87ccb15d29$var$R, $af3a2d87ccb15d29$var$Z);
}
function $af3a2d87ccb15d29$var$Jk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 2;
    var d = $af3a2d87ccb15d29$var$Kk();
    if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Lk(a, b);
    for(;;)try {
        $af3a2d87ccb15d29$var$Uk();
        break;
    } catch (e) {
        $af3a2d87ccb15d29$var$Nk(a, e);
    }
    $af3a2d87ccb15d29$var$Qg();
    $af3a2d87ccb15d29$var$K = c;
    $af3a2d87ccb15d29$var$nk.current = d;
    if (null !== $af3a2d87ccb15d29$var$Y) throw Error($af3a2d87ccb15d29$var$p(261));
    $af3a2d87ccb15d29$var$R = null;
    $af3a2d87ccb15d29$var$Z = 0;
    return $af3a2d87ccb15d29$var$T;
}
function $af3a2d87ccb15d29$var$Uk() {
    for(; null !== $af3a2d87ccb15d29$var$Y;)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Mk() {
    for(; null !== $af3a2d87ccb15d29$var$Y && !$af3a2d87ccb15d29$var$cc();)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Vk(a) {
    var b = $af3a2d87ccb15d29$var$Wk(a.alternate, a, $af3a2d87ccb15d29$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $af3a2d87ccb15d29$var$Tk(a) : $af3a2d87ccb15d29$var$Y = b;
    $af3a2d87ccb15d29$var$ok.current = null;
}
function $af3a2d87ccb15d29$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $af3a2d87ccb15d29$var$Fj(c, b, $af3a2d87ccb15d29$var$gj), null !== c) {
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
        } else {
            c = $af3a2d87ccb15d29$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $af3a2d87ccb15d29$var$T = 6;
                $af3a2d87ccb15d29$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $af3a2d87ccb15d29$var$Y = b;
            return;
        }
        $af3a2d87ccb15d29$var$Y = b = a;
    }while (null !== b);
    0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 5);
}
function $af3a2d87ccb15d29$var$Qk(a, b, c) {
    var d = $af3a2d87ccb15d29$var$C, e = $af3a2d87ccb15d29$var$pk.transition;
    try {
        $af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$Xk(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$pk.transition = e, $af3a2d87ccb15d29$var$C = d;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xk(a, b, c, d) {
    do $af3a2d87ccb15d29$var$Ik();
    while (null !== $af3a2d87ccb15d29$var$xk);
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($af3a2d87ccb15d29$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $af3a2d87ccb15d29$var$Bc(a, f);
    a === $af3a2d87ccb15d29$var$R && ($af3a2d87ccb15d29$var$Y = $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $af3a2d87ccb15d29$var$wk || ($af3a2d87ccb15d29$var$wk = !0, $af3a2d87ccb15d29$var$Gk($af3a2d87ccb15d29$var$hc, function() {
        $af3a2d87ccb15d29$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $af3a2d87ccb15d29$var$pk.transition;
        $af3a2d87ccb15d29$var$pk.transition = null;
        var g = $af3a2d87ccb15d29$var$C;
        $af3a2d87ccb15d29$var$C = 1;
        var h = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 4;
        $af3a2d87ccb15d29$var$ok.current = null;
        $af3a2d87ccb15d29$var$Pj(a, c);
        $af3a2d87ccb15d29$var$ek(c, a);
        $af3a2d87ccb15d29$var$Oe($af3a2d87ccb15d29$var$Df);
        $af3a2d87ccb15d29$var$dd = !!$af3a2d87ccb15d29$var$Cf;
        $af3a2d87ccb15d29$var$Df = $af3a2d87ccb15d29$var$Cf = null;
        a.current = c;
        $af3a2d87ccb15d29$var$ik(c, a, e);
        $af3a2d87ccb15d29$var$dc();
        $af3a2d87ccb15d29$var$K = h;
        $af3a2d87ccb15d29$var$C = g;
        $af3a2d87ccb15d29$var$pk.transition = f;
    } else a.current = c;
    $af3a2d87ccb15d29$var$wk && ($af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = a, $af3a2d87ccb15d29$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($af3a2d87ccb15d29$var$Si = null);
    $af3a2d87ccb15d29$var$mc(c.stateNode, d);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($af3a2d87ccb15d29$var$Pi) throw $af3a2d87ccb15d29$var$Pi = !1, a = $af3a2d87ccb15d29$var$Qi, $af3a2d87ccb15d29$var$Qi = null, a;
    0 !== ($af3a2d87ccb15d29$var$yk & 1) && 0 !== a.tag && $af3a2d87ccb15d29$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $af3a2d87ccb15d29$var$Ak ? $af3a2d87ccb15d29$var$zk++ : ($af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = a) : $af3a2d87ccb15d29$var$zk = 0;
    $af3a2d87ccb15d29$var$jg();
    return null;
}
function $af3a2d87ccb15d29$var$Ik() {
    if (null !== $af3a2d87ccb15d29$var$xk) {
        var a = $af3a2d87ccb15d29$var$Dc($af3a2d87ccb15d29$var$yk), b = $af3a2d87ccb15d29$var$pk.transition, c = $af3a2d87ccb15d29$var$C;
        try {
            $af3a2d87ccb15d29$var$pk.transition = null;
            $af3a2d87ccb15d29$var$C = 16 > a ? 16 : a;
            if (null === $af3a2d87ccb15d29$var$xk) var d = !1;
            else {
                a = $af3a2d87ccb15d29$var$xk;
                $af3a2d87ccb15d29$var$xk = null;
                $af3a2d87ccb15d29$var$yk = 0;
                if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(331));
                var e = $af3a2d87ccb15d29$var$K;
                $af3a2d87ccb15d29$var$K |= 4;
                for($af3a2d87ccb15d29$var$V = a.current; null !== $af3a2d87ccb15d29$var$V;){
                    var f = $af3a2d87ccb15d29$var$V, g = f.child;
                    if (0 !== ($af3a2d87ccb15d29$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($af3a2d87ccb15d29$var$V = l; null !== $af3a2d87ccb15d29$var$V;){
                                    var m = $af3a2d87ccb15d29$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $af3a2d87ccb15d29$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $af3a2d87ccb15d29$var$V = q;
                                    else for(; null !== $af3a2d87ccb15d29$var$V;){
                                        m = $af3a2d87ccb15d29$var$V;
                                        var r = m.sibling, y = m.return;
                                        $af3a2d87ccb15d29$var$Tj(m);
                                        if (m === l) {
                                            $af3a2d87ccb15d29$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $af3a2d87ccb15d29$var$V = r;
                                            break;
                                        }
                                        $af3a2d87ccb15d29$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $af3a2d87ccb15d29$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $af3a2d87ccb15d29$var$V = g;
                    else b: for(; null !== $af3a2d87ccb15d29$var$V;){
                        f = $af3a2d87ccb15d29$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $af3a2d87ccb15d29$var$V = x;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = f.return;
                    }
                }
                var w = a.current;
                for($af3a2d87ccb15d29$var$V = w; null !== $af3a2d87ccb15d29$var$V;){
                    g = $af3a2d87ccb15d29$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $af3a2d87ccb15d29$var$V = u;
                    else b: for(g = w; null !== $af3a2d87ccb15d29$var$V;){
                        h = $af3a2d87ccb15d29$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $af3a2d87ccb15d29$var$Rj(9, h);
                            }
                        } catch (na) {
                            $af3a2d87ccb15d29$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $af3a2d87ccb15d29$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $af3a2d87ccb15d29$var$V = F;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = h.return;
                    }
                }
                $af3a2d87ccb15d29$var$K = e;
                $af3a2d87ccb15d29$var$jg();
                if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot) try {
                    $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot($af3a2d87ccb15d29$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$pk.transition = b;
        }
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Yk(a, b, c) {
    b = $af3a2d87ccb15d29$var$Ki(c, b);
    b = $af3a2d87ccb15d29$var$Oi(a, b, 1);
    a = $af3a2d87ccb15d29$var$dh(a, b, 1);
    b = $af3a2d87ccb15d29$var$L();
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, 1, b), $af3a2d87ccb15d29$var$Ek(a, b));
}
function $af3a2d87ccb15d29$var$W(a, b, c) {
    if (3 === a.tag) $af3a2d87ccb15d29$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $af3a2d87ccb15d29$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(d))) {
                a = $af3a2d87ccb15d29$var$Ki(c, a);
                a = $af3a2d87ccb15d29$var$Ri(b, a, 1);
                b = $af3a2d87ccb15d29$var$dh(b, a, 1);
                a = $af3a2d87ccb15d29$var$L();
                null !== b && ($af3a2d87ccb15d29$var$Ac(b, 1, a), $af3a2d87ccb15d29$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $af3a2d87ccb15d29$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $af3a2d87ccb15d29$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $af3a2d87ccb15d29$var$R === a && ($af3a2d87ccb15d29$var$Z & c) === c && (4 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$Z & 130023424) === $af3a2d87ccb15d29$var$Z && 500 > $af3a2d87ccb15d29$var$B() - $af3a2d87ccb15d29$var$gk ? $af3a2d87ccb15d29$var$Lk(a, 0) : $af3a2d87ccb15d29$var$sk |= c);
    $af3a2d87ccb15d29$var$Ek(a, b);
}
function $af3a2d87ccb15d29$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $af3a2d87ccb15d29$var$sc, $af3a2d87ccb15d29$var$sc <<= 1, 0 === ($af3a2d87ccb15d29$var$sc & 130023424) && ($af3a2d87ccb15d29$var$sc = 4194304)));
    var c = $af3a2d87ccb15d29$var$L();
    a = $af3a2d87ccb15d29$var$Zg(a, b);
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, b, c), $af3a2d87ccb15d29$var$Ek(a, c));
}
function $af3a2d87ccb15d29$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
function $af3a2d87ccb15d29$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($af3a2d87ccb15d29$var$p(314));
    }
    null !== d && d.delete(b);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
var $af3a2d87ccb15d29$var$Wk;
$af3a2d87ccb15d29$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $af3a2d87ccb15d29$var$Wf.current) $af3a2d87ccb15d29$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$zj(a, b, c);
            $af3a2d87ccb15d29$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$I && 0 !== (b.flags & 1048576) && $af3a2d87ccb15d29$var$ug(b, $af3a2d87ccb15d29$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $af3a2d87ccb15d29$var$jj(a, b);
            a = b.pendingProps;
            var e = $af3a2d87ccb15d29$var$Yf(b, $af3a2d87ccb15d29$var$H.current);
            $af3a2d87ccb15d29$var$Tg(b, c);
            e = $af3a2d87ccb15d29$var$Xh(null, b, d, a, e, c);
            var f = $af3a2d87ccb15d29$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $af3a2d87ccb15d29$var$Zf(d) ? (f = !0, $af3a2d87ccb15d29$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $af3a2d87ccb15d29$var$ah(b), e.updater = $af3a2d87ccb15d29$var$nh, b.stateNode = e, e._reactInternals = b, $af3a2d87ccb15d29$var$rh(b, d, a, c), b = $af3a2d87ccb15d29$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $af3a2d87ccb15d29$var$I && f && $af3a2d87ccb15d29$var$vg(b), $af3a2d87ccb15d29$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $af3a2d87ccb15d29$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $af3a2d87ccb15d29$var$$k(d);
                a = $af3a2d87ccb15d29$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $af3a2d87ccb15d29$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $af3a2d87ccb15d29$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $af3a2d87ccb15d29$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $af3a2d87ccb15d29$var$aj(null, b, d, $af3a2d87ccb15d29$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($af3a2d87ccb15d29$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $af3a2d87ccb15d29$var$lj(b);
                if (null === a) throw Error($af3a2d87ccb15d29$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $af3a2d87ccb15d29$var$bh(a, b);
                $af3a2d87ccb15d29$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(423)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(424)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else for($af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.stateNode.containerInfo.firstChild), $af3a2d87ccb15d29$var$xg = b, $af3a2d87ccb15d29$var$I = !0, $af3a2d87ccb15d29$var$zg = null, c = $af3a2d87ccb15d29$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $af3a2d87ccb15d29$var$Ig();
                    if (d === e) {
                        b = $af3a2d87ccb15d29$var$$i(a, b, c);
                        break a;
                    }
                    $af3a2d87ccb15d29$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $af3a2d87ccb15d29$var$Kh(b), null === a && $af3a2d87ccb15d29$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $af3a2d87ccb15d29$var$Ef(d, e) ? g = null : null !== f && $af3a2d87ccb15d29$var$Ef(d, f) && (b.flags |= 32), $af3a2d87ccb15d29$var$hj(a, b), $af3a2d87ccb15d29$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $af3a2d87ccb15d29$var$Eg(b), null;
        case 13:
            return $af3a2d87ccb15d29$var$pj(a, b, c);
        case 4:
            return $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $af3a2d87ccb15d29$var$Bh(b, null, d, c) : $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$Zi(a, b, d, e, c);
        case 7:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($af3a2d87ccb15d29$var$He(f.value, g)) {
                        if (f.children === e.children && !$af3a2d87ccb15d29$var$Wf.current) {
                            b = $af3a2d87ccb15d29$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $af3a2d87ccb15d29$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $af3a2d87ccb15d29$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($af3a2d87ccb15d29$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $af3a2d87ccb15d29$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $af3a2d87ccb15d29$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $af3a2d87ccb15d29$var$Tg(b, c), e = $af3a2d87ccb15d29$var$Vg(e), d = d(e), b.flags |= 1, $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $af3a2d87ccb15d29$var$Lg(d, b.pendingProps), e = $af3a2d87ccb15d29$var$Lg(d.type, e), $af3a2d87ccb15d29$var$aj(a, b, d, e, c);
        case 15:
            return $af3a2d87ccb15d29$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$jj(a, b), b.tag = 1, $af3a2d87ccb15d29$var$Zf(d) ? (a = !0, $af3a2d87ccb15d29$var$cg(b)) : a = !1, $af3a2d87ccb15d29$var$Tg(b, c), $af3a2d87ccb15d29$var$ph(b, d, e), $af3a2d87ccb15d29$var$rh(b, d, e, c), $af3a2d87ccb15d29$var$kj(null, b, d, !0, a, c);
        case 19:
            return $af3a2d87ccb15d29$var$yj(a, b, c);
        case 22:
            return $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
};
function $af3a2d87ccb15d29$var$Gk(a, b) {
    return $af3a2d87ccb15d29$var$ac(a, b);
}
function $af3a2d87ccb15d29$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $af3a2d87ccb15d29$var$Bg(a, b, c, d) {
    return new $af3a2d87ccb15d29$var$al(a, b, c, d);
}
function $af3a2d87ccb15d29$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $af3a2d87ccb15d29$var$$k(a) {
    if ("function" === typeof a) return $af3a2d87ccb15d29$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $af3a2d87ccb15d29$var$Da) return 11;
        if (a === $af3a2d87ccb15d29$var$Ga) return 14;
    }
    return 2;
}
function $af3a2d87ccb15d29$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $af3a2d87ccb15d29$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $af3a2d87ccb15d29$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $af3a2d87ccb15d29$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return $af3a2d87ccb15d29$var$Ah(c.children, e, f, b);
        case $af3a2d87ccb15d29$var$za:
            g = 8;
            e |= 8;
            break;
        case $af3a2d87ccb15d29$var$Aa:
            return a = $af3a2d87ccb15d29$var$Bg(12, c, b, e | 2), a.elementType = $af3a2d87ccb15d29$var$Aa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ea:
            return a = $af3a2d87ccb15d29$var$Bg(13, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Ea, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Fa:
            return a = $af3a2d87ccb15d29$var$Bg(19, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Fa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ia:
            return $af3a2d87ccb15d29$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $af3a2d87ccb15d29$var$Ba:
                    g = 10;
                    break a;
                case $af3a2d87ccb15d29$var$Ca:
                    g = 9;
                    break a;
                case $af3a2d87ccb15d29$var$Da:
                    g = 11;
                    break a;
                case $af3a2d87ccb15d29$var$Ga:
                    g = 14;
                    break a;
                case $af3a2d87ccb15d29$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($af3a2d87ccb15d29$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $af3a2d87ccb15d29$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $af3a2d87ccb15d29$var$Ah(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$qj(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(22, a, d, b);
    a.elementType = $af3a2d87ccb15d29$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $af3a2d87ccb15d29$var$xh(a, b, c) {
    a = $af3a2d87ccb15d29$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$zh(a, b, c) {
    b = $af3a2d87ccb15d29$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $af3a2d87ccb15d29$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $af3a2d87ccb15d29$var$zc(0);
    this.expirationTimes = $af3a2d87ccb15d29$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $af3a2d87ccb15d29$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $af3a2d87ccb15d29$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $af3a2d87ccb15d29$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $af3a2d87ccb15d29$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $af3a2d87ccb15d29$var$ah(f);
    return a;
}
function $af3a2d87ccb15d29$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $af3a2d87ccb15d29$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $af3a2d87ccb15d29$var$el(a) {
    if (!a) return $af3a2d87ccb15d29$var$Vf;
    a = a._reactInternals;
    a: {
        if ($af3a2d87ccb15d29$var$Vb(a) !== a || 1 !== a.tag) throw Error($af3a2d87ccb15d29$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($af3a2d87ccb15d29$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($af3a2d87ccb15d29$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($af3a2d87ccb15d29$var$Zf(c)) return $af3a2d87ccb15d29$var$bg(a, c, b);
    }
    return b;
}
function $af3a2d87ccb15d29$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $af3a2d87ccb15d29$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $af3a2d87ccb15d29$var$el(null);
    c = a.current;
    d = $af3a2d87ccb15d29$var$L();
    e = $af3a2d87ccb15d29$var$lh(c);
    f = $af3a2d87ccb15d29$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $af3a2d87ccb15d29$var$dh(c, f, e);
    a.current.lanes = e;
    $af3a2d87ccb15d29$var$Ac(a, e, d);
    $af3a2d87ccb15d29$var$Ek(a, d);
    return a;
}
function $af3a2d87ccb15d29$var$gl(a, b, c, d) {
    var e = b.current, f = $af3a2d87ccb15d29$var$L(), g = $af3a2d87ccb15d29$var$lh(e);
    c = $af3a2d87ccb15d29$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $af3a2d87ccb15d29$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $af3a2d87ccb15d29$var$dh(e, b, g);
    null !== a && ($af3a2d87ccb15d29$var$mh(a, e, g, f), $af3a2d87ccb15d29$var$eh(a, e, g));
    return g;
}
function $af3a2d87ccb15d29$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $af3a2d87ccb15d29$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $af3a2d87ccb15d29$var$jl(a, b) {
    $af3a2d87ccb15d29$var$il(a, b);
    (a = a.alternate) && $af3a2d87ccb15d29$var$il(a, b);
}
function $af3a2d87ccb15d29$var$kl() {
    return null;
}
var $af3a2d87ccb15d29$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $af3a2d87ccb15d29$var$ml(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.render = $af3a2d87ccb15d29$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($af3a2d87ccb15d29$var$p(409));
    $af3a2d87ccb15d29$var$gl(a, b, null, null);
};
$af3a2d87ccb15d29$var$nl.prototype.unmount = $af3a2d87ccb15d29$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $af3a2d87ccb15d29$var$Sk(function() {
            $af3a2d87ccb15d29$var$gl(null, a, null, null);
        });
        b[$af3a2d87ccb15d29$var$uf] = null;
    }
};
function $af3a2d87ccb15d29$var$nl(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $af3a2d87ccb15d29$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $af3a2d87ccb15d29$var$Qc.length && 0 !== b && b < $af3a2d87ccb15d29$var$Qc[c].priority; c++);
        $af3a2d87ccb15d29$var$Qc.splice(c, 0, a);
        0 === c && $af3a2d87ccb15d29$var$Vc(a);
    }
};
function $af3a2d87ccb15d29$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $af3a2d87ccb15d29$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $af3a2d87ccb15d29$var$ql() {}
function $af3a2d87ccb15d29$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                f.call(a);
            };
        }
        var g = $af3a2d87ccb15d29$var$fl(b, d, a, 0, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
        a._reactRootContainer = g;
        a[$af3a2d87ccb15d29$var$uf] = g.current;
        $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
        $af3a2d87ccb15d29$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $af3a2d87ccb15d29$var$hl(k);
            h.call(a);
        };
    }
    var k = $af3a2d87ccb15d29$var$cl(a, 0, !1, null, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
    a._reactRootContainer = k;
    a[$af3a2d87ccb15d29$var$uf] = k.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    $af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$gl(b, k, c, d);
    });
    return k;
}
function $af3a2d87ccb15d29$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                h.call(a);
            };
        }
        $af3a2d87ccb15d29$var$gl(b, g, a, e);
    } else g = $af3a2d87ccb15d29$var$rl(c, b, a, e, d);
    return $af3a2d87ccb15d29$var$hl(g);
}
$af3a2d87ccb15d29$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $af3a2d87ccb15d29$var$tc(b.pendingLanes);
                0 !== c && ($af3a2d87ccb15d29$var$Cc(b, c | 1), $af3a2d87ccb15d29$var$Ek(b, $af3a2d87ccb15d29$var$B()), 0 === ($af3a2d87ccb15d29$var$K & 6) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$jg()));
            }
            break;
        case 13:
            $af3a2d87ccb15d29$var$Sk(function() {
                var b = $af3a2d87ccb15d29$var$Zg(a, 1);
                if (null !== b) {
                    var c = $af3a2d87ccb15d29$var$L();
                    $af3a2d87ccb15d29$var$mh(b, a, 1, c);
                }
            }), $af3a2d87ccb15d29$var$jl(a, 1);
    }
};
$af3a2d87ccb15d29$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(b, a, 134217728, c);
        }
        $af3a2d87ccb15d29$var$jl(a, 134217728);
    }
};
$af3a2d87ccb15d29$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$lh(a), c = $af3a2d87ccb15d29$var$Zg(a, b);
        if (null !== c) {
            var d = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(c, a, b, d);
        }
        $af3a2d87ccb15d29$var$jl(a, b);
    }
};
$af3a2d87ccb15d29$var$Hc = function() {
    return $af3a2d87ccb15d29$var$C;
};
$af3a2d87ccb15d29$var$Ic = function(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    try {
        return $af3a2d87ccb15d29$var$C = a, b();
    } finally{
        $af3a2d87ccb15d29$var$C = c;
    }
};
$af3a2d87ccb15d29$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $af3a2d87ccb15d29$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $af3a2d87ccb15d29$var$Db(d);
                        if (!e) throw Error($af3a2d87ccb15d29$var$p(90));
                        $af3a2d87ccb15d29$var$Wa(d);
                        $af3a2d87ccb15d29$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $af3a2d87ccb15d29$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $af3a2d87ccb15d29$var$fb(a, !!c.multiple, b, !1);
    }
};
$af3a2d87ccb15d29$var$Gb = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$var$Hb = $af3a2d87ccb15d29$var$Sk;
var $af3a2d87ccb15d29$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $af3a2d87ccb15d29$var$Cb,
        $af3a2d87ccb15d29$var$ue,
        $af3a2d87ccb15d29$var$Db,
        $af3a2d87ccb15d29$var$Eb,
        $af3a2d87ccb15d29$var$Fb,
        $af3a2d87ccb15d29$var$Rk
    ]
}, $af3a2d87ccb15d29$var$ul = {
    findFiberByHostInstance: $af3a2d87ccb15d29$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $af3a2d87ccb15d29$var$vl = {
    bundleType: $af3a2d87ccb15d29$var$ul.bundleType,
    version: $af3a2d87ccb15d29$var$ul.version,
    rendererPackageName: $af3a2d87ccb15d29$var$ul.rendererPackageName,
    rendererConfig: $af3a2d87ccb15d29$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $af3a2d87ccb15d29$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $af3a2d87ccb15d29$var$ul.findFiberByHostInstance || $af3a2d87ccb15d29$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $af3a2d87ccb15d29$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$af3a2d87ccb15d29$var$wl.isDisabled && $af3a2d87ccb15d29$var$wl.supportsFiber) try {
        $af3a2d87ccb15d29$var$kc = $af3a2d87ccb15d29$var$wl.inject($af3a2d87ccb15d29$var$vl), $af3a2d87ccb15d29$var$lc = $af3a2d87ccb15d29$var$wl;
    } catch (a) {}
}
$af3a2d87ccb15d29$export$ae55be85d98224ed = $af3a2d87ccb15d29$var$tl;
$af3a2d87ccb15d29$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$af3a2d87ccb15d29$var$ol(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$dl(a, b, null, c);
};
$af3a2d87ccb15d29$export$882461b6382ed46c = function(a, b) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(299));
    var c = !1, d = "", e = $af3a2d87ccb15d29$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $af3a2d87ccb15d29$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $af3a2d87ccb15d29$var$ml(b);
};
$af3a2d87ccb15d29$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($af3a2d87ccb15d29$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($af3a2d87ccb15d29$var$p(268, a));
    }
    a = $af3a2d87ccb15d29$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = function(a) {
    return $af3a2d87ccb15d29$var$Sk(a);
};
$af3a2d87ccb15d29$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !0, c);
};
$af3a2d87ccb15d29$export$757ceba2d55c277e = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $af3a2d87ccb15d29$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $af3a2d87ccb15d29$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $af3a2d87ccb15d29$var$nl(b);
};
$af3a2d87ccb15d29$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !1, c);
};
$af3a2d87ccb15d29$export$502457920280e6be = function(a) {
    if (!$af3a2d87ccb15d29$var$pl(a)) throw Error($af3a2d87ccb15d29$var$p(40));
    return a._reactRootContainer ? ($af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$af3a2d87ccb15d29$var$uf] = null;
        });
    }), !0) : !1;
};
$af3a2d87ccb15d29$export$c78a37762a8d58e1 = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$af3a2d87ccb15d29$var$pl(c)) throw Error($af3a2d87ccb15d29$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($af3a2d87ccb15d29$var$p(38));
    return $af3a2d87ccb15d29$var$sl(a, b, c, !1, d);
};
$af3a2d87ccb15d29$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("7DCHO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("59RiQ"));

});
parcelRegister("59RiQ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3c1723e4455f0262$export$c4744153514ff05d, (v) => $3c1723e4455f0262$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3c1723e4455f0262$export$3e506c1ccc9cc1a7, (v) => $3c1723e4455f0262$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3c1723e4455f0262$export$e26fe2ed2fa76875, (v) => $3c1723e4455f0262$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3c1723e4455f0262$export$502329bbf4b505b1, (v) => $3c1723e4455f0262$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3c1723e4455f0262$export$6e3807111c4874c4, (v) => $3c1723e4455f0262$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3c1723e4455f0262$export$c27134553091fb3a, (v) => $3c1723e4455f0262$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3c1723e4455f0262$export$33ee1acdc04fd2a2, (v) => $3c1723e4455f0262$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3c1723e4455f0262$export$b00a404bbd5edef2, (v) => $3c1723e4455f0262$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3c1723e4455f0262$export$8352ce38b91d0c62, (v) => $3c1723e4455f0262$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3c1723e4455f0262$export$d66a1c1c77bd778b, (v) => $3c1723e4455f0262$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3c1723e4455f0262$export$d3dfb8e4810cb555, (v) => $3c1723e4455f0262$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3c1723e4455f0262$export$839f9183b0465a69, (v) => $3c1723e4455f0262$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3c1723e4455f0262$export$72fdf0e06517287b, (v) => $3c1723e4455f0262$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3c1723e4455f0262$export$4b844e58a3e414b4, (v) => $3c1723e4455f0262$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3c1723e4455f0262$export$816d2913ae6b83b1, (v) => $3c1723e4455f0262$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3c1723e4455f0262$export$61bcfe829111a1d0, (v) => $3c1723e4455f0262$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3c1723e4455f0262$export$7ee8c9beb337bc3f, (v) => $3c1723e4455f0262$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3c1723e4455f0262$export$b5836b71941fa3ed, (v) => $3c1723e4455f0262$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3c1723e4455f0262$export$cf845f2c119da08a, (v) => $3c1723e4455f0262$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c1723e4455f0262$export$c4744153514ff05d;
var $3c1723e4455f0262$export$3e506c1ccc9cc1a7;
var $3c1723e4455f0262$export$e26fe2ed2fa76875;
var $3c1723e4455f0262$export$502329bbf4b505b1;
var $3c1723e4455f0262$export$6e3807111c4874c4;
var $3c1723e4455f0262$export$c27134553091fb3a;
var $3c1723e4455f0262$export$33ee1acdc04fd2a2;
var $3c1723e4455f0262$export$b00a404bbd5edef2;
var $3c1723e4455f0262$export$8352ce38b91d0c62;
var $3c1723e4455f0262$export$d66a1c1c77bd778b;
var $3c1723e4455f0262$export$d3dfb8e4810cb555;
var $3c1723e4455f0262$export$839f9183b0465a69;
var $3c1723e4455f0262$export$72fdf0e06517287b;
var $3c1723e4455f0262$export$4b844e58a3e414b4;
var $3c1723e4455f0262$export$816d2913ae6b83b1;
var $3c1723e4455f0262$export$61bcfe829111a1d0;
var $3c1723e4455f0262$export$7ee8c9beb337bc3f;
var $3c1723e4455f0262$export$b5836b71941fa3ed;
var $3c1723e4455f0262$export$cf845f2c119da08a;
"use strict";
function $3c1723e4455f0262$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3c1723e4455f0262$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3c1723e4455f0262$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3c1723e4455f0262$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3c1723e4455f0262$var$g(C, c)) n < e && 0 > $3c1723e4455f0262$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3c1723e4455f0262$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3c1723e4455f0262$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3c1723e4455f0262$var$l = performance;
    $3c1723e4455f0262$export$c4744153514ff05d = function() {
        return $3c1723e4455f0262$var$l.now();
    };
} else {
    var $3c1723e4455f0262$var$p = Date, $3c1723e4455f0262$var$q = $3c1723e4455f0262$var$p.now();
    $3c1723e4455f0262$export$c4744153514ff05d = function() {
        return $3c1723e4455f0262$var$p.now() - $3c1723e4455f0262$var$q;
    };
}
var $3c1723e4455f0262$var$r = [], $3c1723e4455f0262$var$t = [], $3c1723e4455f0262$var$u = 1, $3c1723e4455f0262$var$v = null, $3c1723e4455f0262$var$y = 3, $3c1723e4455f0262$var$z = !1, $3c1723e4455f0262$var$A = !1, $3c1723e4455f0262$var$B = !1, $3c1723e4455f0262$var$D = "function" === typeof setTimeout ? setTimeout : null, $3c1723e4455f0262$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3c1723e4455f0262$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3c1723e4455f0262$var$G(a) {
    for(var b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t); null !== b;){
        if (null === b.callback) $3c1723e4455f0262$var$k($3c1723e4455f0262$var$t);
        else if (b.startTime <= a) $3c1723e4455f0262$var$k($3c1723e4455f0262$var$t), b.sortIndex = b.expirationTime, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$r, b);
        else break;
        b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
    }
}
function $3c1723e4455f0262$var$H(a) {
    $3c1723e4455f0262$var$B = !1;
    $3c1723e4455f0262$var$G(a);
    if (!$3c1723e4455f0262$var$A) {
        if (null !== $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r)) $3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J);
        else {
            var b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
            null !== b && $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, b.startTime - a);
        }
    }
}
function $3c1723e4455f0262$var$J(a, b) {
    $3c1723e4455f0262$var$A = !1;
    $3c1723e4455f0262$var$B && ($3c1723e4455f0262$var$B = !1, $3c1723e4455f0262$var$E($3c1723e4455f0262$var$L), $3c1723e4455f0262$var$L = -1);
    $3c1723e4455f0262$var$z = !0;
    var c = $3c1723e4455f0262$var$y;
    try {
        $3c1723e4455f0262$var$G(b);
        for($3c1723e4455f0262$var$v = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r); null !== $3c1723e4455f0262$var$v && (!($3c1723e4455f0262$var$v.expirationTime > b) || a && !$3c1723e4455f0262$var$M());){
            var d = $3c1723e4455f0262$var$v.callback;
            if ("function" === typeof d) {
                $3c1723e4455f0262$var$v.callback = null;
                $3c1723e4455f0262$var$y = $3c1723e4455f0262$var$v.priorityLevel;
                var e = d($3c1723e4455f0262$var$v.expirationTime <= b);
                b = $3c1723e4455f0262$export$c4744153514ff05d();
                "function" === typeof e ? $3c1723e4455f0262$var$v.callback = e : $3c1723e4455f0262$var$v === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r) && $3c1723e4455f0262$var$k($3c1723e4455f0262$var$r);
                $3c1723e4455f0262$var$G(b);
            } else $3c1723e4455f0262$var$k($3c1723e4455f0262$var$r);
            $3c1723e4455f0262$var$v = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r);
        }
        if (null !== $3c1723e4455f0262$var$v) var w = !0;
        else {
            var m = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
            null !== m && $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3c1723e4455f0262$var$v = null, $3c1723e4455f0262$var$y = c, $3c1723e4455f0262$var$z = !1;
    }
}
var $3c1723e4455f0262$var$N = !1, $3c1723e4455f0262$var$O = null, $3c1723e4455f0262$var$L = -1, $3c1723e4455f0262$var$P = 5, $3c1723e4455f0262$var$Q = -1;
function $3c1723e4455f0262$var$M() {
    return $3c1723e4455f0262$export$c4744153514ff05d() - $3c1723e4455f0262$var$Q < $3c1723e4455f0262$var$P ? !1 : !0;
}
function $3c1723e4455f0262$var$R() {
    if (null !== $3c1723e4455f0262$var$O) {
        var a = $3c1723e4455f0262$export$c4744153514ff05d();
        $3c1723e4455f0262$var$Q = a;
        var b = !0;
        try {
            b = $3c1723e4455f0262$var$O(!0, a);
        } finally{
            b ? $3c1723e4455f0262$var$S() : ($3c1723e4455f0262$var$N = !1, $3c1723e4455f0262$var$O = null);
        }
    } else $3c1723e4455f0262$var$N = !1;
}
var $3c1723e4455f0262$var$S;
if ("function" === typeof $3c1723e4455f0262$var$F) $3c1723e4455f0262$var$S = function() {
    $3c1723e4455f0262$var$F($3c1723e4455f0262$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3c1723e4455f0262$var$T = new MessageChannel, $3c1723e4455f0262$var$U = $3c1723e4455f0262$var$T.port2;
    $3c1723e4455f0262$var$T.port1.onmessage = $3c1723e4455f0262$var$R;
    $3c1723e4455f0262$var$S = function() {
        $3c1723e4455f0262$var$U.postMessage(null);
    };
} else $3c1723e4455f0262$var$S = function() {
    $3c1723e4455f0262$var$D($3c1723e4455f0262$var$R, 0);
};
function $3c1723e4455f0262$var$I(a) {
    $3c1723e4455f0262$var$O = a;
    $3c1723e4455f0262$var$N || ($3c1723e4455f0262$var$N = !0, $3c1723e4455f0262$var$S());
}
function $3c1723e4455f0262$var$K(a, b) {
    $3c1723e4455f0262$var$L = $3c1723e4455f0262$var$D(function() {
        a($3c1723e4455f0262$export$c4744153514ff05d());
    }, b);
}
$3c1723e4455f0262$export$3e506c1ccc9cc1a7 = 5;
$3c1723e4455f0262$export$e26fe2ed2fa76875 = 1;
$3c1723e4455f0262$export$502329bbf4b505b1 = 4;
$3c1723e4455f0262$export$6e3807111c4874c4 = 3;
$3c1723e4455f0262$export$c27134553091fb3a = null;
$3c1723e4455f0262$export$33ee1acdc04fd2a2 = 2;
$3c1723e4455f0262$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3c1723e4455f0262$export$8352ce38b91d0c62 = function() {
    $3c1723e4455f0262$var$A || $3c1723e4455f0262$var$z || ($3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J));
};
$3c1723e4455f0262$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3c1723e4455f0262$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3c1723e4455f0262$export$d3dfb8e4810cb555 = function() {
    return $3c1723e4455f0262$var$y;
};
$3c1723e4455f0262$export$839f9183b0465a69 = function() {
    return $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r);
};
$3c1723e4455f0262$export$72fdf0e06517287b = function(a) {
    switch($3c1723e4455f0262$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3c1723e4455f0262$var$y;
    }
    var c = $3c1723e4455f0262$var$y;
    $3c1723e4455f0262$var$y = b;
    try {
        return a();
    } finally{
        $3c1723e4455f0262$var$y = c;
    }
};
$3c1723e4455f0262$export$4b844e58a3e414b4 = function() {};
$3c1723e4455f0262$export$816d2913ae6b83b1 = function() {};
$3c1723e4455f0262$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3c1723e4455f0262$var$y;
    $3c1723e4455f0262$var$y = a;
    try {
        return b();
    } finally{
        $3c1723e4455f0262$var$y = c;
    }
};
$3c1723e4455f0262$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3c1723e4455f0262$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3c1723e4455f0262$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$t, a), null === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r) && a === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t) && ($3c1723e4455f0262$var$B ? ($3c1723e4455f0262$var$E($3c1723e4455f0262$var$L), $3c1723e4455f0262$var$L = -1) : $3c1723e4455f0262$var$B = !0, $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, c - d))) : (a.sortIndex = e, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$r, a), $3c1723e4455f0262$var$A || $3c1723e4455f0262$var$z || ($3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J)));
    return a;
};
$3c1723e4455f0262$export$b5836b71941fa3ed = $3c1723e4455f0262$var$M;
$3c1723e4455f0262$export$cf845f2c119da08a = function(a) {
    var b = $3c1723e4455f0262$var$y;
    return function() {
        var c = $3c1723e4455f0262$var$y;
        $3c1723e4455f0262$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3c1723e4455f0262$var$y = c;
        }
    };
};

});



parcelRegister("bEub4", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $f6Psy = parcelRequire("f6Psy");

var $bY9yL = parcelRequire("bY9yL");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $f6Psy.validateField)(curve.Fp);
    (0, $bY9yL.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $f6Psy.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});
parcelRegister("f6Psy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $bY9yL = parcelRequire("bY9yL");
// prettier-ignore
const $afff555e4e29ceee$var$_0n = BigInt(0), $afff555e4e29ceee$var$_1n = BigInt(1), $afff555e4e29ceee$var$_2n = BigInt(2), $afff555e4e29ceee$var$_3n = BigInt(3);
// prettier-ignore
const $afff555e4e29ceee$var$_4n = BigInt(4), $afff555e4e29ceee$var$_5n = BigInt(5), $afff555e4e29ceee$var$_8n = BigInt(8);
// prettier-ignore
const $afff555e4e29ceee$var$_9n = BigInt(9), $afff555e4e29ceee$var$_16n = BigInt(16);
// Calculates a modulo b
function $afff555e4e29ceee$var$mod(a, b) {
    const result = a % b;
    return result >= $afff555e4e29ceee$var$_0n ? result : b + result;
}
module.exports.mod = $afff555e4e29ceee$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $afff555e4e29ceee$var$pow(num, power, modulo) {
    if (modulo <= $afff555e4e29ceee$var$_0n || power < $afff555e4e29ceee$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $afff555e4e29ceee$var$_1n) return $afff555e4e29ceee$var$_0n;
    let res = $afff555e4e29ceee$var$_1n;
    while(power > $afff555e4e29ceee$var$_0n){
        if (power & $afff555e4e29ceee$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $afff555e4e29ceee$var$_1n;
    }
    return res;
}
module.exports.pow = $afff555e4e29ceee$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $afff555e4e29ceee$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $afff555e4e29ceee$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $afff555e4e29ceee$var$pow2;
// Inverses number over modulo
function $afff555e4e29ceee$var$invert(number, modulo) {
    if (number === $afff555e4e29ceee$var$_0n || modulo <= $afff555e4e29ceee$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $afff555e4e29ceee$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $afff555e4e29ceee$var$_0n, y = $afff555e4e29ceee$var$_1n, u = $afff555e4e29ceee$var$_1n, v = $afff555e4e29ceee$var$_0n;
    while(a !== $afff555e4e29ceee$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $afff555e4e29ceee$var$_1n) throw new Error("invert: does not exist");
    return $afff555e4e29ceee$var$mod(x, modulo);
}
module.exports.invert = $afff555e4e29ceee$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $afff555e4e29ceee$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $afff555e4e29ceee$var$_1n) / $afff555e4e29ceee$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $afff555e4e29ceee$var$_1n, S = 0; Q % $afff555e4e29ceee$var$_2n === $afff555e4e29ceee$var$_0n; Q /= $afff555e4e29ceee$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $afff555e4e29ceee$var$_2n; Z < P && $afff555e4e29ceee$var$pow(Z, legendreC, P) !== P - $afff555e4e29ceee$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $afff555e4e29ceee$var$_1n) / $afff555e4e29ceee$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $afff555e4e29ceee$var$_1n) / $afff555e4e29ceee$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $afff555e4e29ceee$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $afff555e4e29ceee$var$tonelliShanks;
function $afff555e4e29ceee$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $afff555e4e29ceee$var$_4n === $afff555e4e29ceee$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $afff555e4e29ceee$var$_1n) / $afff555e4e29ceee$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $afff555e4e29ceee$var$_8n === $afff555e4e29ceee$var$_5n) {
        const c1 = (P - $afff555e4e29ceee$var$_5n) / $afff555e4e29ceee$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $afff555e4e29ceee$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $afff555e4e29ceee$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $afff555e4e29ceee$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $afff555e4e29ceee$var$tonelliShanks(P);
}
module.exports.FpSqrt = $afff555e4e29ceee$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $afff555e4e29ceee$var$isNegativeLE = (num, modulo)=>($afff555e4e29ceee$var$mod(num, modulo) & $afff555e4e29ceee$var$_1n) === $afff555e4e29ceee$var$_1n;
module.exports.isNegativeLE = $afff555e4e29ceee$var$isNegativeLE;
// prettier-ignore
const $afff555e4e29ceee$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $afff555e4e29ceee$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $afff555e4e29ceee$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $bY9yL.validateObject)(field, opts);
}
module.exports.validateField = $afff555e4e29ceee$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $afff555e4e29ceee$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $afff555e4e29ceee$var$_0n) throw new Error("Expected power > 0");
    if (power === $afff555e4e29ceee$var$_0n) return f.ONE;
    if (power === $afff555e4e29ceee$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $afff555e4e29ceee$var$_0n){
        if (power & $afff555e4e29ceee$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $afff555e4e29ceee$var$_1n;
    }
    return p;
}
module.exports.FpPow = $afff555e4e29ceee$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $afff555e4e29ceee$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $afff555e4e29ceee$var$FpInvertBatch;
function $afff555e4e29ceee$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $afff555e4e29ceee$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $afff555e4e29ceee$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $afff555e4e29ceee$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $afff555e4e29ceee$var$_1n) / $afff555e4e29ceee$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $afff555e4e29ceee$var$FpIsSquare;
// CURVE.n lengths
function $afff555e4e29ceee$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $afff555e4e29ceee$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $afff555e4e29ceee$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $afff555e4e29ceee$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $afff555e4e29ceee$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $afff555e4e29ceee$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $bY9yL.bitMask)(BITS),
        ZERO: $afff555e4e29ceee$var$_0n,
        ONE: $afff555e4e29ceee$var$_1n,
        create: (num)=>$afff555e4e29ceee$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $afff555e4e29ceee$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $afff555e4e29ceee$var$_0n,
        isOdd: (num)=>(num & $afff555e4e29ceee$var$_1n) === $afff555e4e29ceee$var$_1n,
        neg: (num)=>$afff555e4e29ceee$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$afff555e4e29ceee$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$afff555e4e29ceee$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$afff555e4e29ceee$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$afff555e4e29ceee$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$afff555e4e29ceee$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$afff555e4e29ceee$var$mod(lhs * $afff555e4e29ceee$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$afff555e4e29ceee$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$afff555e4e29ceee$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $bY9yL.numberToBytesLE)(num, BYTES) : (0, $bY9yL.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $bY9yL.bytesToNumberLE)(bytes) : (0, $bY9yL.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $afff555e4e29ceee$var$Field;
function $afff555e4e29ceee$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $afff555e4e29ceee$var$FpSqrtOdd;
function $afff555e4e29ceee$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $afff555e4e29ceee$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $afff555e4e29ceee$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $bY9yL.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $afff555e4e29ceee$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $bY9yL.bytesToNumberLE)(hash) : (0, $bY9yL.bytesToNumberBE)(hash);
    return $afff555e4e29ceee$var$mod(num, groupOrder - $afff555e4e29ceee$var$_1n) + $afff555e4e29ceee$var$_1n;
}
module.exports.hashToPrivateScalar = $afff555e4e29ceee$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $afff555e4e29ceee$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $afff555e4e29ceee$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $afff555e4e29ceee$var$getMinHashLength(fieldOrder) {
    const length = $afff555e4e29ceee$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $afff555e4e29ceee$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $afff555e4e29ceee$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $afff555e4e29ceee$var$getFieldBytesLength(fieldOrder);
    const minLen = $afff555e4e29ceee$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $bY9yL.bytesToNumberBE)(key) : (0, $bY9yL.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $afff555e4e29ceee$var$mod(num, fieldOrder - $afff555e4e29ceee$var$_1n) + $afff555e4e29ceee$var$_1n;
    return isLE ? (0, $bY9yL.numberToBytesLE)(reduced, fieldLen) : (0, $bY9yL.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $afff555e4e29ceee$var$mapHashToField;

});
parcelRegister("bY9yL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = module.exports.isBytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $8b6cb6ab2d2985b7$var$_0n = BigInt(0);
const $8b6cb6ab2d2985b7$var$_1n = BigInt(1);
const $8b6cb6ab2d2985b7$var$_2n = BigInt(2);
function $8b6cb6ab2d2985b7$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $8b6cb6ab2d2985b7$var$isBytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
const $8b6cb6ab2d2985b7$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $8b6cb6ab2d2985b7$var$bytesToHex(bytes) {
    if (!$8b6cb6ab2d2985b7$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $8b6cb6ab2d2985b7$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $8b6cb6ab2d2985b7$var$bytesToHex;
function $8b6cb6ab2d2985b7$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $8b6cb6ab2d2985b7$var$numberToHexUnpadded;
function $8b6cb6ab2d2985b7$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $8b6cb6ab2d2985b7$var$hexToNumber;
// We use optimized technique to convert hex string to byte array
const $8b6cb6ab2d2985b7$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $8b6cb6ab2d2985b7$var$asciiToBase16(char) {
    if (char >= $8b6cb6ab2d2985b7$var$asciis._0 && char <= $8b6cb6ab2d2985b7$var$asciis._9) return char - $8b6cb6ab2d2985b7$var$asciis._0;
    if (char >= $8b6cb6ab2d2985b7$var$asciis._A && char <= $8b6cb6ab2d2985b7$var$asciis._F) return char - ($8b6cb6ab2d2985b7$var$asciis._A - 10);
    if (char >= $8b6cb6ab2d2985b7$var$asciis._a && char <= $8b6cb6ab2d2985b7$var$asciis._f) return char - ($8b6cb6ab2d2985b7$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $8b6cb6ab2d2985b7$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $8b6cb6ab2d2985b7$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $8b6cb6ab2d2985b7$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $8b6cb6ab2d2985b7$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $8b6cb6ab2d2985b7$var$bytesToNumberBE(bytes) {
    return $8b6cb6ab2d2985b7$var$hexToNumber($8b6cb6ab2d2985b7$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $8b6cb6ab2d2985b7$var$bytesToNumberBE;
function $8b6cb6ab2d2985b7$var$bytesToNumberLE(bytes) {
    if (!$8b6cb6ab2d2985b7$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    return $8b6cb6ab2d2985b7$var$hexToNumber($8b6cb6ab2d2985b7$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $8b6cb6ab2d2985b7$var$bytesToNumberLE;
function $8b6cb6ab2d2985b7$var$numberToBytesBE(n, len) {
    return $8b6cb6ab2d2985b7$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $8b6cb6ab2d2985b7$var$numberToBytesBE;
function $8b6cb6ab2d2985b7$var$numberToBytesLE(n, len) {
    return $8b6cb6ab2d2985b7$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $8b6cb6ab2d2985b7$var$numberToBytesLE;
// Unpadded, rarely used
function $8b6cb6ab2d2985b7$var$numberToVarBytesBE(n) {
    return $8b6cb6ab2d2985b7$var$hexToBytes($8b6cb6ab2d2985b7$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $8b6cb6ab2d2985b7$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $8b6cb6ab2d2985b7$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $8b6cb6ab2d2985b7$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($8b6cb6ab2d2985b7$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $8b6cb6ab2d2985b7$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $8b6cb6ab2d2985b7$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$8b6cb6ab2d2985b7$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    let res = new Uint8Array(sum);
    let pad = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $8b6cb6ab2d2985b7$var$concatBytes;
// Compares 2 u8a-s in kinda constant time
function $8b6cb6ab2d2985b7$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
module.exports.equalBytes = $8b6cb6ab2d2985b7$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $8b6cb6ab2d2985b7$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $8b6cb6ab2d2985b7$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $8b6cb6ab2d2985b7$var$bitLen(n) {
    let len;
    for(len = 0; n > $8b6cb6ab2d2985b7$var$_0n; n >>= $8b6cb6ab2d2985b7$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $8b6cb6ab2d2985b7$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $8b6cb6ab2d2985b7$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $8b6cb6ab2d2985b7$var$_1n;
}
module.exports.bitGet = $8b6cb6ab2d2985b7$var$bitGet;
/**
 * Sets single bit at position.
 */ const $8b6cb6ab2d2985b7$var$bitSet = (n, pos, value)=>{
    return n | (value ? $8b6cb6ab2d2985b7$var$_1n : $8b6cb6ab2d2985b7$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $8b6cb6ab2d2985b7$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $8b6cb6ab2d2985b7$var$bitMask = (n)=>($8b6cb6ab2d2985b7$var$_2n << BigInt(n - 1)) - $8b6cb6ab2d2985b7$var$_1n;
module.exports.bitMask = $8b6cb6ab2d2985b7$var$bitMask;
// DRBG
const $8b6cb6ab2d2985b7$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $8b6cb6ab2d2985b7$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $8b6cb6ab2d2985b7$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $8b6cb6ab2d2985b7$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $8b6cb6ab2d2985b7$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $8b6cb6ab2d2985b7$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($8b6cb6ab2d2985b7$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($8b6cb6ab2d2985b7$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $8b6cb6ab2d2985b7$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $8b6cb6ab2d2985b7$var$createHmacDrbg;
// Validating curves and fields
const $8b6cb6ab2d2985b7$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $8b6cb6ab2d2985b7$var$isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $8b6cb6ab2d2985b7$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $8b6cb6ab2d2985b7$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $8b6cb6ab2d2985b7$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



parcelRegister("cj5EG", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("ippNs")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("ippNs", function(module, exports) {
"use strict";

});


parcelRegister("f4WXk", function(module, exports) {

var $b2OXO = parcelRequire("b2OXO");
var $afa4f628852b76fb$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $b2OXO($afa4f628852b76fb$var$ALPHABET);

});
parcelRegister("b2OXO", function(module, exports) {
"use strict";

var $jcTxY = parcelRequire("jcTxY");
var $80a769f26c1e8b41$require$_Buffer = $jcTxY.Buffer;
function $80a769f26c1e8b41$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $80a769f26c1e8b41$require$_Buffer.from(source);
        if (!$80a769f26c1e8b41$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $80a769f26c1e8b41$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $80a769f26c1e8b41$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $80a769f26c1e8b41$var$base;

});
parcelRegister("jcTxY", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $cbQCu = parcelRequire("cbQCu");
var $dfba39cd620cd3d7$var$Buffer = $cbQCu.Buffer;
// alternative to using Object.keys for old browsers
function $dfba39cd620cd3d7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($dfba39cd620cd3d7$var$Buffer.from && $dfba39cd620cd3d7$var$Buffer.alloc && $dfba39cd620cd3d7$var$Buffer.allocUnsafe && $dfba39cd620cd3d7$var$Buffer.allocUnsafeSlow) module.exports = $cbQCu;
else {
    // Copy properties from require('buffer')
    $dfba39cd620cd3d7$var$copyProps($cbQCu, module.exports);
    module.exports.Buffer = $dfba39cd620cd3d7$var$SafeBuffer;
}
function $dfba39cd620cd3d7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $dfba39cd620cd3d7$var$Buffer(arg, encodingOrOffset, length);
}
$dfba39cd620cd3d7$var$SafeBuffer.prototype = Object.create($dfba39cd620cd3d7$var$Buffer.prototype);
// Copy static methods from Buffer
$dfba39cd620cd3d7$var$copyProps($dfba39cd620cd3d7$var$Buffer, $dfba39cd620cd3d7$var$SafeBuffer);
$dfba39cd620cd3d7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $dfba39cd620cd3d7$var$Buffer(arg, encodingOrOffset, length);
};
$dfba39cd620cd3d7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $dfba39cd620cd3d7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$dfba39cd620cd3d7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $dfba39cd620cd3d7$var$Buffer(size);
};
$dfba39cd620cd3d7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $cbQCu.SlowBuffer(size);
};

});
parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $8dff54558831dec9$export$e4cf37d7f6fb9e0a, (v) => $8dff54558831dec9$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $8dff54558831dec9$export$599f31c3813fae4d, (v) => $8dff54558831dec9$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
"use strict";

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case "ascii":
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case "base64":
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8dff54558831dec9$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
"use strict";
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup["-".charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup["_".charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("2uYNW", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $1d1d8ca34bfce079$export$88fb0cfd153261a7, (v) => $1d1d8ca34bfce079$export$88fb0cfd153261a7 = v);
$parcel$export(module.exports, "TextDecoder", () => $1d1d8ca34bfce079$export$9c6b53e35bc51b5c, (v) => $1d1d8ca34bfce079$export$9c6b53e35bc51b5c = v);
var $1d1d8ca34bfce079$export$88fb0cfd153261a7;
var $1d1d8ca34bfce079$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $1d1d8ca34bfce079$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $1d1d8ca34bfce079$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $1d1d8ca34bfce079$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $1d1d8ca34bfce079$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $1d1d8ca34bfce079$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $1d1d8ca34bfce079$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$1d1d8ca34bfce079$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $1d1d8ca34bfce079$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $1d1d8ca34bfce079$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $1d1d8ca34bfce079$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $1d1d8ca34bfce079$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $1d1d8ca34bfce079$var$TextDecoder(encoding, options) {
    if (!(this instanceof $1d1d8ca34bfce079$var$TextDecoder)) return new $1d1d8ca34bfce079$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $1d1d8ca34bfce079$var$DEFAULT_ENCODING;
    if (encoding !== $1d1d8ca34bfce079$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $1d1d8ca34bfce079$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$1d1d8ca34bfce079$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $1d1d8ca34bfce079$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $1d1d8ca34bfce079$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $1d1d8ca34bfce079$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $1d1d8ca34bfce079$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $1d1d8ca34bfce079$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $1d1d8ca34bfce079$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $1d1d8ca34bfce079$var$TextEncoder(encoding, options) {
    if (!(this instanceof $1d1d8ca34bfce079$var$TextEncoder)) return new $1d1d8ca34bfce079$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $1d1d8ca34bfce079$var$DEFAULT_ENCODING;
    if (encoding !== $1d1d8ca34bfce079$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $1d1d8ca34bfce079$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$1d1d8ca34bfce079$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $1d1d8ca34bfce079$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $1d1d8ca34bfce079$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $1d1d8ca34bfce079$var$Stream($1d1d8ca34bfce079$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $1d1d8ca34bfce079$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $1d1d8ca34bfce079$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $1d1d8ca34bfce079$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $1d1d8ca34bfce079$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $1d1d8ca34bfce079$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $1d1d8ca34bfce079$var$end_of_stream) return $1d1d8ca34bfce079$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($1d1d8ca34bfce079$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($1d1d8ca34bfce079$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($1d1d8ca34bfce079$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($1d1d8ca34bfce079$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $1d1d8ca34bfce079$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$1d1d8ca34bfce079$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $1d1d8ca34bfce079$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $1d1d8ca34bfce079$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $1d1d8ca34bfce079$var$end_of_stream) return $1d1d8ca34bfce079$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($1d1d8ca34bfce079$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($1d1d8ca34bfce079$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($1d1d8ca34bfce079$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($1d1d8ca34bfce079$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$1d1d8ca34bfce079$export$88fb0cfd153261a7 = $1d1d8ca34bfce079$var$TextEncoder;
$1d1d8ca34bfce079$export$9c6b53e35bc51b5c = $1d1d8ca34bfce079$var$TextDecoder;

});

parcelRegister("fJCyt", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $b748f7374afeddb0$var$runtime = (parcelRequire("e3y9D"))();
module.exports = $b748f7374afeddb0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $b748f7374afeddb0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b748f7374afeddb0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b748f7374afeddb0$var$runtime);
}

});
parcelRegister("e3y9D", function(module, exports) {

var $h0bfi = parcelRequire("h0bfi");
var $a3bbd6d943c3a33e$var$_typeof = $h0bfi.default;
function $a3bbd6d943c3a33e$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $a3bbd6d943c3a33e$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $a3bbd6d943c3a33e$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($a3bbd6d943c3a33e$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $a3bbd6d943c3a33e$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("h0bfi", function(module, exports) {
function $c60b28e70c35adf9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $c60b28e70c35adf9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c60b28e70c35adf9$var$_typeof(o);
}
module.exports = $c60b28e70c35adf9$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bXpXp", function(module, exports) {
function $8b4956f0d64a1215$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $8b4956f0d64a1215$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $8b4956f0d64a1215$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $8b4956f0d64a1215$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $8b4956f0d64a1215$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5W7fH", function(module, exports) {
function $4527fea7a1f2d687$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $4527fea7a1f2d687$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iiIaW", function(module, exports) {

var $lOf49 = parcelRequire("lOf49");
function $d52c2cbf80fcdb3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $lOf49(descriptor.key), descriptor);
    }
}
function $d52c2cbf80fcdb3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d52c2cbf80fcdb3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d52c2cbf80fcdb3c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $d52c2cbf80fcdb3c$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lOf49", function(module, exports) {

var $h0bfi = parcelRequire("h0bfi");
var $fe09f4437b4e371a$var$_typeof = $h0bfi.default;

var $ga4pg = parcelRequire("ga4pg");
function $fe09f4437b4e371a$var$toPropertyKey(t) {
    var i = $ga4pg(t, "string");
    return "symbol" == $fe09f4437b4e371a$var$_typeof(i) ? i : String(i);
}
module.exports = $fe09f4437b4e371a$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ga4pg", function(module, exports) {

var $h0bfi = parcelRequire("h0bfi");
var $bc40ff9288a97253$var$_typeof = $h0bfi.default;
function $bc40ff9288a97253$var$toPrimitive(t, r) {
    if ("object" != $bc40ff9288a97253$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bc40ff9288a97253$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $bc40ff9288a97253$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fxSBS", function(module, exports) {

var $4hUzM = parcelRequire("4hUzM");
function $b5144c7842b2641b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4hUzM(subClass, superClass);
}
module.exports = $b5144c7842b2641b$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4hUzM", function(module, exports) {
function $31f4a2c7ba5ee8ae$var$_setPrototypeOf(o, p) {
    module.exports = $31f4a2c7ba5ee8ae$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $31f4a2c7ba5ee8ae$var$_setPrototypeOf(o, p);
}
module.exports = $31f4a2c7ba5ee8ae$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dmYtZ", function(module, exports) {

var $h0bfi = parcelRequire("h0bfi");
var $9bbc3f0fccc04307$var$_typeof = $h0bfi.default;

var $1DxMa = parcelRequire("1DxMa");
function $9bbc3f0fccc04307$var$_possibleConstructorReturn(self, call) {
    if (call && ($9bbc3f0fccc04307$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1DxMa(self);
}
module.exports = $9bbc3f0fccc04307$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1DxMa", function(module, exports) {
function $1313a22a469cb3cd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $1313a22a469cb3cd$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1dvnv", function(module, exports) {
function $0e2f5864e7c29c30$var$_getPrototypeOf(o) {
    module.exports = $0e2f5864e7c29c30$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $0e2f5864e7c29c30$var$_getPrototypeOf(o);
}
module.exports = $0e2f5864e7c29c30$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dFMVQ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $9f450f8bd59818cd$export$bf730a2d8bf68b42, (v) => $9f450f8bd59818cd$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9f450f8bd59818cd$export$bf730a2d8bf68b42;
"use strict";

var $lx97N = parcelRequire("lx97N");

var $kCHLQ = parcelRequire("kCHLQ");
function $9f450f8bd59818cd$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9f450f8bd59818cd$var$q = "function" === typeof Object.is ? Object.is : $9f450f8bd59818cd$var$p, $9f450f8bd59818cd$var$r = $kCHLQ.useSyncExternalStore, $9f450f8bd59818cd$var$t = $lx97N.useRef, $9f450f8bd59818cd$var$u = $lx97N.useEffect, $9f450f8bd59818cd$var$v = $lx97N.useMemo, $9f450f8bd59818cd$var$w = $lx97N.useDebugValue;
$9f450f8bd59818cd$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $9f450f8bd59818cd$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $9f450f8bd59818cd$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($9f450f8bd59818cd$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $9f450f8bd59818cd$var$r(a, c[0], c[1]);
    $9f450f8bd59818cd$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $9f450f8bd59818cd$var$w(d);
    return d;
};

});
parcelRegister("kCHLQ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bbgAE"));

});
parcelRegister("bbgAE", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $823d97410cd8fe80$export$306c0aa65ff9ec16, (v) => $823d97410cd8fe80$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $823d97410cd8fe80$export$306c0aa65ff9ec16;
"use strict";

var $lx97N = parcelRequire("lx97N");
function $823d97410cd8fe80$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $823d97410cd8fe80$var$k = "function" === typeof Object.is ? Object.is : $823d97410cd8fe80$var$h, $823d97410cd8fe80$var$l = $lx97N.useState, $823d97410cd8fe80$var$m = $lx97N.useEffect, $823d97410cd8fe80$var$n = $lx97N.useLayoutEffect, $823d97410cd8fe80$var$p = $lx97N.useDebugValue;
function $823d97410cd8fe80$var$q(a, b) {
    var d = b(), f = $823d97410cd8fe80$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $823d97410cd8fe80$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $823d97410cd8fe80$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $823d97410cd8fe80$var$m(function() {
        $823d97410cd8fe80$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $823d97410cd8fe80$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $823d97410cd8fe80$var$p(d);
    return d;
}
function $823d97410cd8fe80$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$823d97410cd8fe80$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $823d97410cd8fe80$var$t(a, b) {
    return b();
}
var $823d97410cd8fe80$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $823d97410cd8fe80$var$t : $823d97410cd8fe80$var$q;
$823d97410cd8fe80$export$306c0aa65ff9ec16 = void 0 !== $lx97N.useSyncExternalStore ? $lx97N.useSyncExternalStore : $823d97410cd8fe80$var$u;

});



parcelRegister("xtbW9", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");

var $1yPDs = parcelRequire("1yPDs");

var $kTeNx = parcelRequire("kTeNx");

var $fveEe = parcelRequire("fveEe");

var $gybT0 = parcelRequire("gybT0");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $0649ba0324057234$var$createInstance(defaultConfig) {
    var context = new $kTeNx(defaultConfig);
    var instance = $1yPDs($kTeNx.prototype.request, context);
    // Copy axios.prototype to instance
    $8x7z0.extend(instance, $kTeNx.prototype, context);
    // Copy context to instance
    $8x7z0.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $0649ba0324057234$var$createInstance($fveEe(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $0649ba0324057234$var$axios = $0649ba0324057234$var$createInstance($gybT0);
// Expose Axios class to allow class inheritance
$0649ba0324057234$var$axios.Axios = $kTeNx;

// Expose Cancel & CancelToken
$0649ba0324057234$var$axios.Cancel = (parcelRequire("46Hdp"));

$0649ba0324057234$var$axios.CancelToken = (parcelRequire("5RTfQ"));

$0649ba0324057234$var$axios.isCancel = (parcelRequire("3EJu8"));

$0649ba0324057234$var$axios.VERSION = (parcelRequire("6Uw9o")).version;
// Expose all/spread
$0649ba0324057234$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$0649ba0324057234$var$axios.spread = (parcelRequire("belRa"));

// Expose isAxiosError
$0649ba0324057234$var$axios.isAxiosError = (parcelRequire("jSNhQ"));
module.exports = $0649ba0324057234$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $0649ba0324057234$var$axios;

});
parcelRegister("8x7z0", function(module, exports) {
"use strict";

var $1yPDs = parcelRequire("1yPDs");
// utils is a library of generic helper functions non-specific to axios
var $636745c0afec921a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $636745c0afec921a$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $636745c0afec921a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $636745c0afec921a$var$isBuffer(val) {
    return val !== null && !$636745c0afec921a$var$isUndefined(val) && val.constructor !== null && !$636745c0afec921a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $636745c0afec921a$var$isArrayBuffer(val) {
    return $636745c0afec921a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $636745c0afec921a$var$isFormData(val) {
    return $636745c0afec921a$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $636745c0afec921a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $636745c0afec921a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $636745c0afec921a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $636745c0afec921a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $636745c0afec921a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $636745c0afec921a$var$isPlainObject(val) {
    if ($636745c0afec921a$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $636745c0afec921a$var$isDate(val) {
    return $636745c0afec921a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $636745c0afec921a$var$isFile(val) {
    return $636745c0afec921a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $636745c0afec921a$var$isBlob(val) {
    return $636745c0afec921a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $636745c0afec921a$var$isFunction(val) {
    return $636745c0afec921a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $636745c0afec921a$var$isStream(val) {
    return $636745c0afec921a$var$isObject(val) && $636745c0afec921a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $636745c0afec921a$var$isURLSearchParams(val) {
    return $636745c0afec921a$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $636745c0afec921a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $636745c0afec921a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $636745c0afec921a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($636745c0afec921a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $636745c0afec921a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($636745c0afec921a$var$isPlainObject(result[key]) && $636745c0afec921a$var$isPlainObject(val)) result[key] = $636745c0afec921a$var$merge(result[key], val);
        else if ($636745c0afec921a$var$isPlainObject(val)) result[key] = $636745c0afec921a$var$merge({}, val);
        else if ($636745c0afec921a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$636745c0afec921a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $636745c0afec921a$var$extend(a, b, thisArg) {
    $636745c0afec921a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $1yPDs(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $636745c0afec921a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $636745c0afec921a$var$isArray,
    isArrayBuffer: $636745c0afec921a$var$isArrayBuffer,
    isBuffer: $636745c0afec921a$var$isBuffer,
    isFormData: $636745c0afec921a$var$isFormData,
    isArrayBufferView: $636745c0afec921a$var$isArrayBufferView,
    isString: $636745c0afec921a$var$isString,
    isNumber: $636745c0afec921a$var$isNumber,
    isObject: $636745c0afec921a$var$isObject,
    isPlainObject: $636745c0afec921a$var$isPlainObject,
    isUndefined: $636745c0afec921a$var$isUndefined,
    isDate: $636745c0afec921a$var$isDate,
    isFile: $636745c0afec921a$var$isFile,
    isBlob: $636745c0afec921a$var$isBlob,
    isFunction: $636745c0afec921a$var$isFunction,
    isStream: $636745c0afec921a$var$isStream,
    isURLSearchParams: $636745c0afec921a$var$isURLSearchParams,
    isStandardBrowserEnv: $636745c0afec921a$var$isStandardBrowserEnv,
    forEach: $636745c0afec921a$var$forEach,
    merge: $636745c0afec921a$var$merge,
    extend: $636745c0afec921a$var$extend,
    trim: $636745c0afec921a$var$trim,
    stripBOM: $636745c0afec921a$var$stripBOM
};

});
parcelRegister("1yPDs", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("kTeNx", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");

var $0yFJt = parcelRequire("0yFJt");

var $bDxj4 = parcelRequire("bDxj4");

var $bglhc = parcelRequire("bglhc");

var $fveEe = parcelRequire("fveEe");

var $9fqgi = parcelRequire("9fqgi");
var $f3546c432f01aea9$var$validators = $9fqgi.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $f3546c432f01aea9$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $bDxj4(),
        response: new $bDxj4()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $f3546c432f01aea9$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $fveEe(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $9fqgi.assertOptions(transitional, {
        silentJSONParsing: $f3546c432f01aea9$var$validators.transitional($f3546c432f01aea9$var$validators.boolean),
        forcedJSONParsing: $f3546c432f01aea9$var$validators.transitional($f3546c432f01aea9$var$validators.boolean),
        clarifyTimeoutError: $f3546c432f01aea9$var$validators.transitional($f3546c432f01aea9$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $bglhc,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $bglhc(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$f3546c432f01aea9$var$Axios.prototype.getUri = function getUri(config) {
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $fveEe(this.defaults, config);
    return $0yFJt(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$8x7z0.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $f3546c432f01aea9$var$Axios.prototype[method] = function(url, config) {
        return this.request($fveEe(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$8x7z0.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $f3546c432f01aea9$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($fveEe(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $f3546c432f01aea9$var$Axios;

});
parcelRegister("0yFJt", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
function $001ae55c14372700$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($8x7z0.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $8x7z0.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($8x7z0.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $8x7z0.forEach(val, function parseValue(v) {
                if ($8x7z0.isDate(v)) v = v.toISOString();
                else if ($8x7z0.isObject(v)) v = JSON.stringify(v);
                parts.push($001ae55c14372700$var$encode(key) + "=" + $001ae55c14372700$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("bDxj4", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
function $878d2c3b7c458d37$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $878d2c3b7c458d37$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $878d2c3b7c458d37$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $878d2c3b7c458d37$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $8x7z0.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $878d2c3b7c458d37$var$InterceptorManager;

});

parcelRegister("bglhc", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");

var $iUEy5 = parcelRequire("iUEy5");

var $3EJu8 = parcelRequire("3EJu8");

var $gybT0 = parcelRequire("gybT0");

var $46Hdp = parcelRequire("46Hdp");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $8331b160b9908220$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $46Hdp("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $8331b160b9908220$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $iUEy5.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $8x7z0.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $8x7z0.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $gybT0.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $8331b160b9908220$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $iUEy5.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$3EJu8(reason)) {
            $8331b160b9908220$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $iUEy5.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("iUEy5", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");

var $gybT0 = parcelRequire("gybT0");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $gybT0;
    /*eslint no-param-reassign:0*/ $8x7z0.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("gybT0", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
"use strict";

var $8x7z0 = parcelRequire("8x7z0");

var $j3wXc = parcelRequire("j3wXc");

var $jXl6B = parcelRequire("jXl6B");
var $c0c90aad62ffa343$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $c0c90aad62ffa343$var$setContentTypeIfUnset(headers, value) {
    if (!$8x7z0.isUndefined(headers) && $8x7z0.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $c0c90aad62ffa343$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("6Y34y"));
    else if (typeof $4Jj9n !== "undefined" && Object.prototype.toString.call($4Jj9n) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("6Y34y"));
    return adapter;
}
function $c0c90aad62ffa343$var$stringifySafely(rawValue, parser, encoder) {
    if ($8x7z0.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $8x7z0.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $c0c90aad62ffa343$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $c0c90aad62ffa343$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $j3wXc(headers, "Accept");
            $j3wXc(headers, "Content-Type");
            if ($8x7z0.isFormData(data) || $8x7z0.isArrayBuffer(data) || $8x7z0.isBuffer(data) || $8x7z0.isStream(data) || $8x7z0.isFile(data) || $8x7z0.isBlob(data)) return data;
            if ($8x7z0.isArrayBufferView(data)) return data.buffer;
            if ($8x7z0.isURLSearchParams(data)) {
                $c0c90aad62ffa343$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($8x7z0.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $c0c90aad62ffa343$var$setContentTypeIfUnset(headers, "application/json");
                return $c0c90aad62ffa343$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $c0c90aad62ffa343$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $8x7z0.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $jXl6B(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$8x7z0.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $c0c90aad62ffa343$var$defaults.headers[method] = {};
});
$8x7z0.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $c0c90aad62ffa343$var$defaults.headers[method] = $8x7z0.merge($c0c90aad62ffa343$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $c0c90aad62ffa343$var$defaults;

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = "browser";
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ""; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$371a3837fd81d701$var$process.cwd = function() {
    return "/";
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});

parcelRegister("j3wXc", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $8x7z0.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("jXl6B", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("6Y34y", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");

var $1qHQ4 = parcelRequire("1qHQ4");

var $5ysrB = parcelRequire("5ysrB");

var $0yFJt = parcelRequire("0yFJt");

var $dI3oW = parcelRequire("dI3oW");

var $6THhW = parcelRequire("6THhW");

var $lJqGA = parcelRequire("lJqGA");

var $4FINT = parcelRequire("4FINT");

var $gybT0 = parcelRequire("gybT0");

var $46Hdp = parcelRequire("46Hdp");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($8x7z0.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $dI3oW(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $0yFJt(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $6THhW(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1qHQ4(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($4FINT("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($4FINT("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $gybT0.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($4FINT(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($8x7z0.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $lJqGA(fullPath)) && config.xsrfCookieName ? $5ysrB.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $8x7z0.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$8x7z0.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $46Hdp("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("1qHQ4", function(module, exports) {
"use strict";

var $4FINT = parcelRequire("4FINT");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($4FINT("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("4FINT", function(module, exports) {
"use strict";

var $jXl6B = parcelRequire("jXl6B");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $jXl6B(error, config, code, request, response);
};

});


parcelRegister("5ysrB", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
module.exports = $8x7z0.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($8x7z0.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($8x7z0.isString(path)) cookie.push("path=" + path);
            if ($8x7z0.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("dI3oW", function(module, exports) {
"use strict";

var $8Wtbc = parcelRequire("8Wtbc");

var $boGzT = parcelRequire("boGzT");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$8Wtbc(requestedURL)) return $boGzT(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("8Wtbc", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("boGzT", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("6THhW", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $5059754b7c16e022$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $8x7z0.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $8x7z0.trim(line.substr(0, i)).toLowerCase();
        val = $8x7z0.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $5059754b7c16e022$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("lJqGA", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
module.exports = $8x7z0.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $8x7z0.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("46Hdp", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $2fd93ea352f02385$var$Cancel(message) {
    this.message = message;
}
$2fd93ea352f02385$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$2fd93ea352f02385$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $2fd93ea352f02385$var$Cancel;

});




parcelRegister("3EJu8", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("fveEe", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($8x7z0.isPlainObject(target) && $8x7z0.isPlainObject(source)) return $8x7z0.merge(target, source);
        else if ($8x7z0.isPlainObject(source)) return $8x7z0.merge({}, source);
        else if ($8x7z0.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$8x7z0.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$8x7z0.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$8x7z0.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$8x7z0.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$8x7z0.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $8x7z0.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $8x7z0.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("9fqgi", function(module, exports) {
"use strict";

var $6Uw9o = parcelRequire("6Uw9o");
var $6bb9e2d909d9d31a$require$VERSION = $6Uw9o.version;
var $6bb9e2d909d9d31a$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $6bb9e2d909d9d31a$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $6bb9e2d909d9d31a$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $6bb9e2d909d9d31a$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $6bb9e2d909d9d31a$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$6bb9e2d909d9d31a$var$deprecatedWarnings[opt]) {
            $6bb9e2d909d9d31a$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $6bb9e2d909d9d31a$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $6bb9e2d909d9d31a$var$assertOptions,
    validators: $6bb9e2d909d9d31a$var$validators
};

});
parcelRegister("6Uw9o", function(module, exports) {
module.exports = {
    "version": "0.25.0"
};

});



parcelRegister("5RTfQ", function(module, exports) {
"use strict";

var $46Hdp = parcelRequire("46Hdp");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $445cc36abd39c136$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $46Hdp(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $445cc36abd39c136$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $445cc36abd39c136$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $445cc36abd39c136$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $445cc36abd39c136$var$CancelToken.source = function source() {
    var cancel;
    var token = new $445cc36abd39c136$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $445cc36abd39c136$var$CancelToken;

});

parcelRegister("belRa", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("jSNhQ", function(module, exports) {
"use strict";

var $8x7z0 = parcelRequire("8x7z0");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $8x7z0.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("5Hty4", function(module, exports) {
"use strict";
var $4267e39d86d98f0a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4267e39d86d98f0a$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafetyDepositBox = module.exports.SafetyDepositBoxData = void 0;

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $cbQCu = parcelRequire("cbQCu");

var $1jULY = parcelRequire("1jULY");
class $4267e39d86d98f0a$var$SafetyDepositBoxData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9JmsZ.VaultKey.SafetyDepositBoxV1;
    }
}
module.exports.SafetyDepositBoxData = $4267e39d86d98f0a$var$SafetyDepositBoxData;
$4267e39d86d98f0a$var$_a = $4267e39d86d98f0a$var$SafetyDepositBoxData;
$4267e39d86d98f0a$var$SafetyDepositBoxData.SCHEMA = $4267e39d86d98f0a$var$_a.struct([
    [
        "key",
        "u8"
    ],
    [
        "vault",
        "pubkeyAsString"
    ],
    [
        "tokenMint",
        "pubkeyAsString"
    ],
    [
        "store",
        "pubkeyAsString"
    ],
    [
        "order",
        "u8"
    ]
]);
class $4267e39d86d98f0a$var$SafetyDepositBox extends $1jULY.Account {
    constructor(key, info){
        super(key, info);
        if (!this.assertOwner($9JmsZ.VaultProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$4267e39d86d98f0a$var$SafetyDepositBox.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $4267e39d86d98f0a$var$SafetyDepositBoxData.deserialize(this.info.data);
    }
    static getPDA(vault, mint) {
        return $4267e39d86d98f0a$var$__awaiter(this, void 0, void 0, function*() {
            return $9JmsZ.VaultProgram.findProgramAddress([
                $cbQCu.Buffer.from($9JmsZ.VaultProgram.PREFIX),
                new $1biTx.PublicKey(vault).toBuffer(),
                new $1biTx.PublicKey(mint).toBuffer()
            ]);
        });
    }
    static isCompatible(data) {
        return data[0] === $9JmsZ.VaultKey.SafetyDepositBoxV1;
    }
}
module.exports.SafetyDepositBox = $4267e39d86d98f0a$var$SafetyDepositBox;

});
parcelRegister("1biTx", function(module, exports) {

$parcel$export(module.exports, "PublicKey", () => $0dc579a0cc55ffb4$export$ca8b6604d6ce14de);
$parcel$export(module.exports, "SIGNATURE_LENGTH_IN_BYTES", () => $0dc579a0cc55ffb4$export$14aee086fde78fa6);
$parcel$export(module.exports, "VersionedMessage", () => $0dc579a0cc55ffb4$export$b0a61927d00ede7f);
$parcel$export(module.exports, "TransactionInstruction", () => $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59);
$parcel$export(module.exports, "Transaction", () => $0dc579a0cc55ffb4$export$febc5573c75cefb0);
$parcel$export(module.exports, "VersionedTransaction", () => $0dc579a0cc55ffb4$export$232cc3f078dcc284);
$parcel$export(module.exports, "SYSVAR_CLOCK_PUBKEY", () => $0dc579a0cc55ffb4$export$393aa1412d47050e);
$parcel$export(module.exports, "SYSVAR_INSTRUCTIONS_PUBKEY", () => $0dc579a0cc55ffb4$export$54419cc1a3ece8d6);
$parcel$export(module.exports, "SYSVAR_RENT_PUBKEY", () => $0dc579a0cc55ffb4$export$970d0190cdb3a8e9);
$parcel$export(module.exports, "sendAndConfirmTransaction", () => $0dc579a0cc55ffb4$export$4ad6fe6dae0b6bc3);
$parcel$export(module.exports, "NONCE_ACCOUNT_LENGTH", () => $0dc579a0cc55ffb4$export$7126250b6d8bd94a);
$parcel$export(module.exports, "SystemProgram", () => $0dc579a0cc55ffb4$export$d8c4e17726848113);
$parcel$export(module.exports, "SendTransactionError", () => $0dc579a0cc55ffb4$export$121e803f723b3045);
$parcel$export(module.exports, "Connection", () => $0dc579a0cc55ffb4$export$98b66c25bb38499d);
$parcel$export(module.exports, "Keypair", () => $0dc579a0cc55ffb4$export$c53bca448cf33676);
$parcel$export(module.exports, "ComputeBudgetProgram", () => $0dc579a0cc55ffb4$export$11585db5942bcdb7);
$parcel$export(module.exports, "clusterApiUrl", () => $0dc579a0cc55ffb4$export$11656287b4eb76ff);

var $cbQCu = parcelRequire("cbQCu");

var $jNKMc = parcelRequire("jNKMc");

var $cj5EG = parcelRequire("cj5EG");

var $f4WXk = parcelRequire("f4WXk");

var $9XCBn = parcelRequire("9XCBn");

var $cY9OW = parcelRequire("cY9OW");

var $ivDjT = parcelRequire("ivDjT");

var $bpv1j = parcelRequire("bpv1j");

var $8TK0B = parcelRequire("8TK0B");

var $5iF8R = parcelRequire("5iF8R");

var $6Rz5s = parcelRequire("6Rz5s");

var $hFjcB = parcelRequire("hFjcB");

var $2dinB = parcelRequire("2dinB");

var $386SJ = parcelRequire("386SJ");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $0dc579a0cc55ffb4$var$generatePrivateKey = (0, $jNKMc.ed25519).utils.randomPrivateKey;
const $0dc579a0cc55ffb4$var$generateKeypair = ()=>{
    const privateScalar = (0, $jNKMc.ed25519).utils.randomPrivateKey();
    const publicKey = $0dc579a0cc55ffb4$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $0dc579a0cc55ffb4$var$getPublicKey = (0, $jNKMc.ed25519).getPublicKey;
function $0dc579a0cc55ffb4$var$isOnCurve(publicKey) {
    try {
        (0, $jNKMc.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $0dc579a0cc55ffb4$var$sign = (message, secretKey)=>(0, $jNKMc.ed25519).sign(message, secretKey.slice(0, 32));
const $0dc579a0cc55ffb4$var$verify = (0, $jNKMc.ed25519).verify;
const $0dc579a0cc55ffb4$var$toBuffer = (arr)=>{
    if ((0, $cbQCu.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $cbQCu.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $cbQCu.Buffer).from(arr);
};
// Class wrapping a plain object
class $0dc579a0cc55ffb4$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $cbQCu.Buffer).from((0, $cY9OW.serialize)($0dc579a0cc55ffb4$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $cY9OW.deserialize)($0dc579a0cc55ffb4$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $cY9OW.deserializeUnchecked)($0dc579a0cc55ffb4$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $0dc579a0cc55ffb4$export$deb82508dd66d288 extends $0dc579a0cc55ffb4$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $0dc579a0cc55ffb4$export$68d13ce9b4cc48f3 = new Map();
var $0dc579a0cc55ffb4$var$_class;
let $0dc579a0cc55ffb4$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $0dc579a0cc55ffb4$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $0dc579a0cc55ffb4$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $0dc579a0cc55ffb4$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $0dc579a0cc55ffb4$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $0dc579a0cc55ffb4$var$_Symbol$toStringTag = Symbol.toStringTag;
class $0dc579a0cc55ffb4$export$ca8b6604d6ce14de extends $0dc579a0cc55ffb4$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($0dc579a0cc55ffb4$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(value);
                if (decoded.length != $0dc579a0cc55ffb4$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(value);
            if (this._bn.byteLength() > $0dc579a0cc55ffb4$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de($0dc579a0cc55ffb4$var$uniquePublicKeyCounter);
        $0dc579a0cc55ffb4$var$uniquePublicKeyCounter += 1;
        return new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $cbQCu.Buffer));
        if (b.length === $0dc579a0cc55ffb4$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $cbQCu.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$0dc579a0cc55ffb4$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $cbQCu.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $cbQCu.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $9XCBn.sha256)(buffer);
        return new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $cbQCu.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $0dc579a0cc55ffb4$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $cbQCu.Buffer).concat([
                buffer,
                $0dc579a0cc55ffb4$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $cbQCu.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $cbQCu.Buffer).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $9XCBn.sha256)(buffer);
        if ($0dc579a0cc55ffb4$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $cbQCu.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(pubkeyData);
        return $0dc579a0cc55ffb4$var$isOnCurve(pubkey.toBytes());
    }
}
$0dc579a0cc55ffb4$var$_class = $0dc579a0cc55ffb4$export$ca8b6604d6ce14de;
$0dc579a0cc55ffb4$export$ca8b6604d6ce14de.default = new $0dc579a0cc55ffb4$var$_class("11111111111111111111111111111111");
$0dc579a0cc55ffb4$export$68d13ce9b4cc48f3.set($0dc579a0cc55ffb4$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $0dc579a0cc55ffb4$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $0dc579a0cc55ffb4$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $0dc579a0cc55ffb4$var$toBuffer($0dc579a0cc55ffb4$var$generatePrivateKey());
            this._publicKey = $0dc579a0cc55ffb4$var$toBuffer($0dc579a0cc55ffb4$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $cbQCu.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $0dc579a0cc55ffb4$export$42bd37c1c64962b6 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $0dc579a0cc55ffb4$export$4c6d5b89e1596f26 = 1232;
const $0dc579a0cc55ffb4$export$3c3793d809f8b858 = 0x7f;
const $0dc579a0cc55ffb4$export$14aee086fde78fa6 = 64;
class $0dc579a0cc55ffb4$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($0dc579a0cc55ffb4$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $0dc579a0cc55ffb4$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($0dc579a0cc55ffb4$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $0dc579a0cc55ffb4$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($0dc579a0cc55ffb4$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $0dc579a0cc55ffb4$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $0dc579a0cc55ffb4$var$publicKey = (property = "publicKey")=>{
    return $ivDjT.blob(32, property);
};
/**
 * Layout for a signature
 */ const $0dc579a0cc55ffb4$var$signature = (property = "signature")=>{
    return $ivDjT.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $0dc579a0cc55ffb4$var$rustString = (property = "string")=>{
    const rsl = $ivDjT.struct([
        $ivDjT.u32("length"),
        $ivDjT.u32("lengthPadding"),
        $ivDjT.blob($ivDjT.offset($ivDjT.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $cbQCu.Buffer).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $ivDjT.u32().span + $ivDjT.u32().span + (0, $cbQCu.Buffer).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $0dc579a0cc55ffb4$var$authorized = (property = "authorized")=>{
    return $ivDjT.struct([
        $0dc579a0cc55ffb4$var$publicKey("staker"),
        $0dc579a0cc55ffb4$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $0dc579a0cc55ffb4$var$lockup = (property = "lockup")=>{
    return $ivDjT.struct([
        $ivDjT.ns64("unixTimestamp"),
        $ivDjT.ns64("epoch"),
        $0dc579a0cc55ffb4$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $0dc579a0cc55ffb4$var$voteInit = (property = "voteInit")=>{
    return $ivDjT.struct([
        $0dc579a0cc55ffb4$var$publicKey("nodePubkey"),
        $0dc579a0cc55ffb4$var$publicKey("authorizedVoter"),
        $0dc579a0cc55ffb4$var$publicKey("authorizedWithdrawer"),
        $ivDjT.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $0dc579a0cc55ffb4$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $ivDjT.struct([
        $ivDjT.u32("voteAuthorizationType"),
        $0dc579a0cc55ffb4$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $0dc579a0cc55ffb4$var$rustString("currentAuthorityDerivedKeySeed"),
        $0dc579a0cc55ffb4$var$publicKey("newAuthorized")
    ], property);
};
function $0dc579a0cc55ffb4$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $0dc579a0cc55ffb4$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $0dc579a0cc55ffb4$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $0dc579a0cc55ffb4$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $0dc579a0cc55ffb4$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $0dc579a0cc55ffb4$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $0dc579a0cc55ffb4$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $0dc579a0cc55ffb4$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $0dc579a0cc55ffb4$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $0dc579a0cc55ffb4$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $0dc579a0cc55ffb4$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $0dc579a0cc55ffb4$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $0dc579a0cc55ffb4$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $0dc579a0cc55ffb4$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $0dc579a0cc55ffb4$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(ix.data)
            }));
        return new $0dc579a0cc55ffb4$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $0dc579a0cc55ffb4$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(instruction.data));
            let keyIndicesCount = [];
            $0dc579a0cc55ffb4$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $0dc579a0cc55ffb4$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $cbQCu.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $cbQCu.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $0dc579a0cc55ffb4$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $cbQCu.Buffer).alloc($0dc579a0cc55ffb4$export$4c6d5b89e1596f26);
        (0, $cbQCu.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $ivDjT.struct([
                $ivDjT.u8("programIdIndex"),
                $ivDjT.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $ivDjT.seq($ivDjT.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $ivDjT.blob(instruction.dataLength.length, "dataLength"),
                $ivDjT.seq($ivDjT.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $ivDjT.struct([
            $ivDjT.blob(1, "numRequiredSignatures"),
            $ivDjT.blob(1, "numReadonlySignedAccounts"),
            $ivDjT.blob(1, "numReadonlyUnsignedAccounts"),
            $ivDjT.blob(keyCount.length, "keyCount"),
            $ivDjT.seq($0dc579a0cc55ffb4$var$publicKey("key"), numKeys, "keys"),
            $0dc579a0cc55ffb4$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $cbQCu.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $cbQCu.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $cbQCu.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $cbQCu.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$0dc579a0cc55ffb4$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(this.recentBlockhash)
        };
        let signData = (0, $cbQCu.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = byteArray.shift();
        if (numRequiredSignatures !== (numRequiredSignatures & $0dc579a0cc55ffb4$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = byteArray.shift();
        const numReadonlyUnsignedAccounts = byteArray.shift();
        const accountCount = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = byteArray.slice(0, $0dc579a0cc55ffb4$export$84fc0a248cc54343);
            byteArray = byteArray.slice($0dc579a0cc55ffb4$export$84fc0a248cc54343);
            accountKeys.push(new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de((0, $cbQCu.Buffer).from(account)));
        }
        const recentBlockhash = byteArray.slice(0, $0dc579a0cc55ffb4$export$84fc0a248cc54343);
        byteArray = byteArray.slice($0dc579a0cc55ffb4$export$84fc0a248cc54343);
        const instructionCount = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = byteArray.shift();
            const accountCount = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
            const accounts = byteArray.slice(0, accountCount);
            byteArray = byteArray.slice(accountCount);
            const dataLength = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
            const dataSlice = byteArray.slice(0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode((0, $cbQCu.Buffer).from(dataSlice));
            byteArray = byteArray.slice(dataLength);
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode((0, $cbQCu.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $0dc579a0cc55ffb4$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $0dc579a0cc55ffb4$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $0dc579a0cc55ffb4$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $0dc579a0cc55ffb4$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $0dc579a0cc55ffb4$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $0dc579a0cc55ffb4$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $0dc579a0cc55ffb4$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $0dc579a0cc55ffb4$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $0dc579a0cc55ffb4$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $ivDjT.struct([
            $ivDjT.u8("prefix"),
            $ivDjT.struct([
                $ivDjT.u8("numRequiredSignatures"),
                $ivDjT.u8("numReadonlySignedAccounts"),
                $ivDjT.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $ivDjT.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $ivDjT.seq($0dc579a0cc55ffb4$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $0dc579a0cc55ffb4$var$publicKey("recentBlockhash"),
            $ivDjT.blob(encodedInstructionsLength.length, "instructionsLength"),
            $ivDjT.blob(serializedInstructions.length, "serializedInstructions"),
            $ivDjT.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $ivDjT.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($0dc579a0cc55ffb4$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($0dc579a0cc55ffb4$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $0dc579a0cc55ffb4$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $0dc579a0cc55ffb4$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $ivDjT.struct([
                $ivDjT.u8("programIdIndex"),
                $ivDjT.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $ivDjT.seq($ivDjT.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $ivDjT.blob(encodedDataLength.length, "encodedDataLength"),
                $ivDjT.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($0dc579a0cc55ffb4$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $0dc579a0cc55ffb4$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $0dc579a0cc55ffb4$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $ivDjT.struct([
                $0dc579a0cc55ffb4$var$publicKey("accountKey"),
                $ivDjT.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $ivDjT.seq($ivDjT.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $ivDjT.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $ivDjT.seq($ivDjT.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = byteArray.shift();
        const maskedPrefix = prefix & $0dc579a0cc55ffb4$export$3c3793d809f8b858;
        $0dc579a0cc55ffb4$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $0dc579a0cc55ffb4$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: byteArray.shift(),
            numReadonlySignedAccounts: byteArray.shift(),
            numReadonlyUnsignedAccounts: byteArray.shift()
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(byteArray.splice(0, $0dc579a0cc55ffb4$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(byteArray.splice(0, $0dc579a0cc55ffb4$export$84fc0a248cc54343));
        const instructionCount = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = byteArray.shift();
            const accountKeyIndexesLength = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
            const accountKeyIndexes = byteArray.splice(0, accountKeyIndexesLength);
            const dataLength = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
            const data = new Uint8Array(byteArray.splice(0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(byteArray.splice(0, $0dc579a0cc55ffb4$export$84fc0a248cc54343));
            const writableIndexesLength = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
            const writableIndexes = byteArray.splice(0, writableIndexesLength);
            const readonlyIndexesLength = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
            const readonlyIndexes = byteArray.splice(0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $0dc579a0cc55ffb4$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $0dc579a0cc55ffb4$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $0dc579a0cc55ffb4$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $0dc579a0cc55ffb4$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $0dc579a0cc55ffb4$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $0dc579a0cc55ffb4$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $0dc579a0cc55ffb4$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $0dc579a0cc55ffb4$var$DEFAULT_SIGNATURE = (0, $cbQCu.Buffer).alloc($0dc579a0cc55ffb4$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $cbQCu.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $0dc579a0cc55ffb4$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $0dc579a0cc55ffb4$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$0dc579a0cc55ffb4$var$assert(keyIndex >= 0));
        });
        return new $0dc579a0cc55ffb4$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $0dc579a0cc55ffb4$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $0dc579a0cc55ffb4$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $0dc579a0cc55ffb4$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $cbQCu.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$0dc579a0cc55ffb4$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = "Signature verification failed.";
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? "" : "(s)"} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join("`, `")}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? "" : "(s)"} [\`${sigErrors.missing.map((p)=>p.toBase58()).join("`, `")}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $0dc579a0cc55ffb4$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $cbQCu.Buffer).alloc(transactionLength);
        $0dc579a0cc55ffb4$var$assert(signatures.length < 256);
        (0, $cbQCu.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $0dc579a0cc55ffb4$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $cbQCu.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $0dc579a0cc55ffb4$var$assert(wireTransaction.length <= $0dc579a0cc55ffb4$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$0dc579a0cc55ffb4$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $0dc579a0cc55ffb4$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $0dc579a0cc55ffb4$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $0dc579a0cc55ffb4$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = byteArray.slice(0, $0dc579a0cc55ffb4$export$14aee086fde78fa6);
            byteArray = byteArray.slice($0dc579a0cc55ffb4$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode((0, $cbQCu.Buffer).from(signature)));
        }
        return $0dc579a0cc55ffb4$export$febc5573c75cefb0.populate($0dc579a0cc55ffb4$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode($0dc579a0cc55ffb4$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $0dc579a0cc55ffb4$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $0dc579a0cc55ffb4$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $0dc579a0cc55ffb4$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $0dc579a0cc55ffb4$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $0dc579a0cc55ffb4$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $0dc579a0cc55ffb4$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $0dc579a0cc55ffb4$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $0dc579a0cc55ffb4$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $0dc579a0cc55ffb4$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($0dc579a0cc55ffb4$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $0dc579a0cc55ffb4$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $ivDjT.struct([
            $ivDjT.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $ivDjT.seq($0dc579a0cc55ffb4$var$signature(), this.signatures.length, "signatures"),
            $ivDjT.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array(byteArray.splice(0, $0dc579a0cc55ffb4$export$14aee086fde78fa6)));
        const message = $0dc579a0cc55ffb4$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $0dc579a0cc55ffb4$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $0dc579a0cc55ffb4$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $0dc579a0cc55ffb4$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $0dc579a0cc55ffb4$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $0dc579a0cc55ffb4$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$NUM_SLOTS_PER_SECOND = $0dc579a0cc55ffb4$var$NUM_TICKS_PER_SECOND / $0dc579a0cc55ffb4$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$MS_PER_SLOT = 1000 / $0dc579a0cc55ffb4$var$NUM_SLOTS_PER_SECOND;
const $0dc579a0cc55ffb4$export$393aa1412d47050e = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $0dc579a0cc55ffb4$export$2b71d479444d2f4 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $0dc579a0cc55ffb4$export$54419cc1a3ece8d6 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $0dc579a0cc55ffb4$export$e74201139e9833db = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $0dc579a0cc55ffb4$export$970d0190cdb3a8e9 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $0dc579a0cc55ffb4$export$da3b38d796bc1af1 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $0dc579a0cc55ffb4$export$7b3a057916a4a7ae = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $0dc579a0cc55ffb4$export$3272815bf0633907 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $0dc579a0cc55ffb4$export$ca994171317280ea = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $0dc579a0cc55ffb4$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $0dc579a0cc55ffb4$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $0dc579a0cc55ffb4$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $0dc579a0cc55ffb4$var$getAlloc(type, fields);
    const data = (0, $cbQCu.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $0dc579a0cc55ffb4$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $0dc579a0cc55ffb4$export$d1cc579b1c48f515 = $ivDjT.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $0dc579a0cc55ffb4$var$NonceAccountLayout = $ivDjT.struct([
    $ivDjT.u32("version"),
    $ivDjT.u32("state"),
    $0dc579a0cc55ffb4$var$publicKey("authorizedPubkey"),
    $0dc579a0cc55ffb4$var$publicKey("nonce"),
    $ivDjT.struct([
        $0dc579a0cc55ffb4$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $0dc579a0cc55ffb4$export$7126250b6d8bd94a = $0dc579a0cc55ffb4$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $0dc579a0cc55ffb4$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $0dc579a0cc55ffb4$var$NonceAccountLayout.decode($0dc579a0cc55ffb4$var$toBuffer(buffer), 0);
        return new $0dc579a0cc55ffb4$export$ed1c2356ce604759({
            authorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $0dc579a0cc55ffb4$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $0dc579a0cc55ffb4$var$bigInt = (length)=>(property)=>{
        const layout = (0, $ivDjT.blob)(length, property);
        const { encode: encode, decode: decode } = $0dc579a0cc55ffb4$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $bpv1j.toBigIntLE)((0, $cbQCu.Buffer).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $bpv1j.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $0dc579a0cc55ffb4$var$u64 = $0dc579a0cc55ffb4$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $0dc579a0cc55ffb4$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ivDjT.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($0dc579a0cc55ffb4$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($0dc579a0cc55ffb4$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $0dc579a0cc55ffb4$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $ivDjT.ns64("lamports"),
            $ivDjT.ns64("space"),
            $0dc579a0cc55ffb4$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("base"),
            $0dc579a0cc55ffb4$var$rustString("seed"),
            $ivDjT.ns64("lamports"),
            $ivDjT.ns64("space"),
            $0dc579a0cc55ffb4$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $ivDjT.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $ivDjT.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("base"),
            $0dc579a0cc55ffb4$var$rustString("seed"),
            $ivDjT.ns64("space"),
            $0dc579a0cc55ffb4$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("base"),
            $0dc579a0cc55ffb4$var$rustString("seed"),
            $0dc579a0cc55ffb4$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$u64("lamports"),
            $0dc579a0cc55ffb4$var$rustString("seed"),
            $0dc579a0cc55ffb4$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $0dc579a0cc55ffb4$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Create;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $0dc579a0cc55ffb4$var$toBuffer(params.programId.toBuffer())
        });
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $0dc579a0cc55ffb4$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $0dc579a0cc55ffb4$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Transfer;
            data = $0dc579a0cc55ffb4$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $0dc579a0cc55ffb4$var$encodeData(type, {
                base: $0dc579a0cc55ffb4$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $0dc579a0cc55ffb4$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Assign;
            data = $0dc579a0cc55ffb4$var$encodeData(type, {
                programId: $0dc579a0cc55ffb4$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            base: $0dc579a0cc55ffb4$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $0dc579a0cc55ffb4$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $0dc579a0cc55ffb4$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $0dc579a0cc55ffb4$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            authorized: $0dc579a0cc55ffb4$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $0dc579a0cc55ffb4$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            authorized: $0dc579a0cc55ffb4$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $0dc579a0cc55ffb4$var$encodeData(type, {
                base: $0dc579a0cc55ffb4$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $0dc579a0cc55ffb4$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $0dc579a0cc55ffb4$export$74bdf41d8d1e7108.Allocate;
            data = $0dc579a0cc55ffb4$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$0dc579a0cc55ffb4$export$d8c4e17726848113.programId = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $0dc579a0cc55ffb4$var$CHUNK_SIZE = $0dc579a0cc55ffb4$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $0dc579a0cc55ffb4$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $0dc579a0cc55ffb4$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
                    transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
                    transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
                    transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add($0dc579a0cc55ffb4$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $0dc579a0cc55ffb4$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $ivDjT.u32("offset"),
            $ivDjT.u32("bytesLength"),
            $ivDjT.u32("bytesLengthPadding"),
            $ivDjT.seq($ivDjT.u8("byte"), $ivDjT.offset($ivDjT.u32(), -8), "bytes")
        ]);
        const chunkSize = $0dc579a0cc55ffb4$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $cbQCu.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($0dc579a0cc55ffb4$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $0dc579a0cc55ffb4$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $ivDjT.struct([
                $ivDjT.u32("instruction")
            ]);
            const data = (0, $cbQCu.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $0dc579a0cc55ffb4$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($0dc579a0cc55ffb4$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$0dc579a0cc55ffb4$export$3b0d6d7590275603.chunkSize = $0dc579a0cc55ffb4$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $0dc579a0cc55ffb4$export$59833422f998b937 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $0dc579a0cc55ffb4$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $0dc579a0cc55ffb4$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $0dc579a0cc55ffb4$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $0dc579a0cc55ffb4$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $0dc579a0cc55ffb4$var$objToString = Object.prototype.toString;
var $0dc579a0cc55ffb4$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $0dc579a0cc55ffb4$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $0dc579a0cc55ffb4$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $0dc579a0cc55ffb4$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = "[";
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $0dc579a0cc55ffb4$var$stringify(val[i], true) + ",";
                    if (max > -1) str += $0dc579a0cc55ffb4$var$stringify(val[i], true);
                    return str + "]";
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $0dc579a0cc55ffb4$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $0dc579a0cc55ffb4$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ",";
                            str += JSON.stringify(key) + ":" + propVal;
                        }
                        i++;
                    }
                    return "{" + str + "}";
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $0dc579a0cc55ffb4$var$fastStableStringify = function(val) {
    var returnVal = $0dc579a0cc55ffb4$var$stringify(val, false);
    if (returnVal !== undefined) return "" + returnVal;
};
var $0dc579a0cc55ffb4$var$fastStableStringify$1 = /*@__PURE__*/ $0dc579a0cc55ffb4$var$getDefaultExportFromCjs($0dc579a0cc55ffb4$var$fastStableStringify);
const $0dc579a0cc55ffb4$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $0dc579a0cc55ffb4$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $0dc579a0cc55ffb4$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $0dc579a0cc55ffb4$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $0dc579a0cc55ffb4$var$trailingZeros($0dc579a0cc55ffb4$var$nextPowerOfTwo(slot + $0dc579a0cc55ffb4$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $0dc579a0cc55ffb4$var$trailingZeros($0dc579a0cc55ffb4$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $0dc579a0cc55ffb4$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $0dc579a0cc55ffb4$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $0dc579a0cc55ffb4$var$trailingZeros($0dc579a0cc55ffb4$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $0dc579a0cc55ffb4$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $0dc579a0cc55ffb4$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
var $0dc579a0cc55ffb4$var$fetchImpl = globalThis.fetch;
class $0dc579a0cc55ffb4$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($6Rz5s))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($hFjcB)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $0dc579a0cc55ffb4$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $0dc579a0cc55ffb4$var$LOOKUP_TABLE_META_SIZE = 56;
class $0dc579a0cc55ffb4$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $0dc579a0cc55ffb4$var$decodeData($0dc579a0cc55ffb4$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $0dc579a0cc55ffb4$var$LOOKUP_TABLE_META_SIZE;
        $0dc579a0cc55ffb4$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $0dc579a0cc55ffb4$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $ivDjT.struct([
            $ivDjT.seq($0dc579a0cc55ffb4$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($0dc579a0cc55ffb4$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(address))
        };
    }
}
const $0dc579a0cc55ffb4$var$LookupTableMetaLayout = {
    index: 1,
    layout: $ivDjT.struct([
        $ivDjT.u32("typeIndex"),
        $0dc579a0cc55ffb4$var$u64("deactivationSlot"),
        $ivDjT.nu64("lastExtendedSlot"),
        $ivDjT.u8("lastExtendedStartIndex"),
        $ivDjT.u8(),
        // option
        $ivDjT.seq($0dc579a0cc55ffb4$var$publicKey(), $ivDjT.offset($ivDjT.u8(), -1), "authority")
    ])
};
const $0dc579a0cc55ffb4$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $0dc579a0cc55ffb4$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($0dc579a0cc55ffb4$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $0dc579a0cc55ffb4$var$PublicKeyFromString = (0, $8TK0B.coerce)((0, $8TK0B.instance)($0dc579a0cc55ffb4$export$ca8b6604d6ce14de), (0, $8TK0B.string)(), (value)=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(value));
const $0dc579a0cc55ffb4$var$RawAccountDataResult = (0, $8TK0B.tuple)([
    (0, $8TK0B.string)(),
    (0, $8TK0B.literal)("base64")
]);
const $0dc579a0cc55ffb4$var$BufferFromRawAccountData = (0, $8TK0B.coerce)((0, $8TK0B.instance)((0, $cbQCu.Buffer)), $0dc579a0cc55ffb4$var$RawAccountDataResult, (value)=>(0, $cbQCu.Buffer).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $0dc579a0cc55ffb4$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $0dc579a0cc55ffb4$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $0dc579a0cc55ffb4$var$createRpcResult(result) {
    return (0, $8TK0B.union)([
        (0, $8TK0B.type)({
            jsonrpc: (0, $8TK0B.literal)("2.0"),
            id: (0, $8TK0B.string)(),
            result: result
        }),
        (0, $8TK0B.type)({
            jsonrpc: (0, $8TK0B.literal)("2.0"),
            id: (0, $8TK0B.string)(),
            error: (0, $8TK0B.type)({
                code: (0, $8TK0B.unknown)(),
                message: (0, $8TK0B.string)(),
                data: (0, $8TK0B.optional)((0, $8TK0B.any)())
            })
        })
    ]);
}
const $0dc579a0cc55ffb4$var$UnknownRpcResult = $0dc579a0cc55ffb4$var$createRpcResult((0, $8TK0B.unknown)());
/**
 * @internal
 */ function $0dc579a0cc55ffb4$var$jsonRpcResult(schema) {
    return (0, $8TK0B.coerce)($0dc579a0cc55ffb4$var$createRpcResult(schema), $0dc579a0cc55ffb4$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $8TK0B.create)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $0dc579a0cc55ffb4$var$jsonRpcResultAndContext(value) {
    return $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.type)({
        context: (0, $8TK0B.type)({
            slot: (0, $8TK0B.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $0dc579a0cc55ffb4$var$notificationResultAndContext(value) {
    return (0, $8TK0B.type)({
        context: (0, $8TK0B.type)({
            slot: (0, $8TK0B.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $0dc579a0cc55ffb4$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $0dc579a0cc55ffb4$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $0dc579a0cc55ffb4$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $0dc579a0cc55ffb4$var$GetInflationGovernorResult = (0, $8TK0B.type)({
    foundation: (0, $8TK0B.number)(),
    foundationTerm: (0, $8TK0B.number)(),
    initial: (0, $8TK0B.number)(),
    taper: (0, $8TK0B.number)(),
    terminal: (0, $8TK0B.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $0dc579a0cc55ffb4$var$GetInflationRewardResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)((0, $8TK0B.nullable)((0, $8TK0B.type)({
    epoch: (0, $8TK0B.number)(),
    effectiveSlot: (0, $8TK0B.number)(),
    amount: (0, $8TK0B.number)(),
    postBalance: (0, $8TK0B.number)(),
    commission: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $0dc579a0cc55ffb4$var$GetRecentPrioritizationFeesResult = (0, $8TK0B.array)((0, $8TK0B.type)({
    slot: (0, $8TK0B.number)(),
    prioritizationFee: (0, $8TK0B.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $0dc579a0cc55ffb4$var$GetInflationRateResult = (0, $8TK0B.type)({
    total: (0, $8TK0B.number)(),
    validator: (0, $8TK0B.number)(),
    foundation: (0, $8TK0B.number)(),
    epoch: (0, $8TK0B.number)()
});
/**
 * Information about the current epoch
 */ const $0dc579a0cc55ffb4$var$GetEpochInfoResult = (0, $8TK0B.type)({
    epoch: (0, $8TK0B.number)(),
    slotIndex: (0, $8TK0B.number)(),
    slotsInEpoch: (0, $8TK0B.number)(),
    absoluteSlot: (0, $8TK0B.number)(),
    blockHeight: (0, $8TK0B.optional)((0, $8TK0B.number)()),
    transactionCount: (0, $8TK0B.optional)((0, $8TK0B.number)())
});
const $0dc579a0cc55ffb4$var$GetEpochScheduleResult = (0, $8TK0B.type)({
    slotsPerEpoch: (0, $8TK0B.number)(),
    leaderScheduleSlotOffset: (0, $8TK0B.number)(),
    warmup: (0, $8TK0B.boolean)(),
    firstNormalEpoch: (0, $8TK0B.number)(),
    firstNormalSlot: (0, $8TK0B.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $0dc579a0cc55ffb4$var$GetLeaderScheduleResult = (0, $8TK0B.record)((0, $8TK0B.string)(), (0, $8TK0B.array)((0, $8TK0B.number)()));
/**
 * Transaction error or null
 */ const $0dc579a0cc55ffb4$var$TransactionErrorResult = (0, $8TK0B.nullable)((0, $8TK0B.union)([
    (0, $8TK0B.type)({}),
    (0, $8TK0B.string)()
]));
/**
 * Signature status for a transaction
 */ const $0dc579a0cc55ffb4$var$SignatureStatusResult = (0, $8TK0B.type)({
    err: $0dc579a0cc55ffb4$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $0dc579a0cc55ffb4$var$SignatureReceivedResult = (0, $8TK0B.literal)("receivedSignature");
/**
 * Version info for a node
 */ const $0dc579a0cc55ffb4$var$VersionResult = (0, $8TK0B.type)({
    "solana-core": (0, $8TK0B.string)(),
    "feature-set": (0, $8TK0B.optional)((0, $8TK0B.number)())
});
const $0dc579a0cc55ffb4$var$SimulatedTransactionResponseStruct = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.type)({
    err: (0, $8TK0B.nullable)((0, $8TK0B.union)([
        (0, $8TK0B.type)({}),
        (0, $8TK0B.string)()
    ])),
    logs: (0, $8TK0B.nullable)((0, $8TK0B.array)((0, $8TK0B.string)())),
    accounts: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)((0, $8TK0B.nullable)((0, $8TK0B.type)({
        executable: (0, $8TK0B.boolean)(),
        owner: (0, $8TK0B.string)(),
        lamports: (0, $8TK0B.number)(),
        data: (0, $8TK0B.array)((0, $8TK0B.string)()),
        rentEpoch: (0, $8TK0B.optional)((0, $8TK0B.number)())
    }))))),
    unitsConsumed: (0, $8TK0B.optional)((0, $8TK0B.number)()),
    returnData: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.type)({
        programId: (0, $8TK0B.string)(),
        data: (0, $8TK0B.tuple)([
            (0, $8TK0B.string)(),
            (0, $8TK0B.literal)("base64")
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $0dc579a0cc55ffb4$var$BlockProductionResponseStruct = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.type)({
    byIdentity: (0, $8TK0B.record)((0, $8TK0B.string)(), (0, $8TK0B.array)((0, $8TK0B.number)())),
    range: (0, $8TK0B.type)({
        firstSlot: (0, $8TK0B.number)(),
        lastSlot: (0, $8TK0B.number)()
    })
}));
/**
 * A performance sample
 */ function $0dc579a0cc55ffb4$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $0dc579a0cc55ffb4$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($5iF8R)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $0dc579a0cc55ffb4$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $0dc579a0cc55ffb4$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $0dc579a0cc55ffb4$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $0dc579a0cc55ffb4$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $0dc579a0cc55ffb4$var$GetInflationGovernorRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $0dc579a0cc55ffb4$var$GetInflationRateRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $0dc579a0cc55ffb4$var$GetRecentPrioritizationFeesRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $0dc579a0cc55ffb4$var$GetEpochInfoRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $0dc579a0cc55ffb4$var$GetEpochScheduleRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $0dc579a0cc55ffb4$var$GetLeaderScheduleRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $0dc579a0cc55ffb4$var$SlotRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $0dc579a0cc55ffb4$var$GetSupplyRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.type)({
    total: (0, $8TK0B.number)(),
    circulating: (0, $8TK0B.number)(),
    nonCirculating: (0, $8TK0B.number)(),
    nonCirculatingAccounts: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $0dc579a0cc55ffb4$var$TokenAmountResult = (0, $8TK0B.type)({
    amount: (0, $8TK0B.string)(),
    uiAmount: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    decimals: (0, $8TK0B.number)(),
    uiAmountString: (0, $8TK0B.optional)((0, $8TK0B.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $0dc579a0cc55ffb4$var$GetTokenLargestAccountsResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.array)((0, $8TK0B.type)({
    address: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    amount: (0, $8TK0B.string)(),
    uiAmount: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    decimals: (0, $8TK0B.number)(),
    uiAmountString: (0, $8TK0B.optional)((0, $8TK0B.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $0dc579a0cc55ffb4$var$GetTokenAccountsByOwner = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.array)((0, $8TK0B.type)({
    pubkey: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    account: (0, $8TK0B.type)({
        executable: (0, $8TK0B.boolean)(),
        owner: $0dc579a0cc55ffb4$var$PublicKeyFromString,
        lamports: (0, $8TK0B.number)(),
        data: $0dc579a0cc55ffb4$var$BufferFromRawAccountData,
        rentEpoch: (0, $8TK0B.number)()
    })
})));
const $0dc579a0cc55ffb4$var$ParsedAccountDataResult = (0, $8TK0B.type)({
    program: (0, $8TK0B.string)(),
    parsed: (0, $8TK0B.unknown)(),
    space: (0, $8TK0B.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $0dc579a0cc55ffb4$var$GetParsedTokenAccountsByOwner = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.array)((0, $8TK0B.type)({
    pubkey: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    account: (0, $8TK0B.type)({
        executable: (0, $8TK0B.boolean)(),
        owner: $0dc579a0cc55ffb4$var$PublicKeyFromString,
        lamports: (0, $8TK0B.number)(),
        data: $0dc579a0cc55ffb4$var$ParsedAccountDataResult,
        rentEpoch: (0, $8TK0B.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $0dc579a0cc55ffb4$var$GetLargestAccountsRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.array)((0, $8TK0B.type)({
    lamports: (0, $8TK0B.number)(),
    address: $0dc579a0cc55ffb4$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$AccountInfoResult = (0, $8TK0B.type)({
    executable: (0, $8TK0B.boolean)(),
    owner: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    lamports: (0, $8TK0B.number)(),
    data: $0dc579a0cc55ffb4$var$BufferFromRawAccountData,
    rentEpoch: (0, $8TK0B.number)()
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$KeyedAccountInfoResult = (0, $8TK0B.type)({
    pubkey: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    account: $0dc579a0cc55ffb4$var$AccountInfoResult
});
const $0dc579a0cc55ffb4$var$ParsedOrRawAccountData = (0, $8TK0B.coerce)((0, $8TK0B.union)([
    (0, $8TK0B.instance)((0, $cbQCu.Buffer)),
    $0dc579a0cc55ffb4$var$ParsedAccountDataResult
]), (0, $8TK0B.union)([
    $0dc579a0cc55ffb4$var$RawAccountDataResult,
    $0dc579a0cc55ffb4$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $8TK0B.create)(value, $0dc579a0cc55ffb4$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$ParsedAccountInfoResult = (0, $8TK0B.type)({
    executable: (0, $8TK0B.boolean)(),
    owner: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    lamports: (0, $8TK0B.number)(),
    data: $0dc579a0cc55ffb4$var$ParsedOrRawAccountData,
    rentEpoch: (0, $8TK0B.number)()
});
const $0dc579a0cc55ffb4$var$KeyedParsedAccountInfoResult = (0, $8TK0B.type)({
    pubkey: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    account: $0dc579a0cc55ffb4$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$StakeActivationResult = (0, $8TK0B.type)({
    state: (0, $8TK0B.union)([
        (0, $8TK0B.literal)("active"),
        (0, $8TK0B.literal)("inactive"),
        (0, $8TK0B.literal)("activating"),
        (0, $8TK0B.literal)("deactivating")
    ]),
    active: (0, $8TK0B.number)(),
    inactive: (0, $8TK0B.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $0dc579a0cc55ffb4$var$GetConfirmedSignaturesForAddress2RpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)((0, $8TK0B.type)({
    signature: (0, $8TK0B.string)(),
    slot: (0, $8TK0B.number)(),
    err: $0dc579a0cc55ffb4$var$TransactionErrorResult,
    memo: (0, $8TK0B.nullable)((0, $8TK0B.string)()),
    blockTime: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $0dc579a0cc55ffb4$var$GetSignaturesForAddressRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)((0, $8TK0B.type)({
    signature: (0, $8TK0B.string)(),
    slot: (0, $8TK0B.number)(),
    err: $0dc579a0cc55ffb4$var$TransactionErrorResult,
    memo: (0, $8TK0B.nullable)((0, $8TK0B.string)()),
    blockTime: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $0dc579a0cc55ffb4$var$AccountNotificationResult = (0, $8TK0B.type)({
    subscription: (0, $8TK0B.number)(),
    result: $0dc579a0cc55ffb4$var$notificationResultAndContext($0dc579a0cc55ffb4$var$AccountInfoResult)
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$ProgramAccountInfoResult = (0, $8TK0B.type)({
    pubkey: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    account: $0dc579a0cc55ffb4$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $0dc579a0cc55ffb4$var$ProgramAccountNotificationResult = (0, $8TK0B.type)({
    subscription: (0, $8TK0B.number)(),
    result: $0dc579a0cc55ffb4$var$notificationResultAndContext($0dc579a0cc55ffb4$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$SlotInfoResult = (0, $8TK0B.type)({
    parent: (0, $8TK0B.number)(),
    slot: (0, $8TK0B.number)(),
    root: (0, $8TK0B.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $0dc579a0cc55ffb4$var$SlotNotificationResult = (0, $8TK0B.type)({
    subscription: (0, $8TK0B.number)(),
    result: $0dc579a0cc55ffb4$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $0dc579a0cc55ffb4$var$SlotUpdateResult = (0, $8TK0B.union)([
    (0, $8TK0B.type)({
        type: (0, $8TK0B.union)([
            (0, $8TK0B.literal)("firstShredReceived"),
            (0, $8TK0B.literal)("completed"),
            (0, $8TK0B.literal)("optimisticConfirmation"),
            (0, $8TK0B.literal)("root")
        ]),
        slot: (0, $8TK0B.number)(),
        timestamp: (0, $8TK0B.number)()
    }),
    (0, $8TK0B.type)({
        type: (0, $8TK0B.literal)("createdBank"),
        parent: (0, $8TK0B.number)(),
        slot: (0, $8TK0B.number)(),
        timestamp: (0, $8TK0B.number)()
    }),
    (0, $8TK0B.type)({
        type: (0, $8TK0B.literal)("frozen"),
        slot: (0, $8TK0B.number)(),
        timestamp: (0, $8TK0B.number)(),
        stats: (0, $8TK0B.type)({
            numTransactionEntries: (0, $8TK0B.number)(),
            numSuccessfulTransactions: (0, $8TK0B.number)(),
            numFailedTransactions: (0, $8TK0B.number)(),
            maxTransactionsPerEntry: (0, $8TK0B.number)()
        })
    }),
    (0, $8TK0B.type)({
        type: (0, $8TK0B.literal)("dead"),
        slot: (0, $8TK0B.number)(),
        timestamp: (0, $8TK0B.number)(),
        err: (0, $8TK0B.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $0dc579a0cc55ffb4$var$SlotUpdateNotificationResult = (0, $8TK0B.type)({
    subscription: (0, $8TK0B.number)(),
    result: $0dc579a0cc55ffb4$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $0dc579a0cc55ffb4$var$SignatureNotificationResult = (0, $8TK0B.type)({
    subscription: (0, $8TK0B.number)(),
    result: $0dc579a0cc55ffb4$var$notificationResultAndContext((0, $8TK0B.union)([
        $0dc579a0cc55ffb4$var$SignatureStatusResult,
        $0dc579a0cc55ffb4$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $0dc579a0cc55ffb4$var$RootNotificationResult = (0, $8TK0B.type)({
    subscription: (0, $8TK0B.number)(),
    result: (0, $8TK0B.number)()
});
const $0dc579a0cc55ffb4$var$ContactInfoResult = (0, $8TK0B.type)({
    pubkey: (0, $8TK0B.string)(),
    gossip: (0, $8TK0B.nullable)((0, $8TK0B.string)()),
    tpu: (0, $8TK0B.nullable)((0, $8TK0B.string)()),
    rpc: (0, $8TK0B.nullable)((0, $8TK0B.string)()),
    version: (0, $8TK0B.nullable)((0, $8TK0B.string)())
});
const $0dc579a0cc55ffb4$var$VoteAccountInfoResult = (0, $8TK0B.type)({
    votePubkey: (0, $8TK0B.string)(),
    nodePubkey: (0, $8TK0B.string)(),
    activatedStake: (0, $8TK0B.number)(),
    epochVoteAccount: (0, $8TK0B.boolean)(),
    epochCredits: (0, $8TK0B.array)((0, $8TK0B.tuple)([
        (0, $8TK0B.number)(),
        (0, $8TK0B.number)(),
        (0, $8TK0B.number)()
    ])),
    commission: (0, $8TK0B.number)(),
    lastVote: (0, $8TK0B.number)(),
    rootSlot: (0, $8TK0B.nullable)((0, $8TK0B.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $0dc579a0cc55ffb4$var$GetVoteAccounts = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.type)({
    current: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$VoteAccountInfoResult),
    delinquent: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$VoteAccountInfoResult)
}));
const $0dc579a0cc55ffb4$var$ConfirmationStatus = (0, $8TK0B.union)([
    (0, $8TK0B.literal)("processed"),
    (0, $8TK0B.literal)("confirmed"),
    (0, $8TK0B.literal)("finalized")
]);
const $0dc579a0cc55ffb4$var$SignatureStatusResponse = (0, $8TK0B.type)({
    slot: (0, $8TK0B.number)(),
    confirmations: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    err: $0dc579a0cc55ffb4$var$TransactionErrorResult,
    confirmationStatus: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $0dc579a0cc55ffb4$var$GetSignatureStatusesRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.array)((0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $0dc579a0cc55ffb4$var$GetMinimumBalanceForRentExemptionRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.number)());
const $0dc579a0cc55ffb4$var$AddressTableLookupStruct = (0, $8TK0B.type)({
    accountKey: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    writableIndexes: (0, $8TK0B.array)((0, $8TK0B.number)()),
    readonlyIndexes: (0, $8TK0B.array)((0, $8TK0B.number)())
});
const $0dc579a0cc55ffb4$var$ConfirmedTransactionResult = (0, $8TK0B.type)({
    signatures: (0, $8TK0B.array)((0, $8TK0B.string)()),
    message: (0, $8TK0B.type)({
        accountKeys: (0, $8TK0B.array)((0, $8TK0B.string)()),
        header: (0, $8TK0B.type)({
            numRequiredSignatures: (0, $8TK0B.number)(),
            numReadonlySignedAccounts: (0, $8TK0B.number)(),
            numReadonlyUnsignedAccounts: (0, $8TK0B.number)()
        }),
        instructions: (0, $8TK0B.array)((0, $8TK0B.type)({
            accounts: (0, $8TK0B.array)((0, $8TK0B.number)()),
            data: (0, $8TK0B.string)(),
            programIdIndex: (0, $8TK0B.number)()
        })),
        recentBlockhash: (0, $8TK0B.string)(),
        addressTableLookups: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$AddressTableLookupStruct))
    })
});
const $0dc579a0cc55ffb4$var$AnnotatedAccountKey = (0, $8TK0B.type)({
    pubkey: $0dc579a0cc55ffb4$var$PublicKeyFromString,
    signer: (0, $8TK0B.boolean)(),
    writable: (0, $8TK0B.boolean)(),
    source: (0, $8TK0B.optional)((0, $8TK0B.union)([
        (0, $8TK0B.literal)("transaction"),
        (0, $8TK0B.literal)("lookupTable")
    ]))
});
const $0dc579a0cc55ffb4$var$ConfirmedTransactionAccountsModeResult = (0, $8TK0B.type)({
    accountKeys: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$AnnotatedAccountKey),
    signatures: (0, $8TK0B.array)((0, $8TK0B.string)())
});
const $0dc579a0cc55ffb4$var$ParsedInstructionResult = (0, $8TK0B.type)({
    parsed: (0, $8TK0B.unknown)(),
    program: (0, $8TK0B.string)(),
    programId: $0dc579a0cc55ffb4$var$PublicKeyFromString
});
const $0dc579a0cc55ffb4$var$RawInstructionResult = (0, $8TK0B.type)({
    accounts: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$PublicKeyFromString),
    data: (0, $8TK0B.string)(),
    programId: $0dc579a0cc55ffb4$var$PublicKeyFromString
});
const $0dc579a0cc55ffb4$var$InstructionResult = (0, $8TK0B.union)([
    $0dc579a0cc55ffb4$var$RawInstructionResult,
    $0dc579a0cc55ffb4$var$ParsedInstructionResult
]);
const $0dc579a0cc55ffb4$var$UnknownInstructionResult = (0, $8TK0B.union)([
    (0, $8TK0B.type)({
        parsed: (0, $8TK0B.unknown)(),
        program: (0, $8TK0B.string)(),
        programId: (0, $8TK0B.string)()
    }),
    (0, $8TK0B.type)({
        accounts: (0, $8TK0B.array)((0, $8TK0B.string)()),
        data: (0, $8TK0B.string)(),
        programId: (0, $8TK0B.string)()
    })
]);
const $0dc579a0cc55ffb4$var$ParsedOrRawInstruction = (0, $8TK0B.coerce)($0dc579a0cc55ffb4$var$InstructionResult, $0dc579a0cc55ffb4$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $8TK0B.create)(value, $0dc579a0cc55ffb4$var$RawInstructionResult);
    else return (0, $8TK0B.create)(value, $0dc579a0cc55ffb4$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$ParsedConfirmedTransactionResult = (0, $8TK0B.type)({
    signatures: (0, $8TK0B.array)((0, $8TK0B.string)()),
    message: (0, $8TK0B.type)({
        accountKeys: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$AnnotatedAccountKey),
        instructions: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $8TK0B.string)(),
        addressTableLookups: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$AddressTableLookupStruct)))
    })
});
const $0dc579a0cc55ffb4$var$TokenBalanceResult = (0, $8TK0B.type)({
    accountIndex: (0, $8TK0B.number)(),
    mint: (0, $8TK0B.string)(),
    owner: (0, $8TK0B.optional)((0, $8TK0B.string)()),
    uiTokenAmount: $0dc579a0cc55ffb4$var$TokenAmountResult
});
const $0dc579a0cc55ffb4$var$LoadedAddressesResult = (0, $8TK0B.type)({
    writable: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$PublicKeyFromString),
    readonly: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$ConfirmedTransactionMetaResult = (0, $8TK0B.type)({
    err: $0dc579a0cc55ffb4$var$TransactionErrorResult,
    fee: (0, $8TK0B.number)(),
    innerInstructions: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)((0, $8TK0B.type)({
        index: (0, $8TK0B.number)(),
        instructions: (0, $8TK0B.array)((0, $8TK0B.type)({
            accounts: (0, $8TK0B.array)((0, $8TK0B.number)()),
            data: (0, $8TK0B.string)(),
            programIdIndex: (0, $8TK0B.number)()
        }))
    })))),
    preBalances: (0, $8TK0B.array)((0, $8TK0B.number)()),
    postBalances: (0, $8TK0B.array)((0, $8TK0B.number)()),
    logMessages: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)((0, $8TK0B.string)()))),
    preTokenBalances: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$TokenBalanceResult))),
    postTokenBalances: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$TokenBalanceResult))),
    loadedAddresses: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $8TK0B.optional)((0, $8TK0B.number)())
});
/**
 * @internal
 */ const $0dc579a0cc55ffb4$var$ParsedConfirmedTransactionMetaResult = (0, $8TK0B.type)({
    err: $0dc579a0cc55ffb4$var$TransactionErrorResult,
    fee: (0, $8TK0B.number)(),
    innerInstructions: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)((0, $8TK0B.type)({
        index: (0, $8TK0B.number)(),
        instructions: (0, $8TK0B.array)($0dc579a0cc55ffb4$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $8TK0B.array)((0, $8TK0B.number)()),
    postBalances: (0, $8TK0B.array)((0, $8TK0B.number)()),
    logMessages: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)((0, $8TK0B.string)()))),
    preTokenBalances: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$TokenBalanceResult))),
    postTokenBalances: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$TokenBalanceResult))),
    loadedAddresses: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $8TK0B.optional)((0, $8TK0B.number)())
});
const $0dc579a0cc55ffb4$var$TransactionVersionStruct = (0, $8TK0B.union)([
    (0, $8TK0B.literal)(0),
    (0, $8TK0B.literal)("legacy")
]);
/** @internal */ const $0dc579a0cc55ffb4$var$RewardsResult = (0, $8TK0B.type)({
    pubkey: (0, $8TK0B.string)(),
    lamports: (0, $8TK0B.number)(),
    postBalance: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    rewardType: (0, $8TK0B.nullable)((0, $8TK0B.string)()),
    commission: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $0dc579a0cc55ffb4$var$GetBlockRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    transactions: (0, $8TK0B.array)((0, $8TK0B.type)({
        transaction: $0dc579a0cc55ffb4$var$ConfirmedTransactionResult,
        meta: (0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ConfirmedTransactionMetaResult),
        version: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$TransactionVersionStruct)
    })),
    rewards: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$RewardsResult)),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    blockHeight: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $0dc579a0cc55ffb4$var$GetNoneModeBlockRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    rewards: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$RewardsResult)),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    blockHeight: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $0dc579a0cc55ffb4$var$GetAccountsModeBlockRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    transactions: (0, $8TK0B.array)((0, $8TK0B.type)({
        transaction: $0dc579a0cc55ffb4$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ConfirmedTransactionMetaResult),
        version: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$TransactionVersionStruct)
    })),
    rewards: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$RewardsResult)),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    blockHeight: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $0dc579a0cc55ffb4$var$GetParsedBlockRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    transactions: (0, $8TK0B.array)((0, $8TK0B.type)({
        transaction: $0dc579a0cc55ffb4$var$ParsedConfirmedTransactionResult,
        meta: (0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$TransactionVersionStruct)
    })),
    rewards: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$RewardsResult)),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    blockHeight: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $0dc579a0cc55ffb4$var$GetParsedAccountsModeBlockRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    transactions: (0, $8TK0B.array)((0, $8TK0B.type)({
        transaction: $0dc579a0cc55ffb4$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$TransactionVersionStruct)
    })),
    rewards: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$RewardsResult)),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    blockHeight: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $0dc579a0cc55ffb4$var$GetParsedNoneModeBlockRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    rewards: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$RewardsResult)),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)()),
    blockHeight: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $0dc579a0cc55ffb4$var$GetConfirmedBlockRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    transactions: (0, $8TK0B.array)((0, $8TK0B.type)({
        transaction: $0dc579a0cc55ffb4$var$ConfirmedTransactionResult,
        meta: (0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $8TK0B.optional)((0, $8TK0B.array)($0dc579a0cc55ffb4$var$RewardsResult)),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $0dc579a0cc55ffb4$var$GetBlockSignaturesRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    previousBlockhash: (0, $8TK0B.string)(),
    parentSlot: (0, $8TK0B.number)(),
    signatures: (0, $8TK0B.array)((0, $8TK0B.string)()),
    blockTime: (0, $8TK0B.nullable)((0, $8TK0B.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $0dc579a0cc55ffb4$var$GetTransactionRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    slot: (0, $8TK0B.number)(),
    meta: (0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.number)())),
    transaction: $0dc579a0cc55ffb4$var$ConfirmedTransactionResult,
    version: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $0dc579a0cc55ffb4$var$GetParsedTransactionRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.type)({
    slot: (0, $8TK0B.number)(),
    transaction: $0dc579a0cc55ffb4$var$ParsedConfirmedTransactionResult,
    meta: (0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $8TK0B.optional)((0, $8TK0B.nullable)((0, $8TK0B.number)())),
    version: (0, $8TK0B.optional)($0dc579a0cc55ffb4$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $0dc579a0cc55ffb4$var$GetRecentBlockhashAndContextRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    feeCalculator: (0, $8TK0B.type)({
        lamportsPerSignature: (0, $8TK0B.number)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $0dc579a0cc55ffb4$var$GetLatestBlockhashRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.type)({
    blockhash: (0, $8TK0B.string)(),
    lastValidBlockHeight: (0, $8TK0B.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $0dc579a0cc55ffb4$var$IsBlockhashValidRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.boolean)());
const $0dc579a0cc55ffb4$var$PerfSampleResult = (0, $8TK0B.type)({
    slot: (0, $8TK0B.number)(),
    numTransactions: (0, $8TK0B.number)(),
    numSlots: (0, $8TK0B.number)(),
    samplePeriodSecs: (0, $8TK0B.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $0dc579a0cc55ffb4$var$GetRecentPerformanceSamplesRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)($0dc579a0cc55ffb4$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $0dc579a0cc55ffb4$var$GetFeeCalculatorRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.nullable)((0, $8TK0B.type)({
    feeCalculator: (0, $8TK0B.type)({
        lamportsPerSignature: (0, $8TK0B.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $0dc579a0cc55ffb4$var$RequestAirdropRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $0dc579a0cc55ffb4$var$SendTransactionRpcResult = $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $0dc579a0cc55ffb4$var$LogsResult = (0, $8TK0B.type)({
    err: $0dc579a0cc55ffb4$var$TransactionErrorResult,
    logs: (0, $8TK0B.array)((0, $8TK0B.string)()),
    signature: (0, $8TK0B.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $0dc579a0cc55ffb4$var$LogsNotificationResult = (0, $8TK0B.type)({
    result: $0dc579a0cc55ffb4$var$notificationResultAndContext($0dc579a0cc55ffb4$var$LogsResult),
    subscription: (0, $8TK0B.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $0dc579a0cc55ffb4$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $0dc579a0cc55ffb4$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $0dc579a0cc55ffb4$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.number)()));
                        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $0dc579a0cc55ffb4$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $0dc579a0cc55ffb4$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $0dc579a0cc55ffb4$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $0dc579a0cc55ffb4$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $0dc579a0cc55ffb4$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $0dc579a0cc55ffb4$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.number)()));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.nullable)((0, $8TK0B.number)())));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.number)()));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$SlotRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetSupplyRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext($0dc579a0cc55ffb4$var$TokenAmountResult));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext($0dc579a0cc55ffb4$var$TokenAmountResult));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$AccountInfoResult)));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.array)((0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.array)((0, $8TK0B.nullable)($0dc579a0cc55ffb4$var$AccountInfoResult))));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$StakeActivationResult));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", configWithoutEncoding);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $8TK0B.array)($0dc579a0cc55ffb4$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext(baseSchema)) : (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)($0dc579a0cc55ffb4$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $0dc579a0cc55ffb4$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $0dc579a0cc55ffb4$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $0dc579a0cc55ffb4$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $0dc579a0cc55ffb4$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $0dc579a0cc55ffb4$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $0dc579a0cc55ffb4$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $0dc579a0cc55ffb4$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $0dc579a0cc55ffb4$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $0dc579a0cc55ffb4$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $0dc579a0cc55ffb4$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $0dc579a0cc55ffb4$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $0dc579a0cc55ffb4$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $0dc579a0cc55ffb4$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $0dc579a0cc55ffb4$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $0dc579a0cc55ffb4$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $0dc579a0cc55ffb4$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $0dc579a0cc55ffb4$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $0dc579a0cc55ffb4$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)($0dc579a0cc55ffb4$var$ContactInfoResult)));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetVoteAccounts);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.number)()));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.string)()));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)($0dc579a0cc55ffb4$var$PublicKeyFromString)));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $0dc579a0cc55ffb4$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.number)()));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetInflationRewardResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $0dc579a0cc55ffb4$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getRecentBlockhash", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetRecentBlockhashAndContextRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $0dc579a0cc55ffb4$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.nullable)((0, $8TK0B.number)())));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult($0dc579a0cc55ffb4$var$VersionResult));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.string)()));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $0dc579a0cc55ffb4$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetTransactionRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $0dc579a0cc55ffb4$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetTransactionRpcResult);
            if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $0dc579a0cc55ffb4$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $0dc579a0cc55ffb4$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $0dc579a0cc55ffb4$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResult((0, $8TK0B.array)((0, $8TK0B.number)())));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetTransactionRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $0dc579a0cc55ffb4$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $0dc579a0cc55ffb4$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getConfirmedTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $0dc579a0cc55ffb4$export$5b2310da10e607da({
            key: accountKey,
            state: $0dc579a0cc55ffb4$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $0dc579a0cc55ffb4$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $0dc579a0cc55ffb4$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $0dc579a0cc55ffb4$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $0dc579a0cc55ffb4$var$sleep($0dc579a0cc55ffb4$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $0dc579a0cc55ffb4$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$jsonRpcResultAndContext((0, $8TK0B.number)()));
        if ("error" in res) throw new $0dc579a0cc55ffb4$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $cbQCu.Buffer).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $0dc579a0cc55ffb4$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $0dc579a0cc55ffb4$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $0dc579a0cc55ffb4$export$121e803f723b3045("failed to simulate transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $0dc579a0cc55ffb4$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $8TK0B.create)(unsafeRes, $0dc579a0cc55ffb4$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $0dc579a0cc55ffb4$export$121e803f723b3045("failed to send transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $8TK0B.create)(notification, $0dc579a0cc55ffb4$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $0dc579a0cc55ffb4$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $0dc579a0cc55ffb4$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64");
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $8TK0B.create)(notification, $0dc579a0cc55ffb4$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param id client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $8TK0B.create)(notification, $0dc579a0cc55ffb4$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $8TK0B.create)(notification, $0dc579a0cc55ffb4$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $8TK0B.create)(notification, $0dc579a0cc55ffb4$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $8TK0B.create)(notification, $0dc579a0cc55ffb4$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $8TK0B.create)(notification, $0dc579a0cc55ffb4$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param id client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $0dc579a0cc55ffb4$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $0dc579a0cc55ffb4$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $0dc579a0cc55ffb4$export$c53bca448cf33676($0dc579a0cc55ffb4$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $0dc579a0cc55ffb4$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $0dc579a0cc55ffb4$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $0dc579a0cc55ffb4$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $0dc579a0cc55ffb4$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $0dc579a0cc55ffb4$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$u64("recentSlot"),
            $ivDjT.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$u64(),
            $ivDjT.seq($0dc579a0cc55ffb4$var$publicKey(), $ivDjT.offset($ivDjT.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    }
});
class $0dc579a0cc55ffb4$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ivDjT.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($0dc579a0cc55ffb4$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($0dc579a0cc55ffb4$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $0dc579a0cc55ffb4$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $0dc579a0cc55ffb4$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $bpv1j.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $0dc579a0cc55ffb4$export$7d102200c3a357d6.CreateLookupTable;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $0dc579a0cc55ffb4$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $0dc579a0cc55ffb4$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $0dc579a0cc55ffb4$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $0dc579a0cc55ffb4$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $0dc579a0cc55ffb4$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $0dc579a0cc55ffb4$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $0dc579a0cc55ffb4$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $0dc579a0cc55ffb4$export$7d102200c3a357d6.CloseLookupTable;
        const data = $0dc579a0cc55ffb4$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$0dc579a0cc55ffb4$export$5147a345798de168.programId = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $0dc579a0cc55ffb4$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ivDjT.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($0dc579a0cc55ffb4$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($0dc579a0cc55ffb4$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $0dc579a0cc55ffb4$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $ivDjT.struct([
            $ivDjT.u8("instruction"),
            $ivDjT.u32("units"),
            $ivDjT.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $ivDjT.struct([
            $ivDjT.u8("instruction"),
            $ivDjT.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $ivDjT.struct([
            $ivDjT.u8("instruction"),
            $ivDjT.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $ivDjT.struct([
            $ivDjT.u8("instruction"),
            $0dc579a0cc55ffb4$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $0dc579a0cc55ffb4$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $0dc579a0cc55ffb4$export$b7c79c50764da3d6.RequestUnits;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, params);
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $0dc579a0cc55ffb4$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, params);
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $0dc579a0cc55ffb4$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, params);
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $0dc579a0cc55ffb4$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$0dc579a0cc55ffb4$export$11585db5942bcdb7.programId = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $0dc579a0cc55ffb4$var$PRIVATE_KEY_BYTES$1 = 64;
const $0dc579a0cc55ffb4$var$PUBLIC_KEY_BYTES$1 = 32;
const $0dc579a0cc55ffb4$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $0dc579a0cc55ffb4$var$ED25519_INSTRUCTION_LAYOUT = $ivDjT.struct([
    $ivDjT.u8("numSignatures"),
    $ivDjT.u8("padding"),
    $ivDjT.u16("signatureOffset"),
    $ivDjT.u16("signatureInstructionIndex"),
    $ivDjT.u16("publicKeyOffset"),
    $ivDjT.u16("publicKeyInstructionIndex"),
    $ivDjT.u16("messageDataOffset"),
    $ivDjT.u16("messageDataSize"),
    $ivDjT.u16("messageInstructionIndex")
]);
class $0dc579a0cc55ffb4$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $0dc579a0cc55ffb4$var$assert(publicKey.length === $0dc579a0cc55ffb4$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$0dc579a0cc55ffb4$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $0dc579a0cc55ffb4$var$assert(signature.length === $0dc579a0cc55ffb4$var$SIGNATURE_BYTES, `Signature must be ${$0dc579a0cc55ffb4$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $0dc579a0cc55ffb4$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $cbQCu.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $0dc579a0cc55ffb4$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $0dc579a0cc55ffb4$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $0dc579a0cc55ffb4$var$assert(privateKey.length === $0dc579a0cc55ffb4$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$0dc579a0cc55ffb4$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $0dc579a0cc55ffb4$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $0dc579a0cc55ffb4$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$0dc579a0cc55ffb4$export$e5087aea02631e.programId = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $0dc579a0cc55ffb4$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $386SJ.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $386SJ.secp256k1).utils.isValidPrivateKey;
const $0dc579a0cc55ffb4$var$publicKeyCreate = (0, $386SJ.secp256k1).getPublicKey;
const $0dc579a0cc55ffb4$var$PRIVATE_KEY_BYTES = 32;
const $0dc579a0cc55ffb4$var$ETHEREUM_ADDRESS_BYTES = 20;
const $0dc579a0cc55ffb4$var$PUBLIC_KEY_BYTES = 64;
const $0dc579a0cc55ffb4$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $0dc579a0cc55ffb4$var$SECP256K1_INSTRUCTION_LAYOUT = $ivDjT.struct([
    $ivDjT.u8("numSignatures"),
    $ivDjT.u16("signatureOffset"),
    $ivDjT.u8("signatureInstructionIndex"),
    $ivDjT.u16("ethAddressOffset"),
    $ivDjT.u8("ethAddressInstructionIndex"),
    $ivDjT.u16("messageDataOffset"),
    $ivDjT.u16("messageDataSize"),
    $ivDjT.u8("messageInstructionIndex"),
    $ivDjT.blob(20, "ethAddress"),
    $ivDjT.blob(64, "signature"),
    $ivDjT.u8("recoveryId")
]);
class $0dc579a0cc55ffb4$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $0dc579a0cc55ffb4$var$assert(publicKey.length === $0dc579a0cc55ffb4$var$PUBLIC_KEY_BYTES, `Public key must be ${$0dc579a0cc55ffb4$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $cbQCu.Buffer).from((0, $2dinB.keccak_256)($0dc579a0cc55ffb4$var$toBuffer(publicKey))).slice(-$0dc579a0cc55ffb4$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $0dc579a0cc55ffb4$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $0dc579a0cc55ffb4$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $cbQCu.Buffer).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $cbQCu.Buffer).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $0dc579a0cc55ffb4$var$assert(ethAddress.length === $0dc579a0cc55ffb4$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$0dc579a0cc55ffb4$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $0dc579a0cc55ffb4$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $cbQCu.Buffer).alloc($0dc579a0cc55ffb4$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $0dc579a0cc55ffb4$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $0dc579a0cc55ffb4$var$toBuffer(signature),
            ethAddress: $0dc579a0cc55ffb4$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($0dc579a0cc55ffb4$var$toBuffer(message), $0dc579a0cc55ffb4$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $0dc579a0cc55ffb4$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $0dc579a0cc55ffb4$var$assert(pkey.length === $0dc579a0cc55ffb4$var$PRIVATE_KEY_BYTES, `Private key must be ${$0dc579a0cc55ffb4$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $0dc579a0cc55ffb4$var$toBuffer(pkey);
            const publicKey = $0dc579a0cc55ffb4$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $cbQCu.Buffer).from((0, $2dinB.keccak_256)($0dc579a0cc55ffb4$var$toBuffer(message)));
            const [signature, recoveryId] = $0dc579a0cc55ffb4$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$0dc579a0cc55ffb4$export$d85dd4c1161d13c9.programId = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $0dc579a0cc55ffb4$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $0dc579a0cc55ffb4$export$18aac71979bdd08f = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $0dc579a0cc55ffb4$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $0dc579a0cc55ffb4$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$0dc579a0cc55ffb4$var$_class2 = $0dc579a0cc55ffb4$export$e7f3941ade35598c;
$0dc579a0cc55ffb4$export$e7f3941ade35598c.default = new $0dc579a0cc55ffb4$var$_class2(0, 0, $0dc579a0cc55ffb4$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $0dc579a0cc55ffb4$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ivDjT.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($0dc579a0cc55ffb4$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $0dc579a0cc55ffb4$export$9ac74ae66932a145(new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(authorized.staker), new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $0dc579a0cc55ffb4$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($0dc579a0cc55ffb4$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $0dc579a0cc55ffb4$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$authorized(),
            $0dc579a0cc55ffb4$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("newAuthorized"),
            $ivDjT.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $ivDjT.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $ivDjT.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("newAuthorized"),
            $ivDjT.u32("stakeAuthorizationType"),
            $0dc579a0cc55ffb4$var$rustString("authoritySeed"),
            $0dc579a0cc55ffb4$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $0dc579a0cc55ffb4$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $0dc579a0cc55ffb4$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $0dc579a0cc55ffb4$export$e7f3941ade35598c.default;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Initialize;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            authorized: {
                staker: $0dc579a0cc55ffb4$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $0dc579a0cc55ffb4$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $0dc579a0cc55ffb4$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
        transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
        transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Delegate;
        const data = $0dc579a0cc55ffb4$var$encodeData(type);
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Authorize;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            newAuthorized: $0dc579a0cc55ffb4$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            newAuthorized: $0dc579a0cc55ffb4$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $0dc579a0cc55ffb4$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Split;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            lamports: lamports
        });
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params) {
        const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
        transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: 0,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
        transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Merge;
        const data = $0dc579a0cc55ffb4$var$encodeData(type);
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Withdraw;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $0dc579a0cc55ffb4$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $0dc579a0cc55ffb4$export$c89793bd2bba8b2e.Deactivate;
        const data = $0dc579a0cc55ffb4$var$encodeData(type);
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$0dc579a0cc55ffb4$export$df86f933e9f8fb15.programId = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeState::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeState.html
 */ $0dc579a0cc55ffb4$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $0dc579a0cc55ffb4$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Vote Instruction class
 */ class $0dc579a0cc55ffb4$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ivDjT.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $0dc579a0cc55ffb4$export$3f9d1b16ff840d7(new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $0dc579a0cc55ffb4$var$decodeData$1($0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($0dc579a0cc55ffb4$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$publicKey("newAuthorized"),
            $ivDjT.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $ivDjT.ns64("lamports")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $ivDjT.struct([
            $ivDjT.u32("instruction"),
            $0dc579a0cc55ffb4$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $0dc579a0cc55ffb4$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $0dc579a0cc55ffb4$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            voteInit: {
                nodePubkey: $0dc579a0cc55ffb4$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $0dc579a0cc55ffb4$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $0dc579a0cc55ffb4$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $0dc579a0cc55ffb4$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $0dc579a0cc55ffb4$export$febc5573c75cefb0();
        transaction.add($0dc579a0cc55ffb4$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            newAuthorized: $0dc579a0cc55ffb4$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $0dc579a0cc55ffb4$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $0dc579a0cc55ffb4$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $0dc579a0cc55ffb4$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $0dc579a0cc55ffb4$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $0dc579a0cc55ffb4$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $0dc579a0cc55ffb4$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insuffcient funds.");
        return $0dc579a0cc55ffb4$export$83db2bc702bee1eb.withdraw(params);
    }
}
$0dc579a0cc55ffb4$export$83db2bc702bee1eb.programId = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $0dc579a0cc55ffb4$export$83db2bc702bee1eb.space = 3731;
const $0dc579a0cc55ffb4$export$afdb09d3afdde87c = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $0dc579a0cc55ffb4$var$InfoString = (0, $8TK0B.type)({
    name: (0, $8TK0B.string)(),
    website: (0, $8TK0B.optional)((0, $8TK0B.string)()),
    details: (0, $8TK0B.optional)((0, $8TK0B.string)()),
    keybaseUsername: (0, $8TK0B.optional)((0, $8TK0B.string)())
});
/**
 * ValidatorInfo class
 */ class $0dc579a0cc55ffb4$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $0dc579a0cc55ffb4$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(byteArray.slice(0, $0dc579a0cc55ffb4$export$84fc0a248cc54343));
            byteArray = byteArray.slice($0dc579a0cc55ffb4$export$84fc0a248cc54343);
            const isSigner = byteArray.slice(0, 1)[0] === 1;
            byteArray = byteArray.slice(1);
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($0dc579a0cc55ffb4$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $0dc579a0cc55ffb4$var$rustString().decode((0, $cbQCu.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $8TK0B.assert)(info, $0dc579a0cc55ffb4$var$InfoString);
                return new $0dc579a0cc55ffb4$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $0dc579a0cc55ffb4$export$90bca02a3aea0768 = new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $0dc579a0cc55ffb4$var$VoteAccountLayout = $ivDjT.struct([
    $0dc579a0cc55ffb4$var$publicKey("nodePubkey"),
    $0dc579a0cc55ffb4$var$publicKey("authorizedWithdrawer"),
    $ivDjT.u8("commission"),
    $ivDjT.nu64(),
    // votes.length
    $ivDjT.seq($ivDjT.struct([
        $ivDjT.nu64("slot"),
        $ivDjT.u32("confirmationCount")
    ]), $ivDjT.offset($ivDjT.u32(), -8), "votes"),
    $ivDjT.u8("rootSlotValid"),
    $ivDjT.nu64("rootSlot"),
    $ivDjT.nu64(),
    // authorizedVoters.length
    $ivDjT.seq($ivDjT.struct([
        $ivDjT.nu64("epoch"),
        $0dc579a0cc55ffb4$var$publicKey("authorizedVoter")
    ]), $ivDjT.offset($ivDjT.u32(), -8), "authorizedVoters"),
    $ivDjT.struct([
        $ivDjT.seq($ivDjT.struct([
            $0dc579a0cc55ffb4$var$publicKey("authorizedPubkey"),
            $ivDjT.nu64("epochOfLastAuthorizedSwitch"),
            $ivDjT.nu64("targetEpoch")
        ]), 32, "buf"),
        $ivDjT.nu64("idx"),
        $ivDjT.u8("isEmpty")
    ], "priorVoters"),
    $ivDjT.nu64(),
    // epochCredits.length
    $ivDjT.seq($ivDjT.struct([
        $ivDjT.nu64("epoch"),
        $ivDjT.nu64("credits"),
        $ivDjT.nu64("prevCredits")
    ]), $ivDjT.offset($ivDjT.u32(), -8), "epochCredits"),
    $ivDjT.struct([
        $ivDjT.nu64("slot"),
        $ivDjT.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $0dc579a0cc55ffb4$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $0dc579a0cc55ffb4$var$VoteAccountLayout.decode($0dc579a0cc55ffb4$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $0dc579a0cc55ffb4$export$89ef186f708d638b({
            nodePubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($0dc579a0cc55ffb4$var$parseAuthorizedVoter),
            priorVoters: $0dc579a0cc55ffb4$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $0dc579a0cc55ffb4$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $0dc579a0cc55ffb4$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $0dc579a0cc55ffb4$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $0dc579a0cc55ffb4$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($0dc579a0cc55ffb4$var$parsePriorVoters),
        ...buf.slice(0, idx).map($0dc579a0cc55ffb4$var$parsePriorVoters)
    ];
}
const $0dc579a0cc55ffb4$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $0dc579a0cc55ffb4$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $0dc579a0cc55ffb4$var$endpoint[key]["devnet"];
    const url = $0dc579a0cc55ffb4$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $0dc579a0cc55ffb4$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $0dc579a0cc55ffb4$export$5f6a2f2669741bbe = 1000000000;

});
parcelRegister("jNKMc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255 = module.exports.RistrettoPoint = module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.edwardsToMontgomeryPriv = module.exports.edwardsToMontgomery = module.exports.edwardsToMontgomeryPub = module.exports.x25519 = module.exports.ed25519ph = module.exports.ed25519ctx = module.exports.ed25519 = module.exports.ED25519_TORSION_SUBGROUP = void 0;

var $hXge2 = parcelRequire("hXge2");

var $bzzBR = parcelRequire("bzzBR");

var $c3BtP = parcelRequire("c3BtP");

var $cmda8 = parcelRequire("cmda8");

var $f6Psy = parcelRequire("f6Psy");

var $bY9yL = parcelRequire("bY9yL");

var $9CBZF = parcelRequire("9CBZF");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $e6a6e0b997d524b6$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $e6a6e0b997d524b6$var$ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $e6a6e0b997d524b6$var$_0n = BigInt(0), $e6a6e0b997d524b6$var$_1n = BigInt(1), $e6a6e0b997d524b6$var$_2n = BigInt(2), $e6a6e0b997d524b6$var$_5n = BigInt(5);
// prettier-ignore
const $e6a6e0b997d524b6$var$_10n = BigInt(10), $e6a6e0b997d524b6$var$_20n = BigInt(20), $e6a6e0b997d524b6$var$_40n = BigInt(40), $e6a6e0b997d524b6$var$_80n = BigInt(80);
function $e6a6e0b997d524b6$var$ed25519_pow_2_252_3(x) {
    const P = $e6a6e0b997d524b6$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $f6Psy.pow2)(b2, $e6a6e0b997d524b6$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $f6Psy.pow2)(b4, $e6a6e0b997d524b6$var$_1n, P) * x % P; // x^31
    const b10 = (0, $f6Psy.pow2)(b5, $e6a6e0b997d524b6$var$_5n, P) * b5 % P;
    const b20 = (0, $f6Psy.pow2)(b10, $e6a6e0b997d524b6$var$_10n, P) * b10 % P;
    const b40 = (0, $f6Psy.pow2)(b20, $e6a6e0b997d524b6$var$_20n, P) * b20 % P;
    const b80 = (0, $f6Psy.pow2)(b40, $e6a6e0b997d524b6$var$_40n, P) * b40 % P;
    const b160 = (0, $f6Psy.pow2)(b80, $e6a6e0b997d524b6$var$_80n, P) * b80 % P;
    const b240 = (0, $f6Psy.pow2)(b160, $e6a6e0b997d524b6$var$_80n, P) * b80 % P;
    const b250 = (0, $f6Psy.pow2)(b240, $e6a6e0b997d524b6$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $f6Psy.pow2)(b250, $e6a6e0b997d524b6$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $e6a6e0b997d524b6$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $e6a6e0b997d524b6$var$uvRatio(u, v) {
    const P = $e6a6e0b997d524b6$var$ED25519_P;
    const v3 = (0, $f6Psy.mod)(v * v * v, P); // v³
    const v7 = (0, $f6Psy.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $e6a6e0b997d524b6$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $f6Psy.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $f6Psy.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $f6Psy.mod)(x * $e6a6e0b997d524b6$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $f6Psy.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $f6Psy.mod)(-u * $e6a6e0b997d524b6$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $f6Psy.isNegativeLE)(x, P)) x = (0, $f6Psy.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
// Just in case
module.exports.ED25519_TORSION_SUBGROUP = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $e6a6e0b997d524b6$var$Fp = (0, $f6Psy.Field)($e6a6e0b997d524b6$var$ED25519_P, undefined, true);
const $e6a6e0b997d524b6$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $e6a6e0b997d524b6$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: $hXge2.sha512,
    randomBytes: $bzzBR.randomBytes,
    adjustScalarBytes: $e6a6e0b997d524b6$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $e6a6e0b997d524b6$var$uvRatio
};
module.exports.ed25519 = (0, $c3BtP.twistedEdwards)($e6a6e0b997d524b6$var$ed25519Defaults);
function $e6a6e0b997d524b6$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $bzzBR.concatBytes)((0, $bzzBR.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
module.exports.ed25519ctx = (0, $c3BtP.twistedEdwards)({
    ...$e6a6e0b997d524b6$var$ed25519Defaults,
    domain: $e6a6e0b997d524b6$var$ed25519_domain
});
module.exports.ed25519ph = (0, $c3BtP.twistedEdwards)({
    ...$e6a6e0b997d524b6$var$ed25519Defaults,
    domain: $e6a6e0b997d524b6$var$ed25519_domain,
    prehash: $hXge2.sha512
});
module.exports.x25519 = (()=>(0, $cmda8.montgomery)({
        P: $e6a6e0b997d524b6$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $e6a6e0b997d524b6$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $e6a6e0b997d524b6$var$ed25519_pow_2_252_3(x);
            return (0, $f6Psy.mod)((0, $f6Psy.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $e6a6e0b997d524b6$var$adjustScalarBytes,
        randomBytes: $bzzBR.randomBytes
    }))();
/**
 * Converts ed25519 public key to x25519 public key. Uses formula:
 * * `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
 * * `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
 * @example
 *   const someonesPub = ed25519.getPublicKey(ed25519.utils.randomPrivateKey());
 *   const aPriv = x25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(aPriv, edwardsToMontgomeryPub(someonesPub))
 */ function $e6a6e0b997d524b6$var$edwardsToMontgomeryPub(edwardsPub) {
    const { y: y } = module.exports.ed25519.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $e6a6e0b997d524b6$var$Fp.toBytes($e6a6e0b997d524b6$var$Fp.create((_1n + y) * $e6a6e0b997d524b6$var$Fp.inv(_1n - y)));
}
module.exports.edwardsToMontgomeryPub = $e6a6e0b997d524b6$var$edwardsToMontgomeryPub;
module.exports.edwardsToMontgomery = $e6a6e0b997d524b6$var$edwardsToMontgomeryPub; // deprecated
/**
 * Converts ed25519 secret key to x25519 secret key.
 * @example
 *   const someonesPub = x25519.getPublicKey(x25519.utils.randomPrivateKey());
 *   const aPriv = ed25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(edwardsToMontgomeryPriv(aPriv), someonesPub)
 */ function $e6a6e0b997d524b6$var$edwardsToMontgomeryPriv(edwardsPriv) {
    const hashed = $e6a6e0b997d524b6$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $e6a6e0b997d524b6$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
module.exports.edwardsToMontgomeryPriv = $e6a6e0b997d524b6$var$edwardsToMontgomeryPriv;
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $e6a6e0b997d524b6$var$ELL2_C1 = ($e6a6e0b997d524b6$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $e6a6e0b997d524b6$var$ELL2_C2 = $e6a6e0b997d524b6$var$Fp.pow($e6a6e0b997d524b6$var$_2n, $e6a6e0b997d524b6$var$ELL2_C1); // 2. c2 = 2^c1
const $e6a6e0b997d524b6$var$ELL2_C3 = $e6a6e0b997d524b6$var$Fp.sqrt($e6a6e0b997d524b6$var$Fp.neg($e6a6e0b997d524b6$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $e6a6e0b997d524b6$var$ELL2_C4 = ($e6a6e0b997d524b6$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $e6a6e0b997d524b6$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $e6a6e0b997d524b6$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $e6a6e0b997d524b6$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $e6a6e0b997d524b6$var$Fp.mul(tv1, $e6a6e0b997d524b6$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $e6a6e0b997d524b6$var$Fp.add(tv1, $e6a6e0b997d524b6$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $e6a6e0b997d524b6$var$Fp.neg($e6a6e0b997d524b6$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $e6a6e0b997d524b6$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $e6a6e0b997d524b6$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $e6a6e0b997d524b6$var$Fp.mul(tv1, $e6a6e0b997d524b6$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $e6a6e0b997d524b6$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $e6a6e0b997d524b6$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $e6a6e0b997d524b6$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $e6a6e0b997d524b6$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $e6a6e0b997d524b6$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $e6a6e0b997d524b6$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $e6a6e0b997d524b6$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $e6a6e0b997d524b6$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $e6a6e0b997d524b6$var$Fp.pow(tv2, $e6a6e0b997d524b6$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $e6a6e0b997d524b6$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $e6a6e0b997d524b6$var$Fp.mul(y11, $e6a6e0b997d524b6$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $e6a6e0b997d524b6$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $e6a6e0b997d524b6$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $e6a6e0b997d524b6$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $e6a6e0b997d524b6$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $e6a6e0b997d524b6$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $e6a6e0b997d524b6$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $e6a6e0b997d524b6$var$Fp.mul(y21, $e6a6e0b997d524b6$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $e6a6e0b997d524b6$var$Fp.mul(y21, $e6a6e0b997d524b6$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $e6a6e0b997d524b6$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $e6a6e0b997d524b6$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $e6a6e0b997d524b6$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $e6a6e0b997d524b6$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $e6a6e0b997d524b6$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $e6a6e0b997d524b6$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $e6a6e0b997d524b6$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $e6a6e0b997d524b6$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $e6a6e0b997d524b6$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $e6a6e0b997d524b6$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $e6a6e0b997d524b6$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $e6a6e0b997d524b6$var$Fp.cmov(y, $e6a6e0b997d524b6$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $e6a6e0b997d524b6$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $e6a6e0b997d524b6$var$ELL2_C1_EDWARDS = (0, $f6Psy.FpSqrtEven)($e6a6e0b997d524b6$var$Fp, $e6a6e0b997d524b6$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $e6a6e0b997d524b6$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $e6a6e0b997d524b6$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $e6a6e0b997d524b6$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $e6a6e0b997d524b6$var$Fp.mul(xn, $e6a6e0b997d524b6$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $e6a6e0b997d524b6$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $e6a6e0b997d524b6$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $e6a6e0b997d524b6$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $e6a6e0b997d524b6$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $e6a6e0b997d524b6$var$Fp.eql(tv1, $e6a6e0b997d524b6$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $e6a6e0b997d524b6$var$Fp.cmov(xn, $e6a6e0b997d524b6$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $e6a6e0b997d524b6$var$Fp.cmov(xd, $e6a6e0b997d524b6$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $e6a6e0b997d524b6$var$Fp.cmov(yn, $e6a6e0b997d524b6$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $e6a6e0b997d524b6$var$Fp.cmov(yd, $e6a6e0b997d524b6$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $e6a6e0b997d524b6$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $e6a6e0b997d524b6$var$Fp.mul(xn, inv[0]),
        y: $e6a6e0b997d524b6$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $e6a6e0b997d524b6$var$htf = /* @__PURE__ */ (()=>(0, $9CBZF.createHasher)(module.exports.ed25519.ExtendedPoint, (scalars)=>$e6a6e0b997d524b6$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $e6a6e0b997d524b6$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $hXge2.sha512
    }))();
module.exports.hashToCurve = (()=>$e6a6e0b997d524b6$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$e6a6e0b997d524b6$var$htf.encodeToCurve)();
function $e6a6e0b997d524b6$var$assertRstPoint(other) {
    if (!(other instanceof $e6a6e0b997d524b6$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $e6a6e0b997d524b6$var$SQRT_M1 = $e6a6e0b997d524b6$var$ED25519_SQRT_M1;
// √(ad - 1)
const $e6a6e0b997d524b6$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $e6a6e0b997d524b6$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $e6a6e0b997d524b6$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $e6a6e0b997d524b6$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $e6a6e0b997d524b6$var$invertSqrt = (number)=>$e6a6e0b997d524b6$var$uvRatio($e6a6e0b997d524b6$var$_1n, number);
const $e6a6e0b997d524b6$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $e6a6e0b997d524b6$var$bytes255ToNumberLE = (bytes)=>module.exports.ed25519.CURVE.Fp.create((0, $bY9yL.bytesToNumberLE)(bytes) & $e6a6e0b997d524b6$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $e6a6e0b997d524b6$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = module.exports.ed25519.CURVE;
    const P = module.exports.ed25519.CURVE.Fp.ORDER;
    const mod = module.exports.ed25519.CURVE.Fp.create;
    const r = mod($e6a6e0b997d524b6$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $e6a6e0b997d524b6$var$_1n) * $e6a6e0b997d524b6$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $e6a6e0b997d524b6$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $f6Psy.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $e6a6e0b997d524b6$var$_1n) * $e6a6e0b997d524b6$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $e6a6e0b997d524b6$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($e6a6e0b997d524b6$var$_1n - s2); // 12
    const W3 = mod($e6a6e0b997d524b6$var$_1n + s2); // 13
    return new module.exports.ed25519.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $e6a6e0b997d524b6$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $e6a6e0b997d524b6$var$RistPoint(module.exports.ed25519.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $bY9yL.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $e6a6e0b997d524b6$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $e6a6e0b997d524b6$var$calcElligatorRistrettoMap(r1);
        const r2 = $e6a6e0b997d524b6$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $e6a6e0b997d524b6$var$calcElligatorRistrettoMap(r2);
        return new $e6a6e0b997d524b6$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $bY9yL.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = module.exports.ed25519.CURVE;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $e6a6e0b997d524b6$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $bY9yL.equalBytes)((0, $bY9yL.numberToBytesLE)(s, 32), hex) || (0, $f6Psy.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($e6a6e0b997d524b6$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($e6a6e0b997d524b6$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $e6a6e0b997d524b6$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $f6Psy.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $f6Psy.isNegativeLE)(t, P) || y === $e6a6e0b997d524b6$var$_0n) throw new Error(emsg);
        return new $e6a6e0b997d524b6$var$RistPoint(new module.exports.ed25519.ExtendedPoint(x, y, $e6a6e0b997d524b6$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $e6a6e0b997d524b6$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $f6Psy.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $e6a6e0b997d524b6$var$SQRT_M1);
            let _y = mod(x * $e6a6e0b997d524b6$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $e6a6e0b997d524b6$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $f6Psy.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $f6Psy.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $bY9yL.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $bY9yL.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $e6a6e0b997d524b6$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $e6a6e0b997d524b6$var$assertRstPoint(other);
        return new $e6a6e0b997d524b6$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $e6a6e0b997d524b6$var$assertRstPoint(other);
        return new $e6a6e0b997d524b6$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $e6a6e0b997d524b6$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $e6a6e0b997d524b6$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $e6a6e0b997d524b6$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $e6a6e0b997d524b6$var$RistPoint(this.ep.negate());
    }
}
module.exports.RistrettoPoint = (()=>{
    if (!$e6a6e0b997d524b6$var$RistPoint.BASE) $e6a6e0b997d524b6$var$RistPoint.BASE = new $e6a6e0b997d524b6$var$RistPoint(module.exports.ed25519.ExtendedPoint.BASE);
    if (!$e6a6e0b997d524b6$var$RistPoint.ZERO) $e6a6e0b997d524b6$var$RistPoint.ZERO = new $e6a6e0b997d524b6$var$RistPoint(module.exports.ed25519.ExtendedPoint.ZERO);
    return $e6a6e0b997d524b6$var$RistPoint;
})();
// Hashing to ristretto255. https://www.rfc-editor.org/rfc/rfc9380#appendix-B
const $e6a6e0b997d524b6$var$hashToRistretto255 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $bzzBR.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $9CBZF.expand_message_xmd)(msg, DST, 64, $hXge2.sha512);
    const P = $e6a6e0b997d524b6$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
module.exports.hashToRistretto255 = $e6a6e0b997d524b6$var$hashToRistretto255;
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255; // legacy

});
parcelRegister("hXge2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $9X7A7 = parcelRequire("9X7A7");

var $5ypm0 = parcelRequire("5ypm0");

var $bzzBR = parcelRequire("bzzBR");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$d1248866b60d4a38$var$SHA512_Kh, $d1248866b60d4a38$var$SHA512_Kl] = /* @__PURE__ */ (()=>$5ypm0.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $d1248866b60d4a38$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $d1248866b60d4a38$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $d1248866b60d4a38$var$SHA512 extends $9X7A7.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $d1248866b60d4a38$var$SHA512_W_H[i] = view.getUint32(offset);
            $d1248866b60d4a38$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $d1248866b60d4a38$var$SHA512_W_H[i - 15] | 0;
            const W15l = $d1248866b60d4a38$var$SHA512_W_L[i - 15] | 0;
            const s0h = $5ypm0.default.rotrSH(W15h, W15l, 1) ^ $5ypm0.default.rotrSH(W15h, W15l, 8) ^ $5ypm0.default.shrSH(W15h, W15l, 7);
            const s0l = $5ypm0.default.rotrSL(W15h, W15l, 1) ^ $5ypm0.default.rotrSL(W15h, W15l, 8) ^ $5ypm0.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $d1248866b60d4a38$var$SHA512_W_H[i - 2] | 0;
            const W2l = $d1248866b60d4a38$var$SHA512_W_L[i - 2] | 0;
            const s1h = $5ypm0.default.rotrSH(W2h, W2l, 19) ^ $5ypm0.default.rotrBH(W2h, W2l, 61) ^ $5ypm0.default.shrSH(W2h, W2l, 6);
            const s1l = $5ypm0.default.rotrSL(W2h, W2l, 19) ^ $5ypm0.default.rotrBL(W2h, W2l, 61) ^ $5ypm0.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $5ypm0.default.add4L(s0l, s1l, $d1248866b60d4a38$var$SHA512_W_L[i - 7], $d1248866b60d4a38$var$SHA512_W_L[i - 16]);
            const SUMh = $5ypm0.default.add4H(SUMl, s0h, s1h, $d1248866b60d4a38$var$SHA512_W_H[i - 7], $d1248866b60d4a38$var$SHA512_W_H[i - 16]);
            $d1248866b60d4a38$var$SHA512_W_H[i] = SUMh | 0;
            $d1248866b60d4a38$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $5ypm0.default.rotrSH(Eh, El, 14) ^ $5ypm0.default.rotrSH(Eh, El, 18) ^ $5ypm0.default.rotrBH(Eh, El, 41);
            const sigma1l = $5ypm0.default.rotrSL(Eh, El, 14) ^ $5ypm0.default.rotrSL(Eh, El, 18) ^ $5ypm0.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $5ypm0.default.add5L(Hl, sigma1l, CHIl, $d1248866b60d4a38$var$SHA512_Kl[i], $d1248866b60d4a38$var$SHA512_W_L[i]);
            const T1h = $5ypm0.default.add5H(T1ll, Hh, sigma1h, CHIh, $d1248866b60d4a38$var$SHA512_Kh[i], $d1248866b60d4a38$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $5ypm0.default.rotrSH(Ah, Al, 28) ^ $5ypm0.default.rotrBH(Ah, Al, 34) ^ $5ypm0.default.rotrBH(Ah, Al, 39);
            const sigma0l = $5ypm0.default.rotrSL(Ah, Al, 28) ^ $5ypm0.default.rotrBL(Ah, Al, 34) ^ $5ypm0.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $5ypm0.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $5ypm0.default.add3L(T1l, sigma0l, MAJl);
            Ah = $5ypm0.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $5ypm0.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $5ypm0.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $5ypm0.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $5ypm0.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $5ypm0.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $5ypm0.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $5ypm0.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $5ypm0.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $d1248866b60d4a38$var$SHA512_W_H.fill(0);
        $d1248866b60d4a38$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $d1248866b60d4a38$var$SHA512;
class $d1248866b60d4a38$var$SHA512_224 extends $d1248866b60d4a38$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $d1248866b60d4a38$var$SHA512_256 extends $d1248866b60d4a38$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $d1248866b60d4a38$var$SHA384 extends $d1248866b60d4a38$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $bzzBR.wrapConstructor)(()=>new $d1248866b60d4a38$var$SHA512());
module.exports.sha512_224 = (0, $bzzBR.wrapConstructor)(()=>new $d1248866b60d4a38$var$SHA512_224());
module.exports.sha512_256 = (0, $bzzBR.wrapConstructor)(()=>new $d1248866b60d4a38$var$SHA512_256());
module.exports.sha384 = (0, $bzzBR.wrapConstructor)(()=>new $d1248866b60d4a38$var$SHA384());

});
parcelRegister("9X7A7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $9Wm5b = parcelRequire("9Wm5b");

var $bzzBR = parcelRequire("bzzBR");
// Polyfill for Safari 14
function $73ef81443b384cd6$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $73ef81443b384cd6$var$SHA2 extends $bzzBR.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $bzzBR.createView)(this.buffer);
    }
    update(data) {
        (0, $9Wm5b.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $bzzBR.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $bzzBR.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $9Wm5b.exists)(this);
        (0, $9Wm5b.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $73ef81443b384cd6$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $bzzBR.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $73ef81443b384cd6$var$SHA2;

});
parcelRegister("9Wm5b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $73caa8fa68faa683$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $73caa8fa68faa683$var$number;
function $73caa8fa68faa683$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $73caa8fa68faa683$var$bool;
// copied from utils
function $73caa8fa68faa683$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $73caa8fa68faa683$var$bytes(b, ...lengths) {
    if (!$73caa8fa68faa683$var$isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $73caa8fa68faa683$var$bytes;
function $73caa8fa68faa683$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $73caa8fa68faa683$var$number(hash.outputLen);
    $73caa8fa68faa683$var$number(hash.blockLen);
}
module.exports.hash = $73caa8fa68faa683$var$hash;
function $73caa8fa68faa683$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $73caa8fa68faa683$var$exists;
function $73caa8fa68faa683$var$output(out, instance) {
    $73caa8fa68faa683$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $73caa8fa68faa683$var$output;
const $73caa8fa68faa683$var$assert = {
    number: $73caa8fa68faa683$var$number,
    bool: $73caa8fa68faa683$var$bool,
    bytes: $73caa8fa68faa683$var$bytes,
    hash: $73caa8fa68faa683$var$hash,
    exists: $73caa8fa68faa683$var$exists,
    output: $73caa8fa68faa683$var$output
};
module.exports.default = $73caa8fa68faa683$var$assert;

});

parcelRegister("bzzBR", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $216PF = parcelRequire("216PF");
// Cast array to different type
const $86ce95f3bc8b7bfb$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $86ce95f3bc8b7bfb$var$u8;
const $86ce95f3bc8b7bfb$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $86ce95f3bc8b7bfb$var$u32;
function $86ce95f3bc8b7bfb$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to view
const $86ce95f3bc8b7bfb$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $86ce95f3bc8b7bfb$var$createView;
// The rotate right (circular right shift) operation for uint32
const $86ce95f3bc8b7bfb$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $86ce95f3bc8b7bfb$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $86ce95f3bc8b7bfb$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $86ce95f3bc8b7bfb$var$bytesToHex(bytes) {
    if (!$86ce95f3bc8b7bfb$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $86ce95f3bc8b7bfb$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $86ce95f3bc8b7bfb$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $86ce95f3bc8b7bfb$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $86ce95f3bc8b7bfb$var$asciiToBase16(char) {
    if (char >= $86ce95f3bc8b7bfb$var$asciis._0 && char <= $86ce95f3bc8b7bfb$var$asciis._9) return char - $86ce95f3bc8b7bfb$var$asciis._0;
    if (char >= $86ce95f3bc8b7bfb$var$asciis._A && char <= $86ce95f3bc8b7bfb$var$asciis._F) return char - ($86ce95f3bc8b7bfb$var$asciis._A - 10);
    if (char >= $86ce95f3bc8b7bfb$var$asciis._a && char <= $86ce95f3bc8b7bfb$var$asciis._f) return char - ($86ce95f3bc8b7bfb$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $86ce95f3bc8b7bfb$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $86ce95f3bc8b7bfb$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $86ce95f3bc8b7bfb$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $86ce95f3bc8b7bfb$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $86ce95f3bc8b7bfb$var$nextTick = async ()=>{};
module.exports.nextTick = $86ce95f3bc8b7bfb$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $86ce95f3bc8b7bfb$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $86ce95f3bc8b7bfb$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $86ce95f3bc8b7bfb$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $86ce95f3bc8b7bfb$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $86ce95f3bc8b7bfb$var$toBytes(data) {
    if (typeof data === "string") data = $86ce95f3bc8b7bfb$var$utf8ToBytes(data);
    if (!$86ce95f3bc8b7bfb$var$isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $86ce95f3bc8b7bfb$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $86ce95f3bc8b7bfb$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$86ce95f3bc8b7bfb$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $86ce95f3bc8b7bfb$var$concatBytes;
// For runtime check if class implements interface
class $86ce95f3bc8b7bfb$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $86ce95f3bc8b7bfb$var$Hash;
const $86ce95f3bc8b7bfb$var$toStr = {}.toString;
function $86ce95f3bc8b7bfb$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $86ce95f3bc8b7bfb$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $86ce95f3bc8b7bfb$var$checkOpts;
function $86ce95f3bc8b7bfb$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($86ce95f3bc8b7bfb$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $86ce95f3bc8b7bfb$var$wrapConstructor;
function $86ce95f3bc8b7bfb$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($86ce95f3bc8b7bfb$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $86ce95f3bc8b7bfb$var$wrapConstructorWithOpts;
function $86ce95f3bc8b7bfb$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($86ce95f3bc8b7bfb$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $86ce95f3bc8b7bfb$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $86ce95f3bc8b7bfb$var$randomBytes(bytesLength = 32) {
    if ($216PF.crypto && typeof $216PF.crypto.getRandomValues === "function") return $216PF.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $86ce95f3bc8b7bfb$var$randomBytes;

});
parcelRegister("216PF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("5ypm0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $40b3cb82b4222f08$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $40b3cb82b4222f08$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $40b3cb82b4222f08$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $40b3cb82b4222f08$var$U32_MASK64),
        l: Number(n >> $40b3cb82b4222f08$var$_32n & $40b3cb82b4222f08$var$U32_MASK64)
    };
    return {
        h: Number(n >> $40b3cb82b4222f08$var$_32n & $40b3cb82b4222f08$var$U32_MASK64) | 0,
        l: Number(n & $40b3cb82b4222f08$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $40b3cb82b4222f08$var$fromBig;
function $40b3cb82b4222f08$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $40b3cb82b4222f08$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $40b3cb82b4222f08$var$split;
const $40b3cb82b4222f08$var$toBig = (h, l)=>BigInt(h >>> 0) << $40b3cb82b4222f08$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $40b3cb82b4222f08$var$toBig;
// for Shift in [0, 32)
const $40b3cb82b4222f08$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $40b3cb82b4222f08$var$shrSH;
const $40b3cb82b4222f08$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $40b3cb82b4222f08$var$shrSL;
// Right rotate for Shift in [1, 32)
const $40b3cb82b4222f08$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $40b3cb82b4222f08$var$rotrSH;
const $40b3cb82b4222f08$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $40b3cb82b4222f08$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $40b3cb82b4222f08$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $40b3cb82b4222f08$var$rotrBH;
const $40b3cb82b4222f08$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $40b3cb82b4222f08$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $40b3cb82b4222f08$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $40b3cb82b4222f08$var$rotr32H;
const $40b3cb82b4222f08$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $40b3cb82b4222f08$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $40b3cb82b4222f08$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $40b3cb82b4222f08$var$rotlSH;
const $40b3cb82b4222f08$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $40b3cb82b4222f08$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $40b3cb82b4222f08$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $40b3cb82b4222f08$var$rotlBH;
const $40b3cb82b4222f08$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $40b3cb82b4222f08$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $40b3cb82b4222f08$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $40b3cb82b4222f08$var$add;
// Addition with more than 2 elements
const $40b3cb82b4222f08$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $40b3cb82b4222f08$var$add3L;
const $40b3cb82b4222f08$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $40b3cb82b4222f08$var$add3H;
const $40b3cb82b4222f08$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $40b3cb82b4222f08$var$add4L;
const $40b3cb82b4222f08$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $40b3cb82b4222f08$var$add4H;
const $40b3cb82b4222f08$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $40b3cb82b4222f08$var$add5L;
const $40b3cb82b4222f08$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $40b3cb82b4222f08$var$add5H;
// prettier-ignore
const $40b3cb82b4222f08$var$u64 = {
    fromBig: $40b3cb82b4222f08$var$fromBig,
    split: $40b3cb82b4222f08$var$split,
    toBig: $40b3cb82b4222f08$var$toBig,
    shrSH: $40b3cb82b4222f08$var$shrSH,
    shrSL: $40b3cb82b4222f08$var$shrSL,
    rotrSH: $40b3cb82b4222f08$var$rotrSH,
    rotrSL: $40b3cb82b4222f08$var$rotrSL,
    rotrBH: $40b3cb82b4222f08$var$rotrBH,
    rotrBL: $40b3cb82b4222f08$var$rotrBL,
    rotr32H: $40b3cb82b4222f08$var$rotr32H,
    rotr32L: $40b3cb82b4222f08$var$rotr32L,
    rotlSH: $40b3cb82b4222f08$var$rotlSH,
    rotlSL: $40b3cb82b4222f08$var$rotlSL,
    rotlBH: $40b3cb82b4222f08$var$rotlBH,
    rotlBL: $40b3cb82b4222f08$var$rotlBL,
    add: $40b3cb82b4222f08$var$add,
    add3L: $40b3cb82b4222f08$var$add3L,
    add3H: $40b3cb82b4222f08$var$add3H,
    add4L: $40b3cb82b4222f08$var$add4L,
    add4H: $40b3cb82b4222f08$var$add4H,
    add5H: $40b3cb82b4222f08$var$add5H,
    add5L: $40b3cb82b4222f08$var$add5L
};
module.exports.default = $40b3cb82b4222f08$var$u64;

});


parcelRegister("c3BtP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.twistedEdwards = void 0;

var $f6Psy = parcelRequire("f6Psy");

var $bY9yL = parcelRequire("bY9yL");

var $bY9yL = parcelRequire("bY9yL");

var $bEub4 = parcelRequire("bEub4");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $8c72d6a2cb7b7da3$var$_0n = BigInt(0), $8c72d6a2cb7b7da3$var$_1n = BigInt(1), $8c72d6a2cb7b7da3$var$_2n = BigInt(2), $8c72d6a2cb7b7da3$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $8c72d6a2cb7b7da3$var$VERIFY_DEFAULT = {
    zip215: true
};
function $8c72d6a2cb7b7da3$var$validateOpts(curve) {
    const opts = (0, $bEub4.validateBasic)(curve);
    $bY9yL.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
// It is not generic twisted curve for now, but ed25519/ed448 generic implementation
function $8c72d6a2cb7b7da3$var$twistedEdwards(curveDef) {
    const CURVE = $8c72d6a2cb7b7da3$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $8c72d6a2cb7b7da3$var$_2n << BigInt(nByteLength * 8) - $8c72d6a2cb7b7da3$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $8c72d6a2cb7b7da3$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === "bigint" && $8c72d6a2cb7b7da3$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $8c72d6a2cb7b7da3$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $8c72d6a2cb7b7da3$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
            return new Point(x, y, $8c72d6a2cb7b7da3$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error("bad point: equation left != right (1)");
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($8c72d6a2cb7b7da3$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $8c72d6a2cb7b7da3$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $8c72d6a2cb7b7da3$var$_2n * T2);
                const D = modP(T1 * $8c72d6a2cb7b7da3$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $8c72d6a2cb7b7da3$var$_0n) return I;
            if (this.equals(I) || n === $8c72d6a2cb7b7da3$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $8c72d6a2cb7b7da3$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $8c72d6a2cb7b7da3$var$_0n,
                y: $8c72d6a2cb7b7da3$var$_1n
            };
            if (zz !== $8c72d6a2cb7b7da3$var$_1n) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $8c72d6a2cb7b7da3$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $bY9yL.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $bY9yL.bytesToNumberLE(normed);
            if (y === $8c72d6a2cb7b7da3$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $8c72d6a2cb7b7da3$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $8c72d6a2cb7b7da3$var$_1n) === $8c72d6a2cb7b7da3$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $8c72d6a2cb7b7da3$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $bY9yL.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $8c72d6a2cb7b7da3$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $bY9yL.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $8c72d6a2cb7b7da3$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($8c72d6a2cb7b7da3$var$_0n, $8c72d6a2cb7b7da3$var$_1n, $8c72d6a2cb7b7da3$var$_1n, $8c72d6a2cb7b7da3$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $bEub4.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $f6Psy.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($bY9yL.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $bY9yL.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $bY9yL.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $bY9yL.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $bY9yL.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $bY9yL.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $bY9yL.concatBytes(R, $bY9yL.numberToBytesLE(s, Fp.BYTES));
        return (0, $bY9yL.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $8c72d6a2cb7b7da3$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $bY9yL.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $bY9yL.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $bY9yL.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}
module.exports.twistedEdwards = $8c72d6a2cb7b7da3$var$twistedEdwards;

});

parcelRegister("cmda8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.montgomery = void 0;

var $f6Psy = parcelRequire("f6Psy");

var $bY9yL = parcelRequire("bY9yL");
const $8ff1bfe7b059cd97$var$_0n = BigInt(0);
const $8ff1bfe7b059cd97$var$_1n = BigInt(1);
function $8ff1bfe7b059cd97$var$validateOpts(curve) {
    (0, $bY9yL.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
// NOTE: not really montgomery curve, just bunch of very specific methods for X25519/X448 (RFC 7748, https://www.rfc-editor.org/rfc/rfc7748)
// Uses only one coordinate instead of two
function $8ff1bfe7b059cd97$var$montgomery(curveDef) {
    const CURVE = $8ff1bfe7b059cd97$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $f6Psy.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $f6Psy.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === "bigint" && $8ff1bfe7b059cd97$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $8ff1bfe7b059cd97$var$_1n;
        let z_2 = $8ff1bfe7b059cd97$var$_0n;
        let x_3 = u;
        let z_3 = $8ff1bfe7b059cd97$var$_1n;
        let swap = $8ff1bfe7b059cd97$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $8ff1bfe7b059cd97$var$_0n; t--){
            const k_t = k >> t & $8ff1bfe7b059cd97$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $bY9yL.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        const u = (0, $bY9yL.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $bY9yL.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $bY9yL.ensureBytes)("scalar", n);
        const len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${len}`);
        return (0, $bY9yL.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $8ff1bfe7b059cd97$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}
module.exports.montgomery = $8ff1bfe7b059cd97$var$montgomery;

});

parcelRegister("9CBZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createHasher = module.exports.isogenyMap = module.exports.hash_to_field = module.exports.expand_message_xof = module.exports.expand_message_xmd = void 0;

var $f6Psy = parcelRequire("f6Psy");

var $bY9yL = parcelRequire("bY9yL");
function $70152264fee72ac7$var$validateDST(dst) {
    if ((0, $bY9yL.isBytes)(dst)) return dst;
    if (typeof dst === "string") return (0, $bY9yL.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $70152264fee72ac7$var$os2ip = $bY9yL.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $70152264fee72ac7$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $70152264fee72ac7$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $70152264fee72ac7$var$abytes(item) {
    if (!(0, $bY9yL.isBytes)(item)) throw new Error("Uint8Array expected");
}
function $70152264fee72ac7$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $70152264fee72ac7$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $70152264fee72ac7$var$abytes(msg);
    $70152264fee72ac7$var$abytes(DST);
    $70152264fee72ac7$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $bY9yL.concatBytes)((0, $bY9yL.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $bY9yL.concatBytes)(DST, $70152264fee72ac7$var$i2osp(DST.length, 1));
    const Z_pad = $70152264fee72ac7$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $70152264fee72ac7$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $bY9yL.concatBytes)(Z_pad, msg, l_i_b_str, $70152264fee72ac7$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $bY9yL.concatBytes)(b_0, $70152264fee72ac7$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $70152264fee72ac7$var$strxor(b_0, b[i - 1]),
            $70152264fee72ac7$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $bY9yL.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $bY9yL.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
module.exports.expand_message_xmd = $70152264fee72ac7$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $70152264fee72ac7$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $70152264fee72ac7$var$abytes(msg);
    $70152264fee72ac7$var$abytes(DST);
    $70152264fee72ac7$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $bY9yL.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($70152264fee72ac7$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($70152264fee72ac7$var$i2osp(DST.length, 1)).digest();
}
module.exports.expand_message_xof = $70152264fee72ac7$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $70152264fee72ac7$var$hash_to_field(msg, count, options) {
    (0, $bY9yL.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $70152264fee72ac7$var$abytes(msg);
    $70152264fee72ac7$var$isNum(count);
    const DST = $70152264fee72ac7$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $70152264fee72ac7$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $70152264fee72ac7$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $f6Psy.mod)($70152264fee72ac7$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
module.exports.hash_to_field = $70152264fee72ac7$var$hash_to_field;
function $70152264fee72ac7$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
module.exports.isogenyMap = $70152264fee72ac7$var$isogenyMap;
function $70152264fee72ac7$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $70152264fee72ac7$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $70152264fee72ac7$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
module.exports.createHasher = $70152264fee72ac7$var$createHasher;

});


parcelRegister("9XCBn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $9X7A7 = parcelRequire("9X7A7");

var $bzzBR = parcelRequire("bzzBR");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $740791417e78df5d$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $740791417e78df5d$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $740791417e78df5d$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $740791417e78df5d$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $740791417e78df5d$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $740791417e78df5d$var$SHA256 extends $9X7A7.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $740791417e78df5d$var$IV[0] | 0;
        this.B = $740791417e78df5d$var$IV[1] | 0;
        this.C = $740791417e78df5d$var$IV[2] | 0;
        this.D = $740791417e78df5d$var$IV[3] | 0;
        this.E = $740791417e78df5d$var$IV[4] | 0;
        this.F = $740791417e78df5d$var$IV[5] | 0;
        this.G = $740791417e78df5d$var$IV[6] | 0;
        this.H = $740791417e78df5d$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$740791417e78df5d$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $740791417e78df5d$var$SHA256_W[i - 15];
            const W2 = $740791417e78df5d$var$SHA256_W[i - 2];
            const s0 = (0, $bzzBR.rotr)(W15, 7) ^ (0, $bzzBR.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $bzzBR.rotr)(W2, 17) ^ (0, $bzzBR.rotr)(W2, 19) ^ W2 >>> 10;
            $740791417e78df5d$var$SHA256_W[i] = s1 + $740791417e78df5d$var$SHA256_W[i - 7] + s0 + $740791417e78df5d$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $bzzBR.rotr)(E, 6) ^ (0, $bzzBR.rotr)(E, 11) ^ (0, $bzzBR.rotr)(E, 25);
            const T1 = H + sigma1 + $740791417e78df5d$var$Chi(E, F, G) + $740791417e78df5d$var$SHA256_K[i] + $740791417e78df5d$var$SHA256_W[i] | 0;
            const sigma0 = (0, $bzzBR.rotr)(A, 2) ^ (0, $bzzBR.rotr)(A, 13) ^ (0, $bzzBR.rotr)(A, 22);
            const T2 = sigma0 + $740791417e78df5d$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $740791417e78df5d$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $740791417e78df5d$var$SHA224 extends $740791417e78df5d$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $bzzBR.wrapConstructor)(()=>new $740791417e78df5d$var$SHA256());
module.exports.sha224 = (0, $bzzBR.wrapConstructor)(()=>new $740791417e78df5d$var$SHA224());

});

parcelRegister("cY9OW", function(module, exports) {

var $cbQCu = parcelRequire("cbQCu");
var $9712b4cdbf21a2f0$require$Buffer = $cbQCu.Buffer;
"use strict";
var $9712b4cdbf21a2f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9712b4cdbf21a2f0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9712b4cdbf21a2f0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9712b4cdbf21a2f0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $9712b4cdbf21a2f0$var$__createBinding(result, mod, k);
    }
    $9712b4cdbf21a2f0$var$__setModuleDefault(result, mod);
    return result;
};
var $9712b4cdbf21a2f0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $9712b4cdbf21a2f0$var$bn_js_1 = $9712b4cdbf21a2f0$var$__importDefault((parcelRequire("cj5EG")));

const $9712b4cdbf21a2f0$var$bs58_1 = $9712b4cdbf21a2f0$var$__importDefault((parcelRequire("f4WXk")));

// TODO: Make sure this polyfill not included when not required
const $9712b4cdbf21a2f0$var$encoding = $9712b4cdbf21a2f0$var$__importStar((parcelRequire("2uYNW")));
const $9712b4cdbf21a2f0$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $9712b4cdbf21a2f0$var$encoding.TextDecoder : TextDecoder;
const $9712b4cdbf21a2f0$var$textDecoder = new $9712b4cdbf21a2f0$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $9712b4cdbf21a2f0$var$baseEncode(value) {
    if (typeof value === "string") value = $9712b4cdbf21a2f0$require$Buffer.from(value, "utf8");
    return $9712b4cdbf21a2f0$var$bs58_1.default.encode($9712b4cdbf21a2f0$require$Buffer.from(value));
}
module.exports.baseEncode = $9712b4cdbf21a2f0$var$baseEncode;
function $9712b4cdbf21a2f0$var$baseDecode(value) {
    return $9712b4cdbf21a2f0$require$Buffer.from($9712b4cdbf21a2f0$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $9712b4cdbf21a2f0$var$baseDecode;
const $9712b4cdbf21a2f0$var$INITIAL_LENGTH = 1024;
class $9712b4cdbf21a2f0$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $9712b4cdbf21a2f0$var$BorshError;
/// Binary encoder.
class $9712b4cdbf21a2f0$var$BinaryWriter {
    constructor(){
        this.buf = $9712b4cdbf21a2f0$require$Buffer.alloc($9712b4cdbf21a2f0$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $9712b4cdbf21a2f0$require$Buffer.concat([
            this.buf,
            $9712b4cdbf21a2f0$require$Buffer.alloc($9712b4cdbf21a2f0$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($9712b4cdbf21a2f0$require$Buffer.from(new $9712b4cdbf21a2f0$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($9712b4cdbf21a2f0$require$Buffer.from(new $9712b4cdbf21a2f0$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($9712b4cdbf21a2f0$require$Buffer.from(new $9712b4cdbf21a2f0$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($9712b4cdbf21a2f0$require$Buffer.from(new $9712b4cdbf21a2f0$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $9712b4cdbf21a2f0$require$Buffer.concat([
            $9712b4cdbf21a2f0$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $9712b4cdbf21a2f0$require$Buffer.alloc($9712b4cdbf21a2f0$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $9712b4cdbf21a2f0$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($9712b4cdbf21a2f0$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $9712b4cdbf21a2f0$var$BinaryWriter;
function $9712b4cdbf21a2f0$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $9712b4cdbf21a2f0$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $9712b4cdbf21a2f0$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $9712b4cdbf21a2f0$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $9712b4cdbf21a2f0$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $9712b4cdbf21a2f0$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $9712b4cdbf21a2f0$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $9712b4cdbf21a2f0$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $9712b4cdbf21a2f0$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $9712b4cdbf21a2f0$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readU8", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readU16", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readU32", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readU64", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readU128", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readU256", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readU512", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readString", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readFixedArray", null);
$9712b4cdbf21a2f0$var$__decorate([
    $9712b4cdbf21a2f0$var$handlingRangeError
], $9712b4cdbf21a2f0$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $9712b4cdbf21a2f0$var$BinaryReader;
function $9712b4cdbf21a2f0$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $9712b4cdbf21a2f0$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$9712b4cdbf21a2f0$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $9712b4cdbf21a2f0$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $9712b4cdbf21a2f0$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$9712b4cdbf21a2f0$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $9712b4cdbf21a2f0$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $9712b4cdbf21a2f0$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $9712b4cdbf21a2f0$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $9712b4cdbf21a2f0$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $9712b4cdbf21a2f0$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $9712b4cdbf21a2f0$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $9712b4cdbf21a2f0$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $9712b4cdbf21a2f0$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $9712b4cdbf21a2f0$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $9712b4cdbf21a2f0$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $9712b4cdbf21a2f0$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $9712b4cdbf21a2f0$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $9712b4cdbf21a2f0$var$serialize(schema, obj, Writer = $9712b4cdbf21a2f0$var$BinaryWriter) {
    const writer = new Writer();
    $9712b4cdbf21a2f0$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $9712b4cdbf21a2f0$var$serialize;
function $9712b4cdbf21a2f0$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$9712b4cdbf21a2f0$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($9712b4cdbf21a2f0$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$9712b4cdbf21a2f0$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $9712b4cdbf21a2f0$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $9712b4cdbf21a2f0$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $9712b4cdbf21a2f0$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $9712b4cdbf21a2f0$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $9712b4cdbf21a2f0$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $9712b4cdbf21a2f0$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $9712b4cdbf21a2f0$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $9712b4cdbf21a2f0$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $9712b4cdbf21a2f0$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $9712b4cdbf21a2f0$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $9712b4cdbf21a2f0$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $9712b4cdbf21a2f0$var$deserialize(schema, classType, buffer, Reader = $9712b4cdbf21a2f0$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $9712b4cdbf21a2f0$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $9712b4cdbf21a2f0$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $9712b4cdbf21a2f0$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $9712b4cdbf21a2f0$var$deserializeUnchecked(schema, classType, buffer, Reader = $9712b4cdbf21a2f0$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $9712b4cdbf21a2f0$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $9712b4cdbf21a2f0$var$deserializeUnchecked;

});

parcelRegister("ivDjT", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.s16 = module.exports.s8 = module.exports.nu64be = module.exports.u48be = module.exports.u40be = module.exports.u32be = module.exports.u24be = module.exports.u16be = module.exports.nu64 = module.exports.u48 = module.exports.u40 = module.exports.u32 = module.exports.u24 = module.exports.u16 = module.exports.u8 = module.exports.offset = module.exports.greedy = module.exports.Constant = module.exports.UTF8 = module.exports.CString = module.exports.Blob = module.exports.Boolean = module.exports.BitField = module.exports.BitStructure = module.exports.VariantLayout = module.exports.Union = module.exports.UnionLayoutDiscriminator = module.exports.UnionDiscriminator = module.exports.Structure = module.exports.Sequence = module.exports.DoubleBE = module.exports.Double = module.exports.FloatBE = module.exports.Float = module.exports.NearInt64BE = module.exports.NearInt64 = module.exports.NearUInt64BE = module.exports.NearUInt64 = module.exports.IntBE = module.exports.Int = module.exports.UIntBE = module.exports.UInt = module.exports.OffsetLayout = module.exports.GreedyCount = module.exports.ExternalLayout = module.exports.bindConstructorLayout = module.exports.nameWithProperty = module.exports.Layout = module.exports.uint8ArrayToBuffer = module.exports.checkUint8Array = void 0;
module.exports.constant = module.exports.utf8 = module.exports.cstr = module.exports.blob = module.exports.unionLayoutDiscriminator = module.exports.union = module.exports.seq = module.exports.bits = module.exports.struct = module.exports.f64be = module.exports.f64 = module.exports.f32be = module.exports.f32 = module.exports.ns64be = module.exports.s48be = module.exports.s40be = module.exports.s32be = module.exports.s24be = module.exports.s16be = module.exports.ns64 = module.exports.s48 = module.exports.s40 = module.exports.s32 = module.exports.s24 = void 0;

var $cbQCu = parcelRequire("cbQCu");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $d7999f565f1d9919$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
module.exports.checkUint8Array = $d7999f565f1d9919$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $d7999f565f1d9919$var$uint8ArrayToBuffer(b) {
    $d7999f565f1d9919$var$checkUint8Array(b);
    return $cbQCu.Buffer.from(b.buffer, b.byteOffset, b.length);
}
module.exports.uint8ArrayToBuffer = $d7999f565f1d9919$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $d7999f565f1d9919$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
module.exports.Layout = $d7999f565f1d9919$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $d7999f565f1d9919$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
module.exports.nameWithProperty = $d7999f565f1d9919$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $d7999f565f1d9919$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $d7999f565f1d9919$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
module.exports.bindConstructorLayout = $d7999f565f1d9919$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$ExternalLayout extends $d7999f565f1d9919$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
module.exports.ExternalLayout = $d7999f565f1d9919$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $d7999f565f1d9919$var$GreedyCount extends $d7999f565f1d9919$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $d7999f565f1d9919$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
module.exports.GreedyCount = $d7999f565f1d9919$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$OffsetLayout extends $d7999f565f1d9919$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $d7999f565f1d9919$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $d7999f565f1d9919$var$UInt || this.layout instanceof $d7999f565f1d9919$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
module.exports.OffsetLayout = $d7999f565f1d9919$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$UInt extends $d7999f565f1d9919$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UInt = $d7999f565f1d9919$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$UIntBE extends $d7999f565f1d9919$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UIntBE = $d7999f565f1d9919$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Int extends $d7999f565f1d9919$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.Int = $d7999f565f1d9919$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$IntBE extends $d7999f565f1d9919$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.IntBE = $d7999f565f1d9919$var$IntBE;
const $d7999f565f1d9919$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $d7999f565f1d9919$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $d7999f565f1d9919$var$V2E32);
    const lo32 = src - hi32 * $d7999f565f1d9919$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $d7999f565f1d9919$var$roundedInt64(hi32, lo32) {
    return hi32 * $d7999f565f1d9919$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$NearUInt64 extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $d7999f565f1d9919$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $d7999f565f1d9919$var$divmodInt64(src);
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64 = $d7999f565f1d9919$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$NearUInt64BE extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $d7999f565f1d9919$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $d7999f565f1d9919$var$divmodInt64(src);
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64BE = $d7999f565f1d9919$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$NearInt64 extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $d7999f565f1d9919$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $d7999f565f1d9919$var$divmodInt64(src);
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64 = $d7999f565f1d9919$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$NearInt64BE extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $d7999f565f1d9919$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $d7999f565f1d9919$var$divmodInt64(src);
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64BE = $d7999f565f1d9919$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Float extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
module.exports.Float = $d7999f565f1d9919$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$FloatBE extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
module.exports.FloatBE = $d7999f565f1d9919$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Double extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
module.exports.Double = $d7999f565f1d9919$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$DoubleBE extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
module.exports.DoubleBE = $d7999f565f1d9919$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Sequence extends $d7999f565f1d9919$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $d7999f565f1d9919$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $d7999f565f1d9919$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $d7999f565f1d9919$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $d7999f565f1d9919$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $d7999f565f1d9919$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $d7999f565f1d9919$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
module.exports.Sequence = $d7999f565f1d9919$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Structure extends $d7999f565f1d9919$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $d7999f565f1d9919$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $d7999f565f1d9919$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
module.exports.Structure = $d7999f565f1d9919$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $d7999f565f1d9919$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
module.exports.UnionDiscriminator = $d7999f565f1d9919$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $d7999f565f1d9919$var$UnionLayoutDiscriminator extends $d7999f565f1d9919$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $d7999f565f1d9919$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
module.exports.UnionLayoutDiscriminator = $d7999f565f1d9919$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Union extends $d7999f565f1d9919$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $d7999f565f1d9919$var$UInt || discr instanceof $d7999f565f1d9919$var$UIntBE) discriminator = new $d7999f565f1d9919$var$UnionLayoutDiscriminator(new $d7999f565f1d9919$var$OffsetLayout(discr));
        else if (discr instanceof $d7999f565f1d9919$var$ExternalLayout && discr.isCount()) discriminator = new $d7999f565f1d9919$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $d7999f565f1d9919$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $d7999f565f1d9919$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $d7999f565f1d9919$var$UInt || discr instanceof $d7999f565f1d9919$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $d7999f565f1d9919$var$UInt || discr instanceof $d7999f565f1d9919$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $d7999f565f1d9919$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
module.exports.Union = $d7999f565f1d9919$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$VariantLayout extends $d7999f565f1d9919$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $d7999f565f1d9919$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $d7999f565f1d9919$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
module.exports.VariantLayout = $d7999f565f1d9919$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $d7999f565f1d9919$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$BitStructure extends $d7999f565f1d9919$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $d7999f565f1d9919$var$UInt || word instanceof $d7999f565f1d9919$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $d7999f565f1d9919$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $d7999f565f1d9919$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $d7999f565f1d9919$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
module.exports.BitStructure = $d7999f565f1d9919$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $d7999f565f1d9919$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $d7999f565f1d9919$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $d7999f565f1d9919$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $d7999f565f1d9919$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $d7999f565f1d9919$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($d7999f565f1d9919$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $d7999f565f1d9919$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($d7999f565f1d9919$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
module.exports.BitField = $d7999f565f1d9919$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $d7999f565f1d9919$var$Boolean extends $d7999f565f1d9919$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
module.exports.Boolean = $d7999f565f1d9919$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Blob extends $d7999f565f1d9919$var$Layout {
    constructor(length, property){
        if (!(length instanceof $d7999f565f1d9919$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $d7999f565f1d9919$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $d7999f565f1d9919$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($d7999f565f1d9919$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(src);
        $d7999f565f1d9919$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $d7999f565f1d9919$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
module.exports.Blob = $d7999f565f1d9919$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$CString extends $d7999f565f1d9919$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $d7999f565f1d9919$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $cbQCu.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $d7999f565f1d9919$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
module.exports.CString = $d7999f565f1d9919$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$UTF8 extends $d7999f565f1d9919$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $d7999f565f1d9919$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $d7999f565f1d9919$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $cbQCu.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($d7999f565f1d9919$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
module.exports.UTF8 = $d7999f565f1d9919$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $d7999f565f1d9919$var$Constant extends $d7999f565f1d9919$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
module.exports.Constant = $d7999f565f1d9919$var$Constant;
/** Factory for {@link GreedyCount}. */ module.exports.greedy = (elementSpan, property)=>new $d7999f565f1d9919$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ module.exports.offset = (layout, offset, property)=>new $d7999f565f1d9919$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ module.exports.u8 = (property)=>new $d7999f565f1d9919$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16 = (property)=>new $d7999f565f1d9919$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24 = (property)=>new $d7999f565f1d9919$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32 = (property)=>new $d7999f565f1d9919$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40 = (property)=>new $d7999f565f1d9919$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48 = (property)=>new $d7999f565f1d9919$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64 = (property)=>new $d7999f565f1d9919$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16be = (property)=>new $d7999f565f1d9919$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24be = (property)=>new $d7999f565f1d9919$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32be = (property)=>new $d7999f565f1d9919$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40be = (property)=>new $d7999f565f1d9919$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48be = (property)=>new $d7999f565f1d9919$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64be = (property)=>new $d7999f565f1d9919$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ module.exports.s8 = (property)=>new $d7999f565f1d9919$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16 = (property)=>new $d7999f565f1d9919$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24 = (property)=>new $d7999f565f1d9919$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32 = (property)=>new $d7999f565f1d9919$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40 = (property)=>new $d7999f565f1d9919$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48 = (property)=>new $d7999f565f1d9919$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64 = (property)=>new $d7999f565f1d9919$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16be = (property)=>new $d7999f565f1d9919$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24be = (property)=>new $d7999f565f1d9919$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32be = (property)=>new $d7999f565f1d9919$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40be = (property)=>new $d7999f565f1d9919$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48be = (property)=>new $d7999f565f1d9919$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64be = (property)=>new $d7999f565f1d9919$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ module.exports.f32 = (property)=>new $d7999f565f1d9919$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ module.exports.f32be = (property)=>new $d7999f565f1d9919$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ module.exports.f64 = (property)=>new $d7999f565f1d9919$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ module.exports.f64be = (property)=>new $d7999f565f1d9919$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ module.exports.struct = (fields, property, decodePrefixes)=>new $d7999f565f1d9919$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ module.exports.bits = (word, msb, property)=>new $d7999f565f1d9919$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ module.exports.seq = (elementLayout, count, property)=>new $d7999f565f1d9919$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ module.exports.union = (discr, defaultLayout, property)=>new $d7999f565f1d9919$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ module.exports.unionLayoutDiscriminator = (layout, property)=>new $d7999f565f1d9919$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ module.exports.blob = (length, property)=>new $d7999f565f1d9919$var$Blob(length, property);
/** Factory for {@link CString} values. */ module.exports.cstr = (property)=>new $d7999f565f1d9919$var$CString(property);
/** Factory for {@link UTF8} values. */ module.exports.utf8 = (maxSpan, property)=>new $d7999f565f1d9919$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ module.exports.constant = (value, property)=>new $d7999f565f1d9919$var$Constant(value, property);

});

parcelRegister("bpv1j", function(module, exports) {

var $cbQCu = parcelRequire("cbQCu");
var $84ea177c36420570$require$Buffer = $cbQCu.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
let $84ea177c36420570$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $84ea177c36420570$var$toBigIntLE(buf) {
    {
        const reversed = $84ea177c36420570$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $84ea177c36420570$var$converter.toBigInt(buf, false);
}
module.exports.toBigIntLE = $84ea177c36420570$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $84ea177c36420570$var$toBigIntBE(buf) {
    {
        const hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $84ea177c36420570$var$converter.toBigInt(buf, true);
}
module.exports.toBigIntBE = $84ea177c36420570$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $84ea177c36420570$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $84ea177c36420570$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $84ea177c36420570$var$converter.fromBigInt(num, $84ea177c36420570$require$Buffer.allocUnsafe(width), false);
}
module.exports.toBufferLE = $84ea177c36420570$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $84ea177c36420570$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $84ea177c36420570$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $84ea177c36420570$var$converter.fromBigInt(num, $84ea177c36420570$require$Buffer.allocUnsafe(width), true);
}
module.exports.toBufferBE = $84ea177c36420570$var$toBufferBE;

});

parcelRegister("8TK0B", function(module, exports) {

$parcel$export(module.exports, "assert", () => $67a72622450fd2e4$export$a7a9523472993e97);
$parcel$export(module.exports, "create", () => $67a72622450fd2e4$export$185802fd694ee1f5);
$parcel$export(module.exports, "optional", () => $67a72622450fd2e4$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "any", () => $67a72622450fd2e4$export$4154a199d7d90455);
$parcel$export(module.exports, "array", () => $67a72622450fd2e4$export$2f23118c22fb2630);
$parcel$export(module.exports, "boolean", () => $67a72622450fd2e4$export$4a21f16c33752377);
$parcel$export(module.exports, "instance", () => $67a72622450fd2e4$export$9544d5bb712b01ea);
$parcel$export(module.exports, "literal", () => $67a72622450fd2e4$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "nullable", () => $67a72622450fd2e4$export$133fc36489ac9add);
$parcel$export(module.exports, "number", () => $67a72622450fd2e4$export$98e628dec113755e);
$parcel$export(module.exports, "record", () => $67a72622450fd2e4$export$e5185e241753e543);
$parcel$export(module.exports, "string", () => $67a72622450fd2e4$export$22b082955e083ec3);
$parcel$export(module.exports, "tuple", () => $67a72622450fd2e4$export$65e3907585753458);
$parcel$export(module.exports, "type", () => $67a72622450fd2e4$export$bf9fb029d174d554);
$parcel$export(module.exports, "union", () => $67a72622450fd2e4$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "unknown", () => $67a72622450fd2e4$export$19282c40b967aec6);
$parcel$export(module.exports, "coerce", () => $67a72622450fd2e4$export$8c14e57e778d3873);
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $67a72622450fd2e4$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join(".") + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $67a72622450fd2e4$var$isIterable(x) {
    return $67a72622450fd2e4$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $67a72622450fd2e4$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $67a72622450fd2e4$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $67a72622450fd2e4$var$print(value) {
    return typeof value === "string" ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $67a72622450fd2e4$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $67a72622450fd2e4$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : "") + ", but received: `" + $67a72622450fd2e4$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $67a72622450fd2e4$var$toFailures(result, context, struct, value) {
    if (!$67a72622450fd2e4$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $67a72622450fd2e4$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $67a72622450fd2e4$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $67a72622450fd2e4$var$isObject(struct.schema) && $67a72622450fd2e4$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $67a72622450fd2e4$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($67a72622450fd2e4$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $67a72622450fd2e4$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $67a72622450fd2e4$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $67a72622450fd2e4$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $67a72622450fd2e4$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $67a72622450fd2e4$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $67a72622450fd2e4$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $67a72622450fd2e4$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $67a72622450fd2e4$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $67a72622450fd2e4$export$a7a9523472993e97(value, struct) {
    const result = $67a72622450fd2e4$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $67a72622450fd2e4$export$185802fd694ee1f5(value, struct) {
    const result = $67a72622450fd2e4$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $67a72622450fd2e4$export$d99f0801a68bbcf1(value, struct) {
    const result = $67a72622450fd2e4$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $67a72622450fd2e4$export$226b3eccf92c9ed9(value, struct) {
    const result = $67a72622450fd2e4$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $67a72622450fd2e4$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $67a72622450fd2e4$var$run(value, struct, options);
    const tuple = $67a72622450fd2e4$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $67a72622450fd2e4$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $67a72622450fd2e4$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $67a72622450fd2e4$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $67a72622450fd2e4$export$f36d6a7a5c09a23e(name, validator) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $67a72622450fd2e4$export$cdd73fc4100a6ef4(struct, log) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $67a72622450fd2e4$export$7077912c31975674(fn) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $67a72622450fd2e4$export$488013bae63b21da(fn) {
    let struct;
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $67a72622450fd2e4$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $67a72622450fd2e4$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $67a72622450fd2e4$export$e45945969df8035a(struct) {
    const schema = struct instanceof $67a72622450fd2e4$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $67a72622450fd2e4$export$516e28dec6a4b6d4(schema[key]);
    return $67a72622450fd2e4$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $67a72622450fd2e4$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $67a72622450fd2e4$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $67a72622450fd2e4$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $67a72622450fd2e4$export$4154a199d7d90455() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $67a72622450fd2e4$export$2f23118c22fb2630(Element) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $67a72622450fd2e4$export$4a21f16c33752377() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $67a72622450fd2e4$export$324d90190a8b822a() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $67a72622450fd2e4$var$print(value);
    });
}
function $67a72622450fd2e4$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$67a72622450fd2e4$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $67a72622450fd2e4$export$86951950244e2001() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || "Expected a function, but received: " + $67a72622450fd2e4$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $67a72622450fd2e4$export$9544d5bb712b01ea(Class) {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $67a72622450fd2e4$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $67a72622450fd2e4$export$32744b5b3bba4764() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $67a72622450fd2e4$var$print(value);
    });
}
function $67a72622450fd2e4$export$bc86dfbf7795668c(Structs) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $67a72622450fd2e4$export$c8ec6e1ec9fefcb0(constant) {
    const description = $67a72622450fd2e4$var$print(constant);
    const t = typeof constant;
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
function $67a72622450fd2e4$export$871de8747c9eaa88(Key, Value) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $67a72622450fd2e4$export$b3e22bcfd64c1022() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $67a72622450fd2e4$export$133fc36489ac9add(struct) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $67a72622450fd2e4$export$98e628dec113755e() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: " + $67a72622450fd2e4$var$print(value);
    });
}
function $67a72622450fd2e4$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $67a72622450fd2e4$export$b3e22bcfd64c1022();
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $67a72622450fd2e4$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $67a72622450fd2e4$var$isObject(value) || "Expected an object, but received: " + $67a72622450fd2e4$var$print(value);
        },
        coercer (value) {
            return $67a72622450fd2e4$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $67a72622450fd2e4$export$516e28dec6a4b6d4(struct) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $67a72622450fd2e4$export$e5185e241753e543(Key, Value) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($67a72622450fd2e4$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $67a72622450fd2e4$var$isObject(value) || "Expected an object, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $67a72622450fd2e4$export$efdc1e5bdb609bb() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $67a72622450fd2e4$export$adaa4cf7ef1b65be(Element) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $67a72622450fd2e4$export$22b082955e083ec3() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || "Expected a string, but received: " + $67a72622450fd2e4$var$print(value);
    });
}
function $67a72622450fd2e4$export$65e3907585753458(Elements) {
    const Never = $67a72622450fd2e4$export$b3e22bcfd64c1022();
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $67a72622450fd2e4$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($67a72622450fd2e4$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $67a72622450fd2e4$var$isObject(value) || "Expected an object, but received: " + $67a72622450fd2e4$var$print(value);
        }
    });
}
function $67a72622450fd2e4$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        type: "union",
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $67a72622450fd2e4$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $67a72622450fd2e4$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $67a72622450fd2e4$export$19282c40b967aec6() {
    return $67a72622450fd2e4$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $67a72622450fd2e4$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $67a72622450fd2e4$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $67a72622450fd2e4$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $67a72622450fd2e4$export$8c14e57e778d3873(struct, $67a72622450fd2e4$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $67a72622450fd2e4$var$isPlainObject(x) && $67a72622450fd2e4$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $67a72622450fd2e4$export$41f369984ed28930(struct) {
    return $67a72622450fd2e4$export$8c14e57e778d3873(struct, $67a72622450fd2e4$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $67a72622450fd2e4$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $67a72622450fd2e4$export$edc9d475108b3212(struct, "empty", (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $67a72622450fd2e4$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $67a72622450fd2e4$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $67a72622450fd2e4$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $67a72622450fd2e4$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $67a72622450fd2e4$export$24f82734ea047e6f(struct, regexp) {
    return $67a72622450fd2e4$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + '/` but received "' + value + '"';
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $67a72622450fd2e4$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $67a72622450fd2e4$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $67a72622450fd2e4$export$edc9d475108b3212(struct, name, refiner) {
    return new $67a72622450fd2e4$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $67a72622450fd2e4$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});

parcelRegister("5iF8R", function(module, exports) {
"use strict";

var $6fzQb = parcelRequire("6fzQb");
var $3dbe8c1be887567b$require$uuid = $6fzQb.default;

var $4qoJD = parcelRequire("4qoJD");
/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $3dbe8c1be887567b$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $3dbe8c1be887567b$var$ClientBrowser)) return new $3dbe8c1be887567b$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $3dbe8c1be887567b$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
module.exports = $3dbe8c1be887567b$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $3dbe8c1be887567b$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $4qoJD(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $3dbe8c1be887567b$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};

});
parcelRegister("6fzQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $48cff2060dd9bf40$export$2e2bcd8739ae039);

var $4UsLq = parcelRequire("4UsLq");

var $cyszw = parcelRequire("cyszw");
function $48cff2060dd9bf40$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $4UsLq.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $cyszw.default)(rnds);
}
var $48cff2060dd9bf40$export$2e2bcd8739ae039 = $48cff2060dd9bf40$var$v4;

});
parcelRegister("4UsLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3932b45211f8b2ac$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $3932b45211f8b2ac$var$getRandomValues;
var $3932b45211f8b2ac$var$rnds8 = new Uint8Array(16);
function $3932b45211f8b2ac$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$3932b45211f8b2ac$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $3932b45211f8b2ac$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$3932b45211f8b2ac$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $3932b45211f8b2ac$var$getRandomValues($3932b45211f8b2ac$var$rnds8);
}

});

parcelRegister("cyszw", function(module, exports) {

$parcel$export(module.exports, "default", () => $923ed2ccd944d2b6$export$2e2bcd8739ae039);

var $6jPF4 = parcelRequire("6jPF4");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $923ed2ccd944d2b6$var$byteToHex = [];
for(var $923ed2ccd944d2b6$var$i = 0; $923ed2ccd944d2b6$var$i < 256; ++$923ed2ccd944d2b6$var$i)$923ed2ccd944d2b6$var$byteToHex.push(($923ed2ccd944d2b6$var$i + 0x100).toString(16).substr(1));
function $923ed2ccd944d2b6$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($923ed2ccd944d2b6$var$byteToHex[arr[offset + 0]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 1]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 2]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 3]] + "-" + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 4]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 5]] + "-" + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 6]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 7]] + "-" + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 8]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 9]] + "-" + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 10]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 11]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 12]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 13]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 14]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $6jPF4.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $923ed2ccd944d2b6$export$2e2bcd8739ae039 = $923ed2ccd944d2b6$var$stringify;

});
parcelRegister("6jPF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $499c9750349abc1d$export$2e2bcd8739ae039);

var $7yMkF = parcelRequire("7yMkF");
function $499c9750349abc1d$var$validate(uuid) {
    return typeof uuid === "string" && (0, $7yMkF.default).test(uuid);
}
var $499c9750349abc1d$export$2e2bcd8739ae039 = $499c9750349abc1d$var$validate;

});
parcelRegister("7yMkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $58113331cb3833cb$export$2e2bcd8739ae039);
var $58113331cb3833cb$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("4qoJD", function(module, exports) {
"use strict";

var $6fzQb = parcelRequire("6fzQb");
var $338cc6fb2b588821$require$uuid = $6fzQb.default;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $338cc6fb2b588821$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $338cc6fb2b588821$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
module.exports = $338cc6fb2b588821$var$generateRequest;

});


parcelRegister("6Rz5s", function(module, exports) {
/**
 * "Client" wraps "ws" or a browser-implemented "WebSocket" library
 * according to the environment providing JSON RPC 2.0 support on top.
 * @module Client
 */ 
var $cbQCu = parcelRequire("cbQCu");
var $4ff2e8e3e6ddd292$require$Buffer = $cbQCu.Buffer;
"use strict";

var $3WA7R = parcelRequire("3WA7R");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4ff2e8e3e6ddd292$var$_regenerator = $3WA7R((parcelRequire("fJCyt")));

var $4ff2e8e3e6ddd292$var$_asyncToGenerator2 = $3WA7R((parcelRequire("bXpXp")));

var $4ff2e8e3e6ddd292$var$_typeof2 = $3WA7R((parcelRequire("h0bfi")));

var $4ff2e8e3e6ddd292$var$_classCallCheck2 = $3WA7R((parcelRequire("5W7fH")));

var $4ff2e8e3e6ddd292$var$_createClass2 = $3WA7R((parcelRequire("iiIaW")));

var $4ff2e8e3e6ddd292$var$_inherits2 = $3WA7R((parcelRequire("fxSBS")));

var $4ff2e8e3e6ddd292$var$_possibleConstructorReturn2 = $3WA7R((parcelRequire("dmYtZ")));

var $4ff2e8e3e6ddd292$var$_getPrototypeOf2 = $3WA7R((parcelRequire("1dvnv")));

var $1PbQI = parcelRequire("1PbQI");

var $4kWh5 = parcelRequire("4kWh5");
function $4ff2e8e3e6ddd292$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4ff2e8e3e6ddd292$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $4ff2e8e3e6ddd292$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4ff2e8e3e6ddd292$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4ff2e8e3e6ddd292$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $4ff2e8e3e6ddd292$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $4ff2e8e3e6ddd292$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// @ts-ignore
var $4ff2e8e3e6ddd292$var$CommonClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $4ff2e8e3e6ddd292$var$_inherits2["default"])(CommonClient, _EventEmitter);
    var _super = $4ff2e8e3e6ddd292$var$_createSuper(CommonClient);
    /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */ function CommonClient(webSocketFactory) {
        var _this;
        var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ws://localhost:8080";
        var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var generate_request_id = arguments.length > 3 ? arguments[3] : undefined;
        var dataPack = arguments.length > 4 ? arguments[4] : undefined;
        (0, $4ff2e8e3e6ddd292$var$_classCallCheck2["default"])(this, CommonClient);
        var _a$autoconnect = _a.autoconnect, autoconnect = _a$autoconnect === void 0 ? true : _a$autoconnect, _a$reconnect = _a.reconnect, reconnect = _a$reconnect === void 0 ? true : _a$reconnect, _a$reconnect_interval = _a.reconnect_interval, reconnect_interval = _a$reconnect_interval === void 0 ? 1000 : _a$reconnect_interval, _a$max_reconnects = _a.max_reconnects, max_reconnects = _a$max_reconnects === void 0 ? 5 : _a$max_reconnects, rest_options = $4ff2e8e3e6ddd292$var$__rest(_a, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = undefined;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (!dataPack) _this.dataPack = new $4kWh5.DefaultDataPack();
        else _this.dataPack = dataPack;
        if (_this.autoconnect) _this._connect(_this.address, Object.assign({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */ (0, $4ff2e8e3e6ddd292$var$_createClass2["default"])(CommonClient, [
        {
            key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, Object.assign({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this2 = this;
                if (!ws_opts && "object" === (0, $4ff2e8e3e6ddd292$var$_typeof2["default"])(timeout)) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this2.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this2.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || undefined,
                        id: rpc_id
                    };
                    _this2.socket.send(_this2.dataPack.encode(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this2.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this2.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this2.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: function() {
                var _login = (0, $4ff2e8e3e6ddd292$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4ff2e8e3e6ddd292$var$_regenerator["default"].mark(function _callee(params) {
                    var resp;
                    return $4ff2e8e3e6ddd292$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.call("rpc.login", params);
                            case 2:
                                resp = _context.sent;
                                if (resp) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("authentication failed");
                            case 5:
                                return _context.abrupt("return", resp);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function login(_x) {
                    return _login.apply(this, arguments);
                }
                return login;
            }()
        },
        {
            key: "listMethods",
            value: function() {
                var _listMethods = (0, $4ff2e8e3e6ddd292$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4ff2e8e3e6ddd292$var$_regenerator["default"].mark(function _callee2() {
                    return $4ff2e8e3e6ddd292$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.call("__listMethods");
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function listMethods() {
                    return _listMethods.apply(this, arguments);
                }
                return listMethods;
            }()
        },
        {
            key: "notify",
            value: function notify(method, params) {
                var _this3 = this;
                return new Promise(function(resolve, reject) {
                    if (!_this3.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params
                    };
                    _this3.socket.send(_this3.dataPack.encode(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $4ff2e8e3e6ddd292$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4ff2e8e3e6ddd292$var$_regenerator["default"].mark(function _callee3(event) {
                    var result;
                    return $4ff2e8e3e6ddd292$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context3.next = 3;
                                return this.call("rpc.on", event);
                            case 3:
                                result = _context3.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context3.next = 6;
                                    break;
                                }
                                throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                            case 6:
                                return _context3.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function subscribe(_x2) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "unsubscribe",
            value: function() {
                var _unsubscribe = (0, $4ff2e8e3e6ddd292$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4ff2e8e3e6ddd292$var$_regenerator["default"].mark(function _callee4(event) {
                    var result;
                    return $4ff2e8e3e6ddd292$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context4.next = 3;
                                return this.call("rpc.off", event);
                            case 3:
                                result = _context4.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context4.next = 6;
                                    break;
                                }
                                throw new Error("Failed unsubscribing from an event with: " + result);
                            case 6:
                                return _context4.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function unsubscribe(_x3) {
                    return _unsubscribe.apply(this, arguments);
                }
                return unsubscribe;
            }()
        },
        {
            key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1000, data);
            }
        },
        {
            key: "_connect",
            value: function _connect(address, options) {
                var _this4 = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this4.ready = true;
                    _this4.emit("open");
                    _this4.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(_ref) {
                    var message = _ref.data;
                    if (message instanceof ArrayBuffer) message = $4ff2e8e3e6ddd292$require$Buffer.from(message).toString();
                    try {
                        message = _this4.dataPack.decode(message);
                    } catch (error) {
                        return;
                    }
                    // check if any listeners are attached and forward event
                    if (message.notification && _this4.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this4.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else // using for-loop instead of unshift/spread because performance is better
                        for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        // run as microtask so that pending queue messages are resolved first
                        // eslint-disable-next-line prefer-spread
                        return Promise.resolve().then(function() {
                            _this4.emit.apply(_this4, args);
                        });
                    }
                    if (!_this4.queue[message.id]) {
                        // general JSON RPC 2.0 events
                        if (message.method) // run as microtask so that pending queue messages are resolved first
                        return Promise.resolve().then(function() {
                            _this4.emit(message.method, message === null || message === void 0 ? void 0 : message.params);
                        });
                        return;
                    }
                    // reject early since server's response is invalid
                    if ("error" in message === "result" in message) _this4.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this4.queue[message.id].timeout) clearTimeout(_this4.queue[message.id].timeout);
                    if (message.error) _this4.queue[message.id].promise[1](message.error);
                    else _this4.queue[message.id].promise[0](message.result);
                    delete _this4.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this4.emit("error", error);
                });
                this.socket.addEventListener("close", function(_ref2) {
                    var code = _ref2.code, reason = _ref2.reason;
                    if (_this4.ready) // Delay close event until internal state is updated
                    setTimeout(function() {
                        return _this4.emit("close", code, reason);
                    }, 0);
                    _this4.ready = false;
                    _this4.socket = undefined;
                    if (code === 1000) return;
                    _this4.current_reconnects++;
                    if (_this4.reconnect && (_this4.max_reconnects > _this4.current_reconnects || _this4.max_reconnects === 0)) _this4.reconnect_timer_id = setTimeout(function() {
                        return _this4._connect(address, options);
                    }, _this4.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}($1PbQI.EventEmitter);
module.exports["default"] = $4ff2e8e3e6ddd292$var$CommonClient;

});
parcelRegister("3WA7R", function(module, exports) {
function $2df2cfae4a55c056$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $2df2cfae4a55c056$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1PbQI", function(module, exports) {
"use strict";
var $1543bee13b19bcd1$var$has = Object.prototype.hasOwnProperty, $1543bee13b19bcd1$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $1543bee13b19bcd1$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $1543bee13b19bcd1$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $1543bee13b19bcd1$var$Events().__proto__) $1543bee13b19bcd1$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $1543bee13b19bcd1$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $1543bee13b19bcd1$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $1543bee13b19bcd1$var$EE(fn, context || emitter, once), evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $1543bee13b19bcd1$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $1543bee13b19bcd1$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $1543bee13b19bcd1$var$EventEmitter() {
    this._events = new $1543bee13b19bcd1$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($1543bee13b19bcd1$var$has.call(events, name)) names.push($1543bee13b19bcd1$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $1543bee13b19bcd1$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $1543bee13b19bcd1$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $1543bee13b19bcd1$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $1543bee13b19bcd1$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $1543bee13b19bcd1$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
        if (this._events[evt]) $1543bee13b19bcd1$var$clearEvent(this, evt);
    } else {
        this._events = new $1543bee13b19bcd1$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$1543bee13b19bcd1$var$EventEmitter.prototype.off = $1543bee13b19bcd1$var$EventEmitter.prototype.removeListener;
$1543bee13b19bcd1$var$EventEmitter.prototype.addListener = $1543bee13b19bcd1$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$1543bee13b19bcd1$var$EventEmitter.prefixed = $1543bee13b19bcd1$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$1543bee13b19bcd1$var$EventEmitter.EventEmitter = $1543bee13b19bcd1$var$EventEmitter;
module.exports = $1543bee13b19bcd1$var$EventEmitter;

});

parcelRegister("4kWh5", function(module, exports) {
"use strict";

var $3WA7R = parcelRequire("3WA7R");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultDataPack = void 0;
module.exports.createError = $32863bcf3dc4978f$var$createError;

var $32863bcf3dc4978f$var$_classCallCheck2 = $3WA7R((parcelRequire("5W7fH")));

var $32863bcf3dc4978f$var$_createClass2 = $3WA7R((parcelRequire("iiIaW")));
var $32863bcf3dc4978f$var$errors = new Map([
    [
        -32000,
        "Event not provided"
    ],
    [
        -32600,
        "Invalid Request"
    ],
    [
        -32601,
        "Method not found"
    ],
    [
        -32602,
        "Invalid params"
    ],
    [
        -32603,
        "Internal error"
    ],
    [
        -32604,
        "Params not found"
    ],
    [
        -32605,
        "Method forbidden"
    ],
    [
        -32606,
        "Event forbidden"
    ],
    [
        -32700,
        "Parse error"
    ]
]);
var $32863bcf3dc4978f$var$DefaultDataPack = /*#__PURE__*/ function() {
    function DefaultDataPack() {
        (0, $32863bcf3dc4978f$var$_classCallCheck2["default"])(this, DefaultDataPack);
    }
    (0, $32863bcf3dc4978f$var$_createClass2["default"])(DefaultDataPack, [
        {
            key: "encode",
            value: function encode(value) {
                return JSON.stringify(value);
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                return JSON.parse(value);
            }
        }
    ]);
    return DefaultDataPack;
}();
/**
 * Creates a JSON-RPC 2.0-compliant error.
 * @param {Number} code - error code
 * @param {String} details - error details
 * @return {Object}
 */ module.exports.DefaultDataPack = $32863bcf3dc4978f$var$DefaultDataPack;
function $32863bcf3dc4978f$var$createError(code, details) {
    var error = {
        code: code,
        message: $32863bcf3dc4978f$var$errors.get(code) || "Internal Server Error"
    };
    if (details) error["data"] = details;
    return error;
}

});


parcelRegister("hFjcB", function(module, exports) {
/**
 * WebSocket implements a browser-side WebSocket specification.
 * @module Client
 */ "use strict";

var $3WA7R = parcelRequire("3WA7R");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $cdc52927915a0a0a$var$_default;

var $cdc52927915a0a0a$var$_classCallCheck2 = $3WA7R((parcelRequire("5W7fH")));

var $cdc52927915a0a0a$var$_createClass2 = $3WA7R((parcelRequire("iiIaW")));

var $cdc52927915a0a0a$var$_inherits2 = $3WA7R((parcelRequire("fxSBS")));

var $cdc52927915a0a0a$var$_possibleConstructorReturn2 = $3WA7R((parcelRequire("dmYtZ")));

var $cdc52927915a0a0a$var$_getPrototypeOf2 = $3WA7R((parcelRequire("1dvnv")));

var $1PbQI = parcelRequire("1PbQI");
function $cdc52927915a0a0a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cdc52927915a0a0a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $cdc52927915a0a0a$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $cdc52927915a0a0a$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cdc52927915a0a0a$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $cdc52927915a0a0a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $cdc52927915a0a0a$var$WebSocketBrowserImpl = /*#__PURE__*/ function(_EventEmitter) {
    (0, $cdc52927915a0a0a$var$_inherits2["default"])(WebSocketBrowserImpl, _EventEmitter);
    var _super = $cdc52927915a0a0a$var$_createSuper(WebSocketBrowserImpl);
    /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */ function WebSocketBrowserImpl(address, options, protocols) {
        var _this;
        (0, $cdc52927915a0a0a$var$_classCallCheck2["default"])(this, WebSocketBrowserImpl);
        _this = _super.call(this);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */ (0, $cdc52927915a0a0a$var$_createClass2["default"])(WebSocketBrowserImpl, [
        {
            key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}($1PbQI.EventEmitter);
/**
 * factory method for common WebSocket instance
 * @method
 * @param {String} address - url to a websocket server
 * @param {(Object)} options - websocket options
 * @return {Undefined}
 */ function $cdc52927915a0a0a$var$_default(address, options) {
    return new $cdc52927915a0a0a$var$WebSocketBrowserImpl(address, options);
}

});

parcelRegister("2dinB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $9Wm5b = parcelRequire("9Wm5b");

var $5ypm0 = parcelRequire("5ypm0");

var $bzzBR = parcelRequire("bzzBR");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$19cb0d7c799243c5$var$SHA3_PI, $19cb0d7c799243c5$var$SHA3_ROTL, $19cb0d7c799243c5$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $19cb0d7c799243c5$var$_0n = /* @__PURE__ */ BigInt(0);
const $19cb0d7c799243c5$var$_1n = /* @__PURE__ */ BigInt(1);
const $19cb0d7c799243c5$var$_2n = /* @__PURE__ */ BigInt(2);
const $19cb0d7c799243c5$var$_7n = /* @__PURE__ */ BigInt(7);
const $19cb0d7c799243c5$var$_256n = /* @__PURE__ */ BigInt(256);
const $19cb0d7c799243c5$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $19cb0d7c799243c5$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $19cb0d7c799243c5$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $19cb0d7c799243c5$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $19cb0d7c799243c5$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $19cb0d7c799243c5$var$_1n ^ (R >> $19cb0d7c799243c5$var$_7n) * $19cb0d7c799243c5$var$_0x71n) % $19cb0d7c799243c5$var$_256n;
        if (R & $19cb0d7c799243c5$var$_2n) t ^= $19cb0d7c799243c5$var$_1n << ($19cb0d7c799243c5$var$_1n << /* @__PURE__ */ BigInt(j)) - $19cb0d7c799243c5$var$_1n;
    }
    $19cb0d7c799243c5$var$_SHA3_IOTA.push(t);
}
const [$19cb0d7c799243c5$var$SHA3_IOTA_H, $19cb0d7c799243c5$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $5ypm0.split)($19cb0d7c799243c5$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $19cb0d7c799243c5$var$rotlH = (h, l, s)=>s > 32 ? (0, $5ypm0.rotlBH)(h, l, s) : (0, $5ypm0.rotlSH)(h, l, s);
const $19cb0d7c799243c5$var$rotlL = (h, l, s)=>s > 32 ? (0, $5ypm0.rotlBL)(h, l, s) : (0, $5ypm0.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $19cb0d7c799243c5$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $19cb0d7c799243c5$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $19cb0d7c799243c5$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $19cb0d7c799243c5$var$SHA3_ROTL[t];
            const Th = $19cb0d7c799243c5$var$rotlH(curH, curL, shift);
            const Tl = $19cb0d7c799243c5$var$rotlL(curH, curL, shift);
            const PI = $19cb0d7c799243c5$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $19cb0d7c799243c5$var$SHA3_IOTA_H[round];
        s[1] ^= $19cb0d7c799243c5$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $19cb0d7c799243c5$var$keccakP;
class $19cb0d7c799243c5$var$Keccak extends $bzzBR.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $9Wm5b.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $bzzBR.u32)(this.state);
    }
    keccak() {
        $19cb0d7c799243c5$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $9Wm5b.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $bzzBR.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $9Wm5b.exists)(this, false);
        (0, $9Wm5b.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $9Wm5b.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $9Wm5b.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $19cb0d7c799243c5$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $19cb0d7c799243c5$var$Keccak;
const $19cb0d7c799243c5$var$gen = (suffix, blockLen, outputLen)=>(0, $bzzBR.wrapConstructor)(()=>new $19cb0d7c799243c5$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $19cb0d7c799243c5$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $19cb0d7c799243c5$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $19cb0d7c799243c5$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $19cb0d7c799243c5$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $19cb0d7c799243c5$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $19cb0d7c799243c5$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $19cb0d7c799243c5$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $19cb0d7c799243c5$var$gen(0x01, 72, 64);
const $19cb0d7c799243c5$var$genShake = (suffix, blockLen, outputLen)=>(0, $bzzBR.wrapXOFConstructorWithOpts)((opts = {})=>new $19cb0d7c799243c5$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $19cb0d7c799243c5$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $19cb0d7c799243c5$var$genShake(0x1f, 136, 32);

});

parcelRegister("386SJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.schnorr = module.exports.secp256k1 = void 0;

var $9XCBn = parcelRequire("9XCBn");

var $bzzBR = parcelRequire("bzzBR");

var $f6Psy = parcelRequire("f6Psy");

var $11W5Z = parcelRequire("11W5Z");

var $bY9yL = parcelRequire("bY9yL");

var $9CBZF = parcelRequire("9CBZF");

var $keQ7l = parcelRequire("keQ7l");
const $24777508aa14dabe$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $24777508aa14dabe$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $24777508aa14dabe$var$_1n = BigInt(1);
const $24777508aa14dabe$var$_2n = BigInt(2);
const $24777508aa14dabe$var$divNearest = (a, b)=>(a + b / $24777508aa14dabe$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $24777508aa14dabe$var$sqrtMod(y) {
    const P = $24777508aa14dabe$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $f6Psy.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $f6Psy.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $f6Psy.pow2)(b9, $24777508aa14dabe$var$_2n, P) * b2 % P;
    const b22 = (0, $f6Psy.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $f6Psy.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $f6Psy.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $f6Psy.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $f6Psy.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $f6Psy.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $f6Psy.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $f6Psy.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $f6Psy.pow2)(t2, $24777508aa14dabe$var$_2n, P);
    if (!$24777508aa14dabe$var$Fp.eql($24777508aa14dabe$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $24777508aa14dabe$var$Fp = (0, $f6Psy.Field)($24777508aa14dabe$var$secp256k1P, undefined, undefined, {
    sqrt: $24777508aa14dabe$var$sqrtMod
});
module.exports.secp256k1 = (0, $keQ7l.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $24777508aa14dabe$var$Fp,
    n: $24777508aa14dabe$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $24777508aa14dabe$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$24777508aa14dabe$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $24777508aa14dabe$var$divNearest(b2 * k, n);
            const c2 = $24777508aa14dabe$var$divNearest(-b1 * k, n);
            let k1 = (0, $f6Psy.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $f6Psy.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $9XCBn.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $24777508aa14dabe$var$_0n = BigInt(0);
const $24777508aa14dabe$var$fe = (x)=>typeof x === "bigint" && $24777508aa14dabe$var$_0n < x && x < $24777508aa14dabe$var$secp256k1P;
const $24777508aa14dabe$var$ge = (x)=>typeof x === "bigint" && $24777508aa14dabe$var$_0n < x && x < $24777508aa14dabe$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $24777508aa14dabe$var$TAGGED_HASH_PREFIXES = {};
function $24777508aa14dabe$var$taggedHash(tag, ...messages) {
    let tagP = $24777508aa14dabe$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $9XCBn.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $bY9yL.concatBytes)(tagH, tagH);
        $24777508aa14dabe$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $9XCBn.sha256)((0, $bY9yL.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $24777508aa14dabe$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $24777508aa14dabe$var$numTo32b = (n)=>(0, $bY9yL.numberToBytesBE)(n, 32);
const $24777508aa14dabe$var$modP = (x)=>(0, $f6Psy.mod)(x, $24777508aa14dabe$var$secp256k1P);
const $24777508aa14dabe$var$modN = (x)=>(0, $f6Psy.mod)(x, $24777508aa14dabe$var$secp256k1N);
const $24777508aa14dabe$var$Point = module.exports.secp256k1.ProjectivePoint;
const $24777508aa14dabe$var$GmulAdd = (Q, a, b)=>$24777508aa14dabe$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $24777508aa14dabe$var$schnorrGetExtPubKey(priv) {
    let d_ = module.exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $24777508aa14dabe$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $24777508aa14dabe$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $24777508aa14dabe$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $24777508aa14dabe$var$lift_x(x) {
    if (!$24777508aa14dabe$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $24777508aa14dabe$var$modP(x * x);
    const c = $24777508aa14dabe$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $24777508aa14dabe$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $24777508aa14dabe$var$_2n !== $24777508aa14dabe$var$_0n) y = $24777508aa14dabe$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $24777508aa14dabe$var$Point(x, y, $24777508aa14dabe$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $24777508aa14dabe$var$challenge(...args) {
    return $24777508aa14dabe$var$modN((0, $bY9yL.bytesToNumberBE)($24777508aa14dabe$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $24777508aa14dabe$var$schnorrGetPublicKey(privateKey) {
    return $24777508aa14dabe$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $24777508aa14dabe$var$schnorrSign(message, privateKey, auxRand = (0, $bzzBR.randomBytes)(32)) {
    const m = (0, $bY9yL.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $24777508aa14dabe$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $bY9yL.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $24777508aa14dabe$var$numTo32b(d ^ (0, $bY9yL.bytesToNumberBE)($24777508aa14dabe$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $24777508aa14dabe$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $24777508aa14dabe$var$modN((0, $bY9yL.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $24777508aa14dabe$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $24777508aa14dabe$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $24777508aa14dabe$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($24777508aa14dabe$var$numTo32b($24777508aa14dabe$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$24777508aa14dabe$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $24777508aa14dabe$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $bY9yL.ensureBytes)("signature", signature, 64);
    const m = (0, $bY9yL.ensureBytes)("message", message);
    const pub = (0, $bY9yL.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $24777508aa14dabe$var$lift_x((0, $bY9yL.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $bY9yL.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$24777508aa14dabe$var$fe(r)) return false;
        const s = (0, $bY9yL.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$24777508aa14dabe$var$ge(s)) return false;
        const e = $24777508aa14dabe$var$challenge($24777508aa14dabe$var$numTo32b(r), $24777508aa14dabe$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $24777508aa14dabe$var$GmulAdd(P, s, $24777508aa14dabe$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
module.exports.schnorr = (()=>({
        getPublicKey: $24777508aa14dabe$var$schnorrGetPublicKey,
        sign: $24777508aa14dabe$var$schnorrSign,
        verify: $24777508aa14dabe$var$schnorrVerify,
        utils: {
            randomPrivateKey: module.exports.secp256k1.utils.randomPrivateKey,
            lift_x: $24777508aa14dabe$var$lift_x,
            pointToBytes: $24777508aa14dabe$var$pointToBytes,
            numberToBytesBE: $bY9yL.numberToBytesBE,
            bytesToNumberBE: $bY9yL.bytesToNumberBE,
            taggedHash: $24777508aa14dabe$var$taggedHash,
            mod: $f6Psy.mod
        }
    }))();
const $24777508aa14dabe$var$isoMap = /* @__PURE__ */ (()=>(0, $9CBZF.isogenyMap)($24777508aa14dabe$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $24777508aa14dabe$var$mapSWU = /* @__PURE__ */ (()=>(0, $11W5Z.mapToCurveSimpleSWU)($24777508aa14dabe$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $24777508aa14dabe$var$Fp.create(BigInt("-11"))
    }))();
const $24777508aa14dabe$var$htf = /* @__PURE__ */ (()=>(0, $9CBZF.createHasher)(module.exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $24777508aa14dabe$var$mapSWU($24777508aa14dabe$var$Fp.create(scalars[0]));
        return $24777508aa14dabe$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $24777508aa14dabe$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $9XCBn.sha256
    }))();
module.exports.hashToCurve = (()=>$24777508aa14dabe$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$24777508aa14dabe$var$htf.encodeToCurve)();

});
parcelRegister("11W5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapToCurveSimpleSWU = module.exports.SWUFpSqrtRatio = module.exports.weierstrass = module.exports.weierstrassPoints = module.exports.DER = void 0;

var $f6Psy = parcelRequire("f6Psy");

var $bY9yL = parcelRequire("bY9yL");

var $bY9yL = parcelRequire("bY9yL");

var $bEub4 = parcelRequire("bEub4");
function $0c02f2fe1cbfd863$var$validatePointOpts(curve) {
    const opts = (0, $bEub4.validateBasic)(curve);
    $bY9yL.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $0c02f2fe1cbfd863$var$b2n, hexToBytes: $0c02f2fe1cbfd863$var$h2b } = $bY9yL;
module.exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = module.exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $0c02f2fe1cbfd863$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = module.exports.DER;
        const data = typeof hex === "string" ? $0c02f2fe1cbfd863$var$h2b(hex) : hex;
        if (!$bY9yL.isBytes(data)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = module.exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = module.exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $0c02f2fe1cbfd863$var$_0n = BigInt(0), $0c02f2fe1cbfd863$var$_1n = BigInt(1), $0c02f2fe1cbfd863$var$_2n = BigInt(2), $0c02f2fe1cbfd863$var$_3n = BigInt(3), $0c02f2fe1cbfd863$var$_4n = BigInt(4);
function $0c02f2fe1cbfd863$var$weierstrassPoints(opts) {
    const CURVE = $0c02f2fe1cbfd863$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $bY9yL.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $0c02f2fe1cbfd863$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($bY9yL.isBytes(key)) key = $bY9yL.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $bY9yL.bytesToNumberBE((0, $bY9yL.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $f6Psy.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $bY9yL.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $0c02f2fe1cbfd863$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $0c02f2fe1cbfd863$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $0c02f2fe1cbfd863$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $0c02f2fe1cbfd863$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $0c02f2fe1cbfd863$var$_0n || k2 > $0c02f2fe1cbfd863$var$_0n){
                if (k1 & $0c02f2fe1cbfd863$var$_1n) k1p = k1p.add(d);
                if (k2 & $0c02f2fe1cbfd863$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $0c02f2fe1cbfd863$var$_1n;
                k2 >>= $0c02f2fe1cbfd863$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $0c02f2fe1cbfd863$var$_0n || a === $0c02f2fe1cbfd863$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $0c02f2fe1cbfd863$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $0c02f2fe1cbfd863$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $bY9yL.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $bEub4.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
module.exports.weierstrassPoints = $0c02f2fe1cbfd863$var$weierstrassPoints;
function $0c02f2fe1cbfd863$var$validateOpts(curve) {
    const opts = (0, $bEub4.validateBasic)(curve);
    $bY9yL.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $0c02f2fe1cbfd863$var$weierstrass(curveDef) {
    const CURVE = $0c02f2fe1cbfd863$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $0c02f2fe1cbfd863$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $f6Psy.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $f6Psy.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $0c02f2fe1cbfd863$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $bY9yL.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $bY9yL.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $0c02f2fe1cbfd863$var$_1n) === $0c02f2fe1cbfd863$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$bY9yL.bytesToHex($bY9yL.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $0c02f2fe1cbfd863$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$bY9yL.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $bY9yL.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = module.exports.DER.toSig((0, $bY9yL.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $bY9yL.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $bY9yL.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return module.exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $bY9yL.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $f6Psy.getMinHashLength(CURVE.n);
            return $f6Psy.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $bY9yL.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $bY9yL.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $bY9yL.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($0c02f2fe1cbfd863$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $bY9yL.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $bY9yL.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $bY9yL.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $bY9yL.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $bY9yL.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $0c02f2fe1cbfd863$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $0c02f2fe1cbfd863$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $0c02f2fe1cbfd863$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $bY9yL.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $bY9yL.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $bY9yL.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || $bY9yL.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof module.exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
module.exports.weierstrass = $0c02f2fe1cbfd863$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $0c02f2fe1cbfd863$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $0c02f2fe1cbfd863$var$_0n;
    for(let o = q - $0c02f2fe1cbfd863$var$_1n; o % $0c02f2fe1cbfd863$var$_2n === $0c02f2fe1cbfd863$var$_0n; o /= $0c02f2fe1cbfd863$var$_2n)l += $0c02f2fe1cbfd863$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $0c02f2fe1cbfd863$var$_2n << c1 - $0c02f2fe1cbfd863$var$_1n - $0c02f2fe1cbfd863$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $0c02f2fe1cbfd863$var$_2n;
    const c2 = (q - $0c02f2fe1cbfd863$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $0c02f2fe1cbfd863$var$_1n) / $0c02f2fe1cbfd863$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $0c02f2fe1cbfd863$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $0c02f2fe1cbfd863$var$_1n) / $0c02f2fe1cbfd863$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $0c02f2fe1cbfd863$var$_1n; i--){
            let tv5 = i - $0c02f2fe1cbfd863$var$_2n; // 18.    tv5 = i - 2
            tv5 = $0c02f2fe1cbfd863$var$_2n << tv5 - $0c02f2fe1cbfd863$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $0c02f2fe1cbfd863$var$_4n === $0c02f2fe1cbfd863$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $0c02f2fe1cbfd863$var$_3n) / $0c02f2fe1cbfd863$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
module.exports.SWUFpSqrtRatio = $0c02f2fe1cbfd863$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $0c02f2fe1cbfd863$var$mapToCurveSimpleSWU(Fp, opts) {
    $f6Psy.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $0c02f2fe1cbfd863$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
module.exports.mapToCurveSimpleSWU = $0c02f2fe1cbfd863$var$mapToCurveSimpleSWU;

});

parcelRegister("keQ7l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCurve = module.exports.getHash = void 0;

var $azkmV = parcelRequire("azkmV");

var $bzzBR = parcelRequire("bzzBR");

var $11W5Z = parcelRequire("11W5Z");
// connects noble-curves to noble-hashes
function $ebbd8ae54cda72b2$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $azkmV.hmac)(hash, key, (0, $bzzBR.concatBytes)(...msgs)),
        randomBytes: $bzzBR.randomBytes
    };
}
module.exports.getHash = $ebbd8ae54cda72b2$var$getHash;
function $ebbd8ae54cda72b2$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $11W5Z.weierstrass)({
            ...curveDef,
            ...$ebbd8ae54cda72b2$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
module.exports.createCurve = $ebbd8ae54cda72b2$var$createCurve;

});
parcelRegister("azkmV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $9Wm5b = parcelRequire("9Wm5b");

var $bzzBR = parcelRequire("bzzBR");
// HMAC (RFC 2104)
class $7b1cf91722ca7f85$var$HMAC extends $bzzBR.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $9Wm5b.hash)(hash);
        const key = (0, $bzzBR.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $9Wm5b.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $9Wm5b.exists)(this);
        (0, $9Wm5b.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $7b1cf91722ca7f85$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $7b1cf91722ca7f85$var$hmac = (hash, key, message)=>new $7b1cf91722ca7f85$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $7b1cf91722ca7f85$var$hmac;
module.exports.hmac.create = (hash, key)=>new $7b1cf91722ca7f85$var$HMAC(hash, key);

});




parcelRegister("9JmsZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VaultProgram = module.exports.VaultInstructions = module.exports.VaultKey = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");
var $7159be6cc71324b0$var$VaultKey;
(function(VaultKey) {
    VaultKey[VaultKey["Uninitialized"] = 0] = "Uninitialized";
    VaultKey[VaultKey["VaultV1"] = 3] = "VaultV1";
    VaultKey[VaultKey["SafetyDepositBoxV1"] = 1] = "SafetyDepositBoxV1";
    VaultKey[VaultKey["ExternalPriceAccountV1"] = 2] = "ExternalPriceAccountV1";
})($7159be6cc71324b0$var$VaultKey = module.exports.VaultKey || (module.exports.VaultKey = {}));
var $7159be6cc71324b0$var$VaultInstructions;
(function(VaultInstructions) {
    VaultInstructions[VaultInstructions["InitVault"] = 0] = "InitVault";
    VaultInstructions[VaultInstructions["AddTokenToInactiveVault"] = 1] = "AddTokenToInactiveVault";
    VaultInstructions[VaultInstructions["ActivateVault"] = 2] = "ActivateVault";
    VaultInstructions[VaultInstructions["CombineVault"] = 3] = "CombineVault";
    VaultInstructions[VaultInstructions["RedeemShares"] = 4] = "RedeemShares";
    VaultInstructions[VaultInstructions["WithdrawTokenFromSafetyDepositBox"] = 5] = "WithdrawTokenFromSafetyDepositBox";
    VaultInstructions[VaultInstructions["MintFractionalShares"] = 6] = "MintFractionalShares";
    VaultInstructions[VaultInstructions["WithdrawSharesFromTreasury"] = 7] = "WithdrawSharesFromTreasury";
    VaultInstructions[VaultInstructions["AddSharesToTreasury"] = 8] = "AddSharesToTreasury";
    VaultInstructions[VaultInstructions["UpdateExternalPriceAccount"] = 9] = "UpdateExternalPriceAccount";
    VaultInstructions[VaultInstructions["SetVaultAuthority"] = 10] = "SetVaultAuthority";
})($7159be6cc71324b0$var$VaultInstructions = module.exports.VaultInstructions || (module.exports.VaultInstructions = {}));
class $7159be6cc71324b0$var$VaultProgram extends $1jULY.Program {
}
module.exports.VaultProgram = $7159be6cc71324b0$var$VaultProgram;
$7159be6cc71324b0$var$VaultProgram.PREFIX = "vault";
$7159be6cc71324b0$var$VaultProgram.PUBKEY = new $1biTx.PublicKey($1jULY.config.programs.vault);

});
parcelRegister("1jULY", function(module, exports) {
"use strict";
var $0f639aac1f114ac2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f639aac1f114ac2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0f639aac1f114ac2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0f639aac1f114ac2$var$__exportStar((parcelRequire("kH3yO")), module.exports);

$0f639aac1f114ac2$var$__exportStar((parcelRequire("cLoKX")), module.exports);

$0f639aac1f114ac2$var$__exportStar((parcelRequire("g4ixw")), module.exports);

$0f639aac1f114ac2$var$__exportStar((parcelRequire("5MzAB")), module.exports);

$0f639aac1f114ac2$var$__exportStar((parcelRequire("3oCjM")), module.exports);

$0f639aac1f114ac2$var$__exportStar((parcelRequire("feOHt")), module.exports);

$0f639aac1f114ac2$var$__exportStar((parcelRequire("4NBGR")), module.exports);

});
parcelRegister("kH3yO", function(module, exports) {
"use strict";
var $f10a95d79fd68deb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f10a95d79fd68deb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f10a95d79fd68deb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f10a95d79fd68deb$var$__exportStar((parcelRequire("j0KgC")), module.exports);

$f10a95d79fd68deb$var$__exportStar((parcelRequire("fpgHR")), module.exports);

});
parcelRegister("j0KgC", function(module, exports) {
"use strict";
var $dd71e81745280ab7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account = void 0;

var $1biTx = parcelRequire("1biTx");

var $cbQCu = parcelRequire("cbQCu");

var $g4ixw = parcelRequire("g4ixw");
class $dd71e81745280ab7$var$Account {
    constructor(pubkey, info){
        this.pubkey = new $1biTx.PublicKey(pubkey);
        this.info = info;
    }
    static from(account) {
        return new this(account.pubkey, account.info);
    }
    static load(connection, pubkey) {
        return $dd71e81745280ab7$var$__awaiter(this, void 0, void 0, function*() {
            const info = yield $dd71e81745280ab7$var$Account.getInfo(connection, pubkey);
            return new this(pubkey, info);
        });
    }
    static isCompatible(_data) {
        throw new Error(`method 'isCompatible' is not implemented`);
    }
    static getInfo(connection, pubkey) {
        return $dd71e81745280ab7$var$__awaiter(this, void 0, void 0, function*() {
            const info = yield connection.getAccountInfo(new $1biTx.PublicKey(pubkey));
            if (!info) throw (0, $g4ixw.ERROR_ACCOUNT_NOT_FOUND)(pubkey);
            return Object.assign(Object.assign({}, info), {
                data: $cbQCu.Buffer.from(info === null || info === void 0 ? void 0 : info.data)
            });
        });
    }
    static getInfos(connection, pubkeys, commitment = "recent") {
        return $dd71e81745280ab7$var$__awaiter(this, void 0, void 0, function*() {
            const BATCH_SIZE = 99;
            const promises = [];
            for(let i = 0; i < pubkeys.length; i += BATCH_SIZE)promises.push($dd71e81745280ab7$var$Account.getMultipleAccounts(connection, pubkeys.slice(i, Math.min(pubkeys.length, i + BATCH_SIZE)), commitment));
            const results = new Map();
            (yield Promise.all(promises)).forEach((result)=>{
                var _a;
                return [
                    ...(_a = result === null || result === void 0 ? void 0 : result.entries()) !== null && _a !== void 0 ? _a : []
                ].forEach(([k, v])=>results.set(k, v));
            });
            return results;
        });
    }
    static getMultipleAccounts(connection, pubkeys, commitment) {
        return $dd71e81745280ab7$var$__awaiter(this, void 0, void 0, function*() {
            const args = connection._buildArgs([
                pubkeys.map((k)=>k.toString())
            ], commitment, "base64");
            const unsafeRes = yield connection._rpcRequest("getMultipleAccounts", args);
            if (unsafeRes.error) throw new Error("failed to get info about accounts " + unsafeRes.error.message);
            if (!unsafeRes.result.value) return;
            const infos = unsafeRes.result.value.filter(Boolean).map((info)=>Object.assign(Object.assign({}, info), {
                    data: $cbQCu.Buffer.from(info.data[0], "base64")
                }));
            return infos.reduce((acc, info, index)=>{
                acc.set(pubkeys[index], info);
                return acc;
            }, new Map());
        });
    }
    assertOwner(pubkey) {
        var _a;
        return (_a = this.info) === null || _a === void 0 ? void 0 : _a.owner.equals(new $1biTx.PublicKey(pubkey));
    }
    toJSON() {
        var _a, _b, _c, _d, _e;
        return {
            pubkey: this.pubkey.toString(),
            info: {
                executable: !!((_a = this.info) === null || _a === void 0 ? void 0 : _a.executable),
                owner: ((_b = this.info) === null || _b === void 0 ? void 0 : _b.owner) ? new $1biTx.PublicKey((_c = this.info) === null || _c === void 0 ? void 0 : _c.owner) : null,
                lamports: (_d = this.info) === null || _d === void 0 ? void 0 : _d.lamports,
                data: (_e = this.info) === null || _e === void 0 ? void 0 : _e.data.toJSON()
            },
            data: this.data
        };
    }
    toString() {
        return JSON.stringify(this.toJSON());
    }
}
module.exports.Account = $dd71e81745280ab7$var$Account;

});
parcelRegister("g4ixw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_ACCOUNT_NOT_FOUND = module.exports.ERROR_DEPRECATED_ACCOUNT_DATA = module.exports.ERROR_INVALID_ACCOUNT_DATA = module.exports.ERROR_INVALID_OWNER = module.exports.MetaplexError = module.exports.ErrorCode = void 0;
var $bb2b66ab3087bfb8$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["ERROR_INVALID_OWNER"] = 0] = "ERROR_INVALID_OWNER";
    ErrorCode[ErrorCode["ERROR_INVALID_ACCOUNT_DATA"] = 1] = "ERROR_INVALID_ACCOUNT_DATA";
    ErrorCode[ErrorCode["ERROR_DEPRECATED_ACCOUNT_DATA"] = 2] = "ERROR_DEPRECATED_ACCOUNT_DATA";
    ErrorCode[ErrorCode["ERROR_ACCOUNT_NOT_FOUND"] = 3] = "ERROR_ACCOUNT_NOT_FOUND";
})($bb2b66ab3087bfb8$var$ErrorCode = module.exports.ErrorCode || (module.exports.ErrorCode = {}));
class $bb2b66ab3087bfb8$var$MetaplexError extends Error {
    constructor(errorCode, message){
        super(message);
        this.errorCode = errorCode;
    }
}
module.exports.MetaplexError = $bb2b66ab3087bfb8$var$MetaplexError;
const $bb2b66ab3087bfb8$var$ERROR_INVALID_OWNER = ()=>{
    return new $bb2b66ab3087bfb8$var$MetaplexError($bb2b66ab3087bfb8$var$ErrorCode.ERROR_INVALID_OWNER, "Invalid owner");
};
module.exports.ERROR_INVALID_OWNER = $bb2b66ab3087bfb8$var$ERROR_INVALID_OWNER;
const $bb2b66ab3087bfb8$var$ERROR_INVALID_ACCOUNT_DATA = ()=>{
    return new $bb2b66ab3087bfb8$var$MetaplexError($bb2b66ab3087bfb8$var$ErrorCode.ERROR_INVALID_ACCOUNT_DATA, "Invalid data");
};
module.exports.ERROR_INVALID_ACCOUNT_DATA = $bb2b66ab3087bfb8$var$ERROR_INVALID_ACCOUNT_DATA;
const $bb2b66ab3087bfb8$var$ERROR_DEPRECATED_ACCOUNT_DATA = ()=>{
    return new $bb2b66ab3087bfb8$var$MetaplexError($bb2b66ab3087bfb8$var$ErrorCode.ERROR_DEPRECATED_ACCOUNT_DATA, "Account data is deprecated");
};
module.exports.ERROR_DEPRECATED_ACCOUNT_DATA = $bb2b66ab3087bfb8$var$ERROR_DEPRECATED_ACCOUNT_DATA;
const $bb2b66ab3087bfb8$var$ERROR_ACCOUNT_NOT_FOUND = (pubkey)=>{
    return new $bb2b66ab3087bfb8$var$MetaplexError($bb2b66ab3087bfb8$var$ErrorCode.ERROR_ACCOUNT_NOT_FOUND, `Unable to find account: ${pubkey}`);
};
module.exports.ERROR_ACCOUNT_NOT_FOUND = $bb2b66ab3087bfb8$var$ERROR_ACCOUNT_NOT_FOUND;

});


parcelRegister("fpgHR", function(module, exports) {
"use strict";
var $b376265a9f9295c3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserialize = module.exports.TokenAccount = void 0;

var $g4ixw = parcelRequire("g4ixw");

var $j0KgC = parcelRequire("j0KgC");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");
class $b376265a9f9295c3$var$TokenAccount extends $j0KgC.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($febfi.TOKEN_PROGRAM_ID)) throw (0, $g4ixw.ERROR_INVALID_OWNER)();
        if (!$b376265a9f9295c3$var$TokenAccount.isCompatible(this.info.data)) throw (0, $g4ixw.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = (0, module.exports.deserialize)(this.info.data);
    }
    static isCompatible(data) {
        return data.length === $febfi.AccountLayout.span;
    }
    static getTokenAccountsByOwner(connection, owner) {
        return $b376265a9f9295c3$var$__awaiter(this, void 0, void 0, function*() {
            return (yield connection.getTokenAccountsByOwner(new $1biTx.PublicKey(owner), {
                programId: $febfi.TOKEN_PROGRAM_ID
            })).value.map(({ pubkey: pubkey, account: account })=>new $b376265a9f9295c3$var$TokenAccount(pubkey, account));
        });
    }
}
module.exports.TokenAccount = $b376265a9f9295c3$var$TokenAccount;
const $b376265a9f9295c3$var$deserialize = (data)=>{
    const accountInfo = $febfi.AccountLayout.decode(data);
    accountInfo.mint = new $1biTx.PublicKey(accountInfo.mint);
    accountInfo.owner = new $1biTx.PublicKey(accountInfo.owner);
    accountInfo.amount = $febfi.u64.fromBuffer(accountInfo.amount);
    if (accountInfo.delegateOption === 0) {
        accountInfo.delegate = null;
        accountInfo.delegatedAmount = new $febfi.u64(0);
    } else {
        accountInfo.delegate = new $1biTx.PublicKey(accountInfo.delegate);
        accountInfo.delegatedAmount = $febfi.u64.fromBuffer(accountInfo.delegatedAmount);
    }
    accountInfo.isInitialized = accountInfo.state !== 0;
    accountInfo.isFrozen = accountInfo.state === 2;
    if (accountInfo.isNativeOption === 1) {
        accountInfo.rentExemptReserve = $febfi.u64.fromBuffer(accountInfo.isNative);
        accountInfo.isNative = true;
    } else {
        accountInfo.rentExemptReserve = null;
        accountInfo.isNative = false;
    }
    if (accountInfo.closeAuthorityOption === 0) accountInfo.closeAuthority = null;
    else accountInfo.closeAuthority = new $1biTx.PublicKey(accountInfo.closeAuthority);
    return accountInfo;
};
module.exports.deserialize = $b376265a9f9295c3$var$deserialize;

});
parcelRegister("febfi", function(module, exports) {

$parcel$export(module.exports, "TOKEN_PROGRAM_ID", () => $b160e2fbc6182d4d$export$79de3e3c2b1ca801);
$parcel$export(module.exports, "ASSOCIATED_TOKEN_PROGRAM_ID", () => $b160e2fbc6182d4d$export$57a4f33bcc1767fa);
$parcel$export(module.exports, "u64", () => $b160e2fbc6182d4d$export$cd1442401e54cffa);
$parcel$export(module.exports, "NATIVE_MINT", () => $b160e2fbc6182d4d$export$71f490c6a4aef7af);
$parcel$export(module.exports, "MintLayout", () => $b160e2fbc6182d4d$export$1374e91decd2fbe5);
$parcel$export(module.exports, "AccountLayout", () => $b160e2fbc6182d4d$export$cab31ec27f6c5fa);
$parcel$export(module.exports, "Token", () => $b160e2fbc6182d4d$export$50792b0e93539fde);

var $5V9Vg = parcelRequire("5V9Vg");

var $cj5EG = parcelRequire("cj5EG");

var $1biTx = parcelRequire("1biTx");
var $b160e2fbc6182d4d$var$buffer = {};
var $b160e2fbc6182d4d$var$base64Js = {};
$b160e2fbc6182d4d$var$base64Js.byteLength = $b160e2fbc6182d4d$var$byteLength;
$b160e2fbc6182d4d$var$base64Js.toByteArray = $b160e2fbc6182d4d$var$toByteArray;
$b160e2fbc6182d4d$var$base64Js.fromByteArray = $b160e2fbc6182d4d$var$fromByteArray;
var $b160e2fbc6182d4d$var$lookup = [];
var $b160e2fbc6182d4d$var$revLookup = [];
var $b160e2fbc6182d4d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $b160e2fbc6182d4d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $b160e2fbc6182d4d$var$i = 0, $b160e2fbc6182d4d$var$len = $b160e2fbc6182d4d$var$code.length; $b160e2fbc6182d4d$var$i < $b160e2fbc6182d4d$var$len; ++$b160e2fbc6182d4d$var$i){
    $b160e2fbc6182d4d$var$lookup[$b160e2fbc6182d4d$var$i] = $b160e2fbc6182d4d$var$code[$b160e2fbc6182d4d$var$i];
    $b160e2fbc6182d4d$var$revLookup[$b160e2fbc6182d4d$var$code.charCodeAt($b160e2fbc6182d4d$var$i)] = $b160e2fbc6182d4d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$b160e2fbc6182d4d$var$revLookup["-".charCodeAt(0)] = 62;
$b160e2fbc6182d4d$var$revLookup["_".charCodeAt(0)] = 63;
function $b160e2fbc6182d4d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $b160e2fbc6182d4d$var$byteLength(b64) {
    var lens = $b160e2fbc6182d4d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b160e2fbc6182d4d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b160e2fbc6182d4d$var$toByteArray(b64) {
    var tmp;
    var lens = $b160e2fbc6182d4d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $b160e2fbc6182d4d$var$Arr($b160e2fbc6182d4d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i)] << 18 | $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i)] << 2 | $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i)] << 10 | $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $b160e2fbc6182d4d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $b160e2fbc6182d4d$var$tripletToBase64(num) {
    return $b160e2fbc6182d4d$var$lookup[num >> 18 & 0x3F] + $b160e2fbc6182d4d$var$lookup[num >> 12 & 0x3F] + $b160e2fbc6182d4d$var$lookup[num >> 6 & 0x3F] + $b160e2fbc6182d4d$var$lookup[num & 0x3F];
}
function $b160e2fbc6182d4d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($b160e2fbc6182d4d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $b160e2fbc6182d4d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($b160e2fbc6182d4d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($b160e2fbc6182d4d$var$lookup[tmp >> 2] + $b160e2fbc6182d4d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($b160e2fbc6182d4d$var$lookup[tmp >> 10] + $b160e2fbc6182d4d$var$lookup[tmp >> 4 & 0x3F] + $b160e2fbc6182d4d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}
var $b160e2fbc6182d4d$var$ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ $b160e2fbc6182d4d$var$ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$b160e2fbc6182d4d$var$ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ (function(exports) {
    const base64 = $b160e2fbc6182d4d$var$base64Js;
    const ieee754$1 = $b160e2fbc6182d4d$var$ieee754;
    const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
     ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    const K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            const arr = new Uint8Array(1);
            const proto = {
                foo: function() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, "parent", {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, "offset", {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
        // Return an augmented `Uint8Array` instance
        const buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === "number") {
            if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === "string") return fromString(value, encodingOrOffset);
        if (ArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        const b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    };
    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer, Uint8Array);
    function assertSize(size) {
        if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
        if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        const length = byteLength(string, encoding) | 0;
        let buf = createBuffer(length);
        const actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        const length = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length);
        for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, Uint8Array)) {
            const copy = new Uint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        let buf;
        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
        else buf = new Uint8Array(array, byteOffset, length);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            const len = checked(obj.length) | 0;
            const buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
        ;
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        let x = a.length;
        let y = b.length;
        for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        let i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        const buffer = Buffer.allocUnsafe(length);
        let pos = 0;
        for(i = 0; i < list.length; ++i){
            let buf = list[i];
            if (isInstance(buf, Uint8Array)) {
                if (pos + buf.length > buffer.length) {
                    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                    buf.copy(buffer, pos);
                } else Uint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
        if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0;
        // Use a for loop to avoid recursion
        let loweredCase = false;
        for(;;)switch(encoding){
            case "ascii":
            case "latin1":
            case "binary":
                return len;
            case "utf8":
            case "utf-8":
                return utf8ToBytes(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return len * 2;
            case "hex":
                return len >>> 1;
            case "base64":
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                ;
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        let loweredCase = false;
        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
        // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return "";
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return "";
        // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return "";
        if (!encoding) encoding = "utf8";
        while(true)switch(encoding){
            case "hex":
                return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
                return utf8Slice(this, start, end);
            case "ascii":
                return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
                return latin1Slice(this, start, end);
            case "base64":
                return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = (encoding + "").toLowerCase();
                loweredCase = true;
        }
    }
    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        const i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(let i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(let i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        const length = this.length;
        if (length === 0) return "";
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        let str = "";
        const max = exports.INSPECT_MAX_BYTES;
        str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
        if (this.length > max) str += " ... ";
        return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1;
        // Normalize byteOffset
        if (typeof byteOffset === "string") {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
        // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        }
        // Normalize val
        if (typeof val === "string") val = Buffer.from(val, encoding);
        // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof Uint8Array.prototype.indexOf === "function") {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        let i;
        if (dir) {
            let foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                let found = true;
                for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        const strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        let i;
        for(i = 0; i < length; ++i){
            const parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = "utf8";
            length = this.length;
            offset = 0;
        // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === "string") {
            encoding = offset;
            length = this.length;
            offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = "utf8";
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        const remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        if (!encoding) encoding = "utf8";
        let loweredCase = false;
        for(;;)switch(encoding){
            case "hex":
                return hexWrite(this, string, offset, length);
            case "utf8":
            case "utf-8":
                return utf8Write(this, string, offset, length);
            case "ascii":
            case "latin1":
            case "binary":
                return asciiWrite(this, string, offset, length);
            case "base64":
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
        else return base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i = start;
        while(i < end){
            const firstByte = buf[i];
            let codePoint = null;
            let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                let secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    }
    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    const MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
        ;
        // Decode in chunks to avoid "call stack size exceeded".
        let res = "";
        let i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        let out = "";
        for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        const bytes = buf.slice(start, end);
        let res = "";
        // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        const newBuf = this.subarray(start, end);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
        if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset + --byteLength];
        let mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let i = byteLength;
        let mul = 1;
        let val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24); // Overflow
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = (first << 24) + // Overflow
        this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
    });
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let mul = 1;
        let i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let i = byteLength - 1;
        let mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
    }
    Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = byteLength - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
        if (offset < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    };
    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        // Fatal error conditions
        if (targetStart < 0) throw new RangeError("targetStart out of bounds");
        if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
        if (end < 0) throw new RangeError("sourceEnd out of bounds");
        // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        const len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    };
    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === "string") {
            if (typeof start === "string") {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === "string") {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
            if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
            if (val.length === 1) {
                const code = val.charCodeAt(0);
                if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === "number") val = val & 255;
        else if (typeof val === "boolean") val = Number(val);
        // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        let i;
        if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
        else {
            const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            const len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    };
    // CUSTOM ERRORS
    // =============
    // Simplified versions from Node, changed for Buffer-only usage
    const errors = {};
    function E(sym, getMessage, Base) {
        errors[sym] = class NodeError extends Base {
            constructor(){
                super();
                Object.defineProperty(this, "message", {
                    value: getMessage.apply(this, arguments),
                    writable: true,
                    configurable: true
                });
                // Add the error code to the name to include it in the stack trace.
                this.name = `${this.name} [${sym}]`;
                // Access the stack to generate the error message including the error code
                // from the name.
                this.stack; // eslint-disable-line no-unused-expressions
                // Reset the name to the actual name.
                delete this.name;
            }
            get code() {
                return sym;
            }
            set code(value) {
                Object.defineProperty(this, "code", {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                });
            }
            toString() {
                return `${this.name} [${sym}]: ${this.message}`;
            }
        };
    }
    E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
        if (name) return `${name} is outside of buffer bounds`;
        return "Attempt to access memory outside buffer bounds";
    }, RangeError);
    E("ERR_INVALID_ARG_TYPE", function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError);
    E("ERR_OUT_OF_RANGE", function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
        else if (typeof input === "bigint") {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
            received += "n";
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
    }, RangeError);
    function addNumericalSeparator(val) {
        let res = "";
        let i = val.length;
        const start = val[0] === "-" ? 1 : 0;
        for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
        return `${val.slice(0, i)}${res}`;
    }
    // CHECK FUNCTIONS
    // ===============
    function checkBounds(buf, offset, byteLength) {
        validateNumber(offset, "offset");
        if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
    }
    function checkIntBI(value, min, max, buf, offset, byteLength) {
        if (value > max || value < min) {
            const n = typeof min === "bigint" ? "n" : "";
            let range;
            if (byteLength > 3) {
                if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
                else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
            } else range = `>= ${min}${n} and <= ${max}${n}`;
            throw new errors.ERR_OUT_OF_RANGE("value", range, value);
        }
        checkBounds(buf, offset, byteLength);
    }
    function validateNumber(value, name) {
        if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
    }
    function boundsError(value, length, type) {
        if (Math.floor(value) !== value) {
            validateNumber(value, type);
            throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
        }
        if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
    }
    // HELPER FUNCTIONS
    // ================
    const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split("=")[0];
        // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, "");
        // Node converts strings with length < 2 to ''
        if (str.length < 2) return "";
        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + "=";
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        let codePoint;
        const length = string.length;
        let leadSurrogate = null;
        const bytes = [];
        for(let i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i);
            // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    }
                    // valid lead
                    leadSurrogate = codePoint;
                    continue;
                }
                // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                }
                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null;
            // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error("Invalid code point");
        }
        return bytes;
    }
    function asciiToBytes(str) {
        const byteArray = [];
        for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for(let i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        let i;
        for(i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    }
    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj // eslint-disable-line no-self-compare
        ;
    }
    // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    const hexSliceLookupTable = function() {
        const alphabet = "0123456789abcdef";
        const table = new Array(256);
        for(let i = 0; i < 16; ++i){
            const i16 = i * 16;
            for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
    // Return not function with Error if BigInt not supported
    function defineBigIntMethod(fn) {
        return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
        throw new Error("BigInt not supported");
    }
})($b160e2fbc6182d4d$var$buffer);
var $b160e2fbc6182d4d$var$global$1 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var $b160e2fbc6182d4d$var$inherits;
if (typeof Object.create === "function") $b160e2fbc6182d4d$var$inherits = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else $b160e2fbc6182d4d$var$inherits = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var $b160e2fbc6182d4d$var$inherits$1 = $b160e2fbc6182d4d$var$inherits;
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $b160e2fbc6182d4d$var$inspect$1(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $b160e2fbc6182d4d$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($b160e2fbc6182d4d$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $b160e2fbc6182d4d$var$_extend(ctx, opts);
    // set default options
    if ($b160e2fbc6182d4d$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($b160e2fbc6182d4d$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($b160e2fbc6182d4d$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($b160e2fbc6182d4d$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $b160e2fbc6182d4d$var$stylizeWithColor;
    return $b160e2fbc6182d4d$var$formatValue(ctx, obj, ctx.depth);
}
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$b160e2fbc6182d4d$var$inspect$1.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$b160e2fbc6182d4d$var$inspect$1.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $b160e2fbc6182d4d$var$stylizeWithColor(str, styleType) {
    var style = $b160e2fbc6182d4d$var$inspect$1.styles[styleType];
    if (style) return "\x1b[" + $b160e2fbc6182d4d$var$inspect$1.colors[style][0] + "m" + str + "\x1b[" + $b160e2fbc6182d4d$var$inspect$1.colors[style][1] + "m";
    else return str;
}
function $b160e2fbc6182d4d$var$stylizeNoColor(str, styleType) {
    return str;
}
function $b160e2fbc6182d4d$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $b160e2fbc6182d4d$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $b160e2fbc6182d4d$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $b160e2fbc6182d4d$var$inspect$1 && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$b160e2fbc6182d4d$var$isString(ret)) ret = $b160e2fbc6182d4d$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $b160e2fbc6182d4d$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $b160e2fbc6182d4d$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($b160e2fbc6182d4d$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $b160e2fbc6182d4d$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($b160e2fbc6182d4d$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($b160e2fbc6182d4d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($b160e2fbc6182d4d$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($b160e2fbc6182d4d$var$isError(value)) return $b160e2fbc6182d4d$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($b160e2fbc6182d4d$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($b160e2fbc6182d4d$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($b160e2fbc6182d4d$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($b160e2fbc6182d4d$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($b160e2fbc6182d4d$var$isError(value)) base = " " + $b160e2fbc6182d4d$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($b160e2fbc6182d4d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $b160e2fbc6182d4d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $b160e2fbc6182d4d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $b160e2fbc6182d4d$var$reduceToSingleString(output, base, braces);
}
function $b160e2fbc6182d4d$var$formatPrimitive(ctx, value) {
    if ($b160e2fbc6182d4d$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($b160e2fbc6182d4d$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($b160e2fbc6182d4d$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($b160e2fbc6182d4d$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($b160e2fbc6182d4d$var$isNull(value)) return ctx.stylize("null", "null");
}
function $b160e2fbc6182d4d$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $b160e2fbc6182d4d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($b160e2fbc6182d4d$var$hasOwnProperty(value, String(i))) output.push($b160e2fbc6182d4d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($b160e2fbc6182d4d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $b160e2fbc6182d4d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$b160e2fbc6182d4d$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($b160e2fbc6182d4d$var$isNull(recurseTimes)) str = $b160e2fbc6182d4d$var$formatValue(ctx, desc.value, null);
            else str = $b160e2fbc6182d4d$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($b160e2fbc6182d4d$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $b160e2fbc6182d4d$var$reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
        cur.indexOf("\n");
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function $b160e2fbc6182d4d$var$isArray(ar) {
    return Array.isArray(ar);
}
function $b160e2fbc6182d4d$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
function $b160e2fbc6182d4d$var$isNull(arg) {
    return arg === null;
}
function $b160e2fbc6182d4d$var$isNumber(arg) {
    return typeof arg === "number";
}
function $b160e2fbc6182d4d$var$isString(arg) {
    return typeof arg === "string";
}
function $b160e2fbc6182d4d$var$isUndefined(arg) {
    return arg === void 0;
}
function $b160e2fbc6182d4d$var$isRegExp(re) {
    return $b160e2fbc6182d4d$var$isObject(re) && $b160e2fbc6182d4d$var$objectToString(re) === "[object RegExp]";
}
function $b160e2fbc6182d4d$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $b160e2fbc6182d4d$var$isDate(d) {
    return $b160e2fbc6182d4d$var$isObject(d) && $b160e2fbc6182d4d$var$objectToString(d) === "[object Date]";
}
function $b160e2fbc6182d4d$var$isError(e) {
    return $b160e2fbc6182d4d$var$isObject(e) && ($b160e2fbc6182d4d$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
function $b160e2fbc6182d4d$var$isFunction(arg) {
    return typeof arg === "function";
}
function $b160e2fbc6182d4d$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
function $b160e2fbc6182d4d$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $b160e2fbc6182d4d$var$_extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$b160e2fbc6182d4d$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}
function $b160e2fbc6182d4d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $b160e2fbc6182d4d$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $b160e2fbc6182d4d$var$hasOwn = Object.prototype.hasOwnProperty;
var $b160e2fbc6182d4d$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)if ($b160e2fbc6182d4d$var$hasOwn.call(obj, key)) keys.push(key);
    return keys;
};
var $b160e2fbc6182d4d$var$pSlice = Array.prototype.slice;
var $b160e2fbc6182d4d$var$_functionsHaveNames;
function $b160e2fbc6182d4d$var$functionsHaveNames() {
    if (typeof $b160e2fbc6182d4d$var$_functionsHaveNames !== "undefined") return $b160e2fbc6182d4d$var$_functionsHaveNames;
    return $b160e2fbc6182d4d$var$_functionsHaveNames = function() {
        return (function foo() {}).name === "foo";
    }();
}
function $b160e2fbc6182d4d$var$pToString(obj) {
    return Object.prototype.toString.call(obj);
}
function $b160e2fbc6182d4d$var$isView(arrbuf) {
    if ($b160e2fbc6182d4d$var$buffer.isBuffer(arrbuf)) return false;
    if (typeof $b160e2fbc6182d4d$var$global$1.ArrayBuffer !== "function") return false;
    if (typeof ArrayBuffer.isView === "function") return ArrayBuffer.isView(arrbuf);
    if (!arrbuf) return false;
    if (arrbuf instanceof DataView) return true;
    if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) return true;
    return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
function $b160e2fbc6182d4d$var$assert(value, message) {
    if (!value) $b160e2fbc6182d4d$var$fail(value, true, message, "==", $b160e2fbc6182d4d$var$ok);
}
// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })
var $b160e2fbc6182d4d$var$regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function $b160e2fbc6182d4d$var$getName(func) {
    if (!$b160e2fbc6182d4d$var$isFunction(func)) return;
    if ($b160e2fbc6182d4d$var$functionsHaveNames()) return func.name;
    var str = func.toString();
    var match = str.match($b160e2fbc6182d4d$var$regex);
    return match && match[1];
}
$b160e2fbc6182d4d$var$assert.AssertionError = $b160e2fbc6182d4d$var$AssertionError;
function $b160e2fbc6182d4d$var$AssertionError(options) {
    this.name = "AssertionError";
    this.actual = options.actual;
    this.expected = options.expected;
    this.operator = options.operator;
    if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
    } else {
        this.message = $b160e2fbc6182d4d$var$getMessage(this);
        this.generatedMessage = true;
    }
    var stackStartFunction = options.stackStartFunction || $b160e2fbc6182d4d$var$fail;
    if (Error.captureStackTrace) Error.captureStackTrace(this, stackStartFunction);
    else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();
        if (err.stack) {
            var out = err.stack;
            // try to strip useless frames
            var fn_name = $b160e2fbc6182d4d$var$getName(stackStartFunction);
            var idx = out.indexOf("\n" + fn_name);
            if (idx >= 0) {
                // once we have located the function frame
                // we need to strip out everything before it (and its line)
                var next_line = out.indexOf("\n", idx + 1);
                out = out.substring(next_line + 1);
            }
            this.stack = out;
        }
    }
}
// assert.AssertionError instanceof Error
$b160e2fbc6182d4d$var$inherits$1($b160e2fbc6182d4d$var$AssertionError, Error);
function $b160e2fbc6182d4d$var$truncate(s, n) {
    if (typeof s === "string") return s.length < n ? s : s.slice(0, n);
    else return s;
}
function $b160e2fbc6182d4d$var$inspect(something) {
    if ($b160e2fbc6182d4d$var$functionsHaveNames() || !$b160e2fbc6182d4d$var$isFunction(something)) return $b160e2fbc6182d4d$var$inspect$1(something);
    var rawname = $b160e2fbc6182d4d$var$getName(something);
    var name = rawname ? ": " + rawname : "";
    return "[Function" + name + "]";
}
function $b160e2fbc6182d4d$var$getMessage(self1) {
    return $b160e2fbc6182d4d$var$truncate($b160e2fbc6182d4d$var$inspect(self1.actual), 128) + " " + self1.operator + " " + $b160e2fbc6182d4d$var$truncate($b160e2fbc6182d4d$var$inspect(self1.expected), 128);
}
// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.
// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $b160e2fbc6182d4d$var$fail(actual, expected, message, operator, stackStartFunction) {
    throw new $b160e2fbc6182d4d$var$AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
    });
}
// EXTENSION! allows for well behaved errors defined elsewhere.
$b160e2fbc6182d4d$var$assert.fail = $b160e2fbc6182d4d$var$fail;
// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.
function $b160e2fbc6182d4d$var$ok(value, message) {
    if (!value) $b160e2fbc6182d4d$var$fail(value, true, message, "==", $b160e2fbc6182d4d$var$ok);
}
$b160e2fbc6182d4d$var$assert.ok = $b160e2fbc6182d4d$var$ok;
// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);
$b160e2fbc6182d4d$var$assert.equal = $b160e2fbc6182d4d$var$equal;
function $b160e2fbc6182d4d$var$equal(actual, expected, message) {
    if (actual != expected) $b160e2fbc6182d4d$var$fail(actual, expected, message, "==", $b160e2fbc6182d4d$var$equal);
}
// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);
$b160e2fbc6182d4d$var$assert.notEqual = $b160e2fbc6182d4d$var$notEqual;
function $b160e2fbc6182d4d$var$notEqual(actual, expected, message) {
    if (actual == expected) $b160e2fbc6182d4d$var$fail(actual, expected, message, "!=", $b160e2fbc6182d4d$var$notEqual);
}
// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);
$b160e2fbc6182d4d$var$assert.deepEqual = $b160e2fbc6182d4d$var$deepEqual;
function $b160e2fbc6182d4d$var$deepEqual(actual, expected, message) {
    if (!$b160e2fbc6182d4d$var$_deepEqual(actual, expected, false)) $b160e2fbc6182d4d$var$fail(actual, expected, message, "deepEqual", $b160e2fbc6182d4d$var$deepEqual);
}
$b160e2fbc6182d4d$var$assert.deepStrictEqual = $b160e2fbc6182d4d$var$deepStrictEqual;
function $b160e2fbc6182d4d$var$deepStrictEqual(actual, expected, message) {
    if (!$b160e2fbc6182d4d$var$_deepEqual(actual, expected, true)) $b160e2fbc6182d4d$var$fail(actual, expected, message, "deepStrictEqual", $b160e2fbc6182d4d$var$deepStrictEqual);
}
function $b160e2fbc6182d4d$var$_deepEqual(actual, expected, strict, memos) {
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if ($b160e2fbc6182d4d$var$buffer.isBuffer(actual) && $b160e2fbc6182d4d$var$buffer.isBuffer(expected)) return $b160e2fbc6182d4d$var$compare(actual, expected) === 0;
    else if ($b160e2fbc6182d4d$var$isDate(actual) && $b160e2fbc6182d4d$var$isDate(expected)) return actual.getTime() === expected.getTime();
    else if ($b160e2fbc6182d4d$var$isRegExp(actual) && $b160e2fbc6182d4d$var$isRegExp(expected)) return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
    else if ((actual === null || typeof actual !== "object") && (expected === null || typeof expected !== "object")) return strict ? actual === expected : actual == expected;
    else if ($b160e2fbc6182d4d$var$isView(actual) && $b160e2fbc6182d4d$var$isView(expected) && $b160e2fbc6182d4d$var$pToString(actual) === $b160e2fbc6182d4d$var$pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) return $b160e2fbc6182d4d$var$compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
    else if ($b160e2fbc6182d4d$var$buffer.isBuffer(actual) !== $b160e2fbc6182d4d$var$buffer.isBuffer(expected)) return false;
    else {
        memos = memos || {
            actual: [],
            expected: []
        };
        var actualIndex = memos.actual.indexOf(actual);
        if (actualIndex !== -1) {
            if (actualIndex === memos.expected.indexOf(expected)) return true;
        }
        memos.actual.push(actual);
        memos.expected.push(expected);
        return $b160e2fbc6182d4d$var$objEquiv(actual, expected, strict, memos);
    }
}
function $b160e2fbc6182d4d$var$isArguments(object) {
    return Object.prototype.toString.call(object) == "[object Arguments]";
}
function $b160e2fbc6182d4d$var$objEquiv(a, b, strict, actualVisitedObjects) {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    // if one is a primitive, the other must be same
    if ($b160e2fbc6182d4d$var$isPrimitive(a) || $b160e2fbc6182d4d$var$isPrimitive(b)) return a === b;
    if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
    var aIsArgs = $b160e2fbc6182d4d$var$isArguments(a);
    var bIsArgs = $b160e2fbc6182d4d$var$isArguments(b);
    if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
    if (aIsArgs) {
        a = $b160e2fbc6182d4d$var$pSlice.call(a);
        b = $b160e2fbc6182d4d$var$pSlice.call(b);
        return $b160e2fbc6182d4d$var$_deepEqual(a, b, strict);
    }
    var ka = $b160e2fbc6182d4d$var$objectKeys(a);
    var kb = $b160e2fbc6182d4d$var$objectKeys(b);
    var key, i;
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length !== kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] !== kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$b160e2fbc6182d4d$var$_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
    }
    return true;
}
// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);
$b160e2fbc6182d4d$var$assert.notDeepEqual = $b160e2fbc6182d4d$var$notDeepEqual;
function $b160e2fbc6182d4d$var$notDeepEqual(actual, expected, message) {
    if ($b160e2fbc6182d4d$var$_deepEqual(actual, expected, false)) $b160e2fbc6182d4d$var$fail(actual, expected, message, "notDeepEqual", $b160e2fbc6182d4d$var$notDeepEqual);
}
$b160e2fbc6182d4d$var$assert.notDeepStrictEqual = $b160e2fbc6182d4d$var$notDeepStrictEqual;
function $b160e2fbc6182d4d$var$notDeepStrictEqual(actual, expected, message) {
    if ($b160e2fbc6182d4d$var$_deepEqual(actual, expected, true)) $b160e2fbc6182d4d$var$fail(actual, expected, message, "notDeepStrictEqual", $b160e2fbc6182d4d$var$notDeepStrictEqual);
}
// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);
$b160e2fbc6182d4d$var$assert.strictEqual = $b160e2fbc6182d4d$var$strictEqual;
function $b160e2fbc6182d4d$var$strictEqual(actual, expected, message) {
    if (actual !== expected) $b160e2fbc6182d4d$var$fail(actual, expected, message, "===", $b160e2fbc6182d4d$var$strictEqual);
}
// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
$b160e2fbc6182d4d$var$assert.notStrictEqual = $b160e2fbc6182d4d$var$notStrictEqual;
function $b160e2fbc6182d4d$var$notStrictEqual(actual, expected, message) {
    if (actual === expected) $b160e2fbc6182d4d$var$fail(actual, expected, message, "!==", $b160e2fbc6182d4d$var$notStrictEqual);
}
function $b160e2fbc6182d4d$var$expectedException(actual, expected) {
    if (!actual || !expected) return false;
    if (Object.prototype.toString.call(expected) == "[object RegExp]") return expected.test(actual);
    try {
        if (actual instanceof expected) return true;
    } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
    }
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $b160e2fbc6182d4d$var$_tryBlock(block) {
    var error;
    try {
        block();
    } catch (e) {
        error = e;
    }
    return error;
}
function $b160e2fbc6182d4d$var$_throws(shouldThrow, block, expected, message) {
    var actual;
    if (typeof block !== "function") throw new TypeError('"block" argument must be a function');
    if (typeof expected === "string") {
        message = expected;
        expected = null;
    }
    actual = $b160e2fbc6182d4d$var$_tryBlock(block);
    message = (expected && expected.name ? " (" + expected.name + ")." : ".") + (message ? " " + message : ".");
    if (shouldThrow && !actual) $b160e2fbc6182d4d$var$fail(actual, expected, "Missing expected exception" + message);
    var userProvidedMessage = typeof message === "string";
    var isUnwantedException = !shouldThrow && $b160e2fbc6182d4d$var$isError(actual);
    var isUnexpectedException = !shouldThrow && actual && !expected;
    if (isUnwantedException && userProvidedMessage && $b160e2fbc6182d4d$var$expectedException(actual, expected) || isUnexpectedException) $b160e2fbc6182d4d$var$fail(actual, expected, "Got unwanted exception" + message);
    if (shouldThrow && actual && expected && !$b160e2fbc6182d4d$var$expectedException(actual, expected) || !shouldThrow && actual) throw actual;
}
// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);
$b160e2fbc6182d4d$var$assert.throws = $b160e2fbc6182d4d$var$throws;
function $b160e2fbc6182d4d$var$throws(block, /*optional*/ error, /*optional*/ message) {
    $b160e2fbc6182d4d$var$_throws(true, block, error, message);
}
// EXTENSION! This is annoying to write outside this module.
$b160e2fbc6182d4d$var$assert.doesNotThrow = $b160e2fbc6182d4d$var$doesNotThrow;
function $b160e2fbc6182d4d$var$doesNotThrow(block, /*optional*/ error, /*optional*/ message) {
    $b160e2fbc6182d4d$var$_throws(false, block, error, message);
}
$b160e2fbc6182d4d$var$assert.ifError = $b160e2fbc6182d4d$var$ifError;
function $b160e2fbc6182d4d$var$ifError(err) {
    if (err) throw err;
}
var $b160e2fbc6182d4d$var$Layout$1 = {};
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $b160e2fbc6182d4d$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
     *
     * Positive values are generally expected.
     *
     * Zero will only appear in {@link Constant}s and in {@link
     * Sequence}s where the {@link Sequence#count|count} is zero.
     *
     * A negative value indicates that the span is value-specific, and
     * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
     * Object.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances.  If left undefined the span of the unnamed layout will
     * be treated as padding: it will not be mutated by {@link
     * Layout#encode|encode} nor represented as a property in the
     * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */ makeDestinationObject() {
        return {};
    }
    /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */ decode(b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */ encode(src, b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */ fromArray(values) {
        return undefined;
    }
}
$b160e2fbc6182d4d$var$Layout$1.Layout = $b160e2fbc6182d4d$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $b160e2fbc6182d4d$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
$b160e2fbc6182d4d$var$Layout$1.nameWithProperty = $b160e2fbc6182d4d$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ function $b160e2fbc6182d4d$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Class.hasOwnProperty("layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $b160e2fbc6182d4d$var$Layout)) throw new TypeError("layout must be a Layout");
    if (layout.hasOwnProperty("boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value: function(b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value: function(b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
$b160e2fbc6182d4d$var$Layout$1.bindConstructorLayout = $b160e2fbc6182d4d$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$ExternalLayout extends $b160e2fbc6182d4d$var$Layout {
    /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $b160e2fbc6182d4d$var$GreedyCount extends $b160e2fbc6182d4d$var$ExternalLayout {
    constructor(elementSpan, property){
        if (undefined === elementSpan) elementSpan = 1;
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
     * must be a positive integer.  If not provided, the value will be
     * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$OffsetLayout extends $b160e2fbc6182d4d$var$ExternalLayout {
    constructor(layout, offset, property){
        if (!(layout instanceof $b160e2fbc6182d4d$var$Layout)) throw new TypeError("layout must be a Layout");
        if (undefined === offset) offset = 0;
        else if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
     * start of another layout.
     *
     * The value may be positive or negative, but an error will thrown
     * if at the point of use it goes outside the span of the Buffer
     * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $b160e2fbc6182d4d$var$UInt || this.layout instanceof $b160e2fbc6182d4d$var$UIntBE;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.encode(src, b, offset + this.offset);
    }
}
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$UInt extends $b160e2fbc6182d4d$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$UIntBE extends $b160e2fbc6182d4d$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Int extends $b160e2fbc6182d4d$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeIntLE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$IntBE extends $b160e2fbc6182d4d$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeIntBE(src, offset, this.span);
        return this.span;
    }
}
const $b160e2fbc6182d4d$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $b160e2fbc6182d4d$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $b160e2fbc6182d4d$var$V2E32);
    const lo32 = src - hi32 * $b160e2fbc6182d4d$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $b160e2fbc6182d4d$var$roundedInt64(hi32, lo32) {
    return hi32 * $b160e2fbc6182d4d$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$NearUInt64 extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readUInt32LE(offset + 4);
        return $b160e2fbc6182d4d$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $b160e2fbc6182d4d$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$NearUInt64BE extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const hi32 = b.readUInt32BE(offset);
        const lo32 = b.readUInt32BE(offset + 4);
        return $b160e2fbc6182d4d$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $b160e2fbc6182d4d$var$divmodInt64(src);
        b.writeUInt32BE(split.hi32, offset);
        b.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$NearInt64 extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readInt32LE(offset + 4);
        return $b160e2fbc6182d4d$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $b160e2fbc6182d4d$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$NearInt64BE extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const hi32 = b.readInt32BE(offset);
        const lo32 = b.readUInt32BE(offset + 4);
        return $b160e2fbc6182d4d$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $b160e2fbc6182d4d$var$divmodInt64(src);
        b.writeInt32BE(split.hi32, offset);
        b.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Float extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeFloatLE(src, offset);
        return 4;
    }
}
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$FloatBE extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeFloatBE(src, offset);
        return 4;
    }
}
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Double extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeDoubleLE(src, offset);
        return 8;
    }
}
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$DoubleBE extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeDoubleBE(src, offset);
        return 8;
    }
}
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Sequence extends $b160e2fbc6182d4d$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $b160e2fbc6182d4d$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $b160e2fbc6182d4d$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $b160e2fbc6182d4d$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
     *
     * This will be either a non-negative integer or an instance of
     * {@link ExternalLayout} for which {@link
     * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        let span = 0;
        let count = this.count;
        if (count instanceof $b160e2fbc6182d4d$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $b160e2fbc6182d4d$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $b160e2fbc6182d4d$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Structure extends $b160e2fbc6182d4d$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $b160e2fbc6182d4d$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {}
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
     * structure.
     *
     * The individual elements need not be the same type, and may be
     * either scalar or aggregate layouts.  If a member layout leaves
     * its {@link Layout#property|property} undefined the
     * corresponding region of the buffer associated with the element
     * will not be mutated.
     *
     * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
     * buffers.
     *
     * In some situations a structure many be extended with additional
     * fields over time, with older installations providing only a
     * prefix of the full structure.  If this property is `true`
     * decoding will accept those buffers and leave subsequent fields
     * undefined, as long as the buffer ends at a field boundary.
     * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
             * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
     * item may have had a dynamic length and we don't want to include
     * the padding between it and the end of the space reserved for
     * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
    }
    /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
    }
}
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $b160e2fbc6182d4d$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
     * discriminator is referenced in isolation (generally when {@link
     * Union#decode|Union decode} cannot delegate to a specific
     * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */ decode() {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */ encode() {
        throw new Error("UnionDiscriminator is abstract");
    }
}
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $b160e2fbc6182d4d$var$UnionLayoutDiscriminator extends $b160e2fbc6182d4d$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $b160e2fbc6182d4d$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
     * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Union extends $b160e2fbc6182d4d$var$Layout {
    constructor(discr, defaultLayout, property){
        const upv = discr instanceof $b160e2fbc6182d4d$var$UInt || discr instanceof $b160e2fbc6182d4d$var$UIntBE;
        if (upv) discr = new $b160e2fbc6182d4d$var$UnionLayoutDiscriminator(new $b160e2fbc6182d4d$var$OffsetLayout(discr));
        else if (discr instanceof $b160e2fbc6182d4d$var$ExternalLayout && discr.isCount()) discr = new $b160e2fbc6182d4d$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $b160e2fbc6182d4d$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $b160e2fbc6182d4d$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
     * layout.  The union spans its default layout, plus any prefix
     * variant layout.  By construction both layouts, if present, have
     * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && upv) span += discr.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
     *
     * This a {@link UnionDiscriminator} either passed to the
     * constructor or synthesized from the `discr` constructor
     * argument.  {@link
     * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
     * `true` iff the `discr` parameter was a non-offset {@link
     * Layout} instance. */ this.discriminator = discr;
        /** `true` if the {@link Union#discriminator|discriminator} is the
     * first field in the union.
     *
     * If `false` the discriminator is obtained from somewhere
     * else. */ this.usesPrefixDiscriminator = upv;
        /** The layout for non-discriminator content when the value of the
     * discriminator is not recognized.
     *
     * This is the value passed to the constructor.  It is
     * structurally equivalent to the second component of {@link
     * Union#layout|layout} but may have a different property
     * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
     *
     * The keys are unsigned integers which should be compatible with
     * {@link Union.discriminator|discriminator}.  The property value
     * is the corresponding {@link VariantLayout} instances assigned
     * to this union by {@link Union#addVariant|addVariant}.
     *
     * **NOTE** The registry remains mutable so that variants can be
     * {@link Union#addVariant|added} at any time.  Users should not
     * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
     *
     * Defaults to {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
     * be overridden using {@link
     * Union#configGetSourceVariant|configGetSourceVariant}.
     *
     * @param {Object} src - as with {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * @returns {(undefined|VariantLayout)} The default variant
     * (`undefined`) or first registered variant that uses a property
     * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
     * Union#getSourceVariant|getSourceVariant}.
     *
     * Use this if the desired variant cannot be identified using the
     * algorithm of {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * **NOTE** The provided function will be invoked bound to this
     * Union instance, providing local access to {@link
     * Union#registry|registry}.
     *
     * @param {Function} gsv - a function that follows the API of
     * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        /* Default layouts always have non-negative span, so we don't have
     * one and we have to recognize the variant which will in turn
     * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */ defaultGetSourceVariant(src) {
        if (src.hasOwnProperty(this.discriminator.property)) {
            if (this.defaultLayout && src.hasOwnProperty(this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || src.hasOwnProperty(vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (src.hasOwnProperty(vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        let clo = this.registry[discr];
        if (undefined === clo) {
            let contentOffset = 0;
            clo = this.defaultLayout;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            dest[clo.property] = this.defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $b160e2fbc6182d4d$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */ getVariant(vb, offset) {
        let variant = vb;
        if ($b160e2fbc6182d4d$var$buffer.Buffer.isBuffer(vb)) {
            if (undefined === offset) offset = 0;
            variant = this.discriminator.decode(vb, offset);
        }
        return this.registry[variant];
    }
}
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$VariantLayout extends $b160e2fbc6182d4d$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $b160e2fbc6182d4d$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $b160e2fbc6182d4d$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
     * the {@link Union#discriminator|discriminator} of the containing
     * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
     * non-discriminator part of the {@link
     * VariantLayout#union|union}.  If `null` the variant carries no
     * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
       * variable. */ return this.span;
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ return contentOffset + this.layout.getSpan(b, offset + contentOffset);
    }
    /** @override */ decode(b, offset) {
        const dest = this.makeDestinationObject();
        if (undefined === offset) offset = 0;
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !src.hasOwnProperty(this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
    }
}
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $b160e2fbc6182d4d$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$BitStructure extends $b160e2fbc6182d4d$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $b160e2fbc6182d4d$var$UInt || word instanceof $b160e2fbc6182d4d$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = undefined;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
     * instances are packed sequentially depending on {@link
     * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
     * significant bit growing down (`true`), or the least significant
     * bit growing up (`false`).
     *
     * **NOTE** Regardless of this value, the least significant bit of
     * any {@link BitField} value is the least significant bit of the
     * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
     * packed structure.
     *
     * **NOTE** The array remains mutable to allow fields to be {@link
     * BitStructure#addField|added} after construction.  Users should
     * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
     * instance property because we don't want anything to change the
     * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $b160e2fbc6182d4d$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset) {
        const dest = this.makeDestinationObject();
        if (undefined === offset) offset = 0;
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(value);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */ addField(bits, property) {
        const bf = new $b160e2fbc6182d4d$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */ addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        // eslint-disable-next-line no-new-wrappers
        const bf = new $b160e2fbc6182d4d$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
    }
}
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $b160e2fbc6182d4d$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $b160e2fbc6182d4d$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
     * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
     * that fit within the field.
     *
     * That is, it masks a value that has not yet been shifted into
     * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
     * integer.  The least significant bit of the packed value is at
     * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
     * within the containing packed unsigned integer. */ this.wordMask = $b160e2fbc6182d4d$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
     * Object.
     *
     * Intended to be functionally equivalent to {@link
     * Layout#property}.
     *
     * If left undefined the corresponding span of bits will be
     * treated as padding: it will not be mutated by {@link
     * Layout#encode|encode} nor represented as a property in the
     * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
   * bit field. */ decode() {
        const word = this.container._packedGetValue();
        const wordValue = $b160e2fbc6182d4d$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if (!Number.isInteger(value) || value !== $b160e2fbc6182d4d$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($b160e2fbc6182d4d$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $b160e2fbc6182d4d$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($b160e2fbc6182d4d$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $b160e2fbc6182d4d$var$Boolean extends $b160e2fbc6182d4d$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */ decode(b, offset) {
        return !!$b160e2fbc6182d4d$var$BitField.prototype.decode.call(this, b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        return $b160e2fbc6182d4d$var$BitField.prototype.encode.call(this, value);
    }
}
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Buffer.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Blob extends $b160e2fbc6182d4d$var$Layout {
    constructor(length, property){
        if (!(length instanceof $b160e2fbc6182d4d$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $b160e2fbc6182d4d$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
     *
     * This may be a non-negative integer, or an instance of {@link
     * ExternalLayout} that satisfies {@link
     * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return b.slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $b160e2fbc6182d4d$var$ExternalLayout) span = src.length;
        if (!($b160e2fbc6182d4d$var$buffer.Buffer.isBuffer(src) && span === src.length)) throw new TypeError($b160e2fbc6182d4d$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Buffer as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        b.write(src.toString("hex"), offset, span, "hex");
        if (this.length instanceof $b160e2fbc6182d4d$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$CString extends $b160e2fbc6182d4d$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset) {
        if (!$b160e2fbc6182d4d$var$buffer.Buffer.isBuffer(b)) throw new TypeError("b must be a Buffer");
        if (undefined === offset) offset = 0;
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset, dest) {
        if (undefined === offset) offset = 0;
        let span = this.getSpan(b, offset);
        return b.slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        /* Must force this to a string, lest it be a number and the
     * "utf8-encoding" below actually allocate a buffer of length
     * src */ if ("string" !== typeof src) src = src.toString();
        const srcb = new $b160e2fbc6182d4d$var$buffer.Buffer(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy(b, offset);
        b[offset + span] = 0;
        return span + 1;
    }
}
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$UTF8 extends $b160e2fbc6182d4d$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
     *
     * Positive values are generally expected.  Zero is abnormal.
     * Attempts to encode or decode a value that exceeds this length
     * will throw a `RangeError`.
     *
     * A negative value indicates that there is no bound on the length
     * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset) {
        if (!$b160e2fbc6182d4d$var$buffer.Buffer.isBuffer(b)) throw new TypeError("b must be a Buffer");
        if (undefined === offset) offset = 0;
        return b.length - offset;
    }
    /** @override */ decode(b, offset, dest) {
        if (undefined === offset) offset = 0;
        let span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return b.slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        /* Must force this to a string, lest it be a number and the
     * "utf8-encoding" below actually allocate a buffer of length
     * src */ if ("string" !== typeof src) src = src.toString();
        const srcb = new $b160e2fbc6182d4d$var$buffer.Buffer(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy(b, offset);
        return span;
    }
}
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $b160e2fbc6182d4d$var$Constant extends $b160e2fbc6182d4d$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
     * Constant#decode|decoded}.
     *
     * Any JavaScript value including `null` and `undefined` is
     * permitted.
     *
     * **WARNING** If `value` passed in the constructor was not
     * frozen, it is possible for users of decoded values to change
     * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset, dest) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
$b160e2fbc6182d4d$var$Layout$1.ExternalLayout = $b160e2fbc6182d4d$var$ExternalLayout;
$b160e2fbc6182d4d$var$Layout$1.GreedyCount = $b160e2fbc6182d4d$var$GreedyCount;
$b160e2fbc6182d4d$var$Layout$1.OffsetLayout = $b160e2fbc6182d4d$var$OffsetLayout;
$b160e2fbc6182d4d$var$Layout$1.UInt = $b160e2fbc6182d4d$var$UInt;
$b160e2fbc6182d4d$var$Layout$1.UIntBE = $b160e2fbc6182d4d$var$UIntBE;
$b160e2fbc6182d4d$var$Layout$1.Int = $b160e2fbc6182d4d$var$Int;
$b160e2fbc6182d4d$var$Layout$1.IntBE = $b160e2fbc6182d4d$var$IntBE;
$b160e2fbc6182d4d$var$Layout$1.Float = $b160e2fbc6182d4d$var$Float;
$b160e2fbc6182d4d$var$Layout$1.FloatBE = $b160e2fbc6182d4d$var$FloatBE;
$b160e2fbc6182d4d$var$Layout$1.Double = $b160e2fbc6182d4d$var$Double;
$b160e2fbc6182d4d$var$Layout$1.DoubleBE = $b160e2fbc6182d4d$var$DoubleBE;
$b160e2fbc6182d4d$var$Layout$1.Sequence = $b160e2fbc6182d4d$var$Sequence;
$b160e2fbc6182d4d$var$Layout$1.Structure = $b160e2fbc6182d4d$var$Structure;
$b160e2fbc6182d4d$var$Layout$1.UnionDiscriminator = $b160e2fbc6182d4d$var$UnionDiscriminator;
$b160e2fbc6182d4d$var$Layout$1.UnionLayoutDiscriminator = $b160e2fbc6182d4d$var$UnionLayoutDiscriminator;
$b160e2fbc6182d4d$var$Layout$1.Union = $b160e2fbc6182d4d$var$Union;
$b160e2fbc6182d4d$var$Layout$1.VariantLayout = $b160e2fbc6182d4d$var$VariantLayout;
$b160e2fbc6182d4d$var$Layout$1.BitStructure = $b160e2fbc6182d4d$var$BitStructure;
$b160e2fbc6182d4d$var$Layout$1.BitField = $b160e2fbc6182d4d$var$BitField;
$b160e2fbc6182d4d$var$Layout$1.Boolean = $b160e2fbc6182d4d$var$Boolean;
$b160e2fbc6182d4d$var$Layout$1.Blob = $b160e2fbc6182d4d$var$Blob;
$b160e2fbc6182d4d$var$Layout$1.CString = $b160e2fbc6182d4d$var$CString;
$b160e2fbc6182d4d$var$Layout$1.UTF8 = $b160e2fbc6182d4d$var$UTF8;
$b160e2fbc6182d4d$var$Layout$1.Constant = $b160e2fbc6182d4d$var$Constant;
/** Factory for {@link GreedyCount}. */ $b160e2fbc6182d4d$var$Layout$1.greedy = (elementSpan, property)=>new $b160e2fbc6182d4d$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ $b160e2fbc6182d4d$var$Layout$1.offset = (layout, offset, property)=>new $b160e2fbc6182d4d$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ var $b160e2fbc6182d4d$var$u8 = $b160e2fbc6182d4d$var$Layout$1.u8 = (property)=>new $b160e2fbc6182d4d$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ $b160e2fbc6182d4d$var$Layout$1.u16 = (property)=>new $b160e2fbc6182d4d$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ $b160e2fbc6182d4d$var$Layout$1.u24 = (property)=>new $b160e2fbc6182d4d$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ var $b160e2fbc6182d4d$var$u32 = $b160e2fbc6182d4d$var$Layout$1.u32 = (property)=>new $b160e2fbc6182d4d$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ $b160e2fbc6182d4d$var$Layout$1.u40 = (property)=>new $b160e2fbc6182d4d$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ $b160e2fbc6182d4d$var$Layout$1.u48 = (property)=>new $b160e2fbc6182d4d$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ $b160e2fbc6182d4d$var$Layout$1.nu64 = (property)=>new $b160e2fbc6182d4d$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ $b160e2fbc6182d4d$var$Layout$1.u16be = (property)=>new $b160e2fbc6182d4d$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ $b160e2fbc6182d4d$var$Layout$1.u24be = (property)=>new $b160e2fbc6182d4d$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ $b160e2fbc6182d4d$var$Layout$1.u32be = (property)=>new $b160e2fbc6182d4d$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ $b160e2fbc6182d4d$var$Layout$1.u40be = (property)=>new $b160e2fbc6182d4d$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ $b160e2fbc6182d4d$var$Layout$1.u48be = (property)=>new $b160e2fbc6182d4d$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ $b160e2fbc6182d4d$var$Layout$1.nu64be = (property)=>new $b160e2fbc6182d4d$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ $b160e2fbc6182d4d$var$Layout$1.s8 = (property)=>new $b160e2fbc6182d4d$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ $b160e2fbc6182d4d$var$Layout$1.s16 = (property)=>new $b160e2fbc6182d4d$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ $b160e2fbc6182d4d$var$Layout$1.s24 = (property)=>new $b160e2fbc6182d4d$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ $b160e2fbc6182d4d$var$Layout$1.s32 = (property)=>new $b160e2fbc6182d4d$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ $b160e2fbc6182d4d$var$Layout$1.s40 = (property)=>new $b160e2fbc6182d4d$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ $b160e2fbc6182d4d$var$Layout$1.s48 = (property)=>new $b160e2fbc6182d4d$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ $b160e2fbc6182d4d$var$Layout$1.ns64 = (property)=>new $b160e2fbc6182d4d$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ $b160e2fbc6182d4d$var$Layout$1.s16be = (property)=>new $b160e2fbc6182d4d$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ $b160e2fbc6182d4d$var$Layout$1.s24be = (property)=>new $b160e2fbc6182d4d$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ $b160e2fbc6182d4d$var$Layout$1.s32be = (property)=>new $b160e2fbc6182d4d$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ $b160e2fbc6182d4d$var$Layout$1.s40be = (property)=>new $b160e2fbc6182d4d$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ $b160e2fbc6182d4d$var$Layout$1.s48be = (property)=>new $b160e2fbc6182d4d$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ $b160e2fbc6182d4d$var$Layout$1.ns64be = (property)=>new $b160e2fbc6182d4d$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ $b160e2fbc6182d4d$var$Layout$1.f32 = (property)=>new $b160e2fbc6182d4d$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ $b160e2fbc6182d4d$var$Layout$1.f32be = (property)=>new $b160e2fbc6182d4d$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ $b160e2fbc6182d4d$var$Layout$1.f64 = (property)=>new $b160e2fbc6182d4d$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ $b160e2fbc6182d4d$var$Layout$1.f64be = (property)=>new $b160e2fbc6182d4d$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ var $b160e2fbc6182d4d$var$struct = $b160e2fbc6182d4d$var$Layout$1.struct = (fields, property, decodePrefixes)=>new $b160e2fbc6182d4d$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ $b160e2fbc6182d4d$var$Layout$1.bits = (word, msb, property)=>new $b160e2fbc6182d4d$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ $b160e2fbc6182d4d$var$Layout$1.seq = (elementLayout, count, property)=>new $b160e2fbc6182d4d$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ $b160e2fbc6182d4d$var$Layout$1.union = (discr, defaultLayout, property)=>new $b160e2fbc6182d4d$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ $b160e2fbc6182d4d$var$Layout$1.unionLayoutDiscriminator = (layout, property)=>new $b160e2fbc6182d4d$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ var $b160e2fbc6182d4d$var$blob = $b160e2fbc6182d4d$var$Layout$1.blob = (length, property)=>new $b160e2fbc6182d4d$var$Blob(length, property);
/** Factory for {@link CString} values. */ $b160e2fbc6182d4d$var$Layout$1.cstr = (property)=>new $b160e2fbc6182d4d$var$CString(property);
/** Factory for {@link UTF8} values. */ $b160e2fbc6182d4d$var$Layout$1.utf8 = (maxSpan, property)=>new $b160e2fbc6182d4d$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ $b160e2fbc6182d4d$var$Layout$1.const = (value, property)=>new $b160e2fbc6182d4d$var$Constant(value, property);
//      
/**
 * Layout for a public key
 */ const $b160e2fbc6182d4d$var$publicKey = (property = "publicKey")=>{
    return $b160e2fbc6182d4d$var$blob(32, property);
};
/**
 * Layout for a 64bit unsigned value
 */ const $b160e2fbc6182d4d$var$uint64 = (property = "uint64")=>{
    return $b160e2fbc6182d4d$var$blob(8, property);
};
//      
function $b160e2fbc6182d4d$var$sendAndConfirmTransaction(title, connection, transaction, ...signers) {
    return (0, $1biTx.sendAndConfirmTransaction)(connection, transaction, signers, {
        skipPreflight: false
    });
}
const $b160e2fbc6182d4d$export$79de3e3c2b1ca801 = new (0, $1biTx.PublicKey)("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const $b160e2fbc6182d4d$export$57a4f33bcc1767fa = new (0, $1biTx.PublicKey)("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
const $b160e2fbc6182d4d$var$FAILED_TO_FIND_ACCOUNT = "Failed to find account";
const $b160e2fbc6182d4d$var$INVALID_ACCOUNT_OWNER = "Invalid account owner";
/**
 * Unfortunately, BufferLayout.encode uses an `instanceof` check for `Buffer`
 * which fails when using `publicKey.toBuffer()` directly because the bundled `Buffer`
 * class in `@solana/web3.js` is different from the bundled `Buffer` class in this package
 */ function $b160e2fbc6182d4d$var$pubkeyToBuffer(publicKey) {
    return $b160e2fbc6182d4d$var$buffer.Buffer.from(publicKey.toBuffer());
}
/**
 * 64-bit value
 */ class $b160e2fbc6182d4d$export$cd1442401e54cffa extends (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG))) {
    /**
   * Convert to Buffer representation
   */ toBuffer() {
        const a = super.toArray().reverse();
        const b = $b160e2fbc6182d4d$var$buffer.Buffer.from(a);
        if (b.length === 8) return b;
        $b160e2fbc6182d4d$var$assert(b.length < 8, "u64 too large");
        const zeroPad = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(8);
        b.copy(zeroPad);
        return zeroPad;
    }
    /**
   * Construct a u64 from Buffer representation
   */ static fromBuffer(buffer) {
        $b160e2fbc6182d4d$var$assert(buffer.length === 8, `Invalid buffer length: ${buffer.length}`);
        return new $b160e2fbc6182d4d$export$cd1442401e54cffa([
            ...buffer
        ].reverse().map((i)=>`00${i.toString(16)}`.slice(-2)).join(""), 16);
    }
}
function $b160e2fbc6182d4d$var$isAccount(accountOrPublicKey) {
    return "publicKey" in accountOrPublicKey;
}
const $b160e2fbc6182d4d$var$AuthorityTypeCodes = {
    MintTokens: 0,
    FreezeAccount: 1,
    AccountOwner: 2,
    CloseAccount: 3
}; // The address of the special mint for wrapped native token.
const $b160e2fbc6182d4d$export$71f490c6a4aef7af = new (0, $1biTx.PublicKey)("So11111111111111111111111111111111111111112");
/**
 * Information about the mint
 */ const $b160e2fbc6182d4d$export$1374e91decd2fbe5 = $b160e2fbc6182d4d$var$struct([
    $b160e2fbc6182d4d$var$u32("mintAuthorityOption"),
    $b160e2fbc6182d4d$var$publicKey("mintAuthority"),
    $b160e2fbc6182d4d$var$uint64("supply"),
    $b160e2fbc6182d4d$var$u8("decimals"),
    $b160e2fbc6182d4d$var$u8("isInitialized"),
    $b160e2fbc6182d4d$var$u32("freezeAuthorityOption"),
    $b160e2fbc6182d4d$var$publicKey("freezeAuthority")
]);
/**
 * Information about an account
 */ /**
 * @private
 */ const $b160e2fbc6182d4d$export$cab31ec27f6c5fa = $b160e2fbc6182d4d$var$struct([
    $b160e2fbc6182d4d$var$publicKey("mint"),
    $b160e2fbc6182d4d$var$publicKey("owner"),
    $b160e2fbc6182d4d$var$uint64("amount"),
    $b160e2fbc6182d4d$var$u32("delegateOption"),
    $b160e2fbc6182d4d$var$publicKey("delegate"),
    $b160e2fbc6182d4d$var$u8("state"),
    $b160e2fbc6182d4d$var$u32("isNativeOption"),
    $b160e2fbc6182d4d$var$uint64("isNative"),
    $b160e2fbc6182d4d$var$uint64("delegatedAmount"),
    $b160e2fbc6182d4d$var$u32("closeAuthorityOption"),
    $b160e2fbc6182d4d$var$publicKey("closeAuthority")
]);
/**
 * Information about an multisig
 */ /**
 * @private
 */ const $b160e2fbc6182d4d$var$MultisigLayout = $b160e2fbc6182d4d$var$struct([
    $b160e2fbc6182d4d$var$u8("m"),
    $b160e2fbc6182d4d$var$u8("n"),
    $b160e2fbc6182d4d$var$u8("is_initialized"),
    $b160e2fbc6182d4d$var$publicKey("signer1"),
    $b160e2fbc6182d4d$var$publicKey("signer2"),
    $b160e2fbc6182d4d$var$publicKey("signer3"),
    $b160e2fbc6182d4d$var$publicKey("signer4"),
    $b160e2fbc6182d4d$var$publicKey("signer5"),
    $b160e2fbc6182d4d$var$publicKey("signer6"),
    $b160e2fbc6182d4d$var$publicKey("signer7"),
    $b160e2fbc6182d4d$var$publicKey("signer8"),
    $b160e2fbc6182d4d$var$publicKey("signer9"),
    $b160e2fbc6182d4d$var$publicKey("signer10"),
    $b160e2fbc6182d4d$var$publicKey("signer11")
]);
/**
 * An ERC20-like Token
 */ class $b160e2fbc6182d4d$export$50792b0e93539fde {
    /**
   * @private
   */ /**
   * The public key identifying this mint
   */ /**
   * Program Identifier for the Token program
   */ /**
   * Program Identifier for the Associated Token program
   */ /**
   * Fee payer
   */ /**
   * Create a Token object attached to the specific mint
   *
   * @param connection The connection to use
   * @param token Public key of the mint
   * @param programId token programId
   * @param payer Payer of fees
   */ constructor(connection, publicKey, programId, payer){
        (0, (/*@__PURE__*/$parcel$interopDefault($5V9Vg)))(this, "connection", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5V9Vg)))(this, "publicKey", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5V9Vg)))(this, "programId", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5V9Vg)))(this, "associatedProgramId", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5V9Vg)))(this, "payer", void 0);
        Object.assign(this, {
            connection: connection,
            publicKey: publicKey,
            programId: programId,
            payer: payer,
            // Hard code is ok; Overriding is needed only for tests
            associatedProgramId: $b160e2fbc6182d4d$export$57a4f33bcc1767fa
        });
    }
    /**
   * Get the minimum balance for the mint to be rent exempt
   *
   * @return Number of lamports required
   */ static async getMinBalanceRentForExemptMint(connection) {
        return await connection.getMinimumBalanceForRentExemption($b160e2fbc6182d4d$export$1374e91decd2fbe5.span);
    }
    /**
   * Get the minimum balance for the account to be rent exempt
   *
   * @return Number of lamports required
   */ static async getMinBalanceRentForExemptAccount(connection) {
        return await connection.getMinimumBalanceForRentExemption($b160e2fbc6182d4d$export$cab31ec27f6c5fa.span);
    }
    /**
   * Get the minimum balance for the multsig to be rent exempt
   *
   * @return Number of lamports required
   */ static async getMinBalanceRentForExemptMultisig(connection) {
        return await connection.getMinimumBalanceForRentExemption($b160e2fbc6182d4d$var$MultisigLayout.span);
    }
    /**
   * Create and initialize a token.
   *
   * @param connection The connection to use
   * @param payer Fee payer for transaction
   * @param mintAuthority Account or multisig that will control minting
   * @param freezeAuthority Optional account or multisig that can freeze token accounts
   * @param decimals Location of the decimal place
   * @param programId Optional token programId, uses the system programId by default
   * @return Token object for the newly minted token
   */ static async createMint(connection, payer, mintAuthority, freezeAuthority, decimals, programId) {
        const mintAccount = (0, $1biTx.Keypair).generate();
        const token = new $b160e2fbc6182d4d$export$50792b0e93539fde(connection, mintAccount.publicKey, programId, payer); // Allocate memory for the account
        const balanceNeeded = await $b160e2fbc6182d4d$export$50792b0e93539fde.getMinBalanceRentForExemptMint(connection);
        const transaction = new (0, $1biTx.Transaction)();
        transaction.add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: mintAccount.publicKey,
            lamports: balanceNeeded,
            space: $b160e2fbc6182d4d$export$1374e91decd2fbe5.span,
            programId: programId
        }));
        transaction.add($b160e2fbc6182d4d$export$50792b0e93539fde.createInitMintInstruction(programId, mintAccount.publicKey, decimals, mintAuthority, freezeAuthority)); // Send the two instructions
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("createAccount and InitializeMint", connection, transaction, payer, mintAccount);
        return token;
    }
    /**
   * Create and initialize a new account.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return Public key of the new empty account
   */ async createAccount(owner) {
        // Allocate memory for the account
        const balanceNeeded = await $b160e2fbc6182d4d$export$50792b0e93539fde.getMinBalanceRentForExemptAccount(this.connection);
        const newAccount = (0, $1biTx.Keypair).generate();
        const transaction = new (0, $1biTx.Transaction)();
        transaction.add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: this.payer.publicKey,
            newAccountPubkey: newAccount.publicKey,
            lamports: balanceNeeded,
            space: $b160e2fbc6182d4d$export$cab31ec27f6c5fa.span,
            programId: this.programId
        }));
        const mintPublicKey = this.publicKey;
        transaction.add($b160e2fbc6182d4d$export$50792b0e93539fde.createInitAccountInstruction(this.programId, mintPublicKey, newAccount.publicKey, owner)); // Send the two instructions
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("createAccount and InitializeAccount", this.connection, transaction, this.payer, newAccount);
        return newAccount.publicKey;
    }
    /**
   * Create and initialize the associated account.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return Public key of the new associated account
   */ async createAssociatedTokenAccount(owner) {
        const associatedAddress = await $b160e2fbc6182d4d$export$50792b0e93539fde.getAssociatedTokenAddress(this.associatedProgramId, this.programId, this.publicKey, owner);
        return this.createAssociatedTokenAccountInternal(owner, associatedAddress);
    }
    async createAssociatedTokenAccountInternal(owner, associatedAddress) {
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("CreateAssociatedTokenAccount", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createAssociatedTokenAccountInstruction(this.associatedProgramId, this.programId, this.publicKey, associatedAddress, owner, this.payer.publicKey)), this.payer);
        return associatedAddress;
    }
    /**
   * Retrieve the associated account or create one if not found.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return The new associated account
   */ async getOrCreateAssociatedAccountInfo(owner) {
        const associatedAddress = await $b160e2fbc6182d4d$export$50792b0e93539fde.getAssociatedTokenAddress(this.associatedProgramId, this.programId, this.publicKey, owner); // This is the optimum logic, considering TX fee, client-side computation,
        // RPC roundtrips and guaranteed idempotent.
        // Sadly we can't do this atomically;
        try {
            return await this.getAccountInfo(associatedAddress);
        } catch (err) {
            // INVALID_ACCOUNT_OWNER can be possible if the associatedAddress has
            // already been received some lamports (= became system accounts).
            // Assuming program derived addressing is safe, this is the only case
            // for the INVALID_ACCOUNT_OWNER in this code-path
            if (err.message === $b160e2fbc6182d4d$var$FAILED_TO_FIND_ACCOUNT || err.message === $b160e2fbc6182d4d$var$INVALID_ACCOUNT_OWNER) {
                // as this isn't atomic, it's possible others can create associated
                // accounts meanwhile
                try {
                    await this.createAssociatedTokenAccountInternal(owner, associatedAddress);
                } catch (err) {
                // selectively ignore the expected instruction error if the
                // associated account is existing already.
                } // Now this should always succeed
                return await this.getAccountInfo(associatedAddress);
            } else throw err;
        }
    }
    /**
   * Create and initialize a new account on the special native token mint.
   *
   * In order to be wrapped, the account must have a balance of native tokens
   * when it is initialized with the token program.
   *
   * This function sends lamports to the new account before initializing it.
   *
   * @param connection A solana web3 connection
   * @param programId The token program ID
   * @param owner The owner of the new token account
   * @param payer The source of the lamports to initialize, and payer of the initialization fees.
   * @param amount The amount of lamports to wrap
   * @return {Promise<PublicKey>} The new token account
   */ static async createWrappedNativeAccount(connection, programId, owner, payer, amount) {
        // Allocate memory for the account
        const balanceNeeded = await $b160e2fbc6182d4d$export$50792b0e93539fde.getMinBalanceRentForExemptAccount(connection); // Create a new account
        const newAccount = (0, $1biTx.Keypair).generate();
        const transaction = new (0, $1biTx.Transaction)();
        transaction.add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: newAccount.publicKey,
            lamports: balanceNeeded,
            space: $b160e2fbc6182d4d$export$cab31ec27f6c5fa.span,
            programId: programId
        })); // Send lamports to it (these will be wrapped into native tokens by the token program)
        transaction.add((0, $1biTx.SystemProgram).transfer({
            fromPubkey: payer.publicKey,
            toPubkey: newAccount.publicKey,
            lamports: amount
        })); // Assign the new account to the native token mint.
        // the account will be initialized with a balance equal to the native token balance.
        // (i.e. amount)
        transaction.add($b160e2fbc6182d4d$export$50792b0e93539fde.createInitAccountInstruction(programId, $b160e2fbc6182d4d$export$71f490c6a4aef7af, newAccount.publicKey, owner)); // Send the three instructions
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("createAccount, transfer, and initializeAccount", connection, transaction, payer, newAccount);
        return newAccount.publicKey;
    }
    /**
   * Create and initialize a new multisig.
   *
   * This account may then be used for multisignature verification
   *
   * @param m Number of required signatures
   * @param signers Full set of signers
   * @return Public key of the new multisig account
   */ async createMultisig(m, signers) {
        const multisigAccount = (0, $1biTx.Keypair).generate(); // Allocate memory for the account
        const balanceNeeded = await $b160e2fbc6182d4d$export$50792b0e93539fde.getMinBalanceRentForExemptMultisig(this.connection);
        const transaction = new (0, $1biTx.Transaction)();
        transaction.add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: this.payer.publicKey,
            newAccountPubkey: multisigAccount.publicKey,
            lamports: balanceNeeded,
            space: $b160e2fbc6182d4d$var$MultisigLayout.span,
            programId: this.programId
        })); // create the new account
        let keys = [
            {
                pubkey: multisigAccount.publicKey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: (0, $1biTx.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        signers.forEach((signer)=>keys.push({
                pubkey: signer,
                isSigner: false,
                isWritable: false
            }));
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$u8("m")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 2,
            m: // InitializeMultisig instruction
            m
        }, data);
        transaction.add({
            keys: keys,
            programId: this.programId,
            data: data
        }); // Send the two instructions
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("createAccount and InitializeMultisig", this.connection, transaction, this.payer, multisigAccount);
        return multisigAccount.publicKey;
    }
    /**
   * Retrieve mint information
   */ async getMintInfo() {
        const info = await this.connection.getAccountInfo(this.publicKey);
        if (info === null) throw new Error("Failed to find mint account");
        if (!info.owner.equals(this.programId)) throw new Error(`Invalid mint owner: ${JSON.stringify(info.owner)}`);
        if (info.data.length != $b160e2fbc6182d4d$export$1374e91decd2fbe5.span) throw new Error(`Invalid mint size`);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.from(info.data);
        const mintInfo = $b160e2fbc6182d4d$export$1374e91decd2fbe5.decode(data);
        if (mintInfo.mintAuthorityOption === 0) mintInfo.mintAuthority = null;
        else mintInfo.mintAuthority = new (0, $1biTx.PublicKey)(mintInfo.mintAuthority);
        mintInfo.supply = $b160e2fbc6182d4d$export$cd1442401e54cffa.fromBuffer(mintInfo.supply);
        mintInfo.isInitialized = mintInfo.isInitialized != 0;
        if (mintInfo.freezeAuthorityOption === 0) mintInfo.freezeAuthority = null;
        else mintInfo.freezeAuthority = new (0, $1biTx.PublicKey)(mintInfo.freezeAuthority);
        return mintInfo;
    }
    /**
   * Retrieve account information
   *
   * @param account Public key of the account
   */ async getAccountInfo(account, commitment) {
        const info = await this.connection.getAccountInfo(account, commitment);
        if (info === null) throw new Error($b160e2fbc6182d4d$var$FAILED_TO_FIND_ACCOUNT);
        if (!info.owner.equals(this.programId)) throw new Error($b160e2fbc6182d4d$var$INVALID_ACCOUNT_OWNER);
        if (info.data.length != $b160e2fbc6182d4d$export$cab31ec27f6c5fa.span) throw new Error(`Invalid account size`);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.from(info.data);
        const accountInfo = $b160e2fbc6182d4d$export$cab31ec27f6c5fa.decode(data);
        accountInfo.address = account;
        accountInfo.mint = new (0, $1biTx.PublicKey)(accountInfo.mint);
        accountInfo.owner = new (0, $1biTx.PublicKey)(accountInfo.owner);
        accountInfo.amount = $b160e2fbc6182d4d$export$cd1442401e54cffa.fromBuffer(accountInfo.amount);
        if (accountInfo.delegateOption === 0) {
            accountInfo.delegate = null;
            accountInfo.delegatedAmount = new $b160e2fbc6182d4d$export$cd1442401e54cffa();
        } else {
            accountInfo.delegate = new (0, $1biTx.PublicKey)(accountInfo.delegate);
            accountInfo.delegatedAmount = $b160e2fbc6182d4d$export$cd1442401e54cffa.fromBuffer(accountInfo.delegatedAmount);
        }
        accountInfo.isInitialized = accountInfo.state !== 0;
        accountInfo.isFrozen = accountInfo.state === 2;
        if (accountInfo.isNativeOption === 1) {
            accountInfo.rentExemptReserve = $b160e2fbc6182d4d$export$cd1442401e54cffa.fromBuffer(accountInfo.isNative);
            accountInfo.isNative = true;
        } else {
            accountInfo.rentExemptReserve = null;
            accountInfo.isNative = false;
        }
        if (accountInfo.closeAuthorityOption === 0) accountInfo.closeAuthority = null;
        else accountInfo.closeAuthority = new (0, $1biTx.PublicKey)(accountInfo.closeAuthority);
        if (!accountInfo.mint.equals(this.publicKey)) throw new Error(`Invalid account mint: ${JSON.stringify(accountInfo.mint)} !== ${JSON.stringify(this.publicKey)}`);
        return accountInfo;
    }
    /**
   * Retrieve Multisig information
   *
   * @param multisig Public key of the account
   */ async getMultisigInfo(multisig) {
        const info = await this.connection.getAccountInfo(multisig);
        if (info === null) throw new Error("Failed to find multisig");
        if (!info.owner.equals(this.programId)) throw new Error(`Invalid multisig owner`);
        if (info.data.length != $b160e2fbc6182d4d$var$MultisigLayout.span) throw new Error(`Invalid multisig size`);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.from(info.data);
        const multisigInfo = $b160e2fbc6182d4d$var$MultisigLayout.decode(data);
        multisigInfo.signer1 = new (0, $1biTx.PublicKey)(multisigInfo.signer1);
        multisigInfo.signer2 = new (0, $1biTx.PublicKey)(multisigInfo.signer2);
        multisigInfo.signer3 = new (0, $1biTx.PublicKey)(multisigInfo.signer3);
        multisigInfo.signer4 = new (0, $1biTx.PublicKey)(multisigInfo.signer4);
        multisigInfo.signer5 = new (0, $1biTx.PublicKey)(multisigInfo.signer5);
        multisigInfo.signer6 = new (0, $1biTx.PublicKey)(multisigInfo.signer6);
        multisigInfo.signer7 = new (0, $1biTx.PublicKey)(multisigInfo.signer7);
        multisigInfo.signer8 = new (0, $1biTx.PublicKey)(multisigInfo.signer8);
        multisigInfo.signer9 = new (0, $1biTx.PublicKey)(multisigInfo.signer9);
        multisigInfo.signer10 = new (0, $1biTx.PublicKey)(multisigInfo.signer10);
        multisigInfo.signer11 = new (0, $1biTx.PublicKey)(multisigInfo.signer11);
        return multisigInfo;
    }
    /**
   * Transfer tokens to another account
   *
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Number of tokens to transfer
   */ async transfer(source, destination, owner, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        return await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("Transfer", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createTransferInstruction(this.programId, source, destination, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Grant a third-party permission to transfer up the specified number of tokens from an account
   *
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */ async approve(account, delegate, owner, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("Approve", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createApproveInstruction(this.programId, account, delegate, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Remove approval for the transfer of any remaining tokens
   *
   * @param account Public key of the account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ async revoke(account, owner, multiSigners) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("Revoke", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createRevokeInstruction(this.programId, account, ownerPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Assign a new authority to the account
   *
   * @param account Public key of the account
   * @param newAuthority New authority of the account
   * @param authorityType Type of authority to set
   * @param currentAuthority Current authority of the account
   * @param multiSigners Signing accounts if `currentAuthority` is a multiSig
   */ async setAuthority(account, newAuthority, authorityType, currentAuthority, multiSigners) {
        let currentAuthorityPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(currentAuthority)) {
            currentAuthorityPublicKey = currentAuthority.publicKey;
            signers = [
                currentAuthority
            ];
        } else {
            currentAuthorityPublicKey = currentAuthority;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("SetAuthority", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createSetAuthorityInstruction(this.programId, account, newAuthority, authorityType, currentAuthorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Mint new tokens
   *
   * @param dest Public key of the account to mint to
   * @param authority Minting authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */ async mintTo(dest, authority, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(authority)) {
            ownerPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            ownerPublicKey = authority;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("MintTo", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createMintToInstruction(this.programId, this.publicKey, dest, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Burn tokens
   *
   * @param account Account to burn tokens from
   * @param owner Account owner
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Amount to burn
   */ async burn(account, owner, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("Burn", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createBurnInstruction(this.programId, this.publicKey, account, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Close account
   *
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Authority which is allowed to close the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */ async closeAccount(account, dest, authority, multiSigners) {
        let authorityPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(authority)) {
            authorityPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            authorityPublicKey = authority;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("CloseAccount", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createCloseAccountInstruction(this.programId, account, dest, authorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Freeze account
   *
   * @param account Account to freeze
   * @param authority The mint freeze authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */ async freezeAccount(account, authority, multiSigners) {
        let authorityPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(authority)) {
            authorityPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            authorityPublicKey = authority;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("FreezeAccount", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createFreezeAccountInstruction(this.programId, account, this.publicKey, authorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Thaw account
   *
   * @param account Account to thaw
   * @param authority The mint freeze authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */ async thawAccount(account, authority, multiSigners) {
        let authorityPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(authority)) {
            authorityPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            authorityPublicKey = authority;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("ThawAccount", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createThawAccountInstruction(this.programId, account, this.publicKey, authorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Transfer tokens to another account, asserting the token mint and decimals
   *
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Number of tokens to transfer
   * @param decimals Number of decimals in transfer amount
   */ async transferChecked(source, destination, owner, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        return await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("TransferChecked", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createTransferCheckedInstruction(this.programId, source, this.publicKey, destination, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Grant a third-party permission to transfer up the specified number of tokens from an account,
   * asserting the token mint and decimals
   *
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   * @param decimals Number of decimals in approve amount
   */ async approveChecked(account, delegate, owner, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("ApproveChecked", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createApproveCheckedInstruction(this.programId, account, this.publicKey, delegate, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Mint new tokens, asserting the token mint and decimals
   *
   * @param dest Public key of the account to mint to
   * @param authority Minting authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   * @param decimals Number of decimals in amount to mint
   */ async mintToChecked(dest, authority, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(authority)) {
            ownerPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            ownerPublicKey = authority;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("MintToChecked", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createMintToCheckedInstruction(this.programId, this.publicKey, dest, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Burn tokens, asserting the token mint and decimals
   *
   * @param account Account to burn tokens from
   * @param owner Account owner
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Amount to burn
   * @param decimals Number of decimals in amount to burn
   */ async burnChecked(account, owner, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($b160e2fbc6182d4d$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("BurnChecked", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createBurnCheckedInstruction(this.programId, this.publicKey, account, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Sync amount in native SPL token account to underlying lamports
   *
   * @param nativeAccount Account to sync
   */ async syncNative(nativeAccount) {
        await $b160e2fbc6182d4d$var$sendAndConfirmTransaction("SyncNative", this.connection, new (0, $1biTx.Transaction)().add($b160e2fbc6182d4d$export$50792b0e93539fde.createSyncNativeInstruction(this.programId, nativeAccount)), this.payer);
    }
    /**
   * Construct an InitializeMint instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param decimals Number of decimals in token account amounts
   * @param mintAuthority Minting authority
   * @param freezeAuthority Optional authority that can freeze token accounts
   */ static createInitMintInstruction(programId, mint, decimals, mintAuthority, freezeAuthority) {
        let keys = [
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: (0, $1biTx.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        const commandDataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$u8("decimals"),
            $b160e2fbc6182d4d$var$publicKey("mintAuthority"),
            $b160e2fbc6182d4d$var$u8("option"),
            $b160e2fbc6182d4d$var$publicKey("freezeAuthority")
        ]);
        let data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(1024);
        {
            const encodeLength = commandDataLayout.encode({
                instruction: 0,
                decimals: // InitializeMint instruction
                decimals,
                mintAuthority: $b160e2fbc6182d4d$var$pubkeyToBuffer(mintAuthority),
                option: freezeAuthority === null ? 0 : 1,
                freezeAuthority: $b160e2fbc6182d4d$var$pubkeyToBuffer(freezeAuthority || new (0, $1biTx.PublicKey)(0))
            }, data);
            data = data.slice(0, encodeLength);
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct an InitializeAccount instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param account New account
   * @param owner Owner of the new account
   */ static createInitAccountInstruction(programId, mint, account, owner) {
        const keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: owner,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: (0, $1biTx.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 1 // InitializeAccount instruction
        }, data);
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Transfer instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   */ static createTransferInstruction(programId, source, destination, owner, multiSigners, amount) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 3,
            // Transfer instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: source,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: destination,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct an Approve instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */ static createApproveInstruction(programId, account, delegate, owner, multiSigners, amount) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 4,
            // Approve instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: delegate,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Revoke instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createRevokeInstruction(programId, account, owner, multiSigners) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 5 // Approve instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a SetAuthority instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param newAuthority New authority of the account
   * @param authorityType Type of authority to set
   * @param currentAuthority Current authority of the specified type
   * @param multiSigners Signing accounts if `currentAuthority` is a multiSig
   */ static createSetAuthorityInstruction(programId, account, newAuthority, authorityType, currentAuthority, multiSigners) {
        const commandDataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$u8("authorityType"),
            $b160e2fbc6182d4d$var$u8("option"),
            $b160e2fbc6182d4d$var$publicKey("newAuthority")
        ]);
        let data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(1024);
        {
            const encodeLength = commandDataLayout.encode({
                instruction: 6,
                // SetAuthority instruction
                authorityType: $b160e2fbc6182d4d$var$AuthorityTypeCodes[authorityType],
                option: newAuthority === null ? 0 : 1,
                newAuthority: $b160e2fbc6182d4d$var$pubkeyToBuffer(newAuthority || new (0, $1biTx.PublicKey)(0))
            }, data);
            data = data.slice(0, encodeLength);
        }
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: currentAuthority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: currentAuthority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a MintTo instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */ static createMintToInstruction(programId, mint, dest, authority, multiSigners, amount) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 7,
            // MintTo instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: dest,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Burn instruction
   *
   * @param programId SPL Token program account
   * @param mint Mint for the account
   * @param account Account to burn tokens from
   * @param owner Owner of the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount amount to burn
   */ static createBurnInstruction(programId, mint, account, owner, multiSigners, amount) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 8,
            // Burn instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Close instruction
   *
   * @param programId SPL Token program account
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Account Close authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createCloseAccountInstruction(programId, account, dest, owner, multiSigners) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 9 // CloseAccount instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: dest,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Freeze instruction
   *
   * @param programId SPL Token program account
   * @param account Account to freeze
   * @param mint Mint account
   * @param authority Mint freeze authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createFreezeAccountInstruction(programId, account, mint, authority, multiSigners) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 10 // FreezeAccount instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Thaw instruction
   *
   * @param programId SPL Token program account
   * @param account Account to thaw
   * @param mint Mint account
   * @param authority Mint freeze authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createThawAccountInstruction(programId, account, mint, authority, multiSigners) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 11 // ThawAccount instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a TransferChecked instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param mint Mint account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   * @param decimals Number of decimals in transfer amount
   */ static createTransferCheckedInstruction(programId, source, mint, destination, owner, multiSigners, amount, decimals) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount"),
            $b160e2fbc6182d4d$var$u8("decimals")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 12,
            // TransferChecked instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: source,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: destination,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct an ApproveChecked instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param mint Mint account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   * @param decimals Number of decimals in approve amount
   */ static createApproveCheckedInstruction(programId, account, mint, delegate, owner, multiSigners, amount, decimals) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount"),
            $b160e2fbc6182d4d$var$u8("decimals")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 13,
            // ApproveChecked instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: delegate,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a MintToChecked instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   * @param decimals Number of decimals in amount to mint
   */ static createMintToCheckedInstruction(programId, mint, dest, authority, multiSigners, amount, decimals) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount"),
            $b160e2fbc6182d4d$var$u8("decimals")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 14,
            // MintToChecked instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: dest,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a BurnChecked instruction
   *
   * @param programId SPL Token program account
   * @param mint Mint for the account
   * @param account Account to burn tokens from
   * @param owner Owner of the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount amount to burn
   */ static createBurnCheckedInstruction(programId, mint, account, owner, multiSigners, amount, decimals) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction"),
            $b160e2fbc6182d4d$var$uint64("amount"),
            $b160e2fbc6182d4d$var$u8("decimals")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 15,
            // BurnChecked instruction
            amount: new $b160e2fbc6182d4d$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a SyncNative instruction
   *
   * @param programId SPL Token program account
   * @param nativeAccount Account to sync lamports from
   */ static createSyncNativeInstruction(programId, nativeAccount) {
        const dataLayout = $b160e2fbc6182d4d$var$struct([
            $b160e2fbc6182d4d$var$u8("instruction")
        ]);
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 17 // SyncNative instruction
        }, data);
        let keys = [
            {
                pubkey: nativeAccount,
                isSigner: false,
                isWritable: true
            }
        ];
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Get the address for the associated token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param owner Owner of the new account
   * @return Public key of the associated token account
   */ static async getAssociatedTokenAddress(associatedProgramId, programId, mint, owner, allowOwnerOffCurve = false) {
        if (!allowOwnerOffCurve && !(0, $1biTx.PublicKey).isOnCurve(owner.toBuffer())) throw new Error(`Owner cannot sign: ${owner.toString()}`);
        return (await (0, $1biTx.PublicKey).findProgramAddress([
            owner.toBuffer(),
            programId.toBuffer(),
            mint.toBuffer()
        ], associatedProgramId))[0];
    }
    /**
   * Construct the AssociatedTokenProgram instruction to create the associated
   * token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param associatedAccount New associated account
   * @param owner Owner of the new account
   * @param payer Payer of fees
   */ static createAssociatedTokenAccountInstruction(associatedProgramId, programId, mint, associatedAccount, owner, payer) {
        const data = $b160e2fbc6182d4d$var$buffer.Buffer.alloc(0);
        let keys = [
            {
                pubkey: payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: associatedAccount,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: owner,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: (0, $1biTx.SystemProgram).programId,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: programId,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: (0, $1biTx.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        return new (0, $1biTx.TransactionInstruction)({
            keys: keys,
            programId: associatedProgramId,
            data: data
        });
    }
}

});
parcelRegister("5V9Vg", function(module, exports) {

var $lOf49 = parcelRequire("lOf49");
function $44f9f90cb121233a$var$_defineProperty(obj, key, value) {
    key = $lOf49(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $44f9f90cb121233a$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cLoKX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.config = void 0;
module.exports.config = {
    arweaveWallet: "HvwC9QSAzvGXhhVrgPmauVwFWcYZhne3hVot9EbHuFTm",
    programs: {
        auction: "auctxRXPeJoc4817jDhf4HbjnhEcr1cCXenosMhK5R8",
        metadata: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
        metaplex: "p1exdMJcjVao65QdewkaZRUnU6VPSXhus9n2GzWfh98",
        vault: "vau1zxA2LbssAUEF7Gpw91zMM1LvXrvpzJtmZ58rPsn",
        packs: "BNRmGgciUJuyznkYHnmitA9an1BcDDiU9JmjEQwvBYVR",
        memo: "MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr",
        token: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
    },
    maxCreatorLimit: 5
};

});

parcelRegister("5MzAB", function(module, exports) {
"use strict";
var $435d0ac3d363260d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Program = void 0;

var $1biTx = parcelRequire("1biTx");

var $kH3yO = parcelRequire("kH3yO");

var $cbQCu = parcelRequire("cbQCu");
class $435d0ac3d363260d$var$Program {
    static findProgramAddress(seeds) {
        return $435d0ac3d363260d$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $1biTx.PublicKey.findProgramAddress(seeds, this.PUBKEY))[0];
        });
    }
    static getProgramAccounts(connection, configOrCommitment) {
        return $435d0ac3d363260d$var$__awaiter(this, void 0, void 0, function*() {
            const extra = {};
            let commitment;
            if (configOrCommitment) {
                if (typeof configOrCommitment === "string") commitment = configOrCommitment;
                else {
                    commitment = configOrCommitment.commitment;
                    if (configOrCommitment.dataSlice) extra.dataSlice = configOrCommitment.dataSlice;
                    if (configOrCommitment.filters) extra.filters = configOrCommitment.filters;
                }
            }
            const args = connection._buildArgs([
                this.PUBKEY.toBase58()
            ], commitment, "base64", extra);
            const unsafeRes = yield connection._rpcRequest("getProgramAccounts", args);
            return unsafeRes.result.map(({ account: { data: data, executable: executable, lamports: lamports, owner: owner }, pubkey: pubkey })=>({
                    account: {
                        data: $cbQCu.Buffer.from(data[0], "base64"),
                        executable: executable,
                        lamports: lamports,
                        owner: new $1biTx.PublicKey(owner)
                    },
                    pubkey: new $1biTx.PublicKey(pubkey)
                })).map(({ pubkey: pubkey, account: account })=>new $kH3yO.Account(pubkey, account));
        });
    }
}
module.exports.Program = $435d0ac3d363260d$var$Program;

});

parcelRegister("3oCjM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transaction = void 0;

var $1biTx = parcelRequire("1biTx");
class $279156220c44fe77$var$Transaction extends $1biTx.Transaction {
    constructor(options){
        super(options);
    }
    static fromCombined(transactions, options = {}) {
        const combinedTransaction = new $279156220c44fe77$var$Transaction(options);
        transactions.forEach((transaction)=>transaction.instructions.forEach((instruction)=>{
                combinedTransaction.add(instruction);
            }));
        return combinedTransaction;
    }
}
module.exports.Transaction = $279156220c44fe77$var$Transaction;

});

parcelRegister("feOHt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4NBGR", function(module, exports) {
"use strict";
var $37e8f986525f13c3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $37e8f986525f13c3$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $37e8f986525f13c3$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $37e8f986525f13c3$var$__createBinding(result, mod, k);
    }
    $37e8f986525f13c3$var$__setModuleDefault(result, mod);
    return result;
};
var $37e8f986525f13c3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $37e8f986525f13c3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Borsh = void 0;

module.exports.Borsh = $37e8f986525f13c3$var$__importStar((parcelRequire("cZZNM")));

$37e8f986525f13c3$var$__exportStar((parcelRequire("d09GC")), module.exports);

});
parcelRegister("cZZNM", function(module, exports) {

var $cbQCu = parcelRequire("cbQCu");
var $976b1f1e5c3a5926$require$Buffer = $cbQCu.Buffer;
"use strict";
var $976b1f1e5c3a5926$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serialize = module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.struct = module.exports.Data = module.exports.extendBorsh = void 0;

var $1biTx = parcelRequire("1biTx");

var $frIZw = parcelRequire("frIZw");
Object.defineProperty(module.exports, "deserializeUnchecked", {
    enumerable: true,
    get: function() {
        return $frIZw.deserializeUnchecked;
    }
});
Object.defineProperty(module.exports, "serialize", {
    enumerable: true,
    get: function() {
        return $frIZw.serialize;
    }
});
Object.defineProperty(module.exports, "deserialize", {
    enumerable: true,
    get: function() {
        return $frIZw.deserialize;
    }
});

const $976b1f1e5c3a5926$var$bs58_1 = $976b1f1e5c3a5926$var$__importDefault((parcelRequire("f4WXk")));
const $976b1f1e5c3a5926$var$extendBorsh = ()=>{
    $frIZw.BinaryReader.prototype.readPubkey = function() {
        const array = this.readFixedArray(32);
        return new $1biTx.PublicKey(array);
    };
    $frIZw.BinaryWriter.prototype.writePubkey = function(value) {
        this.writeFixedArray(value.toBuffer());
    };
    $frIZw.BinaryReader.prototype.readPubkeyAsString = function() {
        const array = this.readFixedArray(32);
        return $976b1f1e5c3a5926$var$bs58_1.default.encode(array);
    };
    $frIZw.BinaryWriter.prototype.writePubkeyAsString = function(value) {
        this.writeFixedArray($976b1f1e5c3a5926$var$bs58_1.default.decode(value));
    };
};
module.exports.extendBorsh = $976b1f1e5c3a5926$var$extendBorsh;
(0, module.exports.extendBorsh)();
class $976b1f1e5c3a5926$var$Data {
    constructor(args = {}){
        Object.assign(this, args);
    }
    static struct(fields) {
        return (0, module.exports.struct)(this, fields);
    }
    static serialize(args = {}) {
        return $976b1f1e5c3a5926$require$Buffer.from((0, $frIZw.serialize)(this.SCHEMA, new this(args)));
    }
    static deserialize(data) {
        return (0, $frIZw.deserializeUnchecked)(this.SCHEMA, this, data);
    }
}
module.exports.Data = $976b1f1e5c3a5926$var$Data;
const $976b1f1e5c3a5926$var$struct = (type, fields)=>{
    return new Map([
        [
            type,
            {
                kind: "struct",
                fields: fields
            }
        ]
    ]);
};
module.exports.struct = $976b1f1e5c3a5926$var$struct;

});
parcelRegister("frIZw", function(module, exports) {

var $cbQCu = parcelRequire("cbQCu");
var $b3ec46f9f1a0b18c$require$Buffer = $cbQCu.Buffer;
"use strict";
var $b3ec46f9f1a0b18c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b3ec46f9f1a0b18c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b3ec46f9f1a0b18c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b3ec46f9f1a0b18c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $b3ec46f9f1a0b18c$var$__createBinding(result, mod, k);
    }
    $b3ec46f9f1a0b18c$var$__setModuleDefault(result, mod);
    return result;
};
var $b3ec46f9f1a0b18c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $b3ec46f9f1a0b18c$var$bn_js_1 = $b3ec46f9f1a0b18c$var$__importDefault((parcelRequire("cj5EG")));

const $b3ec46f9f1a0b18c$var$bs58_1 = $b3ec46f9f1a0b18c$var$__importDefault((parcelRequire("f4WXk")));

// TODO: Make sure this polyfill not included when not required
const $b3ec46f9f1a0b18c$var$encoding = $b3ec46f9f1a0b18c$var$__importStar((parcelRequire("2uYNW")));
const $b3ec46f9f1a0b18c$var$TextDecoder = typeof $parcel$global.TextDecoder !== "function" ? $b3ec46f9f1a0b18c$var$encoding.TextDecoder : $parcel$global.TextDecoder;
const $b3ec46f9f1a0b18c$var$textDecoder = new $b3ec46f9f1a0b18c$var$TextDecoder("utf-8", {
    fatal: true
});
function $b3ec46f9f1a0b18c$var$baseEncode(value) {
    if (typeof value === "string") value = $b3ec46f9f1a0b18c$require$Buffer.from(value, "utf8");
    return $b3ec46f9f1a0b18c$var$bs58_1.default.encode($b3ec46f9f1a0b18c$require$Buffer.from(value));
}
module.exports.baseEncode = $b3ec46f9f1a0b18c$var$baseEncode;
function $b3ec46f9f1a0b18c$var$baseDecode(value) {
    return $b3ec46f9f1a0b18c$require$Buffer.from($b3ec46f9f1a0b18c$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $b3ec46f9f1a0b18c$var$baseDecode;
const $b3ec46f9f1a0b18c$var$INITIAL_LENGTH = 1024;
class $b3ec46f9f1a0b18c$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $b3ec46f9f1a0b18c$var$BorshError;
/// Binary encoder.
class $b3ec46f9f1a0b18c$var$BinaryWriter {
    constructor(){
        this.buf = $b3ec46f9f1a0b18c$require$Buffer.alloc($b3ec46f9f1a0b18c$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $b3ec46f9f1a0b18c$require$Buffer.concat([
            this.buf,
            $b3ec46f9f1a0b18c$require$Buffer.alloc($b3ec46f9f1a0b18c$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($b3ec46f9f1a0b18c$require$Buffer.from(new $b3ec46f9f1a0b18c$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($b3ec46f9f1a0b18c$require$Buffer.from(new $b3ec46f9f1a0b18c$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($b3ec46f9f1a0b18c$require$Buffer.from(new $b3ec46f9f1a0b18c$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($b3ec46f9f1a0b18c$require$Buffer.from(new $b3ec46f9f1a0b18c$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $b3ec46f9f1a0b18c$require$Buffer.concat([
            $b3ec46f9f1a0b18c$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $b3ec46f9f1a0b18c$require$Buffer.alloc($b3ec46f9f1a0b18c$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $b3ec46f9f1a0b18c$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($b3ec46f9f1a0b18c$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $b3ec46f9f1a0b18c$var$BinaryWriter;
function $b3ec46f9f1a0b18c$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $b3ec46f9f1a0b18c$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $b3ec46f9f1a0b18c$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $b3ec46f9f1a0b18c$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $b3ec46f9f1a0b18c$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $b3ec46f9f1a0b18c$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $b3ec46f9f1a0b18c$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $b3ec46f9f1a0b18c$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $b3ec46f9f1a0b18c$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $b3ec46f9f1a0b18c$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readU8", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readU16", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readU32", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readU64", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readU128", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readU256", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readU512", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readString", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readFixedArray", null);
$b3ec46f9f1a0b18c$var$__decorate([
    $b3ec46f9f1a0b18c$var$handlingRangeError
], $b3ec46f9f1a0b18c$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $b3ec46f9f1a0b18c$var$BinaryReader;
function $b3ec46f9f1a0b18c$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $b3ec46f9f1a0b18c$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$b3ec46f9f1a0b18c$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $b3ec46f9f1a0b18c$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else writer.writeArray(value, (item)=>{
                $b3ec46f9f1a0b18c$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $b3ec46f9f1a0b18c$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            default:
                throw new $b3ec46f9f1a0b18c$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $b3ec46f9f1a0b18c$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $b3ec46f9f1a0b18c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $b3ec46f9f1a0b18c$var$serializeStruct(schema, obj, writer) {
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $b3ec46f9f1a0b18c$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $b3ec46f9f1a0b18c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $b3ec46f9f1a0b18c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $b3ec46f9f1a0b18c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $b3ec46f9f1a0b18c$var$serialize(schema, obj) {
    const writer = new $b3ec46f9f1a0b18c$var$BinaryWriter();
    $b3ec46f9f1a0b18c$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $b3ec46f9f1a0b18c$var$serialize;
function $b3ec46f9f1a0b18c$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$b3ec46f9f1a0b18c$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            return reader.readArray(()=>$b3ec46f9f1a0b18c$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $b3ec46f9f1a0b18c$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        return $b3ec46f9f1a0b18c$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $b3ec46f9f1a0b18c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $b3ec46f9f1a0b18c$var$deserializeStruct(schema, classType, reader) {
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $b3ec46f9f1a0b18c$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $b3ec46f9f1a0b18c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $b3ec46f9f1a0b18c$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $b3ec46f9f1a0b18c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $b3ec46f9f1a0b18c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $b3ec46f9f1a0b18c$var$deserialize(schema, classType, buffer) {
    const reader = new $b3ec46f9f1a0b18c$var$BinaryReader(buffer);
    const result = $b3ec46f9f1a0b18c$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $b3ec46f9f1a0b18c$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $b3ec46f9f1a0b18c$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $b3ec46f9f1a0b18c$var$deserializeUnchecked(schema, classType, buffer) {
    const reader = new $b3ec46f9f1a0b18c$var$BinaryReader(buffer);
    return $b3ec46f9f1a0b18c$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $b3ec46f9f1a0b18c$var$deserializeUnchecked;

});


parcelRegister("d09GC", function(module, exports) {
"use strict";
var $9772c9f23d44e93f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBNFromData = module.exports.TupleNumericType = void 0;

const $9772c9f23d44e93f$var$bn_js_1 = $9772c9f23d44e93f$var$__importDefault((parcelRequire("cj5EG")));
var $9772c9f23d44e93f$var$TupleNumericType;
(function(TupleNumericType) {
    TupleNumericType[TupleNumericType["U8"] = 1] = "U8";
    TupleNumericType[TupleNumericType["U16"] = 2] = "U16";
    TupleNumericType[TupleNumericType["U32"] = 4] = "U32";
    TupleNumericType[TupleNumericType["U64"] = 8] = "U64";
})($9772c9f23d44e93f$var$TupleNumericType = module.exports.TupleNumericType || (module.exports.TupleNumericType = {}));
const $9772c9f23d44e93f$var$getBNFromData = (data, offset, dataType)=>{
    switch(dataType){
        case $9772c9f23d44e93f$var$TupleNumericType.U8:
            return new $9772c9f23d44e93f$var$bn_js_1.default(data[offset], "le");
        case $9772c9f23d44e93f$var$TupleNumericType.U16:
            return new $9772c9f23d44e93f$var$bn_js_1.default(data.slice(offset, offset + 2), "le");
        case $9772c9f23d44e93f$var$TupleNumericType.U32:
            return new $9772c9f23d44e93f$var$bn_js_1.default(data.slice(offset, offset + 4), "le");
        case $9772c9f23d44e93f$var$TupleNumericType.U64:
            return new $9772c9f23d44e93f$var$bn_js_1.default(data.slice(offset, offset + 8), "le");
    }
};
module.exports.getBNFromData = $9772c9f23d44e93f$var$getBNFromData;

});





parcelRegister("4fyYc", function(module, exports) {
"use strict";
var $3183b074d457cdf3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3183b074d457cdf3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $3183b074d457cdf3$var$_a, $3183b074d457cdf3$var$_b, $3183b074d457cdf3$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Vault = module.exports.VaultData = module.exports.VaultState = module.exports.NumberOfShareArgs = module.exports.AmountArgs = void 0;

var $1biTx = parcelRequire("1biTx");

const $3183b074d457cdf3$var$bs58_1 = $3183b074d457cdf3$var$__importDefault((parcelRequire("f4WXk")));

var $1jULY = parcelRequire("1jULY");

var $5Hty4 = parcelRequire("5Hty4");

var $9JmsZ = parcelRequire("9JmsZ");

var $cbQCu = parcelRequire("cbQCu");
class $3183b074d457cdf3$var$AmountArgs extends $1jULY.Borsh.Data {
}
module.exports.AmountArgs = $3183b074d457cdf3$var$AmountArgs;
$3183b074d457cdf3$var$_a = $3183b074d457cdf3$var$AmountArgs;
$3183b074d457cdf3$var$AmountArgs.SCHEMA = $3183b074d457cdf3$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "amount",
        "u64"
    ]
]);
class $3183b074d457cdf3$var$NumberOfShareArgs extends $1jULY.Borsh.Data {
}
module.exports.NumberOfShareArgs = $3183b074d457cdf3$var$NumberOfShareArgs;
$3183b074d457cdf3$var$_b = $3183b074d457cdf3$var$NumberOfShareArgs;
$3183b074d457cdf3$var$NumberOfShareArgs.SCHEMA = $3183b074d457cdf3$var$_b.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "numberOfShares",
        "u64"
    ]
]);
var $3183b074d457cdf3$var$VaultState;
(function(VaultState) {
    VaultState[VaultState["Inactive"] = 0] = "Inactive";
    VaultState[VaultState["Active"] = 1] = "Active";
    VaultState[VaultState["Combined"] = 2] = "Combined";
    VaultState[VaultState["Deactivated"] = 3] = "Deactivated";
})($3183b074d457cdf3$var$VaultState = module.exports.VaultState || (module.exports.VaultState = {}));
class $3183b074d457cdf3$var$VaultData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9JmsZ.VaultKey.VaultV1;
    }
}
module.exports.VaultData = $3183b074d457cdf3$var$VaultData;
$3183b074d457cdf3$var$_c = $3183b074d457cdf3$var$VaultData;
$3183b074d457cdf3$var$VaultData.SCHEMA = $3183b074d457cdf3$var$_c.struct([
    [
        "key",
        "u8"
    ],
    [
        "tokenProgram",
        "pubkeyAsString"
    ],
    [
        "fractionMint",
        "pubkeyAsString"
    ],
    [
        "authority",
        "pubkeyAsString"
    ],
    [
        "fractionTreasury",
        "pubkeyAsString"
    ],
    [
        "redeemTreasury",
        "pubkeyAsString"
    ],
    [
        "allowFurtherShareCreation",
        "u8"
    ],
    [
        "pricingLookupAddress",
        "pubkeyAsString"
    ],
    [
        "tokenTypeCount",
        "u8"
    ],
    [
        "state",
        "u8"
    ],
    [
        "lockedPricePerShare",
        "u64"
    ]
]);
class $3183b074d457cdf3$var$Vault extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($9JmsZ.VaultProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$3183b074d457cdf3$var$Vault.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $3183b074d457cdf3$var$VaultData.deserialize(this.info.data);
    }
    static getPDA(pubkey) {
        return $3183b074d457cdf3$var$__awaiter(this, void 0, void 0, function*() {
            return $9JmsZ.VaultProgram.findProgramAddress([
                $cbQCu.Buffer.from($9JmsZ.VaultProgram.PREFIX),
                $9JmsZ.VaultProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(pubkey).toBuffer()
            ]);
        });
    }
    static isCompatible(data) {
        return data[0] === $9JmsZ.VaultKey.VaultV1;
    }
    getSafetyDepositBoxes(connection) {
        return $3183b074d457cdf3$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $9JmsZ.VaultProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: $3183b074d457cdf3$var$bs58_1.default.encode($cbQCu.Buffer.from([
                                $9JmsZ.VaultKey.SafetyDepositBoxV1
                            ]))
                        }
                    },
                    {
                        memcmp: {
                            offset: 1,
                            bytes: this.pubkey.toBase58()
                        }
                    }
                ]
            })).map((account)=>$5Hty4.SafetyDepositBox.from(account));
        });
    }
}
module.exports.Vault = $3183b074d457cdf3$var$Vault;
$3183b074d457cdf3$var$Vault.MAX_VAULT_SIZE = 205;
$3183b074d457cdf3$var$Vault.MAX_EXTERNAL_ACCOUNT_SIZE = 42;

});

parcelRegister("2zN3r", function(module, exports) {
"use strict";
var $1e04e6db40c2b799$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalPriceAccount = module.exports.ExternalPriceAccountData = void 0;

var $1jULY = parcelRequire("1jULY");

var $9JmsZ = parcelRequire("9JmsZ");
class $1e04e6db40c2b799$var$ExternalPriceAccountData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9JmsZ.VaultKey.ExternalPriceAccountV1;
    }
}
module.exports.ExternalPriceAccountData = $1e04e6db40c2b799$var$ExternalPriceAccountData;
$1e04e6db40c2b799$var$_a = $1e04e6db40c2b799$var$ExternalPriceAccountData;
$1e04e6db40c2b799$var$ExternalPriceAccountData.SCHEMA = $1e04e6db40c2b799$var$_a.struct([
    [
        "key",
        "u8"
    ],
    [
        "pricePerShare",
        "u64"
    ],
    [
        "priceMint",
        "pubkeyAsString"
    ],
    [
        "allowedToCombine",
        "u8"
    ]
]);
class $1e04e6db40c2b799$var$ExternalPriceAccount extends $1jULY.Account {
    constructor(key, info){
        super(key, info);
        if (!this.assertOwner($9JmsZ.VaultProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$1e04e6db40c2b799$var$ExternalPriceAccount.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $1e04e6db40c2b799$var$ExternalPriceAccountData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $9JmsZ.VaultKey.ExternalPriceAccountV1;
    }
}
module.exports.ExternalPriceAccount = $1e04e6db40c2b799$var$ExternalPriceAccount;

});

parcelRegister("evWdx", function(module, exports) {
"use strict";
var $a9111eac06e2a389$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a9111eac06e2a389$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a9111eac06e2a389$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a9111eac06e2a389$var$__exportStar((parcelRequire("cDaFP")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("g9Wi7")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("kfhIF")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("lz9Qh")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("9XKN4")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("lguOl")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("cM0y6")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("7yRmN")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("ixNlc")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("33kxI")), module.exports);

$a9111eac06e2a389$var$__exportStar((parcelRequire("9C4QJ")), module.exports);

});
parcelRegister("cDaFP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActivateVault = void 0;

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $4fyYc = parcelRequire("4fyYc");

var $9JmsZ = parcelRequire("9JmsZ");

var $1jULY = parcelRequire("1jULY");
class $9321681f910297cf$var$ActivateVault extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, vaultAuthority: vaultAuthority, fractionMint: fractionMint, fractionTreasury: fractionTreasury, fractionMintAuthority: fractionMintAuthority, numberOfShares: numberOfShares } = params;
        const data = $4fyYc.NumberOfShareArgs.serialize({
            instruction: $9JmsZ.VaultInstructions.ActivateVault,
            numberOfShares: numberOfShares
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMintAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.ActivateVault = $9321681f910297cf$var$ActivateVault;

});

parcelRegister("g9Wi7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddSharesToTreasury = void 0;

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $4fyYc = parcelRequire("4fyYc");

var $9JmsZ = parcelRequire("9JmsZ");

var $1jULY = parcelRequire("1jULY");
class $bc3ab402ba9f46bf$var$AddSharesToTreasury extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, vaultAuthority: vaultAuthority, source: source, transferAuthority: transferAuthority, fractionTreasury: fractionTreasury, numberOfShares: numberOfShares } = params;
        const data = $4fyYc.NumberOfShareArgs.serialize({
            instruction: $9JmsZ.VaultInstructions.AddSharesToTreasury,
            numberOfShares: numberOfShares
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: source,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.AddSharesToTreasury = $bc3ab402ba9f46bf$var$AddSharesToTreasury;

});

parcelRegister("kfhIF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddTokenToInactiveVault = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $4fyYc = parcelRequire("4fyYc");

var $9JmsZ = parcelRequire("9JmsZ");

var $9JmsZ = parcelRequire("9JmsZ");
class $ebd2f4139b93cebc$var$AddTokenToInactiveVault extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { vault: vault, vaultAuthority: vaultAuthority, tokenAccount: tokenAccount, tokenStoreAccount: tokenStoreAccount, transferAuthority: transferAuthority, safetyDepositBox: safetyDepositBox, amount: amount } = params;
        const data = $4fyYc.AmountArgs.serialize({
            instruction: $9JmsZ.VaultInstructions.AddTokenToInactiveVault,
            amount: amount
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: safetyDepositBox,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: tokenAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: tokenStoreAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.AddTokenToInactiveVault = $ebd2f4139b93cebc$var$AddTokenToInactiveVault;

});

parcelRegister("lz9Qh", function(module, exports) {
"use strict";
var $040d3be060a8ee8c$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CombineVault = module.exports.CombineVaultArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $9JmsZ = parcelRequire("9JmsZ");
class $040d3be060a8ee8c$var$CombineVaultArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = $9JmsZ.VaultInstructions.CombineVault;
    }
}
module.exports.CombineVaultArgs = $040d3be060a8ee8c$var$CombineVaultArgs;
$040d3be060a8ee8c$var$_a = $040d3be060a8ee8c$var$CombineVaultArgs;
$040d3be060a8ee8c$var$CombineVaultArgs.SCHEMA = $040d3be060a8ee8c$var$_a.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $040d3be060a8ee8c$var$CombineVault extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, vaultAuthority: vaultAuthority, fractionMint: fractionMint, fractionTreasury: fractionTreasury, outstandingShareTokenAccount: outstandingShareTokenAccount, payingTokenAccount: payingTokenAccount, redeemTreasury: redeemTreasury, newVaultAuthority: newVaultAuthority, transferAuthority: transferAuthority, externalPriceAccount: externalPriceAccount, burnAuthority: burnAuthority } = params;
        const data = $040d3be060a8ee8c$var$CombineVaultArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: outstandingShareTokenAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: payingTokenAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: redeemTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newVaultAuthority || vaultAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: burnAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: externalPriceAccount,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.CombineVault = $040d3be060a8ee8c$var$CombineVault;

});

parcelRegister("9XKN4", function(module, exports) {
"use strict";
var $740deb5e45a7321a$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InitVault = module.exports.InitVaultArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $9JmsZ = parcelRequire("9JmsZ");
class $740deb5e45a7321a$var$InitVaultArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = $9JmsZ.VaultInstructions.InitVault;
        this.allowFurtherShareCreation = false;
    }
}
module.exports.InitVaultArgs = $740deb5e45a7321a$var$InitVaultArgs;
$740deb5e45a7321a$var$_a = $740deb5e45a7321a$var$InitVaultArgs;
$740deb5e45a7321a$var$InitVaultArgs.SCHEMA = $740deb5e45a7321a$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "allowFurtherShareCreation",
        "u8"
    ]
]);
class $740deb5e45a7321a$var$InitVault extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, vaultAuthority: vaultAuthority, fractionalMint: fractionalMint, redeemTreasury: redeemTreasury, fractionalTreasury: fractionalTreasury, pricingLookupAddress: pricingLookupAddress, allowFurtherShareCreation: allowFurtherShareCreation } = params;
        const data = $740deb5e45a7321a$var$InitVaultArgs.serialize({
            allowFurtherShareCreation: allowFurtherShareCreation
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: fractionalMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: redeemTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionalTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: pricingLookupAddress,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.InitVault = $740deb5e45a7321a$var$InitVault;

});

parcelRegister("lguOl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MintFractionalShares = void 0;

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $1jULY = parcelRequire("1jULY");

var $4fyYc = parcelRequire("4fyYc");

var $9JmsZ = parcelRequire("9JmsZ");
class $f7b2fe006115890a$var$MintFractionalShares extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, vaultAuthority: vaultAuthority, fractionMint: fractionMint, fractionTreasury: fractionTreasury, fractionMintAuthority: fractionMintAuthority, numberOfShares: numberOfShares } = params;
        const data = $4fyYc.NumberOfShareArgs.serialize({
            instruction: $9JmsZ.VaultInstructions.MintFractionalShares,
            numberOfShares: numberOfShares
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: fractionTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: fractionMintAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.MintFractionalShares = $f7b2fe006115890a$var$MintFractionalShares;

});

parcelRegister("cM0y6", function(module, exports) {
"use strict";
var $94ca64c71b05a726$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedeemShares = module.exports.RedeemSharesArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $9JmsZ = parcelRequire("9JmsZ");
class $94ca64c71b05a726$var$RedeemSharesArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = $9JmsZ.VaultInstructions.RedeemShares;
    }
}
module.exports.RedeemSharesArgs = $94ca64c71b05a726$var$RedeemSharesArgs;
$94ca64c71b05a726$var$_a = $94ca64c71b05a726$var$RedeemSharesArgs;
$94ca64c71b05a726$var$RedeemSharesArgs.SCHEMA = $94ca64c71b05a726$var$_a.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $94ca64c71b05a726$var$RedeemShares extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, burnAuthority: burnAuthority, fractionMint: fractionMint, outstandingSharesAccount: outstandingSharesAccount, proceedsAccount: proceedsAccount, redeemTreasury: redeemTreasury, transferAuthority: transferAuthority } = params;
        const data = $94ca64c71b05a726$var$RedeemSharesArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: outstandingSharesAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: proceedsAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: redeemTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: transferAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: burnAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.RedeemShares = $94ca64c71b05a726$var$RedeemShares;

});

parcelRegister("7yRmN", function(module, exports) {
"use strict";
var $58151ae10b18b9ef$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetVaultAuthority = module.exports.SetVaultAuthorityArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $9JmsZ = parcelRequire("9JmsZ");
class $58151ae10b18b9ef$var$SetVaultAuthorityArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = $9JmsZ.VaultInstructions.SetVaultAuthority;
    }
}
module.exports.SetVaultAuthorityArgs = $58151ae10b18b9ef$var$SetVaultAuthorityArgs;
$58151ae10b18b9ef$var$_a = $58151ae10b18b9ef$var$SetVaultAuthorityArgs;
$58151ae10b18b9ef$var$SetVaultAuthorityArgs.SCHEMA = $58151ae10b18b9ef$var$_a.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $58151ae10b18b9ef$var$SetVaultAuthority extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, currentAuthority: currentAuthority, newAuthority: newAuthority } = params;
        const data = $58151ae10b18b9ef$var$SetVaultAuthorityArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: currentAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: newAuthority,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.SetVaultAuthority = $58151ae10b18b9ef$var$SetVaultAuthority;

});

parcelRegister("ixNlc", function(module, exports) {
"use strict";
var $d801952aaceb367a$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdateExternalPriceAccount = module.exports.UpdateExternalPriceAccountArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $2zN3r = parcelRequire("2zN3r");

var $9JmsZ = parcelRequire("9JmsZ");
class $d801952aaceb367a$var$UpdateExternalPriceAccountArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = $9JmsZ.VaultInstructions.UpdateExternalPriceAccount;
    }
}
module.exports.UpdateExternalPriceAccountArgs = $d801952aaceb367a$var$UpdateExternalPriceAccountArgs;
$d801952aaceb367a$var$_a = $d801952aaceb367a$var$UpdateExternalPriceAccountArgs;
$d801952aaceb367a$var$UpdateExternalPriceAccountArgs.SCHEMA = new Map([
    ...$2zN3r.ExternalPriceAccountData.SCHEMA,
    ...$d801952aaceb367a$var$_a.struct([
        [
            "instruction",
            "u8"
        ],
        [
            "externalPriceAccount",
            $2zN3r.ExternalPriceAccountData
        ]
    ])
]);
class $d801952aaceb367a$var$UpdateExternalPriceAccount extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { externalPriceAccount: externalPriceAccount, externalPriceAccountData: externalPriceAccountData } = params;
        const data = $d801952aaceb367a$var$UpdateExternalPriceAccountArgs.serialize({
            externalPriceAccount: externalPriceAccountData
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: externalPriceAccount,
                    isSigner: false,
                    isWritable: true
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.UpdateExternalPriceAccount = $d801952aaceb367a$var$UpdateExternalPriceAccount;

});

parcelRegister("33kxI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WithdrawSharesFromTreasury = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $4fyYc = parcelRequire("4fyYc");

var $9JmsZ = parcelRequire("9JmsZ");
class $23919648ee309814$var$WithdrawSharesFromTreasury extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, vaultAuthority: vaultAuthority, destination: destination, transferAuthority: transferAuthority, fractionTreasury: fractionTreasury, numberOfShares: numberOfShares } = params;
        const data = $4fyYc.NumberOfShareArgs.serialize({
            instruction: $9JmsZ.VaultInstructions.WithdrawSharesFromTreasury,
            numberOfShares: numberOfShares
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: destination,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionTreasury,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.WithdrawSharesFromTreasury = $23919648ee309814$var$WithdrawSharesFromTreasury;

});

parcelRegister("9C4QJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WithdrawTokenFromSafetyDepositBox = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9JmsZ = parcelRequire("9JmsZ");

var $4fyYc = parcelRequire("4fyYc");

var $9JmsZ = parcelRequire("9JmsZ");
class $6ffb6ca9d3f2020a$var$WithdrawTokenFromSafetyDepositBox extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { vault: vault, vaultAuthority: vaultAuthority, store: store, destination: destination, fractionMint: fractionMint, transferAuthority: transferAuthority, safetyDepositBox: safetyDepositBox, amount: amount } = params;
        const data = $4fyYc.AmountArgs.serialize({
            instruction: $9JmsZ.VaultInstructions.WithdrawTokenFromSafetyDepositBox,
            amount: amount
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: destination,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDepositBox,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vaultAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9JmsZ.VaultProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.WithdrawTokenFromSafetyDepositBox = $6ffb6ca9d3f2020a$var$WithdrawTokenFromSafetyDepositBox;

});


parcelRegister("eg9Nr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("48E4N", function(module, exports) {
"use strict";
var $3036ff1cf43fa019$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3036ff1cf43fa019$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $3036ff1cf43fa019$var$_a, $3036ff1cf43fa019$var$_b;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuctionManager = module.exports.AuctionManagerV2Data = module.exports.AuctionManagerStateV2 = module.exports.AuctionManagerStatus = void 0;

var $1biTx = parcelRequire("1biTx");

const $3036ff1cf43fa019$var$bn_js_1 = $3036ff1cf43fa019$var$__importDefault((parcelRequire("cj5EG")));

const $3036ff1cf43fa019$var$bs58_1 = $3036ff1cf43fa019$var$__importDefault((parcelRequire("f4WXk")));

var $nvS42 = parcelRequire("nvS42");

var $iqXi3 = parcelRequire("iqXi3");

var $cbQCu = parcelRequire("cbQCu");

var $fRiXQ = parcelRequire("fRiXQ");

var $1jULY = parcelRequire("1jULY");
var $3036ff1cf43fa019$var$AuctionManagerStatus;
(function(AuctionManagerStatus) {
    AuctionManagerStatus[AuctionManagerStatus["Initialized"] = 0] = "Initialized";
    AuctionManagerStatus[AuctionManagerStatus["Validated"] = 1] = "Validated";
    AuctionManagerStatus[AuctionManagerStatus["Running"] = 2] = "Running";
    AuctionManagerStatus[AuctionManagerStatus["Disbursing"] = 3] = "Disbursing";
    AuctionManagerStatus[AuctionManagerStatus["Finished"] = 4] = "Finished";
})($3036ff1cf43fa019$var$AuctionManagerStatus = module.exports.AuctionManagerStatus || (module.exports.AuctionManagerStatus = {}));
class $3036ff1cf43fa019$var$AuctionManagerStateV2 extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.status = $3036ff1cf43fa019$var$AuctionManagerStatus.Initialized;
        this.safetyConfigItemsValidated = new $3036ff1cf43fa019$var$bn_js_1.default(0);
        this.bidsPushedToAcceptPayment = new $3036ff1cf43fa019$var$bn_js_1.default(0);
        this.hasParticipation = false;
    }
}
module.exports.AuctionManagerStateV2 = $3036ff1cf43fa019$var$AuctionManagerStateV2;
$3036ff1cf43fa019$var$_a = $3036ff1cf43fa019$var$AuctionManagerStateV2;
$3036ff1cf43fa019$var$AuctionManagerStateV2.SCHEMA = $3036ff1cf43fa019$var$_a.struct([
    [
        "status",
        "u8"
    ],
    [
        "safetyConfigItemsValidated",
        "u64"
    ],
    [
        "bidsPushedToAcceptPayment",
        "u64"
    ],
    [
        "hasParticipation",
        "u8"
    ]
]);
class $3036ff1cf43fa019$var$AuctionManagerV2Data extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $iqXi3.MetaplexKey.AuctionManagerV2;
    }
}
module.exports.AuctionManagerV2Data = $3036ff1cf43fa019$var$AuctionManagerV2Data;
$3036ff1cf43fa019$var$_b = $3036ff1cf43fa019$var$AuctionManagerV2Data;
$3036ff1cf43fa019$var$AuctionManagerV2Data.SCHEMA = new Map([
    ...$3036ff1cf43fa019$var$AuctionManagerStateV2.SCHEMA,
    ...$3036ff1cf43fa019$var$_b.struct([
        [
            "key",
            "u8"
        ],
        [
            "store",
            "pubkeyAsString"
        ],
        [
            "authority",
            "pubkeyAsString"
        ],
        [
            "auction",
            "pubkeyAsString"
        ],
        [
            "vault",
            "pubkeyAsString"
        ],
        [
            "acceptPayment",
            "pubkeyAsString"
        ],
        [
            "state",
            $3036ff1cf43fa019$var$AuctionManagerStateV2
        ]
    ])
]);
class $3036ff1cf43fa019$var$AuctionManager extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if ($3036ff1cf43fa019$var$AuctionManager.isAuctionManagerV1(this.info.data)) throw (0, $1jULY.ERROR_DEPRECATED_ACCOUNT_DATA)();
        else if ($3036ff1cf43fa019$var$AuctionManager.isAuctionManagerV2(this.info.data)) this.data = $3036ff1cf43fa019$var$AuctionManagerV2Data.deserialize(this.info.data);
        else throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
    }
    static isCompatible(data) {
        return $3036ff1cf43fa019$var$AuctionManager.isAuctionManagerV1(data) || $3036ff1cf43fa019$var$AuctionManager.isAuctionManagerV2(data);
    }
    static isAuctionManagerV1(data) {
        return data[0] === $iqXi3.MetaplexKey.AuctionManagerV1;
    }
    static isAuctionManagerV2(data) {
        return data[0] === $iqXi3.MetaplexKey.AuctionManagerV2;
    }
    static getPDA(auction) {
        return $iqXi3.MetaplexProgram.findProgramAddress([
            $cbQCu.Buffer.from($iqXi3.MetaplexProgram.PREFIX),
            new $1biTx.PublicKey(auction).toBuffer()
        ]);
    }
    static findMany(connection, filters = {}) {
        return $3036ff1cf43fa019$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $iqXi3.MetaplexProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: $3036ff1cf43fa019$var$bs58_1.default.encode($cbQCu.Buffer.from([
                                $iqXi3.MetaplexKey.AuctionManagerV2
                            ]))
                        }
                    },
                    filters.store && {
                        memcmp: {
                            offset: 1,
                            bytes: new $1biTx.PublicKey(filters.store).toBase58()
                        }
                    },
                    filters.authority && {
                        memcmp: {
                            offset: 33,
                            bytes: new $1biTx.PublicKey(filters.authority).toBase58()
                        }
                    }
                ].filter(Boolean)
            })).map((account)=>$3036ff1cf43fa019$var$AuctionManager.from(account));
        });
    }
    getAuction(connection) {
        return $3036ff1cf43fa019$var$__awaiter(this, void 0, void 0, function*() {
            return $fRiXQ.Auction.load(connection, this.data.auction);
        });
    }
    getBidRedemptionTickets(connection, haveWinnerIndex = true) {
        return $3036ff1cf43fa019$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $iqXi3.MetaplexProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: $3036ff1cf43fa019$var$bs58_1.default.encode($cbQCu.Buffer.from([
                                $iqXi3.MetaplexKey.BidRedemptionTicketV2
                            ]))
                        }
                    },
                    {
                        memcmp: {
                            offset: $nvS42.WINNER_INDEX_OFFSETS[+haveWinnerIndex],
                            bytes: this.pubkey.toBase58()
                        }
                    }
                ]
            })).map((account)=>$nvS42.BidRedemptionTicket.from(account));
        });
    }
}
module.exports.AuctionManager = $3036ff1cf43fa019$var$AuctionManager;

});
parcelRegister("nvS42", function(module, exports) {
"use strict";
var $046adf03b4d32c9e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BidRedemptionTicket = module.exports.WINNER_INDEX_OFFSETS = void 0;

const $046adf03b4d32c9e$var$bn_js_1 = $046adf03b4d32c9e$var$__importDefault((parcelRequire("cj5EG")));

const $046adf03b4d32c9e$var$bs58_1 = $046adf03b4d32c9e$var$__importDefault((parcelRequire("f4WXk")));

var $iqXi3 = parcelRequire("iqXi3");

var $1jULY = parcelRequire("1jULY");
module.exports.WINNER_INDEX_OFFSETS = [
    2,
    10
];
class $046adf03b4d32c9e$var$BidRedemptionTicket extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if ($046adf03b4d32c9e$var$BidRedemptionTicket.isBidRedemptionTicketV1(this.info.data)) throw (0, $1jULY.ERROR_DEPRECATED_ACCOUNT_DATA)();
        else if ($046adf03b4d32c9e$var$BidRedemptionTicket.isBidRedemptionTicketV2(this.info.data)) {
            const data = this.info.data.toJSON().data;
            const winnerIndex = data[1] !== 0 && new $046adf03b4d32c9e$var$bn_js_1.default(data.slice(1, 9), "le");
            const offset = module.exports.WINNER_INDEX_OFFSETS[+!!winnerIndex];
            this.data = {
                key: $iqXi3.MetaplexKey.BidRedemptionTicketV2,
                winnerIndex: winnerIndex,
                data: data,
                auctionManager: $046adf03b4d32c9e$var$bs58_1.default.encode(data.slice(offset, offset + 32))
            };
        } else throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
    }
    static isCompatible(data) {
        return $046adf03b4d32c9e$var$BidRedemptionTicket.isBidRedemptionTicketV1(data) || $046adf03b4d32c9e$var$BidRedemptionTicket.isBidRedemptionTicketV2(data);
    }
    static isBidRedemptionTicketV1(data) {
        return data[0] === $iqXi3.MetaplexKey.BidRedemptionTicketV1;
    }
    static isBidRedemptionTicketV2(data) {
        return data[0] === $iqXi3.MetaplexKey.BidRedemptionTicketV2;
    }
}
module.exports.BidRedemptionTicket = $046adf03b4d32c9e$var$BidRedemptionTicket;

});
parcelRegister("iqXi3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MetaplexProgram = module.exports.MetaplexKey = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");
var $d6b8a57eec385ef7$var$MetaplexKey;
(function(MetaplexKey) {
    MetaplexKey[MetaplexKey["Uninitialized"] = 0] = "Uninitialized";
    MetaplexKey[MetaplexKey["OriginalAuthorityLookupV1"] = 1] = "OriginalAuthorityLookupV1";
    MetaplexKey[MetaplexKey["BidRedemptionTicketV1"] = 2] = "BidRedemptionTicketV1";
    MetaplexKey[MetaplexKey["StoreV1"] = 3] = "StoreV1";
    MetaplexKey[MetaplexKey["WhitelistedCreatorV1"] = 4] = "WhitelistedCreatorV1";
    MetaplexKey[MetaplexKey["PayoutTicketV1"] = 5] = "PayoutTicketV1";
    MetaplexKey[MetaplexKey["SafetyDepositValidationTicketV1"] = 6] = "SafetyDepositValidationTicketV1";
    MetaplexKey[MetaplexKey["AuctionManagerV1"] = 7] = "AuctionManagerV1";
    MetaplexKey[MetaplexKey["PrizeTrackingTicketV1"] = 8] = "PrizeTrackingTicketV1";
    MetaplexKey[MetaplexKey["SafetyDepositConfigV1"] = 9] = "SafetyDepositConfigV1";
    MetaplexKey[MetaplexKey["AuctionManagerV2"] = 10] = "AuctionManagerV2";
    MetaplexKey[MetaplexKey["BidRedemptionTicketV2"] = 11] = "BidRedemptionTicketV2";
    MetaplexKey[MetaplexKey["AuctionWinnerTokenTypeTrackerV1"] = 12] = "AuctionWinnerTokenTypeTrackerV1";
    MetaplexKey[MetaplexKey["StoreIndexerV1"] = 13] = "StoreIndexerV1";
    MetaplexKey[MetaplexKey["AuctionCacheV1"] = 14] = "AuctionCacheV1";
    MetaplexKey[MetaplexKey["StoreConfigV1"] = 15] = "StoreConfigV1";
})($d6b8a57eec385ef7$var$MetaplexKey = module.exports.MetaplexKey || (module.exports.MetaplexKey = {}));
class $d6b8a57eec385ef7$var$MetaplexProgram extends $1jULY.Program {
}
module.exports.MetaplexProgram = $d6b8a57eec385ef7$var$MetaplexProgram;
$d6b8a57eec385ef7$var$MetaplexProgram.PREFIX = "metaplex";
$d6b8a57eec385ef7$var$MetaplexProgram.CONFIG = "config";
$d6b8a57eec385ef7$var$MetaplexProgram.TOTALS = "totals";
$d6b8a57eec385ef7$var$MetaplexProgram.PUBKEY = new $1biTx.PublicKey($1jULY.config.programs.metaplex);

});


parcelRegister("fRiXQ", function(module, exports) {
"use strict";
var $b8ba8426cdac5ccd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b8ba8426cdac5ccd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b8ba8426cdac5ccd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b8ba8426cdac5ccd$var$__exportStar((parcelRequire("fSLWB")), module.exports);

$b8ba8426cdac5ccd$var$__exportStar((parcelRequire("fARWj")), module.exports);

$b8ba8426cdac5ccd$var$__exportStar((parcelRequire("cpuOo")), module.exports);

$b8ba8426cdac5ccd$var$__exportStar((parcelRequire("j9Yn4")), module.exports);

$b8ba8426cdac5ccd$var$__exportStar((parcelRequire("BBJUh")), module.exports);

$b8ba8426cdac5ccd$var$__exportStar((parcelRequire("8Wvaj")), module.exports);

});
parcelRegister("fSLWB", function(module, exports) {
"use strict";
var $b90116e102f4c462$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b90116e102f4c462$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Auction = module.exports.AuctionData = module.exports.PriceFloor = module.exports.BidState = module.exports.Bid = module.exports.PriceFloorType = module.exports.BidStateType = module.exports.AuctionState = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

const $b90116e102f4c462$var$bn_js_1 = $b90116e102f4c462$var$__importDefault((parcelRequire("cj5EG")));

var $cbQCu = parcelRequire("cbQCu");

var $BBJUh = parcelRequire("BBJUh");

var $cpuOo = parcelRequire("cpuOo");

var $j9Yn4 = parcelRequire("j9Yn4");
var $b90116e102f4c462$var$AuctionState;
(function(AuctionState) {
    AuctionState[AuctionState["Created"] = 0] = "Created";
    AuctionState[AuctionState["Started"] = 1] = "Started";
    AuctionState[AuctionState["Ended"] = 2] = "Ended";
})($b90116e102f4c462$var$AuctionState = module.exports.AuctionState || (module.exports.AuctionState = {}));
var $b90116e102f4c462$var$BidStateType;
(function(BidStateType) {
    BidStateType[BidStateType["EnglishAuction"] = 0] = "EnglishAuction";
    BidStateType[BidStateType["OpenEdition"] = 1] = "OpenEdition";
})($b90116e102f4c462$var$BidStateType = module.exports.BidStateType || (module.exports.BidStateType = {}));
var $b90116e102f4c462$var$PriceFloorType;
(function(PriceFloorType) {
    PriceFloorType[PriceFloorType["None"] = 0] = "None";
    PriceFloorType[PriceFloorType["Minimum"] = 1] = "Minimum";
    PriceFloorType[PriceFloorType["BlindedPrice"] = 2] = "BlindedPrice";
})($b90116e102f4c462$var$PriceFloorType = module.exports.PriceFloorType || (module.exports.PriceFloorType = {}));
class $b90116e102f4c462$var$Bid extends $1jULY.Borsh.Data {
}
module.exports.Bid = $b90116e102f4c462$var$Bid;
$b90116e102f4c462$var$Bid.SCHEMA = $b90116e102f4c462$var$Bid.struct([
    [
        "key",
        "pubkeyAsString"
    ],
    [
        "amount",
        "u64"
    ]
]);
class $b90116e102f4c462$var$BidState extends $1jULY.Borsh.Data {
    getWinnerAt(winnerIndex) {
        const convertedIndex = this.bids.length - winnerIndex - 1;
        if (convertedIndex >= 0 && convertedIndex < this.bids.length) return this.bids[convertedIndex].key;
        else return null;
    }
    getAmountAt(winnerIndex) {
        const convertedIndex = this.bids.length - winnerIndex - 1;
        if (convertedIndex >= 0 && convertedIndex < this.bids.length) return this.bids[convertedIndex].amount;
        else return null;
    }
    getWinnerIndex(bidder) {
        if (!this.bids) return null;
        const index = this.bids.findIndex((b)=>b.key === bidder);
        if (index !== -1) {
            const zeroBased = this.bids.length - index - 1;
            return zeroBased < this.max.toNumber() ? zeroBased : null;
        }
        return null;
    }
}
module.exports.BidState = $b90116e102f4c462$var$BidState;
$b90116e102f4c462$var$BidState.SCHEMA = new Map([
    ...$b90116e102f4c462$var$Bid.SCHEMA,
    ...$b90116e102f4c462$var$BidState.struct([
        [
            "type",
            "u8"
        ],
        [
            "bids",
            [
                $b90116e102f4c462$var$Bid
            ]
        ],
        [
            "max",
            "u64"
        ]
    ])
]);
class $b90116e102f4c462$var$PriceFloor extends $1jULY.Borsh.Data {
    constructor(args){
        super();
        this.type = args.type;
        this.hash = args.hash || new Uint8Array(32);
        if (this.type === $b90116e102f4c462$var$PriceFloorType.Minimum) {
            if (args.minPrice) this.hash.set(args.minPrice.toArrayLike($cbQCu.Buffer, "le", 8), 0);
            else this.minPrice = new $b90116e102f4c462$var$bn_js_1.default((args.hash || new Uint8Array(0)).slice(0, 8), "le");
        }
    }
}
module.exports.PriceFloor = $b90116e102f4c462$var$PriceFloor;
$b90116e102f4c462$var$PriceFloor.SCHEMA = $b90116e102f4c462$var$PriceFloor.struct([
    [
        "type",
        "u8"
    ],
    [
        "hash",
        [
            32
        ]
    ]
]);
class $b90116e102f4c462$var$AuctionData extends $1jULY.Borsh.Data {
}
module.exports.AuctionData = $b90116e102f4c462$var$AuctionData;
$b90116e102f4c462$var$AuctionData.SCHEMA = new Map([
    ...$b90116e102f4c462$var$BidState.SCHEMA,
    ...$b90116e102f4c462$var$PriceFloor.SCHEMA,
    ...$b90116e102f4c462$var$AuctionData.struct([
        [
            "authority",
            "pubkeyAsString"
        ],
        [
            "tokenMint",
            "pubkeyAsString"
        ],
        [
            "lastBid",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "endedAt",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "endAuctionAt",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "auctionGap",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "priceFloor",
            $b90116e102f4c462$var$PriceFloor
        ],
        [
            "state",
            "u8"
        ],
        [
            "bidState",
            $b90116e102f4c462$var$BidState
        ]
    ])
]);
class $b90116e102f4c462$var$Auction extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($BBJUh.AuctionProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        this.data = $b90116e102f4c462$var$AuctionData.deserialize(this.info.data);
    }
    static getPDA(vault) {
        return $BBJUh.AuctionProgram.findProgramAddress([
            $cbQCu.Buffer.from($BBJUh.AuctionProgram.PREFIX),
            $BBJUh.AuctionProgram.PUBKEY.toBuffer(),
            new $1biTx.PublicKey(vault).toBuffer()
        ]);
    }
    static findMany(connection, filters = {}) {
        return $b90116e102f4c462$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $BBJUh.AuctionProgram.getProgramAccounts(connection, {
                filters: [
                    filters.authority && {
                        memcmp: {
                            offset: 0,
                            bytes: new $1biTx.PublicKey(filters.authority).toBase58()
                        }
                    }
                ].filter(Boolean)
            })).map((account)=>{
                try {
                    return $b90116e102f4c462$var$Auction.from(account);
                } catch (err) {}
            }).filter(Boolean);
        });
    }
    getBidderPots(connection) {
        return $b90116e102f4c462$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $BBJUh.AuctionProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        dataSize: $j9Yn4.BidderPot.DATA_SIZE
                    },
                    {
                        memcmp: {
                            offset: 64,
                            bytes: this.pubkey.toBase58()
                        }
                    }
                ]
            })).map((account)=>$j9Yn4.BidderPot.from(account));
        });
    }
    getBidderMetadata(connection) {
        return $b90116e102f4c462$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $BBJUh.AuctionProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        dataSize: $cpuOo.BidderMetadata.DATA_SIZE
                    },
                    {
                        memcmp: {
                            offset: 32,
                            bytes: this.pubkey.toBase58()
                        }
                    }
                ]
            })).map((account)=>$cpuOo.BidderMetadata.from(account));
        });
    }
}
module.exports.Auction = $b90116e102f4c462$var$Auction;
$b90116e102f4c462$var$Auction.EXTENDED_DATA_SIZE = 219;

});
parcelRegister("BBJUh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuctionProgram = void 0;

var $1biTx = parcelRequire("1biTx");

var $1jULY = parcelRequire("1jULY");
class $0710bb14b3cc0f9a$var$AuctionProgram extends $1jULY.Program {
}
module.exports.AuctionProgram = $0710bb14b3cc0f9a$var$AuctionProgram;
$0710bb14b3cc0f9a$var$AuctionProgram.PREFIX = "auction";
$0710bb14b3cc0f9a$var$AuctionProgram.EXTENDED = "extended";
$0710bb14b3cc0f9a$var$AuctionProgram.PUBKEY = new $1biTx.PublicKey($1jULY.config.programs.auction);

});

parcelRegister("cpuOo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BidderMetadata = module.exports.BidderMetadataData = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $BBJUh = parcelRequire("BBJUh");

var $cbQCu = parcelRequire("cbQCu");
class $908fb8658774509e$var$BidderMetadataData extends $1jULY.Borsh.Data {
}
module.exports.BidderMetadataData = $908fb8658774509e$var$BidderMetadataData;
$908fb8658774509e$var$BidderMetadataData.SCHEMA = $908fb8658774509e$var$BidderMetadataData.struct([
    [
        "bidderPubkey",
        "pubkeyAsString"
    ],
    [
        "auctionPubkey",
        "pubkeyAsString"
    ],
    [
        "lastBid",
        "u64"
    ],
    [
        "lastBidTimestamp",
        "u64"
    ],
    [
        "cancelled",
        "u8"
    ]
]);
class $908fb8658774509e$var$BidderMetadata extends $1jULY.Account {
    constructor(key, info){
        super(key, info);
        if (!this.assertOwner($BBJUh.AuctionProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$908fb8658774509e$var$BidderMetadata.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $908fb8658774509e$var$BidderMetadataData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data.length === $908fb8658774509e$var$BidderMetadata.DATA_SIZE;
    }
    static getPDA(auction, bidder) {
        return $BBJUh.AuctionProgram.findProgramAddress([
            $cbQCu.Buffer.from($BBJUh.AuctionProgram.PREFIX),
            $BBJUh.AuctionProgram.PUBKEY.toBuffer(),
            new $1biTx.PublicKey(auction).toBuffer(),
            new $1biTx.PublicKey(bidder).toBuffer(),
            $cbQCu.Buffer.from("metadata")
        ]);
    }
}
module.exports.BidderMetadata = $908fb8658774509e$var$BidderMetadata;
$908fb8658774509e$var$BidderMetadata.DATA_SIZE = 81;

});

parcelRegister("j9Yn4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BidderPot = module.exports.BidderPotData = void 0;

var $1jULY = parcelRequire("1jULY");

var $BBJUh = parcelRequire("BBJUh");

var $1biTx = parcelRequire("1biTx");

var $cbQCu = parcelRequire("cbQCu");
class $df2db00719f79263$var$BidderPotData extends $1jULY.Borsh.Data {
}
module.exports.BidderPotData = $df2db00719f79263$var$BidderPotData;
$df2db00719f79263$var$BidderPotData.SCHEMA = $df2db00719f79263$var$BidderPotData.struct([
    [
        "bidderPot",
        "pubkeyAsString"
    ],
    [
        "bidderAct",
        "pubkeyAsString"
    ],
    [
        "auctionAct",
        "pubkeyAsString"
    ],
    [
        "emptied",
        "u8"
    ]
]);
class $df2db00719f79263$var$BidderPot extends $1jULY.Account {
    constructor(key, info){
        super(key, info);
        if (!this.assertOwner($BBJUh.AuctionProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$df2db00719f79263$var$BidderPot.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $df2db00719f79263$var$BidderPotData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data.length === $df2db00719f79263$var$BidderPot.DATA_SIZE;
    }
    static getPDA(auction, bidder) {
        return $BBJUh.AuctionProgram.findProgramAddress([
            $cbQCu.Buffer.from($BBJUh.AuctionProgram.PREFIX),
            $BBJUh.AuctionProgram.PUBKEY.toBuffer(),
            new $1biTx.PublicKey(auction).toBuffer(),
            new $1biTx.PublicKey(bidder).toBuffer()
        ]);
    }
}
module.exports.BidderPot = $df2db00719f79263$var$BidderPot;
$df2db00719f79263$var$BidderPot.DATA_SIZE = 97;

});


parcelRegister("fARWj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuctionExtended = module.exports.AuctionDataExtended = void 0;

var $1jULY = parcelRequire("1jULY");

var $BBJUh = parcelRequire("BBJUh");

var $cbQCu = parcelRequire("cbQCu");

var $1biTx = parcelRequire("1biTx");
class $b5a40f192c5c8ae0$var$AuctionDataExtended extends $1jULY.Borsh.Data {
}
module.exports.AuctionDataExtended = $b5a40f192c5c8ae0$var$AuctionDataExtended;
$b5a40f192c5c8ae0$var$AuctionDataExtended.SCHEMA = $b5a40f192c5c8ae0$var$AuctionDataExtended.struct([
    [
        "totalUncancelledBids",
        "u64"
    ],
    [
        "tickSize",
        {
            kind: "option",
            type: "u64"
        }
    ],
    [
        "gapTickSizePercentage",
        {
            kind: "option",
            type: "u8"
        }
    ],
    [
        "instantSalePrice",
        {
            kind: "option",
            type: "u64"
        }
    ],
    [
        "name",
        {
            kind: "option",
            type: [
                32
            ]
        }
    ]
]);
class $b5a40f192c5c8ae0$var$AuctionExtended extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($BBJUh.AuctionProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$b5a40f192c5c8ae0$var$AuctionExtended.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $b5a40f192c5c8ae0$var$AuctionDataExtended.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data.length === $b5a40f192c5c8ae0$var$AuctionExtended.DATA_SIZE;
    }
    static getPDA(vault) {
        return $BBJUh.AuctionProgram.findProgramAddress([
            $cbQCu.Buffer.from($BBJUh.AuctionProgram.PREFIX),
            $BBJUh.AuctionProgram.PUBKEY.toBuffer(),
            new $1biTx.PublicKey(vault).toBuffer(),
            $cbQCu.Buffer.from($BBJUh.AuctionProgram.EXTENDED)
        ]);
    }
}
module.exports.AuctionExtended = $b5a40f192c5c8ae0$var$AuctionExtended;
$b5a40f192c5c8ae0$var$AuctionExtended.DATA_SIZE = 219;

});

parcelRegister("8Wvaj", function(module, exports) {
"use strict";
var $682bea4e410c1ba5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $682bea4e410c1ba5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $682bea4e410c1ba5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$682bea4e410c1ba5$var$__exportStar((parcelRequire("4PYMc")), module.exports);

$682bea4e410c1ba5$var$__exportStar((parcelRequire("6ssCP")), module.exports);

$682bea4e410c1ba5$var$__exportStar((parcelRequire("5afYO")), module.exports);

$682bea4e410c1ba5$var$__exportStar((parcelRequire("9wHCt")), module.exports);

$682bea4e410c1ba5$var$__exportStar((parcelRequire("iH5ul")), module.exports);

});
parcelRegister("4PYMc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancelBid = module.exports.CancelBidArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $BBJUh = parcelRequire("BBJUh");
class $385b11c1821d628e$var$CancelBidArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 0;
    }
}
module.exports.CancelBidArgs = $385b11c1821d628e$var$CancelBidArgs;
$385b11c1821d628e$var$CancelBidArgs.SCHEMA = $385b11c1821d628e$var$CancelBidArgs.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "resource",
        "pubkeyAsString"
    ]
]);
class $385b11c1821d628e$var$CancelBid extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { auction: auction, auctionExtended: auctionExtended, bidderPot: bidderPot, bidderMeta: bidderMeta, bidder: bidder, bidderToken: bidderToken, bidderPotToken: bidderPotToken, tokenMint: tokenMint, resource: resource } = params;
        const data = $385b11c1821d628e$var$CancelBidArgs.serialize({
            resource: resource.toString()
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: bidder,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: bidderToken,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderPot,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderPotToken,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderMeta,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: tokenMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1biTx.SYSVAR_CLOCK_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $BBJUh.AuctionProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.CancelBid = $385b11c1821d628e$var$CancelBid;

});

parcelRegister("6ssCP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CreateAuction = module.exports.CreateAuctionArgs = module.exports.WinnerLimit = module.exports.WinnerLimitType = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $BBJUh = parcelRequire("BBJUh");

var $fSLWB = parcelRequire("fSLWB");
var $4b3b8fff316d4ad7$var$WinnerLimitType;
(function(WinnerLimitType) {
    WinnerLimitType[WinnerLimitType["Unlimited"] = 0] = "Unlimited";
    WinnerLimitType[WinnerLimitType["Capped"] = 1] = "Capped";
})($4b3b8fff316d4ad7$var$WinnerLimitType = module.exports.WinnerLimitType || (module.exports.WinnerLimitType = {}));
class $4b3b8fff316d4ad7$var$WinnerLimit extends $1jULY.Borsh.Data {
}
module.exports.WinnerLimit = $4b3b8fff316d4ad7$var$WinnerLimit;
$4b3b8fff316d4ad7$var$WinnerLimit.SCHEMA = $4b3b8fff316d4ad7$var$WinnerLimit.struct([
    [
        "type",
        "u8"
    ],
    [
        "usize",
        "u64"
    ]
]);
class $4b3b8fff316d4ad7$var$CreateAuctionArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 1;
    }
}
module.exports.CreateAuctionArgs = $4b3b8fff316d4ad7$var$CreateAuctionArgs;
$4b3b8fff316d4ad7$var$CreateAuctionArgs.SCHEMA = new Map([
    ...$4b3b8fff316d4ad7$var$WinnerLimit.SCHEMA,
    ...$fSLWB.PriceFloor.SCHEMA,
    ...$4b3b8fff316d4ad7$var$CreateAuctionArgs.struct([
        [
            "instruction",
            "u8"
        ],
        [
            "winners",
            $4b3b8fff316d4ad7$var$WinnerLimit
        ],
        [
            "endAuctionAt",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "auctionGap",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "tokenMint",
            "pubkeyAsString"
        ],
        [
            "authority",
            "pubkeyAsString"
        ],
        [
            "resource",
            "pubkeyAsString"
        ],
        [
            "priceFloor",
            $fSLWB.PriceFloor
        ],
        [
            "tickSize",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "gapTickSizePercentage",
            {
                kind: "option",
                type: "u8"
            }
        ]
    ])
]);
class $4b3b8fff316d4ad7$var$CreateAuction extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { args: args, auction: auction, auctionExtended: auctionExtended, creator: creator } = params;
        const data = $4b3b8fff316d4ad7$var$CreateAuctionArgs.serialize(args);
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: creator,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $BBJUh.AuctionProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.CreateAuction = $4b3b8fff316d4ad7$var$CreateAuction;

});

parcelRegister("5afYO", function(module, exports) {
"use strict";
var $3c2a482e5c190386$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CreateAuctionV2 = module.exports.CreateAuctionV2Args = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $BBJUh = parcelRequire("BBJUh");

var $fSLWB = parcelRequire("fSLWB");

var $6ssCP = parcelRequire("6ssCP");
class $3c2a482e5c190386$var$CreateAuctionV2Args extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 7;
    }
}
module.exports.CreateAuctionV2Args = $3c2a482e5c190386$var$CreateAuctionV2Args;
$3c2a482e5c190386$var$_a = $3c2a482e5c190386$var$CreateAuctionV2Args;
$3c2a482e5c190386$var$CreateAuctionV2Args.SCHEMA = new Map([
    ...$6ssCP.WinnerLimit.SCHEMA,
    ...$fSLWB.PriceFloor.SCHEMA,
    ...$3c2a482e5c190386$var$_a.struct([
        [
            "instruction",
            "u8"
        ],
        [
            "winners",
            $6ssCP.WinnerLimit
        ],
        [
            "endAuctionAt",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "auctionGap",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "tokenMint",
            "pubkeyAsString"
        ],
        [
            "authority",
            "pubkeyAsString"
        ],
        [
            "resource",
            "pubkeyAsString"
        ],
        [
            "priceFloor",
            $fSLWB.PriceFloor
        ],
        [
            "tickSize",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "gapTickSizePercentage",
            {
                kind: "option",
                type: "u8"
            }
        ],
        [
            "instantSalePrice",
            {
                kind: "option",
                type: "u64"
            }
        ],
        [
            "name",
            {
                kind: "option",
                type: [
                    32
                ]
            }
        ]
    ])
]);
class $3c2a482e5c190386$var$CreateAuctionV2 extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { args: args, auction: auction, auctionExtended: auctionExtended, creator: creator } = params;
        const data = $3c2a482e5c190386$var$CreateAuctionV2Args.serialize(args);
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: creator,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $BBJUh.AuctionProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.CreateAuctionV2 = $3c2a482e5c190386$var$CreateAuctionV2;

});

parcelRegister("9wHCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlaceBid = module.exports.PlaceBidArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $BBJUh = parcelRequire("BBJUh");

var $febfi = parcelRequire("febfi");
class $6ef8f02b9575d202$var$PlaceBidArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 6;
    }
}
module.exports.PlaceBidArgs = $6ef8f02b9575d202$var$PlaceBidArgs;
$6ef8f02b9575d202$var$PlaceBidArgs.SCHEMA = $6ef8f02b9575d202$var$PlaceBidArgs.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "amount",
        "u64"
    ],
    [
        "resource",
        "pubkeyAsString"
    ]
]);
class $6ef8f02b9575d202$var$PlaceBid extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { auction: auction, auctionExtended: auctionExtended, bidderPot: bidderPot, bidderMeta: bidderMeta, bidder: bidder, bidderToken: bidderToken, bidderPotToken: bidderPotToken, tokenMint: tokenMint, transferAuthority: transferAuthority, resource: resource, amount: amount } = params;
        const data = $6ef8f02b9575d202$var$PlaceBidArgs.serialize({
            resource: resource.toString(),
            amount: amount
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: bidder,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: bidderToken,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderPot,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderPotToken,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderMeta,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: tokenMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: transferAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_CLOCK_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $BBJUh.AuctionProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.PlaceBid = $6ef8f02b9575d202$var$PlaceBid;

});

parcelRegister("iH5ul", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetAuctionAuthority = module.exports.SetAuctionAuthorityArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $BBJUh = parcelRequire("BBJUh");
class $d9c080074b75baaa$var$SetAuctionAuthorityArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 5;
    }
}
module.exports.SetAuctionAuthorityArgs = $d9c080074b75baaa$var$SetAuctionAuthorityArgs;
$d9c080074b75baaa$var$SetAuctionAuthorityArgs.SCHEMA = $d9c080074b75baaa$var$SetAuctionAuthorityArgs.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $d9c080074b75baaa$var$SetAuctionAuthority extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { auction: auction, currentAuthority: currentAuthority, newAuthority: newAuthority } = params;
        const data = $d9c080074b75baaa$var$SetAuctionAuthorityArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: currentAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: newAuthority,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $BBJUh.AuctionProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.SetAuctionAuthority = $d9c080074b75baaa$var$SetAuctionAuthority;

});




parcelRegister("7Qbh5", function(module, exports) {
"use strict";
var $5b56229c14529f24$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5b56229c14529f24$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $5b56229c14529f24$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PayoutTicket = module.exports.PayoutTicketData = void 0;

var $1biTx = parcelRequire("1biTx");

const $5b56229c14529f24$var$bs58_1 = $5b56229c14529f24$var$__importDefault((parcelRequire("f4WXk")));

var $1jULY = parcelRequire("1jULY");

var $iqXi3 = parcelRequire("iqXi3");

var $cbQCu = parcelRequire("cbQCu");
class $5b56229c14529f24$var$PayoutTicketData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $iqXi3.MetaplexKey.PayoutTicketV1;
    }
}
module.exports.PayoutTicketData = $5b56229c14529f24$var$PayoutTicketData;
$5b56229c14529f24$var$_a = $5b56229c14529f24$var$PayoutTicketData;
$5b56229c14529f24$var$PayoutTicketData.SCHEMA = $5b56229c14529f24$var$_a.struct([
    [
        "key",
        "u8"
    ],
    [
        "recipient",
        "pubkeyAsString"
    ],
    [
        "amountPaid",
        "u64"
    ]
]);
class $5b56229c14529f24$var$PayoutTicket extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$5b56229c14529f24$var$PayoutTicket.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $5b56229c14529f24$var$PayoutTicketData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $iqXi3.MetaplexKey.PayoutTicketV1;
    }
    static getPayoutTicketsByRecipient(connection, recipient) {
        return $5b56229c14529f24$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $iqXi3.MetaplexProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: $5b56229c14529f24$var$bs58_1.default.encode($cbQCu.Buffer.from([
                                $iqXi3.MetaplexKey.PayoutTicketV1
                            ]))
                        }
                    },
                    {
                        memcmp: {
                            offset: 1,
                            bytes: new $1biTx.PublicKey(recipient).toBase58()
                        }
                    }
                ]
            })).map((account)=>$5b56229c14529f24$var$PayoutTicket.from(account));
        });
    }
}
module.exports.PayoutTicket = $5b56229c14529f24$var$PayoutTicket;

});

parcelRegister("8H1TJ", function(module, exports) {
"use strict";
var $6543cfc3f27ee393$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6543cfc3f27ee393$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrizeTrackingTicket = module.exports.PrizeTrackingTicketData = void 0;

var $1biTx = parcelRequire("1biTx");

var $1jULY = parcelRequire("1jULY");

var $iqXi3 = parcelRequire("iqXi3");

var $cbQCu = parcelRequire("cbQCu");
class $6543cfc3f27ee393$var$PrizeTrackingTicketData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $iqXi3.MetaplexKey.PrizeTrackingTicketV1;
        this.key = $iqXi3.MetaplexKey.PrizeTrackingTicketV1;
    }
}
module.exports.PrizeTrackingTicketData = $6543cfc3f27ee393$var$PrizeTrackingTicketData;
$6543cfc3f27ee393$var$_a = $6543cfc3f27ee393$var$PrizeTrackingTicketData;
$6543cfc3f27ee393$var$PrizeTrackingTicketData.SCHEMA = $6543cfc3f27ee393$var$_a.struct([
    [
        "key",
        "u8"
    ],
    [
        "metadata",
        "pubkeyAsString"
    ],
    [
        "supplySnapshot",
        "u64"
    ],
    [
        "expectedRedemptions",
        "u64"
    ],
    [
        "redemptions",
        "u64"
    ]
]);
class $6543cfc3f27ee393$var$PrizeTrackingTicket extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$6543cfc3f27ee393$var$PrizeTrackingTicket.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $6543cfc3f27ee393$var$PrizeTrackingTicketData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $iqXi3.MetaplexKey.PrizeTrackingTicketV1;
    }
    static getPDA(auctionManager, mint) {
        return $6543cfc3f27ee393$var$__awaiter(this, void 0, void 0, function*() {
            return $iqXi3.MetaplexProgram.findProgramAddress([
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.PREFIX),
                $iqXi3.MetaplexProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(auctionManager).toBuffer(),
                new $1biTx.PublicKey(mint).toBuffer()
            ]);
        });
    }
}
module.exports.PrizeTrackingTicket = $6543cfc3f27ee393$var$PrizeTrackingTicket;

});

parcelRegister("kx8en", function(module, exports) {
"use strict";
var $ef2d46356eb9b314$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ef2d46356eb9b314$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafetyDepositConfig = module.exports.NonWinningConstraint = module.exports.WinningConstraint = module.exports.WinningConfigType = void 0;

var $1biTx = parcelRequire("1biTx");

const $ef2d46356eb9b314$var$bn_js_1 = $ef2d46356eb9b314$var$__importDefault((parcelRequire("cj5EG")));

const $ef2d46356eb9b314$var$bs58_1 = $ef2d46356eb9b314$var$__importDefault((parcelRequire("f4WXk")));

var $1jULY = parcelRequire("1jULY");

var $iqXi3 = parcelRequire("iqXi3");

var $cbQCu = parcelRequire("cbQCu");
var $ef2d46356eb9b314$var$WinningConfigType;
(function(WinningConfigType) {
    WinningConfigType[WinningConfigType["TokenOnlyTransfer"] = 0] = "TokenOnlyTransfer";
    WinningConfigType[WinningConfigType["FullRightsTransfer"] = 1] = "FullRightsTransfer";
    WinningConfigType[WinningConfigType["PrintingV1"] = 2] = "PrintingV1";
    WinningConfigType[WinningConfigType["PrintingV2"] = 3] = "PrintingV2";
    WinningConfigType[WinningConfigType["Participation"] = 4] = "Participation";
})($ef2d46356eb9b314$var$WinningConfigType = module.exports.WinningConfigType || (module.exports.WinningConfigType = {}));
var $ef2d46356eb9b314$var$WinningConstraint;
(function(WinningConstraint) {
    WinningConstraint[WinningConstraint["NoParticipationPrize"] = 0] = "NoParticipationPrize";
    WinningConstraint[WinningConstraint["ParticipationPrizeGiven"] = 1] = "ParticipationPrizeGiven";
})($ef2d46356eb9b314$var$WinningConstraint = module.exports.WinningConstraint || (module.exports.WinningConstraint = {}));
var $ef2d46356eb9b314$var$NonWinningConstraint;
(function(NonWinningConstraint) {
    NonWinningConstraint[NonWinningConstraint["NoParticipationPrize"] = 0] = "NoParticipationPrize";
    NonWinningConstraint[NonWinningConstraint["GivenForFixedPrice"] = 1] = "GivenForFixedPrice";
    NonWinningConstraint[NonWinningConstraint["GivenForBidPrice"] = 2] = "GivenForBidPrice";
})($ef2d46356eb9b314$var$NonWinningConstraint = module.exports.NonWinningConstraint || (module.exports.NonWinningConstraint = {}));
class $ef2d46356eb9b314$var$SafetyDepositConfig extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$ef2d46356eb9b314$var$SafetyDepositConfig.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $ef2d46356eb9b314$var$deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $iqXi3.MetaplexKey.SafetyDepositConfigV1;
    }
    static getPDA(auctionManager, safetyDeposit) {
        return $ef2d46356eb9b314$var$__awaiter(this, void 0, void 0, function*() {
            return $iqXi3.MetaplexProgram.findProgramAddress([
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.PREFIX),
                $iqXi3.MetaplexProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(auctionManager).toBuffer(),
                new $1biTx.PublicKey(safetyDeposit).toBuffer()
            ]);
        });
    }
}
module.exports.SafetyDepositConfig = $ef2d46356eb9b314$var$SafetyDepositConfig;
const $ef2d46356eb9b314$var$deserialize = (buffer)=>{
    const data = {
        key: $iqXi3.MetaplexKey.SafetyDepositConfigV1,
        auctionManager: $ef2d46356eb9b314$var$bs58_1.default.encode(buffer.slice(1, 33)),
        order: new $ef2d46356eb9b314$var$bn_js_1.default(buffer.slice(33, 41), "le"),
        winningConfigType: buffer[41],
        amountType: buffer[42],
        lengthType: buffer[43],
        amountRanges: [],
        participationConfig: null,
        participationState: null
    };
    const lengthOfArray = new $ef2d46356eb9b314$var$bn_js_1.default(buffer.slice(44, 48), "le");
    let offset = 48;
    for(let i = 0; i < lengthOfArray.toNumber(); i++){
        const amount = (0, $1jULY.getBNFromData)(buffer, offset, data.amountType);
        offset += data.amountType;
        const length = (0, $1jULY.getBNFromData)(buffer, offset, data.lengthType);
        offset += data.lengthType;
        data.amountRanges.push({
            amount: amount,
            length: length
        });
    }
    if (buffer[offset] == 0) {
        offset += 1;
        data.participationConfig = null;
    } else {
        const winnerConstraint = buffer[offset + 1];
        const nonWinningConstraint = buffer[offset + 2];
        let fixedPrice = null;
        offset += 3;
        if (buffer[offset] == 1) {
            fixedPrice = new $ef2d46356eb9b314$var$bn_js_1.default(buffer.slice(offset + 1, offset + 9), "le");
            offset += 9;
        } else offset += 1;
        data.participationConfig = {
            winnerConstraint: winnerConstraint,
            nonWinningConstraint: nonWinningConstraint,
            fixedPrice: fixedPrice
        };
    }
    if (buffer[offset] == 0) {
        offset += 1;
        data.participationState = null;
    } else {
        const collectedToAcceptPayment = new $ef2d46356eb9b314$var$bn_js_1.default(buffer.slice(offset + 1, offset + 9), "le");
        offset += 9;
        data.participationState = {
            collectedToAcceptPayment: collectedToAcceptPayment
        };
    }
    return data;
};

});

parcelRegister("hwUZp", function(module, exports) {
"use strict";
var $cc31a1c40d227b13$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cc31a1c40d227b13$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $cc31a1c40d227b13$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Store = module.exports.StoreData = void 0;

var $1jULY = parcelRequire("1jULY");

var $iqXi3 = parcelRequire("iqXi3");

var $1biTx = parcelRequire("1biTx");

const $cc31a1c40d227b13$var$bs58_1 = $cc31a1c40d227b13$var$__importDefault((parcelRequire("f4WXk")));

var $8VTmC = parcelRequire("8VTmC");

var $48E4N = parcelRequire("48E4N");

var $cbQCu = parcelRequire("cbQCu");
class $cc31a1c40d227b13$var$StoreData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $iqXi3.MetaplexKey.StoreV1;
        this.public = true;
        this.key = $iqXi3.MetaplexKey.StoreV1;
    }
}
module.exports.StoreData = $cc31a1c40d227b13$var$StoreData;
$cc31a1c40d227b13$var$_a = $cc31a1c40d227b13$var$StoreData;
$cc31a1c40d227b13$var$StoreData.SCHEMA = $cc31a1c40d227b13$var$_a.struct([
    [
        "key",
        "u8"
    ],
    [
        "public",
        "u8"
    ],
    [
        "auctionProgram",
        "pubkeyAsString"
    ],
    [
        "tokenVaultProgram",
        "pubkeyAsString"
    ],
    [
        "tokenMetadataProgram",
        "pubkeyAsString"
    ],
    [
        "tokenProgram",
        "pubkeyAsString"
    ]
]);
class $cc31a1c40d227b13$var$Store extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$cc31a1c40d227b13$var$Store.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $cc31a1c40d227b13$var$StoreData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $iqXi3.MetaplexKey.StoreV1;
    }
    static getPDA(owner) {
        return $cc31a1c40d227b13$var$__awaiter(this, void 0, void 0, function*() {
            return $iqXi3.MetaplexProgram.findProgramAddress([
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.PREFIX),
                $iqXi3.MetaplexProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(owner).toBuffer()
            ]);
        });
    }
    getWhitelistedCreators(connection) {
        return $cc31a1c40d227b13$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $iqXi3.MetaplexProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: $cc31a1c40d227b13$var$bs58_1.default.encode($cbQCu.Buffer.from([
                                $iqXi3.MetaplexKey.WhitelistedCreatorV1
                            ]))
                        }
                    }
                ]
            })).map((account)=>$8VTmC.WhitelistedCreator.from(account));
        });
    }
    getAuctionManagers(connection) {
        return $cc31a1c40d227b13$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $iqXi3.MetaplexProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: $cc31a1c40d227b13$var$bs58_1.default.encode($cbQCu.Buffer.from([
                                $iqXi3.MetaplexKey.AuctionManagerV2
                            ]))
                        }
                    },
                    {
                        memcmp: {
                            offset: 1,
                            bytes: this.pubkey.toBase58()
                        }
                    }
                ]
            })).map((account)=>$48E4N.AuctionManager.from(account));
        });
    }
}
module.exports.Store = $cc31a1c40d227b13$var$Store;

});
parcelRegister("8VTmC", function(module, exports) {
"use strict";
var $680e97aeadc524c1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $680e97aeadc524c1$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WhitelistedCreator = module.exports.WhitelistedCreatorData = void 0;

var $1jULY = parcelRequire("1jULY");

var $iqXi3 = parcelRequire("iqXi3");

var $cbQCu = parcelRequire("cbQCu");

var $1biTx = parcelRequire("1biTx");
class $680e97aeadc524c1$var$WhitelistedCreatorData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $iqXi3.MetaplexKey.WhitelistedCreatorV1;
        this.activated = true;
        this.key = $iqXi3.MetaplexKey.WhitelistedCreatorV1;
    }
}
module.exports.WhitelistedCreatorData = $680e97aeadc524c1$var$WhitelistedCreatorData;
$680e97aeadc524c1$var$_a = $680e97aeadc524c1$var$WhitelistedCreatorData;
$680e97aeadc524c1$var$WhitelistedCreatorData.SCHEMA = $680e97aeadc524c1$var$_a.struct([
    [
        "key",
        "u8"
    ],
    [
        "address",
        "pubkeyAsString"
    ],
    [
        "activated",
        "u8"
    ]
]);
class $680e97aeadc524c1$var$WhitelistedCreator extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$680e97aeadc524c1$var$WhitelistedCreator.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $680e97aeadc524c1$var$WhitelistedCreatorData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $iqXi3.MetaplexKey.WhitelistedCreatorV1;
    }
    static getPDA(store, creator) {
        return $680e97aeadc524c1$var$__awaiter(this, void 0, void 0, function*() {
            return $iqXi3.MetaplexProgram.findProgramAddress([
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.PREFIX),
                $iqXi3.MetaplexProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(store).toBuffer(),
                new $1biTx.PublicKey(creator).toBuffer()
            ]);
        });
    }
}
module.exports.WhitelistedCreator = $680e97aeadc524c1$var$WhitelistedCreator;

});


parcelRegister("izg5s", function(module, exports) {
"use strict";
var $d847f96c2424f6d9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d847f96c2424f6d9$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StoreConfig = module.exports.StoreConfigData = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $cbQCu = parcelRequire("cbQCu");

var $iqXi3 = parcelRequire("iqXi3");
class $d847f96c2424f6d9$var$StoreConfigData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $iqXi3.MetaplexKey.StoreConfigV1;
        this.key = $iqXi3.MetaplexKey.StoreConfigV1;
    }
}
module.exports.StoreConfigData = $d847f96c2424f6d9$var$StoreConfigData;
$d847f96c2424f6d9$var$_a = $d847f96c2424f6d9$var$StoreConfigData;
$d847f96c2424f6d9$var$StoreConfigData.SCHEMA = $d847f96c2424f6d9$var$_a.struct([
    [
        "key",
        "u8"
    ],
    [
        "settingsUri",
        {
            kind: "option",
            type: "string"
        }
    ]
]);
class $d847f96c2424f6d9$var$StoreConfig extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$d847f96c2424f6d9$var$StoreConfig.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $d847f96c2424f6d9$var$StoreConfigData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $iqXi3.MetaplexKey.StoreConfigV1;
    }
    static getPDA(store) {
        return $d847f96c2424f6d9$var$__awaiter(this, void 0, void 0, function*() {
            return $iqXi3.MetaplexProgram.findProgramAddress([
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.PREFIX),
                $iqXi3.MetaplexProgram.PUBKEY.toBuffer(),
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.CONFIG),
                new $1biTx.PublicKey(store).toBuffer()
            ]);
        });
    }
}
module.exports.StoreConfig = $d847f96c2424f6d9$var$StoreConfig;

});

parcelRegister("b0RIK", function(module, exports) {
"use strict";
var $80495d9db2b32f8f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $80495d9db2b32f8f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuctionWinnerTokenTypeTracker = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

const $80495d9db2b32f8f$var$bn_js_1 = $80495d9db2b32f8f$var$__importDefault((parcelRequire("cj5EG")));

var $cbQCu = parcelRequire("cbQCu");

var $iqXi3 = parcelRequire("iqXi3");
class $80495d9db2b32f8f$var$AuctionWinnerTokenTypeTracker extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($iqXi3.MetaplexProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$80495d9db2b32f8f$var$AuctionWinnerTokenTypeTracker.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $80495d9db2b32f8f$var$deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $iqXi3.MetaplexKey.AuctionWinnerTokenTypeTrackerV1;
    }
    static getPDA(auctionManager) {
        return $80495d9db2b32f8f$var$__awaiter(this, void 0, void 0, function*() {
            return $iqXi3.MetaplexProgram.findProgramAddress([
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.PREFIX),
                $iqXi3.MetaplexProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(auctionManager).toBuffer(),
                $cbQCu.Buffer.from($iqXi3.MetaplexProgram.TOTALS)
            ]);
        });
    }
}
module.exports.AuctionWinnerTokenTypeTracker = $80495d9db2b32f8f$var$AuctionWinnerTokenTypeTracker;
const $80495d9db2b32f8f$var$deserialize = (buffer)=>{
    const data = {
        key: $iqXi3.MetaplexKey.SafetyDepositConfigV1,
        amountType: buffer[1],
        lengthType: buffer[2],
        amountRanges: []
    };
    const lengthOfArray = new $80495d9db2b32f8f$var$bn_js_1.default(buffer.slice(3, 7), "le");
    let offset = 7;
    for(let i = 0; i < lengthOfArray.toNumber(); i++){
        const amount = (0, $1jULY.getBNFromData)(buffer, offset, data.amountType);
        offset += data.amountType;
        const length = (0, $1jULY.getBNFromData)(buffer, offset, data.lengthType);
        offset += data.lengthType;
        data.amountRanges.push({
            amount: amount,
            length: length
        });
    }
    return data;
};

});

parcelRegister("ce6nE", function(module, exports) {
"use strict";
var $8e6bbdde9cf89fad$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8e6bbdde9cf89fad$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8e6bbdde9cf89fad$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("lB1IZ")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("11lzA")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("hrEMY")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("9yClH")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("f8A7Y")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("4eneM")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("ihKLl")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("kAWk8")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("d5A5K")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("6oG8R")), module.exports);

$8e6bbdde9cf89fad$var$__exportStar((parcelRequire("3XfKB")), module.exports);

});
parcelRegister("lB1IZ", function(module, exports) {
"use strict";
var $fb8e642b0090d013$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClaimBid = module.exports.ClaimBidArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $fRiXQ = parcelRequire("fRiXQ");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $iqXi3 = parcelRequire("iqXi3");
class $fb8e642b0090d013$var$ClaimBidArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 6;
    }
}
module.exports.ClaimBidArgs = $fb8e642b0090d013$var$ClaimBidArgs;
$fb8e642b0090d013$var$_a = $fb8e642b0090d013$var$ClaimBidArgs;
$fb8e642b0090d013$var$ClaimBidArgs.SCHEMA = $fb8e642b0090d013$var$_a.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $fb8e642b0090d013$var$ClaimBid extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { store: store, vault: vault, auction: auction, auctionExtended: auctionExtended, auctionManager: auctionManager, bidder: bidder, bidderPot: bidderPot, bidderPotToken: bidderPotToken, acceptPayment: acceptPayment, tokenMint: tokenMint } = params;
        const data = $fb8e642b0090d013$var$ClaimBidArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: acceptPayment,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderPotToken,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidderPot,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidder,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: tokenMint,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $fRiXQ.AuctionProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_CLOCK_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.ClaimBid = $fb8e642b0090d013$var$ClaimBid;

});

parcelRegister("11lzA", function(module, exports) {
"use strict";
var $0be69e673f40a29f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $0be69e673f40a29f$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EndAuction = module.exports.EndAuctionArgs = void 0;

const $0be69e673f40a29f$var$bn_js_1 = $0be69e673f40a29f$var$__importDefault((parcelRequire("cj5EG")));

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $fRiXQ = parcelRequire("fRiXQ");

var $iqXi3 = parcelRequire("iqXi3");
class $0be69e673f40a29f$var$EndAuctionArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 20;
    }
}
module.exports.EndAuctionArgs = $0be69e673f40a29f$var$EndAuctionArgs;
$0be69e673f40a29f$var$_a = $0be69e673f40a29f$var$EndAuctionArgs;
$0be69e673f40a29f$var$EndAuctionArgs.SCHEMA = $0be69e673f40a29f$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "reveal",
        {
            kind: "option",
            type: [
                $0be69e673f40a29f$var$bn_js_1.default,
                $0be69e673f40a29f$var$bn_js_1.default
            ]
        }
    ]
]);
class $0be69e673f40a29f$var$EndAuction extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { store: store, auction: auction, auctionExtended: auctionExtended, auctionManager: auctionManager, auctionManagerAuthority: auctionManagerAuthority, reveal: reveal = null } = params;
        const data = $0be69e673f40a29f$var$EndAuctionArgs.serialize({
            reveal: reveal
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auctionManagerAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $fRiXQ.AuctionProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_CLOCK_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.EndAuction = $0be69e673f40a29f$var$EndAuction;

});

parcelRegister("hrEMY", function(module, exports) {
"use strict";
var $cb349915c1ad819b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $cb349915c1ad819b$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InitAuctionManagerV2 = module.exports.InitAuctionManagerV2Args = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

const $cb349915c1ad819b$var$bn_js_1 = $cb349915c1ad819b$var$__importDefault((parcelRequire("cj5EG")));

var $iqXi3 = parcelRequire("iqXi3");
class $cb349915c1ad819b$var$InitAuctionManagerV2Args extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 17;
        this.amountType = $1jULY.TupleNumericType.U8;
        this.lengthType = $1jULY.TupleNumericType.U8;
        this.maxRanges = new $cb349915c1ad819b$var$bn_js_1.default(1);
    }
}
module.exports.InitAuctionManagerV2Args = $cb349915c1ad819b$var$InitAuctionManagerV2Args;
$cb349915c1ad819b$var$_a = $cb349915c1ad819b$var$InitAuctionManagerV2Args;
$cb349915c1ad819b$var$InitAuctionManagerV2Args.SCHEMA = $cb349915c1ad819b$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "amountType",
        "u8"
    ],
    [
        "lengthType",
        "u8"
    ],
    [
        "maxRanges",
        "u64"
    ]
]);
class $cb349915c1ad819b$var$InitAuctionManagerV2 extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { store: store, vault: vault, auction: auction, auctionManager: auctionManager, auctionManagerAuthority: auctionManagerAuthority, acceptPaymentAccount: acceptPaymentAccount, tokenTracker: tokenTracker, amountType: amountType, lengthType: lengthType, maxRanges: maxRanges } = params;
        const data = $cb349915c1ad819b$var$InitAuctionManagerV2Args.serialize({
            amountType: amountType,
            lengthType: lengthType,
            maxRanges: maxRanges
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: tokenTracker,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auctionManagerAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: acceptPaymentAccount,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.InitAuctionManagerV2 = $cb349915c1ad819b$var$InitAuctionManagerV2;

});

parcelRegister("9yClH", function(module, exports) {
"use strict";
var $6f5509543960efd2$var$_a, $6f5509543960efd2$var$_b;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedeemBid = module.exports.RedeemUnusedWinningConfigItemsAsAuctioneerArgs = module.exports.ProxyCallAddress = module.exports.RedeemBidArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $cAjX2 = parcelRequire("cAjX2");

var $d1ogx = parcelRequire("d1ogx");

var $iqXi3 = parcelRequire("iqXi3");
class $6f5509543960efd2$var$RedeemBidArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 2;
    }
}
module.exports.RedeemBidArgs = $6f5509543960efd2$var$RedeemBidArgs;
$6f5509543960efd2$var$_a = $6f5509543960efd2$var$RedeemBidArgs;
$6f5509543960efd2$var$RedeemBidArgs.SCHEMA = $6f5509543960efd2$var$_a.struct([
    [
        "instruction",
        "u8"
    ]
]);
var $6f5509543960efd2$var$ProxyCallAddress;
(function(ProxyCallAddress) {
    ProxyCallAddress[ProxyCallAddress["RedeemBid"] = 0] = "RedeemBid";
    ProxyCallAddress[ProxyCallAddress["RedeemFullRightsTransferBid"] = 1] = "RedeemFullRightsTransferBid";
})($6f5509543960efd2$var$ProxyCallAddress = module.exports.ProxyCallAddress || (module.exports.ProxyCallAddress = {}));
class $6f5509543960efd2$var$RedeemUnusedWinningConfigItemsAsAuctioneerArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 12;
    }
}
module.exports.RedeemUnusedWinningConfigItemsAsAuctioneerArgs = $6f5509543960efd2$var$RedeemUnusedWinningConfigItemsAsAuctioneerArgs;
$6f5509543960efd2$var$_b = $6f5509543960efd2$var$RedeemUnusedWinningConfigItemsAsAuctioneerArgs;
$6f5509543960efd2$var$RedeemUnusedWinningConfigItemsAsAuctioneerArgs.SCHEMA = $6f5509543960efd2$var$_b.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "winningConfigItemIndex",
        "u8"
    ],
    [
        "proxyCall",
        "u8"
    ]
]);
class $6f5509543960efd2$var$RedeemBid extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { store: store, vault: vault, auction: auction, auctionExtended: auctionExtended, auctionManager: auctionManager, bidRedemption: bidRedemption, bidderMeta: bidMetadata, safetyDepositTokenStore: safetyDepositTokenStore, destination: destination, safetyDeposit: safetyDeposit, fractionMint: fractionMint, bidder: bidder, isPrintingType: isPrintingType, safetyDepositConfig: safetyDepositConfig, transferAuthority: transferAuthority, masterEdition: masterEdition, reservationList: reservationList, auctioneerReclaimIndex: auctioneerReclaimIndex } = params;
        const data = auctioneerReclaimIndex ? $6f5509543960efd2$var$RedeemUnusedWinningConfigItemsAsAuctioneerArgs.serialize({
            winningConfigItemIndex: auctioneerReclaimIndex,
            proxyCall: $6f5509543960efd2$var$ProxyCallAddress.RedeemBid
        }) : $6f5509543960efd2$var$RedeemBidArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDepositTokenStore,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: destination,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidRedemption,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDeposit,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidMetadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidder,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d1ogx.VaultProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $cAjX2.MetadataProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: safetyDepositConfig,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: false
                },
                ...isPrintingType && masterEdition && reservationList ? [
                    {
                        pubkey: masterEdition,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: reservationList,
                        isSigner: false,
                        isWritable: true
                    }
                ] : []
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.RedeemBid = $6f5509543960efd2$var$RedeemBid;

});
parcelRegister("cAjX2", function(module, exports) {
"use strict";
var $929852bca816d498$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $929852bca816d498$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $929852bca816d498$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$929852bca816d498$var$__exportStar((parcelRequire("dmAdW")), module.exports);

$929852bca816d498$var$__exportStar((parcelRequire("h0DHP")), module.exports);

$929852bca816d498$var$__exportStar((parcelRequire("f4qmk")), module.exports);

$929852bca816d498$var$__exportStar((parcelRequire("b1uca")), module.exports);

$929852bca816d498$var$__exportStar((parcelRequire("9iyk5")), module.exports);

$929852bca816d498$var$__exportStar((parcelRequire("ldABh")), module.exports);

});
parcelRegister("dmAdW", function(module, exports) {
"use strict";
var $9ba96dc2833811be$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Edition = module.exports.EditionData = void 0;

var $1jULY = parcelRequire("1jULY");

var $9iyk5 = parcelRequire("9iyk5");

var $1biTx = parcelRequire("1biTx");

var $cbQCu = parcelRequire("cbQCu");
class $9ba96dc2833811be$var$EditionData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9iyk5.MetadataKey.EditionV1;
    }
}
module.exports.EditionData = $9ba96dc2833811be$var$EditionData;
$9ba96dc2833811be$var$EditionData.SCHEMA = $9ba96dc2833811be$var$EditionData.struct([
    [
        "key",
        "u8"
    ],
    [
        "parent",
        "pubkeyAsString"
    ],
    [
        "edition",
        "u64"
    ]
]);
class $9ba96dc2833811be$var$Edition extends $1jULY.Account {
    constructor(key, info){
        super(key, info);
        if (!this.assertOwner($9iyk5.MetadataProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$9ba96dc2833811be$var$Edition.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $9ba96dc2833811be$var$EditionData.deserialize(this.info.data);
    }
    static getPDA(mint) {
        return $9ba96dc2833811be$var$__awaiter(this, void 0, void 0, function*() {
            return $9iyk5.MetadataProgram.findProgramAddress([
                $cbQCu.Buffer.from($9iyk5.MetadataProgram.PREFIX),
                $9iyk5.MetadataProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(mint).toBuffer(),
                $cbQCu.Buffer.from($9ba96dc2833811be$var$Edition.EDITION_PREFIX)
            ]);
        });
    }
    static isCompatible(data) {
        return data[0] === $9iyk5.MetadataKey.EditionV1;
    }
}
module.exports.Edition = $9ba96dc2833811be$var$Edition;
$9ba96dc2833811be$var$Edition.EDITION_PREFIX = "edition";

});
parcelRegister("9iyk5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MetadataProgram = module.exports.MetadataKey = void 0;

var $1biTx = parcelRequire("1biTx");

var $1jULY = parcelRequire("1jULY");
var $6c506b4cbd880f6e$var$MetadataKey;
(function(MetadataKey) {
    MetadataKey[MetadataKey["Uninitialized"] = 0] = "Uninitialized";
    MetadataKey[MetadataKey["MetadataV1"] = 4] = "MetadataV1";
    MetadataKey[MetadataKey["EditionV1"] = 1] = "EditionV1";
    MetadataKey[MetadataKey["MasterEditionV1"] = 2] = "MasterEditionV1";
    MetadataKey[MetadataKey["MasterEditionV2"] = 6] = "MasterEditionV2";
    MetadataKey[MetadataKey["EditionMarker"] = 7] = "EditionMarker";
})($6c506b4cbd880f6e$var$MetadataKey = module.exports.MetadataKey || (module.exports.MetadataKey = {}));
class $6c506b4cbd880f6e$var$MetadataProgram extends $1jULY.Program {
}
module.exports.MetadataProgram = $6c506b4cbd880f6e$var$MetadataProgram;
$6c506b4cbd880f6e$var$MetadataProgram.PREFIX = "metadata";
$6c506b4cbd880f6e$var$MetadataProgram.PUBKEY = new $1biTx.PublicKey($1jULY.config.programs.metadata);

});


parcelRegister("h0DHP", function(module, exports) {
"use strict";
var $c6213c86cd267607$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditionMarker = module.exports.EditionMarkerData = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $dmAdW = parcelRequire("dmAdW");

var $9iyk5 = parcelRequire("9iyk5");

var $cbQCu = parcelRequire("cbQCu");
class $c6213c86cd267607$var$EditionMarkerData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9iyk5.MetadataKey.EditionMarker;
    }
    editionTaken(edition) {
        const editionOffset = edition % $c6213c86cd267607$var$EditionMarker.DATA_SIZE;
        const indexOffset = Math.floor(editionOffset / 8);
        if (indexOffset > 30) throw Error("Bad index for edition");
        const positionInBitsetFromRight = 7 - editionOffset % 8;
        const mask = Math.pow(2, positionInBitsetFromRight);
        const appliedMask = this.ledger[indexOffset] & mask;
        return appliedMask != 0;
    }
}
module.exports.EditionMarkerData = $c6213c86cd267607$var$EditionMarkerData;
$c6213c86cd267607$var$EditionMarkerData.SCHEMA = $c6213c86cd267607$var$EditionMarkerData.struct([
    [
        "key",
        "u8"
    ],
    [
        "ledger",
        [
            31
        ]
    ]
]);
class $c6213c86cd267607$var$EditionMarker extends $1jULY.Account {
    constructor(key, info){
        super(key, info);
        if (!this.assertOwner($9iyk5.MetadataProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$c6213c86cd267607$var$EditionMarker.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $c6213c86cd267607$var$EditionMarkerData.deserialize(this.info.data);
    }
    static getPDA(mint, edition) {
        return $c6213c86cd267607$var$__awaiter(this, void 0, void 0, function*() {
            const editionNumber = Math.floor(edition.toNumber() / 248);
            return $9iyk5.MetadataProgram.findProgramAddress([
                $cbQCu.Buffer.from($9iyk5.MetadataProgram.PREFIX),
                $9iyk5.MetadataProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(mint).toBuffer(),
                $cbQCu.Buffer.from($dmAdW.Edition.EDITION_PREFIX),
                $cbQCu.Buffer.from(editionNumber.toString())
            ]);
        });
    }
    static isCompatible(data) {
        return data[0] === $9iyk5.MetadataKey.EditionMarker;
    }
}
module.exports.EditionMarker = $c6213c86cd267607$var$EditionMarker;
$c6213c86cd267607$var$EditionMarker.DATA_SIZE = 248;

});

parcelRegister("f4qmk", function(module, exports) {
"use strict";
var $af8bad22980241b4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $af8bad22980241b4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MasterEdition = module.exports.MasterEditionV2Data = module.exports.MasterEditionV1Data = void 0;

var $1jULY = parcelRequire("1jULY");

const $af8bad22980241b4$var$bs58_1 = $af8bad22980241b4$var$__importDefault((parcelRequire("f4WXk")));

var $dmAdW = parcelRequire("dmAdW");

var $9iyk5 = parcelRequire("9iyk5");

var $cbQCu = parcelRequire("cbQCu");

var $1biTx = parcelRequire("1biTx");
class $af8bad22980241b4$var$MasterEditionV1Data extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9iyk5.MetadataKey.MasterEditionV1;
    }
}
module.exports.MasterEditionV1Data = $af8bad22980241b4$var$MasterEditionV1Data;
$af8bad22980241b4$var$MasterEditionV1Data.SCHEMA = $af8bad22980241b4$var$MasterEditionV1Data.struct([
    [
        "key",
        "u8"
    ],
    [
        "supply",
        "u64"
    ],
    [
        "maxSupply",
        {
            kind: "option",
            type: "u64"
        }
    ],
    [
        "printingMint",
        "pubkeyAsString"
    ],
    [
        "oneTimePrintingAuthorizationMint",
        "pubkeyAsString"
    ]
]);
class $af8bad22980241b4$var$MasterEditionV2Data extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9iyk5.MetadataKey.MasterEditionV2;
    }
}
module.exports.MasterEditionV2Data = $af8bad22980241b4$var$MasterEditionV2Data;
$af8bad22980241b4$var$MasterEditionV2Data.SCHEMA = $af8bad22980241b4$var$MasterEditionV2Data.struct([
    [
        "key",
        "u8"
    ],
    [
        "supply",
        "u64"
    ],
    [
        "maxSupply",
        {
            kind: "option",
            type: "u64"
        }
    ]
]);
class $af8bad22980241b4$var$MasterEdition extends $1jULY.Account {
    constructor(key, info){
        super(key, info);
        if (!this.assertOwner($9iyk5.MetadataProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if ($af8bad22980241b4$var$MasterEdition.isMasterEditionV1(this.info.data)) this.data = $af8bad22980241b4$var$MasterEditionV1Data.deserialize(this.info.data);
        else if ($af8bad22980241b4$var$MasterEdition.isMasterEditionV2(this.info.data)) this.data = $af8bad22980241b4$var$MasterEditionV2Data.deserialize(this.info.data);
        else throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
    }
    static getPDA(mint) {
        return $af8bad22980241b4$var$__awaiter(this, void 0, void 0, function*() {
            return $9iyk5.MetadataProgram.findProgramAddress([
                $cbQCu.Buffer.from($9iyk5.MetadataProgram.PREFIX),
                $9iyk5.MetadataProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(mint).toBuffer(),
                $cbQCu.Buffer.from($af8bad22980241b4$var$MasterEdition.EDITION_PREFIX)
            ]);
        });
    }
    static isCompatible(data) {
        return $af8bad22980241b4$var$MasterEdition.isMasterEditionV1(data) || $af8bad22980241b4$var$MasterEdition.isMasterEditionV2(data);
    }
    static isMasterEditionV1(data) {
        return data[0] === $9iyk5.MetadataKey.MasterEditionV1;
    }
    static isMasterEditionV2(data) {
        return data[0] === $9iyk5.MetadataKey.MasterEditionV2;
    }
    getEditions(connection) {
        return $af8bad22980241b4$var$__awaiter(this, void 0, void 0, function*() {
            return (yield $9iyk5.MetadataProgram.getProgramAccounts(connection, {
                filters: [
                    {
                        memcmp: {
                            offset: 0,
                            bytes: $af8bad22980241b4$var$bs58_1.default.encode($cbQCu.Buffer.from([
                                $9iyk5.MetadataKey.EditionV1
                            ]))
                        }
                    },
                    {
                        memcmp: {
                            offset: 1,
                            bytes: this.pubkey.toBase58()
                        }
                    }
                ]
            })).map((account)=>$dmAdW.Edition.from(account));
        });
    }
}
module.exports.MasterEdition = $af8bad22980241b4$var$MasterEdition;
$af8bad22980241b4$var$MasterEdition.EDITION_PREFIX = "edition";

});

parcelRegister("b1uca", function(module, exports) {
"use strict";
var $806735df1eae3bb4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $806735df1eae3bb4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeCreatorOffset = module.exports.MAX_CREATOR_LEN = module.exports.MAX_URI_LENGTH = module.exports.MAX_SYMBOL_LENGTH = module.exports.MAX_NAME_LENGTH = module.exports.Metadata = module.exports.MetadataData = module.exports.MetadataDataData = module.exports.Creator = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

const $806735df1eae3bb4$var$bn_js_1 = $806735df1eae3bb4$var$__importDefault((parcelRequire("cj5EG")));

const $806735df1eae3bb4$var$bs58_1 = $806735df1eae3bb4$var$__importDefault((parcelRequire("f4WXk")));

var $cbQCu = parcelRequire("cbQCu");

var $9iyk5 = parcelRequire("9iyk5");

var $dmAdW = parcelRequire("dmAdW");

var $f4qmk = parcelRequire("f4qmk");
class $806735df1eae3bb4$var$Creator extends $1jULY.Borsh.Data {
}
module.exports.Creator = $806735df1eae3bb4$var$Creator;
$806735df1eae3bb4$var$Creator.SCHEMA = $806735df1eae3bb4$var$Creator.struct([
    [
        "address",
        "pubkeyAsString"
    ],
    [
        "verified",
        "u8"
    ],
    [
        "share",
        "u8"
    ]
]);
class $806735df1eae3bb4$var$MetadataDataData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        const METADATA_REPLACE = new RegExp("\x00", "g");
        this.name = args.name.replace(METADATA_REPLACE, "");
        this.uri = args.uri.replace(METADATA_REPLACE, "");
        this.symbol = args.symbol.replace(METADATA_REPLACE, "");
    }
}
module.exports.MetadataDataData = $806735df1eae3bb4$var$MetadataDataData;
$806735df1eae3bb4$var$MetadataDataData.SCHEMA = new Map([
    ...$806735df1eae3bb4$var$Creator.SCHEMA,
    ...$806735df1eae3bb4$var$MetadataDataData.struct([
        [
            "name",
            "string"
        ],
        [
            "symbol",
            "string"
        ],
        [
            "uri",
            "string"
        ],
        [
            "sellerFeeBasisPoints",
            "u16"
        ],
        [
            "creators",
            {
                kind: "option",
                type: [
                    $806735df1eae3bb4$var$Creator
                ]
            }
        ]
    ])
]);
class $806735df1eae3bb4$var$MetadataData extends $1jULY.Borsh.Data {
    constructor(args){
        super(args);
        this.key = $9iyk5.MetadataKey.MetadataV1;
    }
}
module.exports.MetadataData = $806735df1eae3bb4$var$MetadataData;
$806735df1eae3bb4$var$MetadataData.SCHEMA = new Map([
    ...$806735df1eae3bb4$var$MetadataDataData.SCHEMA,
    ...$806735df1eae3bb4$var$MetadataData.struct([
        [
            "key",
            "u8"
        ],
        [
            "updateAuthority",
            "pubkeyAsString"
        ],
        [
            "mint",
            "pubkeyAsString"
        ],
        [
            "data",
            $806735df1eae3bb4$var$MetadataDataData
        ],
        [
            "primarySaleHappened",
            "u8"
        ],
        [
            "isMutable",
            "u8"
        ]
    ])
]);
class $806735df1eae3bb4$var$Metadata extends $1jULY.Account {
    constructor(pubkey, info){
        super(pubkey, info);
        if (!this.assertOwner($9iyk5.MetadataProgram.PUBKEY)) throw (0, $1jULY.ERROR_INVALID_OWNER)();
        if (!$806735df1eae3bb4$var$Metadata.isCompatible(this.info.data)) throw (0, $1jULY.ERROR_INVALID_ACCOUNT_DATA)();
        this.data = $806735df1eae3bb4$var$MetadataData.deserialize(this.info.data);
    }
    static isCompatible(data) {
        return data[0] === $9iyk5.MetadataKey.MetadataV1;
    }
    static getPDA(mint) {
        return $806735df1eae3bb4$var$__awaiter(this, void 0, void 0, function*() {
            return $9iyk5.MetadataProgram.findProgramAddress([
                $cbQCu.Buffer.from($9iyk5.MetadataProgram.PREFIX),
                $9iyk5.MetadataProgram.PUBKEY.toBuffer(),
                new $1biTx.PublicKey(mint).toBuffer()
            ]);
        });
    }
    static findMany(connection, filters = {}) {
        return $806735df1eae3bb4$var$__awaiter(this, void 0, void 0, function*() {
            const baseFilters = [
                {
                    memcmp: {
                        offset: 0,
                        bytes: $806735df1eae3bb4$var$bs58_1.default.encode($cbQCu.Buffer.from([
                            $9iyk5.MetadataKey.MetadataV1
                        ]))
                    }
                },
                filters.updateAuthority && {
                    memcmp: {
                        offset: 1,
                        bytes: new $1biTx.PublicKey(filters.updateAuthority).toBase58()
                    }
                },
                filters.mint && {
                    memcmp: {
                        offset: 33,
                        bytes: new $1biTx.PublicKey(filters.mint).toBase58()
                    }
                }
            ].filter(Boolean);
            if (filters.creators) return (yield Promise.all(Array.from(Array($1jULY.config.maxCreatorLimit).keys()).reduce((prev, i)=>[
                    ...prev,
                    ...filters.creators.map((pubkey)=>$9iyk5.MetadataProgram.getProgramAccounts(connection, {
                            filters: [
                                ...baseFilters,
                                {
                                    memcmp: {
                                        offset: (0, module.exports.computeCreatorOffset)(i),
                                        bytes: new $1biTx.PublicKey(pubkey).toBase58()
                                    }
                                }
                            ]
                        }))
                ], []))).flat().map((account)=>$806735df1eae3bb4$var$Metadata.from(account));
            else return (yield $9iyk5.MetadataProgram.getProgramAccounts(connection, {
                filters: baseFilters
            })).map((account)=>$806735df1eae3bb4$var$Metadata.from(account));
        });
    }
    static findByOwner(connection, owner) {
        return $806735df1eae3bb4$var$__awaiter(this, void 0, void 0, function*() {
            const accounts = yield $1jULY.TokenAccount.getTokenAccountsByOwner(connection, owner);
            const accountMap = new Map(accounts.map(({ data: data })=>[
                    data.mint.toString(),
                    data
                ]));
            const allMetadata = yield $806735df1eae3bb4$var$Metadata.findMany(connection);
            return allMetadata.filter((metadata)=>{
                var _a, _b;
                return accountMap.has(metadata.data.mint) && (((_b = (_a = accountMap === null || accountMap === void 0 ? void 0 : accountMap.get(metadata.data.mint)) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.toNumber()) || 0) > 0;
            });
        });
    }
    static findByOwnerV2(connection, owner) {
        return $806735df1eae3bb4$var$__awaiter(this, void 0, void 0, function*() {
            const accounts = yield $1jULY.TokenAccount.getTokenAccountsByOwner(connection, owner);
            const accountsWithAmount = accounts.map(({ data: data })=>data).filter(({ amount: amount })=>(amount === null || amount === void 0 ? void 0 : amount.toNumber()) > 0);
            return (yield Promise.all(accountsWithAmount.map(({ mint: mint })=>$806735df1eae3bb4$var$Metadata.findMany(connection, {
                    mint: mint
                })))).flat();
        });
    }
    static findDataByOwner(connection, owner) {
        return $806735df1eae3bb4$var$__awaiter(this, void 0, void 0, function*() {
            const accounts = yield $1jULY.TokenAccount.getTokenAccountsByOwner(connection, owner);
            const metadataPdaLookups = accounts.reduce((memo, { data: data })=>{
                var _a;
                return ((_a = data.amount) === null || _a === void 0 ? void 0 : _a.eq(new $806735df1eae3bb4$var$bn_js_1.default(1))) ? [
                    ...memo,
                    $806735df1eae3bb4$var$Metadata.getPDA(data.mint)
                ] : memo;
            }, []);
            const metadataAddresses = yield Promise.all(metadataPdaLookups);
            const tokenInfo = yield $1jULY.Account.getInfos(connection, metadataAddresses);
            return Array.from(tokenInfo.values()).map((m)=>$806735df1eae3bb4$var$MetadataData.deserialize(m.data));
        });
    }
    static getEdition(connection, mint) {
        return $806735df1eae3bb4$var$__awaiter(this, void 0, void 0, function*() {
            const pda = yield $dmAdW.Edition.getPDA(mint);
            const info = yield $1jULY.Account.getInfo(connection, pda);
            const key = info === null || info === void 0 ? void 0 : info.data[0];
            switch(key){
                case $9iyk5.MetadataKey.EditionV1:
                    return new $dmAdW.Edition(pda, info);
                case $9iyk5.MetadataKey.MasterEditionV1:
                case $9iyk5.MetadataKey.MasterEditionV2:
                    return new $f4qmk.MasterEdition(pda, info);
                default:
                    return;
            }
        });
    }
}
module.exports.Metadata = $806735df1eae3bb4$var$Metadata;
module.exports.MAX_NAME_LENGTH = 32;
module.exports.MAX_SYMBOL_LENGTH = 10;
module.exports.MAX_URI_LENGTH = 200;
module.exports.MAX_CREATOR_LEN = 34;
const $806735df1eae3bb4$var$computeCreatorOffset = (index)=>{
    return 69 + module.exports.MAX_NAME_LENGTH + 4 + module.exports.MAX_URI_LENGTH + 4 + module.exports.MAX_SYMBOL_LENGTH + 2 + 1 + 4 + index * module.exports.MAX_CREATOR_LEN;
};
module.exports.computeCreatorOffset = $806735df1eae3bb4$var$computeCreatorOffset;

});

parcelRegister("ldABh", function(module, exports) {
"use strict";
var $f72733ed9159c54d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f72733ed9159c54d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f72733ed9159c54d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f72733ed9159c54d$var$__exportStar((parcelRequire("c5vHt")), module.exports);

$f72733ed9159c54d$var$__exportStar((parcelRequire("6M1i3")), module.exports);

$f72733ed9159c54d$var$__exportStar((parcelRequire("jKRLI")), module.exports);

$f72733ed9159c54d$var$__exportStar((parcelRequire("7Lwv8")), module.exports);

$f72733ed9159c54d$var$__exportStar((parcelRequire("dM9xT")), module.exports);

$f72733ed9159c54d$var$__exportStar((parcelRequire("kYKy3")), module.exports);

});
parcelRegister("c5vHt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CreateMetadata = module.exports.CreateMetadataArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $b1uca = parcelRequire("b1uca");

var $9iyk5 = parcelRequire("9iyk5");
class $8cce8aa8f21235fc$var$CreateMetadataArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 0;
    }
}
module.exports.CreateMetadataArgs = $8cce8aa8f21235fc$var$CreateMetadataArgs;
$8cce8aa8f21235fc$var$CreateMetadataArgs.SCHEMA = new Map([
    ...$b1uca.MetadataDataData.SCHEMA,
    ...$8cce8aa8f21235fc$var$CreateMetadataArgs.struct([
        [
            "instruction",
            "u8"
        ],
        [
            "data",
            $b1uca.MetadataDataData
        ],
        [
            "isMutable",
            "u8"
        ]
    ])
]);
class $8cce8aa8f21235fc$var$CreateMetadata extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { metadata: metadata, metadataData: metadataData, updateAuthority: updateAuthority, mint: mint, mintAuthority: mintAuthority } = params;
        const data = $8cce8aa8f21235fc$var$CreateMetadataArgs.serialize({
            data: metadataData,
            isMutable: true
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: mint,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: mintAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: updateAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9iyk5.MetadataProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.CreateMetadata = $8cce8aa8f21235fc$var$CreateMetadata;

});

parcelRegister("6M1i3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdateMetadata = module.exports.UpdateMetadataArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $b1uca = parcelRequire("b1uca");

var $9iyk5 = parcelRequire("9iyk5");
class $4ee839f849ee3eae$var$UpdateMetadataArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 1;
    }
}
module.exports.UpdateMetadataArgs = $4ee839f849ee3eae$var$UpdateMetadataArgs;
$4ee839f849ee3eae$var$UpdateMetadataArgs.SCHEMA = new Map([
    ...$b1uca.MetadataDataData.SCHEMA,
    ...$4ee839f849ee3eae$var$UpdateMetadataArgs.struct([
        [
            "instruction",
            "u8"
        ],
        [
            "data",
            {
                kind: "option",
                type: $b1uca.MetadataDataData
            }
        ],
        [
            "updateAuthority",
            {
                kind: "option",
                type: "pubkeyAsString"
            }
        ],
        [
            "primarySaleHappened",
            {
                kind: "option",
                type: "u8"
            }
        ]
    ])
]);
class $4ee839f849ee3eae$var$UpdateMetadata extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { metadata: metadata, metadataData: metadataData, updateAuthority: updateAuthority, newUpdateAuthority: newUpdateAuthority, primarySaleHappened: primarySaleHappened } = params;
        const data = $4ee839f849ee3eae$var$UpdateMetadataArgs.serialize({
            data: metadataData,
            updateAuthority: newUpdateAuthority && newUpdateAuthority.toString(),
            primarySaleHappened: primarySaleHappened || null
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: updateAuthority,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: $9iyk5.MetadataProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.UpdateMetadata = $4ee839f849ee3eae$var$UpdateMetadata;

});

parcelRegister("jKRLI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CreateMasterEdition = module.exports.CreateMasterEditionArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9iyk5 = parcelRequire("9iyk5");
class $e61c058411ac3951$var$CreateMasterEditionArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 10;
    }
}
module.exports.CreateMasterEditionArgs = $e61c058411ac3951$var$CreateMasterEditionArgs;
$e61c058411ac3951$var$CreateMasterEditionArgs.SCHEMA = $e61c058411ac3951$var$CreateMasterEditionArgs.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "maxSupply",
        {
            kind: "option",
            type: "u64"
        }
    ]
]);
class $e61c058411ac3951$var$CreateMasterEdition extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { edition: edition, metadata: metadata, updateAuthority: updateAuthority, mint: mint, mintAuthority: mintAuthority, maxSupply: maxSupply } = params;
        const data = $e61c058411ac3951$var$CreateMasterEditionArgs.serialize({
            maxSupply: maxSupply || null
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: edition,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: mint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: updateAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: mintAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9iyk5.MetadataProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.CreateMasterEdition = $e61c058411ac3951$var$CreateMasterEdition;

});

parcelRegister("7Lwv8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MintNewEditionFromMasterEditionViaToken = module.exports.MintNewEditionFromMasterEditionViaTokenArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $9iyk5 = parcelRequire("9iyk5");
class $5a762239cb0bb07f$var$MintNewEditionFromMasterEditionViaTokenArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 11;
    }
}
module.exports.MintNewEditionFromMasterEditionViaTokenArgs = $5a762239cb0bb07f$var$MintNewEditionFromMasterEditionViaTokenArgs;
$5a762239cb0bb07f$var$MintNewEditionFromMasterEditionViaTokenArgs.SCHEMA = $5a762239cb0bb07f$var$MintNewEditionFromMasterEditionViaTokenArgs.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "edition",
        "u64"
    ]
]);
class $5a762239cb0bb07f$var$MintNewEditionFromMasterEditionViaToken extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { edition: edition, metadata: metadata, updateAuthority: updateAuthority, masterEdition: masterEdition, masterMetadata: masterMetadata, mint: mint, editionMarker: editionMarker, mintAuthority: mintAuthority, tokenOwner: tokenOwner, tokenAccount: tokenAccount, editionValue: editionValue } = params;
        const data = $5a762239cb0bb07f$var$MintNewEditionFromMasterEditionViaTokenArgs.serialize({
            edition: editionValue
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: edition,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: masterEdition,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: mint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: editionMarker,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: mintAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: tokenOwner,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: tokenAccount,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: updateAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: masterMetadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9iyk5.MetadataProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.MintNewEditionFromMasterEditionViaToken = $5a762239cb0bb07f$var$MintNewEditionFromMasterEditionViaToken;

});

parcelRegister("dM9xT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdatePrimarySaleHappenedViaToken = module.exports.UpdatePrimarySaleHappenedViaTokenArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $9iyk5 = parcelRequire("9iyk5");
class $a077299d4b4d9354$var$UpdatePrimarySaleHappenedViaTokenArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 4;
    }
}
module.exports.UpdatePrimarySaleHappenedViaTokenArgs = $a077299d4b4d9354$var$UpdatePrimarySaleHappenedViaTokenArgs;
$a077299d4b4d9354$var$UpdatePrimarySaleHappenedViaTokenArgs.SCHEMA = $a077299d4b4d9354$var$UpdatePrimarySaleHappenedViaTokenArgs.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $a077299d4b4d9354$var$UpdatePrimarySaleHappenedViaToken extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { metadata: metadata, owner: owner, tokenAccount: tokenAccount } = params;
        const data = $a077299d4b4d9354$var$UpdatePrimarySaleHappenedViaTokenArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: owner,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: tokenAccount,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $9iyk5.MetadataProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.UpdatePrimarySaleHappenedViaToken = $a077299d4b4d9354$var$UpdatePrimarySaleHappenedViaToken;

});

parcelRegister("kYKy3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignMetadata = module.exports.SignMetadataArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $9iyk5 = parcelRequire("9iyk5");
class $f45d84c6bfda403e$var$SignMetadataArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 7;
    }
}
module.exports.SignMetadataArgs = $f45d84c6bfda403e$var$SignMetadataArgs;
$f45d84c6bfda403e$var$SignMetadataArgs.SCHEMA = $f45d84c6bfda403e$var$SignMetadataArgs.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $f45d84c6bfda403e$var$SignMetadata extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { metadata: metadata, creator: creator } = params;
        const data = $f45d84c6bfda403e$var$SignMetadataArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: creator,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: $9iyk5.MetadataProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.SignMetadata = $f45d84c6bfda403e$var$SignMetadata;

});



parcelRegister("d1ogx", function(module, exports) {
"use strict";
var $97ae31082b6edd3f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $97ae31082b6edd3f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $97ae31082b6edd3f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$97ae31082b6edd3f$var$__exportStar((parcelRequire("5Hty4")), module.exports);

$97ae31082b6edd3f$var$__exportStar((parcelRequire("4fyYc")), module.exports);

$97ae31082b6edd3f$var$__exportStar((parcelRequire("2zN3r")), module.exports);

$97ae31082b6edd3f$var$__exportStar((parcelRequire("9JmsZ")), module.exports);

$97ae31082b6edd3f$var$__exportStar((parcelRequire("evWdx")), module.exports);

$97ae31082b6edd3f$var$__exportStar((parcelRequire("eg9Nr")), module.exports);

});


parcelRegister("f8A7Y", function(module, exports) {
"use strict";
var $b053a08c22ab9766$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedeemFullRightsTransferBid = module.exports.RedeemFullRightsTransferBidArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $cAjX2 = parcelRequire("cAjX2");

var $d1ogx = parcelRequire("d1ogx");

var $iqXi3 = parcelRequire("iqXi3");

var $9yClH = parcelRequire("9yClH");
class $b053a08c22ab9766$var$RedeemFullRightsTransferBidArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 3;
    }
}
module.exports.RedeemFullRightsTransferBidArgs = $b053a08c22ab9766$var$RedeemFullRightsTransferBidArgs;
$b053a08c22ab9766$var$_a = $b053a08c22ab9766$var$RedeemFullRightsTransferBidArgs;
$b053a08c22ab9766$var$RedeemFullRightsTransferBidArgs.SCHEMA = $b053a08c22ab9766$var$_a.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $b053a08c22ab9766$var$RedeemFullRightsTransferBid extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { store: store, vault: vault, auction: auction, auctionExtended: auctionExtended, auctionManager: auctionManager, bidRedemption: bidRedemption, bidMetadata: bidMetadata, safetyDepositTokenStore: safetyDepositTokenStore, destination: destination, safetyDeposit: safetyDeposit, fractionMint: fractionMint, bidder: bidder, safetyDepositConfig: safetyDepositConfig, transferAuthority: transferAuthority, masterMetadata: masterMetadata, newAuthority: newAuthority, auctioneerReclaimIndex: auctioneerReclaimIndex } = params;
        const data = auctioneerReclaimIndex ? $9yClH.RedeemUnusedWinningConfigItemsAsAuctioneerArgs.serialize({
            winningConfigItemIndex: auctioneerReclaimIndex,
            proxyCall: $9yClH.ProxyCallAddress.RedeemFullRightsTransferBid
        }) : $b053a08c22ab9766$var$RedeemFullRightsTransferBidArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDepositTokenStore,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: destination,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidRedemption,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDeposit,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: fractionMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidMetadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidder,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d1ogx.VaultProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $cAjX2.MetadataProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: masterMetadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: safetyDepositConfig,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.RedeemFullRightsTransferBid = $b053a08c22ab9766$var$RedeemFullRightsTransferBid;

});

parcelRegister("4eneM", function(module, exports) {
"use strict";
var $314a7eb16512b851$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedeemPrintingV2Bid = module.exports.RedeemPrintingV2BidArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $d1ogx = parcelRequire("d1ogx");

var $cAjX2 = parcelRequire("cAjX2");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $iqXi3 = parcelRequire("iqXi3");
class $314a7eb16512b851$var$RedeemPrintingV2BidArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 14;
    }
}
module.exports.RedeemPrintingV2BidArgs = $314a7eb16512b851$var$RedeemPrintingV2BidArgs;
$314a7eb16512b851$var$_a = $314a7eb16512b851$var$RedeemPrintingV2BidArgs;
$314a7eb16512b851$var$RedeemPrintingV2BidArgs.SCHEMA = $314a7eb16512b851$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "editionOffset",
        "u64"
    ],
    [
        "winIndex",
        "u64"
    ]
]);
class $314a7eb16512b851$var$RedeemPrintingV2Bid extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { store: store, vault: vault, auction: auction, auctionExtended: auctionExtended, auctionManager: auctionManager, bidRedemption: bidRedemption, bidMetadata: bidMetadata, safetyDepositTokenStore: safetyDepositTokenStore, destination: destination, safetyDeposit: safetyDeposit, bidder: bidder, safetyDepositConfig: safetyDepositConfig, metadata: metadata, prizeTrackingTicket: prizeTrackingTicket, newMetadata: newMetadata, newEdition: newEdition, masterEdition: masterEdition, newMint: newMint, editionMark: editionMark, winIndex: winIndex, editionOffset: editionOffset } = params;
        const data = $314a7eb16512b851$var$RedeemPrintingV2BidArgs.serialize({
            winIndex: winIndex,
            editionOffset: editionOffset
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDepositTokenStore,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: destination,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidRedemption,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDeposit,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDepositConfig,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidMetadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidder,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d1ogx.VaultProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $cAjX2.MetadataProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: prizeTrackingTicket,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newMetadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newEdition,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: masterEdition,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: editionMark,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.RedeemPrintingV2Bid = $314a7eb16512b851$var$RedeemPrintingV2Bid;

});

parcelRegister("ihKLl", function(module, exports) {
"use strict";
var $d4fe169677c0a60e$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetStore = module.exports.SetStoreArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $cAjX2 = parcelRequire("cAjX2");

var $d1ogx = parcelRequire("d1ogx");

var $fRiXQ = parcelRequire("fRiXQ");

var $iqXi3 = parcelRequire("iqXi3");
class $d4fe169677c0a60e$var$SetStoreArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 8;
    }
}
module.exports.SetStoreArgs = $d4fe169677c0a60e$var$SetStoreArgs;
$d4fe169677c0a60e$var$_a = $d4fe169677c0a60e$var$SetStoreArgs;
$d4fe169677c0a60e$var$SetStoreArgs.SCHEMA = $d4fe169677c0a60e$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "public",
        "u8"
    ]
]);
class $d4fe169677c0a60e$var$SetStore extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { admin: admin, store: store, isPublic: isPublic } = params;
        const data = $d4fe169677c0a60e$var$SetStoreArgs.serialize({
            public: isPublic
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: admin,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d1ogx.VaultProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $cAjX2.MetadataProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $fRiXQ.AuctionProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.SetStore = $d4fe169677c0a60e$var$SetStore;

});

parcelRegister("kAWk8", function(module, exports) {
"use strict";
var $efe4694fe94b1c36$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetStoreV2 = module.exports.SetStoreV2Args = void 0;

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $1jULY = parcelRequire("1jULY");

var $d1ogx = parcelRequire("d1ogx");

var $cAjX2 = parcelRequire("cAjX2");

var $fRiXQ = parcelRequire("fRiXQ");

var $iqXi3 = parcelRequire("iqXi3");
class $efe4694fe94b1c36$var$SetStoreV2Args extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 23;
    }
}
module.exports.SetStoreV2Args = $efe4694fe94b1c36$var$SetStoreV2Args;
$efe4694fe94b1c36$var$_a = $efe4694fe94b1c36$var$SetStoreV2Args;
$efe4694fe94b1c36$var$SetStoreV2Args.SCHEMA = $efe4694fe94b1c36$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "public",
        "u8"
    ],
    [
        "settingsUri",
        {
            kind: "option",
            type: "string"
        }
    ]
]);
class $efe4694fe94b1c36$var$SetStoreV2 extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { admin: admin, store: store, config: config, isPublic: isPublic, settingsUri: settingsUri } = params;
        const data = $efe4694fe94b1c36$var$SetStoreV2Args.serialize({
            public: isPublic,
            settingsUri: settingsUri
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: config,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: admin,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d1ogx.VaultProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $cAjX2.MetadataProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $fRiXQ.AuctionProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.SetStoreV2 = $efe4694fe94b1c36$var$SetStoreV2;

});

parcelRegister("d5A5K", function(module, exports) {
"use strict";
var $9877bd0b8a411098$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetWhitelistedCreator = module.exports.SetWhitelistedCreatorArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $iqXi3 = parcelRequire("iqXi3");
class $9877bd0b8a411098$var$SetWhitelistedCreatorArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 9;
    }
}
module.exports.SetWhitelistedCreatorArgs = $9877bd0b8a411098$var$SetWhitelistedCreatorArgs;
$9877bd0b8a411098$var$_a = $9877bd0b8a411098$var$SetWhitelistedCreatorArgs;
$9877bd0b8a411098$var$SetWhitelistedCreatorArgs.SCHEMA = $9877bd0b8a411098$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "activated",
        "u8"
    ]
]);
class $9877bd0b8a411098$var$SetWhitelistedCreator extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { admin: admin, whitelistedCreatorPDA: whitelistedCreatorPDA, store: store, creator: creator, activated: activated } = params;
        const data = $9877bd0b8a411098$var$SetWhitelistedCreatorArgs.serialize({
            activated: activated
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: whitelistedCreatorPDA,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: admin,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: creator,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.SetWhitelistedCreator = $9877bd0b8a411098$var$SetWhitelistedCreator;

});

parcelRegister("6oG8R", function(module, exports) {
"use strict";
var $4a85ac75e311cdf2$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StartAuction = module.exports.StartAuctionArgs = void 0;

var $1jULY = parcelRequire("1jULY");

var $1biTx = parcelRequire("1biTx");

var $fRiXQ = parcelRequire("fRiXQ");

var $iqXi3 = parcelRequire("iqXi3");
class $4a85ac75e311cdf2$var$StartAuctionArgs extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 5;
    }
}
module.exports.StartAuctionArgs = $4a85ac75e311cdf2$var$StartAuctionArgs;
$4a85ac75e311cdf2$var$_a = $4a85ac75e311cdf2$var$StartAuctionArgs;
$4a85ac75e311cdf2$var$StartAuctionArgs.SCHEMA = $4a85ac75e311cdf2$var$_a.struct([
    [
        "instruction",
        "u8"
    ]
]);
class $4a85ac75e311cdf2$var$StartAuction extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { store: store, auction: auction, auctionManager: auctionManager, auctionManagerAuthority: auctionManagerAuthority } = params;
        const data = $4a85ac75e311cdf2$var$StartAuctionArgs.serialize();
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auctionManagerAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $fRiXQ.AuctionProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_CLOCK_PUBKEY,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.StartAuction = $4a85ac75e311cdf2$var$StartAuction;

});

parcelRegister("3XfKB", function(module, exports) {
"use strict";
var $2e131983e22000a0$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedeemParticipationBidV3 = module.exports.RedeemParticipationBidV3Args = void 0;

var $1jULY = parcelRequire("1jULY");

var $cAjX2 = parcelRequire("cAjX2");

var $d1ogx = parcelRequire("d1ogx");

var $febfi = parcelRequire("febfi");

var $1biTx = parcelRequire("1biTx");

var $iqXi3 = parcelRequire("iqXi3");
class $2e131983e22000a0$var$RedeemParticipationBidV3Args extends $1jULY.Borsh.Data {
    constructor(){
        super(...arguments);
        this.instruction = 19;
    }
}
module.exports.RedeemParticipationBidV3Args = $2e131983e22000a0$var$RedeemParticipationBidV3Args;
$2e131983e22000a0$var$_a = $2e131983e22000a0$var$RedeemParticipationBidV3Args;
$2e131983e22000a0$var$RedeemParticipationBidV3Args.SCHEMA = $2e131983e22000a0$var$_a.struct([
    [
        "instruction",
        "u8"
    ],
    [
        "winIndex",
        {
            kind: "option",
            type: "u64"
        }
    ]
]);
class $2e131983e22000a0$var$RedeemParticipationBidV3 extends $1jULY.Transaction {
    constructor(options, params){
        super(options);
        const { feePayer: feePayer } = options;
        const { store: store, vault: vault, auction: auction, auctionExtended: auctionExtended, auctionManager: auctionManager, bidRedemption: bidRedemption, bidMetadata: bidMetadata, safetyDepositTokenStore: safetyDepositTokenStore, destination: destination, safetyDeposit: safetyDeposit, bidder: bidder, safetyDepositConfig: safetyDepositConfig, metadata: metadata, prizeTrackingTicket: prizeTrackingTicket, newMetadata: newMetadata, newEdition: newEdition, masterEdition: masterEdition, newMint: newMint, editionMark: editionMark, winIndex: winIndex, transferAuthority: transferAuthority, acceptPaymentAccount: acceptPaymentAccount, tokenPaymentAccount: tokenPaymentAccount } = params;
        const data = $2e131983e22000a0$var$RedeemParticipationBidV3Args.serialize({
            winIndex: winIndex
        });
        this.add(new $1biTx.TransactionInstruction({
            keys: [
                {
                    pubkey: auctionManager,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDepositTokenStore,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: destination,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: bidRedemption,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: safetyDeposit,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: vault,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: safetyDepositConfig,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: auction,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidMetadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: bidder,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: $febfi.TOKEN_PROGRAM_ID,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d1ogx.VaultProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $cAjX2.MetadataProgram.PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: store,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SystemProgram.programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1biTx.SYSVAR_RENT_PUBKEY,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: transferAuthority,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: acceptPaymentAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: tokenPaymentAccount,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: prizeTrackingTicket,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newMetadata,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newEdition,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: masterEdition,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: newMint,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: editionMark,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: metadata,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: auctionExtended,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: $iqXi3.MetaplexProgram.PUBKEY,
            data: data
        }));
    }
}
module.exports.RedeemParticipationBidV3 = $2e131983e22000a0$var$RedeemParticipationBidV3;

});


var $b8c53ef43392f031$exports = {};
"use strict";

$b8c53ef43392f031$exports = (parcelRequire("iwYKF"));



var $lx97N = parcelRequire("lx97N");
var $e08bedd2d92855da$export$882461b6382ed46c;
var $e08bedd2d92855da$export$757ceba2d55c277e;
"use strict";
var $0d985e384f32d040$exports = {};
"use strict";
function $0d985e384f32d040$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0d985e384f32d040$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0d985e384f32d040$var$checkDCE();

$0d985e384f32d040$exports = (parcelRequire("f2Jil"));


var $e08bedd2d92855da$var$i;
$e08bedd2d92855da$export$882461b6382ed46c = $0d985e384f32d040$exports.createRoot;
$e08bedd2d92855da$export$757ceba2d55c277e = $0d985e384f32d040$exports.hydrateRoot;



var $35afd30d3f8b3243$export$90767a7ae4c388dc;
(function(WalletAdapterNetwork) {
    WalletAdapterNetwork["Mainnet"] = "mainnet-beta";
    WalletAdapterNetwork["Testnet"] = "testnet";
    WalletAdapterNetwork["Devnet"] = "devnet";
})($35afd30d3f8b3243$export$90767a7ae4c388dc || ($35afd30d3f8b3243$export$90767a7ae4c388dc = {}));



var $1biTx = parcelRequire("1biTx");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
const $a3e6306a29927194$export$af54d3055d90c64e = (0, $lx97N.createContext)({});
function $a3e6306a29927194$export$985e8768c0e91dbc() {
    return (0, $lx97N.useContext)($a3e6306a29927194$export$af54d3055d90c64e);
}


const $ab7db6273f05d673$export$fd685cf7c99624bd = ({ children: children, endpoint: endpoint, config: config = {
    commitment: "confirmed"
} })=>{
    const connection = (0, $lx97N.useMemo)(()=>new (0, $1biTx.Connection)(endpoint, config), [
        endpoint,
        config
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $a3e6306a29927194$export$af54d3055d90c64e).Provider, {
        value: {
            connection: connection
        }
    }, children);
};


var $1PbQI = parcelRequire("1PbQI");
class $51fd612dc03e2ca2$export$f46ec6f9dba8711d extends Error {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(message, error){
        super(message);
        this.error = error;
    }
}
class $51fd612dc03e2ca2$export$d65db264eda99cd7 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotReadyError";
    }
}
class $51fd612dc03e2ca2$export$9a551f94af9b0bf8 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletLoadError";
    }
}
class $51fd612dc03e2ca2$export$9525019988612a5e extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConfigError";
    }
}
class $51fd612dc03e2ca2$export$38f21f1c810261c7 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConnectionError";
    }
}
class $51fd612dc03e2ca2$export$bf7028c52ebda81e extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectedError";
    }
}
class $51fd612dc03e2ca2$export$92e2b26fad5723ee extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectionError";
    }
}
class $51fd612dc03e2ca2$export$cd6fa2f8e2a8a612 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletAccountError";
    }
}
class $51fd612dc03e2ca2$export$735bef3bfb0f2c86 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletPublicKeyError";
    }
}
class $51fd612dc03e2ca2$export$c2957028686b1575 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletKeypairError";
    }
}
class $51fd612dc03e2ca2$export$313d299817c74896 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotConnectedError";
    }
}
class $51fd612dc03e2ca2$export$769332ac3f90f46c extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSendTransactionError";
    }
}
class $51fd612dc03e2ca2$export$96f177062fdd8180 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignTransactionError";
    }
}
class $51fd612dc03e2ca2$export$2622c1721bbd4b17 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignMessageError";
    }
}
class $51fd612dc03e2ca2$export$a4c7d3c66e3cdd6c extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignInError";
    }
}
class $51fd612dc03e2ca2$export$ec3efbdc71ef5c8c extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletTimeoutError";
    }
}
class $51fd612dc03e2ca2$export$c87b9320dc154c95 extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowBlockedError";
    }
}
class $51fd612dc03e2ca2$export$d02b2d00a97edcea extends $51fd612dc03e2ca2$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowClosedError";
    }
}


var $bfe62661f5b3c85b$export$2a7b8071105d05b6;
(function(WalletReadyState) {
    /**
     * User-installable wallets can typically be detected by scanning for an API
     * that they've injected into the global context. If such an API is present,
     * we consider the wallet to have been installed.
     */ WalletReadyState["Installed"] = "Installed";
    WalletReadyState["NotDetected"] = "NotDetected";
    /**
     * Loadable wallets are always available to you. Since you can load them at
     * any time, it's meaningless to say that they have been detected.
     */ WalletReadyState["Loadable"] = "Loadable";
    /**
     * If a wallet is not supported on a given platform (eg. server-rendering, or
     * mobile) then it will stay in the `Unsupported` state.
     */ WalletReadyState["Unsupported"] = "Unsupported";
})($bfe62661f5b3c85b$export$2a7b8071105d05b6 || ($bfe62661f5b3c85b$export$2a7b8071105d05b6 = {}));
class $bfe62661f5b3c85b$export$2af1ea2892adc469 extends (0, (/*@__PURE__*/$parcel$interopDefault($1PbQI))) {
    get connected() {
        return !!this.publicKey;
    }
    async autoConnect() {
        await this.connect();
    }
    async prepareTransaction(transaction, connection, options = {}) {
        const publicKey = this.publicKey;
        if (!publicKey) throw new (0, $51fd612dc03e2ca2$export$313d299817c74896)();
        transaction.feePayer = transaction.feePayer || publicKey;
        transaction.recentBlockhash = transaction.recentBlockhash || (await connection.getLatestBlockhash({
            commitment: options.preflightCommitment,
            minContextSlot: options.minContextSlot
        })).blockhash;
        return transaction;
    }
}
function $bfe62661f5b3c85b$export$378bae4c88e0b46e(detect) {
    // Early return when server-side rendering
    if (typeof window === "undefined" || typeof document === "undefined") return;
    const disposers = [];
    function detectAndDispose() {
        const detected = detect();
        if (detected) for (const dispose of disposers)dispose();
    }
    // Strategy #1: Try detecting every second.
    const interval = // TODO: #334 Replace with idle callback strategy.
    setInterval(detectAndDispose, 1000);
    disposers.push(()=>clearInterval(interval));
    // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.
    if (// Implies that `DOMContentLoaded` has not yet fired.
    document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", detectAndDispose, {
            once: true
        });
        disposers.push(()=>document.removeEventListener("DOMContentLoaded", detectAndDispose));
    }
    // Strategy #3: Detect after the `window` has fully loaded.
    if (// If the `complete` state has been reached, we're too late.
    document.readyState !== "complete") {
        window.addEventListener("load", detectAndDispose, {
            once: true
        });
        disposers.push(()=>window.removeEventListener("load", detectAndDispose));
    }
    // Strategy #4: Detect synchronously, now.
    detectAndDispose();
}
function $bfe62661f5b3c85b$export$bf89b558d1e273a2() {
    // SSR: return false
    if (!navigator) return false;
    const userAgent = navigator.userAgent.toLowerCase();
    // if on iOS the user agent will contain either iPhone or iPad
    // caveat: if requesting desktop site then this won't work
    const isIos = userAgent.includes("iphone") || userAgent.includes("ipad");
    // if in a webview then it will not include Safari
    // note that other iOS browsers also include Safari
    // so we will redirect only if Safari is also included
    const isSafari = userAgent.includes("safari");
    return isIos && isSafari;
}



function $22b57afe0b9b3669$export$37ce1cc82e255d8(transaction) {
    return "version" in transaction;
}


class $27607400338ed42b$export$9a51bf5d1bea9e98 extends (0, $bfe62661f5b3c85b$export$2af1ea2892adc469) {
    async sendTransaction(transaction, connection, options = {}) {
        let emit = true;
        try {
            if ((0, $22b57afe0b9b3669$export$37ce1cc82e255d8)(transaction)) {
                if (!this.supportedTransactionVersions) throw new (0, $51fd612dc03e2ca2$export$769332ac3f90f46c)(`Sending versioned transactions isn't supported by this wallet`);
                if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $51fd612dc03e2ca2$export$769332ac3f90f46c)(`Sending transaction version ${transaction.version} isn't supported by this wallet`);
                try {
                    transaction = await this.signTransaction(transaction);
                    const rawTransaction = transaction.serialize();
                    return await connection.sendRawTransaction(rawTransaction, options);
                } catch (error) {
                    // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                    if (error instanceof (0, $51fd612dc03e2ca2$export$96f177062fdd8180)) {
                        emit = false;
                        throw error;
                    }
                    throw new (0, $51fd612dc03e2ca2$export$769332ac3f90f46c)(error?.message, error);
                }
            } else try {
                const { signers: signers, ...sendOptions } = options;
                transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                signers?.length && transaction.partialSign(...signers);
                transaction = await this.signTransaction(transaction);
                const rawTransaction = transaction.serialize();
                return await connection.sendRawTransaction(rawTransaction, sendOptions);
            } catch (error) {
                // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                if (error instanceof (0, $51fd612dc03e2ca2$export$96f177062fdd8180)) {
                    emit = false;
                    throw error;
                }
                throw new (0, $51fd612dc03e2ca2$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            if (emit) this.emit("error", error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        for (const transaction of transactions)if ((0, $22b57afe0b9b3669$export$37ce1cc82e255d8)(transaction)) {
            if (!this.supportedTransactionVersions) throw new (0, $51fd612dc03e2ca2$export$96f177062fdd8180)(`Signing versioned transactions isn't supported by this wallet`);
            if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $51fd612dc03e2ca2$export$96f177062fdd8180)(`Signing transaction version ${transaction.version} isn't supported by this wallet`);
        }
        const signedTransactions = [];
        for (const transaction of transactions)signedTransactions.push(await this.signTransaction(transaction));
        return signedTransactions;
    }
}
class $27607400338ed42b$export$9db08bcddd106c96 extends $27607400338ed42b$export$9a51bf5d1bea9e98 {
}
class $27607400338ed42b$export$9779f871ffdb3d87 extends $27607400338ed42b$export$9db08bcddd106c96 {
}



var $1biTx = parcelRequire("1biTx");

var $1biTx = parcelRequire("1biTx");

var $jNKMc = parcelRequire("jNKMc");
/**
 * @internal
 *
 * Efficiently compare {@link Indexed} arrays (e.g. `Array` and `Uint8Array`).
 *
 * @param a An array.
 * @param b Another array.
 *
 * @return `true` if the arrays have the same length and elements, `false` otherwise.
 *
 * @group Internal
 */ function $acc163ec7d67961b$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $acc163ec7d67961b$export$c663ab80cce302c5(a, b) {
    return $acc163ec7d67961b$export$234180f8206db11b(a, b);
}


function $d18c6b8681655abd$export$54b8e79a8f938f52({ message: message, signedMessage: signedMessage, signature: signature, publicKey: publicKey }) {
    // TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
    return (0, $acc163ec7d67961b$export$c663ab80cce302c5)(message, signedMessage) && (0, $jNKMc.ed25519).verify(signature, signedMessage, publicKey);
}
function $d18c6b8681655abd$export$a7a8e868ceb02186(input, output) {
    const { message: message, account: { publicKey: publicKey } } = input;
    const { signedMessage: signedMessage, signature: signature } = output;
    return $d18c6b8681655abd$export$54b8e79a8f938f52({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}



function $96cfe59d1dec2f20$export$9828dc452d20db63(input, output) {
    const { signedMessage: signedMessage, signature: signature, account: { publicKey: publicKey } } = output;
    const message = $96cfe59d1dec2f20$export$5a98156f426eafe8(input, output);
    return !!message && (0, $d18c6b8681655abd$export$54b8e79a8f938f52)({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}
function $96cfe59d1dec2f20$export$5a98156f426eafe8(input, output) {
    const text = $96cfe59d1dec2f20$export$14d5fbb279d179c2(input, output);
    if (!text) return null;
    return new TextEncoder().encode(text);
}
function $96cfe59d1dec2f20$export$14d5fbb279d179c2(input, output) {
    const parsed = $96cfe59d1dec2f20$export$ddde1a7f6f94bd0a(output.signedMessage);
    if (!parsed) return null;
    if (input.domain && input.domain !== parsed.domain) return null;
    if (input.address && input.address !== parsed.address) return null;
    if (input.statement !== parsed.statement) return null;
    if (input.uri !== parsed.uri) return null;
    if (input.version !== parsed.version) return null;
    if (input.chainId !== parsed.chainId) return null;
    if (input.nonce !== parsed.nonce) return null;
    if (input.issuedAt !== parsed.issuedAt) return null;
    if (input.expirationTime !== parsed.expirationTime) return null;
    if (input.notBefore !== parsed.notBefore) return null;
    if (input.requestId !== parsed.requestId) return null;
    if (input.resources) {
        if (!parsed.resources) return null;
        if (!(0, $acc163ec7d67961b$export$234180f8206db11b)(input.resources, parsed.resources)) return null;
    } else if (parsed.resources) return null;
    return $96cfe59d1dec2f20$export$88aceda9565b68d2(parsed);
}
function $96cfe59d1dec2f20$export$ddde1a7f6f94bd0a(message) {
    const text = new TextDecoder().decode(message);
    return $96cfe59d1dec2f20$export$4a112f3ad8ba8e50(text);
}
// TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
const $96cfe59d1dec2f20$var$DOMAIN = "(?<domain>[^\\n]+?) wants you to sign in with your Solana account:\\n";
const $96cfe59d1dec2f20$var$ADDRESS = "(?<address>[^\\n]+)(?:\\n|$)";
const $96cfe59d1dec2f20$var$STATEMENT = "(?:\\n(?<statement>[\\S\\s]*?)(?:\\n|$))??";
const $96cfe59d1dec2f20$var$URI = "(?:\\nURI: (?<uri>[^\\n]+))?";
const $96cfe59d1dec2f20$var$VERSION = "(?:\\nVersion: (?<version>[^\\n]+))?";
const $96cfe59d1dec2f20$var$CHAIN_ID = "(?:\\nChain ID: (?<chainId>[^\\n]+))?";
const $96cfe59d1dec2f20$var$NONCE = "(?:\\nNonce: (?<nonce>[^\\n]+))?";
const $96cfe59d1dec2f20$var$ISSUED_AT = "(?:\\nIssued At: (?<issuedAt>[^\\n]+))?";
const $96cfe59d1dec2f20$var$EXPIRATION_TIME = "(?:\\nExpiration Time: (?<expirationTime>[^\\n]+))?";
const $96cfe59d1dec2f20$var$NOT_BEFORE = "(?:\\nNot Before: (?<notBefore>[^\\n]+))?";
const $96cfe59d1dec2f20$var$REQUEST_ID = "(?:\\nRequest ID: (?<requestId>[^\\n]+))?";
const $96cfe59d1dec2f20$var$RESOURCES = "(?:\\nResources:(?<resources>(?:\\n- [^\\n]+)*))?";
const $96cfe59d1dec2f20$var$FIELDS = `${$96cfe59d1dec2f20$var$URI}${$96cfe59d1dec2f20$var$VERSION}${$96cfe59d1dec2f20$var$CHAIN_ID}${$96cfe59d1dec2f20$var$NONCE}${$96cfe59d1dec2f20$var$ISSUED_AT}${$96cfe59d1dec2f20$var$EXPIRATION_TIME}${$96cfe59d1dec2f20$var$NOT_BEFORE}${$96cfe59d1dec2f20$var$REQUEST_ID}${$96cfe59d1dec2f20$var$RESOURCES}`;
const $96cfe59d1dec2f20$var$MESSAGE = new RegExp(`^${$96cfe59d1dec2f20$var$DOMAIN}${$96cfe59d1dec2f20$var$ADDRESS}${$96cfe59d1dec2f20$var$STATEMENT}${$96cfe59d1dec2f20$var$FIELDS}\\n*$`);
function $96cfe59d1dec2f20$export$4a112f3ad8ba8e50(text) {
    const match = $96cfe59d1dec2f20$var$MESSAGE.exec(text);
    if (!match) return null;
    const groups = match.groups;
    if (!groups) return null;
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        domain: groups.domain,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        address: groups.address,
        statement: groups.statement,
        uri: groups.uri,
        version: groups.version,
        nonce: groups.nonce,
        chainId: groups.chainId,
        issuedAt: groups.issuedAt,
        expirationTime: groups.expirationTime,
        notBefore: groups.notBefore,
        requestId: groups.requestId,
        resources: groups.resources?.split("\n- ").slice(1)
    };
}
function $96cfe59d1dec2f20$export$92ddcd466ce9e7c4(input) {
    const text = $96cfe59d1dec2f20$export$88aceda9565b68d2(input);
    return new TextEncoder().encode(text);
}
function $96cfe59d1dec2f20$export$88aceda9565b68d2(input) {
    // ${domain} wants you to sign in with your Solana account:
    // ${address}
    //
    // ${statement}
    //
    // URI: ${uri}
    // Version: ${version}
    // Chain ID: ${chain}
    // Nonce: ${nonce}
    // Issued At: ${issued-at}
    // Expiration Time: ${expiration-time}
    // Not Before: ${not-before}
    // Request ID: ${request-id}
    // Resources:
    // - ${resources[0]}
    // - ${resources[1]}
    // ...
    // - ${resources[n]}
    let message = `${input.domain} wants you to sign in with your Solana account:\n`;
    message += `${input.address}`;
    if (input.statement) message += `\n\n${input.statement}`;
    const fields = [];
    if (input.uri) fields.push(`URI: ${input.uri}`);
    if (input.version) fields.push(`Version: ${input.version}`);
    if (input.chainId) fields.push(`Chain ID: ${input.chainId}`);
    if (input.nonce) fields.push(`Nonce: ${input.nonce}`);
    if (input.issuedAt) fields.push(`Issued At: ${input.issuedAt}`);
    if (input.expirationTime) fields.push(`Expiration Time: ${input.expirationTime}`);
    if (input.notBefore) fields.push(`Not Before: ${input.notBefore}`);
    if (input.requestId) fields.push(`Request ID: ${input.requestId}`);
    if (input.resources) {
        fields.push(`Resources:`);
        for (const resource of input.resources)fields.push(`- ${resource}`);
    }
    if (fields.length) message += `\n\n${fields.join("\n")}`;
    return message;
}


// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $fd413eaf80db5857$export$93083e877aec7a8a = {
    ERROR_ASSOCIATION_PORT_OUT_OF_RANGE: "ERROR_ASSOCIATION_PORT_OUT_OF_RANGE",
    ERROR_FORBIDDEN_WALLET_BASE_URL: "ERROR_FORBIDDEN_WALLET_BASE_URL",
    ERROR_SECURE_CONTEXT_REQUIRED: "ERROR_SECURE_CONTEXT_REQUIRED",
    ERROR_SESSION_CLOSED: "ERROR_SESSION_CLOSED",
    ERROR_SESSION_TIMEOUT: "ERROR_SESSION_TIMEOUT",
    ERROR_WALLET_NOT_FOUND: "ERROR_WALLET_NOT_FOUND",
    ERROR_INVALID_PROTOCOL_VERSION: "ERROR_INVALID_PROTOCOL_VERSION"
};
class $fd413eaf80db5857$export$d77545679c409b63 extends Error {
    constructor(...args){
        const [code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.name = "SolanaMobileWalletAdapterError";
    }
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $fd413eaf80db5857$export$23d27841621bc1e8 = {
    // Keep these in sync with `mobilewalletadapter/common/ProtocolContract.java`.
    ERROR_AUTHORIZATION_FAILED: -1,
    ERROR_INVALID_PAYLOADS: -2,
    ERROR_NOT_SIGNED: -3,
    ERROR_NOT_SUBMITTED: -4,
    ERROR_TOO_MANY_PAYLOADS: -5,
    ERROR_ATTEST_ORIGIN_ANDROID: -100
};
class $fd413eaf80db5857$export$58b788f937123c66 extends Error {
    constructor(...args){
        const [jsonRpcMessageId, code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.jsonRpcMessageId = jsonRpcMessageId;
        this.name = "SolanaMobileWalletAdapterProtocolError";
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $fd413eaf80db5857$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fd413eaf80db5857$var$createHelloReq(ecdhPublicKey, associationKeypairPrivateKey) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const publicKeyBuffer = yield crypto.subtle.exportKey("raw", ecdhPublicKey);
        const signatureBuffer = yield crypto.subtle.sign({
            hash: "SHA-256",
            name: "ECDSA"
        }, associationKeypairPrivateKey, publicKeyBuffer);
        const response = new Uint8Array(publicKeyBuffer.byteLength + signatureBuffer.byteLength);
        response.set(new Uint8Array(publicKeyBuffer), 0);
        response.set(new Uint8Array(signatureBuffer), publicKeyBuffer.byteLength);
        return response;
    });
}
function $fd413eaf80db5857$var$encode(input) {
    return window.btoa(input);
}
function $fd413eaf80db5857$var$createSIWSMessage(payload) {
    return (0, $96cfe59d1dec2f20$export$88aceda9565b68d2)(payload);
}
function $fd413eaf80db5857$var$createSIWSMessageBase64(payload) {
    return $fd413eaf80db5857$var$encode($fd413eaf80db5857$var$createSIWSMessage(payload));
}
// optional features
const $fd413eaf80db5857$export$6d2aa8b15676f603 = "solana:signTransactions";
const $fd413eaf80db5857$export$7b8713ece485d770 = "solana:cloneAuthorization";
const $fd413eaf80db5857$export$fca2a421c519d7f8 = "solana:signInWithSolana";
/**
 * Creates a {@link MobileWallet} proxy that handles backwards compatibility and API to RPC conversion.
 *
 * @param protocolVersion the protocol version in use for this session/request
 * @param protocolRequestHandler callback function that handles sending the RPC request to the wallet endpoint.
 * @returns a {@link MobileWallet} proxy
 */ function $fd413eaf80db5857$var$createMobileWalletProxy(protocolVersion, protocolRequestHandler) {
    return new Proxy({}, {
        get (target, p) {
            if (target[p] == null) target[p] = function(inputParams) {
                return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
                    const { method: method, params: params } = $fd413eaf80db5857$var$handleMobileWalletRequest(p, inputParams, protocolVersion);
                    const result = yield protocolRequestHandler(method, params);
                    // if the request tried to sign in but the wallet did not return a sign in result, fallback on message signing
                    if (method === "authorize" && params.sign_in_payload && !result.sign_in_result) result["sign_in_result"] = yield $fd413eaf80db5857$var$signInFallback(params.sign_in_payload, result, protocolRequestHandler);
                    return $fd413eaf80db5857$var$handleMobileWalletResponse(p, result, protocolVersion);
                });
            };
            return target[p];
        },
        defineProperty () {
            return false;
        },
        deleteProperty () {
            return false;
        }
    });
}
/**
 * Handles all {@link MobileWallet} API requests and determines the correct MWA RPC method and params to call.
 * This handles backwards compatibility, based on the provided @protocolVersion.
 *
 * @param methodName the name of {@link MobileWallet} method that was called
 * @param methodParams the parameters that were passed to the method
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the RPC request method and params that should be sent to the wallet endpoint
 */ function $fd413eaf80db5857$var$handleMobileWalletRequest(methodName, methodParams, protocolVersion) {
    let params = methodParams;
    let method = methodName.toString().replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`).toLowerCase();
    switch(methodName){
        case "authorize":
            {
                let { chain: chain } = params;
                if (protocolVersion === "legacy") {
                    switch(chain){
                        case "solana:testnet":
                            chain = "testnet";
                            break;
                        case "solana:devnet":
                            chain = "devnet";
                            break;
                        case "solana:mainnet":
                            chain = "mainnet-beta";
                            break;
                        default:
                            chain = params.cluster;
                    }
                    params.cluster = chain;
                } else {
                    switch(chain){
                        case "testnet":
                        case "devnet":
                            chain = `solana:${chain}`;
                            break;
                        case "mainnet-beta":
                            chain = "solana:mainnet";
                            break;
                    }
                    params.chain = chain;
                }
            }
        case "reauthorize":
            {
                const { auth_token: auth_token, identity: identity } = params;
                if (auth_token) switch(protocolVersion){
                    case "legacy":
                        method = "reauthorize";
                        params = {
                            auth_token: auth_token,
                            identity: identity
                        };
                        break;
                    default:
                        method = "authorize";
                        break;
                }
                break;
            }
    }
    return {
        method: method,
        params: params
    };
}
/**
 * Handles all {@link MobileWallet} API responses and modifies the response for backwards compatibility, if needed
 *
 * @param method the {@link MobileWallet} method that was called
 * @param response the original response that was returned by the method call
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the possibly modified response
 */ function $fd413eaf80db5857$var$handleMobileWalletResponse(method, response, protocolVersion) {
    switch(method){
        case "getCapabilities":
            {
                const capabilities = response;
                switch(protocolVersion){
                    case "legacy":
                        {
                            const features = [
                                $fd413eaf80db5857$export$6d2aa8b15676f603
                            ];
                            if (capabilities.supports_clone_authorization === true) features.push($fd413eaf80db5857$export$7b8713ece485d770);
                            return Object.assign(Object.assign({}, capabilities), {
                                features: features
                            });
                        }
                    case "v1":
                        return Object.assign(Object.assign({}, capabilities), {
                            supports_sign_and_send_transactions: true,
                            supports_clone_authorization: capabilities.features.includes($fd413eaf80db5857$export$7b8713ece485d770)
                        });
                }
            }
    }
    return response;
}
function $fd413eaf80db5857$var$signInFallback(signInPayload, authorizationResult, protocolRequestHandler) {
    var _a;
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const domain = (_a = signInPayload.domain) !== null && _a !== void 0 ? _a : window.location.host;
        const address = authorizationResult.accounts[0].address;
        const siwsMessage = $fd413eaf80db5857$var$createSIWSMessageBase64(Object.assign(Object.assign({}, signInPayload), {
            domain: domain,
            address: address
        }));
        const signMessageResult = yield protocolRequestHandler("sign_messages", {
            addresses: [
                address
            ],
            payloads: [
                siwsMessage
            ]
        });
        const signInResult = {
            address: address,
            signed_message: siwsMessage,
            signature: signMessageResult.signed_payloads[0].slice(siwsMessage.length)
        };
        return signInResult;
    });
}
const $fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES = 4;
function $fd413eaf80db5857$var$createSequenceNumberVector(sequenceNumber) {
    if (sequenceNumber >= 4294967296) throw new Error("Outbound sequence number overflow. The maximum sequence number is 32-bytes.");
    const byteArray = new ArrayBuffer($fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES);
    const view = new DataView(byteArray);
    view.setUint32(0, sequenceNumber, /* littleEndian */ false);
    return new Uint8Array(byteArray);
}
const $fd413eaf80db5857$var$INITIALIZATION_VECTOR_BYTES = 12;
const $fd413eaf80db5857$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES = 65;
function $fd413eaf80db5857$var$encryptMessage(plaintext, sequenceNumber, sharedSecret) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const sequenceNumberVector = $fd413eaf80db5857$var$createSequenceNumberVector(sequenceNumber);
        const initializationVector = new Uint8Array($fd413eaf80db5857$var$INITIALIZATION_VECTOR_BYTES);
        crypto.getRandomValues(initializationVector);
        const ciphertext = yield crypto.subtle.encrypt($fd413eaf80db5857$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, new TextEncoder().encode(plaintext));
        const response = new Uint8Array(sequenceNumberVector.byteLength + initializationVector.byteLength + ciphertext.byteLength);
        response.set(new Uint8Array(sequenceNumberVector), 0);
        response.set(new Uint8Array(initializationVector), sequenceNumberVector.byteLength);
        response.set(new Uint8Array(ciphertext), sequenceNumberVector.byteLength + initializationVector.byteLength);
        return response;
    });
}
function $fd413eaf80db5857$var$decryptMessage(message, sharedSecret) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const sequenceNumberVector = message.slice(0, $fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES);
        const initializationVector = message.slice($fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES, $fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES + $fd413eaf80db5857$var$INITIALIZATION_VECTOR_BYTES);
        const ciphertext = message.slice($fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES + $fd413eaf80db5857$var$INITIALIZATION_VECTOR_BYTES);
        const plaintextBuffer = yield crypto.subtle.decrypt($fd413eaf80db5857$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, ciphertext);
        const plaintext = $fd413eaf80db5857$var$getUtf8Decoder().decode(plaintextBuffer);
        return plaintext;
    });
}
function $fd413eaf80db5857$var$getAlgorithmParams(sequenceNumber, initializationVector) {
    return {
        additionalData: sequenceNumber,
        iv: initializationVector,
        name: "AES-GCM",
        tagLength: 128
    };
}
let $fd413eaf80db5857$var$_utf8Decoder;
function $fd413eaf80db5857$var$getUtf8Decoder() {
    if ($fd413eaf80db5857$var$_utf8Decoder === undefined) $fd413eaf80db5857$var$_utf8Decoder = new TextDecoder("utf-8");
    return $fd413eaf80db5857$var$_utf8Decoder;
}
function $fd413eaf80db5857$var$generateAssociationKeypair() {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign"
        ]);
    });
}
function $fd413eaf80db5857$var$generateECDHKeypair() {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDH",
            namedCurve: "P-256"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
    });
}
function $fd413eaf80db5857$var$encryptJsonRpcMessage(jsonRpcMessage, sharedSecret) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = JSON.stringify(jsonRpcMessage);
        const sequenceNumber = jsonRpcMessage.id;
        return $fd413eaf80db5857$var$encryptMessage(plaintext, sequenceNumber, sharedSecret);
    });
}
function $fd413eaf80db5857$var$decryptJsonRpcMessage(message, sharedSecret) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = yield $fd413eaf80db5857$var$decryptMessage(message, sharedSecret);
        const jsonRpcMessage = JSON.parse(plaintext);
        if (Object.hasOwnProperty.call(jsonRpcMessage, "error")) throw new $fd413eaf80db5857$export$58b788f937123c66(jsonRpcMessage.id, jsonRpcMessage.error.code, jsonRpcMessage.error.message);
        return jsonRpcMessage;
    });
}
function $fd413eaf80db5857$var$parseHelloRsp(payloadBuffer, associationPublicKey, ecdhPrivateKey) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const [associationPublicKeyBuffer, walletPublicKey] = yield Promise.all([
            crypto.subtle.exportKey("raw", associationPublicKey),
            crypto.subtle.importKey("raw", payloadBuffer.slice(0, $fd413eaf80db5857$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES), {
                name: "ECDH",
                namedCurve: "P-256"
            }, false, [])
        ]);
        const sharedSecret = yield crypto.subtle.deriveBits({
            name: "ECDH",
            public: walletPublicKey
        }, ecdhPrivateKey, 256);
        const ecdhSecretKey = yield crypto.subtle.importKey("raw", sharedSecret, "HKDF", false, [
            "deriveKey"
        ]);
        const aesKeyMaterialVal = yield crypto.subtle.deriveKey({
            name: "HKDF",
            hash: "SHA-256",
            salt: new Uint8Array(associationPublicKeyBuffer),
            info: new Uint8Array()
        }, ecdhSecretKey, {
            name: "AES-GCM",
            length: 128
        }, false, [
            "encrypt",
            "decrypt"
        ]);
        return aesKeyMaterialVal;
    });
}
function $fd413eaf80db5857$var$parseSessionProps(message, sharedSecret) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = yield $fd413eaf80db5857$var$decryptMessage(message, sharedSecret);
        const jsonProperties = JSON.parse(plaintext);
        let protocolVersion = "legacy";
        if (Object.hasOwnProperty.call(jsonProperties, "v")) switch(jsonProperties.v){
            case 1:
            case "1":
            case "v1":
                protocolVersion = "v1";
                break;
            case "legacy":
                protocolVersion = "legacy";
                break;
            default:
                throw new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_INVALID_PROTOCOL_VERSION, `Unknown/unsupported protocol version: ${jsonProperties.v}`);
        }
        return {
            protocol_version: protocolVersion
        };
    });
}
function $fd413eaf80db5857$var$getRandomAssociationPort() {
    return $fd413eaf80db5857$var$assertAssociationPort(49152 + Math.floor(Math.random() * 16384));
}
function $fd413eaf80db5857$var$assertAssociationPort(port) {
    if (port < 49152 || port > 65535) throw new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_ASSOCIATION_PORT_OUT_OF_RANGE, `Association port number must be between 49152 and 65535. ${port} given.`, {
        port: port
    });
    return port;
}
// https://stackoverflow.com/a/9458996/802047
function $fd413eaf80db5857$var$arrayBufferToBase64String(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for(let ii = 0; ii < len; ii++)binary += String.fromCharCode(bytes[ii]);
    return window.btoa(binary);
}
function $fd413eaf80db5857$var$getStringWithURLUnsafeCharactersReplaced(unsafeBase64EncodedString) {
    return unsafeBase64EncodedString.replace(/[/+=]/g, (m)=>({
            "/": "_",
            "+": "-",
            "=": "."
        })[m]);
}
const $fd413eaf80db5857$var$INTENT_NAME = "solana-wallet";
function $fd413eaf80db5857$var$getPathParts(pathString) {
    return pathString// Strip leading and trailing slashes
    .replace(/(^\/+|\/+$)/g, "")// Return an array of directories
    .split("/");
}
function $fd413eaf80db5857$var$getIntentURL(methodPathname, intentUrlBase) {
    let baseUrl = null;
    if (intentUrlBase) {
        try {
            baseUrl = new URL(intentUrlBase);
        } catch (_a) {} // eslint-disable-line no-empty
        if ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.protocol) !== "https:") throw new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
    }
    baseUrl || (baseUrl = new URL(`${$fd413eaf80db5857$var$INTENT_NAME}:/`));
    const pathname = methodPathname.startsWith("/") ? methodPathname : [
        ...$fd413eaf80db5857$var$getPathParts(baseUrl.pathname),
        ...$fd413eaf80db5857$var$getPathParts(methodPathname)
    ].join("/");
    return new URL(pathname, baseUrl);
}
function $fd413eaf80db5857$var$getAssociateAndroidIntentURL(associationPublicKey, putativePort, associationURLBase, protocolVersions = [
    "v1"
]) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const associationPort = $fd413eaf80db5857$var$assertAssociationPort(putativePort);
        const exportedKey = yield crypto.subtle.exportKey("raw", associationPublicKey);
        const encodedKey = $fd413eaf80db5857$var$arrayBufferToBase64String(exportedKey);
        const url = $fd413eaf80db5857$var$getIntentURL("v1/associate/local", associationURLBase);
        url.searchParams.set("association", $fd413eaf80db5857$var$getStringWithURLUnsafeCharactersReplaced(encodedKey));
        url.searchParams.set("port", `${associationPort}`);
        protocolVersions.forEach((version)=>{
            url.searchParams.set("v", version);
        });
        return url;
    });
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $fd413eaf80db5857$var$Browser = {
    Firefox: 0,
    Other: 1
};
function $fd413eaf80db5857$var$assertUnreachable(x) {
    return x;
}
function $fd413eaf80db5857$var$getBrowser() {
    return navigator.userAgent.indexOf("Firefox/") !== -1 ? $fd413eaf80db5857$var$Browser.Firefox : $fd413eaf80db5857$var$Browser.Other;
}
function $fd413eaf80db5857$var$getDetectionPromise() {
    // Chrome and others silently fail if a custom protocol is not supported.
    // For these, we wait to see if the browser is navigated away from in
    // a reasonable amount of time (ie. the native wallet opened).
    return new Promise((resolve, reject)=>{
        function cleanup() {
            clearTimeout(timeoutId);
            window.removeEventListener("blur", handleBlur);
        }
        function handleBlur() {
            cleanup();
            resolve();
        }
        window.addEventListener("blur", handleBlur);
        const timeoutId = setTimeout(()=>{
            cleanup();
            reject();
        }, 2000);
    });
}
let $fd413eaf80db5857$var$_frame = null;
function $fd413eaf80db5857$var$launchUrlThroughHiddenFrame(url) {
    if ($fd413eaf80db5857$var$_frame == null) {
        $fd413eaf80db5857$var$_frame = document.createElement("iframe");
        $fd413eaf80db5857$var$_frame.style.display = "none";
        document.body.appendChild($fd413eaf80db5857$var$_frame);
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $fd413eaf80db5857$var$_frame.contentWindow.location.href = url.toString();
}
function $fd413eaf80db5857$var$startSession(associationPublicKey, associationURLBase) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        const randomAssociationPort = $fd413eaf80db5857$var$getRandomAssociationPort();
        const associationUrl = yield $fd413eaf80db5857$var$getAssociateAndroidIntentURL(associationPublicKey, randomAssociationPort, associationURLBase);
        if (associationUrl.protocol === "https:") // The association URL is an Android 'App Link' or iOS 'Universal Link'.
        // These are regular web URLs that are designed to launch an app if it
        // is installed or load the actual target webpage if not.
        window.location.assign(associationUrl);
        else // The association URL has a custom protocol (eg. `solana-wallet:`)
        try {
            const browser = $fd413eaf80db5857$var$getBrowser();
            switch(browser){
                case $fd413eaf80db5857$var$Browser.Firefox:
                    // If a custom protocol is not supported in Firefox, it throws.
                    $fd413eaf80db5857$var$launchUrlThroughHiddenFrame(associationUrl);
                    break;
                case $fd413eaf80db5857$var$Browser.Other:
                    {
                        const detectionPromise = $fd413eaf80db5857$var$getDetectionPromise();
                        window.location.assign(associationUrl);
                        yield detectionPromise;
                        break;
                    }
                default:
                    $fd413eaf80db5857$var$assertUnreachable(browser);
            }
        } catch (e) {
            throw new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_WALLET_NOT_FOUND, "Found no installed wallet that supports the mobile wallet protocol.");
        }
        return randomAssociationPort;
    });
}
const $fd413eaf80db5857$var$WEBSOCKET_CONNECTION_CONFIG = {
    /**
     * 300 milliseconds is a generally accepted threshold for what someone
     * would consider an acceptable response time for a user interface
     * after having performed a low-attention tapping task. We set the initial
     * interval at which we wait for the wallet to set up the websocket at
     * half this, as per the Nyquist frequency, with a progressive backoff
     * sequence from there. The total wait time is 30s, which allows for the
     * user to be presented with a disambiguation dialog, select a wallet, and
     * for the wallet app to subsequently start.
     */ retryDelayScheduleMs: [
        150,
        150,
        200,
        500,
        500,
        750,
        750,
        1000
    ],
    timeoutMs: 30000
};
const $fd413eaf80db5857$var$WEBSOCKET_PROTOCOL = "com.solana.mobilewalletadapter.v1";
function $fd413eaf80db5857$var$assertSecureContext() {
    if (typeof window === "undefined" || window.isSecureContext !== true) throw new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_SECURE_CONTEXT_REQUIRED, "The mobile wallet adapter protocol must be used in a secure context (`https`).");
}
function $fd413eaf80db5857$var$assertSecureEndpointSpecificURI(walletUriBase) {
    let url;
    try {
        url = new URL(walletUriBase);
    } catch (_a) {
        throw new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Invalid base URL supplied by wallet");
    }
    if (url.protocol !== "https:") throw new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
}
function $fd413eaf80db5857$var$getSequenceNumberFromByteArray(byteArray) {
    const view = new DataView(byteArray);
    return view.getUint32(0, /* littleEndian */ false);
}
function $fd413eaf80db5857$export$dac1bad6146b2469(callback, config) {
    return $fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
        $fd413eaf80db5857$var$assertSecureContext();
        const associationKeypair = yield $fd413eaf80db5857$var$generateAssociationKeypair();
        const sessionPort = yield $fd413eaf80db5857$var$startSession(associationKeypair.publicKey, config === null || config === void 0 ? void 0 : config.baseUri);
        const websocketURL = `ws://localhost:${sessionPort}/solana-wallet`;
        let connectionStartTime;
        const getNextRetryDelayMs = (()=>{
            const schedule = [
                ...$fd413eaf80db5857$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
            ];
            return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
        })();
        let nextJsonRpcMessageId = 1;
        let lastKnownInboundSequenceNumber = 0;
        let state = {
            __type: "disconnected"
        };
        return new Promise((resolve, reject)=>{
            let socket;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const jsonRpcResponsePromises = {};
            const handleOpen = ()=>$fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
                    if (state.__type !== "connecting") {
                        console.warn("Expected adapter state to be `connecting` at the moment the websocket opens. " + `Got \`${state.__type}\`.`);
                        return;
                    }
                    const { associationKeypair: associationKeypair } = state;
                    socket.removeEventListener("open", handleOpen);
                    const ecdhKeypair = yield $fd413eaf80db5857$var$generateECDHKeypair();
                    socket.send((yield $fd413eaf80db5857$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)));
                    state = {
                        __type: "hello_req_sent",
                        associationPublicKey: associationKeypair.publicKey,
                        ecdhPrivateKey: ecdhKeypair.privateKey
                    };
                });
            const handleClose = (evt)=>{
                if (evt.wasClean) state = {
                    __type: "disconnected"
                };
                else reject(new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                    closeEvent: evt
                }));
                disposeSocket();
            };
            const handleError = (_evt)=>$fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
                    disposeSocket();
                    if (Date.now() - connectionStartTime >= $fd413eaf80db5857$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $fd413eaf80db5857$export$d77545679c409b63($fd413eaf80db5857$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the wallet websocket on port ${sessionPort}.`));
                    else {
                        yield new Promise((resolve)=>{
                            const retryDelayMs = getNextRetryDelayMs();
                            retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                        });
                        attemptSocketConnection();
                    }
                });
            const handleMessage = (evt)=>$fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
                    const responseBuffer = yield evt.data.arrayBuffer();
                    switch(state.__type){
                        case "connected":
                            try {
                                const sequenceNumberVector = responseBuffer.slice(0, $fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES);
                                const sequenceNumber = $fd413eaf80db5857$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                lastKnownInboundSequenceNumber = sequenceNumber;
                                const jsonRpcMessage = yield $fd413eaf80db5857$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                                const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                                delete jsonRpcResponsePromises[jsonRpcMessage.id];
                                responsePromise.resolve(jsonRpcMessage.result);
                            } catch (e) {
                                if (e instanceof $fd413eaf80db5857$export$58b788f937123c66) {
                                    const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    responsePromise.reject(e);
                                } else throw e;
                            }
                            break;
                        case "hello_req_sent":
                            {
                                const sharedSecret = yield $fd413eaf80db5857$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                                const sessionPropertiesBuffer = responseBuffer.slice($fd413eaf80db5857$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES);
                                const sessionProperties = sessionPropertiesBuffer.byteLength !== 0 ? yield (()=>$fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
                                        const sequenceNumberVector = sessionPropertiesBuffer.slice(0, $fd413eaf80db5857$var$SEQUENCE_NUMBER_BYTES);
                                        const sequenceNumber = $fd413eaf80db5857$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                        if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                        lastKnownInboundSequenceNumber = sequenceNumber;
                                        return $fd413eaf80db5857$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret);
                                    }))() : {
                                    protocol_version: "legacy"
                                };
                                state = {
                                    __type: "connected",
                                    sharedSecret: sharedSecret,
                                    sessionProperties: sessionProperties
                                };
                                const wallet = $fd413eaf80db5857$var$createMobileWalletProxy(sessionProperties.protocol_version, (method, params)=>$fd413eaf80db5857$var$__awaiter(this, void 0, void 0, function*() {
                                        const id = nextJsonRpcMessageId++;
                                        socket.send((yield $fd413eaf80db5857$var$encryptJsonRpcMessage({
                                            id: id,
                                            jsonrpc: "2.0",
                                            method: method,
                                            params: params !== null && params !== void 0 ? params : {}
                                        }, sharedSecret)));
                                        return new Promise((resolve, reject)=>{
                                            jsonRpcResponsePromises[id] = {
                                                resolve (result) {
                                                    switch(method){
                                                        case "authorize":
                                                        case "reauthorize":
                                                            {
                                                                const { wallet_uri_base: wallet_uri_base } = result;
                                                                if (wallet_uri_base != null) try {
                                                                    $fd413eaf80db5857$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                                } catch (e) {
                                                                    reject(e);
                                                                    return;
                                                                }
                                                                break;
                                                            }
                                                    }
                                                    resolve(result);
                                                },
                                                reject: reject
                                            };
                                        });
                                    }));
                                try {
                                    resolve((yield callback(wallet)));
                                } catch (e) {
                                    reject(e);
                                } finally{
                                    disposeSocket();
                                    socket.close();
                                }
                                break;
                            }
                    }
                });
            let disposeSocket;
            let retryWaitTimeoutId;
            const attemptSocketConnection = ()=>{
                if (disposeSocket) disposeSocket();
                state = {
                    __type: "connecting",
                    associationKeypair: associationKeypair
                };
                if (connectionStartTime === undefined) connectionStartTime = Date.now();
                socket = new WebSocket(websocketURL, [
                    $fd413eaf80db5857$var$WEBSOCKET_PROTOCOL
                ]);
                socket.addEventListener("open", handleOpen);
                socket.addEventListener("close", handleClose);
                socket.addEventListener("error", handleError);
                socket.addEventListener("message", handleMessage);
                disposeSocket = ()=>{
                    window.clearTimeout(retryWaitTimeoutId);
                    socket.removeEventListener("open", handleOpen);
                    socket.removeEventListener("close", handleClose);
                    socket.removeEventListener("error", handleError);
                    socket.removeEventListener("message", handleMessage);
                };
            };
            attemptSocketConnection();
        });
    });
}


var $1b5c2d76db9e67a0$exports = {};
var $4f2eb40e36d4dc16$exports = {};
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $4f2eb40e36d4dc16$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$4f2eb40e36d4dc16$exports = $4f2eb40e36d4dc16$var$base;


const $1b5c2d76db9e67a0$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$1b5c2d76db9e67a0$exports = $4f2eb40e36d4dc16$exports($1b5c2d76db9e67a0$var$ALPHABET);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $bfcb0c59dacecb40$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bfcb0c59dacecb40$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bfcb0c59dacecb40$var$fromUint8Array(byteArray) {
    return window.btoa(String.fromCharCode.call(null, ...byteArray));
}
function $bfcb0c59dacecb40$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $bfcb0c59dacecb40$var$getPayloadFromTransaction(transaction) {
    const serializedTransaction = "version" in transaction ? transaction.serialize() : transaction.serialize({
        requireAllSignatures: false,
        verifySignatures: false
    });
    const payload = $bfcb0c59dacecb40$var$fromUint8Array(serializedTransaction);
    return payload;
}
function $bfcb0c59dacecb40$var$getTransactionFromWireMessage(byteArray) {
    const numSignatures = byteArray[0];
    const messageOffset = numSignatures * (0, $1biTx.SIGNATURE_LENGTH_IN_BYTES) + 1;
    const version = (0, $1biTx.VersionedMessage).deserializeMessageVersion(byteArray.slice(messageOffset, byteArray.length));
    if (version === "legacy") return (0, $1biTx.Transaction).from(byteArray);
    else return (0, $1biTx.VersionedTransaction).deserialize(byteArray);
}
function $bfcb0c59dacecb40$export$dac1bad6146b2469(callback, config) {
    return $bfcb0c59dacecb40$var$__awaiter(this, void 0, void 0, function*() {
        const augmentedCallback = (wallet)=>{
            const augmentedAPI = new Proxy({}, {
                get (target, p) {
                    if (target[p] == null) switch(p){
                        case "signAndSendTransactions":
                            target[p] = function(_a) {
                                var { minContextSlot: minContextSlot, commitment: commitment, skipPreflight: skipPreflight, maxRetries: maxRetries, waitForCommitmentToSendNextTransaction: waitForCommitmentToSendNextTransaction, transactions: transactions } = _a, rest = $bfcb0c59dacecb40$var$__rest(_a, [
                                    "minContextSlot",
                                    "commitment",
                                    "skipPreflight",
                                    "maxRetries",
                                    "waitForCommitmentToSendNextTransaction",
                                    "transactions"
                                ]);
                                return $bfcb0c59dacecb40$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($bfcb0c59dacecb40$var$getPayloadFromTransaction);
                                    const options = {
                                        min_context_slot: minContextSlot,
                                        commitment: commitment,
                                        skip_preflight: skipPreflight,
                                        max_retries: maxRetries,
                                        wait_for_commitment_to_send_next_transaction: waitForCommitmentToSendNextTransaction
                                    };
                                    const { signatures: base64EncodedSignatures } = yield wallet.signAndSendTransactions(Object.assign(Object.assign(Object.assign({}, rest), Object.values(options).some((element)=>element != null) ? {
                                        options: options
                                    } : null), {
                                        payloads: payloads
                                    }));
                                    const signatures = base64EncodedSignatures.map($bfcb0c59dacecb40$var$toUint8Array).map((0, (/*@__PURE__*/$parcel$interopDefault($1b5c2d76db9e67a0$exports))).encode);
                                    return signatures;
                                });
                            };
                            break;
                        case "signMessages":
                            target[p] = function(_a) {
                                var { payloads: payloads } = _a, rest = $bfcb0c59dacecb40$var$__rest(_a, [
                                    "payloads"
                                ]);
                                return $bfcb0c59dacecb40$var$__awaiter(this, void 0, void 0, function*() {
                                    const base64EncodedPayloads = payloads.map($bfcb0c59dacecb40$var$fromUint8Array);
                                    const { signed_payloads: base64EncodedSignedMessages } = yield wallet.signMessages(Object.assign(Object.assign({}, rest), {
                                        payloads: base64EncodedPayloads
                                    }));
                                    const signedMessages = base64EncodedSignedMessages.map($bfcb0c59dacecb40$var$toUint8Array);
                                    return signedMessages;
                                });
                            };
                            break;
                        case "signTransactions":
                            target[p] = function(_a) {
                                var { transactions: transactions } = _a, rest = $bfcb0c59dacecb40$var$__rest(_a, [
                                    "transactions"
                                ]);
                                return $bfcb0c59dacecb40$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($bfcb0c59dacecb40$var$getPayloadFromTransaction);
                                    const { signed_payloads: base64EncodedCompiledTransactions } = yield wallet.signTransactions(Object.assign(Object.assign({}, rest), {
                                        payloads: payloads
                                    }));
                                    const compiledTransactions = base64EncodedCompiledTransactions.map($bfcb0c59dacecb40$var$toUint8Array);
                                    const signedTransactions = compiledTransactions.map($bfcb0c59dacecb40$var$getTransactionFromWireMessage);
                                    return signedTransactions;
                                });
                            };
                            break;
                        default:
                            target[p] = wallet[p];
                            break;
                    }
                    return target[p];
                },
                defineProperty () {
                    return false;
                },
                deleteProperty () {
                    return false;
                }
            });
            return callback(augmentedAPI);
        };
        return yield (0, $fd413eaf80db5857$export$dac1bad6146b2469)(augmentedCallback, config);
    });
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $dd84591a730a91e2$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $dd84591a730a91e2$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $dd84591a730a91e2$var$getIsSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
const $dd84591a730a91e2$export$f1265e9082f346f1 = "Mobile Wallet Adapter";
const $dd84591a730a91e2$var$SIGNATURE_LENGTH_IN_BYTES = 64;
function $dd84591a730a91e2$var$getPublicKeyFromAddress(address) {
    const publicKeyByteArray = $dd84591a730a91e2$var$toUint8Array(address);
    return new (0, $1biTx.PublicKey)(publicKeyByteArray);
}
function $dd84591a730a91e2$var$isVersionedTransaction(transaction) {
    return "version" in transaction;
}
class $dd84591a730a91e2$export$dec251788b2f5a84 extends (0, $27607400338ed42b$export$9779f871ffdb3d87) {
    constructor(config){
        var _a;
        super();
        this.supportedTransactionVersions = new Set(// FIXME(#244): We can't actually know what versions are supported until we know which wallet we're talking to.
        [
            "legacy",
            0
        ]);
        this.name = $dd84591a730a91e2$export$f1265e9082f346f1;
        this.url = "https://solanamobile.com/wallets";
        this.icon = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI4IiB3aWR0aD0iMjgiIHZpZXdCb3g9Ii0zIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI0RDQjhGRiI+PHBhdGggZD0iTTE3LjQgMTcuNEgxNXYyLjRoMi40di0yLjRabTEuMi05LjZoLTIuNHYyLjRoMi40VjcuOFoiLz48cGF0aCBkPSJNMjEuNiAzVjBoLTIuNHYzaC0zLjZWMGgtMi40djNoLTIuNHY2LjZINC41YTIuMSAyLjEgMCAxIDEgMC00LjJoMi43VjNINC41QTQuNSA0LjUgMCAwIDAgMCA3LjVWMjRoMjEuNnYtNi42aC0yLjR2NC4ySDIuNFYxMS41Yy41LjMgMS4yLjQgMS44LjVoNy41QTYuNiA2LjYgMCAwIDAgMjQgOVYzaC0yLjRabTAgNS43YTQuMiA0LjIgMCAxIDEtOC40IDBWNS40aDguNHYzLjNaIi8+PC9nPjwvc3ZnPg==";
        this._connecting = false;
        /**
         * Every time the connection is recycled in some way (eg. `disconnect()` is called)
         * increment this and use it to make sure that `transact` calls from the previous
         * 'generation' don't continue to do work and throw exceptions.
         */ this._connectionGeneration = 0;
        this._readyState = $dd84591a730a91e2$var$getIsSupported() ? (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Loadable : (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Unsupported;
        this._authorizationResultCache = config.authorizationResultCache;
        this._addressSelector = config.addressSelector;
        this._appIdentity = config.appIdentity;
        this._chain = (_a = config.chain) !== null && _a !== void 0 ? _a : config.cluster;
        this._onWalletNotFound = config.onWalletNotFound;
        if (this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Unsupported) this._authorizationResultCache.get().then((authorizationResult)=>{
            if (authorizationResult) // Having a prior authorization result is, right now, the best
            // indication that a mobile wallet is installed. There is no API
            // we can use to test for whether the association URI is supported.
            this.declareWalletAsInstalled();
        });
    }
    get publicKey() {
        if (this._publicKey == null && this._selectedAddress != null) try {
            this._publicKey = $dd84591a730a91e2$var$getPublicKeyFromAddress(this._selectedAddress);
        } catch (e) {
            throw new (0, $51fd612dc03e2ca2$export$735bef3bfb0f2c86)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
        }
        return this._publicKey ? this._publicKey : null;
    }
    get connected() {
        return !!this._authorizationResult;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    declareWalletAsInstalled() {
        if (this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed) this.emit("readyStateChange", this._readyState = (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed);
    }
    runWithGuard(callback) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield callback();
            } catch (e) {
                this.emit("error", e);
                throw e;
            }
        });
    }
    /** @deprecated Use `autoConnect()` instead. */ autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED() {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.autoConnect();
        });
    }
    autoConnect() {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Loadable) throw new (0, $51fd612dc03e2ca2$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                        if (cachedAuthorizationResult) // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        this.handleAuthorizationResult(cachedAuthorizationResult);
                    } catch (e) {
                        throw new (0, $51fd612dc03e2ca2$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    connect() {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Loadable) throw new (0, $51fd612dc03e2ca2$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        yield this.performAuthorization();
                    } catch (e) {
                        throw new (0, $51fd612dc03e2ca2$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    performAuthorization(signInPayload) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                if (cachedAuthorizationResult) {
                    // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                    this.handleAuthorizationResult(cachedAuthorizationResult);
                    return cachedAuthorizationResult;
                }
                return yield this.transact((wallet)=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                        const authorizationResult = yield wallet.authorize({
                            chain: this._chain,
                            identity: this._appIdentity,
                            sign_in_payload: signInPayload
                        });
                        // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        Promise.all([
                            this._authorizationResultCache.set(authorizationResult),
                            this.handleAuthorizationResult(authorizationResult)
                        ]);
                        return authorizationResult;
                    }));
            } catch (e) {
                throw new (0, $51fd612dc03e2ca2$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
            }
        });
    }
    handleAuthorizationResult(authorizationResult) {
        var _a;
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            const didPublicKeysChange = // Case 1: We started from having no authorization.
            this._authorizationResult == null || // Case 2: The number of authorized accounts changed.
            ((_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.accounts.length) !== authorizationResult.accounts.length || // Case 3: The new list of addresses isn't exactly the same as the old list, in the same order.
            this._authorizationResult.accounts.some((account, ii)=>account.address !== authorizationResult.accounts[ii].address);
            this._authorizationResult = authorizationResult;
            this.declareWalletAsInstalled();
            if (didPublicKeysChange) {
                const nextSelectedAddress = yield this._addressSelector.select(authorizationResult.accounts.map(({ address: address })=>address));
                if (nextSelectedAddress !== this._selectedAddress) {
                    this._selectedAddress = nextSelectedAddress;
                    delete this._publicKey;
                    this.emit("connect", // Having just set `this._selectedAddress`, `this.publicKey` is definitely non-null
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.publicKey);
                }
            }
        });
    }
    performReauthorization(wallet, authToken) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const authorizationResult = yield wallet.authorize({
                    auth_token: authToken,
                    identity: this._appIdentity
                });
                // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                Promise.all([
                    this._authorizationResultCache.set(authorizationResult),
                    this.handleAuthorizationResult(authorizationResult)
                ]);
            } catch (e) {
                this.disconnect();
                throw new (0, $51fd612dc03e2ca2$export$bf7028c52ebda81e)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
            }
        });
    }
    disconnect() {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            this._authorizationResultCache.clear(); // TODO: Evaluate whether there's any threat to not `awaiting` this expression
            this._connecting = false;
            this._connectionGeneration++;
            delete this._authorizationResult;
            delete this._publicKey;
            delete this._selectedAddress;
            this.emit("disconnect");
        });
    }
    transact(callback) {
        var _a;
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            const walletUriBase = (_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.wallet_uri_base;
            const config = walletUriBase ? {
                baseUri: walletUriBase
            } : undefined;
            const currentConnectionGeneration = this._connectionGeneration;
            try {
                return yield (0, $bfcb0c59dacecb40$export$dac1bad6146b2469)(callback, config);
            } catch (e) {
                if (this._connectionGeneration !== currentConnectionGeneration) yield new Promise(()=>{}); // Never resolve.
                if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") yield this._onWalletNotFound(this);
                throw e;
            }
        });
    }
    assertIsAuthorized() {
        if (!this._authorizationResult || !this._selectedAddress) throw new (0, $51fd612dc03e2ca2$export$313d299817c74896)();
        return {
            authToken: this._authorizationResult.auth_token,
            selectedAddress: this._selectedAddress
        };
    }
    performSignTransactions(transactions) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            const { authToken: authToken } = this.assertIsAuthorized();
            try {
                return yield this.transact((wallet)=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                        yield this.performReauthorization(wallet, authToken);
                        const signedTransactions = yield wallet.signTransactions({
                            transactions: transactions
                        });
                        return signedTransactions;
                    }));
            } catch (error) {
                throw new (0, $51fd612dc03e2ca2$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
            }
        });
    }
    sendTransaction(transaction, connection, options) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken } = this.assertIsAuthorized();
                    const minContextSlot = options === null || options === void 0 ? void 0 : options.minContextSlot;
                    try {
                        return yield this.transact((wallet)=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                                function getTargetCommitment() {
                                    let targetCommitment;
                                    switch(connection.commitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetCommitment = connection.commitment;
                                            break;
                                        default:
                                            targetCommitment = "finalized";
                                    }
                                    let targetPreflightCommitment;
                                    switch(options === null || options === void 0 ? void 0 : options.preflightCommitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetPreflightCommitment = options.preflightCommitment;
                                            break;
                                        case undefined:
                                            targetPreflightCommitment = targetCommitment;
                                            break;
                                        default:
                                            targetPreflightCommitment = "finalized";
                                    }
                                    const preflightCommitmentScore = targetPreflightCommitment === "finalized" ? 2 : targetPreflightCommitment === "confirmed" ? 1 : 0;
                                    const targetCommitmentScore = targetCommitment === "finalized" ? 2 : targetCommitment === "confirmed" ? 1 : 0;
                                    return preflightCommitmentScore < targetCommitmentScore ? targetPreflightCommitment : targetCommitment;
                                }
                                const [capabilities, _1, _2] = yield Promise.all([
                                    wallet.getCapabilities(),
                                    this.performReauthorization(wallet, authToken),
                                    $dd84591a730a91e2$var$isVersionedTransaction(transaction) ? null : /**
                                   * Unlike versioned transactions, legacy `Transaction` objects
                                   * may not have an associated `feePayer` or `recentBlockhash`.
                                   * This code exists to patch them up in case they are missing.
                                   */ (()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                                            var _a;
                                            transaction.feePayer || (transaction.feePayer = (_a = this.publicKey) !== null && _a !== void 0 ? _a : undefined);
                                            if (transaction.recentBlockhash == null) {
                                                const { blockhash: blockhash } = yield connection.getLatestBlockhash({
                                                    commitment: getTargetCommitment()
                                                });
                                                transaction.recentBlockhash = blockhash;
                                            }
                                        }))()
                                ]);
                                if (capabilities.supports_sign_and_send_transactions) {
                                    const signatures = yield wallet.signAndSendTransactions({
                                        minContextSlot: minContextSlot,
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    return signatures[0];
                                } else {
                                    const [signedTransaction] = yield wallet.signTransactions({
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    if ($dd84591a730a91e2$var$isVersionedTransaction(signedTransaction)) return yield connection.sendTransaction(signedTransaction);
                                    else {
                                        const serializedTransaction = signedTransaction.serialize();
                                        return yield connection.sendRawTransaction(serializedTransaction, Object.assign(Object.assign({}, options), {
                                            preflightCommitment: getTargetCommitment()
                                        }));
                                    }
                                }
                            }));
                    } catch (error) {
                        throw new (0, $51fd612dc03e2ca2$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signTransaction(transaction) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                    const [signedTransaction] = yield this.performSignTransactions([
                        transaction
                    ]);
                    return signedTransaction;
                }));
        });
    }
    signAllTransactions(transactions) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                    const signedTransactions = yield this.performSignTransactions(transactions);
                    return signedTransactions;
                }));
        });
    }
    signMessage(message) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken, selectedAddress: selectedAddress } = this.assertIsAuthorized();
                    try {
                        return yield this.transact((wallet)=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                                yield this.performReauthorization(wallet, authToken);
                                const [signedMessage] = yield wallet.signMessages({
                                    addresses: [
                                        selectedAddress
                                    ],
                                    payloads: [
                                        message
                                    ]
                                });
                                const signature = signedMessage.slice(-$dd84591a730a91e2$var$SIGNATURE_LENGTH_IN_BYTES);
                                return signature;
                            }));
                    } catch (error) {
                        throw new (0, $51fd612dc03e2ca2$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signIn(input) {
        return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b;
                    if (this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Loadable) throw new (0, $51fd612dc03e2ca2$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const authorizationResult = yield this.performAuthorization(Object.assign(Object.assign({}, input), {
                            domain: (_a = input === null || input === void 0 ? void 0 : input.domain) !== null && _a !== void 0 ? _a : window.location.host
                        }));
                        if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
                        const signedInAddress = authorizationResult.sign_in_result.address;
                        const signedInAccount = Object.assign(Object.assign({}, (_b = authorizationResult.accounts.find((acc)=>acc.address == signedInAddress)) !== null && _b !== void 0 ? _b : {
                            address: signedInAddress
                        }), {
                            publicKey: $dd84591a730a91e2$var$toUint8Array(signedInAddress)
                        });
                        return {
                            account: signedInAccount,
                            signedMessage: $dd84591a730a91e2$var$toUint8Array(authorizationResult.sign_in_result.signed_message),
                            signature: $dd84591a730a91e2$var$toUint8Array(authorizationResult.sign_in_result.signature)
                        };
                    } catch (e) {
                        throw new (0, $51fd612dc03e2ca2$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
}
function $dd84591a730a91e2$export$a299fb0acc11345b() {
    return {
        select (addresses) {
            return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                return addresses[0];
            });
        }
    };
}
const $dd84591a730a91e2$var$CACHE_KEY = "SolanaMobileWalletAdapterDefaultAuthorizationCache";
function $dd84591a730a91e2$export$4a0b597891770806() {
    let storage;
    try {
        storage = window.localStorage;
    // eslint-disable-next-line no-empty
    } catch (_a) {}
    return {
        clear () {
            return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.removeItem($dd84591a730a91e2$var$CACHE_KEY);
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        get () {
            return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    return JSON.parse(storage.getItem($dd84591a730a91e2$var$CACHE_KEY)) || undefined;
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        set (authorizationResult) {
            return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.setItem($dd84591a730a91e2$var$CACHE_KEY, JSON.stringify(authorizationResult));
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        }
    };
}
function $dd84591a730a91e2$var$defaultWalletNotFoundHandler(mobileWalletAdapter) {
    return $dd84591a730a91e2$var$__awaiter(this, void 0, void 0, function*() {
        if (typeof window !== "undefined") window.location.assign(mobileWalletAdapter.url);
    });
}
function $dd84591a730a91e2$export$e8b9e70cdf783b70() {
    return $dd84591a730a91e2$var$defaultWalletNotFoundHandler;
}


/** Name of the feature. */ const $215934ffe1d9ca55$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

/** Name of the feature. */ const $a3c844ad23570d5d$export$54187c3796d0ecb = "solana:signTransaction";


/** Name of the feature. */ const $d269849b3fd376d2$export$cc68487eeb93b1d4 = "standard:connect";
const $d269849b3fd376d2$export$59e6910693f047c2 = $d269849b3fd376d2$export$cc68487eeb93b1d4;

/** Name of the feature. */ const $42842d901dd7ce85$export$5296443ca9e9fa0f = "standard:events";
const $42842d901dd7ce85$export$ada873a34909da65 = $42842d901dd7ce85$export$5296443ca9e9fa0f;


function $fd312a29475c1e68$export$de6946e7c2c87e9a(wallet) {
    return (0, $d269849b3fd376d2$export$cc68487eeb93b1d4) in wallet.features && (0, $42842d901dd7ce85$export$5296443ca9e9fa0f) in wallet.features && ((0, $215934ffe1d9ca55$export$dd64f32469f35f81) in wallet.features || (0, $a3c844ad23570d5d$export$54187c3796d0ecb) in wallet.features);
}


const $b6e87778cbd31591$export$c5439c91843266e6 = (0, $fd312a29475c1e68$export$de6946e7c2c87e9a);


/** Name of the feature. */ const $ffce9b1cde2c7a05$export$8adeab75f48a3607 = "solana:signIn";

/** Name of the feature. */ const $7aca782651669e5b$export$22c7939a38084172 = "solana:signMessage";


/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ const $117f5ecb93a56280$export$bba9a228295b3963 = "solana:mainnet";
const $117f5ecb93a56280$export$654cc095bd2e650 = "solana:devnet";
const $117f5ecb93a56280$export$76575b7bf4de1f40 = "solana:testnet";
const $117f5ecb93a56280$export$483699a75281444c = "solana:localnet";
const $117f5ecb93a56280$export$d77e7f94b1f6bf7d = [
    $117f5ecb93a56280$export$bba9a228295b3963,
    $117f5ecb93a56280$export$654cc095bd2e650,
    $117f5ecb93a56280$export$76575b7bf4de1f40,
    $117f5ecb93a56280$export$483699a75281444c
];
function $117f5ecb93a56280$export$d8f86f4d3d9fc2b5(chain) {
    return $117f5ecb93a56280$export$d77e7f94b1f6bf7d.includes(chain);
}


const $35383ec1cc303753$export$9462d80112b287bf = "https://api.mainnet-beta.solana.com";
const $35383ec1cc303753$export$2416cc3545b31c3b = "https://api.devnet.solana.com";
const $35383ec1cc303753$export$fe3dc909dfa57ddb = "https://api.testnet.solana.com";
const $35383ec1cc303753$export$ec9ed1d68bb4713f = "http://localhost:8899";
function $35383ec1cc303753$export$43dcd8213c5a5741(endpoint) {
    if (endpoint.includes($35383ec1cc303753$export$9462d80112b287bf)) return 0, $117f5ecb93a56280$export$bba9a228295b3963;
    if (/\bdevnet\b/i.test(endpoint)) return 0, $117f5ecb93a56280$export$654cc095bd2e650;
    if (/\btestnet\b/i.test(endpoint)) return 0, $117f5ecb93a56280$export$76575b7bf4de1f40;
    if (/\blocalhost\b/i.test(endpoint) || /\b127\.0\.0\.1\b/.test(endpoint)) return 0, $117f5ecb93a56280$export$483699a75281444c;
    return 0, $117f5ecb93a56280$export$bba9a228295b3963;
}
function $35383ec1cc303753$export$c9b15526ee38efba(chain, endpoint) {
    if (endpoint) return endpoint;
    if (chain === (0, $117f5ecb93a56280$export$bba9a228295b3963)) return $35383ec1cc303753$export$9462d80112b287bf;
    if (chain === (0, $117f5ecb93a56280$export$654cc095bd2e650)) return $35383ec1cc303753$export$2416cc3545b31c3b;
    if (chain === (0, $117f5ecb93a56280$export$76575b7bf4de1f40)) return $35383ec1cc303753$export$fe3dc909dfa57ddb;
    if (chain === (0, $117f5ecb93a56280$export$483699a75281444c)) return $35383ec1cc303753$export$ec9ed1d68bb4713f;
    return $35383ec1cc303753$export$9462d80112b287bf;
}

/**
 * TODO: docs
 */ function $49ad62f678973bac$export$430b2bce150d42d4(commitment) {
    switch(commitment){
        case "processed":
        case "confirmed":
        case "finalized":
        case undefined:
            return commitment;
        case "recent":
            return "processed";
        case "single":
        case "singleGossip":
            return "confirmed";
        case "max":
        case "root":
            return "finalized";
        default:
            return undefined;
    }
}



var $1biTx = parcelRequire("1biTx");
/** Name of the feature. */ const $d4cf98369db0a1e0$export$38dbd4bbb9b696e6 = "standard:disconnect";
const $d4cf98369db0a1e0$export$9e282393ab352bcd = $d4cf98369db0a1e0$export$38dbd4bbb9b696e6;


var $03463d5133df60e0$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $03463d5133df60e0$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $03463d5133df60e0$var$_ReadonlyWalletAccount_address, $03463d5133df60e0$var$_ReadonlyWalletAccount_publicKey, $03463d5133df60e0$var$_ReadonlyWalletAccount_chains, $03463d5133df60e0$var$_ReadonlyWalletAccount_features, $03463d5133df60e0$var$_ReadonlyWalletAccount_label, $03463d5133df60e0$var$_ReadonlyWalletAccount_icon;
class $03463d5133df60e0$export$c0ac434c7ac96eb0 {
    /**
     * Create and freeze a read-only account.
     *
     * @param account Account to copy properties from.
     */ constructor(account){
        $03463d5133df60e0$var$_ReadonlyWalletAccount_address.set(this, void 0);
        $03463d5133df60e0$var$_ReadonlyWalletAccount_publicKey.set(this, void 0);
        $03463d5133df60e0$var$_ReadonlyWalletAccount_chains.set(this, void 0);
        $03463d5133df60e0$var$_ReadonlyWalletAccount_features.set(this, void 0);
        $03463d5133df60e0$var$_ReadonlyWalletAccount_label.set(this, void 0);
        $03463d5133df60e0$var$_ReadonlyWalletAccount_icon.set(this, void 0);
        if (new.target === $03463d5133df60e0$export$c0ac434c7ac96eb0) Object.freeze(this);
        $03463d5133df60e0$var$__classPrivateFieldSet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_address, account.address, "f");
        $03463d5133df60e0$var$__classPrivateFieldSet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_publicKey, account.publicKey.slice(), "f");
        $03463d5133df60e0$var$__classPrivateFieldSet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_chains, account.chains.slice(), "f");
        $03463d5133df60e0$var$__classPrivateFieldSet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_features, account.features.slice(), "f");
        $03463d5133df60e0$var$__classPrivateFieldSet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_label, account.label, "f");
        $03463d5133df60e0$var$__classPrivateFieldSet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_icon, account.icon, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.address | WalletAccount::address} */ get address() {
        return $03463d5133df60e0$var$__classPrivateFieldGet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_address, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.publicKey | WalletAccount::publicKey} */ get publicKey() {
        return $03463d5133df60e0$var$__classPrivateFieldGet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_publicKey, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.chains | WalletAccount::chains} */ get chains() {
        return $03463d5133df60e0$var$__classPrivateFieldGet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_chains, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.features | WalletAccount::features} */ get features() {
        return $03463d5133df60e0$var$__classPrivateFieldGet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_features, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.label | WalletAccount::label} */ get label() {
        return $03463d5133df60e0$var$__classPrivateFieldGet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_label, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.icon | WalletAccount::icon} */ get icon() {
        return $03463d5133df60e0$var$__classPrivateFieldGet(this, $03463d5133df60e0$var$_ReadonlyWalletAccount_icon, "f");
    }
}
$03463d5133df60e0$var$_ReadonlyWalletAccount_address = new WeakMap(), $03463d5133df60e0$var$_ReadonlyWalletAccount_publicKey = new WeakMap(), $03463d5133df60e0$var$_ReadonlyWalletAccount_chains = new WeakMap(), $03463d5133df60e0$var$_ReadonlyWalletAccount_features = new WeakMap(), $03463d5133df60e0$var$_ReadonlyWalletAccount_label = new WeakMap(), $03463d5133df60e0$var$_ReadonlyWalletAccount_icon = new WeakMap();
function $03463d5133df60e0$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $03463d5133df60e0$export$c663ab80cce302c5(a, b) {
    return $03463d5133df60e0$export$234180f8206db11b(a, b);
}
function $03463d5133df60e0$export$287dd7971339c972(first, ...others) {
    const length = others.reduce((length, bytes)=>length + bytes.length, first.length);
    const bytes = new Uint8Array(length);
    bytes.set(first, 0);
    for (const other of others)bytes.set(other, bytes.length);
    return bytes;
}
function $03463d5133df60e0$export$357523c63a2253b9(source, ...keys) {
    const picked = {};
    for (const key of keys)picked[key] = source[key];
    return picked;
}
function $03463d5133df60e0$export$864d727b48066337(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}



var $f4WXk = parcelRequire("f4WXk");
var $8830a6d651aeb662$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $8830a6d651aeb662$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $8830a6d651aeb662$var$_StandardWalletAdapter_instances, $8830a6d651aeb662$var$_StandardWalletAdapter_account, $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey, $8830a6d651aeb662$var$_StandardWalletAdapter_connecting, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting, $8830a6d651aeb662$var$_StandardWalletAdapter_off, $8830a6d651aeb662$var$_StandardWalletAdapter_supportedTransactionVersions, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, $8830a6d651aeb662$var$_StandardWalletAdapter_readyState, $8830a6d651aeb662$var$_StandardWalletAdapter_connect, $8830a6d651aeb662$var$_StandardWalletAdapter_connected, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnected, $8830a6d651aeb662$var$_StandardWalletAdapter_reset, $8830a6d651aeb662$var$_StandardWalletAdapter_changed, $8830a6d651aeb662$var$_StandardWalletAdapter_signTransaction, $8830a6d651aeb662$var$_StandardWalletAdapter_signAllTransactions, $8830a6d651aeb662$var$_StandardWalletAdapter_signMessage, $8830a6d651aeb662$var$_StandardWalletAdapter_signIn;
class $8830a6d651aeb662$export$e0949de9e32fe3b2 extends (0, $bfe62661f5b3c85b$export$2af1ea2892adc469) {
    constructor({ wallet: wallet }){
        super();
        $8830a6d651aeb662$var$_StandardWalletAdapter_instances.add(this);
        $8830a6d651aeb662$var$_StandardWalletAdapter_account.set(this, void 0);
        $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey.set(this, void 0);
        $8830a6d651aeb662$var$_StandardWalletAdapter_connecting.set(this, void 0);
        $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting.set(this, void 0);
        $8830a6d651aeb662$var$_StandardWalletAdapter_off.set(this, void 0);
        $8830a6d651aeb662$var$_StandardWalletAdapter_supportedTransactionVersions.set(this, void 0);
        $8830a6d651aeb662$var$_StandardWalletAdapter_wallet.set(this, void 0);
        $8830a6d651aeb662$var$_StandardWalletAdapter_readyState.set(this, typeof window === "undefined" || typeof document === "undefined" ? (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Unsupported : (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed);
        $8830a6d651aeb662$var$_StandardWalletAdapter_changed.set(this, (properties)=>{
            // If accounts have changed on the wallet, reflect this on the adapter.
            if ("accounts" in properties) {
                const account = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").accounts[0];
                // If the adapter isn't connected, or is disconnecting, or the first account hasn't changed, do nothing.
                if ($8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f") && !$8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting, "f") && account !== $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f")) {
                    // If there's a connected account, connect the adapter. Otherwise, disconnect it.
                    if (account) // Connect the adapter.
                    $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_connected).call(this, account);
                    else {
                        // Emit an error because the wallet spontaneously disconnected.
                        this.emit("error", new (0, $51fd612dc03e2ca2$export$bf7028c52ebda81e)());
                        // Disconnect the adapter.
                        $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_disconnected).call(this);
                    }
                }
            }
            // After reflecting account changes, if features have changed on the wallet, reflect this on the adapter.
            if ("features" in properties) $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_reset).call(this);
        });
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, wallet, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, null, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey, null, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_connecting, false, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting, false, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_off, $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $42842d901dd7ce85$export$5296443ca9e9fa0f].on("change", $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_changed, "f")), "f");
        $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_reset).call(this);
    }
    get name() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").name;
    }
    get url() {
        return "https://github.com/solana-labs/wallet-standard";
    }
    get icon() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").icon;
    }
    get readyState() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_readyState, "f");
    }
    get publicKey() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey, "f");
    }
    get connecting() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_connecting, "f");
    }
    get supportedTransactionVersions() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_supportedTransactionVersions, "f");
    }
    get wallet() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f");
    }
    get standard() {
        return true;
    }
    destroy() {
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, null, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey, null, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_connecting, false, "f");
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting, false, "f");
        const off = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_off, "f");
        if (off) {
            $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_off, null, "f");
            off();
        }
    }
    async autoConnect() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_connect).call(this, {
            silent: true
        });
    }
    async connect() {
        return $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_connect).call(this);
    }
    async disconnect() {
        if ((0, $d4cf98369db0a1e0$export$38dbd4bbb9b696e6) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features) try {
            $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting, true, "f");
            await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $d4cf98369db0a1e0$export$38dbd4bbb9b696e6].disconnect();
        } catch (error) {
            this.emit("error", new (0, $51fd612dc03e2ca2$export$92e2b26fad5723ee)(error?.message, error));
        } finally{
            $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting, false, "f");
        }
        $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_disconnected).call(this);
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const account = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f");
            if (!account) throw new (0, $51fd612dc03e2ca2$export$313d299817c74896)();
            let feature;
            if ((0, $215934ffe1d9ca55$export$dd64f32469f35f81) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features) {
                if (account.features.includes((0, $215934ffe1d9ca55$export$dd64f32469f35f81))) feature = (0, $215934ffe1d9ca55$export$dd64f32469f35f81);
                else if ((0, $a3c844ad23570d5d$export$54187c3796d0ecb) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features && account.features.includes((0, $a3c844ad23570d5d$export$54187c3796d0ecb))) feature = (0, $a3c844ad23570d5d$export$54187c3796d0ecb);
                else throw new (0, $51fd612dc03e2ca2$export$cd6fa2f8e2a8a612)();
            } else if ((0, $a3c844ad23570d5d$export$54187c3796d0ecb) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features) {
                if (!account.features.includes((0, $a3c844ad23570d5d$export$54187c3796d0ecb))) throw new (0, $51fd612dc03e2ca2$export$cd6fa2f8e2a8a612)();
                feature = (0, $a3c844ad23570d5d$export$54187c3796d0ecb);
            } else throw new (0, $51fd612dc03e2ca2$export$9525019988612a5e)();
            const chain = (0, $35383ec1cc303753$export$43dcd8213c5a5741)(connection.rpcEndpoint);
            if (!account.chains.includes(chain)) throw new (0, $51fd612dc03e2ca2$export$769332ac3f90f46c)();
            try {
                const { signers: signers, ...sendOptions } = options;
                let serializedTransaction;
                if ((0, $22b57afe0b9b3669$export$37ce1cc82e255d8)(transaction)) {
                    signers?.length && transaction.sign(signers);
                    serializedTransaction = transaction.serialize();
                } else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                    serializedTransaction = new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }));
                }
                if (feature === (0, $215934ffe1d9ca55$export$dd64f32469f35f81)) {
                    const [output] = await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $215934ffe1d9ca55$export$dd64f32469f35f81].signAndSendTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $49ad62f678973bac$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            skipPreflight: sendOptions.skipPreflight,
                            maxRetries: sendOptions.maxRetries,
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(output.signature);
                } else {
                    const [output] = await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $a3c844ad23570d5d$export$54187c3796d0ecb].signTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $49ad62f678973bac$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return await connection.sendRawTransaction(output.signedTransaction, {
                        ...sendOptions,
                        preflightCommitment: (0, $49ad62f678973bac$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment)
                    });
                }
            } catch (error) {
                if (error instanceof (0, $51fd612dc03e2ca2$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $51fd612dc03e2ca2$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}
$8830a6d651aeb662$var$_StandardWalletAdapter_account = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_connecting = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_disconnecting = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_off = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_supportedTransactionVersions = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_wallet = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_readyState = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_changed = new WeakMap(), $8830a6d651aeb662$var$_StandardWalletAdapter_instances = new WeakSet(), $8830a6d651aeb662$var$_StandardWalletAdapter_connect = async function _StandardWalletAdapter_connect(input) {
    try {
        if (this.connected || this.connecting) return;
        if ($8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_readyState, "f") !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed) throw new (0, $51fd612dc03e2ca2$export$d65db264eda99cd7)();
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_connecting, true, "f");
        if (!$8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").accounts.length) try {
            await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $d269849b3fd376d2$export$cc68487eeb93b1d4].connect(input);
        } catch (error) {
            throw new (0, $51fd612dc03e2ca2$export$38f21f1c810261c7)(error?.message, error);
        }
        const account = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").accounts[0];
        if (!account) throw new (0, $51fd612dc03e2ca2$export$cd6fa2f8e2a8a612)();
        $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_connected).call(this, account);
    } catch (error) {
        this.emit("error", error);
        throw error;
    } finally{
        $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_connecting, false, "f");
    }
}, $8830a6d651aeb662$var$_StandardWalletAdapter_connected = function _StandardWalletAdapter_connected(account) {
    let publicKey;
    try {
        // Use account.address instead of account.publicKey since address could be a PDA
        publicKey = new (0, $1biTx.PublicKey)(account.address);
    } catch (error) {
        throw new (0, $51fd612dc03e2ca2$export$735bef3bfb0f2c86)(error?.message, error);
    }
    $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, account, "f");
    $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey, publicKey, "f");
    $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_reset).call(this);
    this.emit("connect", publicKey);
}, $8830a6d651aeb662$var$_StandardWalletAdapter_disconnected = function _StandardWalletAdapter_disconnected() {
    $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, null, "f");
    $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_publicKey, null, "f");
    $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_reset).call(this);
    this.emit("disconnect");
}, $8830a6d651aeb662$var$_StandardWalletAdapter_reset = function _StandardWalletAdapter_reset() {
    const supportedTransactionVersions = (0, $215934ffe1d9ca55$export$dd64f32469f35f81) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features ? $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $215934ffe1d9ca55$export$dd64f32469f35f81].supportedTransactionVersions : $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $a3c844ad23570d5d$export$54187c3796d0ecb].supportedTransactionVersions;
    $8830a6d651aeb662$var$__classPrivateFieldSet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_supportedTransactionVersions, (0, $03463d5133df60e0$export$234180f8206db11b)(supportedTransactionVersions, [
        "legacy"
    ]) ? null : new Set(supportedTransactionVersions), "f");
    if ((0, $a3c844ad23570d5d$export$54187c3796d0ecb) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features && $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $a3c844ad23570d5d$export$54187c3796d0ecb))) {
        this.signTransaction = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_signTransaction);
        this.signAllTransactions = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_signAllTransactions);
    } else {
        delete this.signTransaction;
        delete this.signAllTransactions;
    }
    if ((0, $7aca782651669e5b$export$22c7939a38084172) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features && $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $7aca782651669e5b$export$22c7939a38084172))) this.signMessage = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_signMessage);
    else delete this.signMessage;
    if ((0, $ffce9b1cde2c7a05$export$8adeab75f48a3607) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features) this.signIn = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_signIn);
    else delete this.signIn;
}, $8830a6d651aeb662$var$_StandardWalletAdapter_signTransaction = async function _StandardWalletAdapter_signTransaction(transaction) {
    try {
        const account = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $51fd612dc03e2ca2$export$313d299817c74896)();
        if (!((0, $a3c844ad23570d5d$export$54187c3796d0ecb) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $51fd612dc03e2ca2$export$9525019988612a5e)();
        if (!account.features.includes((0, $a3c844ad23570d5d$export$54187c3796d0ecb))) throw new (0, $51fd612dc03e2ca2$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $a3c844ad23570d5d$export$54187c3796d0ecb].signTransaction({
                account: account,
                transaction: (0, $22b57afe0b9b3669$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                    requireAllSignatures: false,
                    verifySignatures: false
                }))
            });
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const serializedTransaction = signedTransactions[0].signedTransaction;
            return (0, $22b57afe0b9b3669$export$37ce1cc82e255d8)(transaction) ? (0, $1biTx.VersionedTransaction).deserialize(serializedTransaction) : (0, $1biTx.Transaction).from(serializedTransaction);
        } catch (error) {
            if (error instanceof (0, $51fd612dc03e2ca2$export$f46ec6f9dba8711d)) throw error;
            throw new (0, $51fd612dc03e2ca2$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $8830a6d651aeb662$var$_StandardWalletAdapter_signAllTransactions = async function _StandardWalletAdapter_signAllTransactions(transactions) {
    try {
        const account = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $51fd612dc03e2ca2$export$313d299817c74896)();
        if (!((0, $a3c844ad23570d5d$export$54187c3796d0ecb) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $51fd612dc03e2ca2$export$9525019988612a5e)();
        if (!account.features.includes((0, $a3c844ad23570d5d$export$54187c3796d0ecb))) throw new (0, $51fd612dc03e2ca2$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $a3c844ad23570d5d$export$54187c3796d0ecb].signTransaction(...transactions.map((transaction)=>({
                    account: account,
                    transaction: (0, $22b57afe0b9b3669$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }))
                })));
            return transactions.map((transaction, index)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const signedTransaction = signedTransactions[index].signedTransaction;
                return (0, $22b57afe0b9b3669$export$37ce1cc82e255d8)(transaction) ? (0, $1biTx.VersionedTransaction).deserialize(signedTransaction) : (0, $1biTx.Transaction).from(signedTransaction);
            });
        } catch (error) {
            throw new (0, $51fd612dc03e2ca2$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $8830a6d651aeb662$var$_StandardWalletAdapter_signMessage = async function _StandardWalletAdapter_signMessage(message) {
    try {
        const account = $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $51fd612dc03e2ca2$export$313d299817c74896)();
        if (!((0, $7aca782651669e5b$export$22c7939a38084172) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $51fd612dc03e2ca2$export$9525019988612a5e)();
        if (!account.features.includes((0, $7aca782651669e5b$export$22c7939a38084172))) throw new (0, $51fd612dc03e2ca2$export$cd6fa2f8e2a8a612)();
        try {
            const signedMessages = await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $7aca782651669e5b$export$22c7939a38084172].signMessage({
                account: account,
                message: message
            });
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return signedMessages[0].signature;
        } catch (error) {
            throw new (0, $51fd612dc03e2ca2$export$2622c1721bbd4b17)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $8830a6d651aeb662$var$_StandardWalletAdapter_signIn = async function _StandardWalletAdapter_signIn(input = {}) {
    try {
        if (!((0, $ffce9b1cde2c7a05$export$8adeab75f48a3607) in $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $51fd612dc03e2ca2$export$9525019988612a5e)();
        let output;
        try {
            [output] = await $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_wallet, "f").features[0, $ffce9b1cde2c7a05$export$8adeab75f48a3607].signIn(input);
        } catch (error) {
            throw new (0, $51fd612dc03e2ca2$export$a4c7d3c66e3cdd6c)(error?.message, error);
        }
        if (!output) throw new (0, $51fd612dc03e2ca2$export$a4c7d3c66e3cdd6c)();
        $8830a6d651aeb662$var$__classPrivateFieldGet(this, $8830a6d651aeb662$var$_StandardWalletAdapter_instances, "m", $8830a6d651aeb662$var$_StandardWalletAdapter_connected).call(this, output.account);
        return output;
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
};


var $36cd46801a08c71f$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $36cd46801a08c71f$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $36cd46801a08c71f$var$_AppReadyEvent_detail;
let $36cd46801a08c71f$var$wallets = undefined;
const $36cd46801a08c71f$var$registered = new Set();
const $36cd46801a08c71f$var$listeners = {};
function $36cd46801a08c71f$export$ac4d188b6eef3eb7() {
    if ($36cd46801a08c71f$var$wallets) return $36cd46801a08c71f$var$wallets;
    $36cd46801a08c71f$var$wallets = Object.freeze({
        register: $36cd46801a08c71f$var$register,
        get: $36cd46801a08c71f$var$get,
        on: $36cd46801a08c71f$var$on
    });
    if (typeof window === "undefined") return $36cd46801a08c71f$var$wallets;
    const api = Object.freeze({
        register: $36cd46801a08c71f$var$register
    });
    try {
        window.addEventListener("wallet-standard:register-wallet", ({ detail: callback })=>callback(api));
    } catch (error) {
        console.error("wallet-standard:register-wallet event listener could not be added\n", error);
    }
    try {
        window.dispatchEvent(new $36cd46801a08c71f$var$AppReadyEvent(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event could not be dispatched\n", error);
    }
    return $36cd46801a08c71f$var$wallets;
}
function $36cd46801a08c71f$var$register(...wallets) {
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter((wallet)=>!$36cd46801a08c71f$var$registered.has(wallet));
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return ()=>{};
    wallets.forEach((wallet)=>$36cd46801a08c71f$var$registered.add(wallet));
    $36cd46801a08c71f$var$listeners["register"]?.forEach((listener)=>$36cd46801a08c71f$var$guard(()=>listener(...wallets)));
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        wallets.forEach((wallet)=>$36cd46801a08c71f$var$registered.delete(wallet));
        $36cd46801a08c71f$var$listeners["unregister"]?.forEach((listener)=>$36cd46801a08c71f$var$guard(()=>listener(...wallets)));
    };
}
function $36cd46801a08c71f$var$get() {
    return [
        ...$36cd46801a08c71f$var$registered
    ];
}
function $36cd46801a08c71f$var$on(event, listener) {
    $36cd46801a08c71f$var$listeners[event]?.push(listener) || ($36cd46801a08c71f$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        $36cd46801a08c71f$var$listeners[event] = $36cd46801a08c71f$var$listeners[event]?.filter((existingListener)=>listener !== existingListener);
    };
}
function $36cd46801a08c71f$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
class $36cd46801a08c71f$var$AppReadyEvent extends Event {
    constructor(api){
        super("wallet-standard:app-ready", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $36cd46801a08c71f$var$_AppReadyEvent_detail.set(this, void 0);
        $36cd46801a08c71f$var$__classPrivateFieldSet(this, $36cd46801a08c71f$var$_AppReadyEvent_detail, api, "f");
    }
    get detail() {
        return $36cd46801a08c71f$var$__classPrivateFieldGet(this, $36cd46801a08c71f$var$_AppReadyEvent_detail, "f");
    }
    get type() {
        return "wallet-standard:app-ready";
    }
    /** @deprecated */ preventDefault() {
        throw new Error("preventDefault cannot be called");
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error("stopImmediatePropagation cannot be called");
    }
    /** @deprecated */ stopPropagation() {
        throw new Error("stopPropagation cannot be called");
    }
}
$36cd46801a08c71f$var$_AppReadyEvent_detail = new WeakMap();
function $36cd46801a08c71f$export$2194deb72a59836d() {
    if ($36cd46801a08c71f$var$wallets) return $36cd46801a08c71f$var$wallets;
    $36cd46801a08c71f$var$wallets = $36cd46801a08c71f$export$ac4d188b6eef3eb7();
    if (typeof window === "undefined") return $36cd46801a08c71f$var$wallets;
    const callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error("window.navigator.wallets is not an array");
        return $36cd46801a08c71f$var$wallets;
    }
    const { register: register } = $36cd46801a08c71f$var$wallets;
    const push = (...callbacks)=>callbacks.forEach((callback)=>$36cd46801a08c71f$var$guard(()=>callback({
                    register: register
                })));
    try {
        Object.defineProperty(window.navigator, "wallets", {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error("window.navigator.wallets could not be set");
        return $36cd46801a08c71f$var$wallets;
    }
    push(...callbacks);
    return $36cd46801a08c71f$var$wallets;
}



var $lx97N = parcelRequire("lx97N");
function $e5096a497b5a50be$export$ca3bd81d254ceecf(adapters) {
    const warnings = $e5096a497b5a50be$var$useConstant(()=>new Set());
    const { get: get, on: on } = $e5096a497b5a50be$var$useConstant(()=>(0, $36cd46801a08c71f$export$2194deb72a59836d)());
    const [standardAdapters, setStandardAdapters] = (0, $lx97N.useState)(()=>$e5096a497b5a50be$var$wrapWalletsWithAdapters(get()));
    (0, $lx97N.useEffect)(()=>{
        const listeners = [
            on("register", (...wallets)=>setStandardAdapters((standardAdapters)=>[
                        ...standardAdapters,
                        ...$e5096a497b5a50be$var$wrapWalletsWithAdapters(wallets)
                    ])),
            on("unregister", (...wallets)=>setStandardAdapters((standardAdapters)=>standardAdapters.filter((standardAdapter)=>wallets.some((wallet)=>wallet === standardAdapter.wallet))))
        ];
        return ()=>listeners.forEach((off)=>off());
    }, [
        on
    ]);
    const prevStandardAdapters = $e5096a497b5a50be$var$usePrevious(standardAdapters);
    (0, $lx97N.useEffect)(()=>{
        if (!prevStandardAdapters) return;
        const currentAdapters = new Set(standardAdapters);
        const removedAdapters = new Set(prevStandardAdapters.filter((previousAdapter)=>!currentAdapters.has(previousAdapter)));
        removedAdapters.forEach((adapter)=>adapter.destroy());
    }, [
        prevStandardAdapters,
        standardAdapters
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $lx97N.useEffect)(()=>()=>standardAdapters.forEach((adapter)=>adapter.destroy()), []);
    return (0, $lx97N.useMemo)(()=>[
            ...standardAdapters,
            ...adapters.filter(({ name: name })=>{
                if (standardAdapters.some((standardAdapter)=>standardAdapter.name === name)) {
                    if (!warnings.has(name)) {
                        warnings.add(name);
                        console.warn(`${name} was registered as a Standard Wallet. The Wallet Adapter for ${name} can be removed from your app.`);
                    }
                    return false;
                }
                return true;
            })
        ], [
        standardAdapters,
        adapters,
        warnings
    ]);
}
function $e5096a497b5a50be$var$useConstant(fn) {
    const ref = (0, $lx97N.useRef)();
    if (!ref.current) ref.current = {
        value: fn()
    };
    return ref.current.value;
}
function $e5096a497b5a50be$var$usePrevious(state) {
    const ref = (0, $lx97N.useRef)();
    (0, $lx97N.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
}
function $e5096a497b5a50be$var$wrapWalletsWithAdapters(wallets) {
    return wallets.filter((0, $b6e87778cbd31591$export$c5439c91843266e6)).map((wallet)=>new (0, $8830a6d651aeb662$export$e0949de9e32fe3b2)({
            wallet: wallet
        }));
}



var $lx97N = parcelRequire("lx97N");


var $bbeb07dc194d27bd$export$7dc6752a22ab011a;
(function(Environment) {
    Environment[Environment["DESKTOP_WEB"] = 0] = "DESKTOP_WEB";
    Environment[Environment["MOBILE_WEB"] = 1] = "MOBILE_WEB";
})($bbeb07dc194d27bd$export$7dc6752a22ab011a || ($bbeb07dc194d27bd$export$7dc6752a22ab011a = {}));
function $bbeb07dc194d27bd$var$isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function $bbeb07dc194d27bd$export$2e2bcd8739ae039({ adapters: adapters, userAgentString: userAgentString }) {
    if (adapters.some((adapter)=>adapter.name !== (0, $dd84591a730a91e2$export$f1265e9082f346f1) && adapter.readyState === (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed)) /**
         * There are only two ways a browser extension adapter should be able to reach `Installed` status:
         *
         *     1. Its browser extension is installed.
         *     2. The app is running on a mobile wallet's in-app browser.
         *
         * In either case, we consider the environment to be desktop-like.
         */ return $bbeb07dc194d27bd$export$7dc6752a22ab011a.DESKTOP_WEB;
    if (userAgentString && // Step 1: Check whether we're on a platform that supports MWA at all.
    /android/i.test(userAgentString) && // Step 2: Determine that we are *not* running in a WebView.
    !$bbeb07dc194d27bd$var$isWebView(userAgentString)) return $bbeb07dc194d27bd$export$7dc6752a22ab011a.MOBILE_WEB;
    else return $bbeb07dc194d27bd$export$7dc6752a22ab011a.DESKTOP_WEB;
}


function $73b242ebecb52ef4$export$2e2bcd8739ae039(endpoint) {
    if (!endpoint) return "mainnet-beta";
    if (/devnet/i.test(endpoint)) return "devnet";
    else if (/testnet/i.test(endpoint)) return "testnet";
    else return "mainnet-beta";
}




var $lx97N = parcelRequire("lx97N");
function $27088ae81f8abe4e$export$86e2cef2561044ac(key, defaultState) {
    const state = (0, $lx97N.useState)(()=>{
        try {
            const value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
        return defaultState;
    });
    const value = state[0];
    const isFirstRenderRef = (0, $lx97N.useRef)(true);
    (0, $lx97N.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        try {
            if (value === null) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
    }, [
        value,
        key
    ]);
    return state;
}




var $lx97N = parcelRequire("lx97N");

class $5947c483a13261a8$export$3f5ccdf96415785c extends (0, $51fd612dc03e2ca2$export$f46ec6f9dba8711d) {
    constructor(){
        super(...arguments);
        this.name = "WalletNotSelectedError";
    }
}



var $lx97N = parcelRequire("lx97N");
const $502df6790791f964$var$EMPTY_ARRAY = [];
const $502df6790791f964$var$DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    select () {
        $502df6790791f964$var$logMissingProviderError("call", "select");
    },
    connect () {
        return Promise.reject($502df6790791f964$var$logMissingProviderError("call", "connect"));
    },
    disconnect () {
        return Promise.reject($502df6790791f964$var$logMissingProviderError("call", "disconnect"));
    },
    sendTransaction () {
        return Promise.reject($502df6790791f964$var$logMissingProviderError("call", "sendTransaction"));
    },
    signTransaction () {
        return Promise.reject($502df6790791f964$var$logMissingProviderError("call", "signTransaction"));
    },
    signAllTransactions () {
        return Promise.reject($502df6790791f964$var$logMissingProviderError("call", "signAllTransactions"));
    },
    signMessage () {
        return Promise.reject($502df6790791f964$var$logMissingProviderError("call", "signMessage"));
    },
    signIn () {
        return Promise.reject($502df6790791f964$var$logMissingProviderError("call", "signIn"));
    }
};
Object.defineProperty($502df6790791f964$var$DEFAULT_CONTEXT, "wallets", {
    get () {
        $502df6790791f964$var$logMissingProviderError("read", "wallets");
        return $502df6790791f964$var$EMPTY_ARRAY;
    }
});
Object.defineProperty($502df6790791f964$var$DEFAULT_CONTEXT, "wallet", {
    get () {
        $502df6790791f964$var$logMissingProviderError("read", "wallet");
        return null;
    }
});
Object.defineProperty($502df6790791f964$var$DEFAULT_CONTEXT, "publicKey", {
    get () {
        $502df6790791f964$var$logMissingProviderError("read", "publicKey");
        return null;
    }
});
function $502df6790791f964$var$logMissingProviderError(action, property) {
    const error = new Error(`You have tried to ${action} "${property}" on a WalletContext without providing one. ` + "Make sure to render a WalletProvider as an ancestor of the component that uses WalletContext.");
    console.error(error);
    return error;
}
const $502df6790791f964$export$19648c908dc8d0bf = (0, $lx97N.createContext)($502df6790791f964$var$DEFAULT_CONTEXT);
function $502df6790791f964$export$c34addee860b0acb() {
    return (0, $lx97N.useContext)($502df6790791f964$export$19648c908dc8d0bf);
}


function $6fdfd7e78a41b858$export$a50b3c99d691184b({ children: children, wallets: adapters, adapter: adapter, isUnloadingRef: isUnloadingRef, onAutoConnectRequest: onAutoConnectRequest, onConnectError: onConnectError, onError: onError, onSelectWallet: onSelectWallet }) {
    const isConnectingRef = (0, $lx97N.useRef)(false);
    const [connecting, setConnecting] = (0, $lx97N.useState)(false);
    const isDisconnectingRef = (0, $lx97N.useRef)(false);
    const [disconnecting, setDisconnecting] = (0, $lx97N.useState)(false);
    const [publicKey, setPublicKey] = (0, $lx97N.useState)(()=>adapter?.publicKey ?? null);
    const [connected, setConnected] = (0, $lx97N.useState)(()=>adapter?.connected ?? false);
    /**
     * Store the error handlers as refs so that a change in the
     * custom error handler does not recompute other dependencies.
     */ const onErrorRef = (0, $lx97N.useRef)(onError);
    (0, $lx97N.useEffect)(()=>{
        onErrorRef.current = onError;
        return ()=>{
            onErrorRef.current = undefined;
        };
    }, [
        onError
    ]);
    const handleErrorRef = (0, $lx97N.useRef)((error, adapter)=>{
        if (!isUnloadingRef.current) {
            if (onErrorRef.current) onErrorRef.current(error, adapter);
            else {
                console.error(error, adapter);
                if (error instanceof (0, $51fd612dc03e2ca2$export$d65db264eda99cd7) && typeof window !== "undefined" && adapter) window.open(adapter.url, "_blank");
            }
        }
        return error;
    });
    // Wrap adapters to conform to the `Wallet` interface
    const [wallets, setWallets] = (0, $lx97N.useState)(()=>adapters.map((adapter)=>({
                adapter: adapter,
                readyState: adapter.readyState
            })).filter(({ readyState: readyState })=>readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Unsupported));
    // When the adapters change, start to listen for changes to their `readyState`
    (0, $lx97N.useEffect)(()=>{
        // When the adapters change, wrap them to conform to the `Wallet` interface
        setWallets((wallets)=>adapters.map((adapter, index)=>{
                const wallet = wallets[index];
                // If the wallet hasn't changed, return the same instance
                return wallet && wallet.adapter === adapter && wallet.readyState === adapter.readyState ? wallet : {
                    adapter: adapter,
                    readyState: adapter.readyState
                };
            }).filter(({ readyState: readyState })=>readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Unsupported));
        function handleReadyStateChange(readyState) {
            setWallets((prevWallets)=>{
                const index = prevWallets.findIndex(({ adapter: adapter })=>adapter === this);
                if (index === -1) return prevWallets;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const { adapter: adapter } = prevWallets[index];
                return [
                    ...prevWallets.slice(0, index),
                    {
                        adapter: adapter,
                        readyState: readyState
                    },
                    ...prevWallets.slice(index + 1)
                ].filter(({ readyState: readyState })=>readyState !== (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Unsupported);
            });
        }
        adapters.forEach((adapter)=>adapter.on("readyStateChange", handleReadyStateChange, adapter));
        return ()=>{
            adapters.forEach((adapter)=>adapter.off("readyStateChange", handleReadyStateChange, adapter));
        };
    }, [
        adapter,
        adapters
    ]);
    const wallet = (0, $lx97N.useMemo)(()=>wallets.find((wallet)=>wallet.adapter === adapter) ?? null, [
        adapter,
        wallets
    ]);
    // Setup and teardown event listeners when the adapter changes
    (0, $lx97N.useEffect)(()=>{
        if (!adapter) return;
        const handleConnect = (publicKey)=>{
            setPublicKey(publicKey);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(true);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleDisconnect = ()=>{
            if (isUnloadingRef.current) return;
            setPublicKey(null);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(false);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleError = (error)=>{
            handleErrorRef.current(error, adapter);
        };
        adapter.on("connect", handleConnect);
        adapter.on("disconnect", handleDisconnect);
        adapter.on("error", handleError);
        return ()=>{
            adapter.off("connect", handleConnect);
            adapter.off("disconnect", handleDisconnect);
            adapter.off("error", handleError);
            handleDisconnect();
        };
    }, [
        adapter,
        isUnloadingRef
    ]);
    // When the adapter changes, clear the `autoConnect` tracking flag
    const didAttemptAutoConnectRef = (0, $lx97N.useRef)(false);
    (0, $lx97N.useEffect)(()=>{
        return ()=>{
            didAttemptAutoConnectRef.current = false;
        };
    }, [
        adapter
    ]);
    // If auto-connect is enabled, request to connect when the adapter changes and is ready
    (0, $lx97N.useEffect)(()=>{
        if (didAttemptAutoConnectRef.current || isConnectingRef.current || connected || !onAutoConnectRequest || !(wallet?.readyState === (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed || wallet?.readyState === (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Loadable)) return;
        isConnectingRef.current = true;
        setConnecting(true);
        didAttemptAutoConnectRef.current = true;
        (async function() {
            try {
                await onAutoConnectRequest();
            } catch  {
                onConnectError();
            // Drop the error. It will be caught by `handleError` anyway.
            } finally{
                setConnecting(false);
                isConnectingRef.current = false;
            }
        })();
    }, [
        connected,
        onAutoConnectRequest,
        onConnectError,
        wallet
    ]);
    // Send a transaction using the provided connection
    const sendTransaction = (0, $lx97N.useCallback)(async (transaction, connection, options)=>{
        if (!adapter) throw handleErrorRef.current(new (0, $5947c483a13261a8$export$3f5ccdf96415785c)());
        if (!connected) throw handleErrorRef.current(new (0, $51fd612dc03e2ca2$export$313d299817c74896)(), adapter);
        return await adapter.sendTransaction(transaction, connection, options);
    }, [
        adapter,
        connected
    ]);
    // Sign a transaction if the wallet supports it
    const signTransaction = (0, $lx97N.useMemo)(()=>adapter && "signTransaction" in adapter ? async (transaction)=>{
            if (!connected) throw handleErrorRef.current(new (0, $51fd612dc03e2ca2$export$313d299817c74896)(), adapter);
            return await adapter.signTransaction(transaction);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign multiple transactions if the wallet supports it
    const signAllTransactions = (0, $lx97N.useMemo)(()=>adapter && "signAllTransactions" in adapter ? async (transactions)=>{
            if (!connected) throw handleErrorRef.current(new (0, $51fd612dc03e2ca2$export$313d299817c74896)(), adapter);
            return await adapter.signAllTransactions(transactions);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign an arbitrary message if the wallet supports it
    const signMessage = (0, $lx97N.useMemo)(()=>adapter && "signMessage" in adapter ? async (message)=>{
            if (!connected) throw handleErrorRef.current(new (0, $51fd612dc03e2ca2$export$313d299817c74896)(), adapter);
            return await adapter.signMessage(message);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign in if the wallet supports it
    const signIn = (0, $lx97N.useMemo)(()=>adapter && "signIn" in adapter ? async (input)=>{
            return await adapter.signIn(input);
        } : undefined, [
        adapter
    ]);
    const handleConnect = (0, $lx97N.useCallback)(async ()=>{
        if (isConnectingRef.current || isDisconnectingRef.current || wallet?.adapter.connected) return;
        if (!wallet) throw handleErrorRef.current(new (0, $5947c483a13261a8$export$3f5ccdf96415785c)());
        const { adapter: adapter, readyState: readyState } = wallet;
        if (!(readyState === (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed || readyState === (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Loadable)) throw handleErrorRef.current(new (0, $51fd612dc03e2ca2$export$d65db264eda99cd7)(), adapter);
        isConnectingRef.current = true;
        setConnecting(true);
        try {
            await adapter.connect();
        } catch (e) {
            onConnectError();
            throw e;
        } finally{
            setConnecting(false);
            isConnectingRef.current = false;
        }
    }, [
        onConnectError,
        wallet
    ]);
    const handleDisconnect = (0, $lx97N.useCallback)(async ()=>{
        if (isDisconnectingRef.current) return;
        if (!adapter) return;
        isDisconnectingRef.current = true;
        setDisconnecting(true);
        try {
            await adapter.disconnect();
        } finally{
            setDisconnecting(false);
            isDisconnectingRef.current = false;
        }
    }, [
        adapter
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $502df6790791f964$export$19648c908dc8d0bf).Provider, {
        value: {
            autoConnect: !!onAutoConnectRequest,
            wallets: wallets,
            wallet: wallet,
            publicKey: publicKey,
            connected: connected,
            connecting: connecting,
            disconnecting: disconnecting,
            select: onSelectWallet,
            connect: handleConnect,
            disconnect: handleDisconnect,
            sendTransaction: sendTransaction,
            signTransaction: signTransaction,
            signAllTransactions: signAllTransactions,
            signMessage: signMessage,
            signIn: signIn
        }
    }, children);
}


let $489600bcf98bc41d$var$_userAgent;
function $489600bcf98bc41d$var$getUserAgent() {
    if ($489600bcf98bc41d$var$_userAgent === undefined) $489600bcf98bc41d$var$_userAgent = globalThis.navigator?.userAgent ?? null;
    return $489600bcf98bc41d$var$_userAgent;
}
function $489600bcf98bc41d$var$getIsMobile(adapters) {
    const userAgentString = $489600bcf98bc41d$var$getUserAgent();
    return (0, $bbeb07dc194d27bd$export$2e2bcd8739ae039)({
        adapters: adapters,
        userAgentString: userAgentString
    }) === (0, $bbeb07dc194d27bd$export$7dc6752a22ab011a).MOBILE_WEB;
}
function $489600bcf98bc41d$var$getUriForAppIdentity() {
    const location = globalThis.location;
    if (!location) return;
    return `${location.protocol}//${location.host}`;
}
function $489600bcf98bc41d$export$717b22fc3a2082b3({ children: children, wallets: adapters, autoConnect: autoConnect, localStorageKey: localStorageKey = "walletName", onError: onError }) {
    const { connection: connection } = (0, $a3e6306a29927194$export$985e8768c0e91dbc)();
    const adaptersWithStandardAdapters = (0, $e5096a497b5a50be$export$ca3bd81d254ceecf)(adapters);
    const mobileWalletAdapter = (0, $lx97N.useMemo)(()=>{
        if (!$489600bcf98bc41d$var$getIsMobile(adaptersWithStandardAdapters)) return null;
        const existingMobileWalletAdapter = adaptersWithStandardAdapters.find((adapter)=>adapter.name === (0, $dd84591a730a91e2$export$f1265e9082f346f1));
        if (existingMobileWalletAdapter) return existingMobileWalletAdapter;
        return new (0, $dd84591a730a91e2$export$dec251788b2f5a84)({
            addressSelector: (0, $dd84591a730a91e2$export$a299fb0acc11345b)(),
            appIdentity: {
                uri: $489600bcf98bc41d$var$getUriForAppIdentity()
            },
            authorizationResultCache: (0, $dd84591a730a91e2$export$4a0b597891770806)(),
            cluster: (0, $73b242ebecb52ef4$export$2e2bcd8739ae039)(connection?.rpcEndpoint),
            onWalletNotFound: (0, $dd84591a730a91e2$export$e8b9e70cdf783b70)()
        });
    }, [
        adaptersWithStandardAdapters,
        connection?.rpcEndpoint
    ]);
    const adaptersWithMobileWalletAdapter = (0, $lx97N.useMemo)(()=>{
        if (mobileWalletAdapter == null || adaptersWithStandardAdapters.indexOf(mobileWalletAdapter) !== -1) return adaptersWithStandardAdapters;
        return [
            mobileWalletAdapter,
            ...adaptersWithStandardAdapters
        ];
    }, [
        adaptersWithStandardAdapters,
        mobileWalletAdapter
    ]);
    const [walletName, setWalletName] = (0, $27088ae81f8abe4e$export$86e2cef2561044ac)(localStorageKey, $489600bcf98bc41d$var$getIsMobile(adaptersWithStandardAdapters) ? (0, $dd84591a730a91e2$export$f1265e9082f346f1) : null);
    const adapter = (0, $lx97N.useMemo)(()=>adaptersWithMobileWalletAdapter.find((a)=>a.name === walletName) ?? null, [
        adaptersWithMobileWalletAdapter,
        walletName
    ]);
    const changeWallet = (0, $lx97N.useCallback)((nextWalletName)=>{
        if (walletName === nextWalletName) return;
        if (adapter && // Selecting a wallet other than the mobile wallet adapter is not
        // sufficient reason to call `disconnect` on the mobile wallet adapter.
        // Calling `disconnect` on the mobile wallet adapter causes the entire
        // authorization store to be wiped.
        adapter.name !== (0, $dd84591a730a91e2$export$f1265e9082f346f1)) adapter.disconnect();
        setWalletName(nextWalletName);
    }, [
        adapter,
        setWalletName,
        walletName
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!adapter) return;
        function handleDisconnect() {
            if (isUnloadingRef.current) return;
            // Leave the adapter selected in the event of a disconnection.
            if (walletName === (0, $dd84591a730a91e2$export$f1265e9082f346f1) && $489600bcf98bc41d$var$getIsMobile(adaptersWithStandardAdapters)) return;
            setWalletName(null);
        }
        adapter.on("disconnect", handleDisconnect);
        return ()=>{
            adapter.off("disconnect", handleDisconnect);
        };
    }, [
        adapter,
        adaptersWithStandardAdapters,
        setWalletName,
        walletName
    ]);
    const hasUserSelectedAWallet = (0, $lx97N.useRef)(false);
    const handleAutoConnectRequest = (0, $lx97N.useMemo)(()=>{
        if (!autoConnect || !adapter) return;
        return async ()=>{
            // If autoConnect is true or returns true, use the default autoConnect behavior.
            if (autoConnect === true || await autoConnect(adapter)) {
                if (hasUserSelectedAWallet.current) await adapter.connect();
                else await adapter.autoConnect();
            }
        };
    }, [
        autoConnect,
        adapter
    ]);
    const isUnloadingRef = (0, $lx97N.useRef)(false);
    (0, $lx97N.useEffect)(()=>{
        if (walletName === (0, $dd84591a730a91e2$export$f1265e9082f346f1) && $489600bcf98bc41d$var$getIsMobile(adaptersWithStandardAdapters)) {
            isUnloadingRef.current = false;
            return;
        }
        function handleBeforeUnload() {
            isUnloadingRef.current = true;
        }
        /**
         * Some wallets fire disconnection events when the window unloads. Since there's no way to
         * distinguish between a disconnection event received because a user initiated it, and one
         * that was received because they've closed the window, we have to track window unload
         * events themselves. Downstream components use this information to decide whether to act
         * upon or drop wallet events and errors.
         */ window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        adaptersWithStandardAdapters,
        walletName
    ]);
    const handleConnectError = (0, $lx97N.useCallback)(()=>{
        if (adapter && adapter.name !== (0, $dd84591a730a91e2$export$f1265e9082f346f1)) // If any error happens while connecting, unset the adapter.
        changeWallet(null);
    }, [
        adapter,
        changeWallet
    ]);
    const selectWallet = (0, $lx97N.useCallback)((walletName)=>{
        hasUserSelectedAWallet.current = true;
        changeWallet(walletName);
    }, [
        changeWallet
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $6fdfd7e78a41b858$export$a50b3c99d691184b), {
        wallets: adaptersWithMobileWalletAdapter,
        adapter: adapter,
        isUnloadingRef: isUnloadingRef,
        onAutoConnectRequest: handleAutoConnectRequest,
        onConnectError: handleConnectError,
        onError: onError,
        onSelectWallet: selectWallet
    }, children);
}



var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
const $eb4e461898b251b4$var$DEFAULT_CONTEXT = {
    setVisible (_open) {
        console.error($eb4e461898b251b4$var$constructMissingProviderErrorMessage("call", "setVisible"));
    },
    visible: false
};
Object.defineProperty($eb4e461898b251b4$var$DEFAULT_CONTEXT, "visible", {
    get () {
        console.error($eb4e461898b251b4$var$constructMissingProviderErrorMessage("read", "visible"));
        return false;
    }
});
function $eb4e461898b251b4$var$constructMissingProviderErrorMessage(action, valueName) {
    return "You have tried to " + ` ${action} "${valueName}"` + " on a WalletModalContext without providing one." + " Make sure to render a WalletModalProvider" + " as an ancestor of the component that uses " + "WalletModalContext";
}
const $eb4e461898b251b4$export$8fa8c0fc3ea86e87 = (0, $lx97N.createContext)($eb4e461898b251b4$var$DEFAULT_CONTEXT);
function $eb4e461898b251b4$export$6fdf0454adae214b() {
    return (0, $lx97N.useContext)($eb4e461898b251b4$export$8fa8c0fc3ea86e87);
}





var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");
const $68a1f3c537faf5b0$export$78768a9af065a7b = ({ id: id, children: children, expanded: expanded = false })=>{
    const ref = (0, $lx97N.useRef)(null);
    const instant = (0, $lx97N.useRef)(true);
    const transition = "height 250ms ease-out";
    const openCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.scrollHeight + "px";
        });
    };
    const closeCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.offsetHeight + "px";
            node.style.overflow = "hidden";
            requestAnimationFrame(()=>{
                node.style.height = "0";
            });
        });
    };
    (0, $lx97N.useLayoutEffect)(()=>{
        if (expanded) openCollapse();
        else closeCollapse();
    }, [
        expanded
    ]);
    (0, $lx97N.useLayoutEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        function handleComplete() {
            if (!node) return;
            node.style.overflow = expanded ? "initial" : "hidden";
            if (expanded) node.style.height = "auto";
        }
        function handleTransitionEnd(event) {
            if (node && event.target === node && event.propertyName === "height") handleComplete();
        }
        if (instant.current) {
            handleComplete();
            instant.current = false;
        }
        node.addEventListener("transitionend", handleTransitionEnd);
        return ()=>node.removeEventListener("transitionend", handleTransitionEnd);
    }, [
        expanded
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("div", {
        className: "wallet-adapter-collapse",
        id: id,
        ref: ref,
        role: "region",
        style: {
            height: 0,
            transition: instant.current ? undefined : transition
        }
    }, children);
};




var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
const $b4923a4ce91c6ed6$export$353f5b6fc5456de1 = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("button", {
        className: `wallet-adapter-button ${props.className || ""}`,
        disabled: props.disabled,
        style: props.style,
        onClick: props.onClick,
        tabIndex: props.tabIndex || 0,
        type: "button"
    }, props.startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("i", {
        className: "wallet-adapter-button-start-icon"
    }, props.startIcon), props.children, props.endIcon && (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("i", {
        className: "wallet-adapter-button-end-icon"
    }, props.endIcon));
};



var $lx97N = parcelRequire("lx97N");
const $c8ce9fd445050de5$export$deff84e7338ee5a5 = ({ wallet: wallet, ...props })=>{
    return wallet && (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("img", {
        src: wallet.adapter.icon,
        alt: `${wallet.adapter.name} icon`,
        ...props
    });
};


const $8336adbf0be70650$export$b6b33106605f17bb = ({ handleClick: handleClick, tabIndex: tabIndex, wallet: wallet })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $b4923a4ce91c6ed6$export$353f5b6fc5456de1), {
        onClick: handleClick,
        startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $c8ce9fd445050de5$export$deff84e7338ee5a5), {
            wallet: wallet
        }),
        tabIndex: tabIndex
    }, wallet.adapter.name, wallet.readyState === (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed && (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("span", null, "Detected")));
};



var $lx97N = parcelRequire("lx97N");
const $fba2d571589d8601$export$d822b842d2dccc19 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("svg", {
        width: "97",
        height: "96",
        viewBox: "0 0 97 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "48",
        fill: "url(#paint0_linear_880_5115)",
        fillOpacity: "0.1"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "47",
        stroke: "url(#paint1_linear_880_5115)",
        strokeOpacity: "0.4",
        strokeWidth: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("g", {
        clipPath: "url(#clip0_880_5115)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("path", {
        d: "M65.5769 28.1523H31.4231C27.6057 28.1523 24.5 31.258 24.5 35.0754V60.9215C24.5 64.7389 27.6057 67.8446 31.4231 67.8446H65.5769C69.3943 67.8446 72.5 64.7389 72.5 60.9215V35.0754C72.5 31.258 69.3943 28.1523 65.5769 28.1523ZM69.7308 52.1523H59.5769C57.2865 52.1523 55.4231 50.289 55.4231 47.9985C55.4231 45.708 57.2864 43.8446 59.5769 43.8446H69.7308V52.1523ZM69.7308 41.0754H59.5769C55.7595 41.0754 52.6539 44.1811 52.6539 47.9985C52.6539 51.8159 55.7595 54.9215 59.5769 54.9215H69.7308V60.9215C69.7308 63.2119 67.8674 65.0754 65.5769 65.0754H31.4231C29.1327 65.0754 27.2692 63.212 27.2692 60.9215V35.0754C27.2692 32.785 29.1326 30.9215 31.4231 30.9215H65.5769C67.8673 30.9215 69.7308 32.7849 69.7308 35.0754V41.0754Z",
        fill: "url(#paint2_linear_880_5115)"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("path", {
        d: "M61.4231 46.6172H59.577C58.8123 46.6172 58.1924 47.2371 58.1924 48.0018C58.1924 48.7665 58.8123 49.3863 59.577 49.3863H61.4231C62.1878 49.3863 62.8077 48.7664 62.8077 48.0018C62.8077 47.2371 62.1878 46.6172 61.4231 46.6172Z",
        fill: "url(#paint3_linear_880_5115)"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("linearGradient", {
        id: "paint0_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("linearGradient", {
        id: "paint1_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("linearGradient", {
        id: "paint2_linear_880_5115",
        x1: "25.9583",
        y1: "68.7101",
        x2: "67.2337",
        y2: "23.7879",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("linearGradient", {
        id: "paint3_linear_880_5115",
        x1: "58.3326",
        y1: "49.4467",
        x2: "61.0002",
        y2: "45.4453",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("clipPath", {
        id: "clip0_880_5115"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("rect", {
        width: "48",
        height: "48",
        fill: "white",
        transform: "translate(24.5 24)"
    }))));
};



const $d9f5fc1df43bc440$export$851b8e4aa786e6a1 = ({ className: className = "", container: container = "body" })=>{
    const ref = (0, $lx97N.useRef)(null);
    const { wallets: wallets, select: select } = (0, $502df6790791f964$export$c34addee860b0acb)();
    const { setVisible: setVisible } = (0, $eb4e461898b251b4$export$6fdf0454adae214b)();
    const [expanded, setExpanded] = (0, $lx97N.useState)(false);
    const [fadeIn, setFadeIn] = (0, $lx97N.useState)(false);
    const [portal, setPortal] = (0, $lx97N.useState)(null);
    const [listedWallets, collapsedWallets] = (0, $lx97N.useMemo)(()=>{
        const installed = [];
        const notInstalled = [];
        for (const wallet of wallets)if (wallet.readyState === (0, $bfe62661f5b3c85b$export$2a7b8071105d05b6).Installed) installed.push(wallet);
        else notInstalled.push(wallet);
        return installed.length ? [
            installed,
            notInstalled
        ] : [
            notInstalled,
            []
        ];
    }, [
        wallets
    ]);
    const hideModal = (0, $lx97N.useCallback)(()=>{
        setFadeIn(false);
        setTimeout(()=>setVisible(false), 150);
    }, [
        setVisible
    ]);
    const handleClose = (0, $lx97N.useCallback)((event)=>{
        event.preventDefault();
        hideModal();
    }, [
        hideModal
    ]);
    const handleWalletClick = (0, $lx97N.useCallback)((event, walletName)=>{
        select(walletName);
        handleClose(event);
    }, [
        select,
        handleClose
    ]);
    const handleCollapseClick = (0, $lx97N.useCallback)(()=>setExpanded(!expanded), [
        expanded
    ]);
    const handleTabKey = (0, $lx97N.useCallback)((event)=>{
        const node = ref.current;
        if (!node) return;
        // here we query all focusable elements
        const focusableElements = node.querySelectorAll("button");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstElement = focusableElements[0];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) // if going backward by pressing tab and firstElement is active, shift focus to last focusable element
        {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
        } else // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
        if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
        }
    }, [
        ref
    ]);
    (0, $lx97N.useLayoutEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") hideModal();
            else if (event.key === "Tab") handleTabKey(event);
        };
        // Get original overflow
        const { overflow: overflow } = window.getComputedStyle(document.body);
        // Hack to enable fade in animation after mount
        setTimeout(()=>setFadeIn(true), 0);
        // Prevent scrolling on mount
        document.body.style.overflow = "hidden";
        // Listen for keydown events
        window.addEventListener("keydown", handleKeyDown, false);
        return ()=>{
            // Re-enable scrolling when component unmounts
            document.body.style.overflow = overflow;
            window.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        hideModal,
        handleTabKey
    ]);
    (0, $lx97N.useLayoutEffect)(()=>setPortal(document.querySelector(container)), [
        container
    ]);
    return portal && (0, $0d985e384f32d040$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("div", {
        "aria-labelledby": "wallet-adapter-modal-title",
        "aria-modal": "true",
        className: `wallet-adapter-modal ${fadeIn && "wallet-adapter-modal-fade-in"} ${className}`,
        ref: ref,
        role: "dialog"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("div", {
        className: "wallet-adapter-modal-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("div", {
        className: "wallet-adapter-modal-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("button", {
        onClick: handleClose,
        className: "wallet-adapter-modal-button-close"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("svg", {
        width: "14",
        height: "14"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("path", {
        d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
    }))), listedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "Connect a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, listedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $8336adbf0be70650$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            wallet: wallet
        })), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $68a1f3c537faf5b0$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $8336adbf0be70650$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))) : null), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("span", null, expanded ? "Less " : "More ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))) : null) : (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "You'll need a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("div", {
        className: "wallet-adapter-modal-middle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $fba2d571589d8601$export$d822b842d2dccc19), null)), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("span", null, expanded ? "Hide " : "Already have a wallet? View ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $68a1f3c537faf5b0$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $8336adbf0be70650$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))))) : null))), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("div", {
        className: "wallet-adapter-modal-overlay",
        onMouseDown: handleClose
    })), portal);
};


const $d2cea7b421ec30ee$export$43bb60413a8a3ee6 = ({ children: children, ...props })=>{
    const [visible, setVisible] = (0, $lx97N.useState)(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $eb4e461898b251b4$export$8fa8c0fc3ea86e87).Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        }
    }, children, visible && (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $d9f5fc1df43bc440$export$851b8e4aa786e6a1), {
        ...props
    }));
};



var $1biTx = parcelRequire("1biTx");

var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");
function $4a9a6188e77c1124$export$629f18756d2627db({ onSelectWallet: onSelectWallet }) {
    const { connect: connect, connected: connected, connecting: connecting, disconnect: disconnect, disconnecting: disconnecting, publicKey: publicKey, select: select, wallet: wallet, wallets: wallets } = (0, $502df6790791f964$export$c34addee860b0acb)();
    let buttonState;
    if (connecting) buttonState = "connecting";
    else if (connected) buttonState = "connected";
    else if (disconnecting) buttonState = "disconnecting";
    else if (wallet) buttonState = "has-wallet";
    else buttonState = "no-wallet";
    const handleConnect = (0, $lx97N.useCallback)(()=>{
        connect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        connect
    ]);
    const handleDisconnect = (0, $lx97N.useCallback)(()=>{
        disconnect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        disconnect
    ]);
    const handleSelectWallet = (0, $lx97N.useCallback)(()=>{
        onSelectWallet({
            onSelectWallet: select,
            wallets: wallets
        });
    }, [
        onSelectWallet,
        select,
        wallets
    ]);
    return {
        buttonState: buttonState,
        onConnect: buttonState === "has-wallet" ? handleConnect : undefined,
        onDisconnect: buttonState !== "disconnecting" && buttonState !== "no-wallet" ? handleDisconnect : undefined,
        onSelectWallet: handleSelectWallet,
        publicKey: publicKey ?? undefined,
        walletIcon: wallet?.adapter.icon,
        walletName: wallet?.adapter.name
    };
}



var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");


function $40329511175cebe9$export$a0d4a8038508425f({ walletIcon: walletIcon, walletName: walletName, ...props }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $b4923a4ce91c6ed6$export$353f5b6fc5456de1), {
        ...props,
        className: "wallet-adapter-button-trigger",
        startIcon: walletIcon && walletName ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $c8ce9fd445050de5$export$deff84e7338ee5a5), {
            wallet: {
                adapter: {
                    icon: walletIcon,
                    name: walletName
                }
            }
        }) : undefined
    });
}



function $e36ca796d79b6f3d$export$50382f20865178f9({ children: children, labels: labels, ...props }) {
    const { setVisible: setModalVisible } = (0, $eb4e461898b251b4$export$6fdf0454adae214b)();
    const { buttonState: buttonState, onConnect: onConnect, onDisconnect: onDisconnect, publicKey: publicKey, walletIcon: walletIcon, walletName: walletName } = (0, $4a9a6188e77c1124$export$629f18756d2627db)({
        onSelectWallet () {
            setModalVisible(true);
        }
    });
    const [copied, setCopied] = (0, $lx97N.useState)(false);
    const [menuOpen, setMenuOpen] = (0, $lx97N.useState)(false);
    const ref = (0, $lx97N.useRef)(null);
    (0, $lx97N.useEffect)(()=>{
        const listener = (event)=>{
            const node = ref.current;
            // Do nothing if clicking dropdown or its descendants
            if (!node || node.contains(event.target)) return;
            setMenuOpen(false);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, []);
    const content = (0, $lx97N.useMemo)(()=>{
        if (children) return children;
        else if (publicKey) {
            const base58 = publicKey.toBase58();
            return base58.slice(0, 4) + ".." + base58.slice(-4);
        } else if (buttonState === "connecting" || buttonState === "has-wallet") return labels[buttonState];
        else return labels["no-wallet"];
    }, [
        buttonState,
        children,
        labels,
        publicKey
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("div", {
        className: "wallet-adapter-dropdown"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $40329511175cebe9$export$a0d4a8038508425f), {
        ...props,
        "aria-expanded": menuOpen,
        style: {
            pointerEvents: menuOpen ? "none" : "auto",
            ...props.style
        },
        onClick: ()=>{
            switch(buttonState){
                case "no-wallet":
                    setModalVisible(true);
                    break;
                case "has-wallet":
                    if (onConnect) onConnect();
                    break;
                case "connected":
                    setMenuOpen(true);
                    break;
            }
        },
        walletIcon: walletIcon,
        walletName: walletName
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("ul", {
        "aria-label": "dropdown-list",
        className: `wallet-adapter-dropdown-list ${menuOpen && "wallet-adapter-dropdown-list-active"}`,
        ref: ref,
        role: "menu"
    }, publicKey ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: async ()=>{
            await navigator.clipboard.writeText(publicKey.toBase58());
            setCopied(true);
            setTimeout(()=>setCopied(false), 400);
        },
        role: "menuitem"
    }, copied ? labels["copied"] : labels["copy-address"]) : null, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            setModalVisible(true);
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["change-wallet"]), onDisconnect ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            onDisconnect();
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["disconnect"]) : null));
}


const $a1d44d7a0b3f9c7f$var$LABELS = {
    "change-wallet": "Change wallet",
    connecting: "Connecting ...",
    "copy-address": "Copy address",
    copied: "Copied",
    disconnect: "Disconnect",
    "has-wallet": "Connect",
    "no-wallet": "Select Wallet"
};
function $a1d44d7a0b3f9c7f$export$968d144f04194cbb(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $e36ca796d79b6f3d$export$50382f20865178f9), {
        ...props,
        labels: $a1d44d7a0b3f9c7f$var$LABELS
    });
}



var $lx97N = parcelRequire("lx97N");

var $1biTx = parcelRequire("1biTx");
var $337f2e695a94146d$exports = {};
"use strict";
var $4f928f2417f4cefa$exports = {};
"use strict";
var $4f928f2417f4cefa$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $4f928f2417f4cefa$var$createStore = function createStore(createState) {
    return createState ? $4f928f2417f4cefa$var$createStoreImpl(createState) : $4f928f2417f4cefa$var$createStoreImpl;
};
var $4f928f2417f4cefa$var$vanilla = function(createState) {
    return $4f928f2417f4cefa$var$createStore(createState);
};
$4f928f2417f4cefa$exports.createStore = $4f928f2417f4cefa$var$createStore;
$4f928f2417f4cefa$exports.default = $4f928f2417f4cefa$var$vanilla;
$4f928f2417f4cefa$exports = $4f928f2417f4cefa$var$vanilla;
$4f928f2417f4cefa$exports.createStore = $4f928f2417f4cefa$var$createStore;
$4f928f2417f4cefa$exports.default = $4f928f2417f4cefa$exports;



var $lx97N = parcelRequire("lx97N");
var $c4dafd72321b6a5d$exports = {};
"use strict";

$c4dafd72321b6a5d$exports = (parcelRequire("dFMVQ"));


var $337f2e695a94146d$var$useDebugValue = $lx97N.useDebugValue;
var $337f2e695a94146d$var$useSyncExternalStoreWithSelector = $c4dafd72321b6a5d$exports.useSyncExternalStoreWithSelector;
var $337f2e695a94146d$var$didWarnAboutEqualityFn = false;
var $337f2e695a94146d$var$identity = function identity(arg) {
    return arg;
};
function $337f2e695a94146d$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $337f2e695a94146d$var$identity;
    var slice = $337f2e695a94146d$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $337f2e695a94146d$var$useDebugValue(slice);
    return slice;
}
var $337f2e695a94146d$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $4f928f2417f4cefa$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $337f2e695a94146d$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $337f2e695a94146d$var$create = function create(createState) {
    return createState ? $337f2e695a94146d$var$createImpl(createState) : $337f2e695a94146d$var$createImpl;
};
var $337f2e695a94146d$var$react = function(createState) {
    return $337f2e695a94146d$var$create(createState);
};
$337f2e695a94146d$exports.create = $337f2e695a94146d$var$create;
$337f2e695a94146d$exports.default = $337f2e695a94146d$var$react;
$337f2e695a94146d$exports.useStore = $337f2e695a94146d$var$useStore;
Object.keys($4f928f2417f4cefa$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($337f2e695a94146d$exports, k)) Object.defineProperty($337f2e695a94146d$exports, k, {
        enumerable: true,
        get: function() {
            return $4f928f2417f4cefa$exports[k];
        }
    });
});
$337f2e695a94146d$exports = $337f2e695a94146d$var$react;
$337f2e695a94146d$exports.create = $337f2e695a94146d$var$create;
$337f2e695a94146d$exports.useStore = $337f2e695a94146d$var$useStore;
$337f2e695a94146d$exports.createStore = $4f928f2417f4cefa$exports.createStore;
$337f2e695a94146d$exports.default = $337f2e695a94146d$exports;



var $1biTx = parcelRequire("1biTx");
var $4ef002f6edd8664f$exports = {};

$4ef002f6edd8664f$exports = (parcelRequire("xtbW9"));



var $1biTx = parcelRequire("1biTx");
/* eslint-env browser */ /* global globalThis:readonly */ var $706e146b56b5f535$export$5091bdda49ba90f5;
var $706e146b56b5f535$export$bced8d2aada2d1c9;
var $706e146b56b5f535$export$612d47d55dedde45;
var $706e146b56b5f535$export$a888d2532e6dc7bb;
"use strict";
// Ponyfill for `globalThis`
const $706e146b56b5f535$var$_globalThis = (()=>{
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    /* istanbul ignore next */ if (typeof window !== "undefined") return window;
    /* istanbul ignore next */ if (typeof $parcel$global !== "undefined") return $parcel$global;
})();
const $706e146b56b5f535$var$bufferToHex = (buffer)=>{
    const view = new DataView(buffer);
    let hexCodes = "";
    for(let i = 0; i < view.byteLength; i += 4)hexCodes += view.getUint32(i).toString(16).padStart(8, "0");
    return hexCodes;
};
const $706e146b56b5f535$var$create = (algorithm)=>async (buffer, options)=>{
        if (typeof buffer === "string") buffer = new $706e146b56b5f535$var$_globalThis.TextEncoder().encode(buffer);
        options = {
            outputFormat: "hex",
            ...options
        };
        const hash = await $706e146b56b5f535$var$_globalThis.crypto.subtle.digest(algorithm, buffer);
        return options.outputFormat === "hex" ? $706e146b56b5f535$var$bufferToHex(hash) : hash;
    };
$706e146b56b5f535$export$5091bdda49ba90f5 = $706e146b56b5f535$var$create("SHA-1");
$706e146b56b5f535$export$bced8d2aada2d1c9 = $706e146b56b5f535$var$create("SHA-256");
$706e146b56b5f535$export$612d47d55dedde45 = $706e146b56b5f535$var$create("SHA-384");
$706e146b56b5f535$export$a888d2532e6dc7bb = $706e146b56b5f535$var$create("SHA-512");



var $cbQCu = parcelRequire("cbQCu");

var $febfi = parcelRequire("febfi");

var $d1ogx = parcelRequire("d1ogx");

var $1jULY = parcelRequire("1jULY");

var $cj5EG = parcelRequire("cj5EG");
var $f911d10793ebf039$exports = {};
"use strict";
var $f911d10793ebf039$var$__createBinding = $f911d10793ebf039$exports && $f911d10793ebf039$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f911d10793ebf039$var$__exportStar = $f911d10793ebf039$exports && $f911d10793ebf039$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f911d10793ebf039$var$__createBinding(exports1, m, p);
};
Object.defineProperty($f911d10793ebf039$exports, "__esModule", {
    value: true
});

$f911d10793ebf039$var$__exportStar((parcelRequire("48E4N")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("nvS42")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("7Qbh5")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("8H1TJ")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("kx8en")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("hwUZp")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("izg5s")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("8VTmC")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("b0RIK")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("iqXi3")), $f911d10793ebf039$exports);

$f911d10793ebf039$var$__exportStar((parcelRequire("ce6nE")), $f911d10793ebf039$exports);



var $cAjX2 = parcelRequire("cAjX2");

var $fRiXQ = parcelRequire("fRiXQ");

var $cbQCu = parcelRequire("cbQCu");
var $73ba2eb78746f6af$require$Buffer = $cbQCu.Buffer;
var $73ba2eb78746f6af$export$b733e092f9f44b2c;
(function(Currency) {
    Currency["USD"] = "usd";
    Currency["EUR"] = "eur";
    Currency["AR"] = "ar";
    Currency["SOL"] = "sol";
})($73ba2eb78746f6af$export$b733e092f9f44b2c || ($73ba2eb78746f6af$export$b733e092f9f44b2c = {}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $73ba2eb78746f6af$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
class $73ba2eb78746f6af$export$c19716cf6300c196 {
    static translateCurrency(currency) {
        switch(currency){
            case $73ba2eb78746f6af$export$b733e092f9f44b2c.AR:
                return "arweave";
            case $73ba2eb78746f6af$export$b733e092f9f44b2c.SOL:
                return "solana";
            case $73ba2eb78746f6af$export$b733e092f9f44b2c.USD:
                return "usd";
            case $73ba2eb78746f6af$export$b733e092f9f44b2c.EUR:
                return "eur";
            default:
                throw new Error("Invalid currency supplied to Coingecko conversion rate provider");
        }
    }
    getRate(from, to) {
        return $73ba2eb78746f6af$var$__awaiter(this, void 0, void 0, function*() {
            const fromArray = typeof from === "string" ? [
                from
            ] : from;
            const toArray = typeof to === "string" ? [
                to
            ] : to;
            const fromIds = fromArray.map((currency)=>$73ba2eb78746f6af$export$c19716cf6300c196.translateCurrency(currency)).join(",");
            const toIds = toArray.map((currency)=>$73ba2eb78746f6af$export$c19716cf6300c196.translateCurrency(currency)).join(",");
            const url = `https://api.coingecko.com/api/v3/simple/price?ids=${fromIds}&vs_currencies=${toIds}`;
            const response = yield (0, (/*@__PURE__*/$parcel$interopDefault($4ef002f6edd8664f$exports)))(url);
            const data = yield response.data;
            return fromArray.reduce((previousPairs, fromCurrency)=>{
                return [
                    ...previousPairs,
                    ...toArray.map((toCurrency)=>({
                            from: fromCurrency,
                            to: toCurrency,
                            rate: data[$73ba2eb78746f6af$export$c19716cf6300c196.translateCurrency(fromCurrency)][$73ba2eb78746f6af$export$c19716cf6300c196.translateCurrency(toCurrency)]
                        }))
                ];
            }, []);
        });
    }
}
/* eslint-env browser */ var $73ba2eb78746f6af$var$browser = typeof self == "object" ? self.FormData : window.FormData;
const $73ba2eb78746f6af$var$ARWEAVE_URL = "https://arweave.net";
const $73ba2eb78746f6af$var$LAMPORT_MULTIPLIER = Math.pow(10, 9);
const $73ba2eb78746f6af$var$WINSTON_MULTIPLIER = Math.pow(10, 12);
class $73ba2eb78746f6af$export$f2a2ab86e3cc4ee8 {
    constructor({ endpoint: endpoint, env: env }){
        this.endpoint = endpoint;
        this.env = env;
    }
    getAssetCostToStore(files, arweaveRate, solanaRate) {
        return $73ba2eb78746f6af$var$__awaiter(this, void 0, void 0, function*() {
            const buffers = Array.from(files.values());
            const totalBytes = buffers.reduce((sum, f)=>sum += f.byteLength, 0);
            const txnFeeInWinstons = parseInt((yield (yield (0, (/*@__PURE__*/$parcel$interopDefault($4ef002f6edd8664f$exports)))(`${$73ba2eb78746f6af$var$ARWEAVE_URL}/price/0`)).data));
            const byteCostInWinstons = parseInt((yield (yield (0, (/*@__PURE__*/$parcel$interopDefault($4ef002f6edd8664f$exports)))(`${$73ba2eb78746f6af$var$ARWEAVE_URL}/price/${totalBytes.toString()}`)).data));
            const totalArCost = (txnFeeInWinstons * buffers.length + byteCostInWinstons) / $73ba2eb78746f6af$var$WINSTON_MULTIPLIER;
            const arMultiplier = arweaveRate / solanaRate;
            return $73ba2eb78746f6af$var$LAMPORT_MULTIPLIER * totalArCost * arMultiplier * 1.1;
        });
    }
    upload(files, mintKey, txid) {
        return $73ba2eb78746f6af$var$__awaiter(this, void 0, void 0, function*() {
            const fileEntries = Array.from(files.entries());
            const tags = fileEntries.reduce((acc, [fileName])=>{
                acc[fileName] = [
                    {
                        name: "mint",
                        value: mintKey
                    }
                ];
                return acc;
            }, {});
            const body = new $73ba2eb78746f6af$var$browser();
            body.append("tags", JSON.stringify(tags));
            body.append("transaction", txid);
            body.append("env", this.env);
            fileEntries.map(([, file])=>{
                body.append("file[]", file);
            });
            const response = yield (0, (/*@__PURE__*/$parcel$interopDefault($4ef002f6edd8664f$exports))).post(this.endpoint, body);
            if (response.data.error) return Promise.reject(new Error(response.data.error));
            return response.data;
        });
    }
}
class $73ba2eb78746f6af$var$Storage {
}
var $73ba2eb78746f6af$export$ddcffe0146c8f882 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Storage: $73ba2eb78746f6af$var$Storage
});
var $73ba2eb78746f6af$export$c06e1e7429de6283;
(function(ChainId) {
    ChainId[ChainId["MainnetBeta"] = 101] = "MainnetBeta";
    ChainId[ChainId["Testnet"] = 102] = "Testnet";
    ChainId[ChainId["Devnet"] = 103] = "Devnet";
})($73ba2eb78746f6af$export$c06e1e7429de6283 || ($73ba2eb78746f6af$export$c06e1e7429de6283 = {}));
const $73ba2eb78746f6af$export$83401e34d5e11bf4 = {
    devnet: {
        endpoint: (0, $1biTx.clusterApiUrl)("devnet"),
        ChainId: $73ba2eb78746f6af$export$c06e1e7429de6283.Devnet
    },
    "mainnet-beta": {
        endpoint: "https://api.metaplex.solana.com/",
        ChainId: $73ba2eb78746f6af$export$c06e1e7429de6283.MainnetBeta
    },
    "mainnet-beta (Solana)": {
        endpoint: "https://api.mainnet-beta.solana.com",
        ChainId: $73ba2eb78746f6af$export$c06e1e7429de6283.MainnetBeta
    },
    "mainnet-beta (Serum)": {
        endpoint: "https://solana-api.projectserum.com/",
        ChainId: $73ba2eb78746f6af$export$c06e1e7429de6283.MainnetBeta
    },
    testnet: {
        endpoint: (0, $1biTx.clusterApiUrl)("testnet"),
        ChainId: $73ba2eb78746f6af$export$c06e1e7429de6283.Testnet
    }
};
class $73ba2eb78746f6af$export$98b66c25bb38499d extends (0, $1biTx.Connection) {
    constructor(endpoint = "mainnet-beta", commitment){
        if (endpoint in $73ba2eb78746f6af$export$83401e34d5e11bf4) endpoint = $73ba2eb78746f6af$export$83401e34d5e11bf4[endpoint].endpoint;
        super(endpoint, commitment);
    }
}
class $73ba2eb78746f6af$export$451984536ab0b3bc {
    constructor(payer){
        this.payer = payer;
    }
    signTransaction(tx) {
        return $73ba2eb78746f6af$var$__awaiter(this, void 0, void 0, function*() {
            tx.partialSign(this.payer);
            return tx;
        });
    }
    signAllTransactions(txs) {
        return $73ba2eb78746f6af$var$__awaiter(this, void 0, void 0, function*() {
            return txs.map((tx)=>{
                tx.partialSign(this.payer);
                return tx;
            });
        });
    }
    get publicKey() {
        return this.payer.publicKey;
    }
}
const $73ba2eb78746f6af$var$getFileHash = (file)=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        return (0, $cbQCu.Buffer).from((yield (0, $706e146b56b5f535$export$bced8d2aada2d1c9)(file.toString())));
    });
var $73ba2eb78746f6af$var$crypto = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getFileHash: $73ba2eb78746f6af$var$getFileHash
});
const $73ba2eb78746f6af$var$lookup = (url)=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            const { data: data } = yield (0, (/*@__PURE__*/$parcel$interopDefault($4ef002f6edd8664f$exports))).get(url);
            return data;
        } catch (_a) {
            throw new Error(`unable to get metadata json from url ${url}`);
        }
    });
var $73ba2eb78746f6af$var$metadata = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    lookup: $73ba2eb78746f6af$var$lookup
});
var $73ba2eb78746f6af$export$eab97d15b1788b8d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Crypto: $73ba2eb78746f6af$var$crypto,
    metadata: $73ba2eb78746f6af$var$metadata
});
class $73ba2eb78746f6af$var$PayForFiles extends (0, $1jULY.Transaction) {
    constructor(options, params){
        const { feePayer: feePayer } = options;
        const { lamports: lamports, fileHashes: fileHashes, arweaveWallet: arweaveWallet } = params;
        super(options);
        this.add((0, $1biTx.SystemProgram).transfer({
            fromPubkey: feePayer,
            toPubkey: arweaveWallet !== null && arweaveWallet !== void 0 ? arweaveWallet : new (0, $1biTx.PublicKey)((0, $1jULY.config).arweaveWallet),
            lamports: lamports
        }));
        fileHashes.forEach((data)=>{
            this.add(new (0, $1biTx.TransactionInstruction)({
                keys: [],
                programId: new (0, $1biTx.PublicKey)((0, $1jULY.config).programs.memo),
                data: data
            }));
        });
    }
}
class $73ba2eb78746f6af$var$CreateMint extends (0, $1jULY.Transaction) {
    constructor(options, params){
        const { feePayer: feePayer } = options;
        const { newAccountPubkey: newAccountPubkey, lamports: lamports, decimals: decimals, owner: owner, freezeAuthority: freezeAuthority } = params;
        super(options);
        this.add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: feePayer,
            newAccountPubkey: newAccountPubkey,
            lamports: lamports,
            space: (0, $febfi.MintLayout).span,
            programId: (0, $febfi.TOKEN_PROGRAM_ID)
        }));
        this.add((0, $febfi.Token).createInitMintInstruction((0, $febfi.TOKEN_PROGRAM_ID), newAccountPubkey, decimals !== null && decimals !== void 0 ? decimals : 0, owner !== null && owner !== void 0 ? owner : feePayer, freezeAuthority !== null && freezeAuthority !== void 0 ? freezeAuthority : feePayer));
    }
}
class $73ba2eb78746f6af$var$CreateTokenAccount extends (0, $1jULY.Transaction) {
    constructor(options, params){
        const { feePayer: feePayer } = options;
        const { newAccountPubkey: newAccountPubkey, lamports: lamports, mint: mint, owner: owner } = params;
        super(options);
        this.add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: feePayer,
            newAccountPubkey: newAccountPubkey,
            lamports: lamports,
            space: (0, $febfi.AccountLayout).span,
            programId: (0, $febfi.TOKEN_PROGRAM_ID)
        }));
        this.add((0, $febfi.Token).createInitAccountInstruction((0, $febfi.TOKEN_PROGRAM_ID), mint, newAccountPubkey, owner !== null && owner !== void 0 ? owner : feePayer));
    }
}
class $73ba2eb78746f6af$var$CreateAssociatedTokenAccount extends (0, $1jULY.Transaction) {
    constructor(options, params){
        const { feePayer: feePayer } = options;
        const { associatedTokenAddress: associatedTokenAddress, walletAddress: walletAddress, splTokenMintAddress: splTokenMintAddress } = params;
        super(options);
        this.add(new (0, $1biTx.TransactionInstruction)({
            keys: [
                {
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: associatedTokenAddress,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: walletAddress !== null && walletAddress !== void 0 ? walletAddress : feePayer,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: splTokenMintAddress,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: (0, $1biTx.SystemProgram).programId,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: (0, $febfi.TOKEN_PROGRAM_ID),
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: (0, $1biTx.SYSVAR_RENT_PUBKEY),
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: (0, $febfi.ASSOCIATED_TOKEN_PROGRAM_ID),
            data: (0, $cbQCu.Buffer).from([])
        }));
    }
}
class $73ba2eb78746f6af$var$MintTo extends (0, $1jULY.Transaction) {
    constructor(options, params){
        const { feePayer: feePayer } = options;
        const { mint: mint, dest: dest, authority: authority, amount: amount } = params;
        super(options);
        this.add((0, $febfi.Token).createMintToInstruction((0, $febfi.TOKEN_PROGRAM_ID), mint, dest, authority !== null && authority !== void 0 ? authority : feePayer, [], new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(amount).toNumber()));
    }
}
var $73ba2eb78746f6af$export$3371c32cd402472f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    PayForFiles: $73ba2eb78746f6af$var$PayForFiles,
    CreateMint: $73ba2eb78746f6af$var$CreateMint,
    CreateTokenAccount: $73ba2eb78746f6af$var$CreateTokenAccount,
    CreateAssociatedTokenAccount: $73ba2eb78746f6af$var$CreateAssociatedTokenAccount,
    MintTo: $73ba2eb78746f6af$var$MintTo
});
function $73ba2eb78746f6af$var$prepareTokenAccountAndMintTxs(connection, owner) {
    return $73ba2eb78746f6af$var$__awaiter(this, void 0, void 0, function*() {
        const mint = (0, $1biTx.Keypair).generate();
        const mintRent = yield connection.getMinimumBalanceForRentExemption((0, $febfi.MintLayout).span);
        const createMintTx = new $73ba2eb78746f6af$var$CreateMint({
            feePayer: owner
        }, {
            newAccountPubkey: mint.publicKey,
            lamports: mintRent
        });
        const recipient = yield (0, $febfi.Token).getAssociatedTokenAddress((0, $febfi.ASSOCIATED_TOKEN_PROGRAM_ID), (0, $febfi.TOKEN_PROGRAM_ID), mint.publicKey, owner);
        const createAssociatedTokenAccountTx = new $73ba2eb78746f6af$var$CreateAssociatedTokenAccount({
            feePayer: owner
        }, {
            associatedTokenAddress: recipient,
            splTokenMintAddress: mint.publicKey
        });
        const mintToTx = new $73ba2eb78746f6af$var$MintTo({
            feePayer: owner
        }, {
            mint: mint.publicKey,
            dest: recipient,
            amount: 1
        });
        return {
            mint: mint,
            createMintTx: createMintTx,
            createAssociatedTokenAccountTx: createAssociatedTokenAccountTx,
            mintToTx: mintToTx,
            recipient: recipient
        };
    });
}
function $73ba2eb78746f6af$var$createWrappedAccountTxs(connection, owner, amount = 0) {
    return $73ba2eb78746f6af$var$__awaiter(this, void 0, void 0, function*() {
        const account = (0, $1biTx.Keypair).generate();
        const accountRentExempt = yield connection.getMinimumBalanceForRentExemption((0, $febfi.AccountLayout).span);
        const createTokenAccountTx = new $73ba2eb78746f6af$var$CreateTokenAccount({
            feePayer: owner
        }, {
            newAccountPubkey: account.publicKey,
            lamports: amount + accountRentExempt,
            mint: (0, $febfi.NATIVE_MINT)
        });
        const closeTokenAccountTx = new (0, $1jULY.Transaction)().add((0, $febfi.Token).createCloseAccountInstruction((0, $febfi.TOKEN_PROGRAM_ID), account.publicKey, owner, owner, []));
        return {
            account: account,
            createTokenAccountTx: createTokenAccountTx,
            closeTokenAccountTx: closeTokenAccountTx
        };
    });
}
function $73ba2eb78746f6af$var$createApproveTxs(args) {
    const { authority: authority = (0, $1biTx.Keypair).generate(), account: account, owner: owner, amount: amount } = args;
    const createApproveTx = new (0, $1biTx.Transaction)().add((0, $febfi.Token).createApproveInstruction((0, $febfi.TOKEN_PROGRAM_ID), account, authority.publicKey, owner, [], amount));
    const createRevokeTx = new (0, $1biTx.Transaction)().add((0, $febfi.Token).createRevokeInstruction((0, $febfi.TOKEN_PROGRAM_ID), account, owner, []));
    return {
        authority: authority,
        createApproveTx: createApproveTx,
        createRevokeTx: createRevokeTx
    };
}
const $73ba2eb78746f6af$var$sendTransaction = ({ connection: connection, wallet: wallet, txs: txs, signers: signers = [], options: options })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        let tx = (0, $1jULY.Transaction).fromCombined(txs, {
            feePayer: wallet.publicKey
        });
        tx.recentBlockhash = (yield connection.getRecentBlockhash()).blockhash;
        if (signers.length) tx.partialSign(...signers);
        tx = yield wallet.signTransaction(tx);
        return connection.sendRawTransaction(tx.serialize(), options);
    });
class $73ba2eb78746f6af$var$TransactionsBatch {
    constructor({ beforeTransactions: beforeTransactions = [], transactions: transactions, afterTransactions: afterTransactions = [] }){
        this.signers = [];
        this.beforeTransactions = beforeTransactions;
        this.transactions = transactions;
        this.afterTransactions = afterTransactions;
    }
    addSigner(signer) {
        this.signers.push(signer);
    }
    addBeforeTransaction(transaction) {
        this.beforeTransactions.push(transaction);
    }
    addTransaction(transaction) {
        this.transactions.push(transaction);
    }
    addAfterTransaction(transaction) {
        this.afterTransactions.push(transaction);
    }
    toTransactions() {
        return [
            ...this.beforeTransactions,
            ...this.transactions,
            ...this.afterTransactions
        ];
    }
    toInstructions() {
        return this.toTransactions().flatMap((t)=>t.instructions);
    }
}
const $73ba2eb78746f6af$var$addTokensToVault = ({ connection: connection, wallet: wallet, vault: vault, nfts: nfts })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txOptions = {
            feePayer: wallet.publicKey
        };
        const safetyDepositTokenStores = [];
        const vaultAuthority = yield (0, $d1ogx.Vault).getPDA(vault);
        const accountRent = yield connection.getMinimumBalanceForRentExemption((0, $febfi.AccountLayout).span);
        for (const nft of nfts){
            const tokenTxBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
                transactions: []
            });
            const safetyDepositBox = yield (0, $d1ogx.SafetyDepositBox).getPDA(vault, nft.tokenMint);
            const tokenStoreAccount = (0, $1biTx.Keypair).generate();
            const tokenStoreAccountTx = new $73ba2eb78746f6af$var$CreateTokenAccount(txOptions, {
                newAccountPubkey: tokenStoreAccount.publicKey,
                lamports: accountRent,
                mint: nft.tokenMint,
                owner: vaultAuthority
            });
            tokenTxBatch.addTransaction(tokenStoreAccountTx);
            tokenTxBatch.addSigner(tokenStoreAccount);
            const { authority: transferAuthority, createApproveTx: createApproveTx } = $73ba2eb78746f6af$var$createApproveTxs({
                account: nft.tokenAccount,
                owner: wallet.publicKey,
                amount: nft.amount.toNumber()
            });
            tokenTxBatch.addTransaction(createApproveTx);
            tokenTxBatch.addSigner(transferAuthority);
            const addTokenTx = new (0, $d1ogx.AddTokenToInactiveVault)(txOptions, {
                vault: vault,
                vaultAuthority: wallet.publicKey,
                tokenAccount: nft.tokenAccount,
                tokenStoreAccount: tokenStoreAccount.publicKey,
                transferAuthority: transferAuthority.publicKey,
                safetyDepositBox: safetyDepositBox,
                amount: nft.amount
            });
            tokenTxBatch.addTransaction(addTokenTx);
            const txId = yield $73ba2eb78746f6af$var$sendTransaction({
                connection: connection,
                wallet: wallet,
                txs: tokenTxBatch.transactions,
                signers: tokenTxBatch.signers
            });
            safetyDepositTokenStores.push({
                txId: txId,
                tokenStoreAccount: tokenStoreAccount.publicKey,
                tokenMint: nft.tokenMint,
                tokenAccount: nft.tokenAccount
            });
        }
        return {
            safetyDepositTokenStores: safetyDepositTokenStores
        };
    });
const $73ba2eb78746f6af$var$initStore = ({ connection: connection, wallet: wallet, isPublic: isPublic = true })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const storeId = yield (0, $f911d10793ebf039$exports.Store).getPDA(wallet.publicKey);
        const tx = new (0, $f911d10793ebf039$exports.SetStore)({
            feePayer: wallet.publicKey
        }, {
            admin: new (0, $1biTx.PublicKey)(wallet.publicKey),
            store: storeId,
            isPublic: isPublic
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: [
                tx
            ]
        });
        return {
            storeId: storeId,
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$initStoreV2 = ({ connection: connection, wallet: wallet, settingsUri: settingsUri = null, isPublic: isPublic = true })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const storeId = yield (0, $f911d10793ebf039$exports.Store).getPDA(wallet.publicKey);
        const configId = yield (0, $f911d10793ebf039$exports.StoreConfig).getPDA(storeId);
        const tx = new (0, $f911d10793ebf039$exports.SetStoreV2)({
            feePayer: wallet.publicKey
        }, {
            admin: new (0, $1biTx.PublicKey)(wallet.publicKey),
            store: storeId,
            config: configId,
            isPublic: isPublic,
            settingsUri: settingsUri
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: [
                tx
            ]
        });
        return {
            storeId: storeId,
            configId: configId,
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$mintNFT = ({ connection: connection, wallet: wallet, uri: uri, maxSupply: maxSupply })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const { mint: mint, createMintTx: createMintTx, createAssociatedTokenAccountTx: createAssociatedTokenAccountTx, mintToTx: mintToTx } = yield $73ba2eb78746f6af$var$prepareTokenAccountAndMintTxs(connection, wallet.publicKey);
        const metadataPDA = yield (0, $cAjX2.Metadata).getPDA(mint.publicKey);
        const editionPDA = yield (0, $cAjX2.MasterEdition).getPDA(mint.publicKey);
        const { name: name, symbol: symbol, seller_fee_basis_points: seller_fee_basis_points, properties: { creators: creators } } = yield $73ba2eb78746f6af$var$lookup(uri);
        const creatorsData = creators.reduce((memo, { address: address, share: share })=>{
            const verified = address === wallet.publicKey.toString();
            const creator = new (0, $cAjX2.Creator)({
                address: address,
                share: share,
                verified: verified
            });
            memo = [
                ...memo,
                creator
            ];
            return memo;
        }, []);
        const metadataData = new (0, $cAjX2.MetadataDataData)({
            name: name,
            symbol: symbol,
            uri: uri,
            sellerFeeBasisPoints: seller_fee_basis_points,
            creators: creatorsData
        });
        const createMetadataTx = new (0, $cAjX2.CreateMetadata)({
            feePayer: wallet.publicKey
        }, {
            metadata: metadataPDA,
            metadataData: metadataData,
            updateAuthority: wallet.publicKey,
            mint: mint.publicKey,
            mintAuthority: wallet.publicKey
        });
        const masterEditionTx = new (0, $cAjX2.CreateMasterEdition)({
            feePayer: wallet.publicKey
        }, {
            edition: editionPDA,
            metadata: metadataPDA,
            updateAuthority: wallet.publicKey,
            mint: mint.publicKey,
            mintAuthority: wallet.publicKey,
            maxSupply: maxSupply || maxSupply === 0 ? new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(maxSupply) : null
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: [
                mint
            ],
            txs: [
                createMintTx,
                createMetadataTx,
                createAssociatedTokenAccountTx,
                mintToTx,
                masterEditionTx
            ],
            wallet: wallet
        });
        return {
            txId: txId,
            mint: mint.publicKey,
            metadata: metadataPDA,
            edition: editionPDA
        };
    });
const $73ba2eb78746f6af$var$mintEditionFromMaster = ({ connection: connection, wallet: wallet, masterEditionMint: masterEditionMint, updateAuthority: updateAuthority } = {})=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const masterPDA = yield (0, $cAjX2.MasterEdition).getPDA(masterEditionMint);
        const masterMetaPDA = yield (0, $cAjX2.Metadata).getPDA(masterEditionMint);
        const masterInfo = yield (0, $1jULY.Account).getInfo(connection, masterPDA);
        const masterData = new (0, $cAjX2.MasterEdition)(masterPDA, masterInfo).data;
        const editionValue = masterData.supply.add(new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(1));
        const { mint: mint, createMintTx: createMintTx, createAssociatedTokenAccountTx: createAssociatedTokenAccountTx, mintToTx: mintToTx } = yield $73ba2eb78746f6af$var$prepareTokenAccountAndMintTxs(connection, wallet.publicKey);
        const tokenAccount = yield (0, $febfi.Token).getAssociatedTokenAddress((0, $febfi.ASSOCIATED_TOKEN_PROGRAM_ID), (0, $febfi.TOKEN_PROGRAM_ID), masterEditionMint, wallet.publicKey);
        const metadataPDA = yield (0, $cAjX2.Metadata).getPDA(mint.publicKey);
        const editionMarker = yield (0, $cAjX2.EditionMarker).getPDA(masterEditionMint, editionValue);
        const editionPDA = yield (0, $cAjX2.Edition).getPDA(mint.publicKey);
        const newEditionFromMasterTx = new (0, $cAjX2.MintNewEditionFromMasterEditionViaToken)({
            feePayer: wallet.publicKey
        }, {
            edition: editionPDA,
            metadata: metadataPDA,
            updateAuthority: updateAuthority !== null && updateAuthority !== void 0 ? updateAuthority : wallet.publicKey,
            mint: mint.publicKey,
            mintAuthority: wallet.publicKey,
            masterEdition: masterPDA,
            masterMetadata: masterMetaPDA,
            editionMarker: editionMarker,
            tokenOwner: wallet.publicKey,
            tokenAccount: tokenAccount,
            editionValue: editionValue
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: [
                mint
            ],
            txs: [
                createMintTx,
                createAssociatedTokenAccountTx,
                mintToTx,
                newEditionFromMasterTx
            ],
            wallet: wallet
        });
        return {
            txId: txId,
            mint: mint.publicKey,
            metadata: metadataPDA,
            edition: editionPDA
        };
    });
const $73ba2eb78746f6af$var$createMetadata = ({ connection: connection, wallet: wallet, editionMint: editionMint, metadataData: metadataData, updateAuthority: updateAuthority } = {})=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const metadata = yield (0, $cAjX2.Metadata).getPDA(editionMint);
        const createMetadataTx = new (0, $cAjX2.CreateMetadata)({
            feePayer: wallet.publicKey
        }, {
            metadata: metadata,
            metadataData: metadataData,
            updateAuthority: updateAuthority !== null && updateAuthority !== void 0 ? updateAuthority : wallet.publicKey,
            mint: editionMint,
            mintAuthority: wallet.publicKey
        });
        return $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: [],
            txs: [
                createMetadataTx
            ],
            wallet: wallet
        });
    });
const $73ba2eb78746f6af$var$createMasterEdition = ({ connection: connection, wallet: wallet, editionMint: editionMint, updateAuthority: updateAuthority, maxSupply: maxSupply } = {})=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const metadata = yield (0, $cAjX2.Metadata).getPDA(editionMint);
        const edition = yield (0, $cAjX2.MasterEdition).getPDA(editionMint);
        const createMetadataTx = new (0, $cAjX2.CreateMasterEdition)({
            feePayer: wallet.publicKey
        }, {
            edition: edition,
            metadata: metadata,
            updateAuthority: updateAuthority !== null && updateAuthority !== void 0 ? updateAuthority : wallet.publicKey,
            mint: editionMint,
            mintAuthority: wallet.publicKey,
            maxSupply: maxSupply
        });
        return $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: [],
            txs: [
                createMetadataTx
            ],
            wallet: wallet
        });
    });
const $73ba2eb78746f6af$var$signMetadata = ({ connection: connection, wallet: wallet, editionMint: editionMint, signer: signer } = {})=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const metadata = yield (0, $cAjX2.Metadata).getPDA(editionMint);
        const signTx = new (0, $cAjX2.SignMetadata)({
            feePayer: wallet.publicKey
        }, {
            metadata: metadata,
            creator: signer ? signer.publicKey : wallet.publicKey
        });
        return yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: signer ? [
                signer
            ] : [],
            txs: [
                signTx
            ],
            wallet: wallet
        });
    });
const $73ba2eb78746f6af$var$updateMetadata = ({ connection: connection, wallet: wallet, editionMint: editionMint, newMetadataData: newMetadataData, newUpdateAuthority: newUpdateAuthority, primarySaleHappened: primarySaleHappened } = {})=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const metadata = yield (0, $cAjX2.Metadata).getPDA(editionMint);
        const updateTx = new (0, $cAjX2.UpdateMetadata)({
            feePayer: wallet.publicKey
        }, {
            metadata: metadata,
            updateAuthority: wallet.publicKey,
            metadataData: newMetadataData,
            newUpdateAuthority: newUpdateAuthority,
            primarySaleHappened: primarySaleHappened
        });
        return $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: [],
            txs: [
                updateTx
            ],
            wallet: wallet
        });
    });
const $73ba2eb78746f6af$var$cancelBid = ({ connection: connection, wallet: wallet, auction: auction, bidderPotToken: bidderPotToken, destAccount: destAccount })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const bidder = wallet.publicKey;
        const auctionManager = yield (0, $f911d10793ebf039$exports.AuctionManager).getPDA(auction);
        const manager = yield (0, $f911d10793ebf039$exports.AuctionManager).load(connection, auctionManager);
        const { data: { tokenMint: tokenMint } } = yield manager.getAuction(connection);
        const auctionTokenMint = new (0, $1biTx.PublicKey)(tokenMint);
        const vault = new (0, $1biTx.PublicKey)(manager.data.vault);
        const auctionExtended = yield (0, $fRiXQ.AuctionExtended).getPDA(vault);
        const bidderPot = yield (0, $fRiXQ.BidderPot).getPDA(auction, bidder);
        const bidderMeta = yield (0, $fRiXQ.BidderMetadata).getPDA(auction, bidder);
        const accountRentExempt = yield connection.getMinimumBalanceForRentExemption((0, $febfi.AccountLayout).span);
        const txBatch = yield $73ba2eb78746f6af$var$getCancelBidTransactions({
            destAccount: destAccount,
            bidder: bidder,
            accountRentExempt: accountRentExempt,
            bidderPot: bidderPot,
            bidderPotToken: bidderPotToken,
            bidderMeta: bidderMeta,
            auction: auction,
            auctionExtended: auctionExtended,
            auctionTokenMint: auctionTokenMint,
            vault: vault
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txBatch.toTransactions(),
            signers: txBatch.signers
        });
        return {
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$getCancelBidTransactions = ({ destAccount: destAccount, bidder: bidder, accountRentExempt: accountRentExempt, bidderPot: bidderPot, bidderPotToken: bidderPotToken, bidderMeta: bidderMeta, auction: auction, auctionExtended: auctionExtended, auctionTokenMint: auctionTokenMint, vault: vault })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        if (!destAccount) {
            const account = (0, $1biTx.Keypair).generate();
            const createTokenAccountTransaction = new $73ba2eb78746f6af$var$CreateTokenAccount({
                feePayer: bidder
            }, {
                newAccountPubkey: account.publicKey,
                lamports: accountRentExempt,
                mint: (0, $febfi.NATIVE_MINT)
            });
            const closeTokenAccountInstruction = new (0, $1jULY.Transaction)().add((0, $febfi.Token).createCloseAccountInstruction((0, $febfi.TOKEN_PROGRAM_ID), account.publicKey, bidder, bidder, []));
            txBatch.addTransaction(createTokenAccountTransaction);
            txBatch.addAfterTransaction(closeTokenAccountInstruction);
            txBatch.addSigner(account);
            destAccount = account.publicKey;
        }
        const cancelBidTransaction = new (0, $fRiXQ.CancelBid)({
            feePayer: bidder
        }, {
            bidder: bidder,
            bidderToken: destAccount,
            bidderPot: bidderPot,
            bidderPotToken: bidderPotToken,
            bidderMeta: bidderMeta,
            auction: auction,
            auctionExtended: auctionExtended,
            tokenMint: auctionTokenMint,
            resource: vault
        });
        txBatch.addTransaction(cancelBidTransaction);
        return txBatch;
    });
const $73ba2eb78746f6af$var$placeBid = ({ connection: connection, wallet: wallet, amount: amount, auction: auction, bidderPotToken: bidderPotToken })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const bidder = wallet.publicKey;
        const accountRentExempt = yield connection.getMinimumBalanceForRentExemption((0, $febfi.AccountLayout).span);
        const auctionManager = yield (0, $f911d10793ebf039$exports.AuctionManager).getPDA(auction);
        const manager = yield (0, $f911d10793ebf039$exports.AuctionManager).load(connection, auctionManager);
        const { data: { tokenMint: tokenMint } } = yield manager.getAuction(connection);
        const auctionTokenMint = new (0, $1biTx.PublicKey)(tokenMint);
        const vault = new (0, $1biTx.PublicKey)(manager.data.vault);
        const auctionExtended = yield (0, $fRiXQ.AuctionExtended).getPDA(vault);
        const bidderPot = yield (0, $fRiXQ.BidderPot).getPDA(auction, bidder);
        const bidderMeta = yield (0, $fRiXQ.BidderMetadata).getPDA(auction, bidder);
        let txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        if (bidderPotToken) txBatch = yield $73ba2eb78746f6af$var$getCancelBidTransactions({
            destAccount: null,
            bidder: bidder,
            accountRentExempt: accountRentExempt,
            bidderPot: bidderPot,
            bidderPotToken: bidderPotToken,
            bidderMeta: bidderMeta,
            auction: auction,
            auctionExtended: auctionExtended,
            auctionTokenMint: auctionTokenMint,
            vault: vault
        });
        else {
            const account = (0, $1biTx.Keypair).generate();
            const createBidderPotTransaction = new $73ba2eb78746f6af$var$CreateTokenAccount({
                feePayer: bidder
            }, {
                newAccountPubkey: account.publicKey,
                lamports: accountRentExempt,
                mint: auctionTokenMint,
                owner: auction
            });
            txBatch.addSigner(account);
            txBatch.addTransaction(createBidderPotTransaction);
            bidderPotToken = account.publicKey;
        }
        const { account: payingAccount, createTokenAccountTx: createTokenAccountTx, closeTokenAccountTx: closeTokenAccountTx } = yield $73ba2eb78746f6af$var$createWrappedAccountTxs(connection, bidder, amount.toNumber() + accountRentExempt * 2);
        txBatch.addTransaction(createTokenAccountTx);
        txBatch.addAfterTransaction(closeTokenAccountTx);
        txBatch.addSigner(payingAccount);
        const { authority: transferAuthority, createApproveTx: createApproveTx, createRevokeTx: createRevokeTx } = $73ba2eb78746f6af$var$createApproveTxs({
            account: payingAccount.publicKey,
            owner: bidder,
            amount: amount.toNumber()
        });
        txBatch.addTransaction(createApproveTx);
        txBatch.addAfterTransaction(createRevokeTx);
        txBatch.addSigner(transferAuthority);
        const placeBidTransaction = new (0, $fRiXQ.PlaceBid)({
            feePayer: bidder
        }, {
            bidder: bidder,
            bidderToken: payingAccount.publicKey,
            bidderPot: bidderPot,
            bidderPotToken: bidderPotToken,
            bidderMeta: bidderMeta,
            auction: auction,
            auctionExtended: auctionExtended,
            tokenMint: auctionTokenMint,
            transferAuthority: transferAuthority.publicKey,
            amount: amount,
            resource: vault
        });
        txBatch.addTransaction(placeBidTransaction);
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txBatch.toTransactions(),
            signers: txBatch.signers
        });
        return {
            txId: txId,
            bidderPotToken: bidderPotToken,
            bidderMeta: bidderMeta
        };
    });
const $73ba2eb78746f6af$var$redeemFullRightsTransferBid = ({ connection: connection, wallet: wallet, store: store, auction: auction })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const bidder = wallet.publicKey;
        const accountRentExempt = yield connection.getMinimumBalanceForRentExemption((0, $febfi.AccountLayout).span);
        const auctionManager = yield (0, $f911d10793ebf039$exports.AuctionManager).getPDA(auction);
        const manager = yield (0, $f911d10793ebf039$exports.AuctionManager).load(connection, auctionManager);
        const vault = yield (0, $d1ogx.Vault).load(connection, manager.data.vault);
        const fractionMint = new (0, $1biTx.PublicKey)(vault.data.fractionMint);
        const auctionExtended = yield (0, $fRiXQ.AuctionExtended).getPDA(vault.pubkey);
        const [safetyDepositBox] = yield vault.getSafetyDepositBoxes(connection);
        const tokenMint = new (0, $1biTx.PublicKey)(safetyDepositBox.data.tokenMint);
        const safetyDepositTokenStore = new (0, $1biTx.PublicKey)(safetyDepositBox.data.store);
        const bidderMeta = yield (0, $fRiXQ.BidderMetadata).getPDA(auction, bidder);
        const bidRedemption = yield $73ba2eb78746f6af$var$getBidRedemptionPDA(auction, bidderMeta);
        const safetyDepositConfig = yield (0, $f911d10793ebf039$exports.SafetyDepositConfig).getPDA(auctionManager, safetyDepositBox.pubkey);
        const transferAuthority = yield (0, $d1ogx.Vault).getPDA(vault.pubkey);
        const metadata = yield (0, $cAjX2.Metadata).getPDA(tokenMint);
        const txBatch = yield $73ba2eb78746f6af$var$getRedeemFRTBidTransactions({
            accountRentExempt: accountRentExempt,
            tokenMint: tokenMint,
            bidder: bidder,
            bidderMeta: bidderMeta,
            store: store,
            vault: vault.pubkey,
            auction: auction,
            auctionExtended: auctionExtended,
            auctionManager: auctionManager,
            fractionMint: fractionMint,
            safetyDepositTokenStore: safetyDepositTokenStore,
            safetyDeposit: safetyDepositBox.pubkey,
            bidRedemption: bidRedemption,
            safetyDepositConfig: safetyDepositConfig,
            transferAuthority: transferAuthority,
            metadata: metadata
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txBatch.toTransactions(),
            signers: txBatch.signers
        });
        return {
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$getRedeemFRTBidTransactions = ({ accountRentExempt: accountRentExempt, bidder: bidder, tokenMint: tokenMint, store: store, vault: vault, auction: auction, auctionManager: auctionManager, auctionExtended: auctionExtended, bidRedemption: bidRedemption, bidderMeta: bidMetadata, safetyDepositTokenStore: safetyDepositTokenStore, safetyDeposit: safetyDeposit, fractionMint: fractionMint, safetyDepositConfig: safetyDepositConfig, transferAuthority: transferAuthority, metadata: metadata })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const account = (0, $1biTx.Keypair).generate();
        const createDestinationTransaction = new $73ba2eb78746f6af$var$CreateTokenAccount({
            feePayer: bidder
        }, {
            newAccountPubkey: account.publicKey,
            lamports: accountRentExempt,
            mint: tokenMint
        });
        txBatch.addSigner(account);
        txBatch.addTransaction(createDestinationTransaction);
        const redeemBidTransaction = new (0, $f911d10793ebf039$exports.RedeemFullRightsTransferBid)({
            feePayer: bidder
        }, {
            store: store,
            vault: vault,
            auction: auction,
            auctionManager: auctionManager,
            bidRedemption: bidRedemption,
            bidMetadata: bidMetadata,
            safetyDepositTokenStore: safetyDepositTokenStore,
            destination: account.publicKey,
            safetyDeposit: safetyDeposit,
            fractionMint: fractionMint,
            bidder: bidder,
            safetyDepositConfig: safetyDepositConfig,
            auctionExtended: auctionExtended,
            transferAuthority: transferAuthority,
            newAuthority: bidder,
            masterMetadata: metadata
        });
        txBatch.addTransaction(redeemBidTransaction);
        const updatePrimarySaleHappenedViaTokenTransaction = new (0, $cAjX2.UpdatePrimarySaleHappenedViaToken)({
            feePayer: bidder
        }, {
            metadata: metadata,
            owner: bidder,
            tokenAccount: account.publicKey
        });
        txBatch.addTransaction(updatePrimarySaleHappenedViaTokenTransaction);
        return txBatch;
    });
const $73ba2eb78746f6af$var$getBidRedemptionPDA = (auction, bidderMeta)=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        return (yield (0, $1biTx.PublicKey).findProgramAddress([
            $73ba2eb78746f6af$require$Buffer.from((0, $f911d10793ebf039$exports.MetaplexProgram).PREFIX),
            auction.toBuffer(),
            bidderMeta.toBuffer()
        ], (0, $f911d10793ebf039$exports.MetaplexProgram).PUBKEY))[0];
    });
const $73ba2eb78746f6af$var$redeemPrintingV2Bid = ({ connection: connection, wallet: wallet, store: store, auction: auction })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const bidder = wallet.publicKey;
        const { data: { bidState: bidState } } = yield (0, $fRiXQ.Auction).load(connection, auction);
        const auctionManagerPDA = yield (0, $f911d10793ebf039$exports.AuctionManager).getPDA(auction);
        const manager = yield (0, $f911d10793ebf039$exports.AuctionManager).load(connection, auctionManagerPDA);
        const vault = yield (0, $d1ogx.Vault).load(connection, manager.data.vault);
        const auctionExtendedPDA = yield (0, $fRiXQ.AuctionExtended).getPDA(vault.pubkey);
        const [safetyDepositBox] = yield vault.getSafetyDepositBoxes(connection);
        const originalMint = new (0, $1biTx.PublicKey)(safetyDepositBox.data.tokenMint);
        const safetyDepositTokenStore = new (0, $1biTx.PublicKey)(safetyDepositBox.data.store);
        const bidderMetaPDA = yield (0, $fRiXQ.BidderMetadata).getPDA(auction, bidder);
        const bidRedemptionPDA = yield $73ba2eb78746f6af$var$getBidRedemptionPDA(auction, bidderMetaPDA);
        const safetyDepositConfigPDA = yield (0, $f911d10793ebf039$exports.SafetyDepositConfig).getPDA(auctionManagerPDA, safetyDepositBox.pubkey);
        const { mint: mint, createMintTx: createMintTx, createAssociatedTokenAccountTx: createAssociatedTokenAccountTx, mintToTx: mintToTx, recipient: recipient } = yield $73ba2eb78746f6af$var$prepareTokenAccountAndMintTxs(connection, wallet.publicKey);
        const newMint = mint.publicKey;
        const newMetadataPDA = yield (0, $cAjX2.Metadata).getPDA(newMint);
        const newEditionPDA = yield (0, $cAjX2.Edition).getPDA(newMint);
        const metadataPDA = yield (0, $cAjX2.Metadata).getPDA(originalMint);
        const masterEditionPDA = yield (0, $cAjX2.MasterEdition).getPDA(originalMint);
        const masterEdition = yield (0, $cAjX2.MasterEdition).load(connection, masterEditionPDA);
        const prizeTrackingTicketPDA = yield (0, $f911d10793ebf039$exports.PrizeTrackingTicket).getPDA(auctionManagerPDA, originalMint);
        let prizeTrackingTicket;
        try {
            prizeTrackingTicket = yield (0, $f911d10793ebf039$exports.PrizeTrackingTicket).load(connection, prizeTrackingTicketPDA);
        } catch (e) {
            prizeTrackingTicket = null;
        }
        const winIndex = bidState.getWinnerIndex(bidder.toBase58()) || 0;
        const editionOffset = $73ba2eb78746f6af$var$getEditionOffset(winIndex);
        const editionBase = (prizeTrackingTicket === null || prizeTrackingTicket === void 0 ? void 0 : prizeTrackingTicket.data.supplySnapshot) || masterEdition.data.supply;
        const desiredEdition = editionBase.add(editionOffset);
        const editionMarkerPDA = yield (0, $cAjX2.EditionMarker).getPDA(originalMint, desiredEdition);
        try {
            const editionMarker = yield (0, $cAjX2.EditionMarker).load(connection, editionMarkerPDA);
            const isEditionTaken = editionMarker.data.editionTaken(desiredEdition.toNumber());
            if (isEditionTaken) throw new Error("The edition is already taken");
        } catch (e) {}
        const txBatch = yield $73ba2eb78746f6af$var$getRedeemPrintingV2BidTransactions({
            bidder: bidder,
            bidderMeta: bidderMetaPDA,
            store: store,
            vault: vault.pubkey,
            destination: recipient,
            auction: auction,
            auctionExtended: auctionExtendedPDA,
            auctionManager: auctionManagerPDA,
            safetyDepositTokenStore: safetyDepositTokenStore,
            safetyDeposit: safetyDepositBox.pubkey,
            bidRedemption: bidRedemptionPDA,
            safetyDepositConfig: safetyDepositConfigPDA,
            metadata: metadataPDA,
            newMint: newMint,
            newMetadata: newMetadataPDA,
            newEdition: newEditionPDA,
            masterEdition: masterEditionPDA,
            editionMarker: editionMarkerPDA,
            prizeTrackingTicket: prizeTrackingTicketPDA,
            editionOffset: editionOffset,
            winIndex: new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(winIndex)
        });
        txBatch.addSigner(mint);
        txBatch.addBeforeTransaction(createMintTx);
        txBatch.addBeforeTransaction(createAssociatedTokenAccountTx);
        txBatch.addBeforeTransaction(mintToTx);
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txBatch.toTransactions(),
            signers: txBatch.signers
        });
        return {
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$getRedeemPrintingV2BidTransactions = ({ bidder: bidder, destination: destination, store: store, vault: vault, auction: auction, auctionManager: auctionManager, auctionExtended: auctionExtended, bidRedemption: bidRedemption, bidderMeta: bidMetadata, safetyDepositTokenStore: safetyDepositTokenStore, safetyDeposit: safetyDeposit, safetyDepositConfig: safetyDepositConfig, metadata: metadata, newMint: newMint, newMetadata: newMetadata, newEdition: newEdition, masterEdition: masterEdition, editionMarker: editionMark, prizeTrackingTicket: prizeTrackingTicket, winIndex: winIndex, editionOffset: editionOffset })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const redeemPrintingV2BidTx = new (0, $f911d10793ebf039$exports.RedeemPrintingV2Bid)({
            feePayer: bidder
        }, {
            store: store,
            vault: vault,
            auction: auction,
            auctionManager: auctionManager,
            bidRedemption: bidRedemption,
            bidMetadata: bidMetadata,
            safetyDepositTokenStore: safetyDepositTokenStore,
            destination: destination,
            safetyDeposit: safetyDeposit,
            bidder: bidder,
            safetyDepositConfig: safetyDepositConfig,
            auctionExtended: auctionExtended,
            newMint: newMint,
            newEdition: newEdition,
            newMetadata: newMetadata,
            metadata: metadata,
            masterEdition: masterEdition,
            editionMark: editionMark,
            prizeTrackingTicket: prizeTrackingTicket,
            winIndex: winIndex,
            editionOffset: editionOffset
        });
        txBatch.addTransaction(redeemPrintingV2BidTx);
        const updatePrimarySaleHappenedViaTokenTx = new (0, $cAjX2.UpdatePrimarySaleHappenedViaToken)({
            feePayer: bidder
        }, {
            metadata: newMetadata,
            owner: bidder,
            tokenAccount: destination
        });
        txBatch.addTransaction(updatePrimarySaleHappenedViaTokenTx);
        return txBatch;
    });
function $73ba2eb78746f6af$var$getEditionOffset(winIndex) {
    const offset = new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(1);
    return offset.add(new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(winIndex));
}
const $73ba2eb78746f6af$var$redeemParticipationBidV3 = ({ connection: connection, wallet: wallet, store: store, auction: auction })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txInitBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const txMainBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const bidder = wallet.publicKey;
        const { data: { bidState: bidState, tokenMint: auctionTokenMint } } = yield (0, $fRiXQ.Auction).load(connection, auction);
        const auctionManagerPDA = yield (0, $f911d10793ebf039$exports.AuctionManager).getPDA(auction);
        const manager = yield (0, $f911d10793ebf039$exports.AuctionManager).load(connection, auctionManagerPDA);
        const vault = yield (0, $d1ogx.Vault).load(connection, manager.data.vault);
        const auctionExtendedPDA = yield (0, $fRiXQ.AuctionExtended).getPDA(vault.pubkey);
        const [safetyDepositBox] = yield vault.getSafetyDepositBoxes(connection);
        const originalMint = new (0, $1biTx.PublicKey)(safetyDepositBox.data.tokenMint);
        const safetyDepositTokenStore = new (0, $1biTx.PublicKey)(safetyDepositBox.data.store);
        const bidderMetaPDA = yield (0, $fRiXQ.BidderMetadata).getPDA(auction, bidder);
        const bidRedemptionPDA = yield $73ba2eb78746f6af$var$getBidRedemptionPDA(auction, bidderMetaPDA);
        const safetyDepositConfigPDA = yield (0, $f911d10793ebf039$exports.SafetyDepositConfig).getPDA(auctionManagerPDA, safetyDepositBox.pubkey);
        const { data: { participationConfig: { fixedPrice: fixedPrice } } } = yield (0, $f911d10793ebf039$exports.SafetyDepositConfig).load(connection, safetyDepositConfigPDA);
        const acceptPaymentAccount = new (0, $1biTx.PublicKey)(manager.data.acceptPayment);
        const { mint: mint, createMintTx: createMintTx, createAssociatedTokenAccountTx: createAssociatedTokenAccountTx, mintToTx: mintToTx, recipient: recipient } = yield $73ba2eb78746f6af$var$prepareTokenAccountAndMintTxs(connection, wallet.publicKey);
        txInitBatch.addSigner(mint);
        txInitBatch.addTransaction(createMintTx);
        txInitBatch.addTransaction(createAssociatedTokenAccountTx);
        txInitBatch.addTransaction(mintToTx);
        const newMint = mint.publicKey;
        const newMetadataPDA = yield (0, $cAjX2.Metadata).getPDA(newMint);
        const newEditionPDA = yield (0, $cAjX2.Edition).getPDA(newMint);
        const metadataPDA = yield (0, $cAjX2.Metadata).getPDA(originalMint);
        const masterEditionPDA = yield (0, $cAjX2.MasterEdition).getPDA(originalMint);
        const masterEdition = yield (0, $cAjX2.MasterEdition).load(connection, masterEditionPDA);
        const prizeTrackingTicketPDA = yield (0, $f911d10793ebf039$exports.PrizeTrackingTicket).getPDA(auctionManagerPDA, originalMint);
        const winIndex = bidState.getWinnerIndex(bidder.toBase58());
        const desiredEdition = masterEdition.data.supply.add(new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(1));
        const editionMarkerPDA = yield (0, $cAjX2.EditionMarker).getPDA(originalMint, desiredEdition);
        let tokenPaymentAccount;
        if (auctionTokenMint === (0, $febfi.NATIVE_MINT).toBase58()) {
            const { account: account, createTokenAccountTx: createTokenAccountTx, closeTokenAccountTx: closeTokenAccountTx } = yield $73ba2eb78746f6af$var$createWrappedAccountTxs(connection, bidder, fixedPrice.toNumber());
            tokenPaymentAccount = account.publicKey;
            txInitBatch.addTransaction(createTokenAccountTx);
            txInitBatch.addSigner(account);
            txMainBatch.addAfterTransaction(closeTokenAccountTx);
        } else tokenPaymentAccount = yield (0, $febfi.Token).getAssociatedTokenAddress((0, $febfi.ASSOCIATED_TOKEN_PROGRAM_ID), (0, $febfi.TOKEN_PROGRAM_ID), new (0, $1biTx.PublicKey)(auctionTokenMint), bidder);
        const { authority: authority, createApproveTx: createApproveTx, createRevokeTx: createRevokeTx } = $73ba2eb78746f6af$var$createApproveTxs({
            account: tokenPaymentAccount,
            owner: bidder,
            amount: fixedPrice.toNumber()
        });
        txMainBatch.addTransaction(createApproveTx);
        txMainBatch.addAfterTransaction(createRevokeTx);
        txMainBatch.addSigner(authority);
        const redeemParticipationBidV3Tx = new (0, $f911d10793ebf039$exports.RedeemParticipationBidV3)({
            feePayer: bidder
        }, {
            store: store,
            vault: vault.pubkey,
            auction: auction,
            auctionManager: auctionManagerPDA,
            bidRedemption: bidRedemptionPDA,
            bidMetadata: bidderMetaPDA,
            safetyDepositTokenStore: safetyDepositTokenStore,
            destination: recipient,
            safetyDeposit: safetyDepositBox.pubkey,
            bidder: bidder,
            safetyDepositConfig: safetyDepositConfigPDA,
            auctionExtended: auctionExtendedPDA,
            newMint: newMint,
            newEdition: newEditionPDA,
            newMetadata: newMetadataPDA,
            metadata: metadataPDA,
            masterEdition: masterEditionPDA,
            editionMark: editionMarkerPDA,
            prizeTrackingTicket: prizeTrackingTicketPDA,
            winIndex: winIndex !== null ? new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(winIndex) : null,
            transferAuthority: authority.publicKey,
            tokenPaymentAccount: tokenPaymentAccount,
            acceptPaymentAccount: acceptPaymentAccount
        });
        txMainBatch.addTransaction(redeemParticipationBidV3Tx);
        const updatePrimarySaleHappenedViaTokenTx = new (0, $cAjX2.UpdatePrimarySaleHappenedViaToken)({
            feePayer: bidder
        }, {
            metadata: newMetadataPDA,
            owner: bidder,
            tokenAccount: recipient
        });
        txMainBatch.addTransaction(updatePrimarySaleHappenedViaTokenTx);
        const initTxId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txInitBatch.toTransactions(),
            signers: txInitBatch.signers
        });
        yield connection.confirmTransaction(initTxId, "finalized");
        const mainTxId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txMainBatch.toTransactions(),
            signers: txMainBatch.signers
        });
        return {
            txIds: [
                initTxId,
                mainTxId
            ]
        };
    });
function $73ba2eb78746f6af$var$isEligibleForParticipationPrize(winIndex, { nonWinningConstraint: nonWinningConstraint, winnerConstraint: winnerConstraint } = {}) {
    const noWinnerConstraints = winnerConstraint !== (0, $f911d10793ebf039$exports.WinningConstraint).NoParticipationPrize;
    const noNonWinnerConstraints = nonWinningConstraint !== (0, $f911d10793ebf039$exports.NonWinningConstraint).NoParticipationPrize;
    return winIndex === null && noNonWinnerConstraints || winIndex !== null && noWinnerConstraints;
}
const $73ba2eb78746f6af$var$claimBid = ({ connection: connection, wallet: wallet, store: store, auction: auction, bidderPotToken: bidderPotToken })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const bidder = wallet.publicKey;
        const auctionManager = yield (0, $f911d10793ebf039$exports.AuctionManager).getPDA(auction);
        const manager = yield (0, $f911d10793ebf039$exports.AuctionManager).load(connection, auctionManager);
        const vault = new (0, $1biTx.PublicKey)(manager.data.vault);
        const { data: { tokenMint: tokenMint } } = yield (0, $fRiXQ.Auction).load(connection, auction);
        const acceptPayment = new (0, $1biTx.PublicKey)(manager.data.acceptPayment);
        const auctionExtended = yield (0, $fRiXQ.AuctionExtended).getPDA(vault);
        const auctionTokenMint = new (0, $1biTx.PublicKey)(tokenMint);
        const bidderPot = yield (0, $fRiXQ.BidderPot).getPDA(auction, bidder);
        const txBatch = yield $73ba2eb78746f6af$var$getClaimBidTransactions({
            auctionTokenMint: auctionTokenMint,
            bidder: bidder,
            store: store,
            vault: vault,
            auction: auction,
            auctionExtended: auctionExtended,
            auctionManager: auctionManager,
            acceptPayment: acceptPayment,
            bidderPot: bidderPot,
            bidderPotToken: bidderPotToken
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txBatch.toTransactions(),
            signers: txBatch.signers
        });
        return {
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$getClaimBidTransactions = ({ bidder: bidder, auctionTokenMint: auctionTokenMint, store: store, vault: vault, auction: auction, auctionManager: auctionManager, auctionExtended: auctionExtended, acceptPayment: acceptPayment, bidderPot: bidderPot, bidderPotToken: bidderPotToken })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const claimBidTransaction = new (0, $f911d10793ebf039$exports.ClaimBid)({
            feePayer: bidder
        }, {
            store: store,
            vault: vault,
            auction: auction,
            auctionExtended: auctionExtended,
            auctionManager: auctionManager,
            bidder: bidder,
            tokenMint: auctionTokenMint,
            acceptPayment: acceptPayment,
            bidderPot: bidderPot,
            bidderPotToken: bidderPotToken
        });
        txBatch.addTransaction(claimBidTransaction);
        return txBatch;
    });
const $73ba2eb78746f6af$var$instantSale = ({ connection: connection, wallet: wallet, store: store, auction: auction })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txIds = [];
        const auctionManagerPDA = yield (0, $f911d10793ebf039$exports.AuctionManager).getPDA(auction);
        const manager = yield (0, $f911d10793ebf039$exports.AuctionManager).load(connection, auctionManagerPDA);
        const vault = yield (0, $d1ogx.Vault).load(connection, manager.data.vault);
        const auctionExtendedPDA = yield (0, $fRiXQ.AuctionExtended).getPDA(vault.pubkey);
        const { data: { instantSalePrice: instantSalePrice } } = yield (0, $fRiXQ.AuctionExtended).load(connection, auctionExtendedPDA);
        const [safetyDepositBox] = yield vault.getSafetyDepositBoxes(connection);
        const safetyDepositConfigPDA = yield (0, $f911d10793ebf039$exports.SafetyDepositConfig).getPDA(auctionManagerPDA, safetyDepositBox.pubkey);
        const { data: { winningConfigType: winningConfigType, participationConfig: participationConfig } } = yield (0, $f911d10793ebf039$exports.SafetyDepositConfig).load(connection, safetyDepositConfigPDA);
        const { txId: placeBidTxId, bidderPotToken: bidderPotToken } = yield $73ba2eb78746f6af$var$placeBid({
            connection: connection,
            wallet: wallet,
            amount: instantSalePrice,
            auction: auction
        });
        txIds.push(placeBidTxId);
        yield connection.confirmTransaction(placeBidTxId, "finalized");
        const { data: { bidState: bidState } } = yield (0, $fRiXQ.Auction).load(connection, auction);
        const winIndex = bidState.getWinnerIndex(wallet.publicKey.toBase58());
        const hasWinner = winIndex !== null;
        if (hasWinner) {
            switch(winningConfigType){
                case (0, $f911d10793ebf039$exports.WinningConfigType).FullRightsTransfer:
                    {
                        const { txId: txId } = yield $73ba2eb78746f6af$var$redeemFullRightsTransferBid({
                            connection: connection,
                            wallet: wallet,
                            store: store,
                            auction: auction
                        });
                        txIds.push(txId);
                        break;
                    }
                case (0, $f911d10793ebf039$exports.WinningConfigType).PrintingV2:
                    {
                        const { txId: txId } = yield $73ba2eb78746f6af$var$redeemPrintingV2Bid({
                            connection: connection,
                            wallet: wallet,
                            store: store,
                            auction: auction
                        });
                        txIds.push(txId);
                        break;
                    }
                default:
                    throw new Error(`${winningConfigType} winning type isn't supported yet`);
            }
            const { txId: claimBidTxId } = yield $73ba2eb78746f6af$var$claimBid({
                connection: connection,
                wallet: wallet,
                store: store,
                auction: auction,
                bidderPotToken: bidderPotToken
            });
            txIds.push(claimBidTxId);
        } else {
            const { txId: txId } = yield $73ba2eb78746f6af$var$cancelBid({
                connection: connection,
                wallet: wallet,
                auction: auction,
                bidderPotToken: bidderPotToken
            });
            txIds.push(txId);
        }
        const hasWonParticipationPrize = $73ba2eb78746f6af$var$isEligibleForParticipationPrize(winIndex, participationConfig);
        if (hasWonParticipationPrize) {
            const { txIds: txIds } = yield $73ba2eb78746f6af$var$redeemParticipationBidV3({
                connection: connection,
                wallet: wallet,
                store: store,
                auction: auction
            });
            txIds.push(...txIds);
        }
        return {
            txIds: txIds
        };
    });
const $73ba2eb78746f6af$var$burnToken = ({ connection: connection, wallet: wallet, token: token, mint: mint, amount: amount, owner: owner, close: close = true })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const tx = new (0, $1jULY.Transaction)({
            feePayer: wallet.publicKey
        }).add((0, $febfi.Token).createBurnInstruction((0, $febfi.TOKEN_PROGRAM_ID), mint, token, owner !== null && owner !== void 0 ? owner : wallet.publicKey, [], amount));
        if (close) tx.add((0, $febfi.Token).createCloseAccountInstruction((0, $febfi.TOKEN_PROGRAM_ID), token, wallet.publicKey, owner !== null && owner !== void 0 ? owner : wallet.publicKey, []));
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: [
                tx
            ]
        });
        return {
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$sendToken = ({ connection: connection, wallet: wallet, source: source, destination: destination, mint: mint, amount: amount })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txs = [];
        const destAta = yield (0, $febfi.Token).getAssociatedTokenAddress((0, $febfi.ASSOCIATED_TOKEN_PROGRAM_ID), (0, $febfi.TOKEN_PROGRAM_ID), mint, destination);
        const transactionCtorFields = {
            feePayer: wallet.publicKey
        };
        try {
            yield (0, $1jULY.Account).load(connection, destAta);
        } catch (_a) {
            txs.push(new $73ba2eb78746f6af$var$CreateAssociatedTokenAccount(transactionCtorFields, {
                associatedTokenAddress: destAta,
                splTokenMintAddress: mint,
                walletAddress: destination
            }));
        }
        txs.push(new (0, $1jULY.Transaction)(transactionCtorFields).add((0, $febfi.Token).createTransferInstruction((0, $febfi.TOKEN_PROGRAM_ID), source, destAta, wallet.publicKey, [], amount)));
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            wallet: wallet,
            txs: txs
        });
        return {
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$closeVault = ({ connection: connection, wallet: wallet, vault: vault, priceMint: priceMint })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const accountRent = yield connection.getMinimumBalanceForRentExemption((0, $febfi.AccountLayout).span);
        const fractionMintAuthority = yield (0, $d1ogx.Vault).getPDA(vault);
        const txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const txOptions = {
            feePayer: wallet.publicKey
        };
        const { data: { fractionMint: fractionMint, fractionTreasury: fractionTreasury, redeemTreasury: redeemTreasury, pricingLookupAddress: pricingLookupAddress } } = yield (0, $d1ogx.Vault).load(connection, vault);
        const fractionMintKey = new (0, $1biTx.PublicKey)(fractionMint);
        const fractionTreasuryKey = new (0, $1biTx.PublicKey)(fractionTreasury);
        const redeemTreasuryKey = new (0, $1biTx.PublicKey)(redeemTreasury);
        const pricingLookupAddressKey = new (0, $1biTx.PublicKey)(pricingLookupAddress);
        const activateVaultTx = new (0, $d1ogx.ActivateVault)(txOptions, {
            vault: vault,
            numberOfShares: new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(0),
            fractionMint: fractionMintKey,
            fractionTreasury: fractionTreasuryKey,
            fractionMintAuthority: fractionMintAuthority,
            vaultAuthority: wallet.publicKey
        });
        txBatch.addTransaction(activateVaultTx);
        const outstandingShareAccount = (0, $1biTx.Keypair).generate();
        const outstandingShareAccountTx = new $73ba2eb78746f6af$var$CreateTokenAccount(txOptions, {
            newAccountPubkey: outstandingShareAccount.publicKey,
            lamports: accountRent,
            mint: fractionMintKey,
            owner: wallet.publicKey
        });
        txBatch.addTransaction(outstandingShareAccountTx);
        txBatch.addSigner(outstandingShareAccount);
        const payingTokenAccount = (0, $1biTx.Keypair).generate();
        const payingTokenAccountTx = new $73ba2eb78746f6af$var$CreateTokenAccount(txOptions, {
            newAccountPubkey: payingTokenAccount.publicKey,
            lamports: accountRent,
            mint: priceMint,
            owner: wallet.publicKey
        });
        txBatch.addTransaction(payingTokenAccountTx);
        txBatch.addSigner(payingTokenAccount);
        const transferAuthority = (0, $1biTx.Keypair).generate();
        const createApproveTx = (account)=>new (0, $1jULY.Transaction)().add((0, $febfi.Token).createApproveInstruction((0, $febfi.TOKEN_PROGRAM_ID), account.publicKey, transferAuthority.publicKey, wallet.publicKey, [], 0));
        txBatch.addTransaction(createApproveTx(payingTokenAccount));
        txBatch.addTransaction(createApproveTx(outstandingShareAccount));
        txBatch.addSigner(transferAuthority);
        const combineVaultTx = new (0, $d1ogx.CombineVault)(txOptions, {
            vault: vault,
            outstandingShareTokenAccount: outstandingShareAccount.publicKey,
            payingTokenAccount: payingTokenAccount.publicKey,
            fractionMint: fractionMintKey,
            fractionTreasury: fractionTreasuryKey,
            redeemTreasury: redeemTreasuryKey,
            burnAuthority: fractionMintAuthority,
            externalPriceAccount: pricingLookupAddressKey,
            transferAuthority: transferAuthority.publicKey,
            vaultAuthority: wallet.publicKey,
            newVaultAuthority: wallet.publicKey
        });
        txBatch.addTransaction(combineVaultTx);
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: txBatch.signers,
            txs: txBatch.transactions,
            wallet: wallet
        });
        return {
            txId: txId
        };
    });
const $73ba2eb78746f6af$var$createExternalPriceAccount = ({ connection: connection, wallet: wallet })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const txOptions = {
            feePayer: wallet.publicKey
        };
        const epaRentExempt = yield connection.getMinimumBalanceForRentExemption((0, $d1ogx.Vault).MAX_EXTERNAL_ACCOUNT_SIZE);
        const externalPriceAccount = (0, $1biTx.Keypair).generate();
        const externalPriceAccountData = new (0, $d1ogx.ExternalPriceAccountData)({
            pricePerShare: new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(0),
            priceMint: (0, $febfi.NATIVE_MINT).toBase58(),
            allowedToCombine: true
        });
        const uninitializedEPA = new (0, $1jULY.Transaction)().add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: wallet.publicKey,
            newAccountPubkey: externalPriceAccount.publicKey,
            lamports: epaRentExempt,
            space: (0, $d1ogx.Vault).MAX_EXTERNAL_ACCOUNT_SIZE,
            programId: (0, $d1ogx.VaultProgram).PUBKEY
        }));
        txBatch.addTransaction(uninitializedEPA);
        txBatch.addSigner(externalPriceAccount);
        const updateEPA = new (0, $d1ogx.UpdateExternalPriceAccount)(txOptions, {
            externalPriceAccount: externalPriceAccount.publicKey,
            externalPriceAccountData: externalPriceAccountData
        });
        txBatch.addTransaction(updateEPA);
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: txBatch.signers,
            txs: txBatch.transactions,
            wallet: wallet
        });
        return {
            txId: txId,
            externalPriceAccount: externalPriceAccount.publicKey,
            priceMint: (0, $febfi.NATIVE_MINT)
        };
    });
const $73ba2eb78746f6af$var$createVault = ({ connection: connection, wallet: wallet, priceMint: priceMint = (0, $febfi.NATIVE_MINT), externalPriceAccount: externalPriceAccount })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const accountRent = yield connection.getMinimumBalanceForRentExemption((0, $febfi.AccountLayout).span);
        const mintRent = yield connection.getMinimumBalanceForRentExemption((0, $febfi.MintLayout).span);
        const vaultRent = yield connection.getMinimumBalanceForRentExemption((0, $d1ogx.Vault).MAX_VAULT_SIZE);
        const vault = (0, $1biTx.Keypair).generate();
        const vaultAuthority = yield (0, $d1ogx.Vault).getPDA(vault.publicKey);
        const txBatch = new $73ba2eb78746f6af$var$TransactionsBatch({
            transactions: []
        });
        const fractionMint = (0, $1biTx.Keypair).generate();
        const fractionMintTx = new $73ba2eb78746f6af$var$CreateMint({
            feePayer: wallet.publicKey
        }, {
            newAccountPubkey: fractionMint.publicKey,
            lamports: mintRent,
            owner: vaultAuthority,
            freezeAuthority: vaultAuthority
        });
        txBatch.addTransaction(fractionMintTx);
        txBatch.addSigner(fractionMint);
        const redeemTreasury = (0, $1biTx.Keypair).generate();
        const redeemTreasuryTx = new $73ba2eb78746f6af$var$CreateTokenAccount({
            feePayer: wallet.publicKey
        }, {
            newAccountPubkey: redeemTreasury.publicKey,
            lamports: accountRent,
            mint: priceMint,
            owner: vaultAuthority
        });
        txBatch.addTransaction(redeemTreasuryTx);
        txBatch.addSigner(redeemTreasury);
        const fractionTreasury = (0, $1biTx.Keypair).generate();
        const fractionTreasuryTx = new $73ba2eb78746f6af$var$CreateTokenAccount({
            feePayer: wallet.publicKey
        }, {
            newAccountPubkey: fractionTreasury.publicKey,
            lamports: accountRent,
            mint: fractionMint.publicKey,
            owner: vaultAuthority
        });
        txBatch.addTransaction(fractionTreasuryTx);
        txBatch.addSigner(fractionTreasury);
        const uninitializedVaultTx = new (0, $1jULY.Transaction)().add((0, $1biTx.SystemProgram).createAccount({
            fromPubkey: wallet.publicKey,
            newAccountPubkey: vault.publicKey,
            lamports: vaultRent,
            space: (0, $d1ogx.Vault).MAX_VAULT_SIZE,
            programId: (0, $d1ogx.VaultProgram).PUBKEY
        }));
        txBatch.addTransaction(uninitializedVaultTx);
        txBatch.addSigner(vault);
        const initVaultTx = new (0, $d1ogx.InitVault)({
            feePayer: wallet.publicKey
        }, {
            vault: vault.publicKey,
            vaultAuthority: wallet.publicKey,
            fractionalTreasury: fractionTreasury.publicKey,
            pricingLookupAddress: externalPriceAccount,
            redeemTreasury: redeemTreasury.publicKey,
            fractionalMint: fractionMint.publicKey,
            allowFurtherShareCreation: true
        });
        txBatch.addTransaction(initVaultTx);
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: txBatch.signers,
            txs: txBatch.transactions,
            wallet: wallet
        });
        return {
            txId: txId,
            vault: vault.publicKey,
            fractionMint: fractionMint.publicKey,
            redeemTreasury: redeemTreasury.publicKey,
            fractionTreasury: fractionTreasury.publicKey
        };
    });
const $73ba2eb78746f6af$var$initAuction = ({ connection: connection, wallet: wallet, vault: vault, auctionSettings: auctionSettings })=>$73ba2eb78746f6af$var$__awaiter(void 0, void 0, void 0, function*() {
        const txOptions = {
            feePayer: wallet.publicKey
        };
        const [auctionKey, auctionExtended] = yield Promise.all([
            (0, $fRiXQ.Auction).getPDA(vault),
            (0, $fRiXQ.AuctionExtended).getPDA(vault)
        ]);
        const fullSettings = new (0, $fRiXQ.CreateAuctionArgs)(Object.assign(Object.assign({}, auctionSettings), {
            authority: wallet.publicKey.toBase58(),
            resource: vault.toBase58()
        }));
        const auctionTx = new (0, $fRiXQ.CreateAuction)(txOptions, {
            args: fullSettings,
            auction: auctionKey,
            creator: wallet.publicKey,
            auctionExtended: auctionExtended
        });
        const txId = yield $73ba2eb78746f6af$var$sendTransaction({
            connection: connection,
            signers: [],
            txs: [
                auctionTx
            ],
            wallet: wallet
        });
        return {
            txId: txId,
            auction: auctionKey
        };
    });
var $73ba2eb78746f6af$export$e324594224ef24da = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    addTokensToVault: $73ba2eb78746f6af$var$addTokensToVault,
    sendTransaction: $73ba2eb78746f6af$var$sendTransaction,
    initStore: $73ba2eb78746f6af$var$initStore,
    initStoreV2: $73ba2eb78746f6af$var$initStoreV2,
    mintNFT: $73ba2eb78746f6af$var$mintNFT,
    mintEditionFromMaster: $73ba2eb78746f6af$var$mintEditionFromMaster,
    createMetadata: $73ba2eb78746f6af$var$createMetadata,
    createMasterEdition: $73ba2eb78746f6af$var$createMasterEdition,
    signMetadata: $73ba2eb78746f6af$var$signMetadata,
    updateMetadata: $73ba2eb78746f6af$var$updateMetadata,
    cancelBid: $73ba2eb78746f6af$var$cancelBid,
    getCancelBidTransactions: $73ba2eb78746f6af$var$getCancelBidTransactions,
    placeBid: $73ba2eb78746f6af$var$placeBid,
    redeemFullRightsTransferBid: $73ba2eb78746f6af$var$redeemFullRightsTransferBid,
    getRedeemFRTBidTransactions: $73ba2eb78746f6af$var$getRedeemFRTBidTransactions,
    getBidRedemptionPDA: $73ba2eb78746f6af$var$getBidRedemptionPDA,
    redeemPrintingV2Bid: $73ba2eb78746f6af$var$redeemPrintingV2Bid,
    getRedeemPrintingV2BidTransactions: $73ba2eb78746f6af$var$getRedeemPrintingV2BidTransactions,
    getEditionOffset: $73ba2eb78746f6af$var$getEditionOffset,
    redeemParticipationBidV3: $73ba2eb78746f6af$var$redeemParticipationBidV3,
    isEligibleForParticipationPrize: $73ba2eb78746f6af$var$isEligibleForParticipationPrize,
    claimBid: $73ba2eb78746f6af$var$claimBid,
    getClaimBidTransactions: $73ba2eb78746f6af$var$getClaimBidTransactions,
    instantSale: $73ba2eb78746f6af$var$instantSale,
    burnToken: $73ba2eb78746f6af$var$burnToken,
    sendToken: $73ba2eb78746f6af$var$sendToken,
    prepareTokenAccountAndMintTxs: $73ba2eb78746f6af$var$prepareTokenAccountAndMintTxs,
    createWrappedAccountTxs: $73ba2eb78746f6af$var$createWrappedAccountTxs,
    createApproveTxs: $73ba2eb78746f6af$var$createApproveTxs,
    closeVault: $73ba2eb78746f6af$var$closeVault,
    createExternalPriceAccount: $73ba2eb78746f6af$var$createExternalPriceAccount,
    createVault: $73ba2eb78746f6af$var$createVault,
    initAuction: $73ba2eb78746f6af$var$initAuction
});
var $73ba2eb78746f6af$export$7f4c6ae6cd2bdde3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    transactions: $73ba2eb78746f6af$export$3371c32cd402472f,
    auction: $fRiXQ,
    core: $1jULY,
    metaplex: $f911d10793ebf039$exports,
    metadata: $cAjX2,
    vault: $d1ogx
});



const $df5bef30413a053b$export$d6b0bfcf40113928 = "https://mainnet.helius-rpc.com/?api-key=f23c591a-e54f-408e-977e-fbea506542ed";
async function $df5bef30413a053b$export$51c4d9482f56a6cc(accountInfoList) {
    const responses = await Promise.all(accountInfoList.map((row)=>(0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection.getTokenAccountBalance(row.pubkey, "confirmed")));
    return accountInfoList.filter((_, i)=>responses[i].value.uiAmount === 1 && responses[i].value.decimals === 0);
}
async function $df5bef30413a053b$var$getMetadataImgUrl(url) {
    return fetch(url).then((response)=>{
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
    }, ()=>{
        return {
            image: ""
        };
    }).then((data)=>{
        return data.image;
    });
}
async function $df5bef30413a053b$var$getMintMetadata(mintPubkey, owner, stakeApi) {
    try {
        const tokenmetaPubkey = await (0, $73ba2eb78746f6af$export$7f4c6ae6cd2bdde3).metadata.Metadata.getPDA(mintPubkey);
        const tokenmeta = await (0, $73ba2eb78746f6af$export$7f4c6ae6cd2bdde3).metadata.Metadata.load((0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection, tokenmetaPubkey);
        const resp = await $df5bef30413a053b$var$getMetadataImgUrl(tokenmeta.data.data.uri);
        const isStaked = await stakeApi.isStaked({
            user: owner,
            nft: {
                mintAddress: mintPubkey,
                metadataAddress: tokenmetaPubkey
            }
        });
        const goldAmount = await stakeApi.readGoldPoints({
            user: owner,
            nft: {
                mintAddress: mintPubkey,
                metadataAddress: tokenmetaPubkey
            }
        });
        return {
            imageUrl: resp,
            name: tokenmeta.data.data.name,
            staked: isStaked,
            goldAmount: goldAmount
        };
    } catch (error) {
        console.log(error);
        return {
            imageUrl: "",
            name: "",
            staked: false,
            goldAmount: 0
        };
    }
}
async function $df5bef30413a053b$export$41de4ca38dfdd45d(mintsList, owner, stakeApi) {
    const metadataList = await Promise.all(mintsList.map((mintPubKey)=>$df5bef30413a053b$var$getMintMetadata(mintPubKey, owner, stakeApi)));
    return metadataList;
}
const $df5bef30413a053b$var$url = `https://mainnet.helius-rpc.com/?api-key=${"43c3d0ff-8ecc-4be0-8345-d1a064a0e1b5"}`;
const $df5bef30413a053b$export$f22f495c06a13176 = async (ownerAddress)=>{
    const response = await fetch($df5bef30413a053b$var$url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            jsonrpc: "2.0",
            id: "my-id",
            method: "searchAssets",
            params: {
                ownerAddress: ownerAddress,
                grouping: [
                    "collection",
                    "J1S9H3QjnRtBbbuD4HjPV6RpRhwuk4zKbxsnCHuTgh9w"
                ]
            }
        })
    });
    const { result: result } = await response.json();
    return result;
};
const $df5bef30413a053b$export$d200926f25a28392 = async (owner, ladList, stakeApi)=>{
    const stakedLadsList = await Promise.all(ladList.items.map(async (item, index)=>{
        const mintPubKey = new (0, $1biTx.PublicKey)(item.id);
        const tokenPubKey = new (0, $1biTx.PublicKey)(item.token_info.associated_token_address);
        const tokenmetaPubkey = await (0, $73ba2eb78746f6af$export$7f4c6ae6cd2bdde3).metadata.Metadata.getPDA(mintPubKey);
        const isStaked = await stakeApi.isStaked({
            user: new (0, $1biTx.PublicKey)(owner),
            nft: {
                mintAddress: mintPubKey,
                metadataAddress: tokenmetaPubkey
            }
        });
        const goldAmount = await stakeApi.readGoldPoints({
            user: new (0, $1biTx.PublicKey)(owner),
            nft: {
                mintAddress: mintPubKey,
                metadataAddress: tokenmetaPubkey
            }
        });
        return {
            mintPubKey: mintPubKey,
            tokenPubKey: tokenPubKey,
            imageUrl: item.content.links.image,
            name: item.content.metadata.name,
            staked: isStaked,
            goldAmount: goldAmount
        };
    }));
    return stakedLadsList;
};


const $565bb8264fce4bd8$export$6a1a4134d62fc440 = (0, $337f2e695a94146d$exports.create)((set)=>({
        rpcConnection: new (0, $1biTx.Connection)((0, $df5bef30413a053b$export$d6b0bfcf40113928)),
        setCustomRpcUrl: (newRpcUrl)=>set({
                rpcConnection: new (0, $1biTx.Connection)(newRpcUrl)
            }),
        setDefaultRpcUrl: ()=>set({
                rpcConnection: new (0, $1biTx.Connection)((0, $df5bef30413a053b$export$d6b0bfcf40113928))
            })
    }));




var $1biTx = parcelRequire("1biTx");
var $969f70d02d907a92$exports = {};
$969f70d02d907a92$exports = new URL("metacamp-logo.afc6991f.png", import.meta.url).toString();


const $e0ed2d4e3eaef4d4$var$TopNav = ()=>{
    const [isNavOpen, setIsNavOpen] = (0, $lx97N.useState)(false);
    const [isSettingsOpen, setIsSettingsOpen] = (0, $lx97N.useState)(false);
    const [isDefaultRpc, setIsDefaultRpc] = (0, $lx97N.useState)(true);
    const [customRpcUrl, setCustomRpcUrl] = (0, $lx97N.useState)("");
    const handleSetDefaultRpcUrl = ()=>{
        setIsDefaultRpc(true);
        (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).setState({
            rpcConnection: new (0, $1biTx.Connection)((0, $df5bef30413a053b$export$d6b0bfcf40113928))
        });
    };
    const handleSetCustomRpcUrl = ()=>{
        setIsDefaultRpc(false);
        (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).setState({
            rpcConnection: new (0, $1biTx.Connection)(customRpcUrl)
        });
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("nav", {
        className: "bg-slate-900 border-b border-slate-800 fixed z-30 w-full ",
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
            className: "mx-auto max-w-screen-xl px-3 py-3 lg:px-0",
            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                        className: "flex w-full md:w-fit items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: isNavOpen ? "showMenuNav" : "hideMenuNav",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                        className: "CROSS-ICON absolute top-0 right-0 px-8 py-8",
                                        onClick: ()=>setIsNavOpen(false),
                                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("svg", {
                                            className: "h-8 w-8 text-gray-600",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("line", {
                                                    x1: "18",
                                                    y1: "6",
                                                    x2: "6",
                                                    y2: "18"
                                                }),
                                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("line", {
                                                    x1: "6",
                                                    y1: "6",
                                                    x2: "18",
                                                    y2: "18"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("ul", {
                                        className: "MENU-LINK-MOBILE-OPEN flex flex-col justify-between",
                                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("li", {
                                            className: "my-3 flex justify-center",
                                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $a1d44d7a0b3f9c7f$export$968d144f04194cbb), {
                                                className: "!bg-gradient-to-r from-sky-500 via-blue-600 !to-purple-700 hover:from-sky-400 !rounded-lg"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("a", {
                                href: "/",
                                className: "text-xl font-bold flex items-center lg:ml-2.5",
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("img", {
                                    src: $969f70d02d907a92$exports,
                                    className: "h-7 md:h-8 mr-2",
                                    alt: "metacamp Logo"
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                                id: "toggleSidebarMobile",
                                "aria-expanded": "true",
                                "aria-controls": "sidebar",
                                onClick: ()=>setIsNavOpen((prev)=>!prev),
                                className: "lg:hidden text-gray-600 -mr-1 hover:text-gray-400 cursor-pointer p-2 hover:bg-gray-100 focus:bg-gray-100 focus:ring-2 focus:ring-gray-100 rounded",
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("svg", {
                                    className: "w-7 h-7",
                                    fill: "currentColor",
                                    viewBox: "0 0 20 20",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z",
                                        clipRule: "evenodd"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                        className: "hidden md:flex md:flex-row items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                                        onClick: ()=>setIsSettingsOpen((value)=>!value),
                                        className: "z-10 border h-12 border-transparent text-white px-6 flex items-center justify-center rounded-md bg-amber-500 hover:bg-amber-400",
                                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                            className: "hidden md:block",
                                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 16 17",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                                                    d: "M6.71971 1.2926L6.41471 2.9726C6.11846 3.06573 5.83097 3.18635 5.55971 3.32761L4.14971 2.35761L2.33979 4.16753L3.31479 5.57252C3.17292 5.84439 3.05355 6.13003 2.95979 6.42753L1.27979 6.73252V9.29252L2.95979 9.59751C3.05354 9.89564 3.17729 10.18 3.31979 10.4525L2.33979 11.8575L4.14971 13.6674L5.5547 12.6974C5.82719 12.8399 6.11657 12.9587 6.4147 13.0524L6.71969 14.7324H9.27969L9.58468 13.0524C9.88218 12.9587 10.1678 12.8393 10.4397 12.6974L11.8447 13.6674L13.6546 11.8575L12.6796 10.4525C12.8208 10.1813 12.9415 9.89878 13.0346 9.60252L14.7196 9.29252V6.73252L13.0346 6.42753C12.9415 6.1319 12.8252 5.84815 12.6846 5.57753L13.6546 4.16753L11.8447 2.35761L10.4397 3.32761C10.1678 3.18574 9.88218 3.06636 9.58468 2.9726L9.27969 1.2926H6.71971ZM7.9997 4.9726C9.67842 4.9726 11.0397 6.33385 11.0397 8.0126C11.0397 9.69135 9.67846 11.0526 7.9997 11.0526C6.32095 11.0526 4.95971 9.69135 4.95971 8.0126C4.95971 6.33385 6.32095 4.9726 7.9997 4.9726Z",
                                                    fill: "currentColor"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("ul", {
                                        "aria-label": "dropdown-list",
                                        className: `wallet-adapter-dropdown-list w-max ${isSettingsOpen ? "wallet-adapter-dropdown-list-active" : "false"}`,
                                        role: "menu",
                                        children: [
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                                                className: "text-lg font-bold  text-white px-5",
                                                children: "RPC Endpoint"
                                            }),
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                                className: "flex items-center space-x-4 cursor-pointer px-5",
                                                onClick: handleSetDefaultRpcUrl,
                                                children: [
                                                    isDefaultRpc ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "hidden",
                                                                checked: false
                                                            }),
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                                                                        d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17Z",
                                                                        fill: "url(#paint0_linear_4842_28073)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("defs", {
                                                                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("linearGradient", {
                                                                            id: "paint0_linear_4842_28073",
                                                                            x1: "3.64948",
                                                                            y1: "-3",
                                                                            x2: "21.9982",
                                                                            y2: "-0.81258",
                                                                            gradientUnits: "userSpaceOnUse",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("stop", {
                                                                                    "stop-color": "#FCC00A"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("stop", {
                                                                                    offset: "1",
                                                                                    "stop-color": "#4EBAE9"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "hidden",
                                                                checked: false
                                                            }),
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("svg", {
                                                                className: "block",
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                                                                    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z",
                                                                    fill: "white",
                                                                    "fill-opacity": "0.35"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                                                        className: "text-black-75 dark:text-white-75 text-sm",
                                                        children: "Helius RPC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                                className: "flex items-center space-x-4 px-5",
                                                children: [
                                                    !isDefaultRpc ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "hidden"
                                                            }),
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                                                                        d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17Z",
                                                                        fill: "url(#paint0_linear_4842_28073)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("defs", {
                                                                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("linearGradient", {
                                                                            id: "paint0_linear_4842_28073",
                                                                            x1: "3.64948",
                                                                            y1: "-3",
                                                                            x2: "21.9982",
                                                                            y2: "-0.81258",
                                                                            gradientUnits: "userSpaceOnUse",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("stop", {
                                                                                    "stop-color": "#FCC00A"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("stop", {
                                                                                    offset: "1",
                                                                                    "stop-color": "#4EBAE9"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "hidden"
                                                            }),
                                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("svg", {
                                                                className: "block",
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                                                                    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z",
                                                                    fill: "white",
                                                                    "fill-opacity": "0.35"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                                                        className: "text-black-75 dark:text-white-75 text-sm",
                                                        children: "Custom RPC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                                className: "relative px-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                                        className: "rounded-md pr-16 items-center bg-gray-900 text-sm text-white placeholder:text-white-35 w-full text-left px-4 py-3.5",
                                                        placeholder: "Custom RPC URL",
                                                        value: customRpcUrl,
                                                        onChange: (e)=>setCustomRpcUrl(e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: handleSetCustomRpcUrl,
                                                        className: "absolute top-1/2 -translate-y-1/2 right-8 text-xs rounded-[4px] bg-white text-black-50 px-2 py-1 dark:text-white-35 dark:bg-jupiter-dark",
                                                        children: "Save"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $a1d44d7a0b3f9c7f$export$968d144f04194cbb), {
                                className: "!bg-gradient-to-r from-sky-500 via-blue-600 !to-purple-700 hover:from-sky-400 !rounded-lg"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $e0ed2d4e3eaef4d4$export$2e2bcd8739ae039 = $e0ed2d4e3eaef4d4$var$TopNav;




var $cbQCu = parcelRequire("cbQCu");

var $1biTx = parcelRequire("1biTx");

var $cj5EG = parcelRequire("cj5EG");

var $f4WXk = parcelRequire("f4WXk");
var $60a70e2f81b43d9e$exports = {};
"use strict";
const $60a70e2f81b43d9e$var$UPPERCASE = /[\p{Lu}]/u;
const $60a70e2f81b43d9e$var$LOWERCASE = /[\p{Ll}]/u;
const $60a70e2f81b43d9e$var$LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const $60a70e2f81b43d9e$var$IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const $60a70e2f81b43d9e$var$SEPARATORS = /[_.\- ]+/;
const $60a70e2f81b43d9e$var$LEADING_SEPARATORS = new RegExp("^" + $60a70e2f81b43d9e$var$SEPARATORS.source);
const $60a70e2f81b43d9e$var$SEPARATORS_AND_IDENTIFIER = new RegExp($60a70e2f81b43d9e$var$SEPARATORS.source + $60a70e2f81b43d9e$var$IDENTIFIER.source, "gu");
const $60a70e2f81b43d9e$var$NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + $60a70e2f81b43d9e$var$IDENTIFIER.source, "gu");
const $60a70e2f81b43d9e$var$preserveCamelCase = (string, toLowerCase, toUpperCase)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && $60a70e2f81b43d9e$var$UPPERCASE.test(character)) {
            string = string.slice(0, i) + "-" + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && $60a70e2f81b43d9e$var$LOWERCASE.test(character)) {
            string = string.slice(0, i - 1) + "-" + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
        }
    }
    return string;
};
const $60a70e2f81b43d9e$var$preserveConsecutiveUppercase = (input, toLowerCase)=>{
    $60a70e2f81b43d9e$var$LEADING_CAPITAL.lastIndex = 0;
    return input.replace($60a70e2f81b43d9e$var$LEADING_CAPITAL, (m1)=>toLowerCase(m1));
};
const $60a70e2f81b43d9e$var$postProcess = (input, toUpperCase)=>{
    $60a70e2f81b43d9e$var$SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
    $60a70e2f81b43d9e$var$NUMBERS_AND_IDENTIFIER.lastIndex = 0;
    return input.replace($60a70e2f81b43d9e$var$SEPARATORS_AND_IDENTIFIER, (_, identifier)=>toUpperCase(identifier)).replace($60a70e2f81b43d9e$var$NUMBERS_AND_IDENTIFIER, (m)=>toUpperCase(m));
};
const $60a70e2f81b43d9e$var$camelCase = (input, options)=>{
    if (!(typeof input === "string" || Array.isArray(input))) throw new TypeError("Expected the input to be `string | string[]`");
    options = {
        pascalCase: false,
        preserveConsecutiveUppercase: false,
        ...options
    };
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join("-");
    else input = input.trim();
    if (input.length === 0) return "";
    const toLowerCase = options.locale === false ? (string)=>string.toLowerCase() : (string)=>string.toLocaleLowerCase(options.locale);
    const toUpperCase = options.locale === false ? (string)=>string.toUpperCase() : (string)=>string.toLocaleUpperCase(options.locale);
    if (input.length === 1) return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
    const hasUpperCase = input !== toLowerCase(input);
    if (hasUpperCase) input = $60a70e2f81b43d9e$var$preserveCamelCase(input, toLowerCase, toUpperCase);
    input = input.replace($60a70e2f81b43d9e$var$LEADING_SEPARATORS, "");
    if (options.preserveConsecutiveUppercase) input = $60a70e2f81b43d9e$var$preserveConsecutiveUppercase(input, toLowerCase);
    else input = toLowerCase(input);
    if (options.pascalCase) input = toUpperCase(input.charAt(0)) + input.slice(1);
    return $60a70e2f81b43d9e$var$postProcess(input, toUpperCase);
};
$60a70e2f81b43d9e$exports = $60a70e2f81b43d9e$var$camelCase;
// TODO: Remove this for the next major release
$60a70e2f81b43d9e$exports.default = $60a70e2f81b43d9e$var$camelCase;


var $8e63f10e9557e84e$exports = {};

var $cbQCu = parcelRequire("cbQCu");
var $8e63f10e9557e84e$require$Buffer = $cbQCu.Buffer;
"use strict";
var $8e63f10e9557e84e$var$__importDefault = $8e63f10e9557e84e$exports && $8e63f10e9557e84e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8e63f10e9557e84e$exports, "__esModule", {
    value: true
});
$8e63f10e9557e84e$exports.map = $8e63f10e9557e84e$exports.array = $8e63f10e9557e84e$exports.rustEnum = $8e63f10e9557e84e$exports.str = $8e63f10e9557e84e$exports.vecU8 = $8e63f10e9557e84e$exports.tagged = $8e63f10e9557e84e$exports.vec = $8e63f10e9557e84e$exports.bool = $8e63f10e9557e84e$exports.option = $8e63f10e9557e84e$exports.publicKey = $8e63f10e9557e84e$exports.i256 = $8e63f10e9557e84e$exports.u256 = $8e63f10e9557e84e$exports.i128 = $8e63f10e9557e84e$exports.u128 = $8e63f10e9557e84e$exports.i64 = $8e63f10e9557e84e$exports.u64 = $8e63f10e9557e84e$exports.struct = $8e63f10e9557e84e$exports.f64 = $8e63f10e9557e84e$exports.f32 = $8e63f10e9557e84e$exports.i32 = $8e63f10e9557e84e$exports.u32 = $8e63f10e9557e84e$exports.i16 = $8e63f10e9557e84e$exports.u16 = $8e63f10e9557e84e$exports.i8 = $8e63f10e9557e84e$exports.u8 = void 0;
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Buffer instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ var $eae21cbfe0657f11$export$c84671f46d6a1ca;
var $eae21cbfe0657f11$export$afa1a74657000b67;
var $eae21cbfe0657f11$export$888df3b4497fe914;
var $eae21cbfe0657f11$export$3fbe2a7b321c34e0;
var $eae21cbfe0657f11$export$a1423b48ba9f7b82;
var $eae21cbfe0657f11$export$33b72ac7c0edff27;
var $eae21cbfe0657f11$export$5aaa69e6f271b98f;
var $eae21cbfe0657f11$export$75952b3c9b52942f;
var $eae21cbfe0657f11$export$fdd676b64b72b00;
var $eae21cbfe0657f11$export$6d6a6e3ae3c61752;
var $eae21cbfe0657f11$export$bb89b76e902dbdb5;
var $eae21cbfe0657f11$export$d68cbce6ee5a6137;
var $eae21cbfe0657f11$export$340e583a64e26663;
var $eae21cbfe0657f11$export$776a1c887f98bb0a;
var $eae21cbfe0657f11$export$edde1bcb1b2b310e;
var $eae21cbfe0657f11$export$d981182684770f2a;
var $eae21cbfe0657f11$export$5e5f461bb7edf74c;
var $eae21cbfe0657f11$export$c05dde5a34d9ea51;
var $eae21cbfe0657f11$export$6cbb4f8fa0c4c986;
var $eae21cbfe0657f11$export$57ee95071e9ec5f5;
var $eae21cbfe0657f11$export$2bdec8c076c815b2;
var $eae21cbfe0657f11$export$f8e44e1658c8d14c;
var $eae21cbfe0657f11$export$f9e6d957cb90bdc0;
var $eae21cbfe0657f11$export$3b660928c86ff55c;
var $eae21cbfe0657f11$export$744d9d543319c3c;
var $eae21cbfe0657f11$export$9560dad2a83e4f04;
var $eae21cbfe0657f11$export$3c508fb3f8ac1ad4;
/** Factory for {@link GreedyCount}. */ var $eae21cbfe0657f11$export$299a26fa2ceaa3f8;
/** Factory for {@link OffsetLayout}. */ var $eae21cbfe0657f11$export$cc800923e997bb8;
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ var $eae21cbfe0657f11$export$9813fca58c0b9f71;
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ var $eae21cbfe0657f11$export$73c443a9dbe0d04a;
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ var $eae21cbfe0657f11$export$9bf749af8ce6f6f8;
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ var $eae21cbfe0657f11$export$8bacf4ad828c7fe7;
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ var $eae21cbfe0657f11$export$ecb77dab600c8b47;
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ var $eae21cbfe0657f11$export$d95fd39a3a649e76;
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ var $eae21cbfe0657f11$export$bb5970674287ec35;
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ var $eae21cbfe0657f11$export$c432074536ef0c2c;
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ var $eae21cbfe0657f11$export$eb2b2a282bde1478;
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ var $eae21cbfe0657f11$export$231c4b14f4a5c881;
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ var $eae21cbfe0657f11$export$d0bca391d9188e81;
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ var $eae21cbfe0657f11$export$11edc2f642bfe946;
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ var $eae21cbfe0657f11$export$c65c6fa3bdaa77fc;
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ var $eae21cbfe0657f11$export$9e2c7b6a4468e78a;
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ var $eae21cbfe0657f11$export$2573154f1fb93a3e;
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ var $eae21cbfe0657f11$export$b5ed35f0656342d4;
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ var $eae21cbfe0657f11$export$fc2ea698f8ef5ace;
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ var $eae21cbfe0657f11$export$75a91ba4bc70ae98;
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ var $eae21cbfe0657f11$export$cc2aca65bf3735b9;
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ var $eae21cbfe0657f11$export$1ab06c27fed8512f;
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ var $eae21cbfe0657f11$export$5930f5afc2558c04;
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ var $eae21cbfe0657f11$export$9708063d81dec021;
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ var $eae21cbfe0657f11$export$6d35d472f297e5bc;
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ var $eae21cbfe0657f11$export$2f1dc4c509c45ba5;
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ var $eae21cbfe0657f11$export$8a2927284f04dc17;
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ var $eae21cbfe0657f11$export$6d75303fcb20b1cb;
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ var $eae21cbfe0657f11$export$e33361ff41014190;
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ var $eae21cbfe0657f11$export$bb50574a3c55bf79;
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ var $eae21cbfe0657f11$export$eda3f5d9b9872690;
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ var $eae21cbfe0657f11$export$7ad1954a0412d2a0;
/** Factory for {@link Structure} values. */ var $eae21cbfe0657f11$export$8cf3da7c1c9174ea;
/** Factory for {@link BitStructure} values. */ var $eae21cbfe0657f11$export$343c373b6ee94f49;
/** Factory for {@link Sequence} values. */ var $eae21cbfe0657f11$export$1041d4276c328e4d;
/** Factory for {@link Union} values. */ var $eae21cbfe0657f11$export$971dd5b0dfd021b6;
/** Factory for {@link UnionLayoutDiscriminator} values. */ var $eae21cbfe0657f11$export$abe73b3325e8ad62;
/** Factory for {@link Blob} values. */ var $eae21cbfe0657f11$export$8cf3c1c9f525ba2;
/** Factory for {@link CString} values. */ var $eae21cbfe0657f11$export$a0f851cdf0eaf93d;
/** Factory for {@link UTF8} values. */ var $eae21cbfe0657f11$export$74329b762b589566;
/** Factory for {@link Constant} values. */ var $eae21cbfe0657f11$export$5b38a098e5a9e7ca;

var $cbQCu = parcelRequire("cbQCu");
var $eae21cbfe0657f11$require$Buffer = $cbQCu.Buffer;
"use strict";
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $eae21cbfe0657f11$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
     *
     * Positive values are generally expected.
     *
     * Zero will only appear in {@link Constant}s and in {@link
     * Sequence}s where the {@link Sequence#count|count} is zero.
     *
     * A negative value indicates that the span is value-specific, and
     * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
     * Object.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances.  If left undefined the span of the unnamed layout will
     * be treated as padding: it will not be mutated by {@link
     * Layout#encode|encode} nor represented as a property in the
     * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */ makeDestinationObject() {
        return {};
    }
    /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */ decode(b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */ encode(src, b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */ fromArray(values) {
        return undefined;
    }
}
$eae21cbfe0657f11$export$c84671f46d6a1ca = $eae21cbfe0657f11$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $eae21cbfe0657f11$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
$eae21cbfe0657f11$export$afa1a74657000b67 = $eae21cbfe0657f11$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ function $eae21cbfe0657f11$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Class.hasOwnProperty("layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $eae21cbfe0657f11$var$Layout)) throw new TypeError("layout must be a Layout");
    if (layout.hasOwnProperty("boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value: function(b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value: function(b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
$eae21cbfe0657f11$export$888df3b4497fe914 = $eae21cbfe0657f11$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$ExternalLayout extends $eae21cbfe0657f11$var$Layout {
    /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $eae21cbfe0657f11$var$GreedyCount extends $eae21cbfe0657f11$var$ExternalLayout {
    constructor(elementSpan, property){
        if (undefined === elementSpan) elementSpan = 1;
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
     * must be a positive integer.  If not provided, the value will be
     * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$OffsetLayout extends $eae21cbfe0657f11$var$ExternalLayout {
    constructor(layout, offset, property){
        if (!(layout instanceof $eae21cbfe0657f11$var$Layout)) throw new TypeError("layout must be a Layout");
        if (undefined === offset) offset = 0;
        else if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
     * start of another layout.
     *
     * The value may be positive or negative, but an error will thrown
     * if at the point of use it goes outside the span of the Buffer
     * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $eae21cbfe0657f11$var$UInt || this.layout instanceof $eae21cbfe0657f11$var$UIntBE;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.encode(src, b, offset + this.offset);
    }
}
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$UInt extends $eae21cbfe0657f11$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$UIntBE extends $eae21cbfe0657f11$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Int extends $eae21cbfe0657f11$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeIntLE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$IntBE extends $eae21cbfe0657f11$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeIntBE(src, offset, this.span);
        return this.span;
    }
}
const $eae21cbfe0657f11$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $eae21cbfe0657f11$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $eae21cbfe0657f11$var$V2E32);
    const lo32 = src - hi32 * $eae21cbfe0657f11$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $eae21cbfe0657f11$var$roundedInt64(hi32, lo32) {
    return hi32 * $eae21cbfe0657f11$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$NearUInt64 extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readUInt32LE(offset + 4);
        return $eae21cbfe0657f11$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $eae21cbfe0657f11$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$NearUInt64BE extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const hi32 = b.readUInt32BE(offset);
        const lo32 = b.readUInt32BE(offset + 4);
        return $eae21cbfe0657f11$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $eae21cbfe0657f11$var$divmodInt64(src);
        b.writeUInt32BE(split.hi32, offset);
        b.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$NearInt64 extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readInt32LE(offset + 4);
        return $eae21cbfe0657f11$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $eae21cbfe0657f11$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$NearInt64BE extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const hi32 = b.readInt32BE(offset);
        const lo32 = b.readUInt32BE(offset + 4);
        return $eae21cbfe0657f11$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $eae21cbfe0657f11$var$divmodInt64(src);
        b.writeInt32BE(split.hi32, offset);
        b.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Float extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeFloatLE(src, offset);
        return 4;
    }
}
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$FloatBE extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeFloatBE(src, offset);
        return 4;
    }
}
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Double extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeDoubleLE(src, offset);
        return 8;
    }
}
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$DoubleBE extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeDoubleBE(src, offset);
        return 8;
    }
}
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Sequence extends $eae21cbfe0657f11$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $eae21cbfe0657f11$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $eae21cbfe0657f11$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $eae21cbfe0657f11$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
     *
     * This will be either a non-negative integer or an instance of
     * {@link ExternalLayout} for which {@link
     * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        let span = 0;
        let count = this.count;
        if (count instanceof $eae21cbfe0657f11$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $eae21cbfe0657f11$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $eae21cbfe0657f11$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Structure extends $eae21cbfe0657f11$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $eae21cbfe0657f11$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {}
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
     * structure.
     *
     * The individual elements need not be the same type, and may be
     * either scalar or aggregate layouts.  If a member layout leaves
     * its {@link Layout#property|property} undefined the
     * corresponding region of the buffer associated with the element
     * will not be mutated.
     *
     * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
     * buffers.
     *
     * In some situations a structure many be extended with additional
     * fields over time, with older installations providing only a
     * prefix of the full structure.  If this property is `true`
     * decoding will accept those buffers and leave subsequent fields
     * undefined, as long as the buffer ends at a field boundary.
     * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
             * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
     * item may have had a dynamic length and we don't want to include
     * the padding between it and the end of the space reserved for
     * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
    }
    /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
    }
}
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $eae21cbfe0657f11$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
     * discriminator is referenced in isolation (generally when {@link
     * Union#decode|Union decode} cannot delegate to a specific
     * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */ decode() {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */ encode() {
        throw new Error("UnionDiscriminator is abstract");
    }
}
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $eae21cbfe0657f11$var$UnionLayoutDiscriminator extends $eae21cbfe0657f11$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $eae21cbfe0657f11$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
     * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Union extends $eae21cbfe0657f11$var$Layout {
    constructor(discr, defaultLayout, property){
        const upv = discr instanceof $eae21cbfe0657f11$var$UInt || discr instanceof $eae21cbfe0657f11$var$UIntBE;
        if (upv) discr = new $eae21cbfe0657f11$var$UnionLayoutDiscriminator(new $eae21cbfe0657f11$var$OffsetLayout(discr));
        else if (discr instanceof $eae21cbfe0657f11$var$ExternalLayout && discr.isCount()) discr = new $eae21cbfe0657f11$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $eae21cbfe0657f11$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $eae21cbfe0657f11$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
     * layout.  The union spans its default layout, plus any prefix
     * variant layout.  By construction both layouts, if present, have
     * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && upv) span += discr.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
     *
     * This a {@link UnionDiscriminator} either passed to the
     * constructor or synthesized from the `discr` constructor
     * argument.  {@link
     * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
     * `true` iff the `discr` parameter was a non-offset {@link
     * Layout} instance. */ this.discriminator = discr;
        /** `true` if the {@link Union#discriminator|discriminator} is the
     * first field in the union.
     *
     * If `false` the discriminator is obtained from somewhere
     * else. */ this.usesPrefixDiscriminator = upv;
        /** The layout for non-discriminator content when the value of the
     * discriminator is not recognized.
     *
     * This is the value passed to the constructor.  It is
     * structurally equivalent to the second component of {@link
     * Union#layout|layout} but may have a different property
     * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
     *
     * The keys are unsigned integers which should be compatible with
     * {@link Union.discriminator|discriminator}.  The property value
     * is the corresponding {@link VariantLayout} instances assigned
     * to this union by {@link Union#addVariant|addVariant}.
     *
     * **NOTE** The registry remains mutable so that variants can be
     * {@link Union#addVariant|added} at any time.  Users should not
     * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
     *
     * Defaults to {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
     * be overridden using {@link
     * Union#configGetSourceVariant|configGetSourceVariant}.
     *
     * @param {Object} src - as with {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * @returns {(undefined|VariantLayout)} The default variant
     * (`undefined`) or first registered variant that uses a property
     * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
     * Union#getSourceVariant|getSourceVariant}.
     *
     * Use this if the desired variant cannot be identified using the
     * algorithm of {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * **NOTE** The provided function will be invoked bound to this
     * Union instance, providing local access to {@link
     * Union#registry|registry}.
     *
     * @param {Function} gsv - a function that follows the API of
     * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        /* Default layouts always have non-negative span, so we don't have
     * one and we have to recognize the variant which will in turn
     * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */ defaultGetSourceVariant(src) {
        if (src.hasOwnProperty(this.discriminator.property)) {
            if (this.defaultLayout && src.hasOwnProperty(this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || src.hasOwnProperty(vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (src.hasOwnProperty(vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        let clo = this.registry[discr];
        if (undefined === clo) {
            let contentOffset = 0;
            clo = this.defaultLayout;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            dest[clo.property] = this.defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $eae21cbfe0657f11$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */ getVariant(vb, offset) {
        let variant = vb;
        if ($eae21cbfe0657f11$require$Buffer.isBuffer(vb)) {
            if (undefined === offset) offset = 0;
            variant = this.discriminator.decode(vb, offset);
        }
        return this.registry[variant];
    }
}
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$VariantLayout extends $eae21cbfe0657f11$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $eae21cbfe0657f11$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $eae21cbfe0657f11$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
     * the {@link Union#discriminator|discriminator} of the containing
     * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
     * non-discriminator part of the {@link
     * VariantLayout#union|union}.  If `null` the variant carries no
     * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
       * variable. */ return this.span;
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ return contentOffset + this.layout.getSpan(b, offset + contentOffset);
    }
    /** @override */ decode(b, offset) {
        const dest = this.makeDestinationObject();
        if (undefined === offset) offset = 0;
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !src.hasOwnProperty(this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
    }
}
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $eae21cbfe0657f11$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$BitStructure extends $eae21cbfe0657f11$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $eae21cbfe0657f11$var$UInt || word instanceof $eae21cbfe0657f11$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = undefined;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
     * instances are packed sequentially depending on {@link
     * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
     * significant bit growing down (`true`), or the least significant
     * bit growing up (`false`).
     *
     * **NOTE** Regardless of this value, the least significant bit of
     * any {@link BitField} value is the least significant bit of the
     * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
     * packed structure.
     *
     * **NOTE** The array remains mutable to allow fields to be {@link
     * BitStructure#addField|added} after construction.  Users should
     * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
     * instance property because we don't want anything to change the
     * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $eae21cbfe0657f11$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset) {
        const dest = this.makeDestinationObject();
        if (undefined === offset) offset = 0;
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(value);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */ addField(bits, property) {
        const bf = new $eae21cbfe0657f11$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */ addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        // eslint-disable-next-line no-new-wrappers
        const bf = new $eae21cbfe0657f11$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
    }
}
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $eae21cbfe0657f11$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $eae21cbfe0657f11$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
     * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
     * that fit within the field.
     *
     * That is, it masks a value that has not yet been shifted into
     * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
     * integer.  The least significant bit of the packed value is at
     * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
     * within the containing packed unsigned integer. */ this.wordMask = $eae21cbfe0657f11$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
     * Object.
     *
     * Intended to be functionally equivalent to {@link
     * Layout#property}.
     *
     * If left undefined the corresponding span of bits will be
     * treated as padding: it will not be mutated by {@link
     * Layout#encode|encode} nor represented as a property in the
     * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
   * bit field. */ decode() {
        const word = this.container._packedGetValue();
        const wordValue = $eae21cbfe0657f11$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if (!Number.isInteger(value) || value !== $eae21cbfe0657f11$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($eae21cbfe0657f11$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $eae21cbfe0657f11$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($eae21cbfe0657f11$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $eae21cbfe0657f11$var$Boolean extends $eae21cbfe0657f11$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */ decode(b, offset) {
        return !!$eae21cbfe0657f11$var$BitField.prototype.decode.call(this, b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        return $eae21cbfe0657f11$var$BitField.prototype.encode.call(this, value);
    }
}
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Buffer.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Blob extends $eae21cbfe0657f11$var$Layout {
    constructor(length, property){
        if (!(length instanceof $eae21cbfe0657f11$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $eae21cbfe0657f11$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
     *
     * This may be a non-negative integer, or an instance of {@link
     * ExternalLayout} that satisfies {@link
     * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return b.slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $eae21cbfe0657f11$var$ExternalLayout) span = src.length;
        if (!($eae21cbfe0657f11$require$Buffer.isBuffer(src) && span === src.length)) throw new TypeError($eae21cbfe0657f11$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Buffer as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        b.write(src.toString("hex"), offset, span, "hex");
        if (this.length instanceof $eae21cbfe0657f11$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$CString extends $eae21cbfe0657f11$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset) {
        if (!$eae21cbfe0657f11$require$Buffer.isBuffer(b)) throw new TypeError("b must be a Buffer");
        if (undefined === offset) offset = 0;
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset, dest) {
        if (undefined === offset) offset = 0;
        let span = this.getSpan(b, offset);
        return b.slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        /* Must force this to a string, lest it be a number and the
     * "utf8-encoding" below actually allocate a buffer of length
     * src */ if ("string" !== typeof src) src = src.toString();
        const srcb = new $eae21cbfe0657f11$require$Buffer(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy(b, offset);
        b[offset + span] = 0;
        return span + 1;
    }
}
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$UTF8 extends $eae21cbfe0657f11$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
     *
     * Positive values are generally expected.  Zero is abnormal.
     * Attempts to encode or decode a value that exceeds this length
     * will throw a `RangeError`.
     *
     * A negative value indicates that there is no bound on the length
     * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset) {
        if (!$eae21cbfe0657f11$require$Buffer.isBuffer(b)) throw new TypeError("b must be a Buffer");
        if (undefined === offset) offset = 0;
        return b.length - offset;
    }
    /** @override */ decode(b, offset, dest) {
        if (undefined === offset) offset = 0;
        let span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return b.slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        /* Must force this to a string, lest it be a number and the
     * "utf8-encoding" below actually allocate a buffer of length
     * src */ if ("string" !== typeof src) src = src.toString();
        const srcb = new $eae21cbfe0657f11$require$Buffer(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy(b, offset);
        return span;
    }
}
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $eae21cbfe0657f11$var$Constant extends $eae21cbfe0657f11$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
     * Constant#decode|decoded}.
     *
     * Any JavaScript value including `null` and `undefined` is
     * permitted.
     *
     * **WARNING** If `value` passed in the constructor was not
     * frozen, it is possible for users of decoded values to change
     * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset, dest) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
$eae21cbfe0657f11$export$3fbe2a7b321c34e0 = $eae21cbfe0657f11$var$ExternalLayout;
$eae21cbfe0657f11$export$a1423b48ba9f7b82 = $eae21cbfe0657f11$var$GreedyCount;
$eae21cbfe0657f11$export$33b72ac7c0edff27 = $eae21cbfe0657f11$var$OffsetLayout;
$eae21cbfe0657f11$export$5aaa69e6f271b98f = $eae21cbfe0657f11$var$UInt;
$eae21cbfe0657f11$export$75952b3c9b52942f = $eae21cbfe0657f11$var$UIntBE;
$eae21cbfe0657f11$export$fdd676b64b72b00 = $eae21cbfe0657f11$var$Int;
$eae21cbfe0657f11$export$6d6a6e3ae3c61752 = $eae21cbfe0657f11$var$IntBE;
$eae21cbfe0657f11$export$bb89b76e902dbdb5 = $eae21cbfe0657f11$var$Float;
$eae21cbfe0657f11$export$d68cbce6ee5a6137 = $eae21cbfe0657f11$var$FloatBE;
$eae21cbfe0657f11$export$340e583a64e26663 = $eae21cbfe0657f11$var$Double;
$eae21cbfe0657f11$export$776a1c887f98bb0a = $eae21cbfe0657f11$var$DoubleBE;
$eae21cbfe0657f11$export$edde1bcb1b2b310e = $eae21cbfe0657f11$var$Sequence;
$eae21cbfe0657f11$export$d981182684770f2a = $eae21cbfe0657f11$var$Structure;
$eae21cbfe0657f11$export$5e5f461bb7edf74c = $eae21cbfe0657f11$var$UnionDiscriminator;
$eae21cbfe0657f11$export$c05dde5a34d9ea51 = $eae21cbfe0657f11$var$UnionLayoutDiscriminator;
$eae21cbfe0657f11$export$6cbb4f8fa0c4c986 = $eae21cbfe0657f11$var$Union;
$eae21cbfe0657f11$export$57ee95071e9ec5f5 = $eae21cbfe0657f11$var$VariantLayout;
$eae21cbfe0657f11$export$2bdec8c076c815b2 = $eae21cbfe0657f11$var$BitStructure;
$eae21cbfe0657f11$export$f8e44e1658c8d14c = $eae21cbfe0657f11$var$BitField;
$eae21cbfe0657f11$export$f9e6d957cb90bdc0 = $eae21cbfe0657f11$var$Boolean;
$eae21cbfe0657f11$export$3b660928c86ff55c = $eae21cbfe0657f11$var$Blob;
$eae21cbfe0657f11$export$744d9d543319c3c = $eae21cbfe0657f11$var$CString;
$eae21cbfe0657f11$export$9560dad2a83e4f04 = $eae21cbfe0657f11$var$UTF8;
$eae21cbfe0657f11$export$3c508fb3f8ac1ad4 = $eae21cbfe0657f11$var$Constant;
$eae21cbfe0657f11$export$299a26fa2ceaa3f8 = (elementSpan, property)=>new $eae21cbfe0657f11$var$GreedyCount(elementSpan, property);
$eae21cbfe0657f11$export$cc800923e997bb8 = (layout, offset, property)=>new $eae21cbfe0657f11$var$OffsetLayout(layout, offset, property);
$eae21cbfe0657f11$export$9813fca58c0b9f71 = (property)=>new $eae21cbfe0657f11$var$UInt(1, property);
$eae21cbfe0657f11$export$73c443a9dbe0d04a = (property)=>new $eae21cbfe0657f11$var$UInt(2, property);
$eae21cbfe0657f11$export$9bf749af8ce6f6f8 = (property)=>new $eae21cbfe0657f11$var$UInt(3, property);
$eae21cbfe0657f11$export$8bacf4ad828c7fe7 = (property)=>new $eae21cbfe0657f11$var$UInt(4, property);
$eae21cbfe0657f11$export$ecb77dab600c8b47 = (property)=>new $eae21cbfe0657f11$var$UInt(5, property);
$eae21cbfe0657f11$export$d95fd39a3a649e76 = (property)=>new $eae21cbfe0657f11$var$UInt(6, property);
$eae21cbfe0657f11$export$bb5970674287ec35 = (property)=>new $eae21cbfe0657f11$var$NearUInt64(property);
$eae21cbfe0657f11$export$c432074536ef0c2c = (property)=>new $eae21cbfe0657f11$var$UIntBE(2, property);
$eae21cbfe0657f11$export$eb2b2a282bde1478 = (property)=>new $eae21cbfe0657f11$var$UIntBE(3, property);
$eae21cbfe0657f11$export$231c4b14f4a5c881 = (property)=>new $eae21cbfe0657f11$var$UIntBE(4, property);
$eae21cbfe0657f11$export$d0bca391d9188e81 = (property)=>new $eae21cbfe0657f11$var$UIntBE(5, property);
$eae21cbfe0657f11$export$11edc2f642bfe946 = (property)=>new $eae21cbfe0657f11$var$UIntBE(6, property);
$eae21cbfe0657f11$export$c65c6fa3bdaa77fc = (property)=>new $eae21cbfe0657f11$var$NearUInt64BE(property);
$eae21cbfe0657f11$export$9e2c7b6a4468e78a = (property)=>new $eae21cbfe0657f11$var$Int(1, property);
$eae21cbfe0657f11$export$2573154f1fb93a3e = (property)=>new $eae21cbfe0657f11$var$Int(2, property);
$eae21cbfe0657f11$export$b5ed35f0656342d4 = (property)=>new $eae21cbfe0657f11$var$Int(3, property);
$eae21cbfe0657f11$export$fc2ea698f8ef5ace = (property)=>new $eae21cbfe0657f11$var$Int(4, property);
$eae21cbfe0657f11$export$75a91ba4bc70ae98 = (property)=>new $eae21cbfe0657f11$var$Int(5, property);
$eae21cbfe0657f11$export$cc2aca65bf3735b9 = (property)=>new $eae21cbfe0657f11$var$Int(6, property);
$eae21cbfe0657f11$export$1ab06c27fed8512f = (property)=>new $eae21cbfe0657f11$var$NearInt64(property);
$eae21cbfe0657f11$export$5930f5afc2558c04 = (property)=>new $eae21cbfe0657f11$var$IntBE(2, property);
$eae21cbfe0657f11$export$9708063d81dec021 = (property)=>new $eae21cbfe0657f11$var$IntBE(3, property);
$eae21cbfe0657f11$export$6d35d472f297e5bc = (property)=>new $eae21cbfe0657f11$var$IntBE(4, property);
$eae21cbfe0657f11$export$2f1dc4c509c45ba5 = (property)=>new $eae21cbfe0657f11$var$IntBE(5, property);
$eae21cbfe0657f11$export$8a2927284f04dc17 = (property)=>new $eae21cbfe0657f11$var$IntBE(6, property);
$eae21cbfe0657f11$export$6d75303fcb20b1cb = (property)=>new $eae21cbfe0657f11$var$NearInt64BE(property);
$eae21cbfe0657f11$export$e33361ff41014190 = (property)=>new $eae21cbfe0657f11$var$Float(property);
$eae21cbfe0657f11$export$bb50574a3c55bf79 = (property)=>new $eae21cbfe0657f11$var$FloatBE(property);
$eae21cbfe0657f11$export$eda3f5d9b9872690 = (property)=>new $eae21cbfe0657f11$var$Double(property);
$eae21cbfe0657f11$export$7ad1954a0412d2a0 = (property)=>new $eae21cbfe0657f11$var$DoubleBE(property);
$eae21cbfe0657f11$export$8cf3da7c1c9174ea = (fields, property, decodePrefixes)=>new $eae21cbfe0657f11$var$Structure(fields, property, decodePrefixes);
$eae21cbfe0657f11$export$343c373b6ee94f49 = (word, msb, property)=>new $eae21cbfe0657f11$var$BitStructure(word, msb, property);
$eae21cbfe0657f11$export$1041d4276c328e4d = (elementLayout, count, property)=>new $eae21cbfe0657f11$var$Sequence(elementLayout, count, property);
$eae21cbfe0657f11$export$971dd5b0dfd021b6 = (discr, defaultLayout, property)=>new $eae21cbfe0657f11$var$Union(discr, defaultLayout, property);
$eae21cbfe0657f11$export$abe73b3325e8ad62 = (layout, property)=>new $eae21cbfe0657f11$var$UnionLayoutDiscriminator(layout, property);
$eae21cbfe0657f11$export$8cf3c1c9f525ba2 = (length, property)=>new $eae21cbfe0657f11$var$Blob(length, property);
$eae21cbfe0657f11$export$a0f851cdf0eaf93d = (property)=>new $eae21cbfe0657f11$var$CString(property);
$eae21cbfe0657f11$export$74329b762b589566 = (maxSpan, property)=>new $eae21cbfe0657f11$var$UTF8(maxSpan, property);
$eae21cbfe0657f11$export$5b38a098e5a9e7ca = (value, property)=>new $eae21cbfe0657f11$var$Constant(value, property);



var $1biTx = parcelRequire("1biTx");

const $8e63f10e9557e84e$var$bn_js_1 = $8e63f10e9557e84e$var$__importDefault((parcelRequire("cj5EG")));

Object.defineProperty($8e63f10e9557e84e$exports, "u8", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$9813fca58c0b9f71;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "i8", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$9e2c7b6a4468e78a;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "u16", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$73c443a9dbe0d04a;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "i16", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$2573154f1fb93a3e;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "u32", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$8bacf4ad828c7fe7;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "i32", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$fc2ea698f8ef5ace;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "f32", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$e33361ff41014190;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "f64", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$eda3f5d9b9872690;
    }
});
Object.defineProperty($8e63f10e9557e84e$exports, "struct", {
    enumerable: true,
    get: function() {
        return $eae21cbfe0657f11$export$8cf3da7c1c9174ea;
    }
});
class $8e63f10e9557e84e$var$BNLayout extends $eae21cbfe0657f11$export$c84671f46d6a1ca {
    constructor(span, signed, property){
        super(span, property);
        this.blob = (0, $eae21cbfe0657f11$export$8cf3c1c9f525ba2)(span);
        this.signed = signed;
    }
    decode(b, offset = 0) {
        const num = new $8e63f10e9557e84e$var$bn_js_1.default(this.blob.decode(b, offset), 10, "le");
        if (this.signed) return num.fromTwos(this.span * 8).clone();
        return num;
    }
    encode(src, b, offset = 0) {
        if (this.signed) src = src.toTwos(this.span * 8);
        return this.blob.encode(src.toArrayLike($8e63f10e9557e84e$require$Buffer, "le", this.span), b, offset);
    }
}
function $8e63f10e9557e84e$var$u64(property) {
    return new $8e63f10e9557e84e$var$BNLayout(8, false, property);
}
$8e63f10e9557e84e$exports.u64 = $8e63f10e9557e84e$var$u64;
function $8e63f10e9557e84e$var$i64(property) {
    return new $8e63f10e9557e84e$var$BNLayout(8, true, property);
}
$8e63f10e9557e84e$exports.i64 = $8e63f10e9557e84e$var$i64;
function $8e63f10e9557e84e$var$u128(property) {
    return new $8e63f10e9557e84e$var$BNLayout(16, false, property);
}
$8e63f10e9557e84e$exports.u128 = $8e63f10e9557e84e$var$u128;
function $8e63f10e9557e84e$var$i128(property) {
    return new $8e63f10e9557e84e$var$BNLayout(16, true, property);
}
$8e63f10e9557e84e$exports.i128 = $8e63f10e9557e84e$var$i128;
function $8e63f10e9557e84e$var$u256(property) {
    return new $8e63f10e9557e84e$var$BNLayout(32, false, property);
}
$8e63f10e9557e84e$exports.u256 = $8e63f10e9557e84e$var$u256;
function $8e63f10e9557e84e$var$i256(property) {
    return new $8e63f10e9557e84e$var$BNLayout(32, true, property);
}
$8e63f10e9557e84e$exports.i256 = $8e63f10e9557e84e$var$i256;
class $8e63f10e9557e84e$var$WrappedLayout extends $eae21cbfe0657f11$export$c84671f46d6a1ca {
    constructor(layout, decoder, encoder, property){
        super(layout.span, property);
        this.layout = layout;
        this.decoder = decoder;
        this.encoder = encoder;
    }
    decode(b, offset) {
        return this.decoder(this.layout.decode(b, offset));
    }
    encode(src, b, offset) {
        return this.layout.encode(this.encoder(src), b, offset);
    }
    getSpan(b, offset) {
        return this.layout.getSpan(b, offset);
    }
}
function $8e63f10e9557e84e$var$publicKey(property) {
    return new $8e63f10e9557e84e$var$WrappedLayout((0, $eae21cbfe0657f11$export$8cf3c1c9f525ba2)(32), (b)=>new $1biTx.PublicKey(b), (key)=>key.toBuffer(), property);
}
$8e63f10e9557e84e$exports.publicKey = $8e63f10e9557e84e$var$publicKey;
class $8e63f10e9557e84e$var$OptionLayout extends $eae21cbfe0657f11$export$c84671f46d6a1ca {
    constructor(layout, property){
        super(-1, property);
        this.layout = layout;
        this.discriminator = (0, $eae21cbfe0657f11$export$9813fca58c0b9f71)();
    }
    encode(src, b, offset = 0) {
        if (src === null || src === undefined) return this.discriminator.encode(0, b, offset);
        this.discriminator.encode(1, b, offset);
        return this.layout.encode(src, b, offset + 1) + 1;
    }
    decode(b, offset = 0) {
        const discriminator = this.discriminator.decode(b, offset);
        if (discriminator === 0) return null;
        else if (discriminator === 1) return this.layout.decode(b, offset + 1);
        throw new Error("Invalid option " + this.property);
    }
    getSpan(b, offset = 0) {
        const discriminator = this.discriminator.decode(b, offset);
        if (discriminator === 0) return 1;
        else if (discriminator === 1) return this.layout.getSpan(b, offset + 1) + 1;
        throw new Error("Invalid option " + this.property);
    }
}
function $8e63f10e9557e84e$var$option(layout, property) {
    return new $8e63f10e9557e84e$var$OptionLayout(layout, property);
}
$8e63f10e9557e84e$exports.option = $8e63f10e9557e84e$var$option;
function $8e63f10e9557e84e$var$bool(property) {
    return new $8e63f10e9557e84e$var$WrappedLayout((0, $eae21cbfe0657f11$export$9813fca58c0b9f71)(), $8e63f10e9557e84e$var$decodeBool, $8e63f10e9557e84e$var$encodeBool, property);
}
$8e63f10e9557e84e$exports.bool = $8e63f10e9557e84e$var$bool;
function $8e63f10e9557e84e$var$decodeBool(value) {
    if (value === 0) return false;
    else if (value === 1) return true;
    throw new Error("Invalid bool: " + value);
}
function $8e63f10e9557e84e$var$encodeBool(value) {
    return value ? 1 : 0;
}
function $8e63f10e9557e84e$var$vec(elementLayout, property) {
    const length = (0, $eae21cbfe0657f11$export$8bacf4ad828c7fe7)("length");
    const layout = (0, $eae21cbfe0657f11$export$8cf3da7c1c9174ea)([
        length,
        (0, $eae21cbfe0657f11$export$1041d4276c328e4d)(elementLayout, (0, $eae21cbfe0657f11$export$cc800923e997bb8)(length, -length.span), "values")
    ]);
    return new $8e63f10e9557e84e$var$WrappedLayout(layout, ({ values: values })=>values, (values)=>({
            values: values
        }), property);
}
$8e63f10e9557e84e$exports.vec = $8e63f10e9557e84e$var$vec;
function $8e63f10e9557e84e$var$tagged(tag, layout, property) {
    const wrappedLayout = (0, $eae21cbfe0657f11$export$8cf3da7c1c9174ea)([
        $8e63f10e9557e84e$var$u64("tag"),
        layout.replicate("data")
    ]);
    function decodeTag({ tag: receivedTag, data: data }) {
        if (!receivedTag.eq(tag)) throw new Error("Invalid tag, expected: " + tag.toString("hex") + ", got: " + receivedTag.toString("hex"));
        return data;
    }
    return new $8e63f10e9557e84e$var$WrappedLayout(wrappedLayout, decodeTag, (data)=>({
            tag: tag,
            data: data
        }), property);
}
$8e63f10e9557e84e$exports.tagged = $8e63f10e9557e84e$var$tagged;
function $8e63f10e9557e84e$var$vecU8(property) {
    const length = (0, $eae21cbfe0657f11$export$8bacf4ad828c7fe7)("length");
    const layout = (0, $eae21cbfe0657f11$export$8cf3da7c1c9174ea)([
        length,
        (0, $eae21cbfe0657f11$export$8cf3c1c9f525ba2)((0, $eae21cbfe0657f11$export$cc800923e997bb8)(length, -length.span), "data")
    ]);
    return new $8e63f10e9557e84e$var$WrappedLayout(layout, ({ data: data })=>data, (data)=>({
            data: data
        }), property);
}
$8e63f10e9557e84e$exports.vecU8 = $8e63f10e9557e84e$var$vecU8;
function $8e63f10e9557e84e$var$str(property) {
    return new $8e63f10e9557e84e$var$WrappedLayout($8e63f10e9557e84e$var$vecU8(), (data)=>data.toString("utf-8"), (s)=>$8e63f10e9557e84e$require$Buffer.from(s, "utf-8"), property);
}
$8e63f10e9557e84e$exports.str = $8e63f10e9557e84e$var$str;
function $8e63f10e9557e84e$var$rustEnum(variants, property, discriminant) {
    const unionLayout = (0, $eae21cbfe0657f11$export$971dd5b0dfd021b6)(discriminant !== null && discriminant !== void 0 ? discriminant : (0, $eae21cbfe0657f11$export$9813fca58c0b9f71)(), property);
    variants.forEach((variant, index)=>unionLayout.addVariant(index, variant, variant.property));
    return unionLayout;
}
$8e63f10e9557e84e$exports.rustEnum = $8e63f10e9557e84e$var$rustEnum;
function $8e63f10e9557e84e$var$array(elementLayout, length, property) {
    const layout = (0, $eae21cbfe0657f11$export$8cf3da7c1c9174ea)([
        (0, $eae21cbfe0657f11$export$1041d4276c328e4d)(elementLayout, length, "values")
    ]);
    return new $8e63f10e9557e84e$var$WrappedLayout(layout, ({ values: values })=>values, (values)=>({
            values: values
        }), property);
}
$8e63f10e9557e84e$exports.array = $8e63f10e9557e84e$var$array;
class $8e63f10e9557e84e$var$MapEntryLayout extends $eae21cbfe0657f11$export$c84671f46d6a1ca {
    constructor(keyLayout, valueLayout, property){
        super(keyLayout.span + valueLayout.span, property);
        this.keyLayout = keyLayout;
        this.valueLayout = valueLayout;
    }
    decode(b, offset) {
        offset = offset || 0;
        const key = this.keyLayout.decode(b, offset);
        const value = this.valueLayout.decode(b, offset + this.keyLayout.getSpan(b, offset));
        return [
            key,
            value
        ];
    }
    encode(src, b, offset) {
        offset = offset || 0;
        const keyBytes = this.keyLayout.encode(src[0], b, offset);
        const valueBytes = this.valueLayout.encode(src[1], b, offset + keyBytes);
        return keyBytes + valueBytes;
    }
    getSpan(b, offset) {
        return this.keyLayout.getSpan(b, offset) + this.valueLayout.getSpan(b, offset);
    }
}
function $8e63f10e9557e84e$var$map(keyLayout, valueLayout, property) {
    const length = (0, $eae21cbfe0657f11$export$8bacf4ad828c7fe7)("length");
    const layout = (0, $eae21cbfe0657f11$export$8cf3da7c1c9174ea)([
        length,
        (0, $eae21cbfe0657f11$export$1041d4276c328e4d)(new $8e63f10e9557e84e$var$MapEntryLayout(keyLayout, valueLayout), (0, $eae21cbfe0657f11$export$cc800923e997bb8)(length, -length.span), "values")
    ]);
    return new $8e63f10e9557e84e$var$WrappedLayout(layout, ({ values: values })=>new Map(values), (values)=>({
            values: Array.from(values.entries())
        }), property);
}
$8e63f10e9557e84e$exports.map = $8e63f10e9557e84e$var$map;



var $9XCBn = parcelRequire("9XCBn");
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $2d68152abb7d3417$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $2d68152abb7d3417$var$Z_BINARY = 0;
const $2d68152abb7d3417$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $2d68152abb7d3417$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $2d68152abb7d3417$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $2d68152abb7d3417$var$STORED_BLOCK = 0;
const $2d68152abb7d3417$var$STATIC_TREES = 1;
const $2d68152abb7d3417$var$DYN_TREES = 2;
/* The three kinds of block type */ const $2d68152abb7d3417$var$MIN_MATCH$1 = 3;
const $2d68152abb7d3417$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $2d68152abb7d3417$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2d68152abb7d3417$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $2d68152abb7d3417$var$L_CODES$1 = $2d68152abb7d3417$var$LITERALS$1 + 1 + $2d68152abb7d3417$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2d68152abb7d3417$var$D_CODES$1 = 30;
/* number of distance codes */ const $2d68152abb7d3417$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $2d68152abb7d3417$var$HEAP_SIZE$1 = 2 * $2d68152abb7d3417$var$L_CODES$1 + 1;
/* maximum heap size */ const $2d68152abb7d3417$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $2d68152abb7d3417$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $2d68152abb7d3417$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $2d68152abb7d3417$var$END_BLOCK = 256;
/* end of block literal code */ const $2d68152abb7d3417$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $2d68152abb7d3417$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $2d68152abb7d3417$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $2d68152abb7d3417$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $2d68152abb7d3417$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $2d68152abb7d3417$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $2d68152abb7d3417$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $2d68152abb7d3417$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $2d68152abb7d3417$var$static_ltree = new Array(($2d68152abb7d3417$var$L_CODES$1 + 2) * 2);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $2d68152abb7d3417$var$static_dtree = new Array($2d68152abb7d3417$var$D_CODES$1 * 2);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $2d68152abb7d3417$var$_dist_code = new Array($2d68152abb7d3417$var$DIST_CODE_LEN);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $2d68152abb7d3417$var$_length_code = new Array($2d68152abb7d3417$var$MAX_MATCH$1 - $2d68152abb7d3417$var$MIN_MATCH$1 + 1);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $2d68152abb7d3417$var$base_length = new Array($2d68152abb7d3417$var$LENGTH_CODES$1);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $2d68152abb7d3417$var$base_dist = new Array($2d68152abb7d3417$var$D_CODES$1);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $2d68152abb7d3417$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $2d68152abb7d3417$var$static_l_desc;
let $2d68152abb7d3417$var$static_d_desc;
let $2d68152abb7d3417$var$static_bl_desc;
function $2d68152abb7d3417$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $2d68152abb7d3417$var$d_code = (dist)=>{
    return dist < 256 ? $2d68152abb7d3417$var$_dist_code[dist] : $2d68152abb7d3417$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $2d68152abb7d3417$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $2d68152abb7d3417$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $2d68152abb7d3417$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $2d68152abb7d3417$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $2d68152abb7d3417$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $2d68152abb7d3417$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $2d68152abb7d3417$var$send_code = (s, c, tree)=>{
    $2d68152abb7d3417$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $2d68152abb7d3417$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $2d68152abb7d3417$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $2d68152abb7d3417$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $2d68152abb7d3417$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $2d68152abb7d3417$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $2d68152abb7d3417$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $2d68152abb7d3417$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($2d68152abb7d3417$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $2d68152abb7d3417$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $2d68152abb7d3417$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $2d68152abb7d3417$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($2d68152abb7d3417$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $2d68152abb7d3417$var$LENGTH_CODES$1 - 1; code++){
        $2d68152abb7d3417$var$base_length[code] = length;
        for(n = 0; n < 1 << $2d68152abb7d3417$var$extra_lbits[code]; n++)$2d68152abb7d3417$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $2d68152abb7d3417$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $2d68152abb7d3417$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $2d68152abb7d3417$var$extra_dbits[code]; n++)$2d68152abb7d3417$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $2d68152abb7d3417$var$D_CODES$1; code++){
        $2d68152abb7d3417$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $2d68152abb7d3417$var$extra_dbits[code] - 7; n++)$2d68152abb7d3417$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $2d68152abb7d3417$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $2d68152abb7d3417$var$gen_codes($2d68152abb7d3417$var$static_ltree, $2d68152abb7d3417$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $2d68152abb7d3417$var$D_CODES$1; n++){
        $2d68152abb7d3417$var$static_dtree[n * 2 + 1] = 5;
        $2d68152abb7d3417$var$static_dtree[n * 2] = $2d68152abb7d3417$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $2d68152abb7d3417$var$static_l_desc = new $2d68152abb7d3417$var$StaticTreeDesc($2d68152abb7d3417$var$static_ltree, $2d68152abb7d3417$var$extra_lbits, $2d68152abb7d3417$var$LITERALS$1 + 1, $2d68152abb7d3417$var$L_CODES$1, $2d68152abb7d3417$var$MAX_BITS$1);
    $2d68152abb7d3417$var$static_d_desc = new $2d68152abb7d3417$var$StaticTreeDesc($2d68152abb7d3417$var$static_dtree, $2d68152abb7d3417$var$extra_dbits, 0, $2d68152abb7d3417$var$D_CODES$1, $2d68152abb7d3417$var$MAX_BITS$1);
    $2d68152abb7d3417$var$static_bl_desc = new $2d68152abb7d3417$var$StaticTreeDesc(new Array(0), $2d68152abb7d3417$var$extra_blbits, 0, $2d68152abb7d3417$var$BL_CODES$1, $2d68152abb7d3417$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $2d68152abb7d3417$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $2d68152abb7d3417$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $2d68152abb7d3417$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $2d68152abb7d3417$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$2d68152abb7d3417$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $2d68152abb7d3417$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $2d68152abb7d3417$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $2d68152abb7d3417$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $2d68152abb7d3417$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $2d68152abb7d3417$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($2d68152abb7d3417$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $2d68152abb7d3417$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $2d68152abb7d3417$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $2d68152abb7d3417$var$_length_code[lc];
            $2d68152abb7d3417$var$send_code(s, code + $2d68152abb7d3417$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $2d68152abb7d3417$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $2d68152abb7d3417$var$base_length[code];
                $2d68152abb7d3417$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $2d68152abb7d3417$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $2d68152abb7d3417$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $2d68152abb7d3417$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $2d68152abb7d3417$var$base_dist[code];
                $2d68152abb7d3417$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $2d68152abb7d3417$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $2d68152abb7d3417$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$2d68152abb7d3417$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $2d68152abb7d3417$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $2d68152abb7d3417$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $2d68152abb7d3417$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $2d68152abb7d3417$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $2d68152abb7d3417$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$2d68152abb7d3417$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$2d68152abb7d3417$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$2d68152abb7d3417$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $2d68152abb7d3417$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $2d68152abb7d3417$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $2d68152abb7d3417$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$REP_3_6, s.bl_tree);
            $2d68152abb7d3417$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$REPZ_3_10, s.bl_tree);
            $2d68152abb7d3417$var$send_bits(s, count - 3, 3);
        } else {
            $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$REPZ_11_138, s.bl_tree);
            $2d68152abb7d3417$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $2d68152abb7d3417$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $2d68152abb7d3417$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $2d68152abb7d3417$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $2d68152abb7d3417$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $2d68152abb7d3417$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$2d68152abb7d3417$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $2d68152abb7d3417$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $2d68152abb7d3417$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $2d68152abb7d3417$var$send_bits(s, dcodes - 1, 5);
    $2d68152abb7d3417$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $2d68152abb7d3417$var$send_bits(s, s.bl_tree[$2d68152abb7d3417$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $2d68152abb7d3417$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $2d68152abb7d3417$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $2d68152abb7d3417$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $2d68152abb7d3417$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $2d68152abb7d3417$var$Z_TEXT;
    for(n = 32; n < $2d68152abb7d3417$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $2d68152abb7d3417$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $2d68152abb7d3417$var$Z_BINARY;
};
let $2d68152abb7d3417$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $2d68152abb7d3417$var$_tr_init$1 = (s)=>{
    if (!$2d68152abb7d3417$var$static_init_done) {
        $2d68152abb7d3417$var$tr_static_init();
        $2d68152abb7d3417$var$static_init_done = true;
    }
    s.l_desc = new $2d68152abb7d3417$var$TreeDesc(s.dyn_ltree, $2d68152abb7d3417$var$static_l_desc);
    s.d_desc = new $2d68152abb7d3417$var$TreeDesc(s.dyn_dtree, $2d68152abb7d3417$var$static_d_desc);
    s.bl_desc = new $2d68152abb7d3417$var$TreeDesc(s.bl_tree, $2d68152abb7d3417$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $2d68152abb7d3417$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $2d68152abb7d3417$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $2d68152abb7d3417$var$send_bits(s, ($2d68152abb7d3417$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $2d68152abb7d3417$var$bi_windup(s); /* align on byte boundary */ 
    $2d68152abb7d3417$var$put_short(s, stored_len);
    $2d68152abb7d3417$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $2d68152abb7d3417$var$_tr_align$1 = (s)=>{
    $2d68152abb7d3417$var$send_bits(s, $2d68152abb7d3417$var$STATIC_TREES << 1, 3);
    $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$END_BLOCK, $2d68152abb7d3417$var$static_ltree);
    $2d68152abb7d3417$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $2d68152abb7d3417$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $2d68152abb7d3417$var$Z_UNKNOWN$1) s.strm.data_type = $2d68152abb7d3417$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $2d68152abb7d3417$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $2d68152abb7d3417$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $2d68152abb7d3417$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $2d68152abb7d3417$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $2d68152abb7d3417$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $2d68152abb7d3417$var$send_bits(s, ($2d68152abb7d3417$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $2d68152abb7d3417$var$compress_block(s, $2d68152abb7d3417$var$static_ltree, $2d68152abb7d3417$var$static_dtree);
    } else {
        $2d68152abb7d3417$var$send_bits(s, ($2d68152abb7d3417$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $2d68152abb7d3417$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $2d68152abb7d3417$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $2d68152abb7d3417$var$init_block(s);
    if (last) $2d68152abb7d3417$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $2d68152abb7d3417$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($2d68152abb7d3417$var$_length_code[lc] + $2d68152abb7d3417$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$2d68152abb7d3417$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $2d68152abb7d3417$var$_tr_init_1 = $2d68152abb7d3417$var$_tr_init$1;
var $2d68152abb7d3417$var$_tr_stored_block_1 = $2d68152abb7d3417$var$_tr_stored_block$1;
var $2d68152abb7d3417$var$_tr_flush_block_1 = $2d68152abb7d3417$var$_tr_flush_block$1;
var $2d68152abb7d3417$var$_tr_tally_1 = $2d68152abb7d3417$var$_tr_tally$1;
var $2d68152abb7d3417$var$_tr_align_1 = $2d68152abb7d3417$var$_tr_align$1;
var $2d68152abb7d3417$var$trees = {
    _tr_init: $2d68152abb7d3417$var$_tr_init_1,
    _tr_stored_block: $2d68152abb7d3417$var$_tr_stored_block_1,
    _tr_flush_block: $2d68152abb7d3417$var$_tr_flush_block_1,
    _tr_tally: $2d68152abb7d3417$var$_tr_tally_1,
    _tr_align: $2d68152abb7d3417$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2d68152abb7d3417$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $2d68152abb7d3417$var$adler32_1 = $2d68152abb7d3417$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $2d68152abb7d3417$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $2d68152abb7d3417$var$crcTable = new Uint32Array($2d68152abb7d3417$var$makeTable());
const $2d68152abb7d3417$var$crc32 = (crc, buf, len, pos)=>{
    const t = $2d68152abb7d3417$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $2d68152abb7d3417$var$crc32_1 = $2d68152abb7d3417$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2d68152abb7d3417$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2d68152abb7d3417$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $2d68152abb7d3417$var$_tr_init, _tr_stored_block: $2d68152abb7d3417$var$_tr_stored_block, _tr_flush_block: $2d68152abb7d3417$var$_tr_flush_block, _tr_tally: $2d68152abb7d3417$var$_tr_tally, _tr_align: $2d68152abb7d3417$var$_tr_align } = $2d68152abb7d3417$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2d68152abb7d3417$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $2d68152abb7d3417$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $2d68152abb7d3417$var$Z_FULL_FLUSH$1, Z_FINISH: $2d68152abb7d3417$var$Z_FINISH$3, Z_BLOCK: $2d68152abb7d3417$var$Z_BLOCK$1, Z_OK: $2d68152abb7d3417$var$Z_OK$3, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END$3, Z_STREAM_ERROR: $2d68152abb7d3417$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $2d68152abb7d3417$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $2d68152abb7d3417$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $2d68152abb7d3417$var$Z_FILTERED, Z_HUFFMAN_ONLY: $2d68152abb7d3417$var$Z_HUFFMAN_ONLY, Z_RLE: $2d68152abb7d3417$var$Z_RLE, Z_FIXED: $2d68152abb7d3417$var$Z_FIXED, Z_DEFAULT_STRATEGY: $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $2d68152abb7d3417$var$Z_UNKNOWN, Z_DEFLATED: $2d68152abb7d3417$var$Z_DEFLATED$2 } = $2d68152abb7d3417$var$constants$2;
/*============================================================================*/ const $2d68152abb7d3417$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $2d68152abb7d3417$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $2d68152abb7d3417$var$DEF_MEM_LEVEL = 8;
const $2d68152abb7d3417$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2d68152abb7d3417$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $2d68152abb7d3417$var$L_CODES = $2d68152abb7d3417$var$LITERALS + 1 + $2d68152abb7d3417$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2d68152abb7d3417$var$D_CODES = 30;
/* number of distance codes */ const $2d68152abb7d3417$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $2d68152abb7d3417$var$HEAP_SIZE = 2 * $2d68152abb7d3417$var$L_CODES + 1;
/* maximum heap size */ const $2d68152abb7d3417$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $2d68152abb7d3417$var$MIN_MATCH = 3;
const $2d68152abb7d3417$var$MAX_MATCH = 258;
const $2d68152abb7d3417$var$MIN_LOOKAHEAD = $2d68152abb7d3417$var$MAX_MATCH + $2d68152abb7d3417$var$MIN_MATCH + 1;
const $2d68152abb7d3417$var$PRESET_DICT = 0x20;
const $2d68152abb7d3417$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $2d68152abb7d3417$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $2d68152abb7d3417$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $2d68152abb7d3417$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $2d68152abb7d3417$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $2d68152abb7d3417$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $2d68152abb7d3417$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $2d68152abb7d3417$var$FINISH_STATE = 666; /* stream complete */ 
const $2d68152abb7d3417$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $2d68152abb7d3417$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $2d68152abb7d3417$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $2d68152abb7d3417$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $2d68152abb7d3417$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $2d68152abb7d3417$var$err = (strm, errorCode)=>{
    strm.msg = $2d68152abb7d3417$var$messages[errorCode];
    return errorCode;
};
const $2d68152abb7d3417$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $2d68152abb7d3417$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $2d68152abb7d3417$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $2d68152abb7d3417$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $2d68152abb7d3417$var$HASH = $2d68152abb7d3417$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $2d68152abb7d3417$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $2d68152abb7d3417$var$flush_block_only = (s, last)=>{
    $2d68152abb7d3417$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $2d68152abb7d3417$var$flush_pending(s.strm);
};
const $2d68152abb7d3417$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $2d68152abb7d3417$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $2d68152abb7d3417$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $2d68152abb7d3417$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $2d68152abb7d3417$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $2d68152abb7d3417$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $2d68152abb7d3417$var$MAX_MATCH - (strend - scan);
        scan = strend - $2d68152abb7d3417$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $2d68152abb7d3417$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $2d68152abb7d3417$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $2d68152abb7d3417$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $2d68152abb7d3417$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[str + $2d68152abb7d3417$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $2d68152abb7d3417$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $2d68152abb7d3417$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $2d68152abb7d3417$var$Z_FINISH$3 || flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $2d68152abb7d3417$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $2d68152abb7d3417$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $2d68152abb7d3417$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $2d68152abb7d3417$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $2d68152abb7d3417$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $2d68152abb7d3417$var$Z_NO_FLUSH$2 && flush !== $2d68152abb7d3417$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $2d68152abb7d3417$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $2d68152abb7d3417$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $2d68152abb7d3417$var$Z_FINISH$3) && flush !== $2d68152abb7d3417$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $2d68152abb7d3417$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $2d68152abb7d3417$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $2d68152abb7d3417$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $2d68152abb7d3417$var$BS_FINISH_STARTED : $2d68152abb7d3417$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $2d68152abb7d3417$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD && flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2d68152abb7d3417$var$longest_match(s, hash_head);
        if (s.match_length >= $2d68152abb7d3417$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $2d68152abb7d3417$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $2d68152abb7d3417$var$MIN_MATCH - 1 ? s.strstart : $2d68152abb7d3417$var$MIN_MATCH - 1;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $2d68152abb7d3417$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD && flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2d68152abb7d3417$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $2d68152abb7d3417$var$Z_FILTERED || s.match_length === $2d68152abb7d3417$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $2d68152abb7d3417$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $2d68152abb7d3417$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $2d68152abb7d3417$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $2d68152abb7d3417$var$MIN_MATCH - 1 ? s.strstart : $2d68152abb7d3417$var$MIN_MATCH - 1;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $2d68152abb7d3417$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $2d68152abb7d3417$var$MAX_MATCH) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead <= $2d68152abb7d3417$var$MAX_MATCH && flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $2d68152abb7d3417$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $2d68152abb7d3417$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $2d68152abb7d3417$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 1, s.match_length - $2d68152abb7d3417$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $2d68152abb7d3417$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $2d68152abb7d3417$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $2d68152abb7d3417$var$configuration_table = [
    /*      good lazy nice chain */ new $2d68152abb7d3417$var$Config(0, 0, 0, 0, $2d68152abb7d3417$var$deflate_stored),
    /* 0 store only */ new $2d68152abb7d3417$var$Config(4, 4, 8, 4, $2d68152abb7d3417$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $2d68152abb7d3417$var$Config(4, 5, 16, 8, $2d68152abb7d3417$var$deflate_fast),
    /* 2 */ new $2d68152abb7d3417$var$Config(4, 6, 32, 32, $2d68152abb7d3417$var$deflate_fast),
    /* 3 */ new $2d68152abb7d3417$var$Config(4, 4, 16, 16, $2d68152abb7d3417$var$deflate_slow),
    /* 4 lazy matches */ new $2d68152abb7d3417$var$Config(8, 16, 32, 32, $2d68152abb7d3417$var$deflate_slow),
    /* 5 */ new $2d68152abb7d3417$var$Config(8, 16, 128, 128, $2d68152abb7d3417$var$deflate_slow),
    /* 6 */ new $2d68152abb7d3417$var$Config(8, 32, 128, 256, $2d68152abb7d3417$var$deflate_slow),
    /* 7 */ new $2d68152abb7d3417$var$Config(32, 128, 258, 1024, $2d68152abb7d3417$var$deflate_slow),
    /* 8 */ new $2d68152abb7d3417$var$Config(32, 258, 258, 4096, $2d68152abb7d3417$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $2d68152abb7d3417$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $2d68152abb7d3417$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $2d68152abb7d3417$var$configuration_table[s.level].max_lazy;
    s.good_match = $2d68152abb7d3417$var$configuration_table[s.level].good_length;
    s.nice_match = $2d68152abb7d3417$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $2d68152abb7d3417$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $2d68152abb7d3417$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $2d68152abb7d3417$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($2d68152abb7d3417$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $2d68152abb7d3417$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $2d68152abb7d3417$var$BL_CODES + 1) * 2);
    $2d68152abb7d3417$var$zero(this.dyn_ltree);
    $2d68152abb7d3417$var$zero(this.dyn_dtree);
    $2d68152abb7d3417$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($2d68152abb7d3417$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $2d68152abb7d3417$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $2d68152abb7d3417$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $2d68152abb7d3417$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $2d68152abb7d3417$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $2d68152abb7d3417$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $2d68152abb7d3417$var$INIT_STATE && //#ifdef GZIP
    s.status !== $2d68152abb7d3417$var$GZIP_STATE && //#endif
    s.status !== $2d68152abb7d3417$var$EXTRA_STATE && s.status !== $2d68152abb7d3417$var$NAME_STATE && s.status !== $2d68152abb7d3417$var$COMMENT_STATE && s.status !== $2d68152abb7d3417$var$HCRC_STATE && s.status !== $2d68152abb7d3417$var$BUSY_STATE && s.status !== $2d68152abb7d3417$var$FINISH_STATE) return 1;
    return 0;
};
const $2d68152abb7d3417$var$deflateResetKeep = (strm)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm)) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $2d68152abb7d3417$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $2d68152abb7d3417$var$GZIP_STATE : //#endif
    s.wrap ? $2d68152abb7d3417$var$INIT_STATE : $2d68152abb7d3417$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $2d68152abb7d3417$var$_tr_init(s);
    return $2d68152abb7d3417$var$Z_OK$3;
};
const $2d68152abb7d3417$var$deflateReset = (strm)=>{
    const ret = $2d68152abb7d3417$var$deflateResetKeep(strm);
    if (ret === $2d68152abb7d3417$var$Z_OK$3) $2d68152abb7d3417$var$lm_init(strm.state);
    return ret;
};
const $2d68152abb7d3417$var$deflateSetHeader = (strm, head)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $2d68152abb7d3417$var$Z_OK$3;
};
const $2d68152abb7d3417$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $2d68152abb7d3417$var$MAX_MEM_LEVEL || method !== $2d68152abb7d3417$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $2d68152abb7d3417$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $2d68152abb7d3417$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $2d68152abb7d3417$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $2d68152abb7d3417$var$MIN_MATCH - 1) / $2d68152abb7d3417$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $2d68152abb7d3417$var$deflateReset(strm);
};
const $2d68152abb7d3417$var$deflateInit = (strm, level)=>{
    return $2d68152abb7d3417$var$deflateInit2(strm, level, $2d68152abb7d3417$var$Z_DEFLATED$2, $2d68152abb7d3417$var$MAX_WBITS$1, $2d68152abb7d3417$var$DEF_MEM_LEVEL, $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $2d68152abb7d3417$var$deflate$2 = (strm, flush)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm) || flush > $2d68152abb7d3417$var$Z_BLOCK$1 || flush < 0) return strm ? $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_STREAM_ERROR$2) : $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $2d68152abb7d3417$var$FINISH_STATE && flush !== $2d68152abb7d3417$var$Z_FINISH$3) return $2d68152abb7d3417$var$err(strm, strm.avail_out === 0 ? $2d68152abb7d3417$var$Z_BUF_ERROR$1 : $2d68152abb7d3417$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $2d68152abb7d3417$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $2d68152abb7d3417$var$rank(flush) <= $2d68152abb7d3417$var$rank(old_flush) && flush !== $2d68152abb7d3417$var$Z_FINISH$3) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $2d68152abb7d3417$var$FINISH_STATE && strm.avail_in !== 0) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $2d68152abb7d3417$var$INIT_STATE && s.wrap === 0) s.status = $2d68152abb7d3417$var$BUSY_STATE;
    if (s.status === $2d68152abb7d3417$var$INIT_STATE) {
        /* zlib header */ let header = $2d68152abb7d3417$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $2d68152abb7d3417$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $2d68152abb7d3417$var$PRESET_DICT;
        header += 31 - header % 31;
        $2d68152abb7d3417$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $2d68152abb7d3417$var$putShortMSB(s, strm.adler >>> 16);
            $2d68152abb7d3417$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $2d68152abb7d3417$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2d68152abb7d3417$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $2d68152abb7d3417$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $2d68152abb7d3417$var$put_byte(s, 31);
        $2d68152abb7d3417$var$put_byte(s, 139);
        $2d68152abb7d3417$var$put_byte(s, 8);
        if (!s.gzhead) {
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2d68152abb7d3417$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2d68152abb7d3417$var$put_byte(s, $2d68152abb7d3417$var$OS_CODE);
            s.status = $2d68152abb7d3417$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $2d68152abb7d3417$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $2d68152abb7d3417$var$Z_OK$3;
            }
        } else {
            $2d68152abb7d3417$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2d68152abb7d3417$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $2d68152abb7d3417$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $2d68152abb7d3417$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $2d68152abb7d3417$var$EXTRA_STATE;
        }
    }
    if (s.status === $2d68152abb7d3417$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $2d68152abb7d3417$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2d68152abb7d3417$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2d68152abb7d3417$var$NAME_STATE;
    }
    if (s.status === $2d68152abb7d3417$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2d68152abb7d3417$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2d68152abb7d3417$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2d68152abb7d3417$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2d68152abb7d3417$var$COMMENT_STATE;
    }
    if (s.status === $2d68152abb7d3417$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2d68152abb7d3417$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2d68152abb7d3417$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2d68152abb7d3417$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $2d68152abb7d3417$var$HCRC_STATE;
    }
    if (s.status === $2d68152abb7d3417$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $2d68152abb7d3417$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2d68152abb7d3417$var$Z_OK$3;
                }
            }
            $2d68152abb7d3417$var$put_byte(s, strm.adler & 0xff);
            $2d68152abb7d3417$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $2d68152abb7d3417$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2d68152abb7d3417$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $2d68152abb7d3417$var$Z_NO_FLUSH$2 && s.status !== $2d68152abb7d3417$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $2d68152abb7d3417$var$deflate_stored(s, flush) : s.strategy === $2d68152abb7d3417$var$Z_HUFFMAN_ONLY ? $2d68152abb7d3417$var$deflate_huff(s, flush) : s.strategy === $2d68152abb7d3417$var$Z_RLE ? $2d68152abb7d3417$var$deflate_rle(s, flush) : $2d68152abb7d3417$var$configuration_table[s.level].func(s, flush);
        if (bstate === $2d68152abb7d3417$var$BS_FINISH_STARTED || bstate === $2d68152abb7d3417$var$BS_FINISH_DONE) s.status = $2d68152abb7d3417$var$FINISH_STATE;
        if (bstate === $2d68152abb7d3417$var$BS_NEED_MORE || bstate === $2d68152abb7d3417$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $2d68152abb7d3417$var$BS_BLOCK_DONE) {
            if (flush === $2d68152abb7d3417$var$Z_PARTIAL_FLUSH) $2d68152abb7d3417$var$_tr_align(s);
            else if (flush !== $2d68152abb7d3417$var$Z_BLOCK$1) {
                $2d68152abb7d3417$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $2d68152abb7d3417$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $2d68152abb7d3417$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $2d68152abb7d3417$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $2d68152abb7d3417$var$Z_OK$3;
            }
        }
    }
    if (flush !== $2d68152abb7d3417$var$Z_FINISH$3) return $2d68152abb7d3417$var$Z_OK$3;
    if (s.wrap <= 0) return $2d68152abb7d3417$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $2d68152abb7d3417$var$put_byte(s, strm.adler & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.adler >> 8 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.adler >> 16 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.adler >> 24 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $2d68152abb7d3417$var$putShortMSB(s, strm.adler >>> 16);
        $2d68152abb7d3417$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $2d68152abb7d3417$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $2d68152abb7d3417$var$Z_OK$3 : $2d68152abb7d3417$var$Z_STREAM_END$3;
};
const $2d68152abb7d3417$var$deflateEnd = (strm)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $2d68152abb7d3417$var$BUSY_STATE ? $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_DATA_ERROR$2) : $2d68152abb7d3417$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $2d68152abb7d3417$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($2d68152abb7d3417$var$deflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $2d68152abb7d3417$var$INIT_STATE || s.lookahead) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $2d68152abb7d3417$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $2d68152abb7d3417$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $2d68152abb7d3417$var$fill_window(s);
    while(s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($2d68152abb7d3417$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[str + $2d68152abb7d3417$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $2d68152abb7d3417$var$MIN_MATCH - 1;
        $2d68152abb7d3417$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $2d68152abb7d3417$var$Z_OK$3;
};
var $2d68152abb7d3417$var$deflateInit_1 = $2d68152abb7d3417$var$deflateInit;
var $2d68152abb7d3417$var$deflateInit2_1 = $2d68152abb7d3417$var$deflateInit2;
var $2d68152abb7d3417$var$deflateReset_1 = $2d68152abb7d3417$var$deflateReset;
var $2d68152abb7d3417$var$deflateResetKeep_1 = $2d68152abb7d3417$var$deflateResetKeep;
var $2d68152abb7d3417$var$deflateSetHeader_1 = $2d68152abb7d3417$var$deflateSetHeader;
var $2d68152abb7d3417$var$deflate_2$1 = $2d68152abb7d3417$var$deflate$2;
var $2d68152abb7d3417$var$deflateEnd_1 = $2d68152abb7d3417$var$deflateEnd;
var $2d68152abb7d3417$var$deflateSetDictionary_1 = $2d68152abb7d3417$var$deflateSetDictionary;
var $2d68152abb7d3417$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $2d68152abb7d3417$var$deflate_1$2 = {
    deflateInit: $2d68152abb7d3417$var$deflateInit_1,
    deflateInit2: $2d68152abb7d3417$var$deflateInit2_1,
    deflateReset: $2d68152abb7d3417$var$deflateReset_1,
    deflateResetKeep: $2d68152abb7d3417$var$deflateResetKeep_1,
    deflateSetHeader: $2d68152abb7d3417$var$deflateSetHeader_1,
    deflate: $2d68152abb7d3417$var$deflate_2$1,
    deflateEnd: $2d68152abb7d3417$var$deflateEnd_1,
    deflateSetDictionary: $2d68152abb7d3417$var$deflateSetDictionary_1,
    deflateInfo: $2d68152abb7d3417$var$deflateInfo
};
const $2d68152abb7d3417$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $2d68152abb7d3417$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(const p in source)if ($2d68152abb7d3417$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $2d68152abb7d3417$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $2d68152abb7d3417$var$common = {
    assign: $2d68152abb7d3417$var$assign,
    flattenChunks: $2d68152abb7d3417$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $2d68152abb7d3417$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $2d68152abb7d3417$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $2d68152abb7d3417$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$2d68152abb7d3417$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$2d68152abb7d3417$var$_utf8len[254] = $2d68152abb7d3417$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $2d68152abb7d3417$var$string2buf = (str)=>{
    if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $2d68152abb7d3417$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $2d68152abb7d3417$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = "";
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $2d68152abb7d3417$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $2d68152abb7d3417$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $2d68152abb7d3417$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $2d68152abb7d3417$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $2d68152abb7d3417$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $2d68152abb7d3417$var$strings = {
    string2buf: $2d68152abb7d3417$var$string2buf,
    buf2string: $2d68152abb7d3417$var$buf2string,
    utf8border: $2d68152abb7d3417$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2d68152abb7d3417$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $2d68152abb7d3417$var$zstream = $2d68152abb7d3417$var$ZStream;
const $2d68152abb7d3417$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2d68152abb7d3417$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $2d68152abb7d3417$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $2d68152abb7d3417$var$Z_FULL_FLUSH, Z_FINISH: $2d68152abb7d3417$var$Z_FINISH$2, Z_OK: $2d68152abb7d3417$var$Z_OK$2, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $2d68152abb7d3417$var$Z_DEFLATED$1 } = $2d68152abb7d3417$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $2d68152abb7d3417$var$Deflate$1(options) {
    this.options = $2d68152abb7d3417$var$common.assign({
        level: $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION,
        method: $2d68152abb7d3417$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2d68152abb7d3417$var$zstream();
    this.strm.avail_out = 0;
    let status = $2d68152abb7d3417$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $2d68152abb7d3417$var$Z_OK$2) throw new Error($2d68152abb7d3417$var$messages[status]);
    if (opt.header) $2d68152abb7d3417$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $2d68152abb7d3417$var$strings.string2buf(opt.dictionary);
        else if ($2d68152abb7d3417$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $2d68152abb7d3417$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $2d68152abb7d3417$var$Z_OK$2) throw new Error($2d68152abb7d3417$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2d68152abb7d3417$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2d68152abb7d3417$var$Z_FINISH$2 : $2d68152abb7d3417$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $2d68152abb7d3417$var$strings.string2buf(data);
    else if ($2d68152abb7d3417$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $2d68152abb7d3417$var$Z_SYNC_FLUSH || _flush_mode === $2d68152abb7d3417$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $2d68152abb7d3417$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $2d68152abb7d3417$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $2d68152abb7d3417$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $2d68152abb7d3417$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2d68152abb7d3417$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2d68152abb7d3417$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2d68152abb7d3417$var$Z_OK$2) this.result = $2d68152abb7d3417$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $2d68152abb7d3417$var$deflate$1(input, options) {
    const deflator = new $2d68152abb7d3417$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $2d68152abb7d3417$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2d68152abb7d3417$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2d68152abb7d3417$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $2d68152abb7d3417$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $2d68152abb7d3417$var$deflate$1(input, options);
}
var $2d68152abb7d3417$var$Deflate_1$1 = $2d68152abb7d3417$var$Deflate$1;
var $2d68152abb7d3417$var$deflate_2 = $2d68152abb7d3417$var$deflate$1;
var $2d68152abb7d3417$var$deflateRaw_1$1 = $2d68152abb7d3417$var$deflateRaw$1;
var $2d68152abb7d3417$var$gzip_1$1 = $2d68152abb7d3417$var$gzip$1;
var $2d68152abb7d3417$var$constants$1 = $2d68152abb7d3417$var$constants$2;
var $2d68152abb7d3417$var$deflate_1$1 = {
    Deflate: $2d68152abb7d3417$var$Deflate_1$1,
    deflate: $2d68152abb7d3417$var$deflate_2,
    deflateRaw: $2d68152abb7d3417$var$deflateRaw_1$1,
    gzip: $2d68152abb7d3417$var$gzip_1$1,
    constants: $2d68152abb7d3417$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $2d68152abb7d3417$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $2d68152abb7d3417$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $2d68152abb7d3417$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $2d68152abb7d3417$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $2d68152abb7d3417$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $2d68152abb7d3417$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $2d68152abb7d3417$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $2d68152abb7d3417$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2d68152abb7d3417$var$MAXBITS = 15;
const $2d68152abb7d3417$var$ENOUGH_LENS$1 = 852;
const $2d68152abb7d3417$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $2d68152abb7d3417$var$CODES$1 = 0;
const $2d68152abb7d3417$var$LENS$1 = 1;
const $2d68152abb7d3417$var$DISTS$1 = 2;
const $2d68152abb7d3417$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $2d68152abb7d3417$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $2d68152abb7d3417$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $2d68152abb7d3417$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $2d68152abb7d3417$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($2d68152abb7d3417$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($2d68152abb7d3417$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $2d68152abb7d3417$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $2d68152abb7d3417$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $2d68152abb7d3417$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $2d68152abb7d3417$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $2d68152abb7d3417$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $2d68152abb7d3417$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $2d68152abb7d3417$var$LENS$1) {
        base = $2d68152abb7d3417$var$lbase;
        extra = $2d68152abb7d3417$var$lext;
        match = 257;
    } else {
        base = $2d68152abb7d3417$var$dbase;
        extra = $2d68152abb7d3417$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $2d68152abb7d3417$var$LENS$1 && used > $2d68152abb7d3417$var$ENOUGH_LENS$1 || type === $2d68152abb7d3417$var$DISTS$1 && used > $2d68152abb7d3417$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $2d68152abb7d3417$var$LENS$1 && used > $2d68152abb7d3417$var$ENOUGH_LENS$1 || type === $2d68152abb7d3417$var$DISTS$1 && used > $2d68152abb7d3417$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $2d68152abb7d3417$var$inftrees = $2d68152abb7d3417$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2d68152abb7d3417$var$CODES = 0;
const $2d68152abb7d3417$var$LENS = 1;
const $2d68152abb7d3417$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $2d68152abb7d3417$var$Z_FINISH$1, Z_BLOCK: $2d68152abb7d3417$var$Z_BLOCK, Z_TREES: $2d68152abb7d3417$var$Z_TREES, Z_OK: $2d68152abb7d3417$var$Z_OK$1, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END$1, Z_NEED_DICT: $2d68152abb7d3417$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $2d68152abb7d3417$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $2d68152abb7d3417$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $2d68152abb7d3417$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $2d68152abb7d3417$var$Z_BUF_ERROR, Z_DEFLATED: $2d68152abb7d3417$var$Z_DEFLATED } = $2d68152abb7d3417$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $2d68152abb7d3417$var$HEAD = 16180; /* i: waiting for magic header */ 
const $2d68152abb7d3417$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $2d68152abb7d3417$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $2d68152abb7d3417$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $2d68152abb7d3417$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $2d68152abb7d3417$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $2d68152abb7d3417$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $2d68152abb7d3417$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $2d68152abb7d3417$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $2d68152abb7d3417$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $2d68152abb7d3417$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $2d68152abb7d3417$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $2d68152abb7d3417$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $2d68152abb7d3417$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $2d68152abb7d3417$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $2d68152abb7d3417$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $2d68152abb7d3417$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $2d68152abb7d3417$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $2d68152abb7d3417$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $2d68152abb7d3417$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $2d68152abb7d3417$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $2d68152abb7d3417$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $2d68152abb7d3417$var$DIST = 16202; /* i: waiting for distance code */ 
const $2d68152abb7d3417$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $2d68152abb7d3417$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $2d68152abb7d3417$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $2d68152abb7d3417$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $2d68152abb7d3417$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $2d68152abb7d3417$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $2d68152abb7d3417$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $2d68152abb7d3417$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $2d68152abb7d3417$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $2d68152abb7d3417$var$ENOUGH_LENS = 852;
const $2d68152abb7d3417$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $2d68152abb7d3417$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $2d68152abb7d3417$var$DEF_WBITS = $2d68152abb7d3417$var$MAX_WBITS;
const $2d68152abb7d3417$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $2d68152abb7d3417$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $2d68152abb7d3417$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $2d68152abb7d3417$var$HEAD || state.mode > $2d68152abb7d3417$var$SYNC) return 1;
    return 0;
};
const $2d68152abb7d3417$var$inflateResetKeep = (strm)=>{
    if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $2d68152abb7d3417$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($2d68152abb7d3417$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($2d68152abb7d3417$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $2d68152abb7d3417$var$Z_OK$1;
};
const $2d68152abb7d3417$var$inflateReset = (strm)=>{
    if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $2d68152abb7d3417$var$inflateResetKeep(strm);
};
const $2d68152abb7d3417$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $2d68152abb7d3417$var$inflateReset(strm);
};
const $2d68152abb7d3417$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $2d68152abb7d3417$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $2d68152abb7d3417$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $2d68152abb7d3417$var$inflateReset2(strm, windowBits);
    if (ret !== $2d68152abb7d3417$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $2d68152abb7d3417$var$inflateInit = (strm)=>{
    return $2d68152abb7d3417$var$inflateInit2(strm, $2d68152abb7d3417$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $2d68152abb7d3417$var$virgin = true;
let $2d68152abb7d3417$var$lenfix, $2d68152abb7d3417$var$distfix; // We have no pointers in JS, so keep tables separate
const $2d68152abb7d3417$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($2d68152abb7d3417$var$virgin) {
        $2d68152abb7d3417$var$lenfix = new Int32Array(512);
        $2d68152abb7d3417$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$LENS, state.lens, 0, 288, $2d68152abb7d3417$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$DISTS, state.lens, 0, 32, $2d68152abb7d3417$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $2d68152abb7d3417$var$virgin = false;
    }
    state.lencode = $2d68152abb7d3417$var$lenfix;
    state.lenbits = 9;
    state.distcode = $2d68152abb7d3417$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $2d68152abb7d3417$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $2d68152abb7d3417$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($2d68152abb7d3417$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $2d68152abb7d3417$var$TYPE) state.mode = $2d68152abb7d3417$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $2d68152abb7d3417$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $2d68152abb7d3417$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $2d68152abb7d3417$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $2d68152abb7d3417$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $2d68152abb7d3417$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $2d68152abb7d3417$var$DICTID : $2d68152abb7d3417$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $2d68152abb7d3417$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $2d68152abb7d3417$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$TIME;
        /* falls through */ case $2d68152abb7d3417$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$OS;
        /* falls through */ case $2d68152abb7d3417$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$EXLEN;
        /* falls through */ case $2d68152abb7d3417$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $2d68152abb7d3417$var$EXTRA;
        /* falls through */ case $2d68152abb7d3417$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $2d68152abb7d3417$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $2d68152abb7d3417$var$NAME;
        /* falls through */ case $2d68152abb7d3417$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2d68152abb7d3417$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $2d68152abb7d3417$var$COMMENT;
        /* falls through */ case $2d68152abb7d3417$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2d68152abb7d3417$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $2d68152abb7d3417$var$HCRC;
        /* falls through */ case $2d68152abb7d3417$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $2d68152abb7d3417$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $2d68152abb7d3417$var$TYPE;
            break;
        case $2d68152abb7d3417$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $2d68152abb7d3417$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$DICT;
        /* falls through */ case $2d68152abb7d3417$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $2d68152abb7d3417$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $2d68152abb7d3417$var$TYPE;
        /* falls through */ case $2d68152abb7d3417$var$TYPE:
            if (flush === $2d68152abb7d3417$var$Z_BLOCK || flush === $2d68152abb7d3417$var$Z_TREES) break inf_leave;
        /* falls through */ case $2d68152abb7d3417$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $2d68152abb7d3417$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2d68152abb7d3417$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $2d68152abb7d3417$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2d68152abb7d3417$var$LEN_; /* decode codes */ 
                    if (flush === $2d68152abb7d3417$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2d68152abb7d3417$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $2d68152abb7d3417$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $2d68152abb7d3417$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$COPY_;
            if (flush === $2d68152abb7d3417$var$Z_TREES) break inf_leave;
        /* falls through */ case $2d68152abb7d3417$var$COPY_:
            state.mode = $2d68152abb7d3417$var$COPY;
        /* falls through */ case $2d68152abb7d3417$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $2d68152abb7d3417$var$TYPE;
            break;
        case $2d68152abb7d3417$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $2d68152abb7d3417$var$LENLENS;
        /* falls through */ case $2d68152abb7d3417$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $2d68152abb7d3417$var$CODELENS;
        /* falls through */ case $2d68152abb7d3417$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $2d68152abb7d3417$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $2d68152abb7d3417$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $2d68152abb7d3417$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $2d68152abb7d3417$var$LEN_;
            if (flush === $2d68152abb7d3417$var$Z_TREES) break inf_leave;
        /* falls through */ case $2d68152abb7d3417$var$LEN_:
            state.mode = $2d68152abb7d3417$var$LEN;
        /* falls through */ case $2d68152abb7d3417$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $2d68152abb7d3417$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $2d68152abb7d3417$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $2d68152abb7d3417$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $2d68152abb7d3417$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $2d68152abb7d3417$var$LENEXT;
        /* falls through */ case $2d68152abb7d3417$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $2d68152abb7d3417$var$DIST;
        /* falls through */ case $2d68152abb7d3417$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $2d68152abb7d3417$var$DISTEXT;
        /* falls through */ case $2d68152abb7d3417$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $2d68152abb7d3417$var$MATCH;
        /* falls through */ case $2d68152abb7d3417$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $2d68152abb7d3417$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $2d68152abb7d3417$var$LEN;
            break;
        case $2d68152abb7d3417$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $2d68152abb7d3417$var$LEN;
            break;
        case $2d68152abb7d3417$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $2d68152abb7d3417$var$crc32_1(state.check, output, _out, put - _out) : $2d68152abb7d3417$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $2d68152abb7d3417$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $2d68152abb7d3417$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $2d68152abb7d3417$var$LENGTH;
        /* falls through */ case $2d68152abb7d3417$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $2d68152abb7d3417$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $2d68152abb7d3417$var$DONE;
        /* falls through */ case $2d68152abb7d3417$var$DONE:
            ret = $2d68152abb7d3417$var$Z_STREAM_END$1;
            break inf_leave;
        case $2d68152abb7d3417$var$BAD:
            ret = $2d68152abb7d3417$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $2d68152abb7d3417$var$MEM:
            return $2d68152abb7d3417$var$Z_MEM_ERROR$1;
        case $2d68152abb7d3417$var$SYNC:
        /* falls through */ default:
            return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $2d68152abb7d3417$var$BAD && (state.mode < $2d68152abb7d3417$var$CHECK || flush !== $2d68152abb7d3417$var$Z_FINISH$1)) $2d68152abb7d3417$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $2d68152abb7d3417$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $2d68152abb7d3417$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $2d68152abb7d3417$var$TYPE ? 128 : 0) + (state.mode === $2d68152abb7d3417$var$LEN_ || state.mode === $2d68152abb7d3417$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $2d68152abb7d3417$var$Z_FINISH$1) && ret === $2d68152abb7d3417$var$Z_OK$1) ret = $2d68152abb7d3417$var$Z_BUF_ERROR;
    return ret;
};
const $2d68152abb7d3417$var$inflateEnd = (strm)=>{
    if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $2d68152abb7d3417$var$Z_OK$1;
};
const $2d68152abb7d3417$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $2d68152abb7d3417$var$Z_OK$1;
};
const $2d68152abb7d3417$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $2d68152abb7d3417$var$DICT) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $2d68152abb7d3417$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $2d68152abb7d3417$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $2d68152abb7d3417$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $2d68152abb7d3417$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $2d68152abb7d3417$var$MEM;
        return $2d68152abb7d3417$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $2d68152abb7d3417$var$Z_OK$1;
};
var $2d68152abb7d3417$var$inflateReset_1 = $2d68152abb7d3417$var$inflateReset;
var $2d68152abb7d3417$var$inflateReset2_1 = $2d68152abb7d3417$var$inflateReset2;
var $2d68152abb7d3417$var$inflateResetKeep_1 = $2d68152abb7d3417$var$inflateResetKeep;
var $2d68152abb7d3417$var$inflateInit_1 = $2d68152abb7d3417$var$inflateInit;
var $2d68152abb7d3417$var$inflateInit2_1 = $2d68152abb7d3417$var$inflateInit2;
var $2d68152abb7d3417$var$inflate_2$1 = $2d68152abb7d3417$var$inflate$2;
var $2d68152abb7d3417$var$inflateEnd_1 = $2d68152abb7d3417$var$inflateEnd;
var $2d68152abb7d3417$var$inflateGetHeader_1 = $2d68152abb7d3417$var$inflateGetHeader;
var $2d68152abb7d3417$var$inflateSetDictionary_1 = $2d68152abb7d3417$var$inflateSetDictionary;
var $2d68152abb7d3417$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $2d68152abb7d3417$var$inflate_1$2 = {
    inflateReset: $2d68152abb7d3417$var$inflateReset_1,
    inflateReset2: $2d68152abb7d3417$var$inflateReset2_1,
    inflateResetKeep: $2d68152abb7d3417$var$inflateResetKeep_1,
    inflateInit: $2d68152abb7d3417$var$inflateInit_1,
    inflateInit2: $2d68152abb7d3417$var$inflateInit2_1,
    inflate: $2d68152abb7d3417$var$inflate_2$1,
    inflateEnd: $2d68152abb7d3417$var$inflateEnd_1,
    inflateGetHeader: $2d68152abb7d3417$var$inflateGetHeader_1,
    inflateSetDictionary: $2d68152abb7d3417$var$inflateSetDictionary_1,
    inflateInfo: $2d68152abb7d3417$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2d68152abb7d3417$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $2d68152abb7d3417$var$gzheader = $2d68152abb7d3417$var$GZheader;
const $2d68152abb7d3417$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2d68152abb7d3417$var$Z_NO_FLUSH, Z_FINISH: $2d68152abb7d3417$var$Z_FINISH, Z_OK: $2d68152abb7d3417$var$Z_OK, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END, Z_NEED_DICT: $2d68152abb7d3417$var$Z_NEED_DICT, Z_STREAM_ERROR: $2d68152abb7d3417$var$Z_STREAM_ERROR, Z_DATA_ERROR: $2d68152abb7d3417$var$Z_DATA_ERROR, Z_MEM_ERROR: $2d68152abb7d3417$var$Z_MEM_ERROR } = $2d68152abb7d3417$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2d68152abb7d3417$var$Inflate$1(options) {
    this.options = $2d68152abb7d3417$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2d68152abb7d3417$var$zstream();
    this.strm.avail_out = 0;
    let status = $2d68152abb7d3417$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $2d68152abb7d3417$var$Z_OK) throw new Error($2d68152abb7d3417$var$messages[status]);
    this.header = new $2d68152abb7d3417$var$gzheader();
    $2d68152abb7d3417$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $2d68152abb7d3417$var$strings.string2buf(opt.dictionary);
        else if ($2d68152abb7d3417$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $2d68152abb7d3417$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $2d68152abb7d3417$var$Z_OK) throw new Error($2d68152abb7d3417$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2d68152abb7d3417$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2d68152abb7d3417$var$Z_FINISH : $2d68152abb7d3417$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($2d68152abb7d3417$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $2d68152abb7d3417$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $2d68152abb7d3417$var$Z_NEED_DICT && dictionary) {
            status = $2d68152abb7d3417$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $2d68152abb7d3417$var$Z_OK) status = $2d68152abb7d3417$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $2d68152abb7d3417$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $2d68152abb7d3417$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $2d68152abb7d3417$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $2d68152abb7d3417$var$inflate_1$2.inflateReset(strm);
            status = $2d68152abb7d3417$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $2d68152abb7d3417$var$Z_STREAM_ERROR:
            case $2d68152abb7d3417$var$Z_DATA_ERROR:
            case $2d68152abb7d3417$var$Z_NEED_DICT:
            case $2d68152abb7d3417$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $2d68152abb7d3417$var$Z_STREAM_END) {
                if (this.options.to === "string") {
                    let next_out_utf8 = $2d68152abb7d3417$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $2d68152abb7d3417$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $2d68152abb7d3417$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $2d68152abb7d3417$var$Z_STREAM_END) {
            status = $2d68152abb7d3417$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2d68152abb7d3417$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2d68152abb7d3417$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2d68152abb7d3417$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $2d68152abb7d3417$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $2d68152abb7d3417$var$inflate$1(input, options) {
    const inflator = new $2d68152abb7d3417$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $2d68152abb7d3417$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2d68152abb7d3417$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2d68152abb7d3417$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2d68152abb7d3417$var$Inflate_1$1 = $2d68152abb7d3417$var$Inflate$1;
var $2d68152abb7d3417$var$inflate_2 = $2d68152abb7d3417$var$inflate$1;
var $2d68152abb7d3417$var$inflateRaw_1$1 = $2d68152abb7d3417$var$inflateRaw$1;
var $2d68152abb7d3417$var$ungzip$1 = $2d68152abb7d3417$var$inflate$1;
var $2d68152abb7d3417$var$constants = $2d68152abb7d3417$var$constants$2;
var $2d68152abb7d3417$var$inflate_1$1 = {
    Inflate: $2d68152abb7d3417$var$Inflate_1$1,
    inflate: $2d68152abb7d3417$var$inflate_2,
    inflateRaw: $2d68152abb7d3417$var$inflateRaw_1$1,
    ungzip: $2d68152abb7d3417$var$ungzip$1,
    constants: $2d68152abb7d3417$var$constants
};
const { Deflate: $2d68152abb7d3417$var$Deflate, deflate: $2d68152abb7d3417$var$deflate, deflateRaw: $2d68152abb7d3417$var$deflateRaw, gzip: $2d68152abb7d3417$var$gzip } = $2d68152abb7d3417$var$deflate_1$1;
const { Inflate: $2d68152abb7d3417$var$Inflate, inflate: $2d68152abb7d3417$var$inflate, inflateRaw: $2d68152abb7d3417$var$inflateRaw, ungzip: $2d68152abb7d3417$var$ungzip } = $2d68152abb7d3417$var$inflate_1$1;
var $2d68152abb7d3417$export$ae157b6234afe138 = $2d68152abb7d3417$var$Deflate;
var $2d68152abb7d3417$export$2316623ecd1285ab = $2d68152abb7d3417$var$deflate;
var $2d68152abb7d3417$export$e95d6a8f69fb340a = $2d68152abb7d3417$var$deflateRaw;
var $2d68152abb7d3417$export$69f0ea7cf3a331a8 = $2d68152abb7d3417$var$gzip;
var $2d68152abb7d3417$export$d1de70a877d6e43c = $2d68152abb7d3417$var$Inflate;
var $2d68152abb7d3417$export$cae1ce83fe4a1782 = $2d68152abb7d3417$var$inflate;
var $2d68152abb7d3417$export$d0f0aa2d05c905c5 = $2d68152abb7d3417$var$inflateRaw;
var $2d68152abb7d3417$export$95adf9d270383091 = $2d68152abb7d3417$var$ungzip;
var $2d68152abb7d3417$export$1a988e7317c65621 = $2d68152abb7d3417$var$constants$2;
var $2d68152abb7d3417$export$2e2bcd8739ae039 = {
    Deflate: $2d68152abb7d3417$export$ae157b6234afe138,
    deflate: $2d68152abb7d3417$export$2316623ecd1285ab,
    deflateRaw: $2d68152abb7d3417$export$e95d6a8f69fb340a,
    gzip: $2d68152abb7d3417$export$69f0ea7cf3a331a8,
    Inflate: $2d68152abb7d3417$export$d1de70a877d6e43c,
    inflate: $2d68152abb7d3417$export$cae1ce83fe4a1782,
    inflateRaw: $2d68152abb7d3417$export$d0f0aa2d05c905c5,
    ungzip: $2d68152abb7d3417$export$95adf9d270383091,
    constants: $2d68152abb7d3417$export$1a988e7317c65621
};



var $1PbQI = parcelRequire("1PbQI");

var $cbQCu = parcelRequire("cbQCu");
var $26e0f71442fe06b5$require$Buffer = $cbQCu.Buffer;
/**
 * Splits an array into chunks
 *
 * @param array Array of objects to chunk.
 * @param size The max size of a chunk.
 * @returns A two dimensional array where each T[] length is < the provided size.
 */ function $26e0f71442fe06b5$var$chunks(array, size) {
    return Array.apply(0, new Array(Math.ceil(array.length / size))).map((_, index)=>array.slice(index * size, (index + 1) * size));
}
/**
 * Check if a transaction object is a VersionedTransaction or not
 *
 * @param tx
 * @returns bool
 */ const $26e0f71442fe06b5$var$isVersionedTransaction = (tx)=>{
    return "version" in tx;
};
function $26e0f71442fe06b5$var$encode$3(data) {
    return data.reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "0x");
}
function $26e0f71442fe06b5$var$decode$3(data) {
    if (data.indexOf("0x") === 0) data = data.substr(2);
    if (data.length % 2 === 1) data = "0" + data;
    let key = data.match(/.{2}/g);
    if (key === null) return (0, $cbQCu.Buffer).from([]);
    return (0, $cbQCu.Buffer).from(key.map((byte)=>parseInt(byte, 16)));
}
var $26e0f71442fe06b5$var$hex = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    encode: $26e0f71442fe06b5$var$encode$3,
    decode: $26e0f71442fe06b5$var$decode$3
});
function $26e0f71442fe06b5$var$decode$2(array) {
    const decoder = new TextDecoder("utf-8") // Browser https://caniuse.com/textencoder.
    ; // Node.
    return decoder.decode(array);
}
function $26e0f71442fe06b5$var$encode$2(input) {
    const encoder = new TextEncoder() // Browser.
    ; // Node.
    return encoder.encode(input);
}
var $26e0f71442fe06b5$var$utf8 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    decode: $26e0f71442fe06b5$var$decode$2,
    encode: $26e0f71442fe06b5$var$encode$2
});
function $26e0f71442fe06b5$var$encode$1(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(data);
}
function $26e0f71442fe06b5$var$decode$1(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(data);
}
var $26e0f71442fe06b5$var$bs58 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    encode: $26e0f71442fe06b5$var$encode$1,
    decode: $26e0f71442fe06b5$var$decode$1
});
function $26e0f71442fe06b5$var$encode(data) {
    return data.toString("base64");
}
function $26e0f71442fe06b5$var$decode(data) {
    return (0, $cbQCu.Buffer).from(data, "base64");
}
var $26e0f71442fe06b5$var$base64 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    encode: $26e0f71442fe06b5$var$encode,
    decode: $26e0f71442fe06b5$var$decode
});
var $26e0f71442fe06b5$var$index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    hex: $26e0f71442fe06b5$var$hex,
    utf8: $26e0f71442fe06b5$var$utf8,
    bs58: $26e0f71442fe06b5$var$bs58,
    base64: $26e0f71442fe06b5$var$base64
});
function $26e0f71442fe06b5$export$cba16e61678ac4e1(idl) {
    const errors = new Map();
    if (idl.errors) idl.errors.forEach((e)=>{
        var _a;
        let msg = (_a = e.msg) !== null && _a !== void 0 ? _a : e.name;
        errors.set(e.code, msg);
    });
    return errors;
}
// Allow either IdLInstruction or IdlStateMethod since the types share fields.
function $26e0f71442fe06b5$export$eaa840300146a0df(idlIx, ...args) {
    if (idlIx.args.length != args.length) throw new Error("Invalid argument length");
    const ix = {};
    let idx = 0;
    idlIx.args.forEach((ixArg)=>{
        ix[ixArg.name] = args[idx];
        idx += 1;
    });
    return ix;
}
// Throws error if any account required for the `ix` is not given.
function $26e0f71442fe06b5$export$5ae43aeb7897a660(ixAccounts, accounts = {}) {
    ixAccounts.forEach((acc)=>{
        if ("accounts" in acc) $26e0f71442fe06b5$export$5ae43aeb7897a660(acc.accounts, accounts[acc.name]);
        else {
            if (accounts[acc.name] === undefined) throw new Error(`Invalid arguments: ${acc.name} not provided.`);
        }
    });
}
// Translates an address to a Pubkey.
function $26e0f71442fe06b5$export$73f4f8860ca47074(address) {
    return address instanceof (0, $1biTx.PublicKey) ? address : new (0, $1biTx.PublicKey)(address);
}
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $26e0f71442fe06b5$var$StructError extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join(".") + " -- " + message;
        super(msg);
        this.value = void 0;
        this.key = void 0;
        this.type = void 0;
        this.refinement = void 0;
        this.path = void 0;
        this.branch = void 0;
        this.failures = void 0;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $26e0f71442fe06b5$var$isIterable(x) {
    return $26e0f71442fe06b5$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $26e0f71442fe06b5$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Return a value as a printable string.
 */ function $26e0f71442fe06b5$var$print(value) {
    return typeof value === "string" ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $26e0f71442fe06b5$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $26e0f71442fe06b5$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : "") + ", but received: `" + $26e0f71442fe06b5$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $26e0f71442fe06b5$var$toFailures(result, context, struct, value) {
    if (!$26e0f71442fe06b5$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $26e0f71442fe06b5$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $26e0f71442fe06b5$var$run(value, struct, options) {
    if (options === void 0) options = {};
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $26e0f71442fe06b5$var$isObject(struct.schema) && $26e0f71442fe06b5$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $26e0f71442fe06b5$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($26e0f71442fe06b5$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $26e0f71442fe06b5$var$Struct {
    constructor(props){
        this.TYPE = void 0;
        this.type = void 0;
        this.schema = void 0;
        this.coercer = void 0;
        this.validator = void 0;
        this.refiner = void 0;
        this.entries = void 0;
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $26e0f71442fe06b5$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $26e0f71442fe06b5$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $26e0f71442fe06b5$var$assert(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $26e0f71442fe06b5$var$create(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $26e0f71442fe06b5$var$is(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $26e0f71442fe06b5$var$mask(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options) {
        if (options === void 0) options = {};
        return $26e0f71442fe06b5$var$validate(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $26e0f71442fe06b5$var$assert(value, struct) {
    const result = $26e0f71442fe06b5$var$validate(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $26e0f71442fe06b5$var$create(value, struct) {
    const result = $26e0f71442fe06b5$var$validate(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $26e0f71442fe06b5$var$mask(value, struct) {
    const result = $26e0f71442fe06b5$var$validate(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $26e0f71442fe06b5$var$is(value, struct) {
    const result = $26e0f71442fe06b5$var$validate(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $26e0f71442fe06b5$var$validate(value, struct, options) {
    if (options === void 0) options = {};
    const tuples = $26e0f71442fe06b5$var$run(value, struct, options);
    const tuple = $26e0f71442fe06b5$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $26e0f71442fe06b5$var$StructError(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
/**
 * Define a new struct type with a custom validation function.
 */ function $26e0f71442fe06b5$var$define(name, validator) {
    return new $26e0f71442fe06b5$var$Struct({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Ensure that any value passes validation.
 */ function $26e0f71442fe06b5$var$any() {
    return $26e0f71442fe06b5$var$define("any", ()=>true);
}
function $26e0f71442fe06b5$var$array(Element) {
    return new $26e0f71442fe06b5$var$Struct({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $26e0f71442fe06b5$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $26e0f71442fe06b5$var$boolean() {
    return $26e0f71442fe06b5$var$define("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
function $26e0f71442fe06b5$var$literal(constant) {
    const description = $26e0f71442fe06b5$var$print(constant);
    const t = typeof constant;
    return new $26e0f71442fe06b5$var$Struct({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $26e0f71442fe06b5$var$print(value);
        }
    });
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $26e0f71442fe06b5$var$nullable(struct) {
    return new $26e0f71442fe06b5$var$Struct({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $26e0f71442fe06b5$var$number() {
    return $26e0f71442fe06b5$var$define("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: " + $26e0f71442fe06b5$var$print(value);
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $26e0f71442fe06b5$var$optional(struct) {
    return new $26e0f71442fe06b5$var$Struct({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a string.
 */ function $26e0f71442fe06b5$var$string() {
    return $26e0f71442fe06b5$var$define("string", (value)=>{
        return typeof value === "string" || "Expected a string, but received: " + $26e0f71442fe06b5$var$print(value);
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $26e0f71442fe06b5$var$type(schema) {
    const keys = Object.keys(schema);
    return new $26e0f71442fe06b5$var$Struct({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($26e0f71442fe06b5$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $26e0f71442fe06b5$var$isObject(value) || "Expected an object, but received: " + $26e0f71442fe06b5$var$print(value);
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $26e0f71442fe06b5$var$union$1(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $26e0f71442fe06b5$var$Struct({
        type: "union",
        schema: null,
        coercer (value, ctx) {
            const firstMatch = Structs.find((s)=>{
                const [e] = s.validate(value, {
                    coerce: true
                });
                return !e;
            }) || $26e0f71442fe06b5$var$unknown();
            return firstMatch.coercer(value, ctx);
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $26e0f71442fe06b5$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $26e0f71442fe06b5$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $26e0f71442fe06b5$var$unknown() {
    return $26e0f71442fe06b5$var$define("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $26e0f71442fe06b5$var$coerce(struct, condition, coercer) {
    return new $26e0f71442fe06b5$var$Struct({
        ...struct,
        coercer: (value, ctx)=>{
            return $26e0f71442fe06b5$var$is(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Sends a transaction to a program with the given accounts and instruction
 * data.
 */ async function $26e0f71442fe06b5$var$invoke(programId, accounts, data, provider) {
    programId = $26e0f71442fe06b5$export$73f4f8860ca47074(programId);
    if (!provider) provider = $26e0f71442fe06b5$export$57632def5536cb24();
    const tx = new (0, $1biTx.Transaction)();
    tx.add(new (0, $1biTx.TransactionInstruction)({
        programId: programId,
        keys: accounts !== null && accounts !== void 0 ? accounts : [],
        data: data
    }));
    if (provider.sendAndConfirm === undefined) throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
    return await provider.sendAndConfirm(tx, []);
}
const $26e0f71442fe06b5$var$GET_MULTIPLE_ACCOUNTS_LIMIT = 99;
async function $26e0f71442fe06b5$var$getMultipleAccounts(connection, publicKeys, commitment) {
    const results = await $26e0f71442fe06b5$var$getMultipleAccountsAndContext(connection, publicKeys, commitment);
    return results.map((result)=>{
        return result ? {
            publicKey: result.publicKey,
            account: result.account
        } : null;
    });
}
async function $26e0f71442fe06b5$var$getMultipleAccountsAndContext(connection, publicKeys, commitment) {
    if (publicKeys.length <= $26e0f71442fe06b5$var$GET_MULTIPLE_ACCOUNTS_LIMIT) return await $26e0f71442fe06b5$var$getMultipleAccountsAndContextCore(connection, publicKeys, commitment);
    else {
        const batches = $26e0f71442fe06b5$var$chunks(publicKeys, $26e0f71442fe06b5$var$GET_MULTIPLE_ACCOUNTS_LIMIT);
        const results = await Promise.all(batches.map((batch)=>$26e0f71442fe06b5$var$getMultipleAccountsAndContextCore(connection, batch, commitment)));
        return results.flat();
    }
}
async function $26e0f71442fe06b5$var$getMultipleAccountsAndContextCore(connection, publicKeys, commitmentOverride) {
    const commitment = commitmentOverride !== null && commitmentOverride !== void 0 ? commitmentOverride : connection.commitment;
    const { value: accountInfos, context: context } = await connection.getMultipleAccountsInfoAndContext(publicKeys, commitment);
    const accounts = accountInfos.map((account, idx)=>{
        if (account === null) return null;
        return {
            publicKey: publicKeys[idx],
            account: account,
            context: context
        };
    });
    return accounts;
}
// copy from @solana/web3.js that has a commitment param
async function $26e0f71442fe06b5$var$simulateTransaction(connection, transaction, signers, commitment, includeAccounts) {
    var _a;
    if (signers && signers.length > 0) transaction.sign(...signers);
    // @ts-expect-error
    const message = transaction._compile();
    const signData = message.serialize();
    // @ts-expect-error
    const wireTransaction = transaction._serialize(signData);
    const encodedTransaction = wireTransaction.toString("base64");
    const config = {
        encoding: "base64",
        commitment: commitment !== null && commitment !== void 0 ? commitment : connection.commitment
    };
    if (includeAccounts) {
        const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
        config["accounts"] = {
            encoding: "base64",
            addresses: addresses
        };
    }
    if (signers) config.sigVerify = true;
    const args = [
        encodedTransaction,
        config
    ];
    // @ts-expect-error
    const unsafeRes = await connection._rpcRequest("simulateTransaction", args);
    const res = $26e0f71442fe06b5$var$create(unsafeRes, $26e0f71442fe06b5$var$SimulatedTransactionResponseStruct);
    if ("error" in res) {
        let logs;
        if ("data" in res.error) {
            logs = (_a = res.error.data) === null || _a === void 0 ? void 0 : _a.logs;
            if (logs && Array.isArray(logs)) {
                const traceIndent = "\n    ";
                const logTrace = traceIndent + logs.join(traceIndent);
                console.error(res.error.message, logTrace);
            }
        }
        throw new (0, $1biTx.SendTransactionError)("failed to simulate transaction: " + res.error.message, logs);
    }
    return res.result;
}
// copy from @solana/web3.js
function $26e0f71442fe06b5$var$jsonRpcResult(schema) {
    return $26e0f71442fe06b5$var$coerce($26e0f71442fe06b5$var$createRpcResult(schema), $26e0f71442fe06b5$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: $26e0f71442fe06b5$var$create(value.result, schema)
        };
    });
}
// copy from @solana/web3.js
const $26e0f71442fe06b5$var$UnknownRpcResult = $26e0f71442fe06b5$var$createRpcResult($26e0f71442fe06b5$var$unknown());
// copy from @solana/web3.js
function $26e0f71442fe06b5$var$createRpcResult(result) {
    return $26e0f71442fe06b5$var$union$1([
        $26e0f71442fe06b5$var$type({
            jsonrpc: $26e0f71442fe06b5$var$literal("2.0"),
            id: $26e0f71442fe06b5$var$string(),
            result: result
        }),
        $26e0f71442fe06b5$var$type({
            jsonrpc: $26e0f71442fe06b5$var$literal("2.0"),
            id: $26e0f71442fe06b5$var$string(),
            error: $26e0f71442fe06b5$var$type({
                code: $26e0f71442fe06b5$var$unknown(),
                message: $26e0f71442fe06b5$var$string(),
                data: $26e0f71442fe06b5$var$optional($26e0f71442fe06b5$var$any())
            })
        })
    ]);
}
// copy from @solana/web3.js
function $26e0f71442fe06b5$var$jsonRpcResultAndContext(value) {
    return $26e0f71442fe06b5$var$jsonRpcResult($26e0f71442fe06b5$var$type({
        context: $26e0f71442fe06b5$var$type({
            slot: $26e0f71442fe06b5$var$number()
        }),
        value: value
    }));
}
// copy from @solana/web3.js
const $26e0f71442fe06b5$var$SimulatedTransactionResponseStruct = $26e0f71442fe06b5$var$jsonRpcResultAndContext($26e0f71442fe06b5$var$type({
    err: $26e0f71442fe06b5$var$nullable($26e0f71442fe06b5$var$union$1([
        $26e0f71442fe06b5$var$type({}),
        $26e0f71442fe06b5$var$string()
    ])),
    logs: $26e0f71442fe06b5$var$nullable($26e0f71442fe06b5$var$array($26e0f71442fe06b5$var$string())),
    accounts: $26e0f71442fe06b5$var$optional($26e0f71442fe06b5$var$nullable($26e0f71442fe06b5$var$array($26e0f71442fe06b5$var$nullable($26e0f71442fe06b5$var$type({
        executable: $26e0f71442fe06b5$var$boolean(),
        owner: $26e0f71442fe06b5$var$string(),
        lamports: $26e0f71442fe06b5$var$number(),
        data: $26e0f71442fe06b5$var$array($26e0f71442fe06b5$var$string()),
        rentEpoch: $26e0f71442fe06b5$var$optional($26e0f71442fe06b5$var$number())
    }))))),
    unitsConsumed: $26e0f71442fe06b5$var$optional($26e0f71442fe06b5$var$number())
}));
var $26e0f71442fe06b5$var$rpc = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    invoke: $26e0f71442fe06b5$var$invoke,
    getMultipleAccounts: $26e0f71442fe06b5$var$getMultipleAccounts,
    getMultipleAccountsAndContext: $26e0f71442fe06b5$var$getMultipleAccountsAndContext,
    simulateTransaction: $26e0f71442fe06b5$var$simulateTransaction
});
/**
 * The network and wallet context used to send transactions paid for and signed
 * by the provider.
 */ class $26e0f71442fe06b5$export$1d7e255c6105d39b {
    /**
     * @param connection The cluster connection where the program is deployed.
     * @param wallet     The wallet used to pay for and sign all transactions.
     * @param opts       Transaction confirmation options to use by default.
     */ constructor(connection, wallet, opts){
        this.connection = connection;
        this.wallet = wallet;
        this.opts = opts;
        this.publicKey = wallet === null || wallet === void 0 ? void 0 : wallet.publicKey;
    }
    static defaultOptions() {
        return {
            preflightCommitment: "processed",
            commitment: "processed"
        };
    }
    /**
     * Returns a `Provider` with a wallet read from the local filesystem.
     *
     * @param url  The network cluster url.
     * @param opts The default transaction confirmation options.
     *
     * (This api is for Node only.)
     */ static local(url, opts) {
        throw new Error(`Provider local is not available on browser.`);
    }
    /**
     * Returns a `Provider` read from the `ANCHOR_PROVIDER_URL` environment
     * variable
     *
     * (This api is for Node only.)
     */ static env() {
        throw new Error(`Provider env is not available on browser.`);
    }
    /**
     * Sends the given transaction, paid for and signed by the provider's wallet.
     *
     * @param tx      The transaction to send.
     * @param signers The signers of the transaction.
     * @param opts    Transaction confirmation options.
     */ async sendAndConfirm(tx, signers, opts) {
        var _a, _b, _c, _d;
        if (opts === undefined) opts = this.opts;
        if ($26e0f71442fe06b5$var$isVersionedTransaction(tx)) {
            if (signers) tx.sign(signers);
        } else {
            tx.feePayer = (_a = tx.feePayer) !== null && _a !== void 0 ? _a : this.wallet.publicKey;
            tx.recentBlockhash = (await this.connection.getLatestBlockhash(opts.preflightCommitment)).blockhash;
            if (signers) for (const signer of signers)tx.partialSign(signer);
        }
        tx = await this.wallet.signTransaction(tx);
        const rawTx = tx.serialize();
        try {
            return await $26e0f71442fe06b5$var$sendAndConfirmRawTransaction(this.connection, rawTx, opts);
        } catch (err) {
            // thrown if the underlying 'confirmTransaction' encounters a failed tx
            // the 'confirmTransaction' error does not return logs so we make another rpc call to get them
            if (err instanceof $26e0f71442fe06b5$var$ConfirmError) {
                // choose the shortest available commitment for 'getTransaction'
                // (the json RPC does not support any shorter than "confirmed" for 'getTransaction')
                // because that will see the tx sent with `sendAndConfirmRawTransaction` no matter which
                // commitment `sendAndConfirmRawTransaction` used
                const txSig = $26e0f71442fe06b5$var$encode$1($26e0f71442fe06b5$var$isVersionedTransaction(tx) ? ((_b = tx.signatures) === null || _b === void 0 ? void 0 : _b[0]) || new Uint8Array() : (_c = tx.signature) !== null && _c !== void 0 ? _c : new Uint8Array());
                const failedTx = await this.connection.getTransaction(txSig, {
                    commitment: "confirmed"
                });
                if (!failedTx) throw err;
                else {
                    const logs = (_d = failedTx.meta) === null || _d === void 0 ? void 0 : _d.logMessages;
                    throw !logs ? err : new (0, $1biTx.SendTransactionError)(err.message, logs);
                }
            } else throw err;
        }
    }
    /**
     * Similar to `send`, but for an array of transactions and signers.
     * All transactions need to be of the same type, it doesn't support a mix of `VersionedTransaction`s and `Transaction`s.
     *
     * @param txWithSigners Array of transactions and signers.
     * @param opts          Transaction confirmation options.
     */ async sendAll(txWithSigners, opts) {
        var _a, _b, _c;
        if (opts === undefined) opts = this.opts;
        const recentBlockhash = (await this.connection.getLatestBlockhash(opts.preflightCommitment)).blockhash;
        let txs = txWithSigners.map((r)=>{
            var _a, _b;
            if ($26e0f71442fe06b5$var$isVersionedTransaction(r.tx)) {
                let tx = r.tx;
                if (r.signers) tx.sign(r.signers);
                return tx;
            } else {
                let tx = r.tx;
                let signers = (_a = r.signers) !== null && _a !== void 0 ? _a : [];
                tx.feePayer = (_b = tx.feePayer) !== null && _b !== void 0 ? _b : this.wallet.publicKey;
                tx.recentBlockhash = recentBlockhash;
                signers.forEach((kp)=>{
                    tx.partialSign(kp);
                });
                return tx;
            }
        });
        const signedTxs = await this.wallet.signAllTransactions(txs);
        const sigs = [];
        for(let k = 0; k < txs.length; k += 1){
            const tx = signedTxs[k];
            const rawTx = tx.serialize();
            try {
                sigs.push(await $26e0f71442fe06b5$var$sendAndConfirmRawTransaction(this.connection, rawTx, opts));
            } catch (err) {
                // thrown if the underlying 'confirmTransaction' encounters a failed tx
                // the 'confirmTransaction' error does not return logs so we make another rpc call to get them
                if (err instanceof $26e0f71442fe06b5$var$ConfirmError) {
                    // choose the shortest available commitment for 'getTransaction'
                    // (the json RPC does not support any shorter than "confirmed" for 'getTransaction')
                    // because that will see the tx sent with `sendAndConfirmRawTransaction` no matter which
                    // commitment `sendAndConfirmRawTransaction` used
                    const txSig = $26e0f71442fe06b5$var$encode$1($26e0f71442fe06b5$var$isVersionedTransaction(tx) ? ((_a = tx.signatures) === null || _a === void 0 ? void 0 : _a[0]) || new Uint8Array() : (_b = tx.signature) !== null && _b !== void 0 ? _b : new Uint8Array());
                    const failedTx = await this.connection.getTransaction(txSig, {
                        commitment: "confirmed"
                    });
                    if (!failedTx) throw err;
                    else {
                        const logs = (_c = failedTx.meta) === null || _c === void 0 ? void 0 : _c.logMessages;
                        throw !logs ? err : new (0, $1biTx.SendTransactionError)(err.message, logs);
                    }
                } else throw err;
            }
        }
        return sigs;
    }
    /**
     * Simulates the given transaction, returning emitted logs from execution.
     *
     * @param tx      The transaction to send.
     * @param signers The signers of the transaction. If unset, the transaction
     *                will be simulated with the "sigVerify: false" option. This
     *                allows for simulation of transactions without asking the
     *                wallet for a signature.
     * @param opts    Transaction confirmation options.
     */ async simulate(tx, signers, commitment, includeAccounts) {
        let recentBlockhash = (await this.connection.getLatestBlockhash(commitment !== null && commitment !== void 0 ? commitment : this.connection.commitment)).blockhash;
        let result;
        if ($26e0f71442fe06b5$var$isVersionedTransaction(tx)) {
            if (signers) {
                tx.sign(signers);
                tx = await this.wallet.signTransaction(tx);
            }
            // Doesn't support includeAccounts which has been changed to something
            // else in later versions of this function.
            result = await this.connection.simulateTransaction(tx, {
                commitment: commitment
            });
        } else {
            tx.feePayer = tx.feePayer || this.wallet.publicKey;
            tx.recentBlockhash = recentBlockhash;
            if (signers) tx = await this.wallet.signTransaction(tx);
            result = await $26e0f71442fe06b5$var$simulateTransaction(this.connection, tx, signers, commitment, includeAccounts);
        }
        if (result.value.err) throw new $26e0f71442fe06b5$var$SimulateError(result.value);
        return result.value;
    }
}
class $26e0f71442fe06b5$var$SimulateError extends Error {
    constructor(simulationResponse, message){
        super(message);
        this.simulationResponse = simulationResponse;
    }
}
// Copy of Connection.sendAndConfirmRawTransaction that throws
// a better error if 'confirmTransaction` returns an error status
async function $26e0f71442fe06b5$var$sendAndConfirmRawTransaction(connection, rawTransaction, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    if (status.err) throw new $26e0f71442fe06b5$var$ConfirmError(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
class $26e0f71442fe06b5$var$ConfirmError extends Error {
    constructor(message){
        super(message);
    }
}
/**
 * Sets the default provider on the client.
 */ function $26e0f71442fe06b5$export$1572b3eade6662f9(provider) {
    $26e0f71442fe06b5$var$_provider = provider;
}
/**
 * Returns the default provider being used by the client.
 */ function $26e0f71442fe06b5$export$57632def5536cb24() {
    if ($26e0f71442fe06b5$var$_provider === null) return $26e0f71442fe06b5$export$1d7e255c6105d39b.local();
    return $26e0f71442fe06b5$var$_provider;
}
// Global provider used as the default when a provider is not given.
let $26e0f71442fe06b5$var$_provider = null;
const $26e0f71442fe06b5$var$_AVAILABLE_FEATURES = new Set([
    "anchor-deprecated-state",
    "debug-logs"
]);
const $26e0f71442fe06b5$var$_FEATURES = new Map();
function $26e0f71442fe06b5$var$set(key) {
    if (!$26e0f71442fe06b5$var$_AVAILABLE_FEATURES.has(key)) throw new Error("Invalid feature");
    $26e0f71442fe06b5$var$_FEATURES.set(key, true);
}
function $26e0f71442fe06b5$var$isSet(key) {
    return $26e0f71442fe06b5$var$_FEATURES.get(key) !== undefined;
}
var $26e0f71442fe06b5$var$features = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    set: $26e0f71442fe06b5$var$set,
    isSet: $26e0f71442fe06b5$var$isSet
});
class $26e0f71442fe06b5$export$f8b0f3df06e3d291 extends Error {
    constructor(message){
        super(message);
        this.name = "IdlError";
    }
}
class $26e0f71442fe06b5$export$741a43b9b6ccc99 {
    constructor(stack){
        this.stack = stack;
    }
    static parse(logs) {
        var _a;
        const programKeyRegex = /^Program (\w*) invoke/;
        const successRegex = /^Program \w* success/;
        const programStack = [];
        for(let i = 0; i < logs.length; i++){
            if (successRegex.exec(logs[i])) {
                programStack.pop();
                continue;
            }
            const programKey = (_a = programKeyRegex.exec(logs[i])) === null || _a === void 0 ? void 0 : _a[1];
            if (!programKey) continue;
            programStack.push(new (0, $1biTx.PublicKey)(programKey));
        }
        return new $26e0f71442fe06b5$export$741a43b9b6ccc99(programStack);
    }
}
class $26e0f71442fe06b5$export$25283b86c4f54869 extends Error {
    constructor(errorCode, errorMessage, errorLogs, logs, origin, comparedValues){
        super(errorLogs.join("\n").replace("Program log: ", ""));
        this.errorLogs = errorLogs;
        this.logs = logs;
        this.error = {
            errorCode: errorCode,
            errorMessage: errorMessage,
            comparedValues: comparedValues,
            origin: origin
        };
        this._programErrorStack = $26e0f71442fe06b5$export$741a43b9b6ccc99.parse(logs);
    }
    static parse(logs) {
        if (!logs) return null;
        const anchorErrorLogIndex = logs.findIndex((log)=>log.startsWith("Program log: AnchorError"));
        if (anchorErrorLogIndex === -1) return null;
        const anchorErrorLog = logs[anchorErrorLogIndex];
        const errorLogs = [
            anchorErrorLog
        ];
        let comparedValues;
        if (anchorErrorLogIndex + 1 < logs.length) {
            // This catches the comparedValues where the following is logged
            // <AnchorError>
            // Left:
            // <Pubkey>
            // Right:
            // <Pubkey>
            if (logs[anchorErrorLogIndex + 1] === "Program log: Left:") {
                const pubkeyRegex = /^Program log: (.*)$/;
                const leftPubkey = pubkeyRegex.exec(logs[anchorErrorLogIndex + 2])[1];
                const rightPubkey = pubkeyRegex.exec(logs[anchorErrorLogIndex + 4])[1];
                comparedValues = [
                    new (0, $1biTx.PublicKey)(leftPubkey),
                    new (0, $1biTx.PublicKey)(rightPubkey)
                ];
                errorLogs.push(...logs.slice(anchorErrorLogIndex + 1, anchorErrorLogIndex + 5));
            } else if (logs[anchorErrorLogIndex + 1].startsWith("Program log: Left:")) {
                const valueRegex = /^Program log: (Left|Right): (.*)$/;
                const leftValue = valueRegex.exec(logs[anchorErrorLogIndex + 1])[2];
                const rightValue = valueRegex.exec(logs[anchorErrorLogIndex + 2])[2];
                errorLogs.push(...logs.slice(anchorErrorLogIndex + 1, anchorErrorLogIndex + 3));
                comparedValues = [
                    leftValue,
                    rightValue
                ];
            }
        }
        const regexNoInfo = /^Program log: AnchorError occurred\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./;
        const noInfoAnchorErrorLog = regexNoInfo.exec(anchorErrorLog);
        const regexFileLine = /^Program log: AnchorError thrown in (.*):(\d*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./;
        const fileLineAnchorErrorLog = regexFileLine.exec(anchorErrorLog);
        const regexAccountName = /^Program log: AnchorError caused by account: (.*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./;
        const accountNameAnchorErrorLog = regexAccountName.exec(anchorErrorLog);
        if (noInfoAnchorErrorLog) {
            const [errorCodeString, errorNumber, errorMessage] = noInfoAnchorErrorLog.slice(1, 4);
            const errorCode = {
                code: errorCodeString,
                number: parseInt(errorNumber)
            };
            return new $26e0f71442fe06b5$export$25283b86c4f54869(errorCode, errorMessage, errorLogs, logs, undefined, comparedValues);
        } else if (fileLineAnchorErrorLog) {
            const [file, line, errorCodeString, errorNumber, errorMessage] = fileLineAnchorErrorLog.slice(1, 6);
            const errorCode = {
                code: errorCodeString,
                number: parseInt(errorNumber)
            };
            const fileLine = {
                file: file,
                line: parseInt(line)
            };
            return new $26e0f71442fe06b5$export$25283b86c4f54869(errorCode, errorMessage, errorLogs, logs, fileLine, comparedValues);
        } else if (accountNameAnchorErrorLog) {
            const [accountName, errorCodeString, errorNumber, errorMessage] = accountNameAnchorErrorLog.slice(1, 5);
            const origin = accountName;
            const errorCode = {
                code: errorCodeString,
                number: parseInt(errorNumber)
            };
            return new $26e0f71442fe06b5$export$25283b86c4f54869(errorCode, errorMessage, errorLogs, logs, origin, comparedValues);
        } else return null;
    }
    get program() {
        return this._programErrorStack.stack[this._programErrorStack.stack.length - 1];
    }
    get programErrorStack() {
        return this._programErrorStack.stack;
    }
    toString() {
        return this.message;
    }
}
// An error from a user defined program.
class $26e0f71442fe06b5$export$5ea104d4a550bb14 extends Error {
    constructor(code, msg, logs){
        super();
        this.code = code;
        this.msg = msg;
        this.logs = logs;
        if (logs) this._programErrorStack = $26e0f71442fe06b5$export$741a43b9b6ccc99.parse(logs);
    }
    static parse(err, idlErrors) {
        const errString = err.toString();
        // TODO: don't rely on the error string. web3.js should preserve the error
        //       code information instead of giving us an untyped string.
        let unparsedErrorCode;
        if (errString.includes("custom program error:")) {
            let components = errString.split("custom program error: ");
            if (components.length !== 2) return null;
            else unparsedErrorCode = components[1];
        } else {
            const matches = errString.match(/"Custom":([0-9]+)}/g);
            if (!matches || matches.length > 1) return null;
            unparsedErrorCode = matches[0].match(/([0-9]+)/g)[0];
        }
        let errorCode;
        try {
            errorCode = parseInt(unparsedErrorCode);
        } catch (parseErr) {
            return null;
        }
        // Parse user error.
        let errorMsg = idlErrors.get(errorCode);
        if (errorMsg !== undefined) return new $26e0f71442fe06b5$export$5ea104d4a550bb14(errorCode, errorMsg, err.logs);
        // Parse framework internal error.
        errorMsg = $26e0f71442fe06b5$export$b79665f7c6aace7c.get(errorCode);
        if (errorMsg !== undefined) return new $26e0f71442fe06b5$export$5ea104d4a550bb14(errorCode, errorMsg, err.logs);
        // Unable to parse the error. Just return the untranslated error.
        return null;
    }
    get program() {
        var _a;
        return (_a = this._programErrorStack) === null || _a === void 0 ? void 0 : _a.stack[this._programErrorStack.stack.length - 1];
    }
    get programErrorStack() {
        var _a;
        return (_a = this._programErrorStack) === null || _a === void 0 ? void 0 : _a.stack;
    }
    toString() {
        return this.msg;
    }
}
function $26e0f71442fe06b5$export$dbb77d813a78f040(err, idlErrors) {
    if ($26e0f71442fe06b5$var$isSet("debug-logs")) console.log("Translating error:", err);
    const anchorError = $26e0f71442fe06b5$export$25283b86c4f54869.parse(err.logs);
    if (anchorError) return anchorError;
    const programError = $26e0f71442fe06b5$export$5ea104d4a550bb14.parse(err, idlErrors);
    if (programError) return programError;
    if (err.logs) {
        const handler = {
            get: function(target, prop) {
                if (prop === "programErrorStack") return target.programErrorStack.stack;
                else if (prop === "program") return target.programErrorStack.stack[err.programErrorStack.stack.length - 1];
                else // this is the normal way to return all other props
                // without modifying them.
                // @ts-expect-error
                return Reflect.get(...arguments);
            }
        };
        err.programErrorStack = $26e0f71442fe06b5$export$741a43b9b6ccc99.parse(err.logs);
        return new Proxy(err, handler);
    }
    return err;
}
const $26e0f71442fe06b5$export$5fb3d29439f1983b = {
    // Instructions.
    InstructionMissing: 100,
    InstructionFallbackNotFound: 101,
    InstructionDidNotDeserialize: 102,
    InstructionDidNotSerialize: 103,
    // IDL instructions.
    IdlInstructionStub: 1000,
    IdlInstructionInvalidProgram: 1001,
    // Constraints.
    ConstraintMut: 2000,
    ConstraintHasOne: 2001,
    ConstraintSigner: 2002,
    ConstraintRaw: 2003,
    ConstraintOwner: 2004,
    ConstraintRentExempt: 2005,
    ConstraintSeeds: 2006,
    ConstraintExecutable: 2007,
    ConstraintState: 2008,
    ConstraintAssociated: 2009,
    ConstraintAssociatedInit: 2010,
    ConstraintClose: 2011,
    ConstraintAddress: 2012,
    ConstraintZero: 2013,
    ConstraintTokenMint: 2014,
    ConstraintTokenOwner: 2015,
    ConstraintMintMintAuthority: 2016,
    ConstraintMintFreezeAuthority: 2017,
    ConstraintMintDecimals: 2018,
    ConstraintSpace: 2019,
    ConstraintAccountIsNone: 2020,
    // Require.
    RequireViolated: 2500,
    RequireEqViolated: 2501,
    RequireKeysEqViolated: 2502,
    RequireNeqViolated: 2503,
    RequireKeysNeqViolated: 2504,
    RequireGtViolated: 2505,
    RequireGteViolated: 2506,
    // Accounts.
    AccountDiscriminatorAlreadySet: 3000,
    AccountDiscriminatorNotFound: 3001,
    AccountDiscriminatorMismatch: 3002,
    AccountDidNotDeserialize: 3003,
    AccountDidNotSerialize: 3004,
    AccountNotEnoughKeys: 3005,
    AccountNotMutable: 3006,
    AccountOwnedByWrongProgram: 3007,
    InvalidProgramId: 3008,
    InvalidProgramExecutable: 3009,
    AccountNotSigner: 3010,
    AccountNotSystemOwned: 3011,
    AccountNotInitialized: 3012,
    AccountNotProgramData: 3013,
    AccountNotAssociatedTokenAccount: 3014,
    AccountSysvarMismatch: 3015,
    AccountReallocExceedsLimit: 3016,
    AccountDuplicateReallocs: 3017,
    // Miscellaneous
    DeclaredProgramIdMismatch: 4100,
    // Used for APIs that shouldn't be used anymore.
    Deprecated: 5000
};
const $26e0f71442fe06b5$export$b79665f7c6aace7c = new Map([
    // Instructions.
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.InstructionMissing,
        "8 byte instruction identifier not provided"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.InstructionFallbackNotFound,
        "Fallback functions are not supported"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.InstructionDidNotDeserialize,
        "The program could not deserialize the given instruction"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.InstructionDidNotSerialize,
        "The program could not serialize the given instruction"
    ],
    // Idl instructions.
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.IdlInstructionStub,
        "The program was compiled without idl instructions"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.IdlInstructionInvalidProgram,
        "The transaction was given an invalid program for the IDL instruction"
    ],
    // Constraints.
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintMut,
        "A mut constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintHasOne,
        "A has one constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintSigner,
        "A signer constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintRaw,
        "A raw constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintOwner,
        "An owner constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintRentExempt,
        "A rent exemption constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintSeeds,
        "A seeds constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintExecutable,
        "An executable constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintState,
        "Deprecated Error, feel free to replace with something else"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintAssociated,
        "An associated constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintAssociatedInit,
        "An associated init constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintClose,
        "A close constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintAddress,
        "An address constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintZero,
        "Expected zero account discriminant"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintTokenMint,
        "A token mint constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintTokenOwner,
        "A token owner constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintMintMintAuthority,
        "A mint mint authority constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintMintFreezeAuthority,
        "A mint freeze authority constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintMintDecimals,
        "A mint decimals constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintSpace,
        "A space constraint was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.ConstraintAccountIsNone,
        "A required account for the constraint is None"
    ],
    // Require.
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.RequireViolated,
        "A require expression was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.RequireEqViolated,
        "A require_eq expression was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.RequireKeysEqViolated,
        "A require_keys_eq expression was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.RequireNeqViolated,
        "A require_neq expression was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.RequireKeysNeqViolated,
        "A require_keys_neq expression was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.RequireGtViolated,
        "A require_gt expression was violated"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.RequireGteViolated,
        "A require_gte expression was violated"
    ],
    // Accounts.
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountDiscriminatorAlreadySet,
        "The account discriminator was already set on this account"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountDiscriminatorNotFound,
        "No 8 byte discriminator was found on the account"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountDiscriminatorMismatch,
        "8 byte discriminator did not match what was expected"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountDidNotDeserialize,
        "Failed to deserialize the account"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountDidNotSerialize,
        "Failed to serialize the account"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountNotEnoughKeys,
        "Not enough account keys given to the instruction"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountNotMutable,
        "The given account is not mutable"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountOwnedByWrongProgram,
        "The given account is owned by a different program than expected"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.InvalidProgramId,
        "Program ID was not as expected"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.InvalidProgramExecutable,
        "Program account is not executable"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountNotSigner,
        "The given account did not sign"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountNotSystemOwned,
        "The given account is not owned by the system program"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountNotInitialized,
        "The program expected this account to be already initialized"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountNotProgramData,
        "The given account is not a program data account"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountNotAssociatedTokenAccount,
        "The given account is not the associated token account"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountSysvarMismatch,
        "The given public key does not match the required sysvar"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountReallocExceedsLimit,
        "The account reallocation exceeds the MAX_PERMITTED_DATA_INCREASE limit"
    ],
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.AccountDuplicateReallocs,
        "The account was duplicated for more than one reallocation"
    ],
    // Miscellaneous
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.DeclaredProgramIdMismatch,
        "The declared program id does not match the actual program id"
    ],
    // Deprecated
    [
        $26e0f71442fe06b5$export$5fb3d29439f1983b.Deprecated,
        "The API being used is deprecated and should no longer be used"
    ]
]);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $26e0f71442fe06b5$var$__assign$1 = function() {
    $26e0f71442fe06b5$var$__assign$1 = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26e0f71442fe06b5$var$__assign$1.apply(this, arguments);
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $26e0f71442fe06b5$var$__assign = function() {
    $26e0f71442fe06b5$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26e0f71442fe06b5$var$__assign.apply(this, arguments);
};
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ /**
 * Lower case as a function.
 */ function $26e0f71442fe06b5$var$lowerCase(str) {
    return str.toLowerCase();
}
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $26e0f71442fe06b5$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $26e0f71442fe06b5$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */ function $26e0f71442fe06b5$var$noCase(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $26e0f71442fe06b5$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $26e0f71442fe06b5$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? $26e0f71442fe06b5$var$lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $26e0f71442fe06b5$var$replace($26e0f71442fe06b5$var$replace(input, splitRegexp, "$1\x00$2"), stripRegexp, "\x00");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\x00")start++;
    while(result.charAt(end - 1) === "\x00")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\x00").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $26e0f71442fe06b5$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}
function $26e0f71442fe06b5$var$dotCase(input, options) {
    if (options === void 0) options = {};
    return $26e0f71442fe06b5$var$noCase(input, $26e0f71442fe06b5$var$__assign({
        delimiter: "."
    }, options));
}
function $26e0f71442fe06b5$var$snakeCase(input, options) {
    if (options === void 0) options = {};
    return $26e0f71442fe06b5$var$dotCase(input, $26e0f71442fe06b5$var$__assign$1({
        delimiter: "_"
    }, options));
}
class $26e0f71442fe06b5$var$IdlCoder {
    static fieldLayout(field, types) {
        const fieldName = field.name !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(field.name) : undefined;
        switch(field.type){
            case "bool":
                return $8e63f10e9557e84e$exports.bool(fieldName);
            case "u8":
                return $8e63f10e9557e84e$exports.u8(fieldName);
            case "i8":
                return $8e63f10e9557e84e$exports.i8(fieldName);
            case "u16":
                return $8e63f10e9557e84e$exports.u16(fieldName);
            case "i16":
                return $8e63f10e9557e84e$exports.i16(fieldName);
            case "u32":
                return $8e63f10e9557e84e$exports.u32(fieldName);
            case "i32":
                return $8e63f10e9557e84e$exports.i32(fieldName);
            case "f32":
                return $8e63f10e9557e84e$exports.f32(fieldName);
            case "u64":
                return $8e63f10e9557e84e$exports.u64(fieldName);
            case "i64":
                return $8e63f10e9557e84e$exports.i64(fieldName);
            case "f64":
                return $8e63f10e9557e84e$exports.f64(fieldName);
            case "u128":
                return $8e63f10e9557e84e$exports.u128(fieldName);
            case "i128":
                return $8e63f10e9557e84e$exports.i128(fieldName);
            case "u256":
                return $8e63f10e9557e84e$exports.u256(fieldName);
            case "i256":
                return $8e63f10e9557e84e$exports.i256(fieldName);
            case "bytes":
                return $8e63f10e9557e84e$exports.vecU8(fieldName);
            case "string":
                return $8e63f10e9557e84e$exports.str(fieldName);
            case "publicKey":
                return $8e63f10e9557e84e$exports.publicKey(fieldName);
            default:
                if ("vec" in field.type) return $8e63f10e9557e84e$exports.vec($26e0f71442fe06b5$var$IdlCoder.fieldLayout({
                    name: undefined,
                    type: field.type.vec
                }, types), fieldName);
                else if ("option" in field.type) return $8e63f10e9557e84e$exports.option($26e0f71442fe06b5$var$IdlCoder.fieldLayout({
                    name: undefined,
                    type: field.type.option
                }, types), fieldName);
                else if ("defined" in field.type) {
                    // User defined type.
                    if (!types) throw new $26e0f71442fe06b5$export$f8b0f3df06e3d291("User defined types not provided");
                    const defined = field.type.defined;
                    const filtered = types.filter((t)=>t.name === defined);
                    if (filtered.length !== 1) throw new $26e0f71442fe06b5$export$f8b0f3df06e3d291(`Type not found: ${JSON.stringify(field)}`);
                    return $26e0f71442fe06b5$var$IdlCoder.typeDefLayout(filtered[0], types, fieldName);
                } else if ("array" in field.type) {
                    let arrayTy = field.type.array[0];
                    let arrayLen = field.type.array[1];
                    let innerLayout = $26e0f71442fe06b5$var$IdlCoder.fieldLayout({
                        name: undefined,
                        type: arrayTy
                    }, types);
                    return $8e63f10e9557e84e$exports.array(innerLayout, arrayLen, fieldName);
                } else throw new Error(`Not yet implemented: ${field}`);
        }
    }
    static typeDefLayout(typeDef, types = [], name) {
        switch(typeDef.type.kind){
            case "struct":
                {
                    const fieldLayouts = typeDef.type.fields.map((field)=>{
                        return $26e0f71442fe06b5$var$IdlCoder.fieldLayout(field, types);
                    });
                    return $8e63f10e9557e84e$exports.struct(fieldLayouts, name);
                }
            case "enum":
                {
                    let variants = typeDef.type.variants.map((variant)=>{
                        const name = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(variant.name);
                        if (!variant.fields) return $8e63f10e9557e84e$exports.struct([], name);
                        const fieldLayouts = variant.fields.map((f, i)=>{
                            if (f === null || f === void 0 ? void 0 : f.name) return $26e0f71442fe06b5$var$IdlCoder.fieldLayout(f, types);
                            return $26e0f71442fe06b5$var$IdlCoder.fieldLayout({
                                type: f,
                                name: i.toString()
                            }, types);
                        });
                        return $8e63f10e9557e84e$exports.struct(fieldLayouts, name);
                    });
                    if (name !== undefined) // Buffer-layout lib requires the name to be null (on construction)
                    // when used as a field.
                    return $8e63f10e9557e84e$exports.rustEnum(variants).replicate(name);
                    return $8e63f10e9557e84e$exports.rustEnum(variants, name);
                }
            case "alias":
                return $26e0f71442fe06b5$var$IdlCoder.fieldLayout({
                    type: typeDef.type.value,
                    name: typeDef.name
                }, types);
        }
    }
}
/**
 * Namespace for global instruction function signatures (i.e. functions
 * that aren't namespaced by the state or any of its trait implementations).
 */ const $26e0f71442fe06b5$var$SIGHASH_GLOBAL_NAMESPACE = "global";
/**
 * Encodes and decodes program instructions.
 */ class $26e0f71442fe06b5$export$219ca8c2dec9575e {
    constructor(idl){
        this.idl = idl;
        this.ixLayout = $26e0f71442fe06b5$export$219ca8c2dec9575e.parseIxLayout(idl);
        const sighashLayouts = new Map();
        idl.instructions.forEach((ix)=>{
            const sh = $26e0f71442fe06b5$var$sighash($26e0f71442fe06b5$var$SIGHASH_GLOBAL_NAMESPACE, ix.name);
            sighashLayouts.set((0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(sh), {
                layout: this.ixLayout.get(ix.name),
                name: ix.name
            });
        });
        this.sighashLayouts = sighashLayouts;
    }
    /**
     * Encodes a program instruction.
     */ encode(ixName, ix) {
        return this._encode($26e0f71442fe06b5$var$SIGHASH_GLOBAL_NAMESPACE, ixName, ix);
    }
    _encode(nameSpace, ixName, ix) {
        const buffer = (0, $cbQCu.Buffer).alloc(1000); // TODO: use a tighter buffer.
        const methodName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(ixName);
        const layout = this.ixLayout.get(methodName);
        if (!layout) throw new Error(`Unknown method: ${methodName}`);
        const len = layout.encode(ix, buffer);
        const data = buffer.slice(0, len);
        return (0, $cbQCu.Buffer).concat([
            $26e0f71442fe06b5$var$sighash(nameSpace, ixName),
            data
        ]);
    }
    static parseIxLayout(idl) {
        const ixLayouts = idl.instructions.map((ix)=>{
            let fieldLayouts = ix.args.map((arg)=>{
                var _a, _b;
                return $26e0f71442fe06b5$var$IdlCoder.fieldLayout(arg, Array.from([
                    ...(_a = idl.accounts) !== null && _a !== void 0 ? _a : [],
                    ...(_b = idl.types) !== null && _b !== void 0 ? _b : []
                ]));
            });
            const name = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(ix.name);
            return [
                name,
                $8e63f10e9557e84e$exports.struct(fieldLayouts, name)
            ];
        });
        return new Map(ixLayouts);
    }
    /**
     * Decodes a program instruction.
     */ decode(ix, encoding = "hex") {
        if (typeof ix === "string") ix = encoding === "hex" ? (0, $cbQCu.Buffer).from(ix, "hex") : (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).decode(ix);
        let sighash = (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(ix.slice(0, 8));
        let data = ix.slice(8);
        const decoder = this.sighashLayouts.get(sighash);
        if (!decoder) return null;
        return {
            data: decoder.layout.decode(data),
            name: decoder.name
        };
    }
    /**
     * Returns a formatted table of all the fields in the given instruction data.
     */ format(ix, accountMetas) {
        return $26e0f71442fe06b5$var$InstructionFormatter.format(ix, accountMetas, this.idl);
    }
}
class $26e0f71442fe06b5$var$InstructionFormatter {
    static format(ix, accountMetas, idl) {
        const idlIx = idl.instructions.filter((i)=>ix.name === i.name)[0];
        if (idlIx === undefined) {
            console.error("Invalid instruction given");
            return null;
        }
        const args = idlIx.args.map((idlField)=>{
            return {
                name: idlField.name,
                type: $26e0f71442fe06b5$var$InstructionFormatter.formatIdlType(idlField.type),
                data: $26e0f71442fe06b5$var$InstructionFormatter.formatIdlData(idlField, ix.data[idlField.name], idl.types)
            };
        });
        const flatIdlAccounts = $26e0f71442fe06b5$var$InstructionFormatter.flattenIdlAccounts(idlIx.accounts);
        const accounts = accountMetas.map((meta, idx)=>{
            if (idx < flatIdlAccounts.length) return {
                name: flatIdlAccounts[idx].name,
                ...meta
            };
            else return {
                name: undefined,
                ...meta
            };
        });
        return {
            args: args,
            accounts: accounts
        };
    }
    static formatIdlType(idlType) {
        if (typeof idlType === "string") return idlType;
        if ("vec" in idlType) return `Vec<${this.formatIdlType(idlType.vec)}>`;
        if ("option" in idlType) return `Option<${this.formatIdlType(idlType.option)}>`;
        if ("defined" in idlType) return idlType.defined;
        if ("array" in idlType) return `Array<${idlType.array[0]}; ${idlType.array[1]}>`;
        throw new Error(`Unknown IDL type: ${idlType}`);
    }
    static formatIdlData(idlField, data, types) {
        if (typeof idlField.type === "string") return data.toString();
        if (idlField.type.hasOwnProperty("vec")) return "[" + data.map((d)=>this.formatIdlData({
                name: "",
                type: idlField.type.vec
            }, d)).join(", ") + "]";
        if (idlField.type.hasOwnProperty("option")) return data === null ? "null" : this.formatIdlData({
            name: "",
            type: idlField.type.option
        }, data, types);
        if (idlField.type.hasOwnProperty("defined")) {
            if (types === undefined) throw new Error("User defined types not provided");
            const filtered = types.filter((t)=>t.name === idlField.type.defined);
            if (filtered.length !== 1) throw new Error(`Type not found: ${idlField.type.defined}`);
            return $26e0f71442fe06b5$var$InstructionFormatter.formatIdlDataDefined(filtered[0], data, types);
        }
        return "unknown";
    }
    static formatIdlDataDefined(typeDef, data, types) {
        switch(typeDef.type.kind){
            case "struct":
                {
                    const struct = typeDef.type;
                    const fields = Object.keys(data).map((k)=>{
                        const field = struct.fields.find((f)=>f.name === k);
                        if (!field) throw new Error("Unable to find type");
                        return k + ": " + $26e0f71442fe06b5$var$InstructionFormatter.formatIdlData(field, data[k], types);
                    }).join(", ");
                    return "{ " + fields + " }";
                }
            case "enum":
                if (typeDef.type.variants.length === 0) return "{}";
                // Struct enum.
                if (typeDef.type.variants[0].name) {
                    const variants = typeDef.type.variants;
                    const variant = Object.keys(data)[0];
                    const enumType = data[variant];
                    const namedFields = Object.keys(enumType).map((f)=>{
                        var _a;
                        const fieldData = enumType[f];
                        const idlField = (_a = variants[variant]) === null || _a === void 0 ? void 0 : _a.find((v)=>v.name === f);
                        if (!idlField) throw new Error("Unable to find variant");
                        return f + ": " + $26e0f71442fe06b5$var$InstructionFormatter.formatIdlData(idlField, fieldData, types);
                    }).join(", ");
                    const variantName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(variant, {
                        pascalCase: true
                    });
                    if (namedFields.length === 0) return variantName;
                    return `${variantName} { ${namedFields} }`;
                } else // TODO.
                return "Tuple formatting not yet implemented";
            case "alias":
                return $26e0f71442fe06b5$var$InstructionFormatter.formatIdlType(typeDef.type.value);
        }
    }
    static flattenIdlAccounts(accounts, prefix) {
        return accounts.map((account)=>{
            const accName = $26e0f71442fe06b5$var$sentenceCase(account.name);
            if (account.hasOwnProperty("accounts")) {
                const newPrefix = prefix ? `${prefix} > ${accName}` : accName;
                return $26e0f71442fe06b5$var$InstructionFormatter.flattenIdlAccounts(account.accounts, newPrefix);
            } else return {
                ...account,
                name: prefix ? `${prefix} > ${accName}` : accName
            };
        }).flat();
    }
}
function $26e0f71442fe06b5$var$sentenceCase(field) {
    const result = field.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}
// Not technically sighash, since we don't include the arguments, as Rust
// doesn't allow function overloading.
function $26e0f71442fe06b5$var$sighash(nameSpace, ixName) {
    let name = $26e0f71442fe06b5$var$snakeCase(ixName);
    let preimage = `${nameSpace}:${name}`;
    return (0, $cbQCu.Buffer).from((0, $9XCBn.sha256)(preimage).slice(0, 8));
}
function $26e0f71442fe06b5$var$accountSize(idl, idlAccount) {
    switch(idlAccount.type.kind){
        case "struct":
            return idlAccount.type.fields.map((f)=>$26e0f71442fe06b5$var$typeSize(idl, f.type)).reduce((acc, size)=>acc + size, 0);
        case "enum":
            {
                const variantSizes = idlAccount.type.variants.map((variant)=>{
                    if (!variant.fields) return 0;
                    return variant.fields.map((f)=>{
                        // Unnamed enum variant
                        if (!(typeof f === "object" && "name" in f)) return $26e0f71442fe06b5$var$typeSize(idl, f);
                        // Named enum variant
                        return $26e0f71442fe06b5$var$typeSize(idl, f.type);
                    }).reduce((acc, size)=>acc + size, 0);
                });
                return Math.max(...variantSizes) + 1;
            }
        case "alias":
            return $26e0f71442fe06b5$var$typeSize(idl, idlAccount.type.value);
    }
}
// Returns the size of the type in bytes. For variable length types, just return
// 1. Users should override this value in such cases.
function $26e0f71442fe06b5$var$typeSize(idl, ty) {
    var _a, _b;
    switch(ty){
        case "bool":
            return 1;
        case "u8":
            return 1;
        case "i8":
            return 1;
        case "i16":
            return 2;
        case "u16":
            return 2;
        case "u32":
            return 4;
        case "i32":
            return 4;
        case "f32":
            return 4;
        case "u64":
            return 8;
        case "i64":
            return 8;
        case "f64":
            return 8;
        case "u128":
            return 16;
        case "i128":
            return 16;
        case "u256":
            return 32;
        case "i256":
            return 32;
        case "bytes":
            return 1;
        case "string":
            return 1;
        case "publicKey":
            return 32;
        default:
            if ("vec" in ty) return 1;
            if ("option" in ty) return 1 + $26e0f71442fe06b5$var$typeSize(idl, ty.option);
            if ("coption" in ty) return 4 + $26e0f71442fe06b5$var$typeSize(idl, ty.coption);
            if ("defined" in ty) {
                const filtered = (_b = (_a = idl.types) === null || _a === void 0 ? void 0 : _a.filter((t)=>t.name === ty.defined)) !== null && _b !== void 0 ? _b : [];
                if (filtered.length !== 1) throw new $26e0f71442fe06b5$export$f8b0f3df06e3d291(`Type not found: ${JSON.stringify(ty)}`);
                let typeDef = filtered[0];
                return $26e0f71442fe06b5$var$accountSize(idl, typeDef);
            }
            if ("array" in ty) {
                let arrayTy = ty.array[0];
                let arraySize = ty.array[1];
                return $26e0f71442fe06b5$var$typeSize(idl, arrayTy) * arraySize;
            }
            throw new Error(`Invalid type ${JSON.stringify(ty)}`);
    }
}
/**
 * Number of bytes in anchor discriminators
 */ const $26e0f71442fe06b5$export$f163405efe051b20 = 8;
function $26e0f71442fe06b5$var$discriminator(preimage) {
    return $26e0f71442fe06b5$require$Buffer.from((0, $9XCBn.sha256)(preimage).slice(0, $26e0f71442fe06b5$export$f163405efe051b20));
}
/**
 * Encodes and decodes account objects.
 */ class $26e0f71442fe06b5$export$b6bcba197161c0e1 {
    constructor(idl){
        if (idl.accounts === undefined) {
            this.accountLayouts = new Map();
            return;
        }
        const layouts = idl.accounts.map((acc)=>{
            return [
                acc.name,
                $26e0f71442fe06b5$var$IdlCoder.typeDefLayout(acc, idl.types)
            ];
        });
        this.accountLayouts = new Map(layouts);
        this.idl = idl;
    }
    async encode(accountName, account) {
        const buffer = (0, $cbQCu.Buffer).alloc(1000); // TODO: use a tighter buffer.
        const layout = this.accountLayouts.get(accountName);
        if (!layout) throw new Error(`Unknown account: ${accountName}`);
        const len = layout.encode(account, buffer);
        let accountData = buffer.slice(0, len);
        let discriminator = $26e0f71442fe06b5$export$b6bcba197161c0e1.accountDiscriminator(accountName);
        return (0, $cbQCu.Buffer).concat([
            discriminator,
            accountData
        ]);
    }
    decode(accountName, data) {
        // Assert the account discriminator is correct.
        const discriminator = $26e0f71442fe06b5$export$b6bcba197161c0e1.accountDiscriminator(accountName);
        if (discriminator.compare(data.slice(0, 8))) throw new Error("Invalid account discriminator");
        return this.decodeUnchecked(accountName, data);
    }
    decodeAny(data) {
        const accountDescriminator = data.slice(0, 8);
        const accountName = Array.from(this.accountLayouts.keys()).find((key)=>$26e0f71442fe06b5$export$b6bcba197161c0e1.accountDiscriminator(key).equals(accountDescriminator));
        if (!accountName) throw new Error("Account descriminator not found");
        return this.decodeUnchecked(accountName, data);
    }
    decodeUnchecked(accountName, ix) {
        // Chop off the discriminator before decoding.
        const data = ix.subarray($26e0f71442fe06b5$export$f163405efe051b20);
        const layout = this.accountLayouts.get(accountName);
        if (!layout) throw new Error(`Unknown account: ${accountName}`);
        return layout.decode(data);
    }
    memcmp(accountName, appendData) {
        const discriminator = $26e0f71442fe06b5$export$b6bcba197161c0e1.accountDiscriminator(accountName);
        return {
            offset: 0,
            bytes: (0, (/*@__PURE__*/$parcel$interopDefault($f4WXk))).encode(appendData ? (0, $cbQCu.Buffer).concat([
                discriminator,
                appendData
            ]) : discriminator)
        };
    }
    size(idlAccount) {
        var _a;
        return $26e0f71442fe06b5$export$f163405efe051b20 + ((_a = $26e0f71442fe06b5$var$accountSize(this.idl, idlAccount)) !== null && _a !== void 0 ? _a : 0);
    }
    /**
     * Calculates and returns a unique 8 byte discriminator prepended to all anchor accounts.
     *
     * @param name The name of the account to calculate the discriminator.
     */ static accountDiscriminator(name) {
        const discriminatorPreimage = `account:${(0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(name, {
            pascalCase: true,
            preserveConsecutiveUppercase: true
        })}`;
        return $26e0f71442fe06b5$var$discriminator(discriminatorPreimage);
    }
}
class $26e0f71442fe06b5$export$34d0b16e294359b6 {
    constructor(idl){
        if (idl.events === undefined) {
            this.layouts = new Map();
            return;
        }
        const layouts = idl.events.map((event)=>{
            let eventTypeDef = {
                name: event.name,
                type: {
                    kind: "struct",
                    fields: event.fields.map((f)=>{
                        return {
                            name: f.name,
                            type: f.type
                        };
                    })
                }
            };
            return [
                event.name,
                $26e0f71442fe06b5$var$IdlCoder.typeDefLayout(eventTypeDef, idl.types)
            ];
        });
        this.layouts = new Map(layouts);
        this.discriminators = new Map(idl.events === undefined ? [] : idl.events.map((e)=>[
                $26e0f71442fe06b5$var$encode($26e0f71442fe06b5$export$a2f66705fb2dcae4(e.name)),
                e.name
            ]));
    }
    decode(log) {
        let logArr;
        // This will throw if log length is not a multiple of 4.
        try {
            logArr = $26e0f71442fe06b5$var$decode(log);
        } catch (e) {
            return null;
        }
        const disc = $26e0f71442fe06b5$var$encode(logArr.slice(0, 8));
        // Only deserialize if the discriminator implies a proper event.
        const eventName = this.discriminators.get(disc);
        if (eventName === undefined) return null;
        const layout = this.layouts.get(eventName);
        if (!layout) throw new Error(`Unknown event: ${eventName}`);
        const data = layout.decode(logArr.slice(8));
        return {
            data: data,
            name: eventName
        };
    }
}
function $26e0f71442fe06b5$export$a2f66705fb2dcae4(name) {
    return $26e0f71442fe06b5$var$discriminator(`event:${name}`);
}
/**
 * Encodes and decodes user-defined types.
 */ class $26e0f71442fe06b5$var$BorshTypesCoder {
    constructor(idl){
        if (idl.types === undefined) {
            this.typeLayouts = new Map();
            return;
        }
        const layouts = idl.types.map((acc)=>{
            return [
                acc.name,
                $26e0f71442fe06b5$var$IdlCoder.typeDefLayout(acc, idl.types)
            ];
        });
        this.typeLayouts = new Map(layouts);
        this.idl = idl;
    }
    encode(typeName, type) {
        const buffer = (0, $cbQCu.Buffer).alloc(1000); // TODO: use a tighter buffer.
        const layout = this.typeLayouts.get(typeName);
        if (!layout) throw new Error(`Unknown type: ${typeName}`);
        const len = layout.encode(type, buffer);
        return buffer.slice(0, len);
    }
    decode(typeName, typeData) {
        const layout = this.typeLayouts.get(typeName);
        if (!layout) throw new Error(`Unknown type: ${typeName}`);
        return layout.decode(typeData);
    }
}
/**
 * BorshCoder is the default Coder for Anchor programs implementing the
 * borsh based serialization interface.
 */ class $26e0f71442fe06b5$export$e59abd64f0cb1e2e {
    constructor(idl){
        this.instruction = new $26e0f71442fe06b5$export$219ca8c2dec9575e(idl);
        this.accounts = new $26e0f71442fe06b5$export$b6bcba197161c0e1(idl);
        this.events = new $26e0f71442fe06b5$export$34d0b16e294359b6(idl);
        this.types = new $26e0f71442fe06b5$var$BorshTypesCoder(idl);
    }
}
var $26e0f71442fe06b5$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $26e0f71442fe06b5$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $26e0f71442fe06b5$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
     *
     * Positive values are generally expected.
     *
     * Zero will only appear in {@link Constant}s and in {@link
     * Sequence}s where the {@link Sequence#count|count} is zero.
     *
     * A negative value indicates that the span is value-specific, and
     * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
     * Object.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances.  If left undefined the span of the unnamed layout will
     * be treated as padding: it will not be mutated by {@link
     * Layout#encode|encode} nor represented as a property in the
     * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */ makeDestinationObject() {
        return {};
    }
    /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */ decode(b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */ encode(src, b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */ fromArray(values) {
        return undefined;
    }
}
var $26e0f71442fe06b5$var$Layout_2 = $26e0f71442fe06b5$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $26e0f71442fe06b5$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$ExternalLayout extends $26e0f71442fe06b5$var$Layout {
    /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$OffsetLayout extends $26e0f71442fe06b5$var$ExternalLayout {
    constructor(layout, offset, property){
        if (!(layout instanceof $26e0f71442fe06b5$var$Layout)) throw new TypeError("layout must be a Layout");
        if (undefined === offset) offset = 0;
        else if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
     * start of another layout.
     *
     * The value may be positive or negative, but an error will thrown
     * if at the point of use it goes outside the span of the Buffer
     * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $26e0f71442fe06b5$var$UInt || this.layout instanceof $26e0f71442fe06b5$var$UIntBE;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.encode(src, b, offset + this.offset);
    }
}
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$UInt extends $26e0f71442fe06b5$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$UIntBE extends $26e0f71442fe06b5$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
const $26e0f71442fe06b5$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $26e0f71442fe06b5$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $26e0f71442fe06b5$var$V2E32);
    const lo32 = src - hi32 * $26e0f71442fe06b5$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $26e0f71442fe06b5$var$roundedInt64(hi32, lo32) {
    return hi32 * $26e0f71442fe06b5$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$NearUInt64 extends $26e0f71442fe06b5$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readUInt32LE(offset + 4);
        return $26e0f71442fe06b5$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $26e0f71442fe06b5$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$NearInt64 extends $26e0f71442fe06b5$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readInt32LE(offset + 4);
        return $26e0f71442fe06b5$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $26e0f71442fe06b5$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$Structure extends $26e0f71442fe06b5$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $26e0f71442fe06b5$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {}
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
     * structure.
     *
     * The individual elements need not be the same type, and may be
     * either scalar or aggregate layouts.  If a member layout leaves
     * its {@link Layout#property|property} undefined the
     * corresponding region of the buffer associated with the element
     * will not be mutated.
     *
     * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
     * buffers.
     *
     * In some situations a structure many be extended with additional
     * fields over time, with older installations providing only a
     * prefix of the full structure.  If this property is `true`
     * decoding will accept those buffers and leave subsequent fields
     * undefined, as long as the buffer ends at a field boundary.
     * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
             * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
     * item may have had a dynamic length and we don't want to include
     * the padding between it and the end of the space reserved for
     * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
    }
    /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
    }
}
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $26e0f71442fe06b5$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
     * discriminator is referenced in isolation (generally when {@link
     * Union#decode|Union decode} cannot delegate to a specific
     * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */ decode() {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */ encode() {
        throw new Error("UnionDiscriminator is abstract");
    }
}
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $26e0f71442fe06b5$var$UnionLayoutDiscriminator extends $26e0f71442fe06b5$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $26e0f71442fe06b5$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
     * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$Union extends $26e0f71442fe06b5$var$Layout {
    constructor(discr, defaultLayout, property){
        const upv = discr instanceof $26e0f71442fe06b5$var$UInt || discr instanceof $26e0f71442fe06b5$var$UIntBE;
        if (upv) discr = new $26e0f71442fe06b5$var$UnionLayoutDiscriminator(new $26e0f71442fe06b5$var$OffsetLayout(discr));
        else if (discr instanceof $26e0f71442fe06b5$var$ExternalLayout && discr.isCount()) discr = new $26e0f71442fe06b5$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $26e0f71442fe06b5$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $26e0f71442fe06b5$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
     * layout.  The union spans its default layout, plus any prefix
     * variant layout.  By construction both layouts, if present, have
     * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && upv) span += discr.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
     *
     * This a {@link UnionDiscriminator} either passed to the
     * constructor or synthesized from the `discr` constructor
     * argument.  {@link
     * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
     * `true` iff the `discr` parameter was a non-offset {@link
     * Layout} instance. */ this.discriminator = discr;
        /** `true` if the {@link Union#discriminator|discriminator} is the
     * first field in the union.
     *
     * If `false` the discriminator is obtained from somewhere
     * else. */ this.usesPrefixDiscriminator = upv;
        /** The layout for non-discriminator content when the value of the
     * discriminator is not recognized.
     *
     * This is the value passed to the constructor.  It is
     * structurally equivalent to the second component of {@link
     * Union#layout|layout} but may have a different property
     * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
     *
     * The keys are unsigned integers which should be compatible with
     * {@link Union.discriminator|discriminator}.  The property value
     * is the corresponding {@link VariantLayout} instances assigned
     * to this union by {@link Union#addVariant|addVariant}.
     *
     * **NOTE** The registry remains mutable so that variants can be
     * {@link Union#addVariant|added} at any time.  Users should not
     * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
     *
     * Defaults to {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
     * be overridden using {@link
     * Union#configGetSourceVariant|configGetSourceVariant}.
     *
     * @param {Object} src - as with {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * @returns {(undefined|VariantLayout)} The default variant
     * (`undefined`) or first registered variant that uses a property
     * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
     * Union#getSourceVariant|getSourceVariant}.
     *
     * Use this if the desired variant cannot be identified using the
     * algorithm of {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * **NOTE** The provided function will be invoked bound to this
     * Union instance, providing local access to {@link
     * Union#registry|registry}.
     *
     * @param {Function} gsv - a function that follows the API of
     * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        /* Default layouts always have non-negative span, so we don't have
     * one and we have to recognize the variant which will in turn
     * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */ defaultGetSourceVariant(src) {
        if (src.hasOwnProperty(this.discriminator.property)) {
            if (this.defaultLayout && src.hasOwnProperty(this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || src.hasOwnProperty(vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (src.hasOwnProperty(vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        let clo = this.registry[discr];
        if (undefined === clo) {
            let contentOffset = 0;
            clo = this.defaultLayout;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            dest[clo.property] = this.defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $26e0f71442fe06b5$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */ getVariant(vb, offset) {
        let variant = vb;
        if ($26e0f71442fe06b5$require$Buffer.isBuffer(vb)) {
            if (undefined === offset) offset = 0;
            variant = this.discriminator.decode(vb, offset);
        }
        return this.registry[variant];
    }
}
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$VariantLayout extends $26e0f71442fe06b5$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $26e0f71442fe06b5$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $26e0f71442fe06b5$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
     * the {@link Union#discriminator|discriminator} of the containing
     * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
     * non-discriminator part of the {@link
     * VariantLayout#union|union}.  If `null` the variant carries no
     * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
       * variable. */ return this.span;
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ return contentOffset + this.layout.getSpan(b, offset + contentOffset);
    }
    /** @override */ decode(b, offset) {
        const dest = this.makeDestinationObject();
        if (undefined === offset) offset = 0;
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !src.hasOwnProperty(this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
    }
}
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Buffer.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $26e0f71442fe06b5$var$Blob$1 extends $26e0f71442fe06b5$var$Layout {
    constructor(length, property){
        if (!(length instanceof $26e0f71442fe06b5$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $26e0f71442fe06b5$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
     *
     * This may be a non-negative integer, or an instance of {@link
     * ExternalLayout} that satisfies {@link
     * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return b.slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $26e0f71442fe06b5$var$ExternalLayout) span = src.length;
        if (!($26e0f71442fe06b5$require$Buffer.isBuffer(src) && span === src.length)) throw new TypeError($26e0f71442fe06b5$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Buffer as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        b.write(src.toString("hex"), offset, span, "hex");
        if (this.length instanceof $26e0f71442fe06b5$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
/** Factory for {@link OffsetLayout}. */ var $26e0f71442fe06b5$var$offset = (layout, offset, property)=>new $26e0f71442fe06b5$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ var $26e0f71442fe06b5$var$u8 = (property)=>new $26e0f71442fe06b5$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ var $26e0f71442fe06b5$var$u32 = (property)=>new $26e0f71442fe06b5$var$UInt(4, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ var $26e0f71442fe06b5$var$nu64 = (property)=>new $26e0f71442fe06b5$var$NearUInt64(property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ var $26e0f71442fe06b5$var$ns64 = (property)=>new $26e0f71442fe06b5$var$NearInt64(property);
/** Factory for {@link Structure} values. */ var $26e0f71442fe06b5$var$struct = (fields, property, decodePrefixes)=>new $26e0f71442fe06b5$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link Union} values. */ var $26e0f71442fe06b5$var$union = (discr, defaultLayout, property)=>new $26e0f71442fe06b5$var$Union(discr, defaultLayout, property);
/** Factory for {@link Blob} values. */ var $26e0f71442fe06b5$var$blob = (length, property)=>new $26e0f71442fe06b5$var$Blob$1(length, property);
class $26e0f71442fe06b5$var$SystemInstructionCoder {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(_){}
    encode(ixName, ix) {
        switch((0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(ixName)){
            case "createAccount":
                return $26e0f71442fe06b5$var$encodeCreateAccount(ix);
            case "assign":
                return $26e0f71442fe06b5$var$encodeAssign(ix);
            case "transfer":
                return $26e0f71442fe06b5$var$encodeTransfer(ix);
            case "createAccountWithSeed":
                return $26e0f71442fe06b5$var$encodeCreateAccountWithSeed(ix);
            case "advanceNonceAccount":
                return $26e0f71442fe06b5$var$encodeAdvanceNonceAccount(ix);
            case "withdrawNonceAccount":
                return $26e0f71442fe06b5$var$encodeWithdrawNonceAccount(ix);
            case "initializeNonceAccount":
                return $26e0f71442fe06b5$var$encodeInitializeNonceAccount(ix);
            case "authorizeNonceAccount":
                return $26e0f71442fe06b5$var$encodeAuthorizeNonceAccount(ix);
            case "allocate":
                return $26e0f71442fe06b5$var$encodeAllocate(ix);
            case "allocateWithSeed":
                return $26e0f71442fe06b5$var$encodeAllocateWithSeed(ix);
            case "assignWithSeed":
                return $26e0f71442fe06b5$var$encodeAssignWithSeed(ix);
            case "transferWithSeed":
                return $26e0f71442fe06b5$var$encodeTransferWithSeed(ix);
            default:
                throw new Error(`Invalid instruction: ${ixName}`);
        }
    }
    encodeState(_ixName, _ix) {
        throw new Error("System does not have state");
    }
}
class $26e0f71442fe06b5$var$RustStringLayout extends $26e0f71442fe06b5$var$Layout_2 {
    constructor(property){
        super(-1, property);
        this.property = property;
        this.layout = $26e0f71442fe06b5$var$struct([
            $26e0f71442fe06b5$var$u32("length"),
            $26e0f71442fe06b5$var$u32("lengthPadding"),
            $26e0f71442fe06b5$var$blob($26e0f71442fe06b5$var$offset($26e0f71442fe06b5$var$u32(), -8), "chars")
        ], this.property);
    }
    encode(src, b, offset = 0) {
        if (src === null || src === undefined) return this.layout.span;
        const data = {
            chars: $26e0f71442fe06b5$require$Buffer.from(src, "utf8")
        };
        return this.layout.encode(data, b, offset);
    }
    decode(b, offset = 0) {
        const data = this.layout.decode(b, offset);
        return data["chars"].toString();
    }
    getSpan(b, offset = 0) {
        return $26e0f71442fe06b5$var$u32().span + $26e0f71442fe06b5$var$u32().span + new (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG)))(new Uint8Array(b).slice(offset, offset + 4), 10, "le").toNumber();
    }
}
function $26e0f71442fe06b5$var$rustStringLayout(property) {
    return new $26e0f71442fe06b5$var$RustStringLayout(property);
}
function $26e0f71442fe06b5$var$publicKey$2(property) {
    return $26e0f71442fe06b5$var$blob(32, property);
}
function $26e0f71442fe06b5$var$encodeCreateAccount({ lamports: lamports, space: space, owner: owner }) {
    return $26e0f71442fe06b5$var$encodeData({
        createAccount: {
            lamports: lamports,
            space: space,
            owner: owner.toBuffer()
        }
    });
}
function $26e0f71442fe06b5$var$encodeAssign({ owner: owner }) {
    return $26e0f71442fe06b5$var$encodeData({
        assign: {
            owner: owner.toBuffer()
        }
    });
}
function $26e0f71442fe06b5$var$encodeTransfer({ lamports: lamports }) {
    return $26e0f71442fe06b5$var$encodeData({
        transfer: {
            lamports: lamports
        }
    });
}
function $26e0f71442fe06b5$var$encodeCreateAccountWithSeed({ base: base, seed: seed, lamports: lamports, space: space, owner: owner }) {
    return $26e0f71442fe06b5$var$encodeData({
        createAccountWithSeed: {
            base: base.toBuffer(),
            seed: seed,
            lamports: lamports,
            space: space,
            owner: owner.toBuffer()
        }
    }, $26e0f71442fe06b5$var$LAYOUT.getVariant(3).span + seed.length);
}
function $26e0f71442fe06b5$var$encodeInitializeNonceAccount({ authorized: authorized }) {
    return $26e0f71442fe06b5$var$encodeData({
        initializeNonceAccount: {
            authorized: authorized.toBuffer()
        }
    });
}
function $26e0f71442fe06b5$var$encodeAdvanceNonceAccount({ authorized: authorized }) {
    return $26e0f71442fe06b5$var$encodeData({
        advanceNonceAccount: {
            authorized: authorized.toBuffer()
        }
    });
}
function $26e0f71442fe06b5$var$encodeWithdrawNonceAccount({ lamports: lamports }) {
    return $26e0f71442fe06b5$var$encodeData({
        withdrawNonceAccount: {
            lamports: lamports
        }
    });
}
function $26e0f71442fe06b5$var$encodeAuthorizeNonceAccount({ authorized: authorized }) {
    return $26e0f71442fe06b5$var$encodeData({
        authorizeNonceAccount: {
            authorized: authorized.toBuffer()
        }
    });
}
function $26e0f71442fe06b5$var$encodeAllocate({ space: space }) {
    return $26e0f71442fe06b5$var$encodeData({
        allocate: {
            space: space
        }
    });
}
function $26e0f71442fe06b5$var$encodeAllocateWithSeed({ base: base, seed: seed, space: space, owner: owner }) {
    return $26e0f71442fe06b5$var$encodeData({
        allocateWithSeed: {
            base: base.toBuffer(),
            seed: seed,
            space: space,
            owner: owner.toBuffer()
        }
    }, $26e0f71442fe06b5$var$LAYOUT.getVariant(9).span + seed.length);
}
function $26e0f71442fe06b5$var$encodeAssignWithSeed({ base: base, seed: seed, owner: owner }) {
    return $26e0f71442fe06b5$var$encodeData({
        assignWithSeed: {
            base: base.toBuffer(),
            seed: seed,
            owner: owner.toBuffer()
        }
    }, $26e0f71442fe06b5$var$LAYOUT.getVariant(10).span + seed.length);
}
function $26e0f71442fe06b5$var$encodeTransferWithSeed({ lamports: lamports, seed: seed, owner: owner }) {
    return $26e0f71442fe06b5$var$encodeData({
        transferWithSeed: {
            lamports: lamports,
            seed: seed,
            owner: owner.toBuffer()
        }
    }, $26e0f71442fe06b5$var$LAYOUT.getVariant(11).span + seed.length);
}
const $26e0f71442fe06b5$var$LAYOUT = $26e0f71442fe06b5$var$union($26e0f71442fe06b5$var$u32("instruction"));
$26e0f71442fe06b5$var$LAYOUT.addVariant(0, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$ns64("lamports"),
    $26e0f71442fe06b5$var$ns64("space"),
    $26e0f71442fe06b5$var$publicKey$2("owner")
]), "createAccount");
$26e0f71442fe06b5$var$LAYOUT.addVariant(1, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey$2("owner")
]), "assign");
$26e0f71442fe06b5$var$LAYOUT.addVariant(2, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$ns64("lamports")
]), "transfer");
$26e0f71442fe06b5$var$LAYOUT.addVariant(3, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey$2("base"),
    $26e0f71442fe06b5$var$rustStringLayout("seed"),
    $26e0f71442fe06b5$var$ns64("lamports"),
    $26e0f71442fe06b5$var$ns64("space"),
    $26e0f71442fe06b5$var$publicKey$2("owner")
]), "createAccountWithSeed");
$26e0f71442fe06b5$var$LAYOUT.addVariant(4, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey$2("authorized")
]), "advanceNonceAccount");
$26e0f71442fe06b5$var$LAYOUT.addVariant(5, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$ns64("lamports")
]), "withdrawNonceAccount");
$26e0f71442fe06b5$var$LAYOUT.addVariant(6, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey$2("authorized")
]), "initializeNonceAccount");
$26e0f71442fe06b5$var$LAYOUT.addVariant(7, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey$2("authorized")
]), "authorizeNonceAccount");
$26e0f71442fe06b5$var$LAYOUT.addVariant(8, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$ns64("space")
]), "allocate");
$26e0f71442fe06b5$var$LAYOUT.addVariant(9, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey$2("base"),
    $26e0f71442fe06b5$var$rustStringLayout("seed"),
    $26e0f71442fe06b5$var$ns64("space"),
    $26e0f71442fe06b5$var$publicKey$2("owner")
]), "allocateWithSeed");
$26e0f71442fe06b5$var$LAYOUT.addVariant(10, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey$2("base"),
    $26e0f71442fe06b5$var$rustStringLayout("seed"),
    $26e0f71442fe06b5$var$publicKey$2("owner")
]), "assignWithSeed");
$26e0f71442fe06b5$var$LAYOUT.addVariant(11, $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$ns64("lamports"),
    $26e0f71442fe06b5$var$rustStringLayout("seed"),
    $26e0f71442fe06b5$var$publicKey$2("owner")
]), "transferWithSeed");
function $26e0f71442fe06b5$var$encodeData(instruction, maxSpan) {
    const b = $26e0f71442fe06b5$require$Buffer.alloc(maxSpan !== null && maxSpan !== void 0 ? maxSpan : $26e0f71442fe06b5$var$instructionMaxSpan);
    const span = $26e0f71442fe06b5$var$LAYOUT.encode(instruction, b);
    if (maxSpan === undefined) return b.slice(0, span);
    return b;
}
const $26e0f71442fe06b5$var$instructionMaxSpan = Math.max(...Object.values($26e0f71442fe06b5$var$LAYOUT.registry).map((r)=>r.span));
class $26e0f71442fe06b5$var$SystemAccountsCoder {
    constructor(idl){
        this.idl = idl;
    }
    async encode(accountName, account) {
        switch(accountName){
            case "nonce":
                {
                    const buffer = $26e0f71442fe06b5$require$Buffer.alloc((0, $1biTx.NONCE_ACCOUNT_LENGTH));
                    const len = $26e0f71442fe06b5$var$NONCE_ACCOUNT_LAYOUT.encode(account, buffer);
                    return buffer.slice(0, len);
                }
            default:
                throw new Error(`Invalid account name: ${accountName}`);
        }
    }
    decode(accountName, ix) {
        return this.decodeUnchecked(accountName, ix);
    }
    decodeUnchecked(accountName, ix) {
        switch(accountName){
            case "nonce":
                return $26e0f71442fe06b5$var$decodeNonceAccount(ix);
            default:
                throw new Error(`Invalid account name: ${accountName}`);
        }
    }
    // TODO: this won't use the appendData.
    memcmp(accountName, _appendData) {
        switch(accountName){
            case "nonce":
                return {
                    dataSize: (0, $1biTx.NONCE_ACCOUNT_LENGTH)
                };
            default:
                throw new Error(`Invalid account name: ${accountName}`);
        }
    }
    size(idlAccount) {
        var _a;
        return (_a = $26e0f71442fe06b5$var$accountSize(this.idl, idlAccount)) !== null && _a !== void 0 ? _a : 0;
    }
}
function $26e0f71442fe06b5$var$decodeNonceAccount(ix) {
    return $26e0f71442fe06b5$var$NONCE_ACCOUNT_LAYOUT.decode(ix);
}
class $26e0f71442fe06b5$var$WrappedLayout$1 extends $26e0f71442fe06b5$var$Layout_2 {
    constructor(layout, decoder, encoder, property){
        super(layout.span, property);
        this.layout = layout;
        this.decoder = decoder;
        this.encoder = encoder;
    }
    decode(b, offset) {
        return this.decoder(this.layout.decode(b, offset));
    }
    encode(src, b, offset) {
        return this.layout.encode(this.encoder(src), b, offset);
    }
    getSpan(b, offset) {
        return this.layout.getSpan(b, offset);
    }
}
function $26e0f71442fe06b5$var$publicKey$1(property) {
    return new $26e0f71442fe06b5$var$WrappedLayout$1($26e0f71442fe06b5$var$blob(32), (b)=>new (0, $1biTx.PublicKey)(b), (key)=>key.toBuffer(), property);
}
const $26e0f71442fe06b5$var$NONCE_ACCOUNT_LAYOUT = $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$u32("version"),
    $26e0f71442fe06b5$var$u32("state"),
    $26e0f71442fe06b5$var$publicKey$1("authorizedPubkey"),
    $26e0f71442fe06b5$var$publicKey$1("nonce"),
    $26e0f71442fe06b5$var$struct([
        $26e0f71442fe06b5$var$nu64("lamportsPerSignature")
    ], "feeCalculator")
]);
class $26e0f71442fe06b5$var$SystemEventsCoder {
    constructor(_idl){}
    decode(_log) {
        throw new Error("System program does not have events");
    }
}
class $26e0f71442fe06b5$var$SystemTypesCoder {
    constructor(_idl){}
    encode(_name, _type) {
        throw new Error("System does not have user-defined types");
    }
    decode(_name, _typeData) {
        throw new Error("System does not have user-defined types");
    }
}
/**
 * Coder for the System program.
 */ class $26e0f71442fe06b5$export$b7cd50a9c9812c96 {
    constructor(idl){
        this.instruction = new $26e0f71442fe06b5$var$SystemInstructionCoder(idl);
        this.accounts = new $26e0f71442fe06b5$var$SystemAccountsCoder(idl);
        this.events = new $26e0f71442fe06b5$var$SystemEventsCoder(idl);
        this.types = new $26e0f71442fe06b5$var$SystemTypesCoder(idl);
    }
}
function $26e0f71442fe06b5$var$hash(data) {
    return new TextDecoder().decode((0, $9XCBn.sha256)(data));
}
var $26e0f71442fe06b5$var$sha256 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    hash: $26e0f71442fe06b5$var$hash
});
// Sync version of web3.PublicKey.createWithSeed.
function $26e0f71442fe06b5$var$createWithSeedSync(fromPublicKey, seed, programId) {
    const buffer = (0, $cbQCu.Buffer).concat([
        fromPublicKey.toBuffer(),
        (0, $cbQCu.Buffer).from(seed),
        programId.toBuffer()
    ]);
    return new (0, $1biTx.PublicKey)((0, $9XCBn.sha256)(buffer));
}
function $26e0f71442fe06b5$var$associated(programId, ...args) {
    let seeds = [
        (0, $cbQCu.Buffer).from([
            97,
            110,
            99,
            104,
            111,
            114
        ])
    ]; // b"anchor".
    args.forEach((arg)=>{
        seeds.push(arg instanceof (0, $cbQCu.Buffer) ? arg : $26e0f71442fe06b5$export$73f4f8860ca47074(arg).toBuffer());
    });
    const [assoc] = (0, $1biTx.PublicKey).findProgramAddressSync(seeds, $26e0f71442fe06b5$export$73f4f8860ca47074(programId));
    return assoc;
}
var $26e0f71442fe06b5$var$pubkey = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createWithSeedSync: $26e0f71442fe06b5$var$createWithSeedSync,
    associated: $26e0f71442fe06b5$var$associated
});
const $26e0f71442fe06b5$var$TOKEN_PROGRAM_ID = new (0, $1biTx.PublicKey)("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const $26e0f71442fe06b5$var$ASSOCIATED_PROGRAM_ID = new (0, $1biTx.PublicKey)("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
function $26e0f71442fe06b5$var$associatedAddress({ mint: mint, owner: owner }) {
    return (0, $1biTx.PublicKey).findProgramAddressSync([
        owner.toBuffer(),
        $26e0f71442fe06b5$var$TOKEN_PROGRAM_ID.toBuffer(),
        mint.toBuffer()
    ], $26e0f71442fe06b5$var$ASSOCIATED_PROGRAM_ID)[0];
}
var $26e0f71442fe06b5$var$token = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TOKEN_PROGRAM_ID: $26e0f71442fe06b5$var$TOKEN_PROGRAM_ID,
    ASSOCIATED_PROGRAM_ID: $26e0f71442fe06b5$var$ASSOCIATED_PROGRAM_ID,
    associatedAddress: $26e0f71442fe06b5$var$associatedAddress
});
var $26e0f71442fe06b5$var$browserPonyfill = {
    exports: {}
};
(function(module, exports) {
    var global1 = typeof self !== "undefined" ? self : $26e0f71442fe06b5$var$commonjsGlobal;
    var __self__ = function() {
        function F() {
            this.fetch = false;
            this.DOMException = global1.DOMException;
        }
        F.prototype = global1;
        return new F();
    }();
    (function(self1) {
        (function(exports) {
            var support = {
                searchParams: "URLSearchParams" in self1,
                iterable: "Symbol" in self1 && "iterator" in Symbol,
                blob: "FileReader" in self1 && "Blob" in self1 && function() {
                    try {
                        new Blob();
                        return true;
                    } catch (e) {
                        return false;
                    }
                }(),
                formData: "FormData" in self1,
                arrayBuffer: "ArrayBuffer" in self1
            };
            function isDataView(obj) {
                return obj && DataView.prototype.isPrototypeOf(obj);
            }
            if (support.arrayBuffer) {
                var viewClasses = [
                    "[object Int8Array]",
                    "[object Uint8Array]",
                    "[object Uint8ClampedArray]",
                    "[object Int16Array]",
                    "[object Uint16Array]",
                    "[object Int32Array]",
                    "[object Uint32Array]",
                    "[object Float32Array]",
                    "[object Float64Array]"
                ];
                var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                    return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
                };
            }
            function normalizeName(name) {
                if (typeof name !== "string") name = String(name);
                if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
                return name.toLowerCase();
            }
            function normalizeValue(value) {
                if (typeof value !== "string") value = String(value);
                return value;
            }
            // Build a destructive iterator for the value list
            function iteratorFor(items) {
                var iterator = {
                    next: function() {
                        var value = items.shift();
                        return {
                            done: value === undefined,
                            value: value
                        };
                    }
                };
                if (support.iterable) iterator[Symbol.iterator] = function() {
                    return iterator;
                };
                return iterator;
            }
            function Headers(headers) {
                this.map = {};
                if (headers instanceof Headers) headers.forEach(function(value, name) {
                    this.append(name, value);
                }, this);
                else if (Array.isArray(headers)) headers.forEach(function(header) {
                    this.append(header[0], header[1]);
                }, this);
                else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                    this.append(name, headers[name]);
                }, this);
            }
            Headers.prototype.append = function(name, value) {
                name = normalizeName(name);
                value = normalizeValue(value);
                var oldValue = this.map[name];
                this.map[name] = oldValue ? oldValue + ", " + value : value;
            };
            Headers.prototype["delete"] = function(name) {
                delete this.map[normalizeName(name)];
            };
            Headers.prototype.get = function(name) {
                name = normalizeName(name);
                return this.has(name) ? this.map[name] : null;
            };
            Headers.prototype.has = function(name) {
                return this.map.hasOwnProperty(normalizeName(name));
            };
            Headers.prototype.set = function(name, value) {
                this.map[normalizeName(name)] = normalizeValue(value);
            };
            Headers.prototype.forEach = function(callback, thisArg) {
                for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
            };
            Headers.prototype.keys = function() {
                var items = [];
                this.forEach(function(value, name) {
                    items.push(name);
                });
                return iteratorFor(items);
            };
            Headers.prototype.values = function() {
                var items = [];
                this.forEach(function(value) {
                    items.push(value);
                });
                return iteratorFor(items);
            };
            Headers.prototype.entries = function() {
                var items = [];
                this.forEach(function(value, name) {
                    items.push([
                        name,
                        value
                    ]);
                });
                return iteratorFor(items);
            };
            if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
            function consumed(body) {
                if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
                body.bodyUsed = true;
            }
            function fileReaderReady(reader) {
                return new Promise(function(resolve, reject) {
                    reader.onload = function() {
                        resolve(reader.result);
                    };
                    reader.onerror = function() {
                        reject(reader.error);
                    };
                });
            }
            function readBlobAsArrayBuffer(blob) {
                var reader = new FileReader();
                var promise = fileReaderReady(reader);
                reader.readAsArrayBuffer(blob);
                return promise;
            }
            function readBlobAsText(blob) {
                var reader = new FileReader();
                var promise = fileReaderReady(reader);
                reader.readAsText(blob);
                return promise;
            }
            function readArrayBufferAsText(buf) {
                var view = new Uint8Array(buf);
                var chars = new Array(view.length);
                for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
                return chars.join("");
            }
            function bufferClone(buf) {
                if (buf.slice) return buf.slice(0);
                else {
                    var view = new Uint8Array(buf.byteLength);
                    view.set(new Uint8Array(buf));
                    return view.buffer;
                }
            }
            function Body() {
                this.bodyUsed = false;
                this._initBody = function(body) {
                    this._bodyInit = body;
                    if (!body) this._bodyText = "";
                    else if (typeof body === "string") this._bodyText = body;
                    else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                    else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                    else if (support.arrayBuffer && support.blob && isDataView(body)) {
                        this._bodyArrayBuffer = bufferClone(body.buffer);
                        // IE 10-11 can't handle a DataView body.
                        this._bodyInit = new Blob([
                            this._bodyArrayBuffer
                        ]);
                    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                    else this._bodyText = body = Object.prototype.toString.call(body);
                    if (!this.headers.get("content-type")) {
                        if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                        else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                        else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                    }
                };
                if (support.blob) {
                    this.blob = function() {
                        var rejected = consumed(this);
                        if (rejected) return rejected;
                        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                            this._bodyArrayBuffer
                        ]));
                        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                        else return Promise.resolve(new Blob([
                            this._bodyText
                        ]));
                    };
                    this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                        else return this.blob().then(readBlobAsArrayBuffer);
                    };
                }
                this.text = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                    else return Promise.resolve(this._bodyText);
                };
                if (support.formData) this.formData = function() {
                    return this.text().then(decode);
                };
                this.json = function() {
                    return this.text().then(JSON.parse);
                };
                return this;
            }
            // HTTP methods whose capitalization should be normalized
            var methods = [
                "DELETE",
                "GET",
                "HEAD",
                "OPTIONS",
                "POST",
                "PUT"
            ];
            function normalizeMethod(method) {
                var upcased = method.toUpperCase();
                return methods.indexOf(upcased) > -1 ? upcased : method;
            }
            function Request(input, options) {
                options = options || {};
                var body = options.body;
                if (input instanceof Request) {
                    if (input.bodyUsed) throw new TypeError("Already read");
                    this.url = input.url;
                    this.credentials = input.credentials;
                    if (!options.headers) this.headers = new Headers(input.headers);
                    this.method = input.method;
                    this.mode = input.mode;
                    this.signal = input.signal;
                    if (!body && input._bodyInit != null) {
                        body = input._bodyInit;
                        input.bodyUsed = true;
                    }
                } else this.url = String(input);
                this.credentials = options.credentials || this.credentials || "same-origin";
                if (options.headers || !this.headers) this.headers = new Headers(options.headers);
                this.method = normalizeMethod(options.method || this.method || "GET");
                this.mode = options.mode || this.mode || null;
                this.signal = options.signal || this.signal;
                this.referrer = null;
                if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
                this._initBody(body);
            }
            Request.prototype.clone = function() {
                return new Request(this, {
                    body: this._bodyInit
                });
            };
            function decode(body) {
                var form = new FormData();
                body.trim().split("&").forEach(function(bytes) {
                    if (bytes) {
                        var split = bytes.split("=");
                        var name = split.shift().replace(/\+/g, " ");
                        var value = split.join("=").replace(/\+/g, " ");
                        form.append(decodeURIComponent(name), decodeURIComponent(value));
                    }
                });
                return form;
            }
            function parseHeaders(rawHeaders) {
                var headers = new Headers();
                // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
                // https://tools.ietf.org/html/rfc7230#section-3.2
                var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
                preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                    var parts = line.split(":");
                    var key = parts.shift().trim();
                    if (key) {
                        var value = parts.join(":").trim();
                        headers.append(key, value);
                    }
                });
                return headers;
            }
            Body.call(Request.prototype);
            function Response(bodyInit, options) {
                if (!options) options = {};
                this.type = "default";
                this.status = options.status === undefined ? 200 : options.status;
                this.ok = this.status >= 200 && this.status < 300;
                this.statusText = "statusText" in options ? options.statusText : "OK";
                this.headers = new Headers(options.headers);
                this.url = options.url || "";
                this._initBody(bodyInit);
            }
            Body.call(Response.prototype);
            Response.prototype.clone = function() {
                return new Response(this._bodyInit, {
                    status: this.status,
                    statusText: this.statusText,
                    headers: new Headers(this.headers),
                    url: this.url
                });
            };
            Response.error = function() {
                var response = new Response(null, {
                    status: 0,
                    statusText: ""
                });
                response.type = "error";
                return response;
            };
            var redirectStatuses = [
                301,
                302,
                303,
                307,
                308
            ];
            Response.redirect = function(url, status) {
                if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
                return new Response(null, {
                    status: status,
                    headers: {
                        location: url
                    }
                });
            };
            exports.DOMException = self1.DOMException;
            try {
                new exports.DOMException();
            } catch (err) {
                exports.DOMException = function(message, name) {
                    this.message = message;
                    this.name = name;
                    var error = Error(message);
                    this.stack = error.stack;
                };
                exports.DOMException.prototype = Object.create(Error.prototype);
                exports.DOMException.prototype.constructor = exports.DOMException;
            }
            function fetch(input, init) {
                return new Promise(function(resolve, reject) {
                    var request = new Request(input, init);
                    if (request.signal && request.signal.aborted) return reject(new exports.DOMException("Aborted", "AbortError"));
                    var xhr = new XMLHttpRequest();
                    function abortXhr() {
                        xhr.abort();
                    }
                    xhr.onload = function() {
                        var options = {
                            status: xhr.status,
                            statusText: xhr.statusText,
                            headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                        };
                        options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                        var body = "response" in xhr ? xhr.response : xhr.responseText;
                        resolve(new Response(body, options));
                    };
                    xhr.onerror = function() {
                        reject(new TypeError("Network request failed"));
                    };
                    xhr.ontimeout = function() {
                        reject(new TypeError("Network request failed"));
                    };
                    xhr.onabort = function() {
                        reject(new exports.DOMException("Aborted", "AbortError"));
                    };
                    xhr.open(request.method, request.url, true);
                    if (request.credentials === "include") xhr.withCredentials = true;
                    else if (request.credentials === "omit") xhr.withCredentials = false;
                    if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                    request.headers.forEach(function(value, name) {
                        xhr.setRequestHeader(name, value);
                    });
                    if (request.signal) {
                        request.signal.addEventListener("abort", abortXhr);
                        xhr.onreadystatechange = function() {
                            // DONE (success or failure)
                            if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                        };
                    }
                    xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
                });
            }
            fetch.polyfill = true;
            if (!self1.fetch) {
                self1.fetch = fetch;
                self1.Headers = Headers;
                self1.Request = Request;
                self1.Response = Response;
            }
            exports.Headers = Headers;
            exports.Request = Request;
            exports.Response = Response;
            exports.fetch = fetch;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            return exports;
        })({});
    })(__self__);
    __self__.fetch.ponyfill = true;
    // Remove "polyfill" property added by whatwg-fetch
    delete __self__.fetch.polyfill;
    // Choose between native implementation (global) or custom implementation (__self__)
    // var ctx = global.fetch ? global : __self__;
    var ctx = __self__; // this line disable service worker support temporarily
    exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
    exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
    exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
    exports.Headers = ctx.Headers;
    exports.Request = ctx.Request;
    exports.Response = ctx.Response;
    module.exports = exports;
})($26e0f71442fe06b5$var$browserPonyfill, $26e0f71442fe06b5$var$browserPonyfill.exports);
var $26e0f71442fe06b5$var$fetch = /*@__PURE__*/ $26e0f71442fe06b5$var$getDefaultExportFromCjs($26e0f71442fe06b5$var$browserPonyfill.exports);
/**
 * Returns a verified build from the anchor registry. null if no such
 * verified build exists, e.g., if the program has been upgraded since the
 * last verified build.
 */ async function $26e0f71442fe06b5$var$verifiedBuild(connection, programId, limit = 5) {
    const url = `https://api.apr.dev/api/v0/program/${programId.toString()}/latest?limit=${limit}`;
    const [programData, latestBuildsResp] = await Promise.all([
        $26e0f71442fe06b5$var$fetchData(connection, programId),
        $26e0f71442fe06b5$var$fetch(url)
    ]);
    // Filter out all non successful builds.
    const latestBuilds = (await latestBuildsResp.json()).filter((b)=>!b.aborted && b.state === "Built" && b.verified === "Verified");
    if (latestBuilds.length === 0) return null;
    // Get the latest build.
    const build = latestBuilds[0];
    // Has the program been upgraded since the last build?
    if (programData.slot.toNumber() !== build.verified_slot) return null;
    // Success.
    return build;
}
/**
 * Returns the program data account for this program, containing the
 * metadata for this program, e.g., the upgrade authority.
 */ async function $26e0f71442fe06b5$var$fetchData(connection, programId) {
    const accountInfo = await connection.getAccountInfo(programId);
    if (accountInfo === null) throw new Error("program account not found");
    const { program: program } = $26e0f71442fe06b5$var$decodeUpgradeableLoaderState(accountInfo.data);
    const programdataAccountInfo = await connection.getAccountInfo(program.programdataAddress);
    if (programdataAccountInfo === null) throw new Error("program data account not found");
    const { programData: programData } = $26e0f71442fe06b5$var$decodeUpgradeableLoaderState(programdataAccountInfo.data);
    return programData;
}
const $26e0f71442fe06b5$var$UPGRADEABLE_LOADER_STATE_LAYOUT = $8e63f10e9557e84e$exports.rustEnum([
    $8e63f10e9557e84e$exports.struct([], "uninitialized"),
    $8e63f10e9557e84e$exports.struct([
        $8e63f10e9557e84e$exports.option($8e63f10e9557e84e$exports.publicKey(), "authorityAddress")
    ], "buffer"),
    $8e63f10e9557e84e$exports.struct([
        $8e63f10e9557e84e$exports.publicKey("programdataAddress")
    ], "program"),
    $8e63f10e9557e84e$exports.struct([
        $8e63f10e9557e84e$exports.u64("slot"),
        $8e63f10e9557e84e$exports.option($8e63f10e9557e84e$exports.publicKey(), "upgradeAuthorityAddress")
    ], "programData")
], undefined, $8e63f10e9557e84e$exports.u32());
function $26e0f71442fe06b5$var$decodeUpgradeableLoaderState(data) {
    return $26e0f71442fe06b5$var$UPGRADEABLE_LOADER_STATE_LAYOUT.decode(data);
}
var $26e0f71442fe06b5$var$registry = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    verifiedBuild: $26e0f71442fe06b5$var$verifiedBuild,
    fetchData: $26e0f71442fe06b5$var$fetchData,
    decodeUpgradeableLoaderState: $26e0f71442fe06b5$var$decodeUpgradeableLoaderState
});
var $26e0f71442fe06b5$export$eab97d15b1788b8d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    sha256: $26e0f71442fe06b5$var$sha256,
    rpc: $26e0f71442fe06b5$var$rpc,
    publicKey: $26e0f71442fe06b5$var$pubkey,
    bytes: $26e0f71442fe06b5$var$index$1,
    token: $26e0f71442fe06b5$var$token,
    features: $26e0f71442fe06b5$var$features,
    registry: $26e0f71442fe06b5$var$registry
});
function $26e0f71442fe06b5$var$isIdlAccounts(accountItem) {
    return "accounts" in accountItem;
}
// Deterministic IDL address as a function of the program id.
async function $26e0f71442fe06b5$var$idlAddress(programId) {
    const base = (await (0, $1biTx.PublicKey).findProgramAddress([], programId))[0];
    return await (0, $1biTx.PublicKey).createWithSeed(base, $26e0f71442fe06b5$var$seed(), programId);
}
// Seed for generating the idlAddress.
function $26e0f71442fe06b5$var$seed() {
    return "anchor:idl";
}
const $26e0f71442fe06b5$var$IDL_ACCOUNT_LAYOUT = $8e63f10e9557e84e$exports.struct([
    $8e63f10e9557e84e$exports.publicKey("authority"),
    $8e63f10e9557e84e$exports.vecU8("data")
]);
function $26e0f71442fe06b5$var$decodeIdlAccount(data) {
    return $26e0f71442fe06b5$var$IDL_ACCOUNT_LAYOUT.decode(data);
}
function $26e0f71442fe06b5$export$f2a7d8fa6736b621(idlIx, args) {
    var _a, _b;
    let options = {};
    const inputLen = idlIx.args ? idlIx.args.length : 0;
    if (args.length > inputLen) {
        if (args.length !== inputLen + 1) throw new Error(`provided too many arguments ${args} to instruction ${idlIx === null || idlIx === void 0 ? void 0 : idlIx.name} expecting: ${(_b = (_a = idlIx.args) === null || _a === void 0 ? void 0 : _a.map((a)=>a.name)) !== null && _b !== void 0 ? _b : []}`);
        options = args.pop();
    }
    return [
        args,
        options
    ];
}
class $26e0f71442fe06b5$var$InstructionNamespaceFactory {
    static build(idlIx, encodeFn, programId) {
        if (idlIx.name === "_inner") throw new $26e0f71442fe06b5$export$f8b0f3df06e3d291("the _inner name is reserved");
        const ix = (...args)=>{
            const [ixArgs, ctx] = $26e0f71442fe06b5$export$f2a7d8fa6736b621(idlIx, [
                ...args
            ]);
            $26e0f71442fe06b5$export$5ae43aeb7897a660(idlIx.accounts, ctx.accounts);
            $26e0f71442fe06b5$var$validateInstruction(idlIx, ...args);
            const keys = ix.accounts(ctx.accounts);
            if (ctx.remainingAccounts !== undefined) keys.push(...ctx.remainingAccounts);
            if ($26e0f71442fe06b5$var$isSet("debug-logs")) console.log("Outgoing account metas:", keys);
            return new (0, $1biTx.TransactionInstruction)({
                keys: keys,
                programId: programId,
                data: encodeFn(idlIx.name, $26e0f71442fe06b5$export$eaa840300146a0df(idlIx, ...ixArgs))
            });
        };
        // Utility fn for ordering the accounts for this instruction.
        ix["accounts"] = (accs)=>{
            return $26e0f71442fe06b5$var$InstructionNamespaceFactory.accountsArray(accs, idlIx.accounts, programId, idlIx.name);
        };
        return ix;
    }
    static accountsArray(ctx, accounts, programId, ixName) {
        if (!ctx) return [];
        return accounts.map((acc)=>{
            // Nested accounts.
            const nestedAccounts = "accounts" in acc ? acc.accounts : undefined;
            if (nestedAccounts !== undefined) {
                const rpcAccs = ctx[acc.name];
                return $26e0f71442fe06b5$var$InstructionNamespaceFactory.accountsArray(rpcAccs, acc.accounts, programId, ixName).flat();
            } else {
                const account = acc;
                let pubkey;
                try {
                    pubkey = $26e0f71442fe06b5$export$73f4f8860ca47074(ctx[acc.name]);
                } catch (err) {
                    throw new Error(`Wrong input type for account "${acc.name}" in the instruction accounts object${ixName !== undefined ? ' for instruction "' + ixName + '"' : ""}. Expected PublicKey or string.`);
                }
                const optional = account.isOptional && pubkey.equals(programId);
                const isWritable = account.isMut && !optional;
                const isSigner = account.isSigner && !optional;
                return {
                    pubkey: pubkey,
                    isWritable: isWritable,
                    isSigner: isSigner
                };
            }
        }).flat();
    }
}
// Throws error if any argument required for the `ix` is not given.
function $26e0f71442fe06b5$var$validateInstruction(ix, ...args) {
// todo
}
class $26e0f71442fe06b5$var$TransactionFactory {
    static build(idlIx, ixFn) {
        const txFn = (...args)=>{
            var _a, _b, _c;
            const [, ctx] = $26e0f71442fe06b5$export$f2a7d8fa6736b621(idlIx, [
                ...args
            ]);
            const tx = new (0, $1biTx.Transaction)();
            if (ctx.preInstructions && ctx.instructions) throw new Error("instructions is deprecated, use preInstructions");
            (_a = ctx.preInstructions) === null || _a === void 0 || _a.forEach((ix)=>tx.add(ix));
            (_b = ctx.instructions) === null || _b === void 0 || _b.forEach((ix)=>tx.add(ix));
            tx.add(ixFn(...args));
            (_c = ctx.postInstructions) === null || _c === void 0 || _c.forEach((ix)=>tx.add(ix));
            return tx;
        };
        return txFn;
    }
}
class $26e0f71442fe06b5$var$RpcFactory {
    static build(idlIx, txFn, idlErrors, provider) {
        const rpc = async (...args)=>{
            var _a;
            const tx = txFn(...args);
            const [, ctx] = $26e0f71442fe06b5$export$f2a7d8fa6736b621(idlIx, [
                ...args
            ]);
            if (provider.sendAndConfirm === undefined) throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
            try {
                return await provider.sendAndConfirm(tx, (_a = ctx.signers) !== null && _a !== void 0 ? _a : [], ctx.options);
            } catch (err) {
                throw $26e0f71442fe06b5$export$dbb77d813a78f040(err, idlErrors);
            }
        };
        return rpc;
    }
}
class $26e0f71442fe06b5$var$AccountFactory {
    static build(idl, coder, programId, provider) {
        var _a;
        const accountFns = {};
        (_a = idl.accounts) === null || _a === void 0 || _a.forEach((idlAccount)=>{
            const name = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(idlAccount.name);
            accountFns[name] = new $26e0f71442fe06b5$export$c72a7a0bd97aabc8(idl, idlAccount, programId, provider, coder);
        });
        return accountFns;
    }
}
class $26e0f71442fe06b5$export$c72a7a0bd97aabc8 {
    /**
     * Returns the number of bytes in this account.
     */ get size() {
        return this._size;
    }
    /**
     * Returns the program ID owning all accounts.
     */ get programId() {
        return this._programId;
    }
    /**
     * Returns the client's wallet and network provider.
     */ get provider() {
        return this._provider;
    }
    /**
     * Returns the coder.
     */ get coder() {
        return this._coder;
    }
    /**
     * Returns the idl account.
     */ get idlAccount() {
        return this._idlAccount;
    }
    constructor(idl, idlAccount, programId, provider, coder){
        this._idlAccount = idlAccount;
        this._programId = programId;
        this._provider = provider !== null && provider !== void 0 ? provider : $26e0f71442fe06b5$export$57632def5536cb24();
        this._coder = coder !== null && coder !== void 0 ? coder : new $26e0f71442fe06b5$export$e59abd64f0cb1e2e(idl);
        this._size = this._coder.accounts.size(idlAccount);
    }
    /**
     * Returns a deserialized account, returning null if it doesn't exist.
     *
     * @param address The address of the account to fetch.
     */ async fetchNullable(address, commitment) {
        const { data: data } = await this.fetchNullableAndContext(address, commitment);
        return data;
    }
    /**
     * Returns a deserialized account along with the associated rpc response context, returning null if it doesn't exist.
     *
     * @param address The address of the account to fetch.
     */ async fetchNullableAndContext(address, commitment) {
        const accountInfo = await this.getAccountInfoAndContext(address, commitment);
        const { value: value, context: context } = accountInfo;
        return {
            data: value && value.data.length !== 0 ? this._coder.accounts.decode(this._idlAccount.name, value.data) : null,
            context: context
        };
    }
    /**
     * Returns a deserialized account.
     *
     * @param address The address of the account to fetch.
     */ async fetch(address, commitment) {
        const { data: data } = await this.fetchNullableAndContext(address, commitment);
        if (data === null) throw new Error(`Account does not exist or has no data ${address.toString()}`);
        return data;
    }
    /**
     * Returns a deserialized account along with the associated rpc response context.
     *
     * @param address The address of the account to fetch.
     */ async fetchAndContext(address, commitment) {
        const { data: data, context: context } = await this.fetchNullableAndContext(address, commitment);
        if (data === null) throw new Error(`Account does not exist ${address.toString()}`);
        return {
            data: data,
            context: context
        };
    }
    /**
     * Returns multiple deserialized accounts.
     * Accounts not found or with wrong discriminator are returned as null.
     *
     * @param addresses The addresses of the accounts to fetch.
     */ async fetchMultiple(addresses, commitment) {
        const accounts = await this.fetchMultipleAndContext(addresses, commitment);
        return accounts.map((account)=>account ? account.data : null);
    }
    /**
     * Returns multiple deserialized accounts.
     * Accounts not found or with wrong discriminator are returned as null.
     *
     * @param addresses The addresses of the accounts to fetch.
     */ async fetchMultipleAndContext(addresses, commitment) {
        const accounts = await $26e0f71442fe06b5$var$getMultipleAccountsAndContext(this._provider.connection, addresses.map((address)=>$26e0f71442fe06b5$export$73f4f8860ca47074(address)), commitment);
        // Decode accounts where discriminator is correct, null otherwise
        return accounts.map((result)=>{
            if (result == null) return null;
            const { account: account, context: context } = result;
            return {
                data: this._coder.accounts.decode(this._idlAccount.name, account.data),
                context: context
            };
        });
    }
    /**
     * Returns all instances of this account type for the program.
     *
     * @param filters User-provided filters to narrow the results from `connection.getProgramAccounts`.
     *
     *                When filters are not defined this method returns all
     *                the account instances.
     *
     *                When filters are of type `Buffer`, the filters are appended
     *                after the discriminator.
     *
     *                When filters are of type `GetProgramAccountsFilter[]`,
     *                filters are appended after the discriminator filter.
     */ async all(filters) {
        const filter = this.coder.accounts.memcmp(this._idlAccount.name, filters instanceof $26e0f71442fe06b5$require$Buffer ? filters : undefined);
        const coderFilters = [];
        if ((filter === null || filter === void 0 ? void 0 : filter.offset) != undefined && (filter === null || filter === void 0 ? void 0 : filter.bytes) != undefined) coderFilters.push({
            memcmp: {
                offset: filter.offset,
                bytes: filter.bytes
            }
        });
        if ((filter === null || filter === void 0 ? void 0 : filter.dataSize) != undefined) coderFilters.push({
            dataSize: filter.dataSize
        });
        let resp = await this._provider.connection.getProgramAccounts(this._programId, {
            commitment: this._provider.connection.commitment,
            filters: [
                ...coderFilters,
                ...Array.isArray(filters) ? filters : []
            ]
        });
        return resp.map(({ pubkey: pubkey, account: account })=>{
            return {
                publicKey: pubkey,
                account: this._coder.accounts.decode(this._idlAccount.name, account.data)
            };
        });
    }
    /**
     * Returns an `EventEmitter` emitting a "change" event whenever the account
     * changes.
     */ subscribe(address, commitment) {
        const sub = $26e0f71442fe06b5$var$subscriptions.get(address.toString());
        if (sub) return sub.ee;
        const ee = new (0, (/*@__PURE__*/$parcel$interopDefault($1PbQI)))();
        address = $26e0f71442fe06b5$export$73f4f8860ca47074(address);
        const listener = this._provider.connection.onAccountChange(address, (acc)=>{
            const account = this._coder.accounts.decode(this._idlAccount.name, acc.data);
            ee.emit("change", account);
        }, commitment);
        $26e0f71442fe06b5$var$subscriptions.set(address.toString(), {
            ee: ee,
            listener: listener
        });
        return ee;
    }
    /**
     * Unsubscribes from the account at the given address.
     */ async unsubscribe(address) {
        let sub = $26e0f71442fe06b5$var$subscriptions.get(address.toString());
        if (!sub) {
            console.warn("Address is not subscribed");
            return;
        }
        if ($26e0f71442fe06b5$var$subscriptions) await this._provider.connection.removeAccountChangeListener(sub.listener).then(()=>{
            $26e0f71442fe06b5$var$subscriptions.delete(address.toString());
        }).catch(console.error);
    }
    /**
     * Returns an instruction for creating this account.
     */ async createInstruction(signer, sizeOverride) {
        const size = this.size;
        if (this._provider.publicKey === undefined) throw new Error("This function requires the Provider interface implementor to have a 'publicKey' field.");
        return (0, $1biTx.SystemProgram).createAccount({
            fromPubkey: this._provider.publicKey,
            newAccountPubkey: signer.publicKey,
            space: sizeOverride !== null && sizeOverride !== void 0 ? sizeOverride : size,
            lamports: await this._provider.connection.getMinimumBalanceForRentExemption(sizeOverride !== null && sizeOverride !== void 0 ? sizeOverride : size),
            programId: this._programId
        });
    }
    /**
     * @deprecated since version 14.0.
     *
     * Function returning the associated account. Args are keys to associate.
     * Order matters.
     */ async associated(...args) {
        const addr = await this.associatedAddress(...args);
        return await this.fetch(addr);
    }
    /**
     * @deprecated since version 14.0.
     *
     * Function returning the associated address. Args are keys to associate.
     * Order matters.
     */ async associatedAddress(...args) {
        return await $26e0f71442fe06b5$var$associated(this._programId, ...args);
    }
    async getAccountInfo(address, commitment) {
        return await this._provider.connection.getAccountInfo($26e0f71442fe06b5$export$73f4f8860ca47074(address), commitment);
    }
    async getAccountInfoAndContext(address, commitment) {
        return await this._provider.connection.getAccountInfoAndContext($26e0f71442fe06b5$export$73f4f8860ca47074(address), commitment);
    }
}
// Tracks all subscriptions.
const $26e0f71442fe06b5$var$subscriptions = new Map();
const $26e0f71442fe06b5$var$PROGRAM_LOG = "Program log: ";
const $26e0f71442fe06b5$var$PROGRAM_DATA = "Program data: ";
const $26e0f71442fe06b5$var$PROGRAM_LOG_START_INDEX = $26e0f71442fe06b5$var$PROGRAM_LOG.length;
const $26e0f71442fe06b5$var$PROGRAM_DATA_START_INDEX = $26e0f71442fe06b5$var$PROGRAM_DATA.length;
class $26e0f71442fe06b5$export$cc74486daaaef499 {
    constructor(programId, provider, coder){
        this._programId = programId;
        this._provider = provider;
        this._eventParser = new $26e0f71442fe06b5$export$c11c1068d8c6037e(programId, coder);
        this._eventCallbacks = new Map();
        this._eventListeners = new Map();
        this._listenerIdCount = 0;
    }
    addEventListener(eventName, callback) {
        var _a;
        let listener = this._listenerIdCount;
        this._listenerIdCount += 1;
        // Store the listener into the event map.
        if (!this._eventListeners.has(eventName)) this._eventListeners.set(eventName, []);
        this._eventListeners.set(eventName, ((_a = this._eventListeners.get(eventName)) !== null && _a !== void 0 ? _a : []).concat(listener));
        // Store the callback into the listener map.
        this._eventCallbacks.set(listener, [
            eventName,
            callback
        ]);
        // Create the subscription singleton, if needed.
        if (this._onLogsSubscriptionId !== undefined) return listener;
        this._onLogsSubscriptionId = this._provider.connection.onLogs(this._programId, (logs, ctx)=>{
            if (logs.err) return;
            for (const event of this._eventParser.parseLogs(logs.logs)){
                const allListeners = this._eventListeners.get(event.name);
                if (allListeners) allListeners.forEach((listener)=>{
                    const listenerCb = this._eventCallbacks.get(listener);
                    if (listenerCb) {
                        const [, callback] = listenerCb;
                        callback(event.data, ctx.slot, logs.signature);
                    }
                });
            }
        });
        return listener;
    }
    async removeEventListener(listener) {
        // Get the callback.
        const callback = this._eventCallbacks.get(listener);
        if (!callback) throw new Error(`Event listener ${listener} doesn't exist!`);
        const [eventName] = callback;
        // Get the listeners.
        let listeners = this._eventListeners.get(eventName);
        if (!listeners) throw new Error(`Event listeners don't exist for ${eventName}!`);
        // Update both maps.
        this._eventCallbacks.delete(listener);
        listeners = listeners.filter((l)=>l !== listener);
        this._eventListeners.set(eventName, listeners);
        if (listeners.length === 0) this._eventListeners.delete(eventName);
        // Kill the websocket connection if all listeners have been removed.
        if (this._eventCallbacks.size === 0) {
            if (this._eventListeners.size !== 0) throw new Error(`Expected event listeners size to be 0 but got ${this._eventListeners.size}`);
            if (this._onLogsSubscriptionId !== undefined) {
                await this._provider.connection.removeOnLogsListener(this._onLogsSubscriptionId);
                this._onLogsSubscriptionId = undefined;
            }
        }
    }
}
class $26e0f71442fe06b5$export$c11c1068d8c6037e {
    constructor(programId, coder){
        this.coder = coder;
        this.programId = programId;
    }
    // Each log given, represents an array of messages emitted by
    // a single transaction, which can execute many different programs across
    // CPI boundaries. However, the subscription is only interested in the
    // events emitted by *this* program. In achieving this, we keep track of the
    // program execution context by parsing each log and looking for a CPI
    // `invoke` call. If one exists, we know a new program is executing. So we
    // push the programId onto a stack and switch the program context. This
    // allows us to track, for a given log, which program was executing during
    // its emission, thereby allowing us to know if a given log event was
    // emitted by *this* program. If it was, then we parse the raw string and
    // emit the event if the string matches the event being subscribed to.
    *parseLogs(logs, errorOnDecodeFailure = false) {
        const logScanner = new $26e0f71442fe06b5$var$LogScanner(logs);
        const execution = new $26e0f71442fe06b5$var$ExecutionContext();
        let log = logScanner.next();
        while(log !== null){
            let [event, newProgram, didPop] = this.handleLog(execution, log, errorOnDecodeFailure);
            if (event) yield event;
            if (newProgram) execution.push(newProgram);
            if (didPop) execution.pop();
            log = logScanner.next();
        }
    }
    // Main log handler. Returns a three element array of the event, the
    // next program that was invoked for CPI, and a boolean indicating if
    // a program has completed execution (and thus should be popped off the
    // execution stack).
    handleLog(execution, log, errorOnDecodeFailure) {
        // Executing program is this program.
        if (execution.stack.length > 0 && execution.program() === this.programId.toString()) return this.handleProgramLog(log, errorOnDecodeFailure);
        else return [
            null,
            ...this.handleSystemLog(log)
        ];
    }
    // Handles logs from *this* program.
    handleProgramLog(log, errorOnDecodeFailure) {
        // This is a `msg!` log or a `sol_log_data` log.
        if (log.startsWith($26e0f71442fe06b5$var$PROGRAM_LOG) || log.startsWith($26e0f71442fe06b5$var$PROGRAM_DATA)) {
            const logStr = log.startsWith($26e0f71442fe06b5$var$PROGRAM_LOG) ? log.slice($26e0f71442fe06b5$var$PROGRAM_LOG_START_INDEX) : log.slice($26e0f71442fe06b5$var$PROGRAM_DATA_START_INDEX);
            const event = this.coder.events.decode(logStr);
            if (errorOnDecodeFailure && event === null) throw new Error(`Unable to decode event ${logStr}`);
            return [
                event,
                null,
                false
            ];
        } else return [
            null,
            ...this.handleSystemLog(log)
        ];
    }
    // Handles logs when the current program being executing is *not* this.
    handleSystemLog(log) {
        // System component.
        const logStart = log.split(":")[0];
        // Did the program finish executing?
        if (logStart.match(/^Program (.*) success/g) !== null) return [
            null,
            true
        ];
        else if (logStart.startsWith(`Program ${this.programId.toString()} invoke`)) return [
            this.programId.toString(),
            false
        ];
        else if (logStart.includes("invoke")) return [
            "cpi",
            false
        ]; // Any string will do.
        else return [
            null,
            false
        ];
    }
}
// Stack frame execution context, allowing one to track what program is
// executing for a given log.
class $26e0f71442fe06b5$var$ExecutionContext {
    constructor(){
        this.stack = [];
    }
    program() {
        if (!this.stack.length) throw new Error("Expected the stack to have elements");
        return this.stack[this.stack.length - 1];
    }
    push(newProgram) {
        this.stack.push(newProgram);
    }
    pop() {
        if (!this.stack.length) throw new Error("Expected the stack to have elements");
        this.stack.pop();
    }
}
class $26e0f71442fe06b5$var$LogScanner {
    constructor(logs){
        this.logs = logs;
    }
    next() {
        if (this.logs.length === 0) return null;
        let l = this.logs[0];
        this.logs = this.logs.slice(1);
        return l;
    }
}
class $26e0f71442fe06b5$var$SimulateFactory {
    static build(idlIx, txFn, idlErrors, provider, coder, programId, idl) {
        const simulate = async (...args)=>{
            var _a;
            const tx = txFn(...args);
            const [, ctx] = $26e0f71442fe06b5$export$f2a7d8fa6736b621(idlIx, [
                ...args
            ]);
            let resp = undefined;
            if (provider.simulate === undefined) throw new Error("This function requires 'Provider.simulate' to be implemented.");
            try {
                resp = await provider.simulate(tx, ctx.signers, (_a = ctx.options) === null || _a === void 0 ? void 0 : _a.commitment);
            } catch (err) {
                throw $26e0f71442fe06b5$export$dbb77d813a78f040(err, idlErrors);
            }
            if (resp === undefined) throw new Error("Unable to simulate transaction");
            const logs = resp.logs;
            if (!logs) throw new Error("Simulated logs not found");
            const events = [];
            if (idl.events) {
                let parser = new $26e0f71442fe06b5$export$c11c1068d8c6037e(programId, coder);
                for (const event of parser.parseLogs(logs))events.push(event);
            }
            return {
                events: events,
                raw: logs
            };
        };
        return simulate;
    }
}
function $26e0f71442fe06b5$var$uint64(property) {
    return new $26e0f71442fe06b5$var$WrappedLayout($26e0f71442fe06b5$var$blob(8), (b)=>$26e0f71442fe06b5$var$u64.fromBuffer(b), (n)=>n.toBuffer(), property);
}
function $26e0f71442fe06b5$var$publicKey(property) {
    return new $26e0f71442fe06b5$var$WrappedLayout($26e0f71442fe06b5$var$blob(32), (b)=>new (0, $1biTx.PublicKey)(b), (key)=>key.toBuffer(), property);
}
function $26e0f71442fe06b5$var$coption(layout, property) {
    return new $26e0f71442fe06b5$var$COptionLayout(layout, property);
}
class $26e0f71442fe06b5$var$WrappedLayout extends $26e0f71442fe06b5$var$Layout_2 {
    constructor(layout, decoder, encoder, property){
        super(layout.span, property);
        this.layout = layout;
        this.decoder = decoder;
        this.encoder = encoder;
    }
    decode(b, offset) {
        return this.decoder(this.layout.decode(b, offset));
    }
    encode(src, b, offset) {
        return this.layout.encode(this.encoder(src), b, offset);
    }
    getSpan(b, offset) {
        return this.layout.getSpan(b, offset);
    }
}
class $26e0f71442fe06b5$var$COptionLayout extends $26e0f71442fe06b5$var$Layout_2 {
    constructor(layout, property){
        super(-1, property);
        this.layout = layout;
        this.discriminator = $26e0f71442fe06b5$var$u32();
    }
    encode(src, b, offset = 0) {
        if (src === null || src === undefined) return this.layout.span + this.discriminator.encode(0, b, offset);
        this.discriminator.encode(1, b, offset);
        return this.layout.encode(src, b, offset + 4) + 4;
    }
    decode(b, offset = 0) {
        const discriminator = this.discriminator.decode(b, offset);
        if (discriminator === 0) return null;
        else if (discriminator === 1) return this.layout.decode(b, offset + 4);
        throw new Error("Invalid coption " + this.layout.property);
    }
    getSpan(b, offset = 0) {
        return this.layout.getSpan(b, offset + 4) + 4;
    }
}
class $26e0f71442fe06b5$var$u64 extends (0, (/*@__PURE__*/$parcel$interopDefault($cj5EG))) {
    /**
     * Convert to Buffer representation
     */ toBuffer() {
        const a = super.toArray().reverse();
        const b = $26e0f71442fe06b5$require$Buffer.from(a);
        if (b.length === 8) return b;
        if (b.length >= 8) throw new Error("u64 too large");
        const zeroPad = $26e0f71442fe06b5$require$Buffer.alloc(8);
        b.copy(zeroPad);
        return zeroPad;
    }
    /**
     * Construct a u64 from Buffer representation
     */ static fromBuffer(buffer) {
        if (buffer.length !== 8) throw new Error(`Invalid buffer length: ${buffer.length}`);
        return new $26e0f71442fe06b5$var$u64([
            ...buffer
        ].reverse().map((i)=>`00${i.toString(16)}`.slice(-2)).join(""), 16);
    }
}
const $26e0f71442fe06b5$var$TOKEN_ACCOUNT_LAYOUT = $26e0f71442fe06b5$var$struct([
    $26e0f71442fe06b5$var$publicKey("mint"),
    $26e0f71442fe06b5$var$publicKey("owner"),
    $26e0f71442fe06b5$var$uint64("amount"),
    $26e0f71442fe06b5$var$coption($26e0f71442fe06b5$var$publicKey(), "delegate"),
    ((p)=>{
        const U = $26e0f71442fe06b5$var$union($26e0f71442fe06b5$var$u8("discriminator"), null, p);
        U.addVariant(0, $26e0f71442fe06b5$var$struct([]), "uninitialized");
        U.addVariant(1, $26e0f71442fe06b5$var$struct([]), "initialized");
        U.addVariant(2, $26e0f71442fe06b5$var$struct([]), "frozen");
        return U;
    })("state"),
    $26e0f71442fe06b5$var$coption($26e0f71442fe06b5$var$uint64(), "isNative"),
    $26e0f71442fe06b5$var$uint64("delegatedAmount"),
    $26e0f71442fe06b5$var$coption($26e0f71442fe06b5$var$publicKey(), "closeAuthority")
]);
function $26e0f71442fe06b5$var$decodeTokenAccount(b) {
    return $26e0f71442fe06b5$var$TOKEN_ACCOUNT_LAYOUT.decode(b);
}
// Populates a given accounts context with PDAs and common missing accounts.
class $26e0f71442fe06b5$var$AccountsResolver {
    constructor(_args, _accounts, _provider, _programId, _idlIx, _accountNamespace, _idlTypes, _customResolver){
        this._accounts = _accounts;
        this._provider = _provider;
        this._programId = _programId;
        this._idlIx = _idlIx;
        this._idlTypes = _idlTypes;
        this._customResolver = _customResolver;
        this._args = _args;
        this._accountStore = new $26e0f71442fe06b5$var$AccountStore(_provider, _accountNamespace, this._programId);
    }
    args(_args) {
        this._args = _args;
    }
    // Note: We serially resolve PDAs one by one rather than doing them
    //       in parallel because there can be dependencies between
    //       addresses. That is, one PDA can be used as a seed in another.
    async resolve() {
        await this.resolveConst(this._idlIx.accounts);
        this._resolveEventCpi(this._idlIx.accounts);
        // Auto populate pdas and relations until we stop finding new accounts
        while(await this.resolvePdas(this._idlIx.accounts) + await this.resolveRelations(this._idlIx.accounts) + await this.resolveCustom() > 0);
    }
    async resolveCustom() {
        if (this._customResolver) {
            const { accounts: accounts, resolved: resolved } = await this._customResolver({
                args: this._args,
                accounts: this._accounts,
                provider: this._provider,
                programId: this._programId,
                idlIx: this._idlIx
            });
            this._accounts = accounts;
            return resolved;
        }
        return 0;
    }
    resolveOptionalsHelper(partialAccounts, accountItems) {
        const nestedAccountsGeneric = {};
        // Looping through accountItem array instead of on partialAccounts, so
        // we only traverse array once
        for (const accountItem of accountItems){
            const accountName = accountItem.name;
            const partialAccount = partialAccounts[accountName];
            // Skip if the account isn't included (thus would be undefined)
            if (partialAccount === undefined) continue;
            if ($26e0f71442fe06b5$var$isPartialAccounts(partialAccount)) {
                // is compound accounts, recurse one level deeper
                if ($26e0f71442fe06b5$var$isIdlAccounts(accountItem)) nestedAccountsGeneric[accountName] = this.resolveOptionalsHelper(partialAccount, accountItem["accounts"]);
                else // Here we try our best to recover gracefully. If there are optionals we can't check, we will fail then.
                nestedAccountsGeneric[accountName] = $26e0f71442fe06b5$var$flattenPartialAccounts(partialAccount, true);
            } else {
                // if not compound accounts, do null/optional check and proceed
                if (partialAccount !== null) nestedAccountsGeneric[accountName] = $26e0f71442fe06b5$export$73f4f8860ca47074(partialAccount);
                else if (accountItem["isOptional"]) nestedAccountsGeneric[accountName] = this._programId;
            }
        }
        return nestedAccountsGeneric;
    }
    resolveOptionals(accounts) {
        Object.assign(this._accounts, this.resolveOptionalsHelper(accounts, this._idlIx.accounts));
    }
    get(path) {
        // Only return if pubkey
        const ret = path.reduce((acc, subPath)=>acc && acc[subPath], this._accounts);
        if (ret && ret.toBase58) return ret;
    }
    set(path, value) {
        let curr = this._accounts;
        path.forEach((p, idx)=>{
            const isLast = idx == path.length - 1;
            if (isLast) curr[p] = value;
            curr[p] = curr[p] || {};
            curr = curr[p];
        });
    }
    async resolveConst(accounts, path = []) {
        for(let k = 0; k < accounts.length; k += 1){
            const accountDescOrAccounts = accounts[k];
            const subAccounts = accountDescOrAccounts.accounts;
            if (subAccounts) await this.resolveConst(subAccounts, [
                ...path,
                (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDescOrAccounts.name)
            ]);
            const accountDesc = accountDescOrAccounts;
            const accountDescName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDescOrAccounts.name);
            // Signers default to the provider.
            if (accountDesc.isSigner && !this.get([
                ...path,
                accountDescName
            ])) {
                // @ts-expect-error
                if (this._provider.wallet === undefined) throw new Error("This function requires the Provider interface implementor to have a 'wallet' field.");
                // @ts-expect-error
                this.set([
                    ...path,
                    accountDescName
                ], this._provider.wallet.publicKey);
            }
            // Common accounts are auto populated with magic names by convention.
            if (Reflect.has($26e0f71442fe06b5$var$AccountsResolver.CONST_ACCOUNTS, accountDescName) && !this.get([
                ...path,
                accountDescName
            ])) this.set([
                ...path,
                accountDescName
            ], $26e0f71442fe06b5$var$AccountsResolver.CONST_ACCOUNTS[accountDescName]);
        }
    }
    /**
     * Resolve event CPI accounts `eventAuthority` and `program`.
     *
     * Accounts will only be resolved if they are declared next to each other to
     * reduce the chance of name collision.
     */ _resolveEventCpi(accounts, path = []) {
        for(const i in accounts){
            const accountDescOrAccounts = accounts[i];
            const subAccounts = accountDescOrAccounts.accounts;
            if (subAccounts) this._resolveEventCpi(subAccounts, [
                ...path,
                (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDescOrAccounts.name)
            ]);
            // Validate next index exists
            const nextIndex = +i + 1;
            if (nextIndex === accounts.length) return;
            const currentName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accounts[i].name);
            const nextName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accounts[nextIndex].name);
            // Populate event CPI accounts if they exist
            if (currentName === "eventAuthority" && nextName === "program") {
                const currentPath = [
                    ...path,
                    currentName
                ];
                const nextPath = [
                    ...path,
                    nextName
                ];
                if (!this.get(currentPath)) this.set(currentPath, (0, $1biTx.PublicKey).findProgramAddressSync([
                    $26e0f71442fe06b5$require$Buffer.from("__event_authority")
                ], this._programId)[0]);
                if (!this.get(nextPath)) this.set(nextPath, this._programId);
                return;
            }
        }
    }
    async resolvePdas(accounts, path = []) {
        let found = 0;
        for(let k = 0; k < accounts.length; k += 1){
            const accountDesc = accounts[k];
            const subAccounts = accountDesc.accounts;
            if (subAccounts) found += await this.resolvePdas(subAccounts, [
                ...path,
                (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDesc.name)
            ]);
            const accountDescCasted = accountDesc;
            const accountDescName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDesc.name);
            // PDA derived from IDL seeds.
            if (accountDescCasted.pda && accountDescCasted.pda.seeds.length > 0 && !this.get([
                ...path,
                accountDescName
            ])) {
                if (Boolean(await this.autoPopulatePda(accountDescCasted, path))) found += 1;
            }
        }
        return found;
    }
    async resolveRelations(accounts, path = []) {
        let found = 0;
        for(let k = 0; k < accounts.length; k += 1){
            const accountDesc = accounts[k];
            const subAccounts = accountDesc.accounts;
            if (subAccounts) found += await this.resolveRelations(subAccounts, [
                ...path,
                (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDesc.name)
            ]);
            const relations = accountDesc.relations || [];
            const accountDescName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDesc.name);
            const newPath = [
                ...path,
                accountDescName
            ];
            // If we have this account and there's some missing accounts that are relations to this account, fetch them
            const accountKey = this.get(newPath);
            if (accountKey) {
                const matching = relations.filter((rel)=>!this.get([
                        ...path,
                        (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(rel)
                    ]));
                found += matching.length;
                if (matching.length > 0) {
                    const account = await this._accountStore.fetchAccount({
                        publicKey: accountKey
                    });
                    await Promise.all(matching.map(async (rel)=>{
                        const relName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(rel);
                        this.set([
                            ...path,
                            relName
                        ], account[relName]);
                        return account[relName];
                    }));
                }
            }
        }
        return found;
    }
    async autoPopulatePda(accountDesc, path = []) {
        if (!accountDesc.pda || !accountDesc.pda.seeds) throw new Error("Must have seeds");
        const seeds = await Promise.all(accountDesc.pda.seeds.map((seedDesc)=>this.toBuffer(seedDesc, path)));
        if (seeds.some((seed)=>typeof seed == "undefined")) return;
        const programId = await this.parseProgramId(accountDesc, path);
        if (!programId) return;
        const [pubkey] = await (0, $1biTx.PublicKey).findProgramAddress(seeds, programId);
        this.set([
            ...path,
            (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(accountDesc.name)
        ], pubkey);
    }
    async parseProgramId(accountDesc, path = []) {
        var _a;
        if (!((_a = accountDesc.pda) === null || _a === void 0 ? void 0 : _a.programId)) return this._programId;
        switch(accountDesc.pda.programId.kind){
            case "const":
                return new (0, $1biTx.PublicKey)(this.toBufferConst(accountDesc.pda.programId.value));
            case "arg":
                return this.argValue(accountDesc.pda.programId);
            case "account":
                return await this.accountValue(accountDesc.pda.programId, path);
            default:
                throw new Error(`Unexpected program seed kind: ${accountDesc.pda.programId.kind}`);
        }
    }
    async toBuffer(seedDesc, path = []) {
        switch(seedDesc.kind){
            case "const":
                return this.toBufferConst(seedDesc);
            case "arg":
                return await this.toBufferArg(seedDesc);
            case "account":
                return await this.toBufferAccount(seedDesc, path);
            default:
                throw new Error(`Unexpected seed kind: ${seedDesc.kind}`);
        }
    }
    /**
     * Recursively get the type at some path of either a primitive or a user defined struct.
     */ getType(type, path = []) {
        if (path.length > 0 && type.defined) {
            const subType = this._idlTypes.find((t)=>t.name === type.defined);
            if (!subType) throw new Error(`Cannot find type ${type.defined}`);
            const structType = subType.type; // enum not supported yet
            const field = structType.fields.find((field)=>field.name === path[0]);
            return this.getType(field.type, path.slice(1));
        }
        return type;
    }
    toBufferConst(seedDesc) {
        return this.toBufferValue(this.getType(seedDesc.type, (seedDesc.path || "").split(".").slice(1)), seedDesc.value);
    }
    async toBufferArg(seedDesc) {
        const argValue = this.argValue(seedDesc);
        if (typeof argValue === "undefined") return;
        return this.toBufferValue(this.getType(seedDesc.type, (seedDesc.path || "").split(".").slice(1)), argValue);
    }
    argValue(seedDesc) {
        const split = seedDesc.path.split(".");
        const seedArgName = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(split[0]);
        const idlArgPosition = this._idlIx.args.findIndex((argDesc)=>argDesc.name === seedArgName);
        if (idlArgPosition === -1) throw new Error(`Unable to find argument for seed: ${seedArgName}`);
        return split.slice(1).reduce((curr, path)=>(curr || {})[path], this._args[idlArgPosition]);
    }
    async toBufferAccount(seedDesc, path = []) {
        const accountValue = await this.accountValue(seedDesc, path);
        if (!accountValue) return;
        return this.toBufferValue(seedDesc.type, accountValue);
    }
    async accountValue(seedDesc, path = []) {
        const pathComponents = seedDesc.path.split(".");
        const fieldName = pathComponents[0];
        const fieldPubkey = this.get([
            ...path,
            (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(fieldName)
        ]);
        if (fieldPubkey === null) throw new Error(`fieldPubkey is null`);
        // The seed is a pubkey of the account.
        if (pathComponents.length === 1) return fieldPubkey;
        // The key is account data.
        //
        // Fetch and deserialize it.
        const account = await this._accountStore.fetchAccount({
            publicKey: fieldPubkey,
            name: seedDesc.account
        });
        // Dereference all fields in the path to get the field value
        // used in the seed.
        const fieldValue = this.parseAccountValue(account, pathComponents.slice(1));
        return fieldValue;
    }
    parseAccountValue(account, path) {
        let accountField;
        while(path.length > 0){
            accountField = account[(0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(path[0])];
            path = path.slice(1);
        }
        return accountField;
    }
    // Converts the given idl valaue into a Buffer. The values here must be
    // primitives. E.g. no structs.
    //
    // TODO: add more types here as needed.
    toBufferValue(type, value) {
        switch(type){
            case "u8":
                return $26e0f71442fe06b5$require$Buffer.from([
                    value
                ]);
            case "u16":
                let b = $26e0f71442fe06b5$require$Buffer.alloc(2);
                b.writeUInt16LE(value);
                return b;
            case "u32":
                let buf = $26e0f71442fe06b5$require$Buffer.alloc(4);
                buf.writeUInt32LE(value);
                return buf;
            case "u64":
                let bU64 = $26e0f71442fe06b5$require$Buffer.alloc(8);
                bU64.writeBigUInt64LE(BigInt(value));
                return bU64;
            case "string":
                return $26e0f71442fe06b5$require$Buffer.from($26e0f71442fe06b5$var$encode$2(value));
            case "publicKey":
                return value.toBuffer();
            default:
                if (type.array) return $26e0f71442fe06b5$require$Buffer.from(value);
                throw new Error(`Unexpected seed type: ${type}`);
        }
    }
}
$26e0f71442fe06b5$var$AccountsResolver.CONST_ACCOUNTS = {
    associatedTokenProgram: $26e0f71442fe06b5$var$ASSOCIATED_PROGRAM_ID,
    rent: (0, $1biTx.SYSVAR_RENT_PUBKEY),
    systemProgram: (0, $1biTx.SystemProgram).programId,
    tokenProgram: $26e0f71442fe06b5$var$TOKEN_PROGRAM_ID,
    clock: (0, $1biTx.SYSVAR_CLOCK_PUBKEY)
};
// TODO: this should be configureable to avoid unnecessary requests.
class $26e0f71442fe06b5$var$AccountStore {
    // todo: don't use the progrma use the account namespace.
    constructor(_provider, _accounts, _programId){
        this._provider = _provider;
        this._programId = _programId;
        this._cache = new Map();
        this._idls = {};
        this._idls[_programId.toBase58()] = _accounts;
    }
    async ensureIdl(programId) {
        if (!this._idls[programId.toBase58()]) {
            const idl = await $26e0f71442fe06b5$export$b6c59b989905b650.fetchIdl(programId, this._provider);
            if (idl) {
                const program = new $26e0f71442fe06b5$export$b6c59b989905b650(idl, programId, this._provider);
                this._idls[programId.toBase58()] = program.account;
            }
        }
        return this._idls[programId.toBase58()];
    }
    async fetchAccount({ publicKey: publicKey, name: name, programId: programId = this._programId }) {
        const address = publicKey.toString();
        if (!this._cache.has(address)) {
            if (name === "TokenAccount") {
                const accountInfo = await this._provider.connection.getAccountInfo(publicKey);
                if (accountInfo === null) throw new Error(`invalid account info for ${address}`);
                const data = $26e0f71442fe06b5$var$decodeTokenAccount(accountInfo.data);
                this._cache.set(address, data);
            } else if (name) {
                const accounts = await this.ensureIdl(programId);
                if (accounts) {
                    const accountFetcher = accounts[(0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(name)];
                    if (accountFetcher) {
                        const account = await accountFetcher.fetch(publicKey);
                        this._cache.set(address, account);
                    }
                }
            } else {
                const account = await this._provider.connection.getAccountInfo(publicKey);
                if (account === null) throw new Error(`invalid account info for ${address}`);
                const data = account.data;
                const accounts = await this.ensureIdl(account.owner);
                if (accounts) {
                    const firstAccountLayout = Object.values(accounts)[0];
                    if (!firstAccountLayout) throw new Error("No accounts for this program");
                    const result = firstAccountLayout.coder.accounts.decodeAny(data);
                    this._cache.set(address, result);
                }
            }
        }
        return this._cache.get(address);
    }
}
class $26e0f71442fe06b5$export$e47d8a80016e5cd1 {
    static build(provider, programId, idlIx, ixFn, txFn, rpcFn, simulateFn, viewFn, accountNamespace, idlTypes, customResolver) {
        return (...args)=>new $26e0f71442fe06b5$var$MethodsBuilder(args, ixFn, txFn, rpcFn, simulateFn, viewFn, provider, programId, idlIx, accountNamespace, idlTypes, customResolver);
    }
}
function $26e0f71442fe06b5$var$isPartialAccounts(partialAccount) {
    return typeof partialAccount === "object" && partialAccount !== null && !("_bn" in partialAccount // Ensures not a pubkey
    );
}
function $26e0f71442fe06b5$var$flattenPartialAccounts(partialAccounts, throwOnNull) {
    const toReturn = {};
    for(const accountName in partialAccounts){
        const account = partialAccounts[accountName];
        if (account === null) {
            if (throwOnNull) throw new Error("Failed to resolve optionals due to IDL type mismatch with input accounts!");
            continue;
        }
        toReturn[accountName] = $26e0f71442fe06b5$var$isPartialAccounts(account) ? $26e0f71442fe06b5$var$flattenPartialAccounts(account, true) : $26e0f71442fe06b5$export$73f4f8860ca47074(account);
    }
    return toReturn;
}
class $26e0f71442fe06b5$var$MethodsBuilder {
    constructor(_args, _ixFn, _txFn, _rpcFn, _simulateFn, _viewFn, _provider, _programId, _idlIx, _accountNamespace, _idlTypes, _customResolver){
        this._ixFn = _ixFn;
        this._txFn = _txFn;
        this._rpcFn = _rpcFn;
        this._simulateFn = _simulateFn;
        this._viewFn = _viewFn;
        this._programId = _programId;
        this._accounts = {};
        this._remainingAccounts = [];
        this._signers = [];
        this._preInstructions = [];
        this._postInstructions = [];
        this._autoResolveAccounts = true;
        this._args = _args;
        this._accountsResolver = new $26e0f71442fe06b5$var$AccountsResolver(_args, this._accounts, _provider, _programId, _idlIx, _accountNamespace, _idlTypes, _customResolver);
    }
    args(_args) {
        this._args = _args;
        this._accountsResolver.args(_args);
    }
    async pubkeys() {
        if (this._autoResolveAccounts) await this._accountsResolver.resolve();
        return this._accounts;
    }
    accounts(accounts) {
        this._autoResolveAccounts = true;
        this._accountsResolver.resolveOptionals(accounts);
        return this;
    }
    accountsStrict(accounts) {
        this._autoResolveAccounts = false;
        this._accountsResolver.resolveOptionals(accounts);
        return this;
    }
    signers(signers) {
        this._signers = this._signers.concat(signers);
        return this;
    }
    remainingAccounts(accounts) {
        this._remainingAccounts = this._remainingAccounts.concat(accounts);
        return this;
    }
    preInstructions(ixs) {
        this._preInstructions = this._preInstructions.concat(ixs);
        return this;
    }
    postInstructions(ixs) {
        this._postInstructions = this._postInstructions.concat(ixs);
        return this;
    }
    async rpc(options) {
        if (this._autoResolveAccounts) await this._accountsResolver.resolve();
        // @ts-ignore
        return this._rpcFn(...this._args, {
            accounts: this._accounts,
            signers: this._signers,
            remainingAccounts: this._remainingAccounts,
            preInstructions: this._preInstructions,
            postInstructions: this._postInstructions,
            options: options
        });
    }
    async rpcAndKeys(options) {
        const pubkeys = await this.pubkeys();
        return {
            pubkeys: pubkeys,
            signature: await this.rpc(options)
        };
    }
    async view(options) {
        if (this._autoResolveAccounts) await this._accountsResolver.resolve();
        if (!this._viewFn) throw new Error("Method does not support views");
        // @ts-ignore
        return this._viewFn(...this._args, {
            accounts: this._accounts,
            signers: this._signers,
            remainingAccounts: this._remainingAccounts,
            preInstructions: this._preInstructions,
            postInstructions: this._postInstructions,
            options: options
        });
    }
    async simulate(options) {
        if (this._autoResolveAccounts) await this._accountsResolver.resolve();
        // @ts-ignore
        return this._simulateFn(...this._args, {
            accounts: this._accounts,
            signers: this._signers,
            remainingAccounts: this._remainingAccounts,
            preInstructions: this._preInstructions,
            postInstructions: this._postInstructions,
            options: options
        });
    }
    async instruction() {
        if (this._autoResolveAccounts) await this._accountsResolver.resolve();
        // @ts-ignore
        return this._ixFn(...this._args, {
            accounts: this._accounts,
            signers: this._signers,
            remainingAccounts: this._remainingAccounts,
            preInstructions: this._preInstructions,
            postInstructions: this._postInstructions
        });
    }
    /**
     * Convenient shortcut to get instructions and pubkeys via
     * const { pubkeys, instructions } = await prepare();
     */ async prepare() {
        return {
            instruction: await this.instruction(),
            pubkeys: await this.pubkeys(),
            signers: await this._signers
        };
    }
    async transaction() {
        if (this._autoResolveAccounts) await this._accountsResolver.resolve();
        // @ts-ignore
        return this._txFn(...this._args, {
            accounts: this._accounts,
            signers: this._signers,
            remainingAccounts: this._remainingAccounts,
            preInstructions: this._preInstructions,
            postInstructions: this._postInstructions
        });
    }
}
class $26e0f71442fe06b5$var$ViewFactory {
    static build(programId, idlIx, simulateFn, idl) {
        const isMut = idlIx.accounts.find((a)=>a.isMut);
        const hasReturn = !!idlIx.returns;
        if (isMut || !hasReturn) return;
        const view = async (...args)=>{
            var _a, _b;
            let simulationResult = await simulateFn(...args);
            const returnPrefix = `Program return: ${programId} `;
            let returnLog = simulationResult.raw.find((l)=>l.startsWith(returnPrefix));
            if (!returnLog) throw new Error("View expected return log");
            let returnData = $26e0f71442fe06b5$var$decode(returnLog.slice(returnPrefix.length));
            let returnType = idlIx.returns;
            if (!returnType) throw new Error("View expected return type");
            const coder = $26e0f71442fe06b5$var$IdlCoder.fieldLayout({
                type: returnType
            }, Array.from([
                ...(_a = idl.accounts) !== null && _a !== void 0 ? _a : [],
                ...(_b = idl.types) !== null && _b !== void 0 ? _b : []
            ]));
            return coder.decode(returnData);
        };
        return view;
    }
}
class $26e0f71442fe06b5$var$NamespaceFactory {
    /**
     * Generates all namespaces for a given program.
     */ static build(idl, coder, programId, provider, getCustomResolver) {
        const rpc = {};
        const instruction = {};
        const transaction = {};
        const simulate = {};
        const methods = {};
        const view = {};
        const idlErrors = $26e0f71442fe06b5$export$cba16e61678ac4e1(idl);
        const account = idl.accounts ? $26e0f71442fe06b5$var$AccountFactory.build(idl, coder, programId, provider) : {};
        idl.instructions.forEach((idlIx)=>{
            const ixItem = $26e0f71442fe06b5$var$InstructionNamespaceFactory.build(idlIx, (ixName, ix)=>coder.instruction.encode(ixName, ix), programId);
            const txItem = $26e0f71442fe06b5$var$TransactionFactory.build(idlIx, ixItem);
            const rpcItem = $26e0f71442fe06b5$var$RpcFactory.build(idlIx, txItem, idlErrors, provider);
            const simulateItem = $26e0f71442fe06b5$var$SimulateFactory.build(idlIx, txItem, idlErrors, provider, coder, programId, idl);
            const viewItem = $26e0f71442fe06b5$var$ViewFactory.build(programId, idlIx, simulateItem, idl);
            const methodItem = $26e0f71442fe06b5$export$e47d8a80016e5cd1.build(provider, programId, idlIx, ixItem, txItem, rpcItem, simulateItem, viewItem, account, idl.types || [], getCustomResolver && getCustomResolver(idlIx));
            const name = (0, (/*@__PURE__*/$parcel$interopDefault($60a70e2f81b43d9e$exports)))(idlIx.name);
            instruction[name] = ixItem;
            transaction[name] = txItem;
            rpc[name] = rpcItem;
            simulate[name] = simulateItem;
            methods[name] = methodItem;
            if (viewItem) view[name] = viewItem;
        });
        return [
            rpc,
            instruction,
            transaction,
            account,
            simulate,
            methods,
            view
        ];
    }
}
/**
 * ## Program
 *
 * Program provides the IDL deserialized client representation of an Anchor
 * program.
 *
 * This API is the one stop shop for all things related to communicating with
 * on-chain programs. Among other things, one can send transactions, fetch
 * deserialized accounts, decode instruction data, subscribe to account
 * changes, and listen to events.
 *
 * In addition to field accessors and methods, the object provides a set of
 * dynamically generated properties, also known as namespaces, that
 * map one-to-one to program methods and accounts. These namespaces generally
 *  can be used as follows:
 *
 * ## Usage
 *
 * ```javascript
 * program.<namespace>.<program-specific-method>
 * ```
 *
 * API specifics are namespace dependent. The examples used in the documentation
 * below will refer to the two counter examples found
 * [here](https://github.com/coral-xyz/anchor#examples).
 */ class $26e0f71442fe06b5$export$b6c59b989905b650 {
    /**
     * Address of the program.
     */ get programId() {
        return this._programId;
    }
    /**
     * IDL defining the program's interface.
     */ get idl() {
        return this._idl;
    }
    /**
     * Coder for serializing requests.
     */ get coder() {
        return this._coder;
    }
    /**
     * Wallet and network provider.
     */ get provider() {
        return this._provider;
    }
    /**
     * @param idl       The interface definition.
     * @param programId The on-chain address of the program.
     * @param provider  The network and wallet context to use. If not provided
     *                  then uses [[getProvider]].
     * @param getCustomResolver A function that returns a custom account resolver
     *                          for the given instruction. This is useful for resolving
     *                          public keys of missing accounts when building instructions
     */ constructor(idl, programId, provider, coder, getCustomResolver){
        programId = $26e0f71442fe06b5$export$73f4f8860ca47074(programId);
        if (!provider) provider = $26e0f71442fe06b5$export$57632def5536cb24();
        // Fields.
        this._idl = idl;
        this._provider = provider;
        this._programId = programId;
        this._coder = coder !== null && coder !== void 0 ? coder : new $26e0f71442fe06b5$export$e59abd64f0cb1e2e(idl);
        this._events = new $26e0f71442fe06b5$export$cc74486daaaef499(this._programId, provider, this._coder);
        // Dynamic namespaces.
        const [rpc, instruction, transaction, account, simulate, methods, views] = $26e0f71442fe06b5$var$NamespaceFactory.build(idl, this._coder, programId, provider, getCustomResolver !== null && getCustomResolver !== void 0 ? getCustomResolver : ()=>undefined);
        this.rpc = rpc;
        this.instruction = instruction;
        this.transaction = transaction;
        this.account = account;
        this.simulate = simulate;
        this.methods = methods;
        this.views = views;
    }
    /**
     * Generates a Program client by fetching the IDL from the network.
     *
     * In order to use this method, an IDL must have been previously initialized
     * via the anchor CLI's `anchor idl init` command.
     *
     * @param programId The on-chain address of the program.
     * @param provider  The network and wallet context.
     */ static async at(address, provider) {
        const programId = $26e0f71442fe06b5$export$73f4f8860ca47074(address);
        const idl = await $26e0f71442fe06b5$export$b6c59b989905b650.fetchIdl(programId, provider);
        if (!idl) throw new Error(`IDL not found for program: ${address.toString()}`);
        return new $26e0f71442fe06b5$export$b6c59b989905b650(idl, programId, provider);
    }
    /**
     * Fetches an idl from the blockchain.
     *
     * In order to use this method, an IDL must have been previously initialized
     * via the anchor CLI's `anchor idl init` command.
     *
     * @param programId The on-chain address of the program.
     * @param provider  The network and wallet context.
     */ static async fetchIdl(address, provider) {
        provider = provider !== null && provider !== void 0 ? provider : $26e0f71442fe06b5$export$57632def5536cb24();
        const programId = $26e0f71442fe06b5$export$73f4f8860ca47074(address);
        const idlAddr = await $26e0f71442fe06b5$var$idlAddress(programId);
        const accountInfo = await provider.connection.getAccountInfo(idlAddr);
        if (!accountInfo) return null;
        // Chop off account discriminator.
        let idlAccount = $26e0f71442fe06b5$var$decodeIdlAccount(accountInfo.data.slice(8));
        const inflatedIdl = (0, $2d68152abb7d3417$export$cae1ce83fe4a1782)(idlAccount.data);
        return JSON.parse($26e0f71442fe06b5$var$decode$2(inflatedIdl));
    }
    /**
     * Invokes the given callback every time the given event is emitted.
     *
     * @param eventName The PascalCase name of the event, provided by the IDL.
     * @param callback  The function to invoke whenever the event is emitted from
     *                  program logs.
     */ addEventListener(eventName, callback) {
        return this._events.addEventListener(eventName, callback);
    }
    /**
     * Unsubscribes from the given eventName.
     */ async removeEventListener(listener) {
        return await this._events.removeEventListener(listener);
    }
}
const $26e0f71442fe06b5$var$SYSTEM_PROGRAM_ID = new (0, $1biTx.PublicKey)("11111111111111111111111111111111");
function $26e0f71442fe06b5$var$program(provider) {
    return new $26e0f71442fe06b5$export$b6c59b989905b650($26e0f71442fe06b5$var$IDL, $26e0f71442fe06b5$var$SYSTEM_PROGRAM_ID, provider, $26e0f71442fe06b5$var$coder());
}
function $26e0f71442fe06b5$var$coder() {
    return new $26e0f71442fe06b5$export$b7cd50a9c9812c96($26e0f71442fe06b5$var$IDL);
}
const $26e0f71442fe06b5$var$IDL = {
    version: "0.1.0",
    name: "system_program",
    instructions: [
        {
            name: "createAccount",
            accounts: [
                {
                    name: "from",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "to",
                    isMut: true,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "lamports",
                    type: "u64"
                },
                {
                    name: "space",
                    type: "u64"
                },
                {
                    name: "owner",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "assign",
            accounts: [
                {
                    name: "pubkey",
                    isMut: true,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "owner",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "transfer",
            accounts: [
                {
                    name: "from",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "to",
                    isMut: true,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "lamports",
                    type: "u64"
                }
            ]
        },
        {
            name: "createAccountWithSeed",
            accounts: [
                {
                    name: "from",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "to",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "base",
                    isMut: false,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "base",
                    type: "publicKey"
                },
                {
                    name: "seed",
                    type: "string"
                },
                {
                    name: "lamports",
                    type: "u64"
                },
                {
                    name: "space",
                    type: "u64"
                },
                {
                    name: "owner",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "advanceNonceAccount",
            accounts: [
                {
                    name: "nonce",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "recentBlockhashes",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authorized",
                    isMut: false,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "authorized",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "withdrawNonceAccount",
            accounts: [
                {
                    name: "nonce",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "to",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "recentBlockhashes",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rent",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authorized",
                    isMut: false,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "lamports",
                    type: "u64"
                }
            ]
        },
        {
            name: "initializeNonceAccount",
            accounts: [
                {
                    name: "nonce",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "recentBlockhashes",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rent",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "authorized",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "authorizeNonceAccount",
            accounts: [
                {
                    name: "nonce",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "authorized",
                    isMut: false,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "authorized",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "allocate",
            accounts: [
                {
                    name: "pubkey",
                    isMut: true,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "space",
                    type: "u64"
                }
            ]
        },
        {
            name: "allocateWithSeed",
            accounts: [
                {
                    name: "account",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "base",
                    isMut: false,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "base",
                    type: "publicKey"
                },
                {
                    name: "seed",
                    type: "string"
                },
                {
                    name: "space",
                    type: "u64"
                },
                {
                    name: "owner",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "assignWithSeed",
            accounts: [
                {
                    name: "account",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "base",
                    isMut: false,
                    isSigner: true
                }
            ],
            args: [
                {
                    name: "base",
                    type: "publicKey"
                },
                {
                    name: "seed",
                    type: "string"
                },
                {
                    name: "owner",
                    type: "publicKey"
                }
            ]
        },
        {
            name: "transferWithSeed",
            accounts: [
                {
                    name: "from",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "base",
                    isMut: false,
                    isSigner: true
                },
                {
                    name: "to",
                    isMut: true,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "lamports",
                    type: "u64"
                },
                {
                    name: "seed",
                    type: "string"
                },
                {
                    name: "owner",
                    type: "publicKey"
                }
            ]
        }
    ],
    accounts: [
        {
            name: "nonce",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "version",
                        type: "u32"
                    },
                    {
                        name: "state",
                        type: "u32"
                    },
                    {
                        name: "authorizedPubkey",
                        type: "publicKey"
                    },
                    {
                        name: "nonce",
                        type: "publicKey"
                    },
                    {
                        name: "feeCalculator",
                        type: {
                            defined: "FeeCalculator"
                        }
                    }
                ]
            }
        }
    ],
    types: [
        {
            name: "FeeCalculator",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "lamportsPerSignature",
                        type: "u64"
                    }
                ]
            }
        }
    ]
};
class $26e0f71442fe06b5$export$7bbc682b75e8aad4 {
    static system(provider) {
        return $26e0f71442fe06b5$var$program(provider);
    }
}



var $lx97N = parcelRequire("lx97N");

function $4ae3b4d833a8f940$export$f0c8856d09a969c2() {
    const { publicKey: publicKey, signTransaction: signTransaction, signAllTransactions: signAllTransactions } = (0, $502df6790791f964$export$c34addee860b0acb)();
    return (0, $lx97N.useMemo)(()=>publicKey && signTransaction && signAllTransactions ? {
            publicKey: publicKey,
            signTransaction: signTransaction,
            signAllTransactions: signAllTransactions
        } : undefined, [
        publicKey,
        signTransaction,
        signAllTransactions
    ]);
}



var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");



const $1d6378fa7d19bec0$var$UnstakeNFT = ({ nft: nft, wallet: wallet, setOverallStates: setOverallStates, stakeApi: stakeApi })=>{
    const { sendTransaction: sendTransaction } = (0, $502df6790791f964$export$c34addee860b0acb)();
    const { mintPubKey: mintPubKey, staked: staked } = nft;
    const [isTxLoading, setIsTxLoading] = (0, $lx97N.useState)(false);
    const [wsSubscriptionId, setWsSubscribtionId] = (0, $lx97N.useState)();
    const removeListener = async ()=>{
        if (wsSubscriptionId) await (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection.removeAccountChangeListener(wsSubscriptionId);
    };
    const onClickStake = async ()=>{
        if (wallet && mintPubKey) {
            setIsTxLoading(true);
            try {
                const tokenmetaPubkey = await (0, $73ba2eb78746f6af$export$7f4c6ae6cd2bdde3).metadata.Metadata.getPDA(mintPubKey);
                const stakeEntry = await stakeApi.stakeEntryAddress({
                    user: wallet.publicKey,
                    nft: {
                        mintAddress: mintPubKey,
                        metadataAddress: tokenmetaPubkey
                    }
                });
                const tx = staked ? await stakeApi.unstake({
                    user: wallet.publicKey,
                    nft: {
                        mintAddress: mintPubKey,
                        metadataAddress: tokenmetaPubkey
                    }
                }) : await stakeApi.stake({
                    user: wallet.publicKey,
                    nft: {
                        mintAddress: mintPubKey,
                        metadataAddress: tokenmetaPubkey
                    }
                });
                const txSig = await sendTransaction(tx, (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection);
                console.log("Submitted tx:", txSig);
                const wsSubscriptionId = (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection.onAccountChange(stakeEntry, async ()=>{
                    await removeListener();
                    await setOverallStates(wallet.publicKey);
                    setIsTxLoading(false);
                }, "finalized");
                setWsSubscribtionId(wsSubscriptionId);
            } catch (err) {
                setIsTxLoading(false);
                console.log(err);
            }
        }
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: "w-max flex flex-row mt-2 space-x-1.5 justify-between",
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
            onClick: onClickStake,
            className: nft.staked ? `w-full inline-block flex justify-center items-center rounded bg-red-500 py-1.5 px-2 text-sm font-semibold text-slate-900 hover:bg-red-400 active:bg-red-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500/50` : `w-full inline-block flex justify-center items-center rounded bg-green-500 py-1.5 px-2 text-sm font-semibold text-slate-900 hover:bg-green-400 active:bg-green-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-500/50`,
            children: isTxLoading ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("svg", {
                className: "animate-spin h-5 w-5",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }) : nft.staked ? "Unstake" : "Stake"
        })
    });
};
var $1d6378fa7d19bec0$export$2e2bcd8739ae039 = $1d6378fa7d19bec0$var$UnstakeNFT;




var $lx97N = parcelRequire("lx97N");



const $4a6e2d09a8a21c11$var$MovePoints = ({ nft: nft, wallet: wallet, setOverallStates: setOverallStates, stakeApi: stakeApi, pointsFromLadMint: pointsFromLadMint, setPointsFromLadMint: setPointsFromLadMint })=>{
    const { sendTransaction: sendTransaction } = (0, $502df6790791f964$export$c34addee860b0acb)();
    const { mintPubKey: mintPubKey, staked: staked } = nft;
    const [isTxLoading, setIsTxLoading] = (0, $lx97N.useState)(false);
    const [wsSubscriptionId, setWsSubscribtionId] = (0, $lx97N.useState)();
    const removeListener = async ()=>{
        if (wsSubscriptionId) await (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection.removeAccountChangeListener(wsSubscriptionId);
    };
    const onClickMove = async ()=>{
        if (wallet && mintPubKey) {
            if (pointsFromLadMint && pointsFromLadMint != mintPubKey) {
                setIsTxLoading(true);
                try {
                    const fromNftMint = pointsFromLadMint;
                    const toNftMint = mintPubKey;
                    const fromNftMeta = await (0, $73ba2eb78746f6af$export$7f4c6ae6cd2bdde3).metadata.Metadata.getPDA(fromNftMint);
                    const toNftMeta = await (0, $73ba2eb78746f6af$export$7f4c6ae6cd2bdde3).metadata.Metadata.getPDA(toNftMint);
                    const goldPointsAddress = await stakeApi.goldPointsAddress({
                        user: wallet.publicKey,
                        nft: {
                            mintAddress: fromNftMint,
                            metadataAddress: fromNftMeta
                        }
                    });
                    const tx = await stakeApi.transferRewards({
                        fromUser: wallet.publicKey,
                        fromNft: {
                            mintAddress: fromNftMint,
                            metadataAddress: fromNftMeta
                        },
                        toNft: {
                            mintAddress: toNftMint,
                            metadataAddress: toNftMeta
                        }
                    });
                    const txSig = await sendTransaction(tx, (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection);
                    console.log("Submitted tx:", txSig);
                    const wsSubscriptionId = (0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection.onAccountChange(goldPointsAddress, async ()=>{
                        await removeListener();
                        await setOverallStates(wallet.publicKey);
                        setPointsFromLadMint(undefined);
                        setIsTxLoading(false);
                    }, "finalized");
                    setWsSubscribtionId(wsSubscriptionId);
                } catch (err) {
                    setIsTxLoading(false);
                    console.log(err);
                }
            } else if (pointsFromLadMint && pointsFromLadMint == mintPubKey) setPointsFromLadMint(undefined);
            else setPointsFromLadMint(nft.mintPubKey);
        }
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        className: "w-full flex flex-row mt-2 space-x-1.5 justify-between",
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
            onClick: onClickMove,
            className: !pointsFromLadMint ? `w-full inline-block flex justify-center items-center rounded bg-cyan-500 py-1.5 px-2 text-sm font-semibold text-slate-900 hover:bg-cyan-400 active:bg-cyan-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-500/50` : pointsFromLadMint == nft.mintPubKey ? `w-full inline-block flex justify-center items-center rounded bg-orange-500 py-1.5 px-2 text-sm font-semibold text-slate-900 hover:bg-orange-400 active:bg-orange-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500/50` : `w-full inline-block flex justify-center items-center rounded bg-violet-500 py-1.5 px-2 text-sm font-semibold text-slate-900 hover:bg-violet-400 active:bg-violet-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-500/50`,
            children: isTxLoading ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("svg", {
                className: "animate-spin h-5 w-5",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }) : pointsFromLadMint ? pointsFromLadMint == nft.mintPubKey ? "Cancel Transfer From" : "Transfer Points To" : "Transfer Points From"
        })
    });
};
var $4a6e2d09a8a21c11$export$2e2bcd8739ae039 = $4a6e2d09a8a21c11$var$MovePoints;





var $cj5EG = parcelRequire("cj5EG");

var $1biTx = parcelRequire("1biTx");

var $ivDjT = parcelRequire("ivDjT");
const $9ab965101f926af6$export$15db02dbfcaf60e0 = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};



var $ivDjT = parcelRequire("ivDjT");

var $bpv1j = parcelRequire("bpv1j");


var $cbQCu = parcelRequire("cbQCu");
var $8d13ee94ac09f29a$require$Buffer = $cbQCu.Buffer;
const $8d13ee94ac09f29a$export$c97e695afb26d84 = (length)=>(property)=>{
        const layout = (0, $ivDjT.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $9ab965101f926af6$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $bpv1j.toBigIntLE)($8d13ee94ac09f29a$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $bpv1j.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $8d13ee94ac09f29a$export$8fa7afc0d3e063a4 = (length)=>(property)=>{
        const layout = (0, $ivDjT.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $9ab965101f926af6$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $bpv1j.toBigIntBE)($8d13ee94ac09f29a$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $bpv1j.toBufferBE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $8d13ee94ac09f29a$export$cd1442401e54cffa = $8d13ee94ac09f29a$export$c97e695afb26d84(8);
const $8d13ee94ac09f29a$export$7f18746cf5292838 = $8d13ee94ac09f29a$export$8fa7afc0d3e063a4(8);
const $8d13ee94ac09f29a$export$6cebf8c93d35ecb4 = $8d13ee94ac09f29a$export$c97e695afb26d84(16);
const $8d13ee94ac09f29a$export$327689723be22772 = $8d13ee94ac09f29a$export$8fa7afc0d3e063a4(16);
const $8d13ee94ac09f29a$export$8f928ec3e6d68946 = $8d13ee94ac09f29a$export$c97e695afb26d84(24);
const $8d13ee94ac09f29a$export$559ccecc3c5a7252 = $8d13ee94ac09f29a$export$8fa7afc0d3e063a4(24);
const $8d13ee94ac09f29a$export$c6d3c723c6dee16b = $8d13ee94ac09f29a$export$c97e695afb26d84(32);
const $8d13ee94ac09f29a$export$667f357a9402d24c = $8d13ee94ac09f29a$export$8fa7afc0d3e063a4(32);


var $4aa9260d4a516990$exports = {};
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, $4aa9260d4a516990$exports) $4aa9260d4a516990$exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})($4aa9260d4a516990$exports);




const $b914afa0fbd687f5$export$23054672248b2c43 = new (0, (/*@__PURE__*/$parcel$interopDefault($4aa9260d4a516990$exports)))("1e+18");
const $b914afa0fbd687f5$export$78a48a3d1e5dbe89 = (property)=>{
    const layout = (0, $8d13ee94ac09f29a$export$6cebf8c93d35ecb4)(property);
    const { encode: encode, decode: decode } = (0, $9ab965101f926af6$export$15db02dbfcaf60e0)(layout);
    const decimalLayout = layout;
    decimalLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset).toString();
        return new (0, (/*@__PURE__*/$parcel$interopDefault($4aa9260d4a516990$exports)))(src).div($b914afa0fbd687f5$export$23054672248b2c43);
    };
    decimalLayout.encode = (decimal, buffer, offset)=>{
        const src = BigInt(decimal.times($b914afa0fbd687f5$export$23054672248b2c43).integerValue().toString());
        return encode(src, buffer, offset);
    };
    return decimalLayout;
};



var $ivDjT = parcelRequire("ivDjT");

const $4a28408af7b99990$export$87b259aa03e3d267 = (property)=>{
    const layout = (0, $ivDjT.u8)(property);
    const { encode: encode, decode: decode } = (0, $9ab965101f926af6$export$15db02dbfcaf60e0)(layout);
    const boolLayout = layout;
    boolLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return !!src;
    };
    boolLayout.encode = (bool, buffer, offset)=>{
        const src = Number(bool);
        return encode(src, buffer, offset);
    };
    return boolLayout;
};



var $ivDjT = parcelRequire("ivDjT");

var $1biTx = parcelRequire("1biTx");

const $b3c8a5e9d2b938eb$export$86f13247979de5d7 = (property)=>{
    const layout = (0, $ivDjT.blob)(32, property);
    const { encode: encode, decode: decode } = (0, $9ab965101f926af6$export$15db02dbfcaf60e0)(layout);
    const publicKeyLayout = layout;
    publicKeyLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return new (0, $1biTx.PublicKey)(src);
    };
    publicKeyLayout.encode = (publicKey, buffer, offset)=>{
        const src = publicKey.toBuffer();
        return encode(src, buffer, offset);
    };
    return publicKeyLayout;
};





var $1biTx = parcelRequire("1biTx");
const $354f0720d1023043$export$79de3e3c2b1ca801 = new (0, $1biTx.PublicKey)("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const $354f0720d1023043$export$8183845dc9f5ce72 = new (0, $1biTx.PublicKey)("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
const $354f0720d1023043$export$57a4f33bcc1767fa = new (0, $1biTx.PublicKey)("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
const $354f0720d1023043$export$71f490c6a4aef7af = new (0, $1biTx.PublicKey)("So11111111111111111111111111111111111111112");
const $354f0720d1023043$export$710fe796384b28ef = new (0, $1biTx.PublicKey)("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
function $354f0720d1023043$export$839bb614a661d99b(programId) {
    if (programId === $354f0720d1023043$export$79de3e3c2b1ca801) return false;
    else return true;
}


/** Base class for errors */ class $8b84caa63ed52a8d$export$ed0b8b496332122d extends Error {
    constructor(message){
        super(message);
    }
}
class $8b84caa63ed52a8d$export$a09a5e48de2f3404 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenAccountNotFoundError";
    }
}
class $8b84caa63ed52a8d$export$f4938317c78e324f extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountError";
    }
}
class $8b84caa63ed52a8d$export$abb470453474d51 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountOwnerError";
    }
}
class $8b84caa63ed52a8d$export$250d31de4ddb7ca5 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountSizeError";
    }
}
class $8b84caa63ed52a8d$export$871debb212ec395 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidMintError";
    }
}
class $8b84caa63ed52a8d$export$9d3e0012e0e06993 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidOwnerError";
    }
}
class $8b84caa63ed52a8d$export$c431a85da6f99bf0 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenOwnerOffCurveError";
    }
}
class $8b84caa63ed52a8d$export$a241007212c884f6 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionProgramError";
    }
}
class $8b84caa63ed52a8d$export$3882cbbd44973a88 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionKeysError";
    }
}
class $8b84caa63ed52a8d$export$f96a822f391c3cc4 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionDataError";
    }
}
class $8b84caa63ed52a8d$export$e1301365d704141e extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionTypeError";
    }
}
class $8b84caa63ed52a8d$export$ff48aa5f01687311 extends $8b84caa63ed52a8d$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenUnsupportedInstructionError";
    }
}


var $02af554e3db3889f$export$b8ca5fa4899cbfc7;
(function(AccountType) {
    AccountType[AccountType["Uninitialized"] = 0] = "Uninitialized";
    AccountType[AccountType["Mint"] = 1] = "Mint";
    AccountType[AccountType["Account"] = 2] = "Account";
})($02af554e3db3889f$export$b8ca5fa4899cbfc7 || ($02af554e3db3889f$export$b8ca5fa4899cbfc7 = {}));
const $02af554e3db3889f$export$9d3ac77dcbf22b3f = 1;




var $ivDjT = parcelRequire("ivDjT");


var $1biTx = parcelRequire("1biTx");






var $ivDjT = parcelRequire("ivDjT");



const $01f797b4826802f9$export$c23cd279ce124ca0 = (0, $ivDjT.struct)([
    (0, $ivDjT.u8)("m"),
    (0, $ivDjT.u8)("n"),
    (0, $4a28408af7b99990$export$87b259aa03e3d267)("isInitialized"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer1"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer2"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer3"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer4"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer5"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer6"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer7"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer8"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer9"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer10"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("signer11")
]);
const $01f797b4826802f9$export$c2abf71f91a1605b = $01f797b4826802f9$export$c23cd279ce124ca0.span;
async function $01f797b4826802f9$export$257dfa65916d8d24(connection, address, commitment, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $01f797b4826802f9$export$2620f4d387573ced(address, info, programId);
}
function $01f797b4826802f9$export$2620f4d387573ced(address, info, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $8b84caa63ed52a8d$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $8b84caa63ed52a8d$export$abb470453474d51)();
    if (info.data.length != $01f797b4826802f9$export$c2abf71f91a1605b) throw new (0, $8b84caa63ed52a8d$export$250d31de4ddb7ca5)();
    const multisig = $01f797b4826802f9$export$c23cd279ce124ca0.decode(info.data);
    return {
        address: address,
        ...multisig
    };
}
async function $01f797b4826802f9$export$cd6dc5245600da53(connection, commitment) {
    return await connection.getMinimumBalanceForRentExemption($01f797b4826802f9$export$c2abf71f91a1605b, commitment);
}



var $cbQCu = parcelRequire("cbQCu");
var $5046bae03150daad$require$Buffer = $cbQCu.Buffer;
const $5046bae03150daad$export$1374e91decd2fbe5 = (0, $ivDjT.struct)([
    (0, $ivDjT.u32)("mintAuthorityOption"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("mintAuthority"),
    (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("supply"),
    (0, $ivDjT.u8)("decimals"),
    (0, $4a28408af7b99990$export$87b259aa03e3d267)("isInitialized"),
    (0, $ivDjT.u32)("freezeAuthorityOption"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("freezeAuthority")
]);
const $5046bae03150daad$export$1e66c79f18e1c0c4 = $5046bae03150daad$export$1374e91decd2fbe5.span;
async function $5046bae03150daad$export$aa28710f9c948d46(connection, address, commitment, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $5046bae03150daad$export$624621e2731540bb(address, info, programId);
}
function $5046bae03150daad$export$624621e2731540bb(address, info, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $8b84caa63ed52a8d$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $8b84caa63ed52a8d$export$abb470453474d51)();
    if (info.data.length < $5046bae03150daad$export$1e66c79f18e1c0c4) throw new (0, $8b84caa63ed52a8d$export$250d31de4ddb7ca5)();
    const rawMint = $5046bae03150daad$export$1374e91decd2fbe5.decode(info.data.slice(0, $5046bae03150daad$export$1e66c79f18e1c0c4));
    let tlvData = $5046bae03150daad$require$Buffer.alloc(0);
    if (info.data.length > $5046bae03150daad$export$1e66c79f18e1c0c4) {
        if (info.data.length <= (0, $825a2ddc199ddd3d$export$66ab21ef808e9dc6)) throw new (0, $8b84caa63ed52a8d$export$250d31de4ddb7ca5)();
        if (info.data.length === (0, $01f797b4826802f9$export$c2abf71f91a1605b)) throw new (0, $8b84caa63ed52a8d$export$250d31de4ddb7ca5)();
        if (info.data[0, $825a2ddc199ddd3d$export$66ab21ef808e9dc6] != (0, $02af554e3db3889f$export$b8ca5fa4899cbfc7).Mint) throw new (0, $8b84caa63ed52a8d$export$871debb212ec395)();
        tlvData = info.data.slice((0, $825a2ddc199ddd3d$export$66ab21ef808e9dc6) + (0, $02af554e3db3889f$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mintAuthority: rawMint.mintAuthorityOption ? rawMint.mintAuthority : null,
        supply: rawMint.supply,
        decimals: rawMint.decimals,
        isInitialized: rawMint.isInitialized,
        freezeAuthority: rawMint.freezeAuthorityOption ? rawMint.freezeAuthority : null,
        tlvData: tlvData
    };
}
async function $5046bae03150daad$export$ee29e619ed2e153c(connection, commitment) {
    return await $5046bae03150daad$export$42e75cb3f25fa0b8(connection, [], commitment);
}
async function $5046bae03150daad$export$42e75cb3f25fa0b8(connection, extensions, commitment) {
    const mintLen = (0, $82f2e1ad6ee0422c$export$887e6fc33c7c42b5)(extensions);
    return await connection.getMinimumBalanceForRentExemption(mintLen, commitment);
}
async function $5046bae03150daad$export$d776e5c4182d21cc(mint, owner, allowOwnerOffCurve = false, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $354f0720d1023043$export$57a4f33bcc1767fa)) {
    if (!allowOwnerOffCurve && !(0, $1biTx.PublicKey).isOnCurve(owner.toBuffer())) throw new (0, $8b84caa63ed52a8d$export$c431a85da6f99bf0)();
    const [address] = await (0, $1biTx.PublicKey).findProgramAddress([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId);
    return address;
}
function $5046bae03150daad$export$226efbbb37d925bb(mint, owner, allowOwnerOffCurve = false, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $354f0720d1023043$export$57a4f33bcc1767fa)) {
    if (!allowOwnerOffCurve && !(0, $1biTx.PublicKey).isOnCurve(owner.toBuffer())) throw new (0, $8b84caa63ed52a8d$export$c431a85da6f99bf0)();
    const [address] = (0, $1biTx.PublicKey).findProgramAddressSync([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId);
    return address;
}





var $ivDjT = parcelRequire("ivDjT");


const $0e8c174b7feb2b55$export$f70216558c70b1a0 = (0, $ivDjT.struct)([
    (0, $4a28408af7b99990$export$87b259aa03e3d267)("lockCpi")
]);
const $0e8c174b7feb2b55$export$2ad51e83460d1d03 = $0e8c174b7feb2b55$export$f70216558c70b1a0.span;
function $0e8c174b7feb2b55$export$1f414ebe518a07c3(account) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).CpiGuard, account.tlvData);
    if (extensionData !== null) return $0e8c174b7feb2b55$export$f70216558c70b1a0.decode(extensionData);
    else return null;
}



var $ivDjT = parcelRequire("ivDjT");

const $e5d0634f65bf6211$export$e8ecc3a3060edae5 = (0, $ivDjT.struct)([
    (0, $ivDjT.u8)("state")
]);
const $e5d0634f65bf6211$export$2e3c876eadfda1ab = $e5d0634f65bf6211$export$e8ecc3a3060edae5.span;
function $e5d0634f65bf6211$export$d7b87bbf5a44c34c(mint) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).DefaultAccountState, mint.tlvData);
    if (extensionData !== null) return $e5d0634f65bf6211$export$e8ecc3a3060edae5.decode(extensionData);
    else return null;
}



var $ivDjT = parcelRequire("ivDjT");

const $f188b0f5896a12d6$export$3b7e34eff13c869c = (0, $ivDjT.struct)([]);
const $f188b0f5896a12d6$export$4ba1dedcafaef535 = $f188b0f5896a12d6$export$3b7e34eff13c869c.span;
function $f188b0f5896a12d6$export$ff9fc6dae6f7d7a0(account) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).ImmutableOwner, account.tlvData);
    if (extensionData !== null) return $f188b0f5896a12d6$export$3b7e34eff13c869c.decode(extensionData);
    else return null;
}



var $ivDjT = parcelRequire("ivDjT");


const $70b570c20d6f0f48$export$dea2930f2b4b5995 = (0, $ivDjT.struct)([
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("rateAuthority"),
    (0, $ivDjT.ns64)("initializationTimestamp"),
    (0, $ivDjT.s16)("preUpdateAverageRate"),
    (0, $ivDjT.ns64)("lastUpdateTimestamp"),
    (0, $ivDjT.s16)("currentRate")
]);
const $70b570c20d6f0f48$export$5deaa22b862a446f = $70b570c20d6f0f48$export$dea2930f2b4b5995.span;
function $70b570c20d6f0f48$export$c0f4cb585bb22702(mint) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).InterestBearingConfig, mint.tlvData);
    if (extensionData !== null) return $70b570c20d6f0f48$export$dea2930f2b4b5995.decode(extensionData);
    return null;
}



var $ivDjT = parcelRequire("ivDjT");


const $f2f32291428ec5b6$export$5607c4289fc50398 = (0, $ivDjT.struct)([
    (0, $4a28408af7b99990$export$87b259aa03e3d267)("requireIncomingTransferMemos")
]);
const $f2f32291428ec5b6$export$f4b5375ad34477a1 = $f2f32291428ec5b6$export$5607c4289fc50398.span;
function $f2f32291428ec5b6$export$3f4bed2e631f122c(account) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).MemoTransfer, account.tlvData);
    if (extensionData !== null) return $f2f32291428ec5b6$export$5607c4289fc50398.decode(extensionData);
    else return null;
}



var $ivDjT = parcelRequire("ivDjT");


const $c7cb58fd5dc45d4c$export$ece081d471f0fc95 = (0, $ivDjT.struct)([
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("closeAuthority")
]);
const $c7cb58fd5dc45d4c$export$1e1aa83bde32eb68 = $c7cb58fd5dc45d4c$export$ece081d471f0fc95.span;
function $c7cb58fd5dc45d4c$export$bfd41dfeb5917197(mint) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).MintCloseAuthority, mint.tlvData);
    if (extensionData !== null) return $c7cb58fd5dc45d4c$export$ece081d471f0fc95.decode(extensionData);
    else return null;
}



var $ivDjT = parcelRequire("ivDjT");

const $1b7a4c0395b10901$export$bae9d70f4fd33725 = (0, $ivDjT.struct)([]);
const $1b7a4c0395b10901$export$31a113d46d052efb = $1b7a4c0395b10901$export$bae9d70f4fd33725.span;
function $1b7a4c0395b10901$export$718a9bb289be2420(mint) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).NonTransferable, mint.tlvData);
    if (extensionData !== null) return $1b7a4c0395b10901$export$bae9d70f4fd33725.decode(extensionData);
    else return null;
}



var $ivDjT = parcelRequire("ivDjT");


const $a303084e12942ce8$export$1d6e8e6f44705001 = (0, $ivDjT.struct)([
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("delegate")
]);
const $a303084e12942ce8$export$636ea2373b6c6b7d = $a303084e12942ce8$export$1d6e8e6f44705001.span;
function $a303084e12942ce8$export$3d161872832356b0(mint) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).PermanentDelegate, mint.tlvData);
    if (extensionData !== null) return $a303084e12942ce8$export$1d6e8e6f44705001.decode(extensionData);
    else return null;
}



var $ivDjT = parcelRequire("ivDjT");


const $e9556e686148ad82$export$7bf230db5a769018 = 10000;
const $e9556e686148ad82$export$8a34ad2d496101b6 = $e9556e686148ad82$export$7bf230db5a769018;
function $e9556e686148ad82$export$35e5691ab3997dac(property) {
    return (0, $ivDjT.struct)([
        (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("epoch"),
        (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("maximumFee"),
        (0, $ivDjT.u16)("transferFeeBasisPoints")
    ], property);
}
const $e9556e686148ad82$export$c849e8e6e4ae7e4b = (0, $ivDjT.struct)([
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("transferFeeConfigAuthority"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("withdrawWithheldAuthority"),
    (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("withheldAmount"),
    $e9556e686148ad82$export$35e5691ab3997dac("olderTransferFee"),
    $e9556e686148ad82$export$35e5691ab3997dac("newerTransferFee")
]);
const $e9556e686148ad82$export$972cf5dcc13158da = $e9556e686148ad82$export$c849e8e6e4ae7e4b.span;
const $e9556e686148ad82$export$a20fb363192b96a2 = (0, $ivDjT.struct)([
    (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("withheldAmount")
]);
const $e9556e686148ad82$export$8657a852ae4f4019 = $e9556e686148ad82$export$a20fb363192b96a2.span;
function $e9556e686148ad82$export$451dabe4cdde5d9a(mint) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).TransferFeeConfig, mint.tlvData);
    if (extensionData !== null) return $e9556e686148ad82$export$c849e8e6e4ae7e4b.decode(extensionData);
    else return null;
}
function $e9556e686148ad82$export$857f13d8ce75ecd9(account) {
    const extensionData = (0, $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee)((0, $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb).TransferFeeAmount, account.tlvData);
    if (extensionData !== null) return $e9556e686148ad82$export$a20fb363192b96a2.decode(extensionData);
    else return null;
}


var $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb;
(function(ExtensionType) {
    ExtensionType[ExtensionType["Uninitialized"] = 0] = "Uninitialized";
    ExtensionType[ExtensionType["TransferFeeConfig"] = 1] = "TransferFeeConfig";
    ExtensionType[ExtensionType["TransferFeeAmount"] = 2] = "TransferFeeAmount";
    ExtensionType[ExtensionType["MintCloseAuthority"] = 3] = "MintCloseAuthority";
    ExtensionType[ExtensionType["ConfidentialTransferMint"] = 4] = "ConfidentialTransferMint";
    ExtensionType[ExtensionType["ConfidentialTransferAccount"] = 5] = "ConfidentialTransferAccount";
    ExtensionType[ExtensionType["DefaultAccountState"] = 6] = "DefaultAccountState";
    ExtensionType[ExtensionType["ImmutableOwner"] = 7] = "ImmutableOwner";
    ExtensionType[ExtensionType["MemoTransfer"] = 8] = "MemoTransfer";
    ExtensionType[ExtensionType["NonTransferable"] = 9] = "NonTransferable";
    ExtensionType[ExtensionType["InterestBearingConfig"] = 10] = "InterestBearingConfig";
    ExtensionType[ExtensionType["CpiGuard"] = 11] = "CpiGuard";
    ExtensionType[ExtensionType["PermanentDelegate"] = 12] = "PermanentDelegate";
})($82f2e1ad6ee0422c$export$4f037c6ec2da4eeb || ($82f2e1ad6ee0422c$export$4f037c6ec2da4eeb = {}));
const $82f2e1ad6ee0422c$export$b60591f8709c84d6 = 2;
const $82f2e1ad6ee0422c$export$7ae242f656e23fe = 2;
function $82f2e1ad6ee0422c$export$a83377bb2e8914d8(e) {
    switch(e){
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.Uninitialized:
            return 0;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return 0, $e9556e686148ad82$export$972cf5dcc13158da;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeAmount:
            return 0, $e9556e686148ad82$export$8657a852ae4f4019;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MintCloseAuthority:
            return 0, $c7cb58fd5dc45d4c$export$1e1aa83bde32eb68;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return 97;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
            return 286;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.CpiGuard:
            return 0, $0e8c174b7feb2b55$export$2ad51e83460d1d03;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.DefaultAccountState:
            return 0, $e5d0634f65bf6211$export$2e3c876eadfda1ab;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ImmutableOwner:
            return 0, $f188b0f5896a12d6$export$4ba1dedcafaef535;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MemoTransfer:
            return 0, $f2f32291428ec5b6$export$f4b5375ad34477a1;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.NonTransferable:
            return 0, $1b7a4c0395b10901$export$31a113d46d052efb;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.InterestBearingConfig:
            return 0, $70b570c20d6f0f48$export$5deaa22b862a446f;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.PermanentDelegate:
            return 0, $a303084e12942ce8$export$636ea2373b6c6b7d;
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $82f2e1ad6ee0422c$export$bb78b607a215e9f6(e) {
    switch(e){
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.NonTransferable:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.PermanentDelegate:
            return true;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.Uninitialized:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MemoTransfer:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.CpiGuard:
            return false;
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $82f2e1ad6ee0422c$export$da3491d66fdbe926(e) {
    switch(e){
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MemoTransfer:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.CpiGuard:
            return true;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.Uninitialized:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.NonTransferable:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.PermanentDelegate:
            return false;
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $82f2e1ad6ee0422c$export$cbf93c990104e9e6(e) {
    switch(e){
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeAmount;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferAccount;
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.CpiGuard:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MemoTransfer:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.NonTransferable:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.Uninitialized:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.PermanentDelegate:
            return $82f2e1ad6ee0422c$export$4f037c6ec2da4eeb.Uninitialized;
    }
}
function $82f2e1ad6ee0422c$var$getLen(extensionTypes, baseSize) {
    if (extensionTypes.length === 0) return baseSize;
    else {
        const accountLength = (0, $825a2ddc199ddd3d$export$66ab21ef808e9dc6) + (0, $02af554e3db3889f$export$9d3ac77dcbf22b3f) + extensionTypes.filter((element, i)=>i === extensionTypes.indexOf(element)).map((element)=>$82f2e1ad6ee0422c$export$a83377bb2e8914d8(element) + $82f2e1ad6ee0422c$export$b60591f8709c84d6 + $82f2e1ad6ee0422c$export$7ae242f656e23fe).reduce((a, b)=>a + b);
        if (accountLength === (0, $01f797b4826802f9$export$c2abf71f91a1605b)) return accountLength + $82f2e1ad6ee0422c$export$b60591f8709c84d6;
        else return accountLength;
    }
}
function $82f2e1ad6ee0422c$export$887e6fc33c7c42b5(extensionTypes) {
    return $82f2e1ad6ee0422c$var$getLen(extensionTypes, (0, $5046bae03150daad$export$1e66c79f18e1c0c4));
}
function $82f2e1ad6ee0422c$export$37c8c863c6dd42a9(extensionTypes) {
    return $82f2e1ad6ee0422c$var$getLen(extensionTypes, (0, $825a2ddc199ddd3d$export$66ab21ef808e9dc6));
}
function $82f2e1ad6ee0422c$export$4fff3ed4eba4f4ee(extension, tlvData) {
    let extensionTypeIndex = 0;
    while(extensionTypeIndex + $82f2e1ad6ee0422c$export$b60591f8709c84d6 + $82f2e1ad6ee0422c$export$7ae242f656e23fe <= tlvData.length){
        const entryType = tlvData.readUInt16LE(extensionTypeIndex);
        const entryLength = tlvData.readUInt16LE(extensionTypeIndex + $82f2e1ad6ee0422c$export$b60591f8709c84d6);
        const typeIndex = extensionTypeIndex + $82f2e1ad6ee0422c$export$b60591f8709c84d6 + $82f2e1ad6ee0422c$export$7ae242f656e23fe;
        if (entryType == extension) return tlvData.slice(typeIndex, typeIndex + entryLength);
        extensionTypeIndex = typeIndex + entryLength;
    }
    return null;
}
function $82f2e1ad6ee0422c$export$ddfd0a43fd10c049(tlvData) {
    const extensionTypes = [];
    let extensionTypeIndex = 0;
    while(extensionTypeIndex < tlvData.length){
        const entryType = tlvData.readUInt16LE(extensionTypeIndex);
        extensionTypes.push(entryType);
        const entryLength = tlvData.readUInt16LE(extensionTypeIndex + $82f2e1ad6ee0422c$export$b60591f8709c84d6);
        extensionTypeIndex += $82f2e1ad6ee0422c$export$b60591f8709c84d6 + $82f2e1ad6ee0422c$export$7ae242f656e23fe + entryLength;
    }
    return extensionTypes;
}
function $82f2e1ad6ee0422c$export$8e188ecf75868f0c(mint) {
    const extensionTypes = $82f2e1ad6ee0422c$export$ddfd0a43fd10c049(mint.tlvData);
    const accountExtensions = extensionTypes.map($82f2e1ad6ee0422c$export$cbf93c990104e9e6);
    return $82f2e1ad6ee0422c$export$37c8c863c6dd42a9(accountExtensions);
}




var $cbQCu = parcelRequire("cbQCu");
var $825a2ddc199ddd3d$require$Buffer = $cbQCu.Buffer;
var $825a2ddc199ddd3d$export$70504fba2ce56d52;
(function(AccountState) {
    AccountState[AccountState["Uninitialized"] = 0] = "Uninitialized";
    AccountState[AccountState["Initialized"] = 1] = "Initialized";
    AccountState[AccountState["Frozen"] = 2] = "Frozen";
})($825a2ddc199ddd3d$export$70504fba2ce56d52 || ($825a2ddc199ddd3d$export$70504fba2ce56d52 = {}));
const $825a2ddc199ddd3d$export$cab31ec27f6c5fa = (0, $ivDjT.struct)([
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("mint"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("owner"),
    (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("amount"),
    (0, $ivDjT.u32)("delegateOption"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("delegate"),
    (0, $ivDjT.u8)("state"),
    (0, $ivDjT.u32)("isNativeOption"),
    (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("isNative"),
    (0, $8d13ee94ac09f29a$export$cd1442401e54cffa)("delegatedAmount"),
    (0, $ivDjT.u32)("closeAuthorityOption"),
    (0, $b3c8a5e9d2b938eb$export$86f13247979de5d7)("closeAuthority")
]);
const $825a2ddc199ddd3d$export$66ab21ef808e9dc6 = $825a2ddc199ddd3d$export$cab31ec27f6c5fa.span;
async function $825a2ddc199ddd3d$export$4f9234baf34abd0(connection, address, commitment, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $825a2ddc199ddd3d$export$776350edf20ed1cc(address, info, programId);
}
async function $825a2ddc199ddd3d$export$7ecda0587e867ff2(connection, addresses, commitment, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801)) {
    const infos = await connection.getMultipleAccountsInfo(addresses, commitment);
    return addresses.map((address, i)=>$825a2ddc199ddd3d$export$776350edf20ed1cc(address, infos[i], programId));
}
async function $825a2ddc199ddd3d$export$22f9b1d0cdd74bb0(connection, commitment) {
    return await $825a2ddc199ddd3d$export$e650be7f0aa49cb4(connection, [], commitment);
}
async function $825a2ddc199ddd3d$export$e650be7f0aa49cb4(connection, extensions, commitment) {
    const accountLen = (0, $82f2e1ad6ee0422c$export$37c8c863c6dd42a9)(extensions);
    return await connection.getMinimumBalanceForRentExemption(accountLen, commitment);
}
function $825a2ddc199ddd3d$export$776350edf20ed1cc(address, info, programId = (0, $354f0720d1023043$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $8b84caa63ed52a8d$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $8b84caa63ed52a8d$export$abb470453474d51)();
    if (info.data.length < $825a2ddc199ddd3d$export$66ab21ef808e9dc6) throw new (0, $8b84caa63ed52a8d$export$250d31de4ddb7ca5)();
    const rawAccount = $825a2ddc199ddd3d$export$cab31ec27f6c5fa.decode(info.data.slice(0, $825a2ddc199ddd3d$export$66ab21ef808e9dc6));
    let tlvData = $825a2ddc199ddd3d$require$Buffer.alloc(0);
    if (info.data.length > $825a2ddc199ddd3d$export$66ab21ef808e9dc6) {
        if (info.data.length === (0, $01f797b4826802f9$export$c2abf71f91a1605b)) throw new (0, $8b84caa63ed52a8d$export$250d31de4ddb7ca5)();
        if (info.data[$825a2ddc199ddd3d$export$66ab21ef808e9dc6] != (0, $02af554e3db3889f$export$b8ca5fa4899cbfc7).Account) throw new (0, $8b84caa63ed52a8d$export$f4938317c78e324f)();
        tlvData = info.data.slice($825a2ddc199ddd3d$export$66ab21ef808e9dc6 + (0, $02af554e3db3889f$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mint: rawAccount.mint,
        owner: rawAccount.owner,
        amount: rawAccount.amount,
        delegate: rawAccount.delegateOption ? rawAccount.delegate : null,
        delegatedAmount: rawAccount.delegatedAmount,
        isInitialized: rawAccount.state !== $825a2ddc199ddd3d$export$70504fba2ce56d52.Uninitialized,
        isFrozen: rawAccount.state === $825a2ddc199ddd3d$export$70504fba2ce56d52.Frozen,
        isNative: !!rawAccount.isNativeOption,
        rentExemptReserve: rawAccount.isNativeOption ? rawAccount.isNative : null,
        closeAuthority: rawAccount.closeAuthorityOption ? rawAccount.closeAuthority : null,
        tlvData: tlvData
    };
}


const $742e30bbeaf42a18$export$933741b57d878c01 = {
    version: "0.1.0",
    name: "soul_bound_authority",
    instructions: [
        {
            name: "createSbaUser",
            accounts: [
                {
                    name: "sba",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "authority",
                    isMut: false,
                    isSigner: true
                },
                {
                    name: "payer",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rent",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: []
        },
        {
            name: "acceptDelegate",
            accounts: [
                {
                    name: "sba",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authority",
                    isMut: false,
                    isSigner: true
                },
                {
                    name: "delegate",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: []
        },
        {
            name: "revokeDelegate",
            accounts: [
                {
                    name: "sba",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authority",
                    isMut: false,
                    isSigner: true
                }
            ],
            args: []
        },
        {
            name: "executeTxScopedUserNftProgram",
            accounts: [
                {
                    name: "sbaUser",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "nftToken",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "nftMint",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authority",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "delegate",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authorityOrDelegate",
                    isMut: false,
                    isSigner: true
                },
                {
                    name: "scopedAuthority",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "program",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "data",
                    type: "bytes"
                }
            ]
        }
    ],
    accounts: [
        {
            name: "soulBoundAuthorityUser",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "authority",
                        type: "publicKey"
                    },
                    {
                        name: "delegate",
                        type: "publicKey"
                    },
                    {
                        name: "bump",
                        type: "u8"
                    }
                ]
            }
        }
    ],
    errors: [
        {
            code: 6000,
            name: "Todo"
        }
    ]
};


const $054ad210da15c80d$export$933741b57d878c01 = {
    version: "2.2.1",
    name: "cardinal_stake_pool",
    instructions: [
        {
            name: "initIdentifier",
            accounts: [
                {
                    name: "identifier",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "payer",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: []
        },
        {
            name: "initPool",
            accounts: [
                {
                    name: "stakePool",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "identifier",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "authority",
                    isMut: false,
                    isSigner: true
                },
                {
                    name: "payer",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "ix",
                    type: {
                        defined: "InitPoolIx"
                    }
                }
            ]
        },
        {
            name: "stakeProgrammable",
            accounts: [
                {
                    name: "stakeEntry",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "rewardEntry",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "rewardDistributor",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "stakePool",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "originalMint",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "user",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "userOriginalMintTokenAccount",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "userOriginalMintTokenRecord",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "mintMetadata",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "mintEdition",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authorizationRules",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "sysvarInstructions",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "tokenMetadataProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authorizationRulesProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rewardDistributorProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "amount",
                    type: "u64"
                }
            ]
        },
        {
            name: "unstakeProgrammable",
            accounts: [
                {
                    name: "stakeEntry",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "stakePool",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "originalMint",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "user",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "userOriginalMintTokenAccount",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "userOriginalMintTokenRecord",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "mintMetadata",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "mintEdition",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authorizationRules",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "sysvarInstructions",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "tokenMetadataProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "authorizationRulesProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: []
        },
        {
            name: "updateTotalStakeSeconds",
            accounts: [
                {
                    name: "stakeEntry",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "lastStaker",
                    isMut: true,
                    isSigner: true
                }
            ],
            args: []
        }
    ],
    accounts: [
        {
            name: "groupStakeEntry",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "groupId",
                        type: "publicKey"
                    },
                    {
                        name: "authority",
                        type: "publicKey"
                    },
                    {
                        name: "stakeEntries",
                        type: {
                            vec: "publicKey"
                        }
                    },
                    {
                        name: "changedAt",
                        type: "i64"
                    },
                    {
                        name: "groupCooldownSeconds",
                        type: "u32"
                    },
                    {
                        name: "groupStakeSeconds",
                        type: "u32"
                    },
                    {
                        name: "groupCooldownStartSeconds",
                        type: {
                            option: "i64"
                        }
                    }
                ]
            }
        },
        {
            name: "stakeEntry",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "pool",
                        type: "publicKey"
                    },
                    {
                        name: "amount",
                        type: "u64"
                    },
                    {
                        name: "originalMint",
                        type: "publicKey"
                    },
                    {
                        name: "originalMintClaimed",
                        type: "bool"
                    },
                    {
                        name: "lastStaker",
                        type: "publicKey"
                    },
                    {
                        name: "lastStakedAt",
                        type: "i64"
                    },
                    {
                        name: "totalStakeSeconds",
                        type: "u128"
                    },
                    {
                        name: "stakeMintClaimed",
                        type: "bool"
                    },
                    {
                        name: "kind",
                        type: "u8"
                    },
                    {
                        name: "stakeMint",
                        type: {
                            option: "publicKey"
                        }
                    },
                    {
                        name: "cooldownStartSeconds",
                        type: {
                            option: "i64"
                        }
                    },
                    {
                        name: "lastUpdatedAt",
                        type: {
                            option: "i64"
                        }
                    },
                    {
                        name: "grouped",
                        type: {
                            option: "bool"
                        }
                    }
                ]
            }
        },
        {
            name: "stakePool",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "identifier",
                        type: "u64"
                    },
                    {
                        name: "authority",
                        type: "publicKey"
                    },
                    {
                        name: "requiresCreators",
                        type: {
                            vec: "publicKey"
                        }
                    },
                    {
                        name: "requiresCollections",
                        type: {
                            vec: "publicKey"
                        }
                    },
                    {
                        name: "requiresAuthorization",
                        type: "bool"
                    },
                    {
                        name: "overlayText",
                        type: "string"
                    },
                    {
                        name: "imageUri",
                        type: "string"
                    },
                    {
                        name: "resetOnStake",
                        type: "bool"
                    },
                    {
                        name: "totalStaked",
                        type: "u32"
                    },
                    {
                        name: "cooldownSeconds",
                        type: {
                            option: "u32"
                        }
                    },
                    {
                        name: "minStakeSeconds",
                        type: {
                            option: "u32"
                        }
                    },
                    {
                        name: "endDate",
                        type: {
                            option: "i64"
                        }
                    },
                    {
                        name: "doubleOrResetEnabled",
                        type: {
                            option: "bool"
                        }
                    }
                ]
            }
        },
        {
            name: "stakeBooster",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "stakePool",
                        type: "publicKey"
                    },
                    {
                        name: "identifier",
                        type: "u64"
                    },
                    {
                        name: "paymentAmount",
                        type: "u64"
                    },
                    {
                        name: "paymentMint",
                        type: "publicKey"
                    },
                    {
                        name: "paymentManager",
                        type: "publicKey"
                    },
                    {
                        name: "paymentRecipient",
                        type: "publicKey"
                    },
                    {
                        name: "boostSeconds",
                        type: "u128"
                    },
                    {
                        name: "startTimeSeconds",
                        type: "i64"
                    }
                ]
            }
        },
        {
            name: "stakeAuthorizationRecord",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "pool",
                        type: "publicKey"
                    },
                    {
                        name: "mint",
                        type: "publicKey"
                    }
                ]
            }
        },
        {
            name: "identifier",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "count",
                        type: "u64"
                    }
                ]
            }
        }
    ],
    types: [
        {
            name: "InitGroupEntryIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "groupId",
                        type: "publicKey"
                    },
                    {
                        name: "groupCooldownSeconds",
                        type: {
                            option: "u32"
                        }
                    },
                    {
                        name: "groupStakeSeconds",
                        type: {
                            option: "u32"
                        }
                    }
                ]
            }
        },
        {
            name: "InitPoolIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "overlayText",
                        type: "string"
                    },
                    {
                        name: "imageUri",
                        type: "string"
                    },
                    {
                        name: "requiresCollections",
                        type: {
                            vec: "publicKey"
                        }
                    },
                    {
                        name: "requiresCreators",
                        type: {
                            vec: "publicKey"
                        }
                    },
                    {
                        name: "requiresAuthorization",
                        type: "bool"
                    },
                    {
                        name: "authority",
                        type: "publicKey"
                    },
                    {
                        name: "resetOnStake",
                        type: "bool"
                    },
                    {
                        name: "cooldownSeconds",
                        type: {
                            option: "u32"
                        }
                    },
                    {
                        name: "minStakeSeconds",
                        type: {
                            option: "u32"
                        }
                    },
                    {
                        name: "endDate",
                        type: {
                            option: "i64"
                        }
                    },
                    {
                        name: "doubleOrResetEnabled",
                        type: {
                            option: "bool"
                        }
                    }
                ]
            }
        },
        {
            name: "InitStakeMintIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "name",
                        type: "string"
                    },
                    {
                        name: "symbol",
                        type: "string"
                    }
                ]
            }
        },
        {
            name: "ReassignStakeEntryIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "target",
                        type: "publicKey"
                    }
                ]
            }
        },
        {
            name: "BoostStakeEntryIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "secondsToBoost",
                        type: "u64"
                    }
                ]
            }
        },
        {
            name: "InitStakeBoosterIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "stakePool",
                        type: "publicKey"
                    },
                    {
                        name: "identifier",
                        type: "u64"
                    },
                    {
                        name: "paymentAmount",
                        type: "u64"
                    },
                    {
                        name: "paymentMint",
                        type: "publicKey"
                    },
                    {
                        name: "paymentManager",
                        type: "publicKey"
                    },
                    {
                        name: "boostSeconds",
                        type: "u128"
                    },
                    {
                        name: "startTimeSeconds",
                        type: "i64"
                    }
                ]
            }
        },
        {
            name: "UpdateStakeBoosterIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "paymentAmount",
                        type: "u64"
                    },
                    {
                        name: "paymentMint",
                        type: "publicKey"
                    },
                    {
                        name: "paymentManager",
                        type: "publicKey"
                    },
                    {
                        name: "boostSeconds",
                        type: "u128"
                    },
                    {
                        name: "startTimeSeconds",
                        type: "i64"
                    }
                ]
            }
        },
        {
            name: "UpdatePoolIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "imageUri",
                        type: {
                            option: "string"
                        }
                    },
                    {
                        name: "overlayText",
                        type: "string"
                    },
                    {
                        name: "requiresCollections",
                        type: {
                            vec: "publicKey"
                        }
                    },
                    {
                        name: "requiresCreators",
                        type: {
                            vec: "publicKey"
                        }
                    },
                    {
                        name: "requiresAuthorization",
                        type: "bool"
                    },
                    {
                        name: "authority",
                        type: "publicKey"
                    },
                    {
                        name: "resetOnStake",
                        type: "bool"
                    },
                    {
                        name: "cooldownSeconds",
                        type: {
                            option: "u32"
                        }
                    },
                    {
                        name: "minStakeSeconds",
                        type: {
                            option: "u32"
                        }
                    },
                    {
                        name: "endDate",
                        type: {
                            option: "i64"
                        }
                    },
                    {
                        name: "doubleOrResetEnabled",
                        type: {
                            option: "bool"
                        }
                    }
                ]
            }
        },
        {
            name: "StakeEntryKind",
            type: {
                kind: "enum",
                variants: [
                    {
                        name: "Permissionless"
                    },
                    {
                        name: "Permissioned"
                    }
                ]
            }
        }
    ],
    errors: [
        {
            code: 6000,
            name: "InvalidOriginalMint",
            msg: "Original mint is invalid"
        },
        {
            code: 6001,
            name: "InvalidTokenManagerMint",
            msg: "Token Manager mint is invalid"
        },
        {
            code: 6002,
            name: "InvalidUserOriginalMintTokenAccount",
            msg: "Invalid user original mint token account"
        },
        {
            code: 6003,
            name: "InvalidUserMintTokenAccount",
            msg: "Invalid user token manager mint account"
        },
        {
            code: 6004,
            name: "InvalidStakeEntryOriginalMintTokenAccount",
            msg: "Invalid stake entry original mint token account"
        },
        {
            code: 6005,
            name: "InvalidStakeEntryMintTokenAccount",
            msg: "Invalid stake entry token manager mint token account"
        },
        {
            code: 6006,
            name: "InvalidUnstakeUser",
            msg: "Invalid unstake user only last staker can unstake"
        },
        {
            code: 6007,
            name: "InvalidStakePool",
            msg: "Invalid stake pool"
        },
        {
            code: 6008,
            name: "NoMintMetadata",
            msg: "No mint metadata"
        },
        {
            code: 6009,
            name: "MintNotAllowedInPool",
            msg: "Mint not allowed in this pool"
        },
        {
            code: 6010,
            name: "InvalidPoolAuthority",
            msg: "Invalid stake pool authority"
        },
        {
            code: 6011,
            name: "InvalidStakeType",
            msg: "Invalid stake type"
        },
        {
            code: 6012,
            name: "InvalidStakeEntryStakeTokenAccount",
            msg: "Invalid stake entry stake token account"
        },
        {
            code: 6013,
            name: "InvalidLastStaker",
            msg: "Invalid last staker"
        },
        {
            code: 6014,
            name: "InvalidTokenManagerProgram",
            msg: "Invalid token manager program"
        },
        {
            code: 6015,
            name: "InvalidReceiptMint",
            msg: "Invalid receipt mint"
        },
        {
            code: 6016,
            name: "StakeEntryAlreadyStaked",
            msg: "Stake entry already has tokens staked"
        },
        {
            code: 6017,
            name: "InvalidAuthority",
            msg: "Invalid authority"
        },
        {
            code: 6018,
            name: "CannotCloseStakedEntry",
            msg: "Cannot close staked entry"
        },
        {
            code: 6019,
            name: "CannotClosePoolWithStakedEntries",
            msg: "Cannot close staked entry"
        },
        {
            code: 6020,
            name: "CooldownSecondRemaining",
            msg: "Token still has some cooldown seconds remaining"
        },
        {
            code: 6021,
            name: "MinStakeSecondsNotSatisfied",
            msg: "Minimum stake seconds not satisfied"
        },
        {
            code: 6022,
            name: "InvalidStakeAuthorizationRecord",
            msg: "Invalid stake authorization provided"
        },
        {
            code: 6023,
            name: "InvalidMintMetadata",
            msg: "Invalid mint metadata"
        },
        {
            code: 6024,
            name: "StakePoolHasEnded",
            msg: "Stake pool has ended"
        },
        {
            code: 6025,
            name: "InvalidMintMetadataOwner",
            msg: "Mint metadata is owned by the incorrect program"
        },
        {
            code: 6026,
            name: "StakeMintAlreadyInitialized",
            msg: "Stake mint already intialized"
        },
        {
            code: 6027,
            name: "InvalidStakeEntry",
            msg: "Invalid stake entry"
        },
        {
            code: 6028,
            name: "CannotUpdateUnstakedEntry",
            msg: "Cannot update unstaked entry"
        },
        {
            code: 6100,
            name: "CannotBoostUnstakedToken",
            msg: "Cannot boost unstaked token"
        },
        {
            code: 6101,
            name: "CannotBoostMoreThanCurrentTime",
            msg: "Cannot boost past current time less than start time"
        },
        {
            code: 6102,
            name: "InvalidBoostPayerTokenAccount",
            msg: "Invalid boost payer token account"
        },
        {
            code: 6103,
            name: "InvalidBoostPaymentRecipientTokenAccount",
            msg: "Invalid boost payment recipient token account"
        },
        {
            code: 6104,
            name: "InvalidPaymentManager",
            msg: "Invalid payment manager"
        },
        {
            code: 6105,
            name: "CannotBoostFungibleToken",
            msg: "Cannot boost a fungible token stake entry"
        },
        {
            code: 6120,
            name: "GroupedStakeEntry",
            msg: "Grouped stake entry"
        },
        {
            code: 6121,
            name: "UngroupedStakeEntry",
            msg: "Ungrouped stake entry"
        },
        {
            code: 6122,
            name: "MinGroupSecondsNotSatisfied",
            msg: "Minimum group seconds not satisfied"
        },
        {
            code: 6123,
            name: "ActiveGroupEntry",
            msg: "Active group entry"
        },
        {
            code: 6124,
            name: "StakeEntryNotFoundInGroup",
            msg: "Stake entry not found in group"
        },
        {
            code: 6130,
            name: "InvalidFundsMint",
            msg: "Invalid funds mint"
        },
        {
            code: 6131,
            name: "InvalidMintForTokenAccount",
            msg: "Invalid mint for token account"
        },
        {
            code: 6132,
            name: "StakeEntryFundsTokenAccountEmpty",
            msg: "Stake entry funds token account is empty"
        }
    ]
};


const $8be15bba9512ab71$export$933741b57d878c01 = {
    version: "2.2.1",
    name: "cardinal_reward_distributor",
    instructions: [
        {
            name: "initRewardDistributor",
            accounts: [
                {
                    name: "rewardDistributor",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "stakePool",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rewardMint",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "authority",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "payer",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "ix",
                    type: {
                        defined: "InitRewardDistributorIx"
                    }
                }
            ]
        },
        {
            name: "initRewardEntry",
            accounts: [
                {
                    name: "rewardEntry",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "stakeEntry",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rewardDistributor",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "payer",
                    isMut: true,
                    isSigner: true
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: []
        },
        {
            name: "claimRewards",
            accounts: [
                {
                    name: "rewardEntry",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "rewardDistributor",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "stakeEntry",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "stakePool",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "originalMint",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rewardMint",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "userRewardMintTokenAccount",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "authority",
                    isMut: false,
                    isSigner: true
                },
                {
                    name: "user",
                    isMut: true,
                    isSigner: false,
                    docs: [
                        "is a function of the mint and the last staker, and the last",
                        "staker is indeed this user."
                    ]
                },
                {
                    name: "associatedTokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rent",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: []
        },
        {
            name: "transferRewards",
            accounts: [
                {
                    name: "rewardEntryA",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "rewardEntryB",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "rewardDistributor",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "stakeEntryA",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "stakeEntryB",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "stakePool",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "originalMintA",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "originalMintB",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rewardMint",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "userRewardMintTokenAccountA",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "userRewardMintTokenAccountB",
                    isMut: true,
                    isSigner: false
                },
                {
                    name: "authorityA",
                    isMut: false,
                    isSigner: true
                },
                {
                    name: "authorityB",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "user",
                    isMut: true,
                    isSigner: false,
                    docs: [
                        "is a function of the mint and the last staker, and the last",
                        "staker is indeed this user."
                    ]
                },
                {
                    name: "associatedTokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false
                },
                {
                    name: "rent",
                    isMut: false,
                    isSigner: false
                }
            ],
            args: [
                {
                    name: "amount",
                    type: {
                        option: "u64"
                    }
                }
            ]
        }
    ],
    accounts: [
        {
            name: "rewardEntry",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "stakeEntry",
                        type: "publicKey"
                    },
                    {
                        name: "rewardDistributor",
                        type: "publicKey"
                    },
                    {
                        name: "rewardSecondsReceived",
                        type: "u128"
                    },
                    {
                        name: "multiplier",
                        type: "u64"
                    }
                ]
            }
        },
        {
            name: "rewardDistributor",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8"
                    },
                    {
                        name: "stakePool",
                        type: "publicKey"
                    },
                    {
                        name: "kind",
                        type: "u8"
                    },
                    {
                        name: "authority",
                        type: "publicKey"
                    },
                    {
                        name: "rewardMint",
                        type: "publicKey"
                    },
                    {
                        name: "rewardAmount",
                        type: "u64"
                    },
                    {
                        name: "rewardDurationSeconds",
                        type: "u128"
                    },
                    {
                        name: "rewardsIssued",
                        type: "u128"
                    },
                    {
                        name: "maxSupply",
                        type: {
                            option: "u64"
                        }
                    },
                    {
                        name: "defaultMultiplier",
                        type: "u64"
                    },
                    {
                        name: "multiplierDecimals",
                        type: "u8"
                    },
                    {
                        name: "maxRewardSecondsReceived",
                        type: {
                            option: "u128"
                        }
                    }
                ]
            }
        }
    ],
    types: [
        {
            name: "InitRewardDistributorIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "rewardAmount",
                        type: "u64"
                    },
                    {
                        name: "rewardDurationSeconds",
                        type: "u128"
                    },
                    {
                        name: "kind",
                        type: "u8"
                    },
                    {
                        name: "supply",
                        type: {
                            option: "u64"
                        }
                    },
                    {
                        name: "maxSupply",
                        type: {
                            option: "u64"
                        }
                    },
                    {
                        name: "defaultMultiplier",
                        type: {
                            option: "u64"
                        }
                    },
                    {
                        name: "multiplierDecimals",
                        type: {
                            option: "u8"
                        }
                    },
                    {
                        name: "maxRewardSecondsReceived",
                        type: {
                            option: "u128"
                        }
                    }
                ]
            }
        },
        {
            name: "UpdateRewardDistributorIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "defaultMultiplier",
                        type: "u64"
                    },
                    {
                        name: "multiplierDecimals",
                        type: "u8"
                    },
                    {
                        name: "rewardAmount",
                        type: "u64"
                    },
                    {
                        name: "rewardDurationSeconds",
                        type: "u128"
                    },
                    {
                        name: "maxRewardSecondsReceived",
                        type: {
                            option: "u128"
                        }
                    }
                ]
            }
        },
        {
            name: "UpdateRewardEntryIx",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "multiplier",
                        type: "u64"
                    }
                ]
            }
        },
        {
            name: "RewardDistributorKind",
            type: {
                kind: "enum",
                variants: [
                    {
                        name: "Mint"
                    },
                    {
                        name: "Treasury"
                    }
                ]
            }
        }
    ],
    errors: [
        {
            code: 6000,
            name: "InvalidTokenAccount",
            msg: "Invalid token account"
        },
        {
            code: 6001,
            name: "InvalidRewardMint",
            msg: "Invalid reward mint"
        },
        {
            code: 6002,
            name: "InvalidUserRewardMintTokenAccount",
            msg: "Invalid user reward mint token account"
        },
        {
            code: 6003,
            name: "InvalidRewardDistributor",
            msg: "Invalid reward distributor"
        },
        {
            code: 6004,
            name: "InvalidRewardDistributorAuthority",
            msg: "Invalid reward distributor authority"
        },
        {
            code: 6005,
            name: "InvalidRewardDistributorKind",
            msg: "Invalid reward distributor kind"
        },
        {
            code: 6006,
            name: "SupplyRequired",
            msg: "Initial supply required for kind treasury"
        },
        {
            code: 6007,
            name: "InvalidAuthority",
            msg: "Invalid authority"
        },
        {
            code: 6008,
            name: "InvalidPoolDistributor",
            msg: "Invalid distributor for pool"
        },
        {
            code: 6009,
            name: "DistributorNotClosed",
            msg: "Distributor is already open"
        },
        {
            code: 6010,
            name: "DistributorAlreadyClosed",
            msg: "Distributor is already closed"
        },
        {
            code: 6011,
            name: "InvalidStakeEntry",
            msg: "Invalid stake entry"
        },
        {
            code: 6012,
            name: "InvalidRewardEntry",
            msg: "Invalid reward entry"
        },
        {
            code: 6013,
            name: "InvalidRewardDistributorTokenAccount",
            msg: "Invalid reward distributor token account"
        },
        {
            code: 6014,
            name: "InvalidAuthorityTokenAccount",
            msg: "Invalid authority token account"
        },
        {
            code: 6015,
            name: "InvalidPayer",
            msg: "Invalid payer"
        },
        {
            code: 6016,
            name: "MaxRewardSecondsClaimed",
            msg: "Max reward seconds claimed"
        },
        {
            code: 6017,
            name: "InvalidRewardTokenOwner",
            msg: "Invalid reward token account owner"
        },
        {
            code: 6018,
            name: "InvalidSelfTransfer",
            msg: "Invalid self transfer"
        },
        {
            code: 6019,
            name: "NotEnoughRewardTokens",
            msg: "Not enough reward tokens"
        },
        {
            code: 6020,
            name: "InvalidInstruction",
            msg: "Invalid instruction"
        }
    ]
};



var $cbQCu = parcelRequire("cbQCu");
var $71cd754ccc718f4f$require$Buffer = $cbQCu.Buffer;
const $71cd754ccc718f4f$var$BN = (/*@__PURE__*/$parcel$interopDefault($cj5EG));
function $71cd754ccc718f4f$export$f2f7e48d401dedc8(PROVIDER) {
    //
    // Mainnet stake constants.
    //
    const STAKE_POOL = new (0, $1biTx.PublicKey)("7xmGGtuNNvjKLDwbYWBYGPpAjRqftJnrTyzSRK92yku8");
    //const STAKE_POOL_IDENTIFIER = new PublicKey(
    //"E43L3VCJcDqN4pPhhPBiQjSr5A9cBJreTdMDVhWxXVCZ"
    //);
    const REWARD_DISTRIBUTOR = new (0, $1biTx.PublicKey)("6DBnpqRm1szSz25dD1aWEmYzgGoMB59Y1GMv2gtWUSM4");
    const GOLD_MINT = new (0, $1biTx.PublicKey)("5QPAPkBvd2B7RQ6DBGvCxGdAcyWitdvRAP58CdvBiuf7");
    //
    // Program ids.
    //
    const SOUL_BOUND_PROGRAM_ID = new (0, $1biTx.PublicKey)("7DkjPwuKxvz6Viiawtbmb4CqnMKP6eGb1WqYas1airUS");
    const CARDINAL_REWARD_DISTRIBUTOR_PROGRAM_ID = new (0, $1biTx.PublicKey)("H2yQahQ7eQH8HXXPtJSJn8MURRFEWVesTd8PsracXp1S");
    const CARDINAL_STAKE_POOL_PROGRAM_ID = new (0, $1biTx.PublicKey)("2gvBmibwtBnbkLExmgsijKy6hGXJneou8X6hkyWQvYnF");
    const TOKEN_METADATA_PROGRAM_ID = new (0, $1biTx.PublicKey)("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
    //
    // Misc program constants.
    //
    const AUTHORIZATION_RULES_PROGRAM_ID = new (0, $1biTx.PublicKey)("auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg");
    const AUTHORIZATION_RULES = new (0, $1biTx.PublicKey)("eBJLFYPxJmMGKuFwpDWkzxZeUrad92kZRC5BJLpzyT9");
    //
    // Stake program clients.
    //
    const SOUL_BOUND_PROGRAM = new (0, $26e0f71442fe06b5$export$b6c59b989905b650)((0, $742e30bbeaf42a18$export$933741b57d878c01), SOUL_BOUND_PROGRAM_ID, PROVIDER);
    const REWARD_DISTRIBUTOR_PROGRAM = new (0, $26e0f71442fe06b5$export$b6c59b989905b650)((0, $8be15bba9512ab71$export$933741b57d878c01), CARDINAL_REWARD_DISTRIBUTOR_PROGRAM_ID, PROVIDER);
    const STAKE_POOL_PROGRAM = new (0, $26e0f71442fe06b5$export$b6c59b989905b650)((0, $054ad210da15c80d$export$933741b57d878c01), CARDINAL_STAKE_POOL_PROGRAM_ID, PROVIDER);
    async function stake({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM }) {
        const tx = new (0, $1biTx.Transaction)();
        tx.add((0, $1biTx.ComputeBudgetProgram).setComputeUnitLimit({
            units: 1000000
        }));
        tx.add(await stakeInstruction({
            user: user,
            nft: nft,
            stakePool: stakePool,
            rewardDistributor: rewardDistributor,
            stakePoolProgram: stakePoolProgram,
            rewardDistributorProgram: rewardDistributorProgram
        }));
        // @ts-ignore
        return tx;
    }
    async function stakeInstruction({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM }) {
        const stakeEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("stake-entry"),
            stakePool.toBuffer(),
            nft.mintAddress.toBuffer(),
            getStakeSeed(1, user).toBuffer()
        ], stakePoolProgram.programId)[0];
        const rewardEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("reward-entry"),
            rewardDistributor.toBuffer(),
            stakeEntry.toBuffer()
        ], rewardDistributorProgram.programId)[0];
        const ata = await $26e0f71442fe06b5$export$eab97d15b1788b8d.token.associatedAddress({
            mint: nft.mintAddress,
            owner: user
        });
        const tokenRecord = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("metadata"),
            TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            nft.mintAddress.toBuffer(),
            $71cd754ccc718f4f$require$Buffer.from("token_record"),
            ata.toBuffer()
        ], TOKEN_METADATA_PROGRAM_ID)[0];
        const masterEditionAddress = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("metadata"),
            TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            nft.mintAddress.toBuffer(),
            $71cd754ccc718f4f$require$Buffer.from("edition")
        ], TOKEN_METADATA_PROGRAM_ID)[0];
        return await stakePoolProgram.methods.stakeProgrammable(new $71cd754ccc718f4f$var$BN(1)).accounts({
            stakeEntry: stakeEntry,
            rewardEntry: rewardEntry,
            rewardDistributor: rewardDistributor,
            stakePool: stakePool,
            originalMint: nft.mintAddress,
            user: user,
            userOriginalMintTokenAccount: ata,
            userOriginalMintTokenRecord: tokenRecord,
            mintMetadata: nft.metadataAddress,
            mintEdition: masterEditionAddress,
            authorizationRules: AUTHORIZATION_RULES,
            sysvarInstructions: (0, $1biTx.SYSVAR_INSTRUCTIONS_PUBKEY),
            tokenProgram: (0, $354f0720d1023043$export$79de3e3c2b1ca801),
            tokenMetadataProgram: TOKEN_METADATA_PROGRAM_ID,
            authorizationRulesProgram: AUTHORIZATION_RULES_PROGRAM_ID,
            rewardDistributorProgram: rewardDistributorProgram.programId,
            systemProgram: (0, $1biTx.SystemProgram).programId
        }).instruction();
    }
    async function unstake({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, options: options }) {
        const tx = new (0, $1biTx.Transaction)();
        tx.add(...await claimAndUnstakeInstructions({
            user: user,
            nft: nft,
            stakePool: stakePool,
            stakePoolProgram: stakePoolProgram
        }));
        // @ts-ignore
        return tx;
    }
    async function claimAndUnstakeInstructions({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM }) {
        const ixs = await claimRewardInstruction({
            user: user,
            nft: nft
        });
        ixs.push(await unstakeInstruction({
            user: user,
            nft: nft,
            stakePool: stakePool,
            stakePoolProgram: stakePoolProgram
        }));
        return ixs;
    }
    async function unstakeInstruction({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM }) {
        const stakeEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("stake-entry"),
            stakePool.toBuffer(),
            nft.mintAddress.toBuffer(),
            getStakeSeed(1, user).toBuffer()
        ], stakePoolProgram.programId)[0];
        const ata = await $26e0f71442fe06b5$export$eab97d15b1788b8d.token.associatedAddress({
            mint: nft.mintAddress,
            owner: user
        });
        const tokenRecord = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("metadata"),
            TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            nft.mintAddress.toBuffer(),
            $71cd754ccc718f4f$require$Buffer.from("token_record"),
            ata.toBuffer()
        ], TOKEN_METADATA_PROGRAM_ID)[0];
        const masterEditionAddress = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("metadata"),
            TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            nft.mintAddress.toBuffer(),
            $71cd754ccc718f4f$require$Buffer.from("edition")
        ], TOKEN_METADATA_PROGRAM_ID)[0];
        return await stakePoolProgram.methods.unstakeProgrammable().accounts({
            stakeEntry: stakeEntry,
            stakePool: stakePool,
            originalMint: nft.mintAddress,
            user: user,
            userOriginalMintTokenAccount: ata,
            userOriginalMintTokenRecord: tokenRecord,
            mintMetadata: nft.metadataAddress,
            mintEdition: masterEditionAddress,
            authorizationRules: AUTHORIZATION_RULES,
            sysvarInstructions: (0, $1biTx.SYSVAR_INSTRUCTIONS_PUBKEY),
            tokenProgram: (0, $354f0720d1023043$export$79de3e3c2b1ca801),
            tokenMetadataProgram: TOKEN_METADATA_PROGRAM_ID,
            authorizationRulesProgram: AUTHORIZATION_RULES_PROGRAM_ID,
            systemProgram: (0, $1biTx.SystemProgram).programId
        }).instruction();
    }
    async function isStaked({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM }) {
        try {
            const stakeEntry = await fetchStakeEntry({
                user: user,
                nft: nft,
                stakePool: stakePool,
                stakePoolProgram: stakePoolProgram
            });
            return stakeEntry.lastStaker.equals(user);
        } catch (err) {
            // If throws, then the account probably doesn't exist.
            console.log(err);
            return false;
        }
    }
    const fetchStakeEntry = async ({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM })=>{
        const stakeEntry = await stakeEntryAddress({
            user: user,
            nft: nft,
            stakePool: stakePool,
            stakePoolProgram: stakePoolProgram
        });
        return await stakePoolProgram.account.stakeEntry.fetch(stakeEntry);
    };
    const stakeEntryAddress = async ({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM })=>{
        const stakeEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("stake-entry"),
            stakePool.toBuffer(),
            nft.mintAddress.toBuffer(),
            getStakeSeed(1, user).toBuffer()
        ], stakePoolProgram.programId)[0];
        return stakeEntry;
    };
    const readStakeEntryAddress = async ({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM })=>{
        const stakeEntry = await stakeEntryAddress({
            user: user,
            nft: nft,
            stakePool: stakePool,
            stakePoolProgram: stakePoolProgram
        });
        const stakeEntryAccount = await stakePoolProgram.account.stakeEntry.fetch(stakeEntry);
        stakeEntryAccount.lastStaker;
        stakeEntryAccount.originalMint;
        return stakeEntryAccount;
    };
    const fetchRewardEntry = async ({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM })=>{
        const stakeEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("stake-entry"),
            stakePool.toBuffer(),
            nft.mintAddress.toBuffer(),
            getStakeSeed(1, user).toBuffer()
        ], stakePoolProgram.programId)[0];
        const rewardEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("reward-entry"),
            rewardDistributor.toBuffer(),
            stakeEntry.toBuffer()
        ], rewardDistributorProgram.programId)[0];
        const rewardEntryAccount = await rewardDistributorProgram.account.rewardEntry.fetch(rewardEntry);
        return rewardEntryAccount;
    };
    const rewardEntryAddress = async ({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM })=>{
        const stakeEntry = await stakeEntryAddress({
            user: user,
            nft: nft,
            stakePool: stakePool,
            stakePoolProgram: stakePoolProgram
        });
        const rewardEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("reward-entry"),
            rewardDistributor.toBuffer(),
            stakeEntry.toBuffer()
        ], rewardDistributorProgram.programId)[0];
        return rewardEntry;
    };
    async function claimRewardInstruction({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, goldMint: goldMint = GOLD_MINT, soulboundProgram: soulboundProgram = SOUL_BOUND_PROGRAM, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM }) {
        const [sbaUser] = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("sba-scoped-user"),
            user.toBuffer()
        ], soulboundProgram.programId);
        const scopedSbaUserAuthority = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("sba-scoped-user-nft-program"),
            user.toBuffer(),
            nft.mintAddress.toBuffer(),
            rewardDistributorProgram.programId.toBuffer()
        ], soulboundProgram.programId)[0];
        const stakeEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("stake-entry"),
            stakePool.toBuffer(),
            nft.mintAddress.toBuffer(),
            getStakeSeed(1, user).toBuffer()
        ], stakePoolProgram.programId)[0];
        const rewardEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("reward-entry"),
            rewardDistributor.toBuffer(),
            stakeEntry.toBuffer()
        ], rewardDistributorProgram.programId)[0];
        const userRewardMintTokenAccount = await (0, $5046bae03150daad$export$d776e5c4182d21cc)(goldMint, scopedSbaUserAuthority, true);
        let { data: data, keys: keys } = await rewardDistributorProgram.methods.claimRewards().accounts({
            rewardEntry: rewardEntry,
            rewardDistributor: rewardDistributor,
            stakeEntry: stakeEntry,
            stakePool: stakePool,
            originalMint: nft.mintAddress,
            rewardMint: goldMint,
            userRewardMintTokenAccount: userRewardMintTokenAccount,
            authority: scopedSbaUserAuthority,
            user: user
        }).instruction();
        // Need to set the signer on the PDA to false so that we can serialize
        // the transaction without error. The CPI in the program will flip this
        // back to true before signging with PDA seeds.
        keys = keys.map((k)=>{
            return {
                ...k,
                isSigner: k.pubkey.equals(scopedSbaUserAuthority) ? false : k.isSigner
            };
        });
        const nftToken = await (0, $5046bae03150daad$export$d776e5c4182d21cc)(nft.mintAddress, user);
        //
        // If this is the first time using the soulbound program, then we need
        // to initialize the user account.
        //
        const soulboundInitInstructions = await (async ()=>{
            // If the soul bound authority user is already created, do nothing.
            if (await isSoulBoundAuthorityUserInitialized(user, soulboundProgram)) return [];
            else {
                __cached = null; // Wipe cache.
                return [
                    await soulboundProgram.methods.createSbaUser().accounts({
                        sba: sbaUser,
                        authority: user,
                        payer: user
                    }).instruction()
                ];
            }
        })();
        const claimIx = await soulboundProgram.methods.executeTxScopedUserNftProgram(data).accounts({
            sbaUser: sbaUser,
            nftToken: nftToken,
            nftMint: nft.mintAddress,
            authority: user,
            delegate: (0, $1biTx.PublicKey).default,
            authorityOrDelegate: user,
            scopedAuthority: scopedSbaUserAuthority,
            program: rewardDistributorProgram.programId
        }).remainingAccounts(keys).instruction();
        const updateIx = await stakePoolProgram.methods.updateTotalStakeSeconds().accounts({
            stakeEntry: stakeEntry,
            lastStaker: user
        }).instruction();
        return soulboundInitInstructions.concat([
            updateIx,
            claimIx
        ]);
    }
    // Should invoke this method on load to slightly speed things up.
    //
    // Note this account can only be created; it can't be removed.
    let __cached = null;
    async function isSoulBoundAuthorityUserInitialized(user, soulboundProgram = SOUL_BOUND_PROGRAM) {
        const [sbaUser] = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("sba-scoped-user"),
            user.toBuffer()
        ], soulboundProgram.programId);
        if (__cached !== null) return __cached;
        try {
            await soulboundProgram.account.soulBoundAuthorityUser.fetch(sbaUser);
            __cached = true;
            return true;
        } catch  {
            __cached = false;
            return false;
        }
    }
    async function readGoldPoints({ user: user, nft: nft, goldMint: goldMint = GOLD_MINT, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, soulboundProgram: soulboundProgram = SOUL_BOUND_PROGRAM, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM, accounts: accounts }) {
        const unclaimed = await (async ()=>{
            try {
                return await readUnclaimedGoldPoints({
                    user: user,
                    nft: nft,
                    stakePool: stakePool,
                    rewardDistributor: rewardDistributor,
                    stakePoolProgram: stakePoolProgram,
                    rewardDistributorProgram: rewardDistributorProgram,
                    accounts: accounts
                });
            } catch  {
                return new $71cd754ccc718f4f$var$BN(0);
            }
        })();
        const claimed = await (async ()=>{
            try {
                return await readClaimedGoldPoints({
                    user: user,
                    nft: nft,
                    goldMint: goldMint,
                    soulboundProgram: soulboundProgram,
                    rewardDistributorProgram: rewardDistributorProgram,
                    accounts: accounts
                });
            } catch  {
                return new $71cd754ccc718f4f$var$BN(0);
            }
        })();
        const native = unclaimed.add(claimed);
        const decimals = 0;
        return native.toNumber() / 10 ** decimals;
    }
    // Unclaimed gold points are calculated client side.
    //
    // Rant: Would be nice if the contract just had a view function so that
    //       we don't have to redo this logic in typescript land, but such is life.
    async function readUnclaimedGoldPoints({ user: user, nft: nft, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM, accounts: accounts }) {
        const stakeEntryAcc = accounts ? accounts.stakeEntry : await fetchStakeEntry({
            user: user,
            nft: nft,
            stakePool: stakePool,
            stakePoolProgram: stakePoolProgram
        });
        const rewardEntryAcc = accounts ? accounts.rewardEntry : await fetchRewardEntry({
            user: user,
            nft: nft,
            stakePool: stakePool,
            rewardDistributor: rewardDistributor,
            stakePoolProgram: stakePoolProgram,
            rewardDistributorProgram: rewardDistributorProgram
        });
        // This means the staker unstaked.
        if (stakeEntryAcc.lastStaker.equals((0, $1biTx.PublicKey).default)) return new $71cd754ccc718f4f$var$BN(0);
        if (stakeEntryAcc.amount.eq(new $71cd754ccc718f4f$var$BN(0))) return new $71cd754ccc718f4f$var$BN(0);
        const totalStakeSeconds = stakeEntryAcc.totalStakeSeconds.add(stakeEntryAcc.amount.eq(new $71cd754ccc718f4f$var$BN(0)) ? new $71cd754ccc718f4f$var$BN(0) : new $71cd754ccc718f4f$var$BN(Date.now() / 1000).sub(stakeEntryAcc.lastUpdatedAt));
        const rewardSecondsReceived = rewardEntryAcc.rewardSecondsReceived;
        const rewardDistributorAcc = accounts ? accounts.rewardDistributor : await rewardDistributorProgram.account.rewardDistributor.fetch(rewardDistributor);
        const rewardAmountToReceive = totalStakeSeconds.sub(rewardSecondsReceived).div(rewardDistributorAcc.rewardDurationSeconds).mul(rewardDistributorAcc.rewardAmount).mul(new $71cd754ccc718f4f$var$BN(1)).div(new $71cd754ccc718f4f$var$BN(10).pow(new $71cd754ccc718f4f$var$BN(rewardDistributorAcc.multiplierDecimals)));
        return rewardAmountToReceive;
    }
    // Points swept into the soulbound token account. These are soulbound to the
    // user and nft (combinatino) and automatically swept during unstaking.
    async function readClaimedGoldPoints({ user: user, nft: nft, goldMint: goldMint = GOLD_MINT, soulboundProgram: soulboundProgram = SOUL_BOUND_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM, accounts: accounts }) {
        const userRewardMintTokenAccount = await goldPointsAddress({
            user: user,
            nft: nft,
            goldMint: goldMint,
            soulboundProgram: soulboundProgram,
            rewardDistributorProgram: rewardDistributorProgram
        });
        const claimedAmount = await (async ()=>{
            try {
                const rewardTokenAccount = accounts ? accounts.goldTokenAccount : await (0, $825a2ddc199ddd3d$export$4f9234baf34abd0)(soulboundProgram.provider.connection, userRewardMintTokenAccount);
                return new $71cd754ccc718f4f$var$BN(rewardTokenAccount.amount.toString());
            } catch  {
                return new $71cd754ccc718f4f$var$BN(0);
            }
        })();
        return claimedAmount;
    }
    async function goldPointsAddress({ user: user, nft: nft, goldMint: goldMint = GOLD_MINT, soulboundProgram: soulboundProgram = SOUL_BOUND_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM }) {
        const scopedSbaUserAuthority = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("sba-scoped-user-nft-program"),
            user.toBuffer(),
            nft.mintAddress.toBuffer(),
            rewardDistributorProgram.programId.toBuffer()
        ], soulboundProgram.programId)[0];
        const userRewardMintTokenAccount = await (0, $5046bae03150daad$export$d776e5c4182d21cc)(goldMint, scopedSbaUserAuthority, true);
        return userRewardMintTokenAccount;
    }
    async function transferRewards({ amount: amount, fromUser: fromUser, fromNft: fromNft, toNft: toNft, goldMint: goldMint = GOLD_MINT, stakePool: stakePool = STAKE_POOL, rewardDistributor: rewardDistributor = REWARD_DISTRIBUTOR, soulboundProgram: soulboundProgram = SOUL_BOUND_PROGRAM, stakePoolProgram: stakePoolProgram = STAKE_POOL_PROGRAM, rewardDistributorProgram: rewardDistributorProgram = REWARD_DISTRIBUTOR_PROGRAM }) {
        const toUser = fromUser; // Transfers only allowed between same wallet.
        const [fromSbaUser] = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("sba-scoped-user"),
            fromUser.toBuffer()
        ], soulboundProgram.programId);
        const fromScopedSbaUserAuthority = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("sba-scoped-user-nft-program"),
            fromUser.toBuffer(),
            fromNft.mintAddress.toBuffer(),
            rewardDistributorProgram.programId.toBuffer()
        ], soulboundProgram.programId)[0];
        const fromStakeEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("stake-entry"),
            stakePool.toBuffer(),
            fromNft.mintAddress.toBuffer(),
            getStakeSeed(1, fromUser).toBuffer()
        ], stakePoolProgram.programId)[0];
        const fromRewardEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("reward-entry"),
            rewardDistributor.toBuffer(),
            fromStakeEntry.toBuffer()
        ], rewardDistributorProgram.programId)[0];
        const fromScopedSbaUserAuthorityAta = await (0, $5046bae03150daad$export$d776e5c4182d21cc)(goldMint, fromScopedSbaUserAuthority, true);
        const toScopedSbaUserAuthority = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("sba-scoped-user-nft-program"),
            toUser.toBuffer(),
            toNft.mintAddress.toBuffer(),
            rewardDistributorProgram.programId.toBuffer()
        ], soulboundProgram.programId)[0];
        const toStakeEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("stake-entry"),
            stakePool.toBuffer(),
            toNft.mintAddress.toBuffer(),
            getStakeSeed(1, toUser).toBuffer()
        ], stakePoolProgram.programId)[0];
        const toRewardEntry = (0, $1biTx.PublicKey).findProgramAddressSync([
            $71cd754ccc718f4f$require$Buffer.from("reward-entry"),
            rewardDistributor.toBuffer(),
            toStakeEntry.toBuffer()
        ], rewardDistributorProgram.programId)[0];
        const toScopedSbaUserAuthorityAta = await (0, $5046bae03150daad$export$d776e5c4182d21cc)(goldMint, toScopedSbaUserAuthority, true);
        const fromNftToken = await (0, $5046bae03150daad$export$d776e5c4182d21cc)(fromNft.mintAddress, fromUser);
        let { data: data, keys: keys } = await rewardDistributorProgram.methods.transferRewards(amount ?? null).accounts({
            rewardEntryA: fromRewardEntry,
            rewardEntryB: toRewardEntry,
            stakeEntryA: fromStakeEntry,
            stakeEntryB: toStakeEntry,
            rewardDistributor: rewardDistributor,
            stakePool: stakePool,
            originalMintA: fromNft.mintAddress,
            originalMintB: toNft.mintAddress,
            rewardMint: goldMint,
            user: fromUser,
            userRewardMintTokenAccountA: fromScopedSbaUserAuthorityAta,
            userRewardMintTokenAccountB: toScopedSbaUserAuthorityAta,
            authorityA: fromScopedSbaUserAuthority,
            authorityB: toScopedSbaUserAuthority
        }).instruction();
        // Need to set the signer on the PDA to false so that we can serialize
        // the transaction without error. The CPI in the program will flip this
        // back to true before signging with PDA seeds.
        keys = keys.map((k)=>{
            return {
                ...k,
                isSigner: k.pubkey.equals(fromScopedSbaUserAuthority) ? false : k.isSigner
            };
        });
        const claimIxs = await claimRewardInstruction({
            user: fromUser,
            nft: fromNft
        });
        const tx = await soulboundProgram.methods.executeTxScopedUserNftProgram(data).accounts({
            sbaUser: fromSbaUser,
            nftToken: fromNftToken,
            nftMint: fromNft.mintAddress,
            authority: fromUser,
            delegate: (0, $1biTx.PublicKey).default,
            authorityOrDelegate: fromUser,
            scopedAuthority: fromScopedSbaUserAuthority,
            program: rewardDistributorProgram.programId
        }).remainingAccounts(keys).preInstructions(claimIxs).transaction();
        // @ts-ignore
        return tx;
    }
    // Supply is the token supply of the nft mint.
    function getStakeSeed(supply, user) {
        if (supply > 1) return user;
        else return (0, $1biTx.PublicKey).default;
    }
    return {
        stake: stake,
        stakeInstruction: stakeInstruction,
        unstake: unstake,
        unstakeInstruction: unstakeInstruction,
        claimAndUnstakeInstructions: claimAndUnstakeInstructions,
        isStaked: isStaked,
        isSoulBoundAuthorityUserInitialized: isSoulBoundAuthorityUserInitialized,
        readGoldPoints: readGoldPoints,
        readUnclaimedGoldPoints: readUnclaimedGoldPoints,
        readClaimedGoldPoints: readClaimedGoldPoints,
        transferRewards: transferRewards,
        anchor: {
            soulbound: SOUL_BOUND_PROGRAM,
            rewardDistributor: REWARD_DISTRIBUTOR_PROGRAM,
            stakePool: STAKE_POOL_PROGRAM
        },
        constants: {
            REWARD_DISTRIBUTOR: REWARD_DISTRIBUTOR
        },
        rewardEntryAddress: rewardEntryAddress,
        stakeEntryAddress: stakeEntryAddress,
        readStakeEntryAddress: readStakeEntryAddress,
        goldPointsAddress: goldPointsAddress
    };
}


const $9d6b52e0822c121e$var$Card = ({ nft: nft, wallet: wallet, setOverallStates: setOverallStates, pointsFromLadMint: pointsFromLadMint, setPointsFromLadMint: setPointsFromLadMint })=>{
    const { imageUrl: imageUrl, name: name, staked: staked, goldAmount: goldAmount } = nft;
    const [imgLoading, setImgLoading] = (0, $lx97N.useState)(true);
    const provider = new $26e0f71442fe06b5$export$1d7e255c6105d39b((0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection, wallet, {
        commitment: "confirmed"
    });
    const stakeApi = (0, $71cd754ccc718f4f$export$f2f7e48d401dedc8)(provider);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: "shadow-xl bg-slate-800 rounded-lg col-span-12 lg:col-span-3 flex flex-col",
        children: [
            imageUrl === "loading" && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: "w-full bg-slate-600 animate-pulse rounded-t-lg",
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                    style: {
                        marginTop: "100%"
                    }
                })
            }),
            imageUrl !== "loading" && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                className: "flex flex-col relative justify-center h-0",
                style: {
                    paddingBottom: "50%",
                    paddingTop: "50%"
                },
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("img", {
                        className: `rounded-t-lg absolute inset-0 h-full w-full ${imgLoading ? "hidden" : ""}`,
                        alt: "example",
                        src: imageUrl === "" ? "https://user-images.githubusercontent.com/47315479/81145216-7fbd8700-8f7e-11ea-9d49-bd5fb4a888f1.png" : imageUrl,
                        onLoad: ()=>setImgLoading(false)
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: `w-full bg-slate-600 animate-pulse rounded-t-lg ${imgLoading ? "" : "hidden"}`,
                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            style: {
                                marginTop: "100%"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                className: "px-3 py-5 text-gray-200 flex flex-col gap-y-1",
                children: [
                    name === "loading" || name === "" ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: "w-1/2 py-3 bg-slate-600 rounded animate-pulse"
                    }) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        children: name
                    }),
                    name === "loading" ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: "w-1/2 py-3 bg-slate-600 rounded animate-pulse"
                    }) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                        children: [
                            goldAmount,
                            " Points"
                        ]
                    }),
                    name === "loading" && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: "w-full py-4 bg-slate-600 rounded animate-pulse"
                    }),
                    name != "loading" && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                        className: "flex w-full gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $1d6378fa7d19bec0$export$2e2bcd8739ae039), {
                                nft: nft,
                                wallet: wallet,
                                setOverallStates: setOverallStates,
                                stakeApi: stakeApi
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $4a6e2d09a8a21c11$export$2e2bcd8739ae039), {
                                nft: nft,
                                wallet: wallet,
                                setOverallStates: setOverallStates,
                                stakeApi: stakeApi,
                                pointsFromLadMint: pointsFromLadMint,
                                setPointsFromLadMint: setPointsFromLadMint
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9d6b52e0822c121e$export$2e2bcd8739ae039 = $9d6b52e0822c121e$var$Card;



parcelRequire("lx97N");
const $11f99a9c97f65a59$var$WalletOverview = ({ walletPubKey: walletPubKey, stakedLads: stakedLads, totalLads: totalLads })=>{
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: "shadow-lg bg-slate-800 rounded-lg mb-8 px-4 py-3 flex flex-col lg:px-10 lg:flex-row lg:space-x-8 w-full",
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: "w-full lg:w-8/12",
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    className: "stat bg-transparent text-white py-2",
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: "text-sm ",
                            children: "Address"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: "stat-value text-2xl truncate font-medium",
                            children: walletPubKey?.toBase58()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: "w-full lg:w-2/12",
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    className: "stat bg-transparent text-white py-2",
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: "stat-title text-sm",
                            children: "Staked Madlads"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: "stat-value text-2xl truncate font-medium",
                            children: stakedLads
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: "w-full lg:w-2/12",
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    className: "stat bg-transparent text-white py-2",
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: "stat-title text-sm",
                            children: "Total Madlads"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                            className: "stat-value text-2xl truncate font-medium",
                            children: totalLads
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: " ml-auto"
            })
        ]
    });
};
var $11f99a9c97f65a59$export$2e2bcd8739ae039 = $11f99a9c97f65a59$var$WalletOverview;



var $1biTx = parcelRequire("1biTx");



const $c5b6574cf2a8f4d0$var$Main = ()=>{
    const wallet = (0, $4ae3b4d833a8f940$export$f0c8856d09a969c2)();
    const [ladsAmount, setLadsAmount] = (0, $lx97N.useState)(0);
    const [stakedLadsAmount, setStakedLadsAmount] = (0, $lx97N.useState)(0);
    const [ladsInfo, setLadsInfo] = (0, $lx97N.useState)();
    const [pointsFromLadMint, setPointsFromLadMint] = (0, $lx97N.useState)();
    const setWalletStates = async (walletPubKey)=>{
        const provider = new $26e0f71442fe06b5$export$1d7e255c6105d39b((0, $565bb8264fce4bd8$export$6a1a4134d62fc440).getState().rpcConnection, wallet, {
            commitment: "confirmed"
        });
        const stakeApi = (0, $71cd754ccc718f4f$export$f2f7e48d401dedc8)(provider);
        const ladsList = await (0, $df5bef30413a053b$export$f22f495c06a13176)(walletPubKey.toBase58());
        if (ladsList) {
            setLadsAmount(ladsList.total);
            setLadsInfo(ladsList.items.map((item)=>{
                return {
                    mintPubKey: new (0, $1biTx.PublicKey)(item.id),
                    tokenPubKey: new (0, $1biTx.PublicKey)(item.token_info.associated_token_address),
                    imageUrl: item.content.links.image,
                    name: item.content.metadata.name,
                    staked: false,
                    goldAmount: 0
                };
            }));
            const stakedLadsInfo = await (0, $df5bef30413a053b$export$d200926f25a28392)(walletPubKey.toBase58(), ladsList, stakeApi);
            setStakedLadsAmount(stakedLadsInfo.filter((val)=>val.staked === true).length);
            setLadsInfo(stakedLadsInfo);
        }
    };
    (0, $lx97N.useEffect)(()=>(0, $565bb8264fce4bd8$export$6a1a4134d62fc440).subscribe(()=>{
            if (wallet) setWalletStates(wallet.publicKey);
        }), [
        wallet
    ]);
    (0, $lx97N.useEffect)(()=>{
        (async ()=>{
            if (wallet) await setWalletStates(wallet.publicKey);
        })();
    }, [
        wallet
    ]);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: "mx-auto min-h-screen max-w-screen-xl flex overflow-hidden pt-16",
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                className: "opacity-50 hidden fixed inset-0 z-10",
                id: "sidebarBackdrop"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                id: "main-content",
                className: "w-full flex flex-col bg-slate-850 relative overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: "mb-auto text-gray-200",
                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("main", {
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                                className: "flex flex-col pt-6 px-6 lg:px-0",
                                children: [
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $11f99a9c97f65a59$export$2e2bcd8739ae039), {
                                        walletPubKey: wallet?.publicKey,
                                        stakedLads: stakedLadsAmount,
                                        totalLads: ladsAmount
                                    }),
                                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                                        className: "grid grid-cols-12 gap-6",
                                        children: ladsInfo?.map((cardInfoNFT, index)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9d6b52e0822c121e$export$2e2bcd8739ae039), {
                                                nft: cardInfoNFT,
                                                wallet: wallet,
                                                pointsFromLadMint: pointsFromLadMint,
                                                setPointsFromLadMint: setPointsFromLadMint,
                                                setOverallStates: setWalletStates
                                            }, index))
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                        className: "text-center text-sm text-gray-400 my-10",
                        children: [
                            "\xa9 2024",
                            " ",
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("a", {
                                href: "https://metacamp.so",
                                className: "hover:underline",
                                children: "Metacamp"
                            }),
                            ". No rights reserved."
                        ]
                    })
                ]
            })
        ]
    });
};
var $c5b6574cf2a8f4d0$export$2e2bcd8739ae039 = $c5b6574cf2a8f4d0$var$Main;


const $cd93687958c8007e$export$86fbec116b87613f = ()=>{
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($cd93687958c8007e$var$Context, {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $e0ed2d4e3eaef4d4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $c5b6574cf2a8f4d0$export$2e2bcd8739ae039), {})
        ]
    });
};
const $cd93687958c8007e$var$Context = ({ children: children })=>{
    // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
    const network = (0, $35afd30d3f8b3243$export$90767a7ae4c388dc).Mainnet;
    // You can also provide a custom RPC endpoint.
    const endpoint = (0, $lx97N.useMemo)(()=>(0, $1biTx.clusterApiUrl)(network), [
        network
    ]);
    const wallets = (0, $lx97N.useMemo)(()=>[], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        network
    ]);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ab7db6273f05d673$export$fd685cf7c99624bd), {
        endpoint: endpoint,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $489600bcf98bc41d$export$717b22fc3a2082b3), {
            wallets: wallets,
            autoConnect: true,
            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $d2cea7b421ec30ee$export$43bb60413a8a3ee6), {
                children: children
            })
        })
    });
};


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(0, $e08bedd2d92855da$export$882461b6382ed46c)(document.getElementById("app")).render(/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $lx97N.StrictMode), {
    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.15b71b8c.js.map
